import './index-CPp8_Sxr.css';var Lc = Object.defineProperty;
var Pc = (D, C, B) => C in D ? Lc(D, C, { enumerable: !0, configurable: !0, writable: !0, value: B }) : D[C] = B;
var nn = (D, C, B) => Pc(D, typeof C != "symbol" ? C + "" : C, B);
import { jsx as ce, jsxs as tn, Fragment as Hr } from "react/jsx-runtime";
import { useRef as lr, useCallback as xn, useSyncExternalStore as xc, createContext as Ta, useContext as ba, useState as ur, useEffect as Ir, useMemo as ir, memo as Fc, useLayoutEffect as kc, useId as Zc, forwardRef as Bc, createRef as Uc } from "react";
import { initReactI18next as Gc, useTranslation as An } from "react-i18next";
import Hc from "i18next";
import qc from "i18next-resources-to-backend";
import { S as Cr, U as Vc, W as jc, X as Yc, Z as jn, _ as Sa, $ as Kc, a0 as zc, a1 as Wc, a2 as Qc, a3 as Xc, a4 as $c, y as Jc, a5 as _a, a6 as ef, a7 as tf, a8 as Ea, a9 as nf, aa as fl, ab as rf, ac as dl, ad as gl, ae as af, af as of, ag as sf, ah as Qs, ai as Xs, aj as lf, ak as po, al as uf, am as cf } from "./vidstack-8s6P_CC9.js";
import { an as Ey } from "./vidstack-8s6P_CC9.js";
import { useFloating as xi, autoUpdate as Fi, shift as Aa, offset as Ia, arrow as Ca, useMergeRefs as wa, useListNavigation as So, useClick as hl, useDismiss as Ra, useInteractions as Na, FloatingFocusManager as Da, FloatingArrow as Ma, detectOverflow as ff } from "@floating-ui/react";
const Si = [0.5, 0.75, 1, 1.25, 1.5, 2], df = [0.5, 1, 2, 3, 4], gf = 5, Ao = "-ytb";
let hf = Symbol("clean"), Zr = [], Wr = 0;
const da = 4;
let Wn = (D) => {
  let C = [], B = {
    get() {
      return B.lc || B.listen(() => {
      })(), B.value;
    },
    lc: 0,
    listen(le) {
      return B.lc = C.push(le), () => {
        for (let qe = Wr + da; qe < Zr.length; )
          Zr[qe] === le ? Zr.splice(qe, da) : qe += da;
        let be = C.indexOf(le);
        ~be && (C.splice(be, 1), --B.lc || B.off());
      };
    },
    notify(le, be) {
      let qe = !Zr.length;
      for (let _e of C)
        Zr.push(_e, B.value, le, be);
      if (qe) {
        for (Wr = 0; Wr < Zr.length; Wr += da)
          Zr[Wr](
            Zr[Wr + 1],
            Zr[Wr + 2],
            Zr[Wr + 3]
          );
        Zr.length = 0;
      }
    },
    /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */
    off() {
    },
    set(le) {
      let be = B.value;
      be !== le && (B.value = le, B.notify(be));
    },
    subscribe(le) {
      let be = B.listen(le);
      return le(B.value), be;
    },
    value: D
  };
  return process.env.NODE_ENV !== "production" && (B[hf] = () => {
    C = [], B.lc = 0, B.off();
  }), B;
}, mf = (D, C) => {
  Array.isArray(D) || (D = [D]);
  let B = [], le, be = () => {
    le && le();
    let qe = D.map((_e) => _e.get());
    le = C(...qe);
  };
  return B = D.map((qe) => qe.listen(be)), be(), () => {
    B.forEach((qe) => qe()), le && le();
  };
};
function pf(D, C, B) {
  let le = new Set(C).add(void 0);
  return D.listen((be, qe, _e) => {
    le.has(_e) && B(be, qe, _e);
  });
}
let yo = (D, C) => (B) => {
  D.current !== B && (D.current = B, C());
};
function va(D, { keys: C, deps: B = [D, C] } = {}) {
  let le = lr();
  le.current = D.get();
  let be = xn((_e) => (yo(le, _e)(D.value), (C == null ? void 0 : C.length) > 0 ? pf(D, C, yo(le, _e)) : D.listen(yo(le, _e))), B), qe = () => le.current;
  return xc(be, qe, qe);
}
var _o = { exports: {} };
/*! For license information please see dash.all.min.js.LICENSE.txt */
var $s;
function yf() {
  return $s || ($s = 1, function(D, C) {
    (function(B, le) {
      D.exports = le();
    })(self, function() {
      return function() {
        var B = { 4593: function(_e, fe) {
          var R, J, E, t, e, h = function(v) {
            for (var m = [], n = 0; n < v.length; ++n) {
              var c = v.charCodeAt(n);
              c < 128 ? m.push(c) : c < 2048 ? (m.push(192 | c >> 6), m.push(128 | 63 & c)) : c < 65536 ? (m.push(224 | c >> 12), m.push(128 | 63 & c >> 6), m.push(128 | 63 & c)) : (m.push(240 | c >> 18), m.push(128 | 63 & c >> 12), m.push(128 | 63 & c >> 6), m.push(128 | 63 & c));
            }
            return m;
          }, p = function(v) {
            for (var m = [], n = 0; n < v.length; ) {
              var c = v[n++];
              c < 128 || (c < 224 ? (c = (31 & c) << 6, c |= 63 & v[n++]) : c < 240 ? (c = (15 & c) << 12, c |= (63 & v[n++]) << 6, c |= 63 & v[n++]) : (c = (7 & c) << 18, c |= (63 & v[n++]) << 12, c |= (63 & v[n++]) << 6, c |= 63 & v[n++])), m.push(String.fromCharCode(c));
            }
            return m.join("");
          }, o = {};
          R = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", J = function(v) {
            for (var m = 0, n = [], c = 0 | v.length / 3; 0 < c--; ) {
              var f = (v[m] << 16) + (v[m + 1] << 8) + v[m + 2];
              m += 3, n.push(R.charAt(63 & f >> 18)), n.push(R.charAt(63 & f >> 12)), n.push(R.charAt(63 & f >> 6)), n.push(R.charAt(63 & f));
            }
            return v.length - m == 2 ? (f = (v[m] << 16) + (v[m + 1] << 8), n.push(R.charAt(63 & f >> 18)), n.push(R.charAt(63 & f >> 12)), n.push(R.charAt(63 & f >> 6)), n.push("=")) : v.length - m == 1 && (f = v[m] << 16, n.push(R.charAt(63 & f >> 18)), n.push(R.charAt(63 & f >> 12)), n.push("==")), n.join("");
          }, E = function() {
            for (var v = [], m = 0; m < R.length; ++m) v[R.charCodeAt(m)] = m;
            return v[61] = 0, v;
          }(), t = function(v) {
            for (var m = 0, n = [], c = 0 | v.length / 4; 0 < c--; ) {
              var f = (E[v.charCodeAt(m)] << 18) + (E[v.charCodeAt(m + 1)] << 12) + (E[v.charCodeAt(m + 2)] << 6) + E[v.charCodeAt(m + 3)];
              n.push(255 & f >> 16), n.push(255 & f >> 8), n.push(255 & f), m += 4;
            }
            return n && (v.charAt(m - 2) == "=" ? (n.pop(), n.pop()) : v.charAt(m - 1) == "=" && n.pop()), n;
          }, e = { encode: function(v) {
            for (var m = [], n = 0; n < v.length; ++n) m.push(v.charCodeAt(n));
            return m;
          }, decode: function(v) {
            for (var m = 0; m < s.length; ++m) a[m] = String.fromCharCode(a[m]);
            return a.join("");
          } }, o.decodeArray = function(v) {
            var m = t(v);
            return new Uint8Array(m);
          }, o.encodeASCII = function(v) {
            var m = e.encode(v);
            return J(m);
          }, o.decodeASCII = function(v) {
            var m = t(v);
            return e.decode(m);
          }, o.encode = function(v) {
            var m = h(v);
            return J(m);
          }, o.decode = function(v) {
            var m = t(v);
            return p(m);
          }, fe.decode = o.decode, fe.decodeArray = o.decodeArray, fe.encode = o.encode, fe.encodeASCII = o.encodeASCII;
        }, 452: function(_e, fe) {
          (function(R) {
            var J = { 42: 225, 92: 233, 94: 237, 95: 243, 96: 250, 123: 231, 124: 247, 125: 209, 126: 241, 127: 9608, 128: 174, 129: 176, 130: 189, 131: 191, 132: 8482, 133: 162, 134: 163, 135: 9834, 136: 224, 137: 32, 138: 232, 139: 226, 140: 234, 141: 238, 142: 244, 143: 251, 144: 193, 145: 201, 146: 211, 147: 218, 148: 220, 149: 252, 150: 8216, 151: 161, 152: 42, 153: 8217, 154: 9473, 155: 169, 156: 8480, 157: 8226, 158: 8220, 159: 8221, 160: 192, 161: 194, 162: 199, 163: 200, 164: 202, 165: 203, 166: 235, 167: 206, 168: 207, 169: 239, 170: 212, 171: 217, 172: 249, 173: 219, 174: 171, 175: 187, 176: 195, 177: 227, 178: 205, 179: 204, 180: 236, 181: 210, 182: 242, 183: 213, 184: 245, 185: 123, 186: 125, 187: 92, 188: 94, 189: 95, 190: 124, 191: 8764, 192: 196, 193: 228, 194: 214, 195: 246, 196: 223, 197: 165, 198: 164, 199: 9475, 200: 197, 201: 229, 202: 216, 203: 248, 204: 9487, 205: 9491, 206: 9495, 207: 9499 }, E = function(P) {
              var Q = P;
              return J.hasOwnProperty(P) && (Q = J[P]), String.fromCharCode(Q);
            }, t = 15, e = 32, h = { 17: 1, 18: 3, 21: 5, 22: 7, 23: 9, 16: 11, 19: 12, 20: 14 }, p = { 17: 2, 18: 4, 21: 6, 22: 8, 23: 10, 19: 13, 20: 15 }, o = { 25: 1, 26: 3, 29: 5, 30: 7, 31: 9, 24: 11, 27: 12, 28: 14 }, v = { 25: 2, 26: 4, 29: 6, 30: 8, 31: 10, 27: 13, 28: 15 }, m = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], n = { verboseFilter: { DATA: 3, DEBUG: 3, INFO: 2, WARNING: 2, TEXT: 1, ERROR: 0 }, time: null, verboseLevel: 0, setTime: function(P) {
              this.time = P;
            }, log: function(P, Q) {
              var se = this.verboseFilter[P];
              this.verboseLevel >= se && console.log(this.time + " [" + P + "] " + Q);
            } }, c = function(P) {
              for (var Q = [], se = 0; se < P.length; se++) Q.push(P[se].toString(16));
              return Q;
            }, f = function(P, Q, se, K, ie) {
              this.foreground = P || "white", this.underline = Q || !1, this.italics = se || !1, this.background = K || "black", this.flash = ie || !1;
            };
            f.prototype = { reset: function() {
              this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
            }, setStyles: function(P) {
              for (var Q = ["foreground", "underline", "italics", "background", "flash"], se = 0; se < Q.length; se++) {
                var K = Q[se];
                P.hasOwnProperty(K) && (this[K] = P[K]);
              }
            }, isDefault: function() {
              return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
            }, equals: function(P) {
              return this.foreground === P.foreground && this.underline === P.underline && this.italics === P.italics && this.background === P.background && this.flash === P.flash;
            }, copy: function(P) {
              this.foreground = P.foreground, this.underline = P.underline, this.italics = P.italics, this.background = P.background, this.flash = P.flash;
            }, toString: function() {
              return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
            } };
            var S = function(P, Q, se, K, ie, ge) {
              this.uchar = P || " ", this.penState = new f(Q, se, K, ie, ge);
            };
            S.prototype = { reset: function() {
              this.uchar = " ", this.penState.reset();
            }, setChar: function(P, Q) {
              this.uchar = P, this.penState.copy(Q);
            }, setPenState: function(P) {
              this.penState.copy(P);
            }, equals: function(P) {
              return this.uchar === P.uchar && this.penState.equals(P.penState);
            }, copy: function(P) {
              this.uchar = P.uchar, this.penState.copy(P.penState);
            }, isEmpty: function() {
              return this.uchar === " " && this.penState.isDefault();
            } };
            var k = function() {
              this.chars = [];
              for (var P = 0; P < e; P++) this.chars.push(new S());
              this.pos = 0, this.currPenState = new f();
            };
            k.prototype = { equals: function(P) {
              for (var Q = !0, se = 0; se < e; se++) if (!this.chars[se].equals(P.chars[se])) {
                Q = !1;
                break;
              }
              return Q;
            }, copy: function(P) {
              for (var Q = 0; Q < e; Q++) this.chars[Q].copy(P.chars[Q]);
            }, isEmpty: function() {
              for (var P = !0, Q = 0; Q < e; Q++) if (!this.chars[Q].isEmpty()) {
                P = !1;
                break;
              }
              return P;
            }, setCursor: function(P) {
              this.pos !== P && (this.pos = P), this.pos < 0 ? (n.log("ERROR", "Negative cursor position " + this.pos), this.pos = 0) : this.pos > e && (n.log("ERROR", "Too large cursor position " + this.pos), this.pos = e);
            }, moveCursor: function(P) {
              var Q = this.pos + P;
              if (P > 1) for (var se = this.pos + 1; se < Q + 1; se++) this.chars[se].setPenState(this.currPenState);
              this.setCursor(Q);
            }, backSpace: function() {
              this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
            }, insertChar: function(P) {
              P >= 144 && this.backSpace();
              var Q = E(P);
              this.pos >= e ? n.log("ERROR", "Cannot insert " + P.toString(16) + " (" + Q + ") at position " + this.pos + ". Skipping it!") : (this.chars[this.pos].setChar(Q, this.currPenState), this.moveCursor(1));
            }, clearFromPos: function(P) {
              var Q;
              for (Q = P; Q < e; Q++) this.chars[Q].reset();
            }, clear: function() {
              this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
            }, clearToEndOfRow: function() {
              this.clearFromPos(this.pos);
            }, getTextString: function() {
              for (var P = [], Q = !0, se = 0; se < e; se++) {
                var K = this.chars[se].uchar;
                K !== " " && (Q = !1), P.push(K);
              }
              return Q ? "" : P.join("");
            }, setPenStyles: function(P) {
              this.currPenState.setStyles(P), this.chars[this.pos].setPenState(this.currPenState);
            } };
            var q = function() {
              this.rows = [];
              for (var P = 0; P < t; P++) this.rows.push(new k());
              this.currRow = 14, this.nrRollUpRows = null, this.reset();
            };
            q.prototype = { reset: function() {
              for (var P = 0; P < t; P++) this.rows[P].clear();
              this.currRow = 14;
            }, equals: function(P) {
              for (var Q = !0, se = 0; se < t; se++) if (!this.rows[se].equals(P.rows[se])) {
                Q = !1;
                break;
              }
              return Q;
            }, copy: function(P) {
              for (var Q = 0; Q < t; Q++) this.rows[Q].copy(P.rows[Q]);
            }, isEmpty: function() {
              for (var P = !0, Q = 0; Q < t; Q++) if (!this.rows[Q].isEmpty()) {
                P = !1;
                break;
              }
              return P;
            }, backSpace: function() {
              this.rows[this.currRow].backSpace();
            }, clearToEndOfRow: function() {
              this.rows[this.currRow].clearToEndOfRow();
            }, insertChar: function(P) {
              this.rows[this.currRow].insertChar(P);
            }, setPen: function(P) {
              this.rows[this.currRow].setPenStyles(P);
            }, moveCursor: function(P) {
              this.rows[this.currRow].moveCursor(P);
            }, setCursor: function(P) {
              n.log("INFO", "setCursor: " + P), this.rows[this.currRow].setCursor(P);
            }, setPAC: function(P) {
              n.log("INFO", "pacData = " + JSON.stringify(P));
              var Q = P.row - 1;
              this.nrRollUpRows && Q < this.nrRollUpRows - 1 && (Q = this.nrRollUpRows - 1), this.currRow = Q;
              var se = this.rows[this.currRow];
              if (P.indent !== null) {
                var K = P.indent, ie = Math.max(K - 1, 0);
                se.setCursor(P.indent), P.color = se.chars[ie].penState.foreground;
              }
              var ge = { foreground: P.color, underline: P.underline, italics: P.italics, background: "black", flash: !1 };
              this.setPen(ge);
            }, setBkgData: function(P) {
              n.log("INFO", "bkgData = " + JSON.stringify(P)), this.backSpace(), this.setPen(P), this.insertChar(32);
            }, setRollUpRows: function(P) {
              this.nrRollUpRows = P;
            }, rollUp: function() {
              if (this.nrRollUpRows !== null) {
                n.log("TEXT", this.getDisplayText());
                var P = this.currRow + 1 - this.nrRollUpRows, Q = this.rows.splice(P, 1)[0];
                Q.clear(), this.rows.splice(this.currRow, 0, Q), n.log("INFO", "Rolling up");
              } else n.log("DEBUG", "roll_up but nrRollUpRows not set yet");
            }, getDisplayText: function(P) {
              P = P || !1;
              for (var Q = [], se = "", K = -1, ie = 0; ie < t; ie++) {
                var ge = this.rows[ie].getTextString();
                ge && (K = ie + 1, P ? Q.push("Row " + K + ': "' + ge + '"') : Q.push(ge.trim()));
              }
              return Q.length > 0 && (se = P ? "[" + Q.join(" | ") + "]" : Q.join(`
`)), se;
            }, getTextAndFormat: function() {
              return this.rows;
            } };
            var F = function(P, Q) {
              this.chNr = P, this.outputFilter = Q, this.mode = null, this.verbose = 0, this.displayedMemory = new q(), this.nonDisplayedMemory = new q(), this.lastOutputScreen = new q(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
            };
            F.prototype = { modes: ["MODE_ROLL-UP", "MODE_POP-ON", "MODE_PAINT-ON", "MODE_TEXT"], reset: function() {
              this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.currRollUpRow = this.displayedMemory.rows[14], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.lastCueEndTime = null;
            }, getHandler: function() {
              return this.outputFilter;
            }, setHandler: function(P) {
              this.outputFilter = P;
            }, setPAC: function(P) {
              this.writeScreen.setPAC(P);
            }, setBkgData: function(P) {
              this.writeScreen.setBkgData(P);
            }, setMode: function(P) {
              P !== this.mode && (this.mode = P, n.log("INFO", "MODE=" + P), this.mode == "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = P);
            }, insertChars: function(P) {
              for (var Q = 0; Q < P.length; Q++) this.writeScreen.insertChar(P[Q]);
              var se = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
              n.log("INFO", se + ": " + this.writeScreen.getDisplayText(!0)), this.mode !== "MODE_PAINT-ON" && this.mode !== "MODE_ROLL-UP" || (n.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
            }, cc_RCL: function() {
              n.log("INFO", "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
            }, cc_BS: function() {
              n.log("INFO", "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
            }, cc_AOF: function() {
            }, cc_AON: function() {
            }, cc_DER: function() {
              n.log("INFO", "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
            }, cc_RU: function(P) {
              n.log("INFO", "RU(" + P + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(P);
            }, cc_FON: function() {
              n.log("INFO", "FON - Flash On"), this.writeScreen.setPen({ flash: !0 });
            }, cc_RDC: function() {
              n.log("INFO", "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
            }, cc_TR: function() {
              n.log("INFO", "TR"), this.setMode("MODE_TEXT");
            }, cc_RTD: function() {
              n.log("INFO", "RTD"), this.setMode("MODE_TEXT");
            }, cc_EDM: function() {
              n.log("INFO", "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate();
            }, cc_CR: function() {
              n.log("CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate();
            }, cc_ENM: function() {
              n.log("INFO", "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
            }, cc_EOC: function() {
              if (n.log("INFO", "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                var P = this.displayedMemory;
                this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = P, this.writeScreen = this.nonDisplayedMemory, n.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
              }
              this.outputDataUpdate();
            }, cc_TO: function(P) {
              n.log("INFO", "TO(" + P + ") - Tab Offset"), this.writeScreen.moveCursor(P);
            }, cc_MIDROW: function(P) {
              var Q = { flash: !1 };
              if (Q.underline = P % 2 == 1, Q.italics = P >= 46, Q.italics) Q.foreground = "white";
              else {
                var se = Math.floor(P / 2) - 16;
                Q.foreground = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"][se];
              }
              n.log("INFO", "MIDROW: " + JSON.stringify(Q)), this.writeScreen.setPen(Q);
            }, outputDataUpdate: function() {
              var P = n.time;
              P !== null && this.outputFilter && (this.outputFilter.updateData && this.outputFilter.updateData(P, this.displayedMemory), this.cueStartTime !== null || this.displayedMemory.isEmpty() ? this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, P, this.lastOutputScreen), this.cueStartTime = this.displayedMemory.isEmpty() ? null : P) : this.cueStartTime = P, this.lastOutputScreen.copy(this.displayedMemory));
            }, cueSplitAtTime: function(P) {
              this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, P, this.displayedMemory), this.cueStartTime = P));
            } };
            var te = function(P, Q, se) {
              this.field = P || 1, this.outputs = [Q, se], this.channels = [new F(1, Q), new F(2, se)], this.currChNr = -1, this.lastCmdA = null, this.lastCmdB = null, this.bufferedData = [], this.startTime = null, this.lastTime = null, this.dataCounters = { padding: 0, char: 0, cmd: 0, other: 0 };
            };
            te.prototype = { getHandler: function(P) {
              return this.channels[P].getHandler();
            }, setHandler: function(P, Q) {
              this.channels[P].setHandler(Q);
            }, addData: function(P, Q) {
              var se, K, ie, ge = !1;
              this.lastTime = P, n.setTime(P);
              for (var Ne = 0; Ne < Q.length; Ne += 2) K = 127 & Q[Ne], ie = 127 & Q[Ne + 1], K >= 16 && K <= 31 && K === this.lastCmdA && ie === this.lastCmdB ? (this.lastCmdA = null, this.lastCmdB = null, n.log("DEBUG", "Repeated command (" + c([K, ie]) + ") is dropped")) : K !== 0 || ie !== 0 ? (n.log("DATA", "[" + c([Q[Ne], Q[Ne + 1]]) + "] -> (" + c([K, ie]) + ")"), (se = this.parseCmd(K, ie)) || (se = this.parseMidrow(K, ie)), se || (se = this.parsePAC(K, ie)), se || (se = this.parseBackgroundAttributes(K, ie)), se || (ge = this.parseChars(K, ie)) && (this.currChNr && this.currChNr >= 0 ? this.channels[this.currChNr - 1].insertChars(ge) : n.log("WARNING", "No channel found yet. TEXT-MODE?")), se ? this.dataCounters.cmd += 2 : ge ? this.dataCounters.char += 2 : (this.dataCounters.other += 2, n.log("WARNING", "Couldn't parse cleaned data " + c([K, ie]) + " orig: " + c([Q[Ne], Q[Ne + 1]])))) : this.dataCounters.padding += 2;
            }, parseCmd: function(P, Q) {
              var se;
              if (!((P === 20 || P === 21 || P === 28 || P === 29) && 32 <= Q && Q <= 47 || (P === 23 || P === 31) && 33 <= Q && Q <= 35)) return !1;
              se = P === 20 || P === 21 || P === 23 ? 1 : 2;
              var K = this.channels[se - 1];
              return P === 20 || P === 21 || P === 28 || P === 29 ? Q === 32 ? K.cc_RCL() : Q === 33 ? K.cc_BS() : Q === 34 ? K.cc_AOF() : Q === 35 ? K.cc_AON() : Q === 36 ? K.cc_DER() : Q === 37 ? K.cc_RU(2) : Q === 38 ? K.cc_RU(3) : Q === 39 ? K.cc_RU(4) : Q === 40 ? K.cc_FON() : Q === 41 ? K.cc_RDC() : Q === 42 ? K.cc_TR() : Q === 43 ? K.cc_RTD() : Q === 44 ? K.cc_EDM() : Q === 45 ? K.cc_CR() : Q === 46 ? K.cc_ENM() : Q === 47 && K.cc_EOC() : K.cc_TO(Q - 32), this.lastCmdA = P, this.lastCmdB = Q, this.currChNr = se, !0;
            }, parseMidrow: function(P, Q) {
              var se = null;
              if ((P === 17 || P === 25) && 32 <= Q && Q <= 47) {
                if ((se = P === 17 ? 1 : 2) !== this.currChNr) return n.log("ERROR", "Mismatch channel in midrow parsing"), !1;
                var K = this.channels[se - 1];
                return K.insertChars([32]), K.cc_MIDROW(Q), n.log("DEBUG", "MIDROW (" + c([P, Q]) + ")"), this.lastCmdA = P, this.lastCmdB = Q, !0;
              }
              return !1;
            }, parsePAC: function(P, Q) {
              var se, K;
              if (!((17 <= P && P <= 23 || 25 <= P && P <= 31) && 64 <= Q && Q <= 127 || (P === 16 || P === 24) && 64 <= Q && Q <= 95)) return !1;
              se = P <= 23 ? 1 : 2, K = 64 <= Q && Q <= 95 ? se === 1 ? h[P] : o[P] : se === 1 ? p[P] : v[P];
              var ie = this.interpretPAC(K, Q);
              return this.channels[se - 1].setPAC(ie), this.lastCmdA = P, this.lastCmdB = Q, this.currChNr = se, !0;
            }, interpretPAC: function(P, Q) {
              var se, K = { color: null, italics: !1, indent: null, underline: !1, row: P };
              return se = Q > 95 ? Q - 96 : Q - 64, K.underline = (1 & se) == 1, se <= 13 ? K.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(se / 2)] : se <= 15 ? (K.italics = !0, K.color = "white") : K.indent = 4 * Math.floor((se - 16) / 2), K;
            }, parseChars: function(P, Q) {
              var se = null, K = null, ie = null;
              if (P >= 25 ? (se = 2, ie = P - 8) : (se = 1, ie = P), 17 <= ie && ie <= 19) {
                var ge;
                ge = ie === 17 ? Q + 80 : ie === 18 ? Q + 112 : Q + 144, n.log("INFO", "Special char '" + E(ge) + "' in channel " + se), K = [ge], this.lastCmdA = P, this.lastCmdB = Q;
              } else 32 <= P && P <= 127 && (K = Q === 0 ? [P] : [P, Q], this.lastCmdA = null, this.lastCmdB = null);
              if (K) {
                var Ne = c(K);
                n.log("DEBUG", "Char codes =  " + Ne.join(","));
              }
              return K;
            }, parseBackgroundAttributes: function(P, Q) {
              var se, K, ie;
              return ((P === 16 || P === 24) && 32 <= Q && Q <= 47 || (P === 23 || P === 31) && 45 <= Q && Q <= 47) && (se = {}, P === 16 || P === 24 ? (K = Math.floor((Q - 32) / 2), se.background = m[K], Q % 2 == 1 && (se.background = se.background + "_semi")) : Q === 45 ? se.background = "transparent" : (se.foreground = "black", Q === 47 && (se.underline = !0)), ie = P < 24 ? 1 : 2, this.channels[ie - 1].setBkgData(se), this.lastCmdA = P, this.lastCmdB = Q, !0);
            }, reset: function() {
              for (var P = 0; P < this.channels.length; P++) this.channels[P] && this.channels[P].reset();
              this.lastCmdA = null, this.lastCmdB = null;
            }, cueSplitAtTime: function(P) {
              for (var Q = 0; Q < this.channels.length; Q++) this.channels[Q] && this.channels[Q].cueSplitAtTime(P);
            } }, R.logger = n, R.PenState = f, R.CaptionScreen = q, R.Cea608Parser = te, R.findCea608Nalus = function(P, Q, se) {
              for (var K = 0, ie = Q, ge = [], Ne = function(Ce, Ue, Je, st) {
                if (Ce !== 4 || Ue < 8) return null;
                var we = Je.getUint8(st), Be = Je.getUint16(st + 1), At = Je.getUint32(st + 3), ht = Je.getUint8(st + 7);
                return we == 181 && Be == 49 && At == 1195456820 && ht == 3;
              }; ie < Q + se; ) {
                if (K = P.getUint32(ie), (31 & P.getUint8(ie + 4)) == 6) for (var ee = ie + 5, Oe = -1; ee < ie + 4 + K - 1; ) {
                  Oe = 0;
                  for (var Ge = 255; Ge === 255; ) Oe += Ge = P.getUint8(ee), ee++;
                  var Xe = 0;
                  for (Ge = 255; Ge === 255; ) Xe += Ge = P.getUint8(ee), ee++;
                  Ne(Oe, Xe, P, ee) && ge.push([ee, Xe]), ee += Xe;
                }
                ie += K + 4;
              }
              return ge;
            }, R.extractCea608DataFromRange = function(P, Q) {
              var se = Q[0], K = [[], []];
              se += 8;
              var ie = 31 & P.getUint8(se);
              se += 2;
              for (var ge = 0; ge < ie; ge++) {
                var Ne = P.getUint8(se), ee = 4 & Ne, Oe = 3 & Ne;
                se++;
                var Ge = P.getUint8(se);
                se++;
                var Xe = P.getUint8(se);
                se++, ee && (127 & Ge) + (127 & Xe) != 0 && (Oe === 0 ? (K[0].push(Ge), K[0].push(Xe)) : Oe === 1 && (K[1].push(Ge), K[1].push(Xe)));
              }
              return K;
            };
          })(fe);
        }, 8416: function(_e, fe, R) {
          var J = R(1139), E = R(5448), t = R(6398), e = R(2032), h = (R(5530), typeof window < "u" && window || R.g), p = h.dashjs;
          p || (p = h.dashjs = {}), p.MediaPlayer = J.Z, p.FactoryMaker = E.Z, p.Debug = t.Z, p.Version = (0, e.e)();
        }, 6398: function(_e, fe, R) {
          var J = R(5595), E = R(8512), t = R(5448), e = 1, h = 2, p = 3, o = 4, v = 5;
          function m(c) {
            c = c || {};
            var f, S, k, q, F = this.context, te = (0, J.Z)(F).getInstance(), P = c.settings, Q = [];
            function se(Ge) {
              return Ge && Ge.bind ? Ge.bind(window.console) : window.console.log.bind(window.console);
            }
            function K() {
              for (var Ge = arguments.length, Xe = new Array(Ge), Ce = 0; Ce < Ge; Ce++) Xe[Ce] = arguments[Ce];
              Oe.apply(void 0, [e, this].concat(Xe));
            }
            function ie() {
              for (var Ge = arguments.length, Xe = new Array(Ge), Ce = 0; Ce < Ge; Ce++) Xe[Ce] = arguments[Ce];
              Oe.apply(void 0, [h, this].concat(Xe));
            }
            function ge() {
              for (var Ge = arguments.length, Xe = new Array(Ge), Ce = 0; Ce < Ge; Ce++) Xe[Ce] = arguments[Ce];
              Oe.apply(void 0, [p, this].concat(Xe));
            }
            function Ne() {
              for (var Ge = arguments.length, Xe = new Array(Ge), Ce = 0; Ce < Ge; Ce++) Xe[Ce] = arguments[Ce];
              Oe.apply(void 0, [o, this].concat(Xe));
            }
            function ee() {
              for (var Ge = arguments.length, Xe = new Array(Ge), Ce = 0; Ce < Ge; Ce++) Xe[Ce] = arguments[Ce];
              Oe.apply(void 0, [v, this].concat(Xe));
            }
            function Oe(Ge, Xe) {
              var Ce = "", Ue = null;
              S && (Ue = (/* @__PURE__ */ new Date()).getTime(), Ce += "[" + (Ue - q) + "]"), k && Xe && Xe.getClassName && (Ce += "[" + Xe.getClassName() + "]", Xe.getType && (Ce += "[" + Xe.getType() + "]")), Ce.length > 0 && (Ce += " ");
              for (var Je = arguments.length, st = new Array(Je > 2 ? Je - 2 : 0), we = 2; we < Je; we++) st[we - 2] = arguments[we];
              Array.apply(null, st).forEach(function(Be) {
                Ce += Be + " ";
              }), Q[Ge] && P && P.get().debug.logLevel >= Ge && Q[Ge](Ce), P && P.get().debug.dispatchEvent && te.trigger(E.Z.LOG, { message: Ce, level: Ge });
            }
            return f = { getLogger: function(Ge) {
              return { fatal: K.bind(Ge), error: ie.bind(Ge), warn: ge.bind(Ge), info: Ne.bind(Ge), debug: ee.bind(Ge) };
            }, setLogTimestampVisible: function(Ge) {
              S = Ge;
            }, setCalleeNameVisible: function(Ge) {
              k = Ge;
            } }, S = !0, k = !0, q = (/* @__PURE__ */ new Date()).getTime(), typeof window < "u" && window.console && (Q[e] = se(window.console.error), Q[h] = se(window.console.error), Q[p] = se(window.console.warn), Q[o] = se(window.console.info), Q[v] = se(window.console.debug)), f;
          }
          m.__dashjs_factory_name = "Debug";
          var n = t.Z.getSingletonFactory(m);
          n.LOG_LEVEL_NONE = 0, n.LOG_LEVEL_FATAL = e, n.LOG_LEVEL_ERROR = h, n.LOG_LEVEL_WARNING = p, n.LOG_LEVEL_INFO = o, n.LOG_LEVEL_DEBUG = v, t.Z.updateSingletonFactory(m.__dashjs_factory_name, n), fe.Z = n;
        }, 5595: function(_e, fe, R) {
          var J = R(5448), E = R(8825);
          function t() {
            var h = {};
            function p(v, m, n) {
              var c = -1;
              return h[v] && h[v].some(function(f, S) {
                if (f && f.callback === m && (!n || n === f.scope)) return c = S, !0;
              }), c;
            }
            var o = { on: function(v, m, n) {
              var c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
              if (!v) throw new Error("event type cannot be null or undefined");
              if (!m || typeof m != "function") throw new Error("listener must be a function: " + m);
              var f = c.priority || 0;
              if (!(p(v, m, n) >= 0)) {
                h[v] = h[v] || [];
                var S = { callback: m, scope: n, priority: f };
                n && n.getStreamId && (S.streamId = n.getStreamId()), n && n.getType && (S.mediaType = n.getType()), c && c.mode && (S.mode = c.mode);
                var k = h[v].some(function(q, F) {
                  if (q && f > q.priority) return h[v].splice(F, 0, S), !0;
                });
                k || h[v].push(S);
              }
            }, off: function(v, m, n) {
              if (v && m && h[v]) {
                var c = p(v, m, n);
                c < 0 || (h[v][c] = null);
              }
            }, trigger: function(v) {
              var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              if (v && h[v]) {
                if ((m = m || {}).hasOwnProperty("type")) throw new Error("'type' is a reserved word for event dispatching");
                m.type = v, n.streamId && (m.streamId = n.streamId), n.mediaType && (m.mediaType = n.mediaType), h[v].filter(function(c) {
                  return !(!c || n.streamId && c.streamId && c.streamId !== n.streamId || n.mediaType && c.mediaType && c.mediaType !== n.mediaType || n.mode && c.mode && c.mode !== n.mode || !c.mode && n.mode && n.mode === E.Z.EVENT_MODE_ON_RECEIVE);
                }).forEach(function(c) {
                  return c && c.callback.call(c.scope, m);
                });
              }
            }, reset: function() {
              h = {};
            } };
            return o;
          }
          t.__dashjs_factory_name = "EventBus";
          var e = J.Z.getSingletonFactory(t);
          e.EVENT_PRIORITY_LOW = 0, e.EVENT_PRIORITY_HIGH = 5e3, J.Z.updateSingletonFactory(t.__dashjs_factory_name, e), fe.Z = e;
        }, 5448: function(_e, fe) {
          var R = function() {
            var J, E = [], t = {}, e = {};
            function h(m, n) {
              for (var c in E) {
                var f = E[c];
                if (f.context === m && f.name === n) return f.instance;
              }
              return null;
            }
            function p(m, n) {
              return n[m];
            }
            function o(m, n, c) {
              m in c && (c[m] = n);
            }
            function v(m, n, c) {
              var f, S = m.__dashjs_factory_name, k = n[S];
              if (k) {
                var q = k.instance;
                if (!k.override) return q.apply({ context: n, factory: J }, c);
                for (var F in f = m.apply({ context: n }, c), q = q.apply({ context: n, factory: J, parent: f }, c)) f.hasOwnProperty(F) && (f[F] = q[F]);
              } else f = m.apply({ context: n }, c);
              return f.getClassName = function() {
                return S;
              }, f;
            }
            return J = { extend: function(m, n, c, f) {
              !f[m] && n && (f[m] = { instance: n, override: c });
            }, getSingletonInstance: h, setSingletonInstance: function(m, n, c) {
              for (var f in E) {
                var S = E[f];
                if (S.context === m && S.name === n) return void (E[f].instance = c);
              }
              E.push({ name: n, context: m, instance: c });
            }, deleteSingletonInstances: function(m) {
              E = E.filter(function(n) {
                return n.context !== m;
              });
            }, getSingletonFactory: function(m) {
              var n = p(m.__dashjs_factory_name, t);
              return n || (n = function(c) {
                var f;
                return c === void 0 && (c = {}), { getInstance: function() {
                  return f || (f = h(c, m.__dashjs_factory_name)), f || (f = v(m, c, arguments), E.push({ name: m.__dashjs_factory_name, context: c, instance: f })), f;
                } };
              }, t[m.__dashjs_factory_name] = n), n;
            }, getSingletonFactoryByName: function(m) {
              return p(m, t);
            }, updateSingletonFactory: function(m, n) {
              o(m, n, t);
            }, getClassFactory: function(m) {
              var n = p(m.__dashjs_factory_name, e);
              return n || (n = function(c) {
                return c === void 0 && (c = {}), { create: function() {
                  return v(m, c, arguments);
                } };
              }, e[m.__dashjs_factory_name] = n), n;
            }, getClassFactoryByName: function(m) {
              return p(m, e);
            }, updateClassFactory: function(m, n) {
              o(m, n, e);
            } }, J;
          }();
          fe.Z = R;
        }, 1264: function(_e, fe, R) {
          var J = R(5448), E = R(703), t = R(6398), e = R(3393), h = R(7855), p = R(5595), o = R(8512);
          function v(f) {
            return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
              return typeof S;
            } : function(S) {
              return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
            }, v(f);
          }
          function m(f, S, k) {
            return S in f ? Object.defineProperty(f, S, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : f[S] = k, f;
          }
          function n() {
            var f, S, k = this.context, q = (0, p.Z)(k).getInstance(), F = { "streaming.delay.liveDelay": o.Z.SETTING_UPDATED_LIVE_DELAY, "streaming.delay.liveDelayFragmentCount": o.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, "streaming.liveCatchup.enabled": o.Z.SETTING_UPDATED_CATCHUP_ENABLED, "streaming.liveCatchup.playbackRate.min": o.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, "streaming.liveCatchup.playbackRate.max": o.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX }, te = { debug: { logLevel: t.Z.LOG_LEVEL_WARNING, dispatchEvent: !1 }, streaming: { abandonLoadTimeout: 1e4, wallclockTimeUpdateInterval: 100, manifestUpdateRetryInterval: 100, liveUpdateTimeThresholdInMilliseconds: 0, cacheInitSegments: !1, applyServiceDescription: !0, applyProducerReferenceTime: !0, applyContentSteering: !0, eventControllerRefreshDelay: 100, enableManifestDurationMismatchFix: !0, parseInbandPrft: !1, enableManifestTimescaleMismatchFix: !1, capabilities: { filterUnsupportedEssentialProperties: !0, useMediaCapabilitiesApi: !1 }, timeShiftBuffer: { calcFromSegmentTimeline: !1, fallbackToSegmentTimeline: !0 }, metrics: { maxListDepth: 100 }, delay: { liveDelayFragmentCount: NaN, liveDelay: NaN, useSuggestedPresentationDelay: !0 }, protection: { keepProtectionMediaKeys: !1, ignoreEmeEncryptedEvent: !1, detectPlayreadyMessageFormat: !0 }, buffer: { enableSeekDecorrelationFix: !1, fastSwitchEnabled: !0, flushBufferAtTrackSwitch: !1, reuseExistingSourceBuffers: !0, bufferPruningInterval: 10, bufferToKeep: 20, bufferTimeAtTopQuality: 30, bufferTimeAtTopQualityLongForm: 60, initialBufferLevel: NaN, stableBufferTime: 12, longFormContentDurationThreshold: 600, stallThreshold: 0.3, useAppendWindow: !0, setStallState: !0, avoidCurrentTimeRangePruning: !1, useChangeTypeForTrackSwitch: !0, mediaSourceDurationInfinity: !0, resetSourceBuffersForTrackSwitch: !1 }, gaps: { jumpGaps: !0, jumpLargeGaps: !0, smallGapLimit: 1.5, threshold: 0.3, enableSeekFix: !0, enableStallFix: !1, stallSeek: 0.1 }, utcSynchronization: { enabled: !0, useManifestDateHeaderTimeSource: !0, backgroundAttempts: 2, timeBetweenSyncAttempts: 30, maximumTimeBetweenSyncAttempts: 600, minimumTimeBetweenSyncAttempts: 2, timeBetweenSyncAttemptsAdjustmentFactor: 2, maximumAllowedDrift: 100, enableBackgroundSyncAfterSegmentDownloadError: !0, defaultTimingSource: { scheme: "urn:mpeg:dash:utc:http-xsdate:2014", value: "https://time.akamai.com/?iso&ms" } }, scheduling: { defaultTimeout: 500, lowLatencyTimeout: 0, scheduleWhilePaused: !0 }, text: { defaultEnabled: !0, dispatchForManualRendering: !1, extendSegmentedCues: !0, imsc: { displayForcedOnlyMode: !1, enableRollUp: !0 }, webvtt: { customRenderingEnabled: !1 } }, liveCatchup: { maxDrift: NaN, playbackRate: { min: NaN, max: NaN }, playbackBufferMin: 0.5, enabled: null, mode: e.Z.LIVE_CATCHUP_MODE_DEFAULT }, lastBitrateCachingInfo: { enabled: !0, ttl: 36e4 }, lastMediaSettingsCachingInfo: { enabled: !0, ttl: 36e4 }, saveLastMediaSettingsForCurrentStreamingSession: !0, cacheLoadThresholds: { video: 50, audio: 5 }, trackSwitchMode: { audio: e.Z.TRACK_SWITCH_MODE_ALWAYS_REPLACE, video: e.Z.TRACK_SWITCH_MODE_NEVER_REPLACE }, selectionModeForInitialTrack: e.Z.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY, fragmentRequestTimeout: 2e4, fragmentRequestProgressTimeout: -1, manifestRequestTimeout: 1e4, retryIntervals: (f = {}, m(f, h.w.MPD_TYPE, 500), m(f, h.w.XLINK_EXPANSION_TYPE, 500), m(f, h.w.MEDIA_SEGMENT_TYPE, 1e3), m(f, h.w.INIT_SEGMENT_TYPE, 1e3), m(f, h.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, 1e3), m(f, h.w.INDEX_SEGMENT_TYPE, 1e3), m(f, h.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 1e3), m(f, h.w.LICENSE, 1e3), m(f, h.w.OTHER_TYPE, 1e3), m(f, "lowLatencyReductionFactor", 10), f), retryAttempts: (S = {}, m(S, h.w.MPD_TYPE, 3), m(S, h.w.XLINK_EXPANSION_TYPE, 1), m(S, h.w.MEDIA_SEGMENT_TYPE, 3), m(S, h.w.INIT_SEGMENT_TYPE, 3), m(S, h.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, 3), m(S, h.w.INDEX_SEGMENT_TYPE, 3), m(S, h.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE, 3), m(S, h.w.LICENSE, 3), m(S, h.w.OTHER_TYPE, 3), m(S, "lowLatencyMultiplyFactor", 5), S), abr: { movingAverageMethod: e.Z.MOVING_AVERAGE_SLIDING_WINDOW, ABRStrategy: e.Z.ABR_STRATEGY_DYNAMIC, additionalAbrRules: { insufficientBufferRule: !0, switchHistoryRule: !0, droppedFramesRule: !0, abandonRequestsRule: !0 }, abrRulesParameters: { abandonRequestsRule: { graceTimeThreshold: 500, abandonMultiplier: 1.8, minLengthToAverage: 5 } }, bandwidthSafetyFactor: 0.9, useDefaultABRRules: !0, useDeadTimeLatency: !0, limitBitrateByPortal: !1, usePixelRatioInLimitBitrateByPortal: !1, maxBitrate: { audio: -1, video: -1 }, minBitrate: { audio: -1, video: -1 }, maxRepresentationRatio: { audio: 1, video: 1 }, initialBitrate: { audio: -1, video: -1 }, initialRepresentationRatio: { audio: -1, video: -1 }, autoSwitchBitrate: { audio: !0, video: !0 }, fetchThroughputCalculationMode: e.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING }, cmcd: { enabled: !1, sid: null, cid: null, rtp: null, rtpSafetyFactor: 5, mode: e.Z.CMCD_MODE_QUERY, enabledKeys: ["br", "d", "ot", "tb", "bl", "dl", "mtp", "nor", "nrr", "su", "bs", "rtp", "cid", "pr", "sf", "sid", "st", "v"] }, cmsd: { enabled: !1, abr: { applyMb: !1, etpWeightRatio: 0 } } }, errors: { recoverAttempts: { mediaErrorDecode: 5 } } }, P = E.Z.clone(te);
            function Q(se, K, ie) {
              for (var ge in se) se.hasOwnProperty(ge) && (K.hasOwnProperty(ge) ? v(se[ge]) !== "object" || se[ge] instanceof Array || se[ge] === null ? (K[ge] = E.Z.clone(se[ge]), F[ie + ge] && q.trigger(F[ie + ge])) : Q(se[ge], K[ge], ie.slice() + ge + ".") : console.error("Settings parameter " + ie + ge + " is not supported"));
            }
            return { get: function() {
              return P;
            }, update: function(se) {
              v(se) === "object" && Q(se, P, "");
            }, reset: function() {
              P = E.Z.clone(te);
            } };
          }
          n.__dashjs_factory_name = "Settings";
          var c = J.Z.getSingletonFactory(n);
          fe.Z = c;
        }, 703: function(_e, fe, R) {
          var J = R(3875), E = R.n(J), t = R(1067);
          function e(o) {
            return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
              return typeof v;
            } : function(v) {
              return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
            }, e(o);
          }
          function h(o, v) {
            for (var m = 0; m < v.length; m++) {
              var n = v[m];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(o, n.key, n);
            }
          }
          var p = function() {
            function o() {
              (function(n, c) {
                if (!(n instanceof c)) throw new TypeError("Cannot call a class as a function");
              })(this, o);
            }
            var v, m;
            return v = o, m = [{ key: "mixin", value: function(n, c, f) {
              var S, k = {};
              if (n) for (var q in c) c.hasOwnProperty(q) && (S = c[q], q in n && (n[q] === S || q in k && k[q] === S) || (e(n[q]) === "object" && n[q] !== null ? n[q] = o.mixin(n[q], S, f) : n[q] = f(S)));
              return n;
            } }, { key: "clone", value: function(n) {
              if (!n || e(n) !== "object") return n;
              var c;
              if (n instanceof Array) {
                c = [];
                for (var f = 0, S = n.length; f < S; ++f) f in n && c.push(o.clone(n[f]));
              } else c = {};
              return o.mixin(c, n, o.clone);
            } }, { key: "addAditionalQueryParameterToUrl", value: function(n, c) {
              try {
                if (!c || c.length === 0) return n;
                var f = new URL(n);
                return c.forEach(function(S) {
                  S.key && S.value && f.searchParams.set(S.key, S.value);
                }), f.href;
              } catch {
                return n;
              }
            } }, { key: "parseHttpHeaders", value: function(n) {
              var c = {};
              if (!n) return c;
              for (var f = n.trim().split(`\r
`), S = 0, k = f.length; S < k; S++) {
                var q = f[S], F = q.indexOf(": ");
                F > 0 && (c[q.substring(0, F)] = q.substring(F + 2));
              }
              return c;
            } }, { key: "generateUuid", value: function() {
              var n = (/* @__PURE__ */ new Date()).getTime();
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                var f = (n + 16 * Math.random()) % 16 | 0;
                return n = Math.floor(n / 16), (c == "x" ? f : 3 & f | 8).toString(16);
              });
            } }, { key: "generateHashCode", value: function(n) {
              var c = 0;
              if (n.length === 0) return c;
              for (var f = 0; f < n.length; f++) c = (c << 5) - c + n.charCodeAt(f), c |= 0;
              return c;
            } }, { key: "getRelativeUrl", value: function(n, c) {
              try {
                var f = new URL(n), S = new URL(c);
                if (f.protocol = S.protocol, f.origin !== S.origin) return c;
                var k = E().relative(f.pathname.substr(0, f.pathname.lastIndexOf("/")), S.pathname.substr(0, S.pathname.lastIndexOf("/"))), q = k.length === 0 ? 1 : 0;
                return k += S.pathname.substr(S.pathname.lastIndexOf("/") + q, S.pathname.length - 1), S.pathname.length < k.length ? S.pathname : k;
              } catch {
                return c;
              }
            } }, { key: "parseUserAgent", value: function() {
              var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              try {
                var c = n === null && typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "";
                return (0, t.UAParser)(c);
              } catch {
                return {};
              }
            } }, { key: "stringHasProtocol", value: function(n) {
              return /(http(s?)):\/\//i.test(n);
            } }], m && h(v, m), o;
          }();
          fe.Z = p;
        }, 2032: function(_e, fe, R) {
          function J() {
            return "4.7.4";
          }
          R.d(fe, { e: function() {
            return J;
          } });
        }, 2230: function(_e, fe) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var h = t[e];
              h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(E, h.key, h);
            }
          }
          var J = function() {
            function E() {
              (function(h, p) {
                if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E);
            }
            var t, e;
            return t = E, (e = [{ key: "extend", value: function(h, p) {
              if (h) {
                var o = !!p && p.override, v = !!p && p.publicOnly;
                for (var m in h) !h.hasOwnProperty(m) || this[m] && !o || v && h[m].indexOf("public_") === -1 || (this[m] = h[m]);
              }
            } }]) && R(t.prototype, e), E;
          }();
          fe.Z = J;
        }, 4351: function(_e, fe, R) {
          function J(p) {
            return J = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
              return typeof o;
            } : function(o) {
              return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, J(p);
          }
          function E(p, o) {
            return E = Object.setPrototypeOf || function(v, m) {
              return v.__proto__ = m, v;
            }, E(p, o);
          }
          function t(p, o) {
            return !o || J(o) !== "object" && typeof o != "function" ? function(v) {
              if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }(p) : o;
          }
          function e(p) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            }, e(p);
          }
          var h = function(p) {
            (function(c, f) {
              if (typeof f != "function" && f !== null) throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(f && f.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), f && E(c, f);
            })(n, p);
            var o, v, m = (o = n, v = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var c, f = e(o);
              if (v) {
                var S = e(this).constructor;
                c = Reflect.construct(f, arguments, S);
              } else c = f.apply(this, arguments);
              return t(this, c);
            });
            function n() {
              var c;
              return function(f, S) {
                if (!(f instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (c = m.call(this)).ATTEMPT_BACKGROUND_SYNC = "attemptBackgroundSync", c.BUFFERING_COMPLETED = "bufferingCompleted", c.BUFFER_CLEARED = "bufferCleared", c.BYTES_APPENDED_END_FRAGMENT = "bytesAppendedEndFragment", c.BUFFER_REPLACEMENT_STARTED = "bufferReplacementStarted", c.CHECK_FOR_EXISTENCE_COMPLETED = "checkForExistenceCompleted", c.CMSD_STATIC_HEADER = "cmsdStaticHeader", c.CURRENT_TRACK_CHANGED = "currentTrackChanged", c.DATA_UPDATE_COMPLETED = "dataUpdateCompleted", c.INBAND_EVENTS = "inbandEvents", c.INITIAL_STREAM_SWITCH = "initialStreamSwitch", c.INIT_FRAGMENT_LOADED = "initFragmentLoaded", c.INIT_FRAGMENT_NEEDED = "initFragmentNeeded", c.INTERNAL_MANIFEST_LOADED = "internalManifestLoaded", c.ORIGINAL_MANIFEST_LOADED = "originalManifestLoaded", c.LOADING_COMPLETED = "loadingCompleted", c.LOADING_PROGRESS = "loadingProgress", c.LOADING_DATA_PROGRESS = "loadingDataProgress", c.LOADING_ABANDONED = "loadingAborted", c.MANIFEST_UPDATED = "manifestUpdated", c.MEDIA_FRAGMENT_LOADED = "mediaFragmentLoaded", c.MEDIA_FRAGMENT_NEEDED = "mediaFragmentNeeded", c.QUOTA_EXCEEDED = "quotaExceeded", c.SEGMENT_LOCATION_BLACKLIST_ADD = "segmentLocationBlacklistAdd", c.SEGMENT_LOCATION_BLACKLIST_CHANGED = "segmentLocationBlacklistChanged", c.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD = "serviceLocationBlacklistAdd", c.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED = "serviceLocationBlacklistChanged", c.SERVICE_LOCATION_LOCATION_BLACKLIST_ADD = "serviceLocationLocationBlacklistAdd", c.SERVICE_LOCATION_LOCATION_BLACKLIST_CHANGED = "serviceLocationLocationBlacklistChanged", c.SET_FRAGMENTED_TEXT_AFTER_DISABLED = "setFragmentedTextAfterDisabled", c.SET_NON_FRAGMENTED_TEXT = "setNonFragmentedText", c.SOURCE_BUFFER_ERROR = "sourceBufferError", c.STREAMS_COMPOSED = "streamsComposed", c.STREAM_BUFFERING_COMPLETED = "streamBufferingCompleted", c.STREAM_REQUESTING_COMPLETED = "streamRequestingCompleted", c.TEXT_TRACKS_QUEUE_INITIALIZED = "textTracksQueueInitialized", c.TIME_SYNCHRONIZATION_COMPLETED = "timeSynchronizationComplete", c.UPDATE_TIME_SYNC_OFFSET = "updateTimeSyncOffset", c.URL_RESOLUTION_FAILED = "urlResolutionFailed", c.VIDEO_CHUNK_RECEIVED = "videoChunkReceived", c.WALLCLOCK_TIME_UPDATED = "wallclockTimeUpdated", c.XLINK_ELEMENT_LOADED = "xlinkElementLoaded", c.XLINK_READY = "xlinkReady", c.SEEK_TARGET = "seekTarget", c.SETTING_UPDATED_LIVE_DELAY = "settingUpdatedLiveDelay", c.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT = "settingUpdatedLiveDelayFragmentCount", c.SETTING_UPDATED_CATCHUP_ENABLED = "settingUpdatedCatchupEnabled", c.SETTING_UPDATED_PLAYBACK_RATE_MIN = "settingUpdatedPlaybackRateMin", c.SETTING_UPDATED_PLAYBACK_RATE_MAX = "settingUpdatedPlaybackRateMax", c;
            }
            return n;
          }(R(8342).Z);
          fe.Z = h;
        }, 8512: function(_e, fe, R) {
          function J(v) {
            return J = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(m) {
              return typeof m;
            } : function(m) {
              return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
            }, J(v);
          }
          function E(v, m) {
            if (!(v instanceof m)) throw new TypeError("Cannot call a class as a function");
          }
          function t(v, m) {
            return t = Object.setPrototypeOf || function(n, c) {
              return n.__proto__ = c, n;
            }, t(v, m);
          }
          function e(v, m) {
            return !m || J(m) !== "object" && typeof m != "function" ? function(n) {
              if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return n;
            }(v) : m;
          }
          function h(v) {
            return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(m) {
              return m.__proto__ || Object.getPrototypeOf(m);
            }, h(v);
          }
          var p = function(v) {
            (function(S, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              S.prototype = Object.create(k && k.prototype, { constructor: { value: S, writable: !0, configurable: !0 } }), k && t(S, k);
            })(f, v);
            var m, n, c = (m = f, n = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var S, k = h(m);
              if (n) {
                var q = h(this).constructor;
                S = Reflect.construct(k, arguments, q);
              } else S = k.apply(this, arguments);
              return e(this, S);
            });
            function f() {
              return E(this, f), c.apply(this, arguments);
            }
            return f;
          }(R(4351).Z), o = new p();
          fe.Z = o;
        }, 8342: function(_e, fe) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var h = t[e];
              h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(E, h.key, h);
            }
          }
          var J = function() {
            function E() {
              (function(h, p) {
                if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E);
            }
            var t, e;
            return t = E, (e = [{ key: "extend", value: function(h, p) {
              if (h) {
                var o = !!p && p.override, v = !!p && p.publicOnly;
                for (var m in h) !h.hasOwnProperty(m) || this[m] && !o || v && h[m].indexOf("public_") === -1 || (this[m] = h[m]);
              }
            } }]) && R(t.prototype, e), E;
          }();
          fe.Z = J;
        }, 9326: function(_e, fe, R) {
          var J = R(3186), E = R(7855), t = R(5448), e = R(8825), h = R(7387), p = R(1553);
          function o(v) {
            var m, n, c, f, S, k = (v = v || {}).eventBus, q = v.debug, F = v.urlUtils, te = v.type, P = v.streamInfo, Q = v.segmentsController, se = v.timelineConverter, K = v.baseURLController;
            function ie() {
              return te;
            }
            function ge() {
              c = null;
            }
            function Ne(Ce, Ue, Je) {
              var st, we, Be = K.resolve(Je.path), At = {};
              return Be && Ue !== Be.url && F.isRelative(Ue) ? (st = Be.url, we = Be.serviceLocation, At = Be.queryParams, Ue && (st = F.resolve(Ue, st))) : st = Ue, !F.isRelative(st) && (Ce.url = st, Ce.serviceLocation = we, Ce.queryParams = At, !0);
            }
            function ee(Ce, Ue) {
              if (Ue == null) return null;
              var Je = new J.Z(), st = Ue.representation, we = st.adaptation.period.mpd.manifest.Period_asArray[st.adaptation.period.index].AdaptationSet_asArray[st.adaptation.index].Representation_asArray[st.index].bandwidth, Be = Ue.media;
              return Be = (0, h.vi)(Be, "Number", Ue.replacementNumber), Be = (0, h.vi)(Be, "Time", Ue.replacementTime), Be = (0, h.vi)(Be, "Bandwidth", we), Be = (0, h.Aj)(Be, st.id), Be = (0, h.eR)(Be), Je.mediaType = ie(), Je.type = E.w.MEDIA_SEGMENT_TYPE, Je.range = Ue.mediaRange, Je.startTime = Ue.presentationStartTime, Je.mediaStartTime = Ue.mediaStartTime, Je.duration = Ue.duration, Je.timescale = st.timescale, Je.availabilityStartTime = Ue.availabilityStartTime, Je.availabilityEndTime = Ue.availabilityEndTime, Je.availabilityTimeComplete = st.availabilityTimeComplete, Je.wallStartTime = Ue.wallStartTime, Je.quality = st.index, Je.index = Ue.index, Je.mediaInfo = Ce, Je.adaptationIndex = st.adaptation.index, Je.representationId = st.id, Ne(Je, Be, st) ? Je : void 0;
            }
            function Oe(Ce, Ue, Je) {
              var st = null;
              if (!Ue || !Ue.segmentInfoType) return st;
              var we = Q.getSegmentByTime(Ue, Je);
              return we && (c = we, n.debug("Index for time " + Je + " is " + we.index), st = ee(Ce, we)), st;
            }
            function Ge(Ce, Ue, Je) {
              var st = null, we = Q.getSegmentByIndex(Ue, Je, c ? c.mediaStartTime : -1);
              if (we) st = ee(Ce, we), c = we;
              else {
                if (f && !S) return n.debug(ie() + " No segment found at index: " + Je + ". Wait for next loop"), null;
                S = !0;
              }
              return st;
            }
            function Xe() {
              n.debug("Dynamic stream complete"), S = !0;
            }
            return m = { getCurrentIndex: function() {
              return c ? c.index : -1;
            }, getInitRequest: function(Ce, Ue) {
              return Ue ? function(Je, st, we) {
                var Be = new J.Z(), At = st.adaptation.period, ht = At.start;
                if (Be.mediaType = we, Be.type = E.w.INIT_SEGMENT_TYPE, Be.range = st.range, Be.availabilityStartTime = se.calcAvailabilityStartTimeFromPresentationTime(ht, st, f), Be.availabilityEndTime = se.calcAvailabilityEndTimeFromPresentationTime(ht + At.duration, st, f), Be.quality = st.index, Be.mediaInfo = Je, Be.representationId = st.id, Ne(Be, st.initialization, st)) return Be.url = (0, h.vi)(Be.url, "Bandwidth", st.bandwidth), Be;
              }(Ce, Ue, ie()) : null;
            }, getNextSegmentRequest: function(Ce, Ue) {
              return Ue && Ue.segmentInfoType ? Ge(Ce, Ue, c ? c.index + 1 : 0) : null;
            }, getNextSegmentRequestIdempotent: function(Ce, Ue) {
              var Je = c ? c.index + 1 : 0, st = Q.getSegmentByIndex(Ue, Je, c ? c.mediaStartTime : -1);
              return st ? ee(Ce, st) : null;
            }, getSegmentRequestForTime: Oe, getStreamId: function() {
              return P.id;
            }, getStreamInfo: function() {
              return P;
            }, getType: ie, getValidTimeAheadOfTargetTime: function(Ce, Ue, Je, st) {
              try {
                if (isNaN(Ce) || !Ue || !Je) return NaN;
                if (Ce < 0 && (Ce = 0), isNaN(st) && (st = 0.5), Oe(Ue, Je, Ce)) return Ce;
                if (Je.adaptation.period.start + Je.adaptation.period.duration < Ce) return NaN;
                for (var we = isFinite(Je.adaptation.period.duration) ? Je.adaptation.period.start + Je.adaptation.period.duration : Ce + 30, Be = Math.min(Ce + st, we), At = NaN, ht = null; Be <= we; ) {
                  var je = null;
                  if (Be <= we && (je = Oe(Ue, Je, Be)), je) {
                    At = Be, ht = je;
                    break;
                  }
                  Be += st;
                }
                if (ht) {
                  var it = ht.startTime + ht.duration;
                  return Ce > ht.startTime && it - Ce > st ? Ce : !isNaN(ht.startTime) && Ce < ht.startTime && At > ht.startTime ? ht.startTime + 1e-3 : Math.min(it - st, At);
                }
                return At;
              } catch {
                return NaN;
              }
            }, initialize: function(Ce) {
              f = Ce, S = !1, Q.initialize(Ce);
            }, isLastSegmentRequested: function(Ce, Ue) {
              return !Ce || !c ? !1 : S ? !0 : !isFinite(Ce.adaptation.period.duration) || c.presentationStartTime + c.duration > Ue ? !1 : Ce.mediaFinishedInformation && !isNaN(Ce.mediaFinishedInformation.numberOfSegments) && !isNaN(c.index) && c.index >= Ce.mediaFinishedInformation.numberOfSegments - 1 && (!f || Ce.segmentInfoType === p.Z.SEGMENT_TEMPLATE || f && Ce.segmentInfoType === p.Z.SEGMENT_LIST && Ce.adaptation.period.nextPeriodId) ? !0 : !!(f && Ce.adaptation.period.nextPeriodId && Ce.segmentInfoType === p.Z.SEGMENT_TIMELINE && Ce.mediaFinishedInformation && !isNaN(Ce.mediaFinishedInformation.mediaTimeOfLastSignaledSegment) && c && !isNaN(c.mediaStartTime) && !isNaN(c.duration) && c.mediaStartTime + c.duration >= Ce.mediaFinishedInformation.mediaTimeOfLastSignaledSegment - 0.05);
            }, repeatSegmentRequest: function(Ce, Ue) {
              return Ue && Ue.segmentInfoType ? Ge(Ce, Ue, c ? c.index : 0) : null;
            }, reset: function() {
              ge(), k.off(e.Z.DYNAMIC_TO_STATIC, Xe, m);
            } }, n = q.getLogger(m), ge(), k.on(e.Z.DYNAMIC_TO_STATIC, Xe, m), m;
          }
          o.__dashjs_factory_name = "DashHandler", fe.Z = t.Z.getClassFactory(o);
        }, 1553: function(_e, fe) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var h = t[e];
              h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(E, h.key, h);
            }
          }
          var J = new (function() {
            function E() {
              (function(h, p) {
                if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E), this.init();
            }
            var t, e;
            return t = E, (e = [{ key: "init", value: function() {
              this.BASE_URL = "BaseURL", this.SEGMENT_BASE = "SegmentBase", this.SEGMENT_TEMPLATE = "SegmentTemplate", this.SEGMENT_LIST = "SegmentList", this.SEGMENT_URL = "SegmentURL", this.SEGMENT_TIMELINE = "SegmentTimeline", this.SEGMENT_PROFILES = "segmentProfiles", this.ADAPTATION_SET = "AdaptationSet", this.REPRESENTATION = "Representation", this.REPRESENTATION_INDEX = "RepresentationIndex", this.SUB_REPRESENTATION = "SubRepresentation", this.INITIALIZATION = "Initialization", this.INITIALIZATION_MINUS = "initialization", this.MPD = "MPD", this.PERIOD = "Period", this.ASSET_IDENTIFIER = "AssetIdentifier", this.EVENT_STREAM = "EventStream", this.ID = "id", this.PROFILES = "profiles", this.SERVICE_LOCATION = "serviceLocation", this.RANGE = "range", this.INDEX = "index", this.MEDIA = "media", this.BYTE_RANGE = "byteRange", this.INDEX_RANGE = "indexRange", this.MEDIA_RANGE = "mediaRange", this.VALUE = "value", this.CONTENT_TYPE = "contentType", this.MIME_TYPE = "mimeType", this.BITSTREAM_SWITCHING = "BitstreamSwitching", this.BITSTREAM_SWITCHING_MINUS = "bitstreamSwitching", this.CODECS = "codecs", this.DEPENDENCY_ID = "dependencyId", this.MEDIA_STREAM_STRUCTURE_ID = "mediaStreamStructureId", this.METRICS = "Metrics", this.METRICS_MINUS = "metrics", this.REPORTING = "Reporting", this.WIDTH = "width", this.HEIGHT = "height", this.SAR = "sar", this.FRAMERATE = "frameRate", this.AUDIO_SAMPLING_RATE = "audioSamplingRate", this.MAXIMUM_SAP_PERIOD = "maximumSAPPeriod", this.START_WITH_SAP = "startWithSAP", this.MAX_PLAYOUT_RATE = "maxPlayoutRate", this.CODING_DEPENDENCY = "codingDependency", this.SCAN_TYPE = "scanType", this.FRAME_PACKING = "FramePacking", this.AUDIO_CHANNEL_CONFIGURATION = "AudioChannelConfiguration", this.CONTENT_PROTECTION = "ContentProtection", this.ESSENTIAL_PROPERTY = "EssentialProperty", this.ESSENTIAL_PROPERTY_ASARRAY = "EssentialProperty_asArray", this.SUPPLEMENTAL_PROPERTY = "SupplementalProperty", this.SUPPLEMENTAL_PROPERTY_ASARRAY = "SupplementalProperty_asArray", this.INBAND_EVENT_STREAM = "InbandEventStream", this.PRODUCER_REFERENCE_TIME = "ProducerReferenceTime", this.INBAND = "inband", this.TYPE = "type", this.ACCESSIBILITY = "Accessibility", this.ROLE = "Role", this.RATING = "Rating", this.CONTENT_COMPONENT = "ContentComponent", this.SUBSET = "Subset", this.LANG = "lang", this.VIEWPOINT = "Viewpoint", this.VIEWPOINT_ASARRAY = "Viewpoint_asArray", this.ROLE_ASARRAY = "Role_asArray", this.REPRESENTATION_ASARRAY = "Representation_asArray", this.PRODUCERREFERENCETIME_ASARRAY = "ProducerReferenceTime_asArray", this.ACCESSIBILITY_ASARRAY = "Accessibility_asArray", this.AUDIOCHANNELCONFIGURATION_ASARRAY = "AudioChannelConfiguration_asArray", this.CONTENTPROTECTION_ASARRAY = "ContentProtection_asArray", this.MAIN = "main", this.DYNAMIC = "dynamic", this.STATIC = "static", this.MEDIA_PRESENTATION_DURATION = "mediaPresentationDuration", this.MINIMUM_UPDATE_PERIOD = "minimumUpdatePeriod", this.CODEC_PRIVATE_DATA = "codecPrivateData", this.BANDWITH = "bandwidth", this.SOURCE_URL = "sourceURL", this.TIMESCALE = "timescale", this.DURATION = "duration", this.START_NUMBER = "startNumber", this.PRESENTATION_TIME_OFFSET = "presentationTimeOffset", this.AVAILABILITY_START_TIME = "availabilityStartTime", this.AVAILABILITY_END_TIME = "availabilityEndTime", this.TIMESHIFT_BUFFER_DEPTH = "timeShiftBufferDepth", this.MAX_SEGMENT_DURATION = "maxSegmentDuration", this.PRESENTATION_TIME = "presentationTime", this.MIN_BUFFER_TIME = "minBufferTime", this.MAX_SUBSEGMENT_DURATION = "maxSubsegmentDuration", this.START = "start", this.AVAILABILITY_TIME_OFFSET = "availabilityTimeOffset", this.AVAILABILITY_TIME_COMPLETE = "availabilityTimeComplete", this.CENC_DEFAULT_KID = "cenc:default_KID", this.DVB_PRIORITY = "dvb:priority", this.DVB_WEIGHT = "dvb:weight", this.DVB_URL = "dvb:url", this.DVB_MIMETYPE = "dvb:mimeType", this.DVB_FONTFAMILY = "dvb:fontFamily", this.SUGGESTED_PRESENTATION_DELAY = "suggestedPresentationDelay", this.SERVICE_DESCRIPTION = "ServiceDescription", this.SERVICE_DESCRIPTION_SCOPE = "Scope", this.SERVICE_DESCRIPTION_LATENCY = "Latency", this.SERVICE_DESCRIPTION_PLAYBACK_RATE = "PlaybackRate", this.SERVICE_DESCRIPTION_OPERATING_QUALITY = "OperatingQuality", this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH = "OperatingBandwidth", this.PATCH_LOCATION = "PatchLocation", this.PATCH_LOCATION_AS_ARRAY = "PatchLocation_asArray", this.LOCATION = "Location", this.LOCATION_AS_ARRAY = "Location_asArray", this.PUBLISH_TIME = "publishTime", this.ORIGINAL_PUBLISH_TIME = "originalPublishTime", this.ORIGINAL_MPD_ID = "mpdId", this.WALL_CLOCK_TIME = "wallClockTime", this.PRESENTATION_TIME = "presentationTime", this.LABEL = "Label", this.GROUP_LABEL = "GroupLabel", this.CONTENT_STEERING = "ContentSteering", this.CONTENT_STEERING_AS_ARRAY = "ContentSteering_asArray", this.DEFAULT_SERVICE_LOCATION = "defaultServiceLocation", this.QUERY_BEFORE_START = "queryBeforeStart", this.CLIENT_REQUIREMENT = "clientRequirement", this.TTL = "ttl", this.CONTENT_STEERING_RESPONSE = { VERSION: "VERSION", TTL: "TTL", RELOAD_URI: "RELOAD-URI", PATHWAY_PRIORITY: "PATHWAY-PRIORITY", PATHWAY_CLONES: "PATHWAY-CLONES", BASE_ID: "BASE-ID", ID: "ID", URI_REPLACEMENT: "URI-REPLACEMENT", HOST: "HOST", PARAMS: "PARAMS" }, this.PRODUCER_REFERENCE_TIME_TYPE = { ENCODER: "encoder", CAPTURED: "captured", APPLICATION: "application" }, this.SEGMENT_ALIGNMENT = "segmentAlignment", this.SUB_SEGMENT_ALIGNMENT = "subsegmentAlignment";
            } }]) && R(t.prototype, e), E;
          }())();
          fe.Z = J;
        }, 7802: function(_e, fe, R) {
          var J = R(5448), E = R(1724), t = R(3636), e = R(1736), h = R(5246);
          function p(v) {
            v = v || {};
            var m, n, c = this.context, f = v.dashConstants, S = v.type, k = v.segmentBaseController;
            function q(F) {
              return F ? F.segments ? n[f.SEGMENT_BASE] : n[F.segmentInfoType] : null;
            }
            return m = { initialize: function(F) {
              n[f.SEGMENT_TIMELINE] = (0, E.Z)(c).create(v, F), n[f.SEGMENT_TEMPLATE] = (0, t.Z)(c).create(v, F), n[f.SEGMENT_LIST] = (0, e.Z)(c).create(v, F), n[f.SEGMENT_BASE] = (0, h.Z)(c).create(v, F);
            }, updateInitData: function(F, te) {
              return te ? Promise.resolve() : k.getSegmentBaseInitSegment({ representation: F, mediaType: S });
            }, updateSegmentData: function(F, te) {
              return te ? Promise.resolve() : k.getSegmentList({ mimeType: F.mimeType, representation: F, mediaType: S });
            }, getSegmentByIndex: function(F, te, P) {
              var Q = q(F);
              return Q ? Q.getSegmentByIndex(F, te, P) : null;
            }, getSegmentByTime: function(F, te) {
              var P = q(F);
              return P ? P.getSegmentByTime(F, te) : null;
            }, getMediaFinishedInformation: function(F) {
              var te = q(F);
              return te ? te.getMediaFinishedInformation(F) : { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
            } }, n = {}, m;
          }
          p.__dashjs_factory_name = "SegmentsController";
          var o = J.Z.getClassFactory(p);
          fe.Z = o;
        }, 1736: function(_e, fe, R) {
          var J = R(5448), E = R(3393), t = R(7387);
          function e(p, o) {
            var v = (p = p || {}).timelineConverter;
            function m() {
              if (!v || !v.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function n(c, f) {
              if (m(), !c) return null;
              var S = c.adaptation.period.mpd.manifest.Period_asArray[c.adaptation.period.index].AdaptationSet_asArray[c.adaptation.index].Representation_asArray[c.index].SegmentList, k = S.SegmentURL_asArray.length, q = c && !isNaN(c.startNumber) ? c.startNumber : 1, F = Math.max(q - 1, 0), te = Math.max(f - F, 0), P = null;
              if (te < k) {
                var Q = S.SegmentURL_asArray[te];
                (P = (0, t.NF)(v, o, c, f)) && (P.replacementTime = (q + f - 1) * c.segmentDuration, P.media = Q.media ? Q.media : "", P.mediaRange = Q.mediaRange, P.indexRange = Q.indexRange);
              }
              return P;
            }
            return { getSegmentByIndex: n, getSegmentByTime: function(c, f) {
              if (m(), !c) return null;
              var S = c.segmentDuration;
              if (isNaN(S)) return null;
              var k = v.calcPeriodRelativeTimeFromMpdRelativeTime(c, f);
              return n(c, Math.floor(k / S));
            }, getMediaFinishedInformation: function(c) {
              var f = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              if (!c) return f;
              var S = c.adaptation.period.mpd.manifest.Period_asArray[c.adaptation.period.index].AdaptationSet_asArray[c.adaptation.index].Representation_asArray[c.index].SegmentList, k = c && !isNaN(c.startNumber) ? c.startNumber : 1, q = Math.max(k - 1, 0);
              return f.numberOfSegments = q + S.SegmentURL_asArray.length, f;
            } };
          }
          e.__dashjs_factory_name = "ListSegmentsGetter";
          var h = J.Z.getClassFactory(e);
          fe.Z = h;
        }, 5246: function(_e, fe, R) {
          var J = R(5448), E = R(3393);
          function t(h) {
            var p = (h = h || {}).timelineConverter;
            function o() {
              if (!p || !p.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function v(m, n) {
              if (o(), !m) return null;
              var c, f = m.segments ? m.segments.length : -1;
              if (n < f && (c = m.segments[n]) && c.index === n) return c;
              for (var S = 0; S < f; S++) if ((c = m.segments[S]) && c.index === n) return c;
              return null;
            }
            return { getSegmentByIndex: v, getSegmentByTime: function(m, n) {
              o();
              var c = function(f, S) {
                if (!f) return -1;
                var k, q, F, te, P, Q = f.segments, se = Q ? Q.length : null, K = -1;
                if (Q && se > 0) {
                  for (P = 0; P < se; P++) if (F = (q = Q[P]).presentationStartTime, S + (k = (te = q.duration) / 2) >= F && S - k < F + te) {
                    K = q.index;
                    break;
                  }
                }
                return K;
              }(m, n);
              return v(m, c);
            }, getMediaFinishedInformation: function(m) {
              var n = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              return m && m.segments && (n.numberOfSegments = m.segments.length), n;
            } };
          }
          t.__dashjs_factory_name = "SegmentBaseGetter";
          var e = J.Z.getClassFactory(t);
          fe.Z = e;
        }, 7387: function(_e, fe, R) {
          R.d(fe, { Aj: function() {
            return e;
          }, NF: function() {
            return v;
          }, TJ: function() {
            return m;
          }, eR: function() {
            return t;
          }, vi: function() {
            return h;
          } });
          var J = R(2011);
          function E(n, c) {
            for (; n.length < c; ) n = "0" + n;
            return n;
          }
          function t(n) {
            return n && n.split("$$").join("$");
          }
          function e(n, c) {
            if (!c || !n || n.indexOf("$RepresentationID$") === -1) return n;
            var f = c.toString();
            return n.split("$RepresentationID$").join(f);
          }
          function h(n, c, f) {
            var S, k, q, F, te, P, Q = c.length, se = 2;
            if (!n) return n;
            for (; ; ) {
              if ((S = n.indexOf("$" + c)) < 0 || (k = n.indexOf("$", S + Q)) < 0) return n;
              if ((q = n.indexOf("%0", S + Q)) > S && q < k) switch (F = n.charAt(k - 1), te = parseInt(n.substring(q + se, k - 1), 10), F) {
                case "d":
                case "i":
                case "u":
                  P = E(f.toString(), te);
                  break;
                case "x":
                  P = E(f.toString(16), te);
                  break;
                case "X":
                  P = E(f.toString(16), te).toUpperCase();
                  break;
                case "o":
                  P = E(f.toString(8), te);
                  break;
                default:
                  return n;
              }
              else P = f;
              n = n.substring(0, S) + P + n.substring(k + 1);
            }
          }
          function p(n, c, f, S, k, q, F, te) {
            var P, Q = new J.Z();
            return Q.representation = n, Q.duration = c, Q.presentationStartTime = f, Q.mediaStartTime = S, Q.availabilityStartTime = k.calcAvailabilityStartTimeFromPresentationTime(q, n, F), Q.availabilityEndTime = k.calcAvailabilityEndTimeFromPresentationTime(q + c, n, F), Q.wallStartTime = k.calcWallTimeForSegment(Q, F), Q.replacementNumber = (P = te, Q.representation.startNumber + P), Q.index = te, Q;
          }
          function o(n, c, f, S) {
            var k = c.adaptation.period;
            if (isFinite(k.duration) && k.start + k.duration <= f.presentationStartTime) return !1;
            if (S) {
              if (c.availabilityTimeOffset === "INF") return !0;
              var q = n.getClientReferenceTime();
              return f.availabilityStartTime.getTime() <= q && (!isFinite(f.availabilityEndTime) || f.availabilityEndTime.getTime() >= q);
            }
            return !0;
          }
          function v(n, c, f, S) {
            var k, q, F;
            k = f.segmentDuration, isNaN(k) && (k = f.adaptation.period.duration), q = parseFloat((f.adaptation.period.start + S * k).toFixed(5)), F = parseFloat((q + k).toFixed(5));
            var te = p(f, k, q, n.calcMediaTimeFromPresentationTime(q, f), n, F, c, S);
            return o(n, f, te, c) ? te : null;
          }
          function m(n, c, f, S, k, q, F, te, P, Q) {
            var se, K, ie = S / q, ge = k / q;
            return se = n.calcPresentationTimeFromMediaTime(ie, f), o(n, f, K = p(f, ge, se, ie, n, se + ge, c, P), c) ? (K.replacementTime = Q || S, F = h(F, "Number", K.replacementNumber), F = h(F, "Time", K.replacementTime), K.media = F, K.mediaRange = te, K) : null;
          }
        }, 3636: function(_e, fe, R) {
          var J = R(5448), E = R(3393), t = R(7387);
          function e(p, o) {
            var v = (p = p || {}).timelineConverter;
            function m() {
              if (!v || !v.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime")) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function n(c, f) {
              if (m(), !c) return null;
              var S = c.adaptation.period.mpd.manifest.Period_asArray[c.adaptation.period.index].AdaptationSet_asArray[c.adaptation.index].Representation_asArray[c.index].SegmentTemplate;
              f = Math.max(f, 0);
              var k = (0, t.NF)(v, o, c, f);
              if (k) {
                k.replacementTime = Math.round((f - 1) * c.segmentDuration * c.timescale, 10);
                var q = S.media;
                q = (0, t.vi)(q, "Number", k.replacementNumber), q = (0, t.vi)(q, "Time", k.replacementTime), k.media = q;
              }
              return k;
            }
            return { getSegmentByIndex: n, getSegmentByTime: function(c, f) {
              if (m(), !c) return null;
              var S = c.segmentDuration;
              if (isNaN(S)) return null;
              var k = v.calcPeriodRelativeTimeFromMpdRelativeTime(c, f);
              return n(c, Math.floor(k / S));
            }, getMediaFinishedInformation: function(c) {
              var f = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN };
              if (!c) return f;
              var S = c.segmentDuration;
              return isNaN(S) ? f.numberOfSegments = 1 : f.numberOfSegments = Math.ceil(c.adaptation.period.duration / S), f;
            } };
          }
          e.__dashjs_factory_name = "TemplateSegmentsGetter";
          var h = J.Z.getClassFactory(e);
          fe.Z = h;
        }, 1724: function(_e, fe, R) {
          var J = R(5448), E = R(3393), t = R(7387);
          function e(p, o) {
            var v = (p = p || {}).timelineConverter, m = p.dashMetrics;
            function n() {
              if (!v) throw new Error(E.Z.MISSING_CONFIG_ERROR);
            }
            function c(S, k) {
              var q, F, te, P, Q, se, K, ie = S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentTemplate || S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentList, ge = ie.SegmentTimeline, Ne = ie.SegmentURL_asArray, ee = 0, Oe = -1;
              K = S.timescale;
              var Ge = !1;
              for (te = 0, P = (q = ge.S_asArray).length; te < P && !Ge; te++) for (se = 0, (F = q[te]).hasOwnProperty("r") && (se = F.r), F.hasOwnProperty("t") && (ee = F.t), se < 0 && (se = f(S, q[te + 1], F, K, ee / K)), Q = 0; Q <= se && !Ge; Q++) (Ge = k(ee, ie, Ne, F, K, ++Oe, te)) && (S.segmentDuration = F.d / K), ee += F.d;
            }
            function f(S, k, q, F, te) {
              var P;
              if (k && k.hasOwnProperty("t")) P = k.t / F;
              else try {
                var Q = 0;
                if (isNaN(S.adaptation.period.start) || isNaN(S.adaptation.period.duration) || !isFinite(S.adaptation.period.duration)) {
                  var se = m.getCurrentDVRInfo();
                  Q = isNaN(se.end) ? 0 : se.end;
                } else Q = S.adaptation.period.start + S.adaptation.period.duration;
                P = v.calcMediaTimeFromPresentationTime(Q, S), S.segmentDuration = q.d / F;
              } catch {
                P = 0;
              }
              return Math.max(Math.ceil((P - te) / (q.d / F)) - 1, 0);
            }
            return { getSegmentByIndex: function(S, k, q) {
              if (n(), !S) return null;
              var F = null, te = !1;
              return c(S, function(P, Q, se, K, ie, ge, Ne) {
                if (te || q < 0) {
                  var ee = Q.media, Oe = K.mediaRange;
                  return se && (ee = se[Ne].media || "", Oe = se[Ne].mediaRange), F = (0, t.TJ)(v, o, S, P, K.d, ie, ee, Oe, ge, K.tManifest), !0;
                }
                return P >= q * ie - 0.5 * K.d && (te = !0), !1;
              }), F;
            }, getSegmentByTime: function(S, k) {
              if (n(), !S) return null;
              k === void 0 && (k = null);
              var q = null, F = v.calcMediaTimeFromPresentationTime(k, S);
              return c(S, function(te, P, Q, se, K, ie, ge) {
                var Ne = parseFloat((F * K).toPrecision(15));
                if (Ne < te + se.d && Ne >= te) {
                  var ee = P.media, Oe = se.mediaRange;
                  return Q && (ee = Q[ge].media || "", Oe = Q[ge].mediaRange), q = (0, t.TJ)(v, o, S, te, se.d, K, ee, Oe, ie, se.tManifest), !0;
                }
                return !1;
              }), q;
            }, getMediaFinishedInformation: function(S) {
              if (!S) return 0;
              var k, q, F, te, P, Q, se, K = (S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentTemplate || S.adaptation.period.mpd.manifest.Period_asArray[S.adaptation.period.index].AdaptationSet_asArray[S.adaptation.index].Representation_asArray[S.index].SegmentList).SegmentTimeline, ie = 0, ge = 0, Ne = 0;
              for (se = S.timescale, te = (k = K.S_asArray).length, F = 0; F < te; F++) for (Q = 0, (q = k[F]).hasOwnProperty("r") && (Q = q.r), q.hasOwnProperty("t") && (ge = (ie = q.t) / se), Q < 0 && (Q = f(S, k[F + 1], q, se, ge)), P = 0; P <= Q; P++) Ne++, ge = (ie += q.d) / se;
              return { numberOfSegments: Ne, mediaTimeOfLastSignaledSegment: ge };
            } };
          }
          e.__dashjs_factory_name = "TimelineSegmentsGetter";
          var h = J.Z.getClassFactory(e);
          fe.Z = h;
        }, 2011: function(_e, fe) {
          fe.Z = function R() {
            (function(J, E) {
              if (!(J instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.indexRange = null, this.index = null, this.mediaRange = null, this.media = null, this.duration = NaN, this.replacementTime = null, this.replacementNumber = NaN, this.mediaStartTime = NaN, this.presentationStartTime = NaN, this.availabilityStartTime = NaN, this.availabilityEndTime = NaN, this.wallStartTime = NaN, this.representation = null;
          };
        }, 2610: function(_e, fe) {
          fe.Z = function R() {
            (function(J, E) {
              if (!(J instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.schemeIdUri = "", this.value = "";
          };
        }, 1139: function(_e, fe, R) {
          R.d(fe, { Z: function() {
            return Oc;
          } });
          var J = R(452), E = R.n(J), t = R(3393), e = R(1553), h = R(3860), p = R(5595), o = R(8512), v = R(5448), m = R(6398), n = R(8825);
          function c() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j, ue, z, me, g, x, O, L = this.context, A = (0, p.Z)(L).getInstance();
            function oe() {
              U(), G = !1, Y = 0, V = 0, he = 0, g = !1, Ee = !0, j = !1, x = !1, ue = NaN, ae = NaN, y && (A.off(o.Z.DATA_UPDATE_COMPLETED, Qe, i), A.off(o.Z.LOADING_PROGRESS, Vt, i), A.off(o.Z.MANIFEST_UPDATED, ft, i), A.off(o.Z.STREAMS_COMPOSED, ye, i), A.off(n.Z.PLAYBACK_ENDED, pt, i), A.off(n.Z.STREAM_INITIALIZING, We, i), A.off(n.Z.REPRESENTATION_SWITCH, Pe, i), A.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, mt, i), yt(), y.removeEventListener("canplay", Tt), y.removeEventListener("canplaythrough", vt), y.removeEventListener("play", Wt), y.removeEventListener("waiting", zt), y.removeEventListener("playing", hn), y.removeEventListener("pause", yn), y.removeEventListener("error", kt), y.removeEventListener("seeking", ze), y.removeEventListener("seeked", Et), y.removeEventListener("timeupdate", lt), y.removeEventListener("progress", wt), y.removeEventListener("ratechange", Pt), y.removeEventListener("loadedmetadata", $t), y.removeEventListener("loadeddata", Qt), y.removeEventListener("stalled", Xt), y.removeEventListener("ended", en), y.removeEventListener("volumechange", ln)), Z = null, y = null, M = null, H = null;
            }
            function X() {
              var Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              return parseFloat((de(Ae) - De()).toFixed(5));
            }
            function de(Ae) {
              var tt = Ae || M;
              return tt.start + tt.duration;
            }
            function ne() {
              var Ae = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              M && y && y.getElement() ? (Ae && H && Fe(De()), y.play()) : G = !0;
            }
            function U() {
              M && y && y.pause();
            }
            function re(Ae) {
              var tt = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Nt = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
              if (M && y && y.getElement()) {
                var _n = isNaN(ue) ? y.getTime() : ue;
                Ae !== _n && ((z = Nt === !0) || (ue = Ae), r.info("Requesting seek to time: " + Ae + (z ? " (internal)" : "")), H && xt && Fe(Ae), y.setCurrentTime(Ae, tt));
              }
            }
            function Te() {
              if (M && y && H) {
                var Ae = u && u.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, tt = w.getCurrentDVRInfo(Ae);
                return tt && tt.range ? tt.range.end : 0;
              }
            }
            function Fe(Ae) {
              var tt = new Date(N.getClientReferenceTime()), Nt = I.getRegularPeriods()[0], xt = N.calcPresentationTimeFromWallTime(tt, Nt);
              Y = xt - Ae;
            }
            function De() {
              return M && y ? y.getTime() : null;
            }
            function ke() {
              return M && y ? y.isPaused() : null;
            }
            function Le() {
              return M && y ? y.isSeeking() : null;
            }
            function ut() {
              return M && y ? y.isStalled() : null;
            }
            function ct() {
              return M && y ? y.getPlaybackRate() : null;
            }
            function rt() {
              return M && y ? y.getEnded() : null;
            }
            function at() {
              return H;
            }
            function Bt() {
              var Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              if (!ke() && H && y.getReadyState() !== 0 && !Le() && !g) {
                Ae || (Ae = u.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO);
                var tt = De(), Nt = Re(tt, Ae), xt = !isNaN(Nt) && Nt !== tt;
                xt && !Le() && (ut() || me || y.getReadyState() === 1) && (r.debug("UpdateCurrentTime: Seek to actual time: ".concat(Nt, " from currentTime: ").concat(tt)), re(Nt, !1, !1));
              }
            }
            function Re(Ae, tt) {
              var Nt = w.getCurrentDVRInfo(tt), xt = Nt ? Nt.range : null;
              return xt ? Ae > xt.end ? Math.max(xt.end - Y, xt.start) : Ae > 0 && Ae + 0.25 < xt.start && Math.abs(Ae - xt.start) < 31536e4 ? j ? Math.max(xt.end - Y, xt.start) : xt.start : Ae : NaN;
            }
            function He() {
              Z === null && (Z = setInterval(function() {
                (function() {
                  if (A.trigger(o.Z.WALLCLOCK_TIME_UPDATED, { isDynamic: H, time: /* @__PURE__ */ new Date() }), at()) {
                    var Ae = Date.now();
                    (isNaN(ae) || Ae > ae + O.get().streaming.liveUpdateTimeThresholdInMilliseconds) && (u.addDVRMetric(), ke() ? function() {
                      var tt = Date.now();
                      (!pe || tt > pe + 500) && (pe = tt, lt());
                    }() : Bt(), ae = Ae);
                  }
                })();
              }, O.get().streaming.wallclockTimeUpdateInterval));
            }
            function yt() {
              clearInterval(Z), Z = null;
            }
            function Qe(Ae) {
              var tt = I.convertRepresentationToRepresentationInfo(Ae.currentRepresentation), Nt = tt ? tt.mediaInfo.streamInfo : null;
              Nt !== null && M.id === Nt.id && (M = Nt);
            }
            function Tt() {
              A.trigger(o.Z.CAN_PLAY);
            }
            function vt() {
              A.trigger(o.Z.CAN_PLAY_THROUGH);
            }
            function mt(Ae) {
              Ae.streamId === u.getActiveStreamInfo().id && (me = Ae.state === h.Z.BUFFER_EMPTY, O.get().streaming.buffer.setStallState && y.setStallState(Ae.mediaType, Ae.state === h.Z.BUFFER_EMPTY));
            }
            function Wt() {
              r.info("Native video element event: play"), Bt(), He(), A.trigger(o.Z.PLAYBACK_STARTED, { startTime: De() });
            }
            function zt() {
              r.info("Native video element event: waiting"), A.trigger(o.Z.PLAYBACK_WAITING, { playingTime: De() });
            }
            function hn() {
              r.info("Native video element event: playing"), z = !1, A.trigger(o.Z.PLAYBACK_PLAYING, { playingTime: De() });
            }
            function yn() {
              r.info("Native video element event: pause"), A.trigger(o.Z.PLAYBACK_PAUSED, { ended: rt() });
            }
            function ze() {
              if (!z) {
                var Ae = De();
                isNaN(ue) || ue === Ae || (Ae = ue), ue = NaN, r.info("Seeking to: " + Ae), He(), A.trigger(o.Z.PLAYBACK_SEEKING, { seekTime: Ae, streamId: M.id });
              }
            }
            function Et() {
              r.info("Native video element event: seeked"), z = !1, A.trigger(o.Z.PLAYBACK_SEEKED);
            }
            function lt() {
              M && A.trigger(o.Z.PLAYBACK_TIME_UPDATED, { timeToEnd: X(), time: De(), streamId: M.id });
            }
            function wt() {
              A.trigger(o.Z.PLAYBACK_PROGRESS, { streamId: M.id });
            }
            function Pt() {
              var Ae = ct();
              r.info("Native video element event: ratechange: ", Ae), A.trigger(o.Z.PLAYBACK_RATE_CHANGED, { playbackRate: Ae });
            }
            function $t() {
              r.info("Native video element event: loadedmetadata"), A.trigger(o.Z.PLAYBACK_METADATA_LOADED), He();
            }
            function Qt() {
              r.info("Native video element event: loadeddata"), A.trigger(o.Z.PLAYBACK_LOADED_DATA);
            }
            function en() {
              r.info("Native video element event: ended"), U(), yt();
              var Ae = u ? u.getActiveStreamInfo() : null;
              Ae && A.trigger(o.Z.PLAYBACK_ENDED, { isLast: Ae.isLast });
            }
            function ln() {
              A.trigger(o.Z.PLAYBACK_VOLUME_CHANGED);
            }
            function pt(Ae) {
              if (Z && Ae.isLast) {
                r.info("onPlaybackEnded -- PLAYBACK_ENDED but native video element didn't fire ended");
                var tt = Ae.seekTime ? Ae.seekTime : de();
                y.setCurrentTime(tt), U(), yt();
              }
            }
            function kt(Ae) {
              var tt = Ae.target || Ae.srcElement;
              A.trigger(o.Z.PLAYBACK_ERROR, { error: tt.error });
            }
            function qt() {
              H = !1;
            }
            function Vt(Ae) {
              if (Ae.stream === !1 && j && !isNaN(Ae.request.duration)) {
                var tt = 1.2 * Ae.request.duration;
                tt > Y && (r.warn("Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:", tt.toFixed(2)), Y = tt, V = tt);
              }
            }
            function Xt(Ae) {
              A.trigger(o.Z.PLAYBACK_STALLED, { e: Ae });
            }
            function We(Ae) {
              var tt;
              (tt = Ae.mediaInfo) && tt.supplementalProperties && tt.supplementalProperties[t.Z.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME] && tt.supplementalProperties[t.Z.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME].value === "true" && (r.debug("Low Latency critical SupplementalProperty set: Enabling low Latency"), j = !0);
            }
            function Pe(Ae) {
              var tt = u.getActiveStreamInfo();
              Ae && tt && Ae.currentRepresentation && Ae.streamId && Ae.streamId === tt.id && Ae.mediaType && (Ae.mediaType === t.Z.VIDEO || Ae.mediaType === t.Z.AUDIO) && (Ee = Ae.currentRepresentation.availabilityTimeComplete, (j = !Ee) && !x && (x = !0));
            }
            function ft() {
              g = !0;
            }
            function ye() {
              g = !1;
            }
            return i = { initialize: function(Ae, tt) {
              M = Ae, tt !== !0 && (y.addEventListener("canplay", Tt), y.addEventListener("canplaythrough", vt), y.addEventListener("play", Wt), y.addEventListener("waiting", zt), y.addEventListener("playing", hn), y.addEventListener("pause", yn), y.addEventListener("error", kt), y.addEventListener("seeking", ze), y.addEventListener("seeked", Et), y.addEventListener("timeupdate", lt), y.addEventListener("progress", wt), y.addEventListener("ratechange", Pt), y.addEventListener("loadedmetadata", $t), y.addEventListener("loadeddata", Qt), y.addEventListener("stalled", Xt), y.addEventListener("ended", en), y.addEventListener("volumechange", ln), H = M.manifestInfo.isDynamic, me = !1, z = !1, A.on(o.Z.DATA_UPDATE_COMPLETED, Qe, i), A.on(o.Z.LOADING_PROGRESS, Vt, i), A.on(o.Z.MANIFEST_UPDATED, ft, i), A.on(o.Z.STREAMS_COMPOSED, ye, i), A.on(n.Z.PLAYBACK_ENDED, pt, i, { priority: p.Z.EVENT_PRIORITY_HIGH }), A.on(n.Z.STREAM_INITIALIZING, We, i), A.on(n.Z.REPRESENTATION_SWITCH, Pe, i), A.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, mt, i), A.on(n.Z.DYNAMIC_TO_STATIC, qt, i), G && (G = !1, ne()));
            }, setConfig: function(Ae) {
              Ae && (Ae.streamController && (u = Ae.streamController), Ae.serviceDescriptionController && (_ = Ae.serviceDescriptionController), Ae.dashMetrics && (w = Ae.dashMetrics), Ae.adapter && (I = Ae.adapter), Ae.videoModel && (y = Ae.videoModel), Ae.timelineConverter && (N = Ae.timelineConverter), Ae.settings && (O = Ae.settings));
            }, getTimeToStreamEnd: X, getBufferLevel: function() {
              var Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, tt = null;
              return u.getActiveStreamProcessors().forEach(function(Nt) {
                if (!Ae || Ae.length === 0 || Ae.indexOf(Nt.getType()) === -1) {
                  var xt = Nt.getBufferLevel();
                  tt = tt === null ? xt : Math.min(tt, xt);
                }
              }), tt;
            }, getPlaybackStalled: function() {
              return me;
            }, getTime: De, getLowLatencyModeEnabled: function() {
              return j;
            }, getInitialCatchupModeActivated: function() {
              return x;
            }, getIsManifestUpdateInProgress: function() {
              return g;
            }, getPlaybackRate: ct, getPlayedRanges: function() {
              return M && y ? y.getPlayedRanges() : null;
            }, getEnded: rt, getIsDynamic: at, getStreamController: function() {
              return u;
            }, computeAndSetLiveDelay: function(Ae, tt) {
              var Nt, xt, _n, Ln = !isNaN(Ae) && isFinite(Ae) ? Ae : NaN, $n = I.getSuggestedPresentationDelay(), Mn = _.getServiceDescriptionSettings();
              return Nt = isNaN(O.get().streaming.delay.liveDelay) ? O.get().streaming.delay.liveDelayFragmentCount === null || isNaN(O.get().streaming.delay.liveDelayFragmentCount) || isNaN(Ln) ? Mn && !isNaN(Mn.liveDelay) && Mn.liveDelay > 0 ? Mn.liveDelay : O.get().streaming.delay.useSuggestedPresentationDelay === !0 && $n !== null && !isNaN($n) && $n > 0 ? $n : isNaN(Ln) ? tt && !isNaN(tt.minBufferTime) ? 4 * tt.minBufferTime : 4 * M.manifestInfo.minBufferTime : 4 * Ln : Ln * O.get().streaming.delay.liveDelayFragmentCount : O.get().streaming.delay.liveDelay, (_n = I.getAvailabilityStartTime()) !== null && (he = _n), xt = tt && tt.dvrWindowSize > 0 ? Math.min(Nt, tt.dvrWindowSize) : Nt, Y = xt, V = xt, xt;
            }, getLiveDelay: function() {
              return Y;
            }, getOriginalLiveDelay: function() {
              return V;
            }, getCurrentLiveLatency: function() {
              if (!H || isNaN(he)) return NaN;
              var Ae = De();
              if (isNaN(Ae) || Ae === 0) return 0;
              var tt = (/* @__PURE__ */ new Date()).getTime() + 1e3 * N.getClientTimeOffset();
              return Math.max(((tt - he - 1e3 * Ae) / 1e3).toFixed(3), 0);
            }, play: ne, isPaused: ke, isStalled: ut, pause: U, isSeeking: Le, getStreamEndTime: de, seek: re, seekToOriginalLive: function() {
              var Ae = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], tt = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Nt = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = Te();
              if (xt !== 0) {
                var _n = xt - (Y = V);
                re(_n, Ae, tt, Nt);
              }
            }, seekToCurrentLive: function() {
              var Ae = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], tt = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], Nt = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], xt = Te();
              if (xt !== 0) {
                var _n = xt - Y;
                re(_n, Ae, tt, Nt);
              }
            }, reset: oe, updateCurrentTime: Bt, getAvailabilityStartTime: function() {
              return he;
            } }, r = (0, m.Z)(L).getInstance().getLogger(i), oe(), i;
          }
          c.__dashjs_factory_name = "PlaybackController";
          var f = v.Z.getSingletonFactory(c), S = R(3186), k = "loading", q = "executed", F = "failed";
          function te(i) {
            var r, u, _, w, I = (i = i || {}).eventBus, y = i.events, N = i.dashMetrics, Z = i.fragmentLoader, Y = i.debug, V = i.streamInfo, M = i.type;
            function H(g) {
              var x;
              return !!g && (x = !1, _.some(function(O) {
                if (L = g, A = O, !isNaN(L.index) && L.startTime === A.startTime && L.adaptationIndex === A.adaptationIndex && L.type === A.type || function(oe, X) {
                  return isNaN(oe.index) && isNaN(X.index) && oe.quality === X.quality;
                }(g, O) || function(oe, X) {
                  return oe.action === S.Z.ACTION_COMPLETE && oe.action === X.action;
                }(g, O)) return x = !0;
                var L, A;
              }), x);
            }
            function G(g) {
              return isNaN(g.duration) ? 0.25 : Math.min(g.duration / 8, 0.5);
            }
            function pe(g) {
              _ = _.filter(function(x) {
                var O = G(x);
                return isNaN(x.startTime) || g !== void 0 && x.startTime >= g - O;
              });
            }
            function ae(g, x) {
              x <= g + 0.5 || (_ = _.filter(function(O) {
                var L = G(O);
                return isNaN(O.startTime) || O.startTime >= x - L || isNaN(O.duration) || O.startTime + O.duration <= g + L;
              }));
            }
            function he(g, x, O) {
              for (var L = g.length - 1; L >= 0; L--) {
                var A = g[L], oe = A.startTime, X = oe + A.duration;
                if (O = isNaN(O) ? G(A) : O, !isNaN(oe) && !isNaN(X) && x + O >= oe && x - O < X || isNaN(oe) && isNaN(x)) return A;
              }
              return null;
            }
            function Ee(g, x) {
              N.addSchedulingInfo(g, x), N.addRequestsQueue(g.mediaType, w, _);
            }
            function j(g) {
              g.sender === Z && (w.splice(w.indexOf(g.request), 1), g.response && !g.error && _.push(g.request), Ee(g.request, g.error ? F : q), I.trigger(y.FRAGMENT_LOADING_COMPLETED, { request: g.request, response: g.response, error: g.error, sender: this }, { streamId: V.id, mediaType: M }));
            }
            function ue(g) {
              g.sender === Z && I.trigger(y.FRAGMENT_LOADING_PROGRESS, { request: g.request, response: g.response, error: g.error, sender: this }, { streamId: V.id, mediaType: M });
            }
            function z(g) {
              g.sender === Z && I.trigger(y.FRAGMENT_LOADING_ABANDONED, { request: g.request }, { streamId: V.id, mediaType: M });
            }
            function me() {
              _ = [], w = [];
            }
            return r = { getStreamId: function() {
              return V.id;
            }, getType: function() {
              return M;
            }, getRequests: function(g) {
              var x = g ? g.state instanceof Array ? g.state : [g.state] : [], O = [];
              return x.forEach(function(L) {
                var A = function(oe) {
                  var X;
                  switch (oe) {
                    case k:
                      X = w;
                      break;
                    case q:
                      X = _;
                      break;
                    default:
                      X = [];
                  }
                  return X;
                }(L);
                O = O.concat(function(oe, X) {
                  return X.hasOwnProperty("time") ? [he(oe, X.time, X.threshold)] : oe.filter(function(de) {
                    for (var ne in X) if (ne !== "state" && X.hasOwnProperty(ne) && de[ne] != X[ne]) return !1;
                    return !0;
                  });
                }(A, g));
              }), O;
            }, isFragmentLoaded: H, isFragmentLoadedOrPending: function(g) {
              var x, O = !1, L = 0;
              if (!(O = H(g))) for (L = 0; L < w.length; L++) x = w[L], g.url === x.url && g.startTime === x.startTime && (O = !0);
              return O;
            }, removeExecutedRequestsBeforeTime: pe, removeExecutedRequestsAfterTime: function(g) {
              _ = _.filter(function(x) {
                return isNaN(x.startTime) || g !== void 0 && x.startTime < g;
              });
            }, syncExecutedRequestsWithBufferedRange: function(g, x) {
              if (g && g.length !== 0) {
                for (var O = 0, L = 0, A = g.length; L < A; L++) ae(O, g.start(L)), O = g.end(L);
                x > 0 && ae(O, x);
              } else pe();
            }, abortRequests: function() {
              u.debug("abort requests"), Z.abort(), w = [];
            }, executeRequest: function(g) {
              g.action === S.Z.ACTION_DOWNLOAD ? (Ee(g, k), w.push(g), function(x) {
                I.trigger(y.FRAGMENT_LOADING_STARTED, { request: x }, { streamId: V.id, mediaType: M }), Z.load(x);
              }(g)) : u.warn("Unknown request action.");
            }, reset: function() {
              I.off(y.LOADING_COMPLETED, j, this), I.off(y.LOADING_DATA_PROGRESS, ue, this), I.off(y.LOADING_ABANDONED, z, this), Z && Z.reset(), me();
            }, resetInitialSettings: me, addExecutedRequest: function(g) {
              _.push(g);
            } }, u = Y.getLogger(r), me(), I.on(y.LOADING_COMPLETED, j, r), I.on(y.LOADING_DATA_PROGRESS, ue, r), I.on(y.LOADING_ABANDONED, z, r), r;
          }
          te.__dashjs_factory_name = "FragmentModel";
          var P = v.Z.getClassFactory(te);
          P.FRAGMENT_MODEL_LOADING = k, P.FRAGMENT_MODEL_EXECUTED = q, P.FRAGMENT_MODEL_CANCELED = "canceled", P.FRAGMENT_MODEL_FAILED = F, v.Z.updateClassFactory(te.__dashjs_factory_name, P);
          var Q = P, se = R(5459);
          function K(i) {
            return K = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, K(i);
          }
          function ie(i, r) {
            return ie = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, ie(i, r);
          }
          function ge(i, r) {
            return !r || K(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Ne(i) {
            return Ne = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Ne(i);
          }
          var ee = new (function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && ie(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Ne(r);
              if (u) {
                var N = Ne(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return ge(this, I);
            });
            function w() {
              var I;
              return function(y, N) {
                if (!(y instanceof N)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (I = _.call(this)).MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE = 10, I.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE = 11, I.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE = 12, I.SEGMENT_BASE_LOADER_ERROR_CODE = 15, I.TIME_SYNC_FAILED_ERROR_CODE = 16, I.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE = 17, I.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE = 18, I.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 19, I.APPEND_ERROR_CODE = 20, I.REMOVE_ERROR_CODE = 21, I.DATA_UPDATE_FAILED_ERROR_CODE = 22, I.CAPABILITY_MEDIASOURCE_ERROR_CODE = 23, I.CAPABILITY_MEDIAKEYS_ERROR_CODE = 24, I.DOWNLOAD_ERROR_ID_MANIFEST_CODE = 25, I.DOWNLOAD_ERROR_ID_SIDX_CODE = 26, I.DOWNLOAD_ERROR_ID_CONTENT_CODE = 27, I.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE = 28, I.DOWNLOAD_ERROR_ID_XLINK_CODE = 29, I.MANIFEST_ERROR_ID_PARSE_CODE = 31, I.MANIFEST_ERROR_ID_NOSTREAMS_CODE = 32, I.TIMED_TEXT_ERROR_ID_PARSE_CODE = 33, I.MANIFEST_ERROR_ID_MULTIPLEXED_CODE = 34, I.MEDIASOURCE_TYPE_UNSUPPORTED_CODE = 35, I.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE = "parsing failed for ", I.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading manifest: ", I.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE = "Failed loading Xlink element: ", I.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE = "Segments update failed", I.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE = "no segments are available yet", I.SEGMENT_BASE_LOADER_ERROR_MESSAGE = "error loading segment ranges from sidx", I.TIME_SYNC_FAILED_ERROR_MESSAGE = "Failed to synchronize client and server time", I.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE = "request is null", I.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = "Failed to resolve a valid URL", I.APPEND_ERROR_MESSAGE = "chunk is not defined", I.REMOVE_ERROR_MESSAGE = "Removing data from the SourceBuffer", I.DATA_UPDATE_FAILED_ERROR_MESSAGE = "Data update failed", I.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE = "mediasource is not supported", I.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE = "mediakeys is not supported", I.TIMED_TEXT_ERROR_MESSAGE_PARSE = "parsing error :", I.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE = "Error creating source buffer of type : ", I;
            }
            return w;
          }(R(2230).Z))(), Oe = R(1264), Ge = R(7855);
          function Xe(i) {
            var r, u, _, w, I, y, N = this.context, Z = (0, Oe.Z)(N).getInstance(), Y = i.textController, V = i.eventBus, M = [], H = [], G = !1, pe = i.mediaSource, ae = null;
            function he(A) {
              return new Promise(function(oe) {
                L(function() {
                  w.changeType && w.changeType(A), oe();
                });
              });
            }
            function Ee(A) {
              return w = Y.getTextSourceBuffer(A), Promise.resolve();
            }
            function j() {
              if (typeof w.addEventListener == "function") try {
                w.addEventListener("updateend", x, !1), w.addEventListener("error", O, !1), w.addEventListener("abort", O, !1);
              } catch {
                y = setInterval(x, 50);
              }
              else y = setInterval(x, 50);
            }
            function ue(A) {
              return new Promise(function(oe) {
                w && Z.get().streaming.buffer.useAppendWindow ? L(function() {
                  try {
                    if (!w) return void oe();
                    var X = pe.duration, de = 0;
                    A && !isNaN(A.start) && !isNaN(A.duration) && isFinite(A.duration) && (X = A.start + A.duration), A && !isNaN(A.start) && (de = A.start), w.appendWindowEnd === X && w.appendWindowStart === de || (w.appendWindowStart = 0, w.appendWindowEnd = X + 0.01, w.appendWindowStart = Math.max(de - 0.1, 0), _.debug("Updated append window for ".concat(I.type, ". Set start to ").concat(w.appendWindowStart, " and end to ").concat(w.appendWindowEnd))), oe();
                  } catch {
                    _.warn("Failed to set append window"), oe();
                  }
                }) : oe();
              });
            }
            function z(A) {
              return new Promise(function(oe) {
                w ? L(function() {
                  try {
                    w.timestampOffset === A || isNaN(A) || (w.timestampOffset = A, _.debug("Set MSE timestamp offset to ".concat(A))), oe();
                  } catch {
                    oe();
                  }
                }) : oe();
              });
            }
            function me() {
              if (!G && H.length > 0) {
                G = !0;
                var A = H[0];
                H.splice(0, 1);
                var oe = function() {
                  G = !1, H.length > 0 && me.call(this), A && A.data && A.data.segmentType && A.data.segmentType !== Ge.w.INIT_SEGMENT_TYPE && delete A.data.bytes, A.promise.resolve({ chunk: A.data });
                };
                try {
                  ae = A.request, A.data.bytes.byteLength === 0 ? oe.call(this) : (w.appendBuffer ? w.appendBuffer(A.data.bytes) : w.append(A.data.bytes, A.data), L(oe.bind(this)));
                } catch (X) {
                  _.fatal('SourceBuffer append failed "' + X + '"'), H.length > 0 ? me() : G = !1, delete A.data.bytes, A.promise.reject({ chunk: A.data, error: new se.Z(X.code, X.message) });
                }
              }
            }
            function g() {
              M.length > 0 && (w.updating || (M.shift()(), g()));
            }
            function x() {
              w.updating || g();
            }
            function O(A) {
              var oe, X, de = A.target || {};
              oe = o.Z.SOURCE_BUFFER_ERROR, X = { error: de, lastRequestAppended: ae }, V.trigger(oe, X, { streamId: I.streamInfo.id, mediaType: u });
            }
            function L(A) {
              M.push(A), w.updating || g();
            }
            return r = { getType: function() {
              return u;
            }, getAllBufferRanges: function() {
              try {
                return w.buffered;
              } catch (A) {
                return _.error("getAllBufferRanges exception: " + A.message), null;
              }
            }, getBuffer: function() {
              return w;
            }, append: function(A) {
              var oe = this, X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return new Promise(function(de, ne) {
                A ? (H.push({ data: A, promise: { resolve: de, reject: ne }, request: X }), L(me.bind(oe))) : ne({ chunk: A, error: new se.Z(ee.APPEND_ERROR_CODE, ee.APPEND_ERROR_MESSAGE) });
              });
            }, remove: function(A) {
              return new Promise(function(oe, X) {
                var de = A.start, ne = A.end;
                de >= 0 && ne > de ? L(function() {
                  try {
                    w.remove(de, ne), L(function() {
                      oe({ from: de, to: ne, unintended: !1 }), A.resolve && A.resolve();
                    });
                  } catch (U) {
                    X({ from: de, to: ne, unintended: !1, error: new se.Z(ee.REMOVE_ERROR_CODE, ee.REMOVE_ERROR_MESSAGE) }), A.reject && A.reject(U);
                  }
                }) : oe();
              });
            }, abort: function() {
              return new Promise(function(A) {
                try {
                  H = [], pe.readyState === "open" ? L(function() {
                    try {
                      w && w.abort(), A();
                    } catch {
                      A();
                    }
                  }) : (w && w.setTextTrack && pe.readyState === "ended" && w.abort(), A());
                } catch {
                  A();
                }
              });
            }, reset: function() {
              if (w) {
                try {
                  M = [], function() {
                    try {
                      typeof w.removeEventListener == "function" && (w.removeEventListener("updateend", x, !1), w.removeEventListener("error", O, !1), w.removeEventListener("abort", O, !1)), clearInterval(y);
                    } catch (A) {
                      _.error(A);
                    }
                  }(), G = !1, H = [], w.getClassName && w.getClassName() === "TextSourceBuffer" || (_.debug("Removing sourcebuffer from media source"), pe.removeSourceBuffer(w));
                } catch {
                }
                w = null;
              }
              ae = null;
            }, updateTimestampOffset: z, initializeForStreamSwitch: function(A, oe, X) {
              u = (I = A).type;
              var de = I.codec;
              (function(U) {
                w = U.getBuffer();
              })(X), j();
              var ne = [];
              return ne.push(new Promise(function(U) {
                L(function() {
                  var re = w.appendWindowStart, Te = w.appendWindowEnd;
                  w && (w.abort(), w.appendWindowStart = re, w.appendWindowEnd = Te), U();
                });
              })), ne.push(ue(I.streamInfo)), Z.get().streaming.buffer.useChangeTypeForTrackSwitch && ne.push(he(de)), oe && oe.MSETimeOffset !== void 0 && ne.push(z(oe.MSETimeOffset)), Promise.all(ne);
            }, initializeForFirstUse: function(A, oe, X) {
              u = (I = oe).type;
              var de = I.codec;
              try {
                if (de.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i)) return Ee(A);
                w = pe.addSourceBuffer(de), j();
                var ne = [];
                return ne.push(ue(I.streamInfo)), X && X.MSETimeOffset !== void 0 && ne.push(z(X.MSETimeOffset)), Promise.all(ne);
              } catch (U) {
                return I.type == t.Z.TEXT && !I.isFragmented || de.indexOf('codecs="stpp') !== -1 || de.indexOf('codecs="vtt') !== -1 || de.indexOf("text/vtt") !== -1 ? Ee(A) : Promise.reject(U);
              }
            }, updateAppendWindow: ue, changeType: he }, _ = (0, m.Z)(N).getInstance().getLogger(r), r;
          }
          Xe.__dashjs_factory_name = "SourceBufferSink";
          var Ce = v.Z.getClassFactory(Xe);
          function Ue(i) {
            var r, u, _, w = this.context, I = [], y = i;
            function N(Z, Y) {
              return I = I.filter(function(V) {
                return !((isNaN(Y) || V.start < Y) && (isNaN(Z) || V.end > Z));
              }), Promise.resolve();
            }
            return r = { getAllBufferRanges: function() {
              for (var Z = [], Y = 0; Y < I.length; Y++) {
                var V = I[Y];
                Z.length === 0 || V.start > Z[Z.length - 1].end ? Z.push({ start: V.start, end: V.end }) : Z[Z.length - 1].end = V.end;
              }
              var M = { start: function(H) {
                return Z[H].start;
              }, end: function(H) {
                return Z[H].end;
              } };
              return Object.defineProperty(M, "length", { get: function() {
                return Z.length;
              } }), M;
            }, append: function(Z) {
              return Z.segmentType !== "InitializationSegment" ? (I.push(Z), I.sort(function(Y, V) {
                return Y.start - V.start;
              }), _ = null) : _ = Z, u.debug("PreBufferSink appended chunk s: " + Z.start + "; e: " + Z.end), y && y({ chunk: Z }), Promise.resolve();
            }, remove: N, abort: function() {
              return Promise.resolve();
            }, discharge: function(Z, Y) {
              var V = function(M, H) {
                return I.filter(function(G) {
                  return (isNaN(H) || G.start < H) && (isNaN(M) || G.end > M);
                });
              }(Z, Y);
              return _ && (V.push(_), _ = null), N(Z, Y), V;
            }, reset: function() {
              I = [], _ = null, y = null;
            }, updateTimestampOffset: function() {
              return Promise.resolve();
            }, waitForUpdateEnd: function(Z) {
              Z();
            }, getBuffer: function() {
              return this;
            } }, u = (0, m.Z)(w).getInstance().getLogger(r), r;
          }
          Ue.__dashjs_factory_name = "PreBufferSink";
          var Je = v.Z.getClassFactory(Ue);
          function st() {
            var i = {};
            return { save: function(r) {
              var u = r.streamId, _ = r.representationId;
              i[u] = i[u] || {}, i[u][_] = r;
            }, extract: function(r, u) {
              return i && i[r] && i[r][u] ? i[r][u] : null;
            }, reset: function() {
              i = {};
            } };
          }
          st.__dashjs_factory_name = "InitCache";
          var we = v.Z.getSingletonFactory(st), Be = 0.01, At = "BufferController";
          function ht(i) {
            i = i || {};
            var r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j, ue, z, me, g = this.context, x = (0, p.Z)(g).getInstance(), O = i.errHandler, L = i.fragmentModel, A = i.representationController, oe = i.adapter, X = i.textController, de = i.abrController, ne = i.playbackController, U = i.streamInfo, re = i.type, Te = i.settings;
            function Fe(Pe) {
              var ft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return new Promise(function(ye, Ae) {
                y = Pe, Y && ft && typeof Y.discharge == "function" ? (V = Y, ke(ft).then(function() {
                  ye();
                }).catch(function(tt) {
                  Ae(tt);
                })) : ye();
              });
            }
            function De(Pe) {
              return oe.convertRepresentationToRepresentationInfo(A.getRepresentationForQuality(Pe));
            }
            function ke(Pe) {
              var ft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
              return new Promise(function(ye, Ae) {
                j && Pe ? y ? (M = !1, ut(Pe, ft).then(function(tt) {
                  ye(tt);
                }).catch(function(tt) {
                  Ae(tt);
                })) : (M = !0, Le().then(function(tt) {
                  ye(tt);
                }).catch(function(tt) {
                  Ae(tt);
                })) : ye(null);
              });
            }
            function Le() {
              var Pe = this;
              return new Promise(function(ft, ye) {
                var Ae = de.getQualityFor(re, U.id);
                Y = Je(g).create(Re.bind(Pe)), $t(De(Ae)).then(function() {
                  ft(Y);
                }).catch(function() {
                  ye();
                });
              });
            }
            function ut(Pe, ft) {
              return new Promise(function(ye, Ae) {
                var tt = de.getQualityFor(re, U.id);
                Y = Ce(g).create({ mediaSource: y, textController: X, eventBus: x }), function(Nt, xt, _n) {
                  var Ln = De(_n);
                  return xt && xt[re] && (re === t.Z.VIDEO || re === t.Z.AUDIO) ? Y.initializeForStreamSwitch(Nt, Ln, xt[re]) : Y.initializeForFirstUse(U, Nt, Ln);
                }(Pe, ft, tt).then(function() {
                  return $t(De(tt));
                }).then(function() {
                  ye(Y);
                }).catch(function(Nt) {
                  u.fatal("Caught error on create SourceBuffer: " + Nt), O.error(new se.Z(ee.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, ee.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + re)), Ae(Nt);
                });
              });
            }
            function ct(Pe) {
              Te.get().streaming.cacheInitSegments && (u.info("Init fragment finished loading saving to", re + "'s init cache"), j.save(Pe.chunk)), u.debug("Append Init fragment", re, " with representationId:", Pe.chunk.representationId, " and quality:", Pe.chunk.quality, ", data size:", Pe.chunk.bytes.byteLength), at(Pe.chunk);
            }
            function rt(Pe) {
              at(Pe.chunk, Pe.request);
            }
            function at(Pe) {
              var ft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              Y && (Y.append(Pe, ft).then(function(ye) {
                Re(ye);
              }).catch(function(ye) {
                Re(ye);
              }), Pe.mediaInfo.type === t.Z.VIDEO && Xt(o.Z.VIDEO_CHUNK_RECEIVED, { chunk: Pe }));
            }
            function Bt(Pe) {
              if (Pe && Pe.length > 0) for (var ft = 0, ye = Pe.length; ft < ye; ft++) u.debug("Buffered range: " + Pe.start(ft) + " - " + Pe.end(ft) + ", currentTime = ", ne.getTime());
            }
            function Re(Pe) {
              if (Pe.error) return Pe.error.code === 22 && function() {
                if (Ee = !0, I = 0.8 * kt(), u.warn("Quota exceeded, Critical Buffer: " + I), I > 0) {
                  var Ae = Math.max(0.2 * I, 1), tt = I - Ae, Nt = Math.min(Te.get().streaming.buffer.bufferTimeAtTopQuality, 0.9 * tt), xt = Math.min(Te.get().streaming.buffer.bufferTimeAtTopQualityLongForm, 0.9 * tt), _n = { streaming: { buffer: { bufferToKeep: parseFloat(Ae.toFixed(5)), bufferTimeAtTopQuality: parseFloat(Nt.toFixed(5)), bufferTimeAtTopQualityLongForm: parseFloat(xt.toFixed(5)) } } };
                  Te.update(_n);
                }
              }(), void (Pe.error.code !== 22 && Vt() || (u.warn("Clearing playback buffer to overcome quota exceed situation"), Xt(o.Z.QUOTA_EXCEEDED, { criticalBufferLevel: I, quotaExceededTime: Pe.chunk.start }), lt(Et())));
              if (Y && (Wt(), Ee = !1, (pe = Pe.chunk) && pe.endFragment)) {
                pe && !isNaN(pe.index) && (N = Math.max(pe.index, N), zt());
                var ft = Y.getAllBufferRanges();
                pe.segmentType === Ge.w.MEDIA_SEGMENT_TYPE && (Bt(ft), Qe(), function() {
                  if (!isNaN(me) && !M) if (re === t.Z.AUDIO || re === t.Z.VIDEO) {
                    var Ae = ne.getTime(), tt = mt(Ae, 0), Nt = mt(me, 0);
                    if (tt && Nt && tt.start === Nt.start) me = NaN;
                    else {
                      var xt = A.getCurrentRepresentation().segmentDuration, _n = mt(me, xt);
                      _n && (Te.get().streaming.buffer.enableSeekDecorrelationFix && Math.abs(Ae - me) > xt ? me <= _n.end && ne.seek(Math.max(me, _n.start), !1, !0) : Ae < _n.start && ne.seek(_n.start, !1, !0));
                    }
                  } else me = NaN;
                }());
                var ye = !1;
                H && (H.indexOf(pe) > 0 && (ye = !0), H = null), pe && !ye && Xt(o.Z.BYTES_APPENDED_END_FRAGMENT, { quality: pe.quality, startTime: pe.start, index: pe.index, bufferedRanges: ft, segmentType: pe.segmentType, mediaType: re });
              }
            }
            function He() {
              return new Promise(function(Pe, ft) {
                var ye = yt();
                if (!ye || ye.length === 0) return Qe(), void Pe();
                lt(ye).then(function() {
                  Pe();
                }).catch(function(Ae) {
                  ft(Ae);
                });
              });
            }
            function yt(Pe) {
              var ft = [], ye = Y.getAllBufferRanges();
              if (!ye || ye.length === 0) return ft;
              if (!Pe && Pe !== 0 || isNaN(Pe)) ft.push({ start: ye.start(0), end: ye.end(ye.length - 1) + 0.5 });
              else {
                var Ae = function(Nt, xt) {
                  var _n = Te.get().streaming.buffer.bufferToKeep, Ln = xt.start(0);
                  if (Nt - Ln > _n) {
                    var $n = Math.max(0, Nt - _n), Mn = L.getRequests({ state: Q.FRAGMENT_MODEL_EXECUTED, time: Nt, threshold: Be })[0];
                    if (Mn && ($n = Math.min(Mn.startTime, $n)), $n > 0) return { start: Ln, end: $n };
                  }
                  return null;
                }(Pe, ye), tt = function(Nt, xt) {
                  var _n = xt.end(xt.length - 1) + 0.5, Ln = qt(Nt), $n = U.manifestInfo.duration >= Te.get().streaming.buffer.longFormContentDurationThreshold ? Te.get().streaming.buffer.bufferTimeAtTopQualityLongForm : Te.get().streaming.buffer.bufferTimeAtTopQuality, Mn = isNaN(Ln) ? Nt : Math.min(Ln, Nt + $n);
                  if (Mn >= xt.end(xt.length - 1)) return null;
                  var yr = L.getRequests({ state: Q.FRAGMENT_MODEL_EXECUTED, time: Nt, threshold: Be })[0];
                  if (yr && (Mn = Math.max(yr.startTime + yr.duration, Mn)), Te.get().streaming.buffer.avoidCurrentTimeRangePruning) {
                    for (var nr = 0; nr < xt.length; nr++) if (xt.start(nr) <= Nt && Nt <= xt.end(nr) && xt.start(nr) <= Mn && Mn <= xt.end(nr)) {
                      var Yr = Mn;
                      Mn = nr + 1 < xt.length ? xt.start(nr + 1) : xt.end(nr) + 1, u.debug("Buffered range [" + xt.start(nr) + ", " + xt.end(nr) + "] overlaps with targetTime " + Nt + " and range to be pruned [" + Yr + ", " + _n + "], using [" + Mn + ", " + _n + "] instead" + (Mn < _n ? "" : " (no actual pruning)"));
                      break;
                    }
                  }
                  return Mn < xt.end(xt.length - 1) ? { start: Mn, end: _n } : null;
                }(Pe, ye);
                Ae && ft.push(Ae), tt && ft.push(tt);
              }
              return ft;
            }
            function Qe() {
              (!z || re === t.Z.TEXT && X.isTextEnabled()) && Wt();
            }
            function Tt() {
              hn();
            }
            function vt() {
              hn(), me = NaN;
            }
            function mt(Pe, ft) {
              if (!Y) return null;
              var ye, Ae, tt = Y.getAllBufferRanges(), Nt = 0, xt = 0, _n = null, Ln = null, $n = 0, Mn = isNaN(ft) ? 0.15 : ft;
              if (tt != null) {
                for (Ae = 0, ye = tt.length; Ae < ye; Ae++) if (Nt = tt.start(Ae), xt = tt.end(Ae), _n === null) $n = Math.abs(Nt - Pe), (Pe >= Nt && Pe < xt || $n <= Mn) && (_n = Nt, Ln = xt);
                else {
                  if (!(($n = Nt - Ln) <= Mn)) break;
                  Ln = xt;
                }
                if (_n !== null) return { start: _n, end: Ln };
              }
              return null;
            }
            function Wt() {
              if (ne) {
                var Pe = ne.getTime() || 0;
                M && (Pe = isNaN(me) ? 0 : me);
                var ft = Te.get().streaming.gaps.jumpGaps && !isNaN(Te.get().streaming.gaps.smallGapLimit) ? Te.get().streaming.gaps.smallGapLimit : NaN;
                w = Math.max(function(ye, Ae) {
                  var tt;
                  return Te.get().streaming.gaps.jumpGaps && (Ae = Te.get().streaming.gaps.smallGapLimit), (tt = mt(ye, Ae)) === null ? 0 : tt.end - ye;
                }(Pe, ft), 0), Xt(o.Z.BUFFER_LEVEL_UPDATED, { mediaType: re, bufferLevel: w }), hn();
              }
            }
            function zt() {
              var Pe = N >= Z - 1, ft = ne.getTimeToStreamEnd(U) - w < 1e-5;
              !Pe && !ft || _ || (pt(!0), u.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(U.id, " and type ").concat(re)));
            }
            function hn() {
              re !== t.Z.AUDIO && re !== t.Z.VIDEO || ((!ne.getLowLatencyModeEnabled() && w < Te.get().streaming.buffer.stallThreshold || w === 0) && !_ ? yn(h.Z.BUFFER_EMPTY) : (_ || w >= Te.get().streaming.buffer.stallThreshold || ne.getLowLatencyModeEnabled() && w > 0) && yn(h.Z.BUFFER_LOADED));
            }
            function yn(Pe) {
              G === Pe || Pe === h.Z.BUFFER_EMPTY && ne.getTime() === 0 || re === t.Z.TEXT && !X.isTextEnabled() || (G = Pe, Xt(o.Z.BUFFER_LEVEL_STATE_CHANGED, { state: Pe }), Xt(Pe === h.Z.BUFFER_LOADED ? o.Z.BUFFER_LOADED : o.Z.BUFFER_EMPTY), u.debug(Pe === h.Z.BUFFER_LOADED ? "Got enough buffer to start" : "Waiting for more buffer before starting playback"));
            }
            function ze() {
              Y && re !== t.Z.TEXT && (_ || lt(Et()));
            }
            function Et() {
              var Pe = [], ft = Y.getAllBufferRanges();
              if (!ft || ft.length === 0) return Pe;
              var ye = ne.getTime(), Ae = Math.max(0, ye - Te.get().streaming.buffer.bufferToKeep), tt = L.getRequests({ state: Q.FRAGMENT_MODEL_EXECUTED, time: ye, threshold: Be })[0];
              if (tt) Ae = Math.min(tt.startTime, Ae);
              else if (ye === 0 && ne.getIsDynamic()) return [];
              if (ft.start(0) <= Ae) {
                for (var Nt = { start: 0, end: Ae }, xt = 0; xt < ft.length && ft.end(xt) <= Ae; xt++) Nt.end = ft.end(xt);
                Nt.start < Nt.end && Pe.push(Nt);
              }
              return Pe;
            }
            function lt(Pe) {
              return new Promise(function(ft, ye) {
                if (Pe && Y && Pe.length !== 0) {
                  var Ae = [];
                  Pe.forEach(function(tt) {
                    Ae.push(function(Nt) {
                      return new Promise(function(xt, _n) {
                        Nt.resolve = xt, Nt.reject = _n, ue.push(Nt);
                      });
                    }(tt));
                  }), he || wt(), Promise.all(Ae).then(function() {
                    ft();
                  }).catch(function(tt) {
                    ye(tt);
                  });
                } else ft();
              });
            }
            function wt() {
              try {
                if (ue.length === 0 || !Y) return u.debug("Nothing to prune, halt pruning"), ue = [], void (he = !1);
                var Pe = Y.getBuffer();
                if (!Pe || !Pe.buffered || Pe.buffered.length === 0) return u.debug("SourceBuffer is empty (or does not exist), halt pruning"), ue = [], void (he = !1);
                var ft = ue.shift();
                u.debug("".concat(re, ": Removing buffer from: ").concat(ft.start, " to ").concat(ft.end)), he = !0, ne.getTime() < ft.end && pt(!1), Y.remove(ft).then(function(ye) {
                  Pt(ye);
                }).catch(function(ye) {
                  Pt(ye);
                });
              } catch {
                he = !1;
              }
            }
            function Pt(Pe) {
              u.debug("onRemoved buffer from:", Pe.from, "to", Pe.to), Y && (Bt(Y.getAllBufferRanges()), ue.length === 0 && (he = !1, Wt()), Pe.unintended && (u.warn("Detected unintended removal from:", Pe.from, "to", Pe.to, "setting streamprocessor time to", Pe.from), Xt(o.Z.SEEK_TARGET, { time: Pe.from })), he ? wt() : (z ? z = !1 : Wt(), Xt(o.Z.BUFFER_CLEARED, { from: Pe.from, to: Pe.to, unintended: Pe.unintended, hasEnoughSpaceToAppend: Vt(), quotaExceeded: Ee })));
            }
            function $t(Pe) {
              return new Promise(function(ft) {
                Pe && Pe.MSETimeOffset !== void 0 && Y && Y.updateTimestampOffset ? Y.updateTimestampOffset(Pe.MSETimeOffset).then(function() {
                  ft();
                }).catch(function() {
                  ft();
                }) : ft();
              });
            }
            function Qt() {
              return Y && !_ ? Y.updateAppendWindow(U) : Promise.resolve();
            }
            function en() {
              ++ae * (Te.get().streaming.wallclockTimeUpdateInterval / 1e3) >= Te.get().streaming.buffer.bufferPruningInterval && (ae = 0, ze());
            }
            function ln() {
              hn();
            }
            function pt(Pe) {
              (_ = Pe) ? Xt(o.Z.BUFFERING_COMPLETED) : Z = Number.POSITIVE_INFINITY;
            }
            function kt() {
              try {
                var Pe, ft, ye = Y.getAllBufferRanges(), Ae = 0;
                if (!ye) return Ae;
                for (ft = 0, Pe = ye.length; ft < Pe; ft++) Ae += ye.end(ft) - ye.start(ft);
                return Ae;
              } catch {
                return 0;
              }
            }
            function qt(Pe) {
              try {
                var ft = Pe, ye = Y.getAllBufferRanges();
                if (!ye || ye.length === 0) return NaN;
                for (var Ae = 0; ft === Pe && Ae < ye.length; ) {
                  var tt = ye.start(Ae), Nt = ye.end(Ae);
                  ft >= tt && ft <= Nt && (ft = Nt), Ae += 1;
                }
                return ft === Pe ? NaN : ft;
              } catch {
              }
            }
            function Vt() {
              var Pe = kt();
              return isNaN(Pe) || Pe < I;
            }
            function Xt(Pe, ft) {
              var ye = ft || {};
              x.trigger(Pe, ye, { streamId: U.id, mediaType: re });
            }
            function We(Pe, ft) {
              if (I = Number.POSITIVE_INFINITY, G = void 0, Z = Number.POSITIVE_INFINITY, N = 0, pe = null, _ = !1, he = !1, Ee = !1, w = 0, ae = 0, ue = [], me = NaN, M = !1, Y) {
                var ye = Y;
                Y = null, Pe || ft || ye.abort().then(function() {
                  ye.reset(ft), ye = null;
                });
              }
              z = !1;
            }
            return r = { initialize: function(Pe) {
              Fe(Pe), x.on(o.Z.INIT_FRAGMENT_LOADED, ct, r), x.on(o.Z.MEDIA_FRAGMENT_LOADED, rt, r), x.on(o.Z.WALLCLOCK_TIME_UPDATED, en, r), x.on(n.Z.PLAYBACK_PLAYING, vt, r), x.on(n.Z.PLAYBACK_PROGRESS, Qe, r), x.on(n.Z.PLAYBACK_TIME_UPDATED, Qe, r), x.on(n.Z.PLAYBACK_RATE_CHANGED, ln, r), x.on(n.Z.PLAYBACK_STALLED, Tt, r);
            }, getStreamId: function() {
              return U.id;
            }, getType: function() {
              return re;
            }, getBufferControllerType: function() {
              return At;
            }, createBufferSink: ke, dischargePreBuffer: function() {
              if (Y && V && typeof V.discharge == "function") {
                var Pe = V.getAllBufferRanges();
                if (Pe.length > 0) {
                  for (var ft = "Beginning " + re + "PreBuffer discharge, adding buffer for:", ye = 0; ye < Pe.length; ye++) ft += " start: " + Pe.start(ye) + ", end: " + Pe.end(ye) + ";";
                  u.debug(ft);
                } else u.debug("PreBuffer discharge requested, but there were no media segments in the PreBuffer.");
                H = [];
                for (var Ae = V.discharge(), tt = null, Nt = 0; Nt < Ae.length; Nt++) {
                  var xt = Ae[Nt];
                  if (xt.segmentType !== Ge.w.INIT_SEGMENT_TYPE) {
                    var _n = j.extract(xt.streamId, xt.representationId);
                    _n && tt !== _n && (H.push(_n), Y.append(_n), tt = _n);
                  }
                  H.push(xt), Y.append(xt);
                }
                V.reset(), V = null;
              }
            }, getBuffer: function() {
              return Y;
            }, getBufferLevel: function() {
              return w;
            }, getRangeAt: mt, hasBufferAtTime: function(Pe) {
              try {
                var ft = Y.getAllBufferRanges();
                if (!ft || ft.length === 0) return !1;
                for (var ye = 0; ye < ft.length; ) {
                  var Ae = ft.start(ye), tt = ft.end(ye);
                  if (Pe >= Ae && Pe <= tt) return !0;
                  ye += 1;
                }
                return !1;
              } catch (Nt) {
                return u.error(Nt), !1;
              }
            }, pruneBuffer: ze, setMediaSource: Fe, getMediaSource: function() {
              return y;
            }, appendInitSegmentFromCache: function(Pe) {
              var ft = j.extract(U.id, Pe);
              return !!ft && (u.info("Append Init fragment", re, " with representationId:", ft.representationId, " and quality:", ft.quality, ", data size:", ft.bytes.byteLength), at(ft), !0);
            }, getIsBufferingCompleted: function() {
              return _;
            }, setIsBufferingCompleted: pt, getIsPruningInProgress: function() {
              return he;
            }, reset: function(Pe, ft) {
              x.off(o.Z.INIT_FRAGMENT_LOADED, ct, this), x.off(o.Z.MEDIA_FRAGMENT_LOADED, rt, this), x.off(o.Z.WALLCLOCK_TIME_UPDATED, en, this), x.off(n.Z.PLAYBACK_PLAYING, vt, this), x.off(n.Z.PLAYBACK_PROGRESS, Qe, this), x.off(n.Z.PLAYBACK_TIME_UPDATED, Qe, this), x.off(n.Z.PLAYBACK_RATE_CHANGED, ln, this), x.off(n.Z.PLAYBACK_STALLED, Tt, this), We(Pe, ft);
            }, prepareForPlaybackSeek: function() {
              return _ && pt(!1), Y.abort();
            }, prepareForReplacementTrackSwitch: function(Pe) {
              return new Promise(function(ft, ye) {
                Y.abort().then(function() {
                  return Qt();
                }).then(function() {
                  return Te.get().streaming.buffer.useChangeTypeForTrackSwitch ? Y.changeType(Pe) : Promise.resolve();
                }).then(function() {
                  return He();
                }).then(function() {
                  pt(!1), ft();
                }).catch(function(Ae) {
                  ye(Ae);
                });
              });
            }, prepareForNonReplacementTrackSwitch: function(Pe) {
              return new Promise(function(ft, ye) {
                Qt().then(function() {
                  return Te.get().streaming.buffer.useChangeTypeForTrackSwitch ? Y.changeType(Pe) : Promise.resolve();
                }).then(function() {
                  ft();
                }).catch(function(Ae) {
                  ye(Ae);
                });
              });
            }, prepareForForceReplacementQualitySwitch: function(Pe) {
              return new Promise(function(ft, ye) {
                Y.abort().then(function() {
                  return Qt();
                }).then(function() {
                  return He();
                }).then(function() {
                  return $t(Pe);
                }).then(function() {
                  pt(!1), ft();
                }).catch(function(Ae) {
                  ye(Ae);
                });
              });
            }, updateAppendWindow: Qt, getAllRangesWithSafetyFactor: yt, getContinuousBufferTimeForTargetTime: qt, clearBuffers: lt, pruneAllSafely: He, updateBufferTimestampOffset: $t, setSeekTarget: function(Pe) {
              me = Pe;
            }, segmentRequestingCompleted: function(Pe) {
              isNaN(Pe) || (Z = Pe, zt());
            } }, u = (0, m.Z)(g).getInstance().getLogger(r), j = we(g).getInstance(), We(), r;
          }
          ht.__dashjs_factory_name = At;
          var je = v.Z.getClassFactory(ht), it = "NotFragmentedTextBufferController";
          function ve(i) {
            i = i || {};
            var r, u, _, w, I, y, N = this.context, Z = (0, p.Z)(N).getInstance(), Y = i.textController, V = i.errHandler, M = i.streamInfo, H = i.type;
            function G(he) {
              w = he;
            }
            function pe(he) {
              var Ee, j;
              u !== he && (u = he) && (Ee = o.Z.BUFFERING_COMPLETED, j = {}, Z.trigger(Ee, j, { streamId: M.id, mediaType: H }));
            }
            function ae(he) {
              he.chunk.bytes && !u && (y.save(he.chunk), I.append(he.chunk), pe(!0));
            }
            return r = { initialize: function(he) {
              G(he);
            }, getStreamId: function() {
              return M.id;
            }, getType: function() {
              return H;
            }, getBufferControllerType: function() {
              return it;
            }, createBufferSink: function(he) {
              return new Promise(function(Ee, j) {
                try {
                  (I = Ce(N).create({ mediaSource: w, textController: Y, eventBus: Z })).initializeForFirstUse(M, he), _ || (I.getBuffer() && typeof I.getBuffer().initialize == "function" && I.getBuffer().initialize(), _ = !0), Ee(I);
                } catch (ue) {
                  V.error(new se.Z(ee.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, ee.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + H)), j(ue);
                }
              });
            }, dischargePreBuffer: function() {
            }, getBuffer: function() {
              return I;
            }, getBufferLevel: function() {
              return 0;
            }, getRangeAt: function() {
              return null;
            }, pruneBuffer: function() {
            }, hasBufferAtTime: function() {
              return !0;
            }, getAllRangesWithSafetyFactor: function() {
              return [];
            }, getContinuousBufferTimeForTargetTime: function() {
              return Number.POSITIVE_INFINITY;
            }, setMediaSource: G, getMediaSource: function() {
              return w;
            }, appendInitSegmentFromCache: function(he) {
              return y.extract(M.id, he) !== null;
            }, getIsBufferingCompleted: function() {
              return u;
            }, setIsBufferingCompleted: pe, getIsPruningInProgress: function() {
              return !1;
            }, reset: function(he) {
              Z.off(o.Z.INIT_FRAGMENT_LOADED, ae, r), !he && I && (I.abort(), I.reset(), I = null);
            }, clearBuffers: function() {
              return Promise.resolve();
            }, prepareForPlaybackSeek: function() {
              return Promise.resolve();
            }, prepareForReplacementTrackSwitch: function() {
              return u = !1, Promise.resolve();
            }, setSeekTarget: function() {
            }, updateAppendWindow: function() {
              return Promise.resolve();
            }, pruneAllSafely: function() {
              return Promise.resolve();
            }, updateBufferTimestampOffset: function() {
              return Promise.resolve();
            }, segmentRequestingCompleted: function() {
            } }, _ = !1, w = null, u = !1, y = we(N).getInstance(), Z.on(o.Z.INIT_FRAGMENT_LOADED, ae, r), r;
          }
          ve.__dashjs_factory_name = it;
          var Se = v.Z.getClassFactory(ve);
          function Ye(i) {
            i = i || {};
            var r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe = this.context, ae = (0, p.Z)(pe).getInstance(), he = i.dashMetrics, Ee = i.mediaPlayerModel, j = i.fragmentModel, ue = i.abrController, z = i.playbackController, me = i.textController, g = i.type, x = i.bufferController, O = i.representationController, L = i.settings;
            function A() {
              H = !0;
            }
            function oe() {
              H = !1;
            }
            function X(ut) {
              if (!x.getIsBufferingCompleted()) {
                de();
                var ct = isNaN(ut) ? 0 : ut;
                I = setTimeout(ne, ct);
              }
            }
            function de() {
              I && (clearTimeout(I), I = null);
            }
            function ne() {
              try {
                if (function() {
                  try {
                    return g === t.Z.TEXT && !me.isTextEnabled() || z.isPaused() && (!z.getStreamController().getInitialPlayback() || !z.getStreamController().getAutoPlay()) && !L.get().streaming.scheduling.scheduleWhilePaused;
                  } catch {
                    return !1;
                  }
                }()) return void de();
                if (function() {
                  try {
                    return !!H && O.getCurrentRepresentationInfo() && (isNaN(Y) || V || (rt = u.id, at = ue.getMaxAllowedIndexFor(g, rt), !(!isNaN(Z) && Z == at || (_.info("Top quality " + g + " index has changed from " + Z + " to " + at), Z = at, 0))) || function() {
                      var Bt = O.getCurrentRepresentationInfo();
                      return !g || !Bt || he.getCurrentBufferLevel(g) < U();
                    }());
                  } catch {
                    return !1;
                  }
                  var rt, at;
                }()) {
                  var ut = !1;
                  G && (ut = ue.checkPlaybackQuality(g, u.id)), ut || (ct = O.getCurrentRepresentationInfo(), M || ct.quality !== Y || V ? (V ? (_.debug("Switch track for " + g + ", representation id = " + ct.id), V = !1) : _.debug("Quality has changed, get init request for representationid = " + ct.id), ae.trigger(o.Z.INIT_FRAGMENT_NEEDED, { representationId: ct.id, sender: r }, { streamId: u.id, mediaType: g }), G = !1, M = !1) : (_.debug("Media segment needed for ".concat(g, " and stream id ").concat(u.id)), ae.trigger(o.Z.MEDIA_FRAGMENT_NEEDED, {}, { streamId: u.id, mediaType: g }), G = !0));
                } else X(z.getLowLatencyModeEnabled() ? L.get().streaming.scheduling.lowLatencyTimeout : L.get().streaming.scheduling.defaultTimeout);
              } catch {
                X(z.getLowLatencyModeEnabled() ? L.get().streaming.scheduling.lowLatencyTimeout : L.get().streaming.scheduling.defaultTimeout);
              }
              var ct;
            }
            function U() {
              var ut = NaN, ct = O.getCurrentRepresentationInfo();
              return g && ct && (ut = g === t.Z.TEXT ? function() {
                try {
                  if (me.isTextEnabled()) {
                    var rt = O.getCurrentRepresentationInfo();
                    if (isNaN(rt.fragmentDuration)) {
                      var at = he.getCurrentSchedulingInfo(h.Z.SCHEDULING_INFO);
                      return at ? at.duration : 0;
                    }
                    return rt.fragmentDuration;
                  }
                  return 0;
                } catch {
                  return 0;
                }
              }() : g === t.Z.AUDIO && y ? function() {
                try {
                  var rt = he.getCurrentBufferLevel(t.Z.VIDEO), at = O.getCurrentRepresentationInfo();
                  return isNaN(at.fragmentDuration) ? rt + 1 : Math.max(rt + 1, at.fragmentDuration);
                } catch {
                  return 0;
                }
              }() : function() {
                try {
                  var rt = O.getCurrentRepresentationInfo().mediaInfo.streamInfo;
                  return ue.isPlayingAtTopQuality(rt) ? rt.manifestInfo.duration >= L.get().streaming.buffer.longFormContentDurationThreshold ? L.get().streaming.buffer.bufferTimeAtTopQualityLongForm : L.get().streaming.buffer.bufferTimeAtTopQuality : Ee.getStableBufferTime();
                } catch {
                  return Ee.getStableBufferTime();
                }
              }()), ut;
            }
            function re() {
              Te(!0);
            }
            function Te(ut) {
              if (z && j) {
                var ct = j.getRequests({ state: Q.FRAGMENT_MODEL_EXECUTED, time: z.getTime(), threshold: 0 })[0];
                ct && z.getTime() >= ct.startTime && ((!N.mediaInfo || ct.mediaInfo.type === N.mediaInfo.type && ct.mediaInfo.index !== N.mediaInfo.index) && ut && ae.trigger(o.Z.TRACK_CHANGE_RENDERED, { mediaType: g, oldMediaInfo: N.mediaInfo, newMediaInfo: ct.mediaInfo, streamId: u.id }), ct.quality === N.quality && ct.adaptationIndex === N.adaptationIndex || !ut || (_.debug("Quality change rendered for streamId ".concat(u.id, " and type ").concat(g)), ae.trigger(o.Z.QUALITY_CHANGE_RENDERED, { mediaType: g, oldQuality: N.quality, newQuality: ct.quality, streamId: u.id })), N = { mediaInfo: ct.mediaInfo, quality: ct.quality, adaptationIndex: ct.adaptationIndex });
              }
            }
            function Fe() {
              j.abortRequests(), de();
            }
            function De() {
              L.get().streaming.scheduling.scheduleWhilePaused || X();
            }
            function ke(ut) {
              he.updatePlayListTraceMetrics({ playbackspeed: ut.playbackRate.toString() });
            }
            function Le() {
              G = !0, w = 0, Y = NaN, N = { mediaInfo: void 0, quality: NaN, adaptationIndex: NaN }, Z = NaN, V = !1, M = !1, H = !0;
            }
            return r = { initialize: function(ut) {
              y = ut, ae.on(o.Z.URL_RESOLUTION_FAILED, Fe, r), ae.on(n.Z.PLAYBACK_STARTED, De, r), ae.on(n.Z.PLAYBACK_RATE_CHANGED, ke, r), ae.on(n.Z.PLAYBACK_TIME_UPDATED, re, r), ae.on(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING, A, r), ae.on(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING, oe, r);
            }, getType: function() {
              return g;
            }, getStreamId: function() {
              return u.id;
            }, setTimeToLoadDelay: function(ut) {
              w = ut;
            }, getTimeToLoadDelay: function() {
              return w;
            }, setSwitchTrack: function(ut) {
              V = ut;
            }, getSwitchTrack: function() {
              return V;
            }, startScheduleTimer: X, clearScheduleTimer: de, reset: function() {
              ae.off(o.Z.URL_RESOLUTION_FAILED, Fe, r), ae.off(n.Z.PLAYBACK_STARTED, De, r), ae.off(n.Z.PLAYBACK_RATE_CHANGED, ke, r), ae.off(n.Z.PLAYBACK_TIME_UPDATED, re, r), ae.off(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING, A, r), ae.off(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING, oe, r), de(), Te(!1), Le(), u = null;
            }, getBufferTarget: U, getPlaybackController: function() {
              return z;
            }, setCheckPlaybackQuality: function(ut) {
              G = ut;
            }, setInitSegmentRequired: function(ut) {
              M = ut;
            }, setLastInitializedQuality: function(ut) {
              Y = ut;
            } }, _ = (0, m.Z)(pe).getInstance().getLogger(r), Le(), u = i.streamInfo, r;
          }
          Ye.__dashjs_factory_name = "ScheduleController";
          var d = v.Z.getClassFactory(Ye), l = R(7387);
          function T(i) {
            var r, u, _, w, I, y, N = (i = i || {}).eventBus, Z = i.events, Y = i.abrController, V = i.dashMetrics, M = i.playbackController, H = i.timelineConverter, G = i.type, pe = i.streamInfo, ae = i.dashConstants, he = i.segmentsController, Ee = i.isDynamic, j = i.adapter;
            function ue() {
              return G;
            }
            function z() {
              return _;
            }
            function me() {
              return y;
            }
            function g() {
              u = null, _ = !0, w = [], I = null;
            }
            function x(de) {
              return new Promise(function(ne, U) {
                var re = de.hasInitialization(), Te = de.hasSegments(), Fe = [];
                Fe.push(he.updateInitData(de, re)), Fe.push(he.updateSegmentData(de, Te)), Promise.all(Fe).then(function(De) {
                  var ke;
                  De[0] && !De[0].error && (de = function(Le, ut) {
                    return ut && !ut.error && ut.representation ? ut.representation : Le;
                  }(de, De[0])), De[1] && !De[1].error && (de = function(Le, ut) {
                    if (ut && !ut.error) {
                      var ct, rt, at, Bt, Re = ut.segments, He = [], yt = 0;
                      for (ct = 0, rt = Re ? Re.length : 0; ct < rt; ct++) at = Re[ct], (Bt = (0, l.TJ)(H, Ee, Le, at.startTime, at.duration, at.timescale, at.media, at.mediaRange, yt)) && (He.push(Bt), Bt = null, yt++);
                      return He.length > 0 && (Le.segments = He), Le;
                    }
                  }(de, De[1])), (ke = de).mediaFinishedInformation = he.getMediaFinishedInformation(ke), function(Le) {
                    if (z()) {
                      var ut, ct, rt = V.getCurrentManifestUpdate(), at = !1;
                      if (rt) {
                        for (var Bt = 0; Bt < rt.representationInfo.length; Bt++) if ((ut = rt.representationInfo[Bt]).index === Le.index && ut.mediaType === ue()) {
                          at = !0;
                          break;
                        }
                        at || V.addManifestUpdateRepresentationInfo(Le, ue());
                      }
                      if (function() {
                        for (var He = 0, yt = w.length; He < yt; He++) {
                          var Qe = w[He].segmentInfoType;
                          if (!w[He].hasInitialization() || (Qe === ae.SEGMENT_BASE || Qe === ae.BASE_URL) && !w[He].segments) return !1;
                        }
                        return !0;
                      }()) {
                        Y.setPlaybackQuality(G, pe, (ct = y, w.indexOf(ct)));
                        var Re = V.getCurrentDVRInfo(G);
                        Re && V.updateManifestUpdateInfo({ latency: Re.range.end - M.getTime() }), V.getCurrentRepresentationSwitch(me().adaptation.type) || O(), A();
                      }
                    }
                  }(de), ne();
                }).catch(function(De) {
                  U(De);
                });
              });
            }
            function O() {
              (function() {
                if (!(Y && V && M && H)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              })();
              var de = /* @__PURE__ */ new Date(), ne = me(), U = 1e3 * M.getTime();
              ne && V.addRepresentationSwitch(ne.adaptation.type, de, U, ne.id), N.trigger(n.Z.REPRESENTATION_SWITCH, { mediaType: G, streamId: pe.id, currentRepresentation: ne, numberOfRepresentations: w.length }, { streamId: pe.id, mediaType: G });
            }
            function L(de) {
              return de == null || de >= w.length ? null : w[de];
            }
            function A(de) {
              _ = !1, N.trigger(Z.DATA_UPDATE_COMPLETED, { data: u, currentRepresentation: y, error: de }, { streamId: pe.id, mediaType: G });
            }
            function oe(de) {
              y = de, I = j.convertRepresentationToRepresentationInfo(y);
            }
            function X(de) {
              if (de.newDuration) {
                var ne = me();
                ne && ne.adaptation.period && (ne.adaptation.period.duration = de.newDuration);
              }
            }
            return r = { getStreamId: function() {
              return pe.id;
            }, getType: ue, getData: function() {
              return u;
            }, isUpdating: z, updateData: function(de, ne, U, re, Te) {
              return new Promise(function(Fe, De) {
                if (_ = !0, w = ne, u = de, oe(L(Te)), U !== t.Z.VIDEO && U !== t.Z.AUDIO && (U !== t.Z.TEXT || !re)) return A(), void Fe();
                for (var ke = [], Le = 0, ut = w.length; Le < ut; Le++) {
                  var ct = w[Le];
                  ke.push(x(ct));
                }
                Promise.all(ke).then(function() {
                  oe(L(Te)), Fe();
                }).catch(function(rt) {
                  De(rt);
                });
              });
            }, getCurrentRepresentation: me, getCurrentRepresentationInfo: function() {
              return I;
            }, getRepresentationForQuality: L, prepareQualityChange: function(de) {
              oe(L(de)), O();
            }, reset: function() {
              N.off(n.Z.MANIFEST_VALIDITY_CHANGED, X, r), g();
            } }, g(), N.on(n.Z.MANIFEST_VALIDITY_CHANGED, X, r), r;
          }
          T.__dashjs_factory_name = "RepresentationController";
          var b = v.Z.getClassFactory(T), $ = R(3106), W = R(9326), Ie = R(7473), $e = R(2594);
          function Ze(i, r) {
            if (!(i instanceof r)) throw new TypeError("Cannot call a class as a function");
          }
          var xe = function i() {
            Ze(this, i), this.start = null, this.mstart = null, this.starttype = null, this.trace = [];
          };
          xe.INITIAL_PLAYOUT_START_REASON = "initial_playout", xe.SEEK_START_REASON = "seek", xe.RESUME_FROM_PAUSE_START_REASON = "resume", xe.METRICS_COLLECTION_START_REASON = "metrics_collection_start";
          var Me = function i() {
            Ze(this, i), this.representationid = null, this.subreplevel = null, this.start = null, this.mstart = null, this.duration = null, this.playbackspeed = null, this.stopreason = null;
          };
          Me.REPRESENTATION_SWITCH_STOP_REASON = "representation_switch", Me.REBUFFERING_REASON = "rebuffering", Me.USER_REQUEST_STOP_REASON = "user_request", Me.END_OF_PERIOD_STOP_REASON = "end_of_period", Me.END_OF_CONTENT_STOP_REASON = "end_of_content", Me.METRICS_COLLECTION_STOP_REASON = "metrics_collection_end", Me.FAILURE_STOP_REASON = "failure";
          var Ve = R(7802);
          function ot() {
            return { ntpToUTC: function(i) {
              var r = new Date(Date.UTC(1900, 0, 1, 0, 0, 0));
              return new Date(r.getTime() + i).getTime();
            } };
          }
          ot.__dashjs_factory_name = "TimeUtils";
          var bt = v.Z.getSingletonFactory(ot);
          function dt(i) {
            i = i || {};
            var r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he = this.context, Ee = (0, p.Z)(he).getInstance(), j = i.streamInfo, ue = i.type, z = i.errHandler, me = i.mimeType, g = i.timelineConverter, x = i.adapter, O = i.manifestModel, L = i.mediaPlayerModel, A = i.fragmentModel, oe = i.abrController, X = i.playbackController, de = i.mediaController, ne = i.textController, U = i.dashMetrics, re = i.settings, Te = i.boxParser, Fe = i.segmentBlacklistController;
            function De() {
              return j.id;
            }
            function ke() {
              return ue;
            }
            function Le() {
              return x.getIsTextTrack(Z.getData());
            }
            function ut() {
              I = [], w = null, pe = 0, Y = !1, V = !1, M = !1, ae = null;
            }
            function ct(We) {
              return !isNaN(We) && !isNaN(j.duration) && isFinite(j.duration) && We >= j.start + j.duration;
            }
            function rt(We) {
              var Pe = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
              if (We.sender) {
                if (X.getIsManifestUpdateInProgress()) yt();
                else if ((!Le() || ne.isTextEnabled()) && y && We.representationId && !y.appendInitSegmentFromCache(We.representationId)) {
                  var ft = Z.getCurrentRepresentation();
                  if (ft.range === 0) return void at();
                  var ye = H ? H.getInitRequest(w, ft) : null;
                  ye ? A.executeRequest(ye) : Pe && (N.setInitSegmentRequired(!0), yt());
                }
              }
            }
            function at(We) {
              var Pe = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
              if (X.getIsManifestUpdateInProgress() || y.getIsPruningInProgress()) yt();
              else {
                var ft = He();
                ft ? (Y = !1, V = !1, Bt(ft)) : Re(Pe);
              }
            }
            function Bt(We) {
              isNaN(We.startTime + We.duration) || (pe = We.startTime + We.duration), We.delayLoadingTime = (/* @__PURE__ */ new Date()).getTime() + N.getTimeToLoadDelay(), N.setTimeToLoadDelay(0), function(Pe) {
                var ft = Pe.url;
                return Pe.range && (ft = ft.concat("_", Pe.range)), Fe.contains(ft);
              }(We) ? (u.warn("Fragment request url ".concat(We.url, " for stream id ").concat(j.id, " and media type ").concat(ue, " is on the ignore list and will be skipped")), yt()) : (u.debug("Next fragment request url for stream id ".concat(j.id, " and media type ").concat(ue, " is ").concat(We.url)), A.executeRequest(We));
            }
            function Re(We) {
              var Pe, ft = Z.getCurrentRepresentation();
              if (!re.get().streaming.gaps.enableSeekFix || !Y && X.getTime() !== 0 || (_ ? _ && ft.segmentInfoType === e.Z.SEGMENT_TIMELINE && (Pe = H.getValidTimeAheadOfTargetTime(pe, w, ft, re.get().streaming.gaps.threshold)) : Pe = H.getValidTimeAheadOfTargetTime(pe, w, ft, re.get().streaming.gaps.threshold), isNaN(Pe) || Pe === pe)) {
                if (H.isLastSegmentRequested(ft, pe)) {
                  var ye = H.getCurrentIndex();
                  return u.debug("Segment requesting for stream ".concat(j.id, " has finished")), Ee.trigger(o.Z.STREAM_REQUESTING_COMPLETED, { segmentIndex: ye }, { streamId: j.id, mediaType: ue }), y.segmentRequestingCompleted(ye), void N.clearScheduleTimer();
                }
                We && yt();
              } else X.isSeeking() || X.getTime() === 0 ? (u.warn("Adjusting playback time ".concat(Pe, " because of gap in the manifest. Seeking by ").concat(Pe - pe)), X.seek(Pe, !1, !1)) : (u.warn("Adjusting buffering time ".concat(Pe, " because of gap in the manifest. Adjusting time by ").concat(Pe - pe)), Xt(Pe), We && yt());
            }
            function He() {
              var We, Pe = Qt();
              if (isNaN(pe) || ke() === t.Z.TEXT && !ne.isTextEnabled()) return null;
              if (H) {
                var ft = Z && Pe ? Z.getRepresentationForQuality(Pe.quality) : null;
                We = Y ? H.getSegmentRequestForTime(w, ft, pe) : V ? H.repeatSegmentRequest(w, ft) : H.getNextSegmentRequest(w, ft);
              }
              return We;
            }
            function yt() {
              N.startScheduleTimer(X.getLowLatencyModeEnabled() ? re.get().streaming.scheduling.lowLatencyTimeout : re.get().streaming.scheduling.defaultTimeout);
            }
            function Qe(We) {
              We.error || y.getIsBufferingCompleted() || y.updateBufferTimestampOffset(We.currentRepresentation);
            }
            function Tt(We) {
              U.addBufferState(ue, We.state, N.getBufferTarget()), We.state !== h.Z.BUFFER_EMPTY || X.isSeeking() || (u.info("Buffer is empty! Stalling!"), U.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), Me.REBUFFERING_REASON));
            }
            function vt(We) {
              A.syncExecutedRequestsWithBufferedRange(y.getBuffer().getAllBufferRanges(), j.duration), We.quotaExceeded && We.from > X.getTime() && Xt(We.from), We.hasEnoughSpaceToAppend && We.quotaExceeded && N.startScheduleTimer();
            }
            function mt(We) {
              if (We && We.lastRequestAppended && We.lastRequestAppended.url) {
                var Pe = We.lastRequestAppended.url;
                We.lastRequestAppended.range && (Pe = Pe.concat("_", We.lastRequestAppended.range)), u.warn("Blacklisting segment with url ".concat(Pe)), Fe.add(Pe);
              }
            }
            function Wt(We) {
              if (u.debug("Appended bytes for ".concat(We.mediaType, " and stream id ").concat(We.streamId)), We.segmentType === Ge.w.INIT_SEGMENT_TYPE) {
                var Pe = We.quality;
                N.setLastInitializedQuality(Pe), u.info("[" + ue + "] lastInitializedRepresentationInfo changed to " + We.quality);
              }
              ae ? zt(ae) : N.startScheduleTimer(0);
            }
            function zt(We) {
              var Pe = A.getRequests({ state: Q.FRAGMENT_MODEL_LOADING });
              if (Pe && Pe.length > 0) return u.debug("Preparing for default quality switch: Waiting for ongoing segment request to be finished before applying switch."), void (ae = We);
              y.updateBufferTimestampOffset(We).then(function() {
                N.setCheckPlaybackQuality(!1), w.segmentAlignment || w.subSegmentAlignment ? N.startScheduleTimer() : qt(), ae = null, M = !1;
              }).catch(function() {
                ae = null, M = !1;
              });
            }
            function hn(We) {
              u.info("onFragmentLoadingAbandoned request: " + We.request.url + " has been aborted"), X.isSeeking() || N.getSwitchTrack() || M || (u.info("onFragmentLoadingAbandoned request: " + We.request.url + " has to be downloaded again, origin is not seeking process or switch track call"), We.request && We.request.isInitializationRequest() ? N.setInitSegmentRequired(!0) : Xt(We.request.startTime + We.request.duration / 2), N.startScheduleTimer(0));
            }
            function yn(We) {
              u.info("OnFragmentLoadingCompleted for stream id " + j.id + " and media type " + ue + " - Url:", We.request ? We.request.url : "undefined", We.request.range ? ", Range:" + We.request.range : ""), Le() && N.startScheduleTimer(0), We.error && We.request.serviceLocation && function(Pe) {
                u.info("Fragment loading completed with an error"), Pe && Pe.request && Pe.request.type && (Pe.request.type === Ge.w.INIT_SEGMENT_TYPE ? rt({ representationId: Pe.request.representationId, sender: {} }, !1) : Pe.request.type === Ge.w.MEDIA_SEGMENT_TYPE && (Xt(Pe.request.startTime + Pe.request.duration / 2), at({}, !1)));
              }(We);
            }
            function ze() {
              Xt(X.getTime()), $t().startScheduleTimer();
            }
            function Et(We) {
              var Pe = We.currentTrackInfo;
              if (Pe) {
                var ft = I.find(function(ye) {
                  return ye.index === Pe.index && ye.lang === Pe.lang;
                });
                ft && Pt(ft).then(function() {
                  y.setIsBufferingCompleted(!1), Xt(X.getTime()), N.setInitSegmentRequired(!0), N.startScheduleTimer();
                });
              }
            }
            function lt(We) {
              Xt(We.quotaExceededTime), N.clearScheduleTimer();
            }
            function wt() {
              return y ? y.getBuffer() : null;
            }
            function Pt(We) {
              We === w || We && w && We.type !== w.type || (w = We);
              var Pe = x.getRealAdaptation(j, w), ft = x.getVoRepresentations(w);
              if (Z) {
                var ye, Ae = Z.getData(), tt = oe.getMaxAllowedIndexFor(ue, j.id), Nt = oe.getMinAllowedIndexFor(ue, j.id), xt = null;
                return Ae !== null && Ae.id === Pe.id || ue === t.Z.TEXT ? ye = oe.getQualityFor(ue, j.id) : (xt = oe.getThroughputHistory().getAverageThroughput(ue, _) || oe.getInitialBitrateFor(ue, j.id), ye = oe.getQualityForBitrate(w, xt, j.id)), Nt !== void 0 && ye < Nt && (ye = Nt), ye > tt && (ye = tt), Z.updateData(Pe, ft, ue, w.isFragmented, ye);
              }
              return Promise.resolve();
            }
            function $t() {
              return N;
            }
            function Qt(We) {
              var Pe;
              return We !== void 0 ? ((0, $.SE)(We), Pe = Z ? Z.getRepresentationForQuality(We) : null) : Pe = Z ? Z.getCurrentRepresentation() : null, x.convertRepresentationToRepresentationInfo(Pe);
            }
            function en() {
              return !!y && y.getIsBufferingCompleted();
            }
            function ln(We) {
              if (re.get().streaming.enableManifestTimescaleMismatchFix) {
                var Pe = We.chunk, ft = Pe.bytes, ye = Qt(Pe.quality), Ae = Z && ye ? Z.getRepresentationForQuality(ye.quality) : null;
                ye && Ae && (Ae.timescale = Te.getMediaTimescaleFromMoov(ft));
              }
            }
            function pt(We) {
              var Pe = We.chunk, ft = Pe.bytes, ye = Pe.quality, Ae = Qt(ye), tt = Z && Ae ? Z.getRepresentationForQuality(Ae.quality) : null;
              if (Ae && tt) {
                var Nt;
                if (re.get().streaming.parseInbandPrft && We.request.type === Ge.w.MEDIA_SEGMENT_TYPE) {
                  var xt = function(yr, nr) {
                    var Yr = yr.getBoxes("prft"), ei = [];
                    return Yr.forEach(function(ti) {
                      ei.push(function(kr, Ur) {
                        var _r = "unknown";
                        switch (kr.flags) {
                          case 0:
                            _r = e.Z.PRODUCER_REFERENCE_TIME_TYPE.ENCODER;
                            break;
                          case 16:
                            _r = e.Z.PRODUCER_REFERENCE_TIME_TYPE.APPLICATION;
                            break;
                          case 24:
                            _r = e.Z.PRODUCER_REFERENCE_TIME_TYPE.CAPTURED;
                        }
                        var Kr = 1e3 * kr.ntp_timestamp_sec + kr.ntp_timestamp_frac / Math.pow(2, 32) * 1e3;
                        return { type: _r, ntpTimestamp: Kr = bt(he).getInstance().ntpToUTC(Kr), mediaTime: kr.media_time / Ur };
                      }(ti, nr));
                    }), ei;
                  }(Nt = Nt || Te.parse(ft), tt.timescale);
                  xt && xt.length && Ee.trigger(n.Z.INBAND_PRFT, { data: xt }, { streamId: j.id, mediaType: ue });
                }
                var _n = x.getEventsFor(Ae.mediaInfo, null, j), Ln = x.getEventsFor(Ae, tt, j);
                if (_n && _n.length > 0 || Ln && Ln.length > 0) {
                  var $n = A.getRequests({ state: Q.FRAGMENT_MODEL_EXECUTED, quality: ye, index: Pe.index })[0], Mn = function(yr, nr, Yr, ei) {
                    try {
                      for (var ti = {}, kr = [], Ur = Yr.concat(ei), _r = 0, Kr = Ur.length; _r < Kr; _r++) ti[Ur[_r].schemeIdUri + "/" + Ur[_r].value] = Ur[_r];
                      var ni = yr.getBoxes("emsg");
                      if (!ni || ni.length === 0) return kr;
                      for (var Lr = yr.getBox("sidx"), Mi = !Lr || isNaN(Lr.earliest_presentation_time) || isNaN(Lr.timescale) ? nr && !isNaN(nr.mediaStartTime) ? nr.mediaStartTime : 0 : Lr.earliest_presentation_time / Lr.timescale, ua = Math.max(Mi, 0), ca = Z.getCurrentRepresentation(), zr = 0, fa = ni.length; zr < fa; zr++) {
                        var ri = x.getEvent(ni[zr], ti, ua, ca);
                        ri && kr.push(ri);
                      }
                      return kr;
                    } catch {
                      return [];
                    }
                  }(Nt = Nt || Te.parse(ft), $n, _n, Ln);
                  Ee.trigger(o.Z.INBAND_EVENTS, { events: Mn }, { streamId: j.id });
                }
              }
            }
            function kt() {
              var We = X.getTime();
              re.get().streaming.buffer.flushBufferAtTrackSwitch && X.seek(We + 1e-3, !1, !0), Xt(We), y.setSeekTarget(We), N.startScheduleTimer();
            }
            function qt() {
              var We = X.getTime(), Pe = y.getContinuousBufferTimeForTargetTime(We);
              Xt(isNaN(Pe) ? We : Pe), N.startScheduleTimer();
            }
            function Vt(We) {
              We && !isNaN(We.time) && (Xt(We.time), y.setSeekTarget(We.time));
            }
            function Xt(We) {
              pe = We, Y = !0;
            }
            return r = { initialize: function(We, Pe, ft) {
              G = (0, Ve.Z)(he).create({ events: o.Z, eventBus: Ee, streamInfo: j, timelineConverter: g, dashConstants: e.Z, segmentBaseController: i.segmentBaseController, type: ue }), H = (0, W.Z)(he).create({ streamInfo: j, type: ue, timelineConverter: g, dashMetrics: U, mediaPlayerModel: L, baseURLController: i.baseURLController, errHandler: z, segmentsController: G, settings: re, boxParser: Te, events: o.Z, eventBus: Ee, errors: ee, debug: (0, m.Z)(he).getInstance(), requestModifier: (0, Ie.Z)(he).getInstance(), dashConstants: e.Z, constants: t.Z, urlUtils: (0, $e.Z)(he).getInstance() }), _ = j.manifestInfo.isDynamic, H.initialize(_), oe.registerStreamType(ue, r), Z = b(he).create({ streamInfo: j, type: ue, abrController: oe, dashMetrics: U, playbackController: X, timelineConverter: g, dashConstants: e.Z, events: o.Z, eventBus: Ee, errors: ee, isDynamic: _, adapter: x, segmentsController: G }), y = function(ye, Ae) {
                return ye ? ye !== t.Z.TEXT || Ae ? je(he).create({ streamInfo: j, type: ye, mediaPlayerModel: L, manifestModel: O, fragmentModel: A, errHandler: z, mediaController: de, representationController: Z, adapter: x, textController: ne, abrController: oe, playbackController: X, settings: re }) : Se(he).create({ streamInfo: j, type: ye, mimeType: me, fragmentModel: A, textController: ne, errHandler: z, settings: re }) : (z.error(new se.Z(ee.MEDIASOURCE_TYPE_UNSUPPORTED_CODE, ee.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + "not properly defined")), null);
              }(ue, ft), y && y.initialize(We), (N = d(he).create({ streamInfo: j, type: ue, mimeType: me, adapter: x, dashMetrics: U, mediaPlayerModel: L, fragmentModel: A, abrController: oe, playbackController: X, textController: ne, mediaController: de, bufferController: y, representationController: Z, settings: re })).initialize(Pe), pe = 0, Y = !1, V = !1;
            }, getStreamId: De, getType: ke, isUpdating: function() {
              return !!Z && Z.isUpdating();
            }, getBufferController: function() {
              return y;
            }, dischargePreBuffer: function() {
              y.dischargePreBuffer();
            }, getFragmentModel: function() {
              return A;
            }, getScheduleController: $t, getRepresentationController: function() {
              return Z;
            }, getRepresentationInfo: Qt, getBufferLevel: function() {
              return y ? y.getBufferLevel() : 0;
            }, isBufferingCompleted: en, createBufferSinks: function(We) {
              var Pe = wt();
              return Pe ? Promise.resolve(Pe) : y ? y.createBufferSink(w, We) : Promise.resolve(null);
            }, updateStreamInfo: function(We) {
              return j = We, en() ? Promise.resolve() : y.updateAppendWindow();
            }, getStreamInfo: function() {
              return j;
            }, selectMediaInfo: Pt, clearMediaInfoArray: function() {
              I = [];
            }, addMediaInfo: function(We) {
              I.indexOf(We) === -1 && I.push(We);
            }, prepareTrackSwitch: function() {
              return new Promise(function(We) {
                u.debug("Preparing track switch for type ".concat(ue));
                var Pe = ue === t.Z.TEXT || re.get().streaming.trackSwitchMode[ue] === t.Z.TRACK_SWITCH_MODE_ALWAYS_REPLACE && X.getTimeToStreamEnd(j) > re.get().streaming.buffer.stallThreshold;
                if (y.getIsBufferingCompleted() && !Pe) return y.prepareForNonReplacementTrackSwitch(w.codec).then(function() {
                  Ee.trigger(o.Z.BUFFERING_COMPLETED, {}, { streamId: j.id, mediaType: ue });
                }).catch(function() {
                  Ee.trigger(o.Z.BUFFERING_COMPLETED, {}, { streamId: j.id, mediaType: ue });
                }), void We();
                N.clearScheduleTimer(), N.setSwitchTrack(!0), Pe ? (Ee.trigger(o.Z.BUFFER_REPLACEMENT_STARTED, { mediaType: ue, streamId: j.id }, { mediaType: ue, streamId: j.id }), A.abortRequests(), y.prepareForReplacementTrackSwitch(w.codec).then(function() {
                  var ft = Qt();
                  return y.updateBufferTimestampOffset(ft);
                }).then(function() {
                  kt(), We();
                }).catch(function() {
                  kt(), We();
                })) : y.prepareForNonReplacementTrackSwitch(w.codec).then(function() {
                  qt(), We();
                }).catch(function() {
                  qt(), We();
                });
              });
            }, prepareQualityChange: function(We) {
              ae && u.warn("Canceling queued representation switch to ".concat(ae.quality, " for ").concat(ue)), u.debug("Preparing quality switch for type ".concat(ue));
              var Pe = We.newQuality;
              M = !0, N.clearScheduleTimer(), Z.prepareQualityChange(Pe);
              var ft = Qt(Pe);
              We.reason && We.reason.forceReplace ? function(ye) {
                A.abortRequests(), Ee.trigger(o.Z.BUFFER_REPLACEMENT_STARTED, { mediaType: ue, streamId: j.id }, { mediaType: ue, streamId: j.id }), N.setCheckPlaybackQuality(!1), y.prepareForForceReplacementQualitySwitch(ye).then(function() {
                  kt(), ae = null, M = !1;
                }).catch(function() {
                  kt(), ae = null, M = !1;
                });
              }(ft) : We && We.reason && We.reason.forceAbandon ? function(ye) {
                y.updateBufferTimestampOffset(ye).then(function() {
                  A.abortRequests(), V = !0, N.setCheckPlaybackQuality(!1), N.startScheduleTimer(), M = !1, ae = null;
                }).catch(function() {
                  ae = null, M = !1;
                });
              }(ft) : re.get().streaming.buffer.fastSwitchEnabled ? function(ye) {
                var Ae = X.getTime(), tt = 1.5 * (isNaN(ye.fragmentDuration) ? 1 : ye.fragmentDuration), Nt = A.getRequests({ state: Q.FRAGMENT_MODEL_EXECUTED, time: Ae + tt, threshold: 0 })[0];
                if (Nt && !Le()) {
                  var xt = y.getBufferLevel(), _n = oe.getAbandonmentStateFor(j.id, ue);
                  Nt.quality < ye.quality && xt >= tt && _n !== h.Z.ABANDON_LOAD ? y.updateBufferTimestampOffset(ye).then(function() {
                    A.abortRequests(), Xt(Ae + tt), N.setCheckPlaybackQuality(!1), N.startScheduleTimer(), M = !1;
                  }).catch(function() {
                    M = !1;
                  }) : zt(ye);
                } else zt(ye);
              }(ft) : zt(ft), U.pushPlayListTraceMetrics(/* @__PURE__ */ new Date(), Me.REPRESENTATION_SWITCH_STOP_REASON), U.createPlaylistTraceMetrics(ft.id, 1e3 * X.getTime(), X.getPlaybackRate());
            }, getMediaInfo: function() {
              return w;
            }, getMediaSource: function() {
              return y.getMediaSource();
            }, setMediaSource: function(We) {
              return y.setMediaSource(We, w);
            }, getBuffer: wt, setExplicitBufferingTime: Xt, finalisePlayList: function(We, Pe) {
              U.pushPlayListTraceMetrics(We, Pe);
            }, probeNextRequest: function() {
              var We = Qt(), Pe = Z && We ? Z.getRepresentationForQuality(We.quality) : null;
              return H.getNextSegmentRequestIdempotent(w, Pe);
            }, prepareInnerPeriodPlaybackSeeking: function(We) {
              return new Promise(function(Pe) {
                if (y.hasBufferAtTime(We.seekTime)) return y.pruneBuffer(), ct(y.getContinuousBufferTimeForTargetTime(We.seekTime)) && y.setIsBufferingCompleted(!0), void Pe();
                N.clearScheduleTimer(), A.abortRequests(), y.prepareForPlaybackSeek().then(function() {
                  var ft = y.getAllRangesWithSafetyFactor(We.seekTime);
                  return y.clearBuffers(ft);
                }).then(function() {
                  var ft = y.getContinuousBufferTimeForTargetTime(We.seekTime);
                  if (ct(ft)) y.setIsBufferingCompleted(!0), Pe();
                  else {
                    var ye = isNaN(ft) ? We.seekTime : ft;
                    Xt(ye), y.setSeekTarget(ye);
                    var Ae = [];
                    Ae.push(y.updateAppendWindow());
                    var tt = Qt();
                    Ae.push(y.updateBufferTimestampOffset(tt)), Promise.all(Ae).then(function() {
                      N.setInitSegmentRequired(!0), N.setCheckPlaybackQuality(!1), N.startScheduleTimer(), Pe();
                    });
                  }
                }).catch(function(ft) {
                  u.error(ft);
                });
              });
            }, prepareOuterPeriodPlaybackSeeking: function() {
              return new Promise(function(We, Pe) {
                try {
                  N.clearScheduleTimer(), A.abortRequests(), y.prepareForPlaybackSeek().then(function() {
                    return y.pruneAllSafely();
                  }).then(function() {
                    We();
                  });
                } catch (ft) {
                  Pe(ft);
                }
              });
            }, reset: function(We, Pe) {
              H && H.reset(), y && (y.reset(We, Pe), y = null), N && (N.reset(), N = null), Z && (Z.reset(), Z = null), G && (G = null), oe && oe.unRegisterStreamType(De(), ue), Ee.off(o.Z.DATA_UPDATE_COMPLETED, Qe, r), Ee.off(o.Z.INIT_FRAGMENT_NEEDED, rt, r), Ee.off(o.Z.MEDIA_FRAGMENT_NEEDED, at, r), Ee.off(o.Z.INIT_FRAGMENT_LOADED, ln, r), Ee.off(o.Z.MEDIA_FRAGMENT_LOADED, pt, r), Ee.off(o.Z.BUFFER_LEVEL_STATE_CHANGED, Tt, r), Ee.off(o.Z.BUFFER_CLEARED, vt, r), Ee.off(o.Z.SEEK_TARGET, Vt, r), Ee.off(o.Z.FRAGMENT_LOADING_ABANDONED, hn, r), Ee.off(o.Z.FRAGMENT_LOADING_COMPLETED, yn, r), Ee.off(o.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, ze, r), Ee.off(o.Z.SET_NON_FRAGMENTED_TEXT, Et, r), Ee.off(o.Z.QUOTA_EXCEEDED, lt, r), Ee.off(o.Z.SOURCE_BUFFER_ERROR, mt, r), Ee.off(o.Z.BYTES_APPENDED_END_FRAGMENT, Wt, r), ut(), ue = null, j = null;
            } }, u = (0, m.Z)(he).getInstance().getLogger(r), ut(), Ee.on(o.Z.DATA_UPDATE_COMPLETED, Qe, r, { priority: p.Z.EVENT_PRIORITY_HIGH }), Ee.on(o.Z.INIT_FRAGMENT_NEEDED, rt, r), Ee.on(o.Z.MEDIA_FRAGMENT_NEEDED, at, r), Ee.on(o.Z.INIT_FRAGMENT_LOADED, ln, r), Ee.on(o.Z.MEDIA_FRAGMENT_LOADED, pt, r), Ee.on(o.Z.BUFFER_LEVEL_STATE_CHANGED, Tt, r), Ee.on(o.Z.BUFFER_CLEARED, vt, r), Ee.on(o.Z.SEEK_TARGET, Vt, r), Ee.on(o.Z.FRAGMENT_LOADING_ABANDONED, hn, r), Ee.on(o.Z.FRAGMENT_LOADING_COMPLETED, yn, r), Ee.on(o.Z.QUOTA_EXCEEDED, lt, r), Ee.on(o.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, ze, r), Ee.on(o.Z.SET_NON_FRAGMENTED_TEXT, Et, r), Ee.on(o.Z.SOURCE_BUFFER_ERROR, mt, r), Ee.on(o.Z.BYTES_APPENDED_END_FRAGMENT, Wt, r), r;
          }
          dt.__dashjs_factory_name = "StreamProcessor";
          var Yt = v.Z.getClassFactory(dt), Ot = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.streamId = null, this.mediaInfo = null, this.segmentType = null, this.quality = NaN, this.index = NaN, this.bytes = null, this.start = NaN, this.end = NaN, this.duration = NaN, this.representationId = null, this.endFragment = null;
          }, Ht = R(9032);
          function Ut(i, r) {
            if (i) {
              if (typeof i == "string") return fn(i, r);
              var u = Object.prototype.toString.call(i).slice(8, -1);
              return u === "Object" && i.constructor && (u = i.constructor.name), u === "Map" || u === "Set" ? Array.from(i) : u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u) ? fn(i, r) : void 0;
            }
          }
          function fn(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function Tn(i) {
            i = i || {};
            var r, u, _ = this.context, w = i.requestModifier, I = i.lowLatencyThroughputModel, y = i.boxParser, N = (0, Oe.Z)(_).getInstance();
            function Z(M) {
              var H, G = /* @__PURE__ */ new Date(), pe = M.request, ae = new Headers();
              if (pe.range && ae.append("Range", "bytes=" + pe.range), M.headers) for (var he in M.headers) {
                var Ee = M.headers[he];
                Ee && ae.append(he, Ee);
              }
              pe.requestStartDate || (pe.requestStartDate = G), w && w.modifyRequestHeader && w.modifyRequestHeader({ setRequestHeader: function(g, x) {
                ae.append(g, x);
              } }, { url: M.url }), typeof window.AbortController == "function" && (H = new AbortController(), M.abortController = H, H.signal.onabort = M.onabort);
              var j = { method: M.method, headers: ae, credentials: M.withCredentials ? "include" : void 0, signal: H ? H.signal : void 0 }, ue = N.get().streaming.abr.fetchThroughputCalculationMode, z = Date.now(), me = 0;
              new Promise(function(g) {
                if (ue === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && I && (me = I.getThroughputCapacityDelayMS(pe, 1e3 * u.getCurrentBufferLevel(pe.mediaType)))) return setTimeout(g, me);
                g();
              }).then(function() {
                var g = Date.now();
                fetch(M.url, j).then(function(x) {
                  M.response || (M.response = {}), M.response.status = x.status, M.response.statusText = x.statusText, M.response.responseURL = x.url, x.ok || M.onerror();
                  var O, L = "", A = function(Qe, Tt) {
                    var vt;
                    if (typeof Symbol > "u" || Qe[Symbol.iterator] == null) {
                      if (Array.isArray(Qe) || (vt = Ut(Qe))) {
                        vt && (Qe = vt);
                        var mt = 0, Wt = function() {
                        };
                        return { s: Wt, n: function() {
                          return mt >= Qe.length ? { done: !0 } : { done: !1, value: Qe[mt++] };
                        }, e: function(ze) {
                          throw ze;
                        }, f: Wt };
                      }
                      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                    }
                    var zt, hn = !0, yn = !1;
                    return { s: function() {
                      vt = Qe[Symbol.iterator]();
                    }, n: function() {
                      var ze = vt.next();
                      return hn = ze.done, ze;
                    }, e: function(ze) {
                      yn = !0, zt = ze;
                    }, f: function() {
                      try {
                        hn || vt.return == null || vt.return();
                      } finally {
                        if (yn) throw zt;
                      }
                    } };
                  }(x.headers.keys());
                  try {
                    for (A.s(); !(O = A.n()).done; ) {
                      var oe = O.value;
                      L += oe + ": " + x.headers.get(oe) + `\r
`;
                    }
                  } catch (Qe) {
                    A.e(Qe);
                  } finally {
                    A.f();
                  }
                  if (M.response.responseHeaders = L, !x.body) return x.arrayBuffer().then(function(Qe) {
                    M.response.response = Qe;
                    var Tt = { loaded: Qe.byteLength, total: Qe.byteLength, stream: !1 };
                    M.progress(Tt), M.onload(), M.onend();
                  });
                  var X, de, ne, U, re = parseInt(x.headers.get("Content-Length"), 10), Te = 0, Fe = !1, De = new Uint8Array(), ke = 0;
                  if (ue === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST && I) {
                    var Le = g, ut = 0, ct = (ne = x.body.tee(), U = 2, function(Qe) {
                      if (Array.isArray(Qe)) return Qe;
                    }(ne) || function(Qe, Tt) {
                      if (typeof Symbol < "u" && Symbol.iterator in Object(Qe)) {
                        var vt = [], mt = !0, Wt = !1, zt = void 0;
                        try {
                          for (var hn, yn = Qe[Symbol.iterator](); !(mt = (hn = yn.next()).done) && (vt.push(hn.value), !Tt || vt.length !== Tt); mt = !0) ;
                        } catch (ze) {
                          Wt = !0, zt = ze;
                        } finally {
                          try {
                            mt || yn.return == null || yn.return();
                          } finally {
                            if (Wt) throw zt;
                          }
                        }
                        return vt;
                      }
                    }(ne, U) || Ut(ne, U) || function() {
                      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                    }()), rt = ct[0], at = ct[1];
                    X = rt.getReader(), de = [], X.read().then(function Qe(Tt) {
                      var vt = Tt.value, mt = Tt.done;
                      if (ut = Date.now(), vt && vt.length) {
                        var Wt = ut - Le, zt = vt.length;
                        de.push({ chunkDownloadTimeRelativeMS: ut - g, chunkDownloadDurationMS: Wt, chunkBytes: zt, kbps: Math.round(8 * zt / (Wt / 1e3)), bufferLevel: u.getCurrentBufferLevel(pe.mediaType) });
                      }
                      if (mt) {
                        var hn = ut - g, yn = de.reduce(function(ze, Et) {
                          return ze + Et.chunkBytes;
                        }, 0);
                        return I.addMeasurement(pe, hn, de, z, me, L), void M.progress({ loaded: yn, total: yn, lengthComputable: !0, time: I.getEstimatedDownloadDurationMS(pe), stream: !0 });
                      }
                      return Le = Date.now(), X.read().then(Qe);
                    }), M.reader = at.getReader();
                  } else M.reader = x.body.getReader();
                  var Bt = [], Re = [], He = [], yt = !0;
                  Y(M, function Qe(Tt) {
                    var vt = Tt.value;
                    if (Tt.done) {
                      if (De) {
                        if (ue !== t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_AAST) {
                          var mt = null, Wt = null;
                          ue === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING ? (mt = function(ze, Et) {
                            try {
                              var lt, wt;
                              lt = ze.filter(function(kt, qt) {
                                return qt < ze.length - 1;
                              }), wt = Et.filter(function(kt, qt) {
                                return qt < Et.length - 1;
                              });
                              var Pt = [];
                              if (lt.length > 1) {
                                for (var $t = 0, Qt = 0, en = 0; en < lt.length; en++) if (lt[en] && wt[en]) {
                                  var ln = wt[en].ts - lt[en].ts;
                                  if (ln > 1) Pt.push(8 * wt[en].bytes / ln), Qt = 0;
                                  else {
                                    Qt === 0 && (Qt = lt[en].ts, $t = 0);
                                    var pt = wt[en].ts - Qt;
                                    pt > 1 ? ($t += wt[en].bytes, Pt.push(8 * $t / pt), Qt = 0) : $t += wt[en].bytes;
                                  }
                                }
                                if (Pt.length > 0) return Pt.reduce(function(kt, qt) {
                                  return kt + qt;
                                }, 0) / Pt.length;
                              }
                              return null;
                            } catch {
                              return null;
                            }
                          }(Re, He), mt && (Wt = 8 * Te / mt)) : ue === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA && (Wt = V(Bt, Te)), M.progress({ loaded: Te, total: isNaN(re) ? Te : re, lengthComputable: !0, time: Wt, stream: !0 });
                        }
                        M.response.response = De.buffer;
                      }
                      return M.onload(), void M.onend();
                    }
                    if (vt && vt.length > 0) {
                      De = function(ze, Et) {
                        if (ze.length === 0) return Et;
                        var lt = new Uint8Array(ze.length + Et.length);
                        return lt.set(ze), lt.set(Et, ze.length), lt;
                      }(De, vt), Te += vt.length, Bt.push({ ts: Date.now(), bytes: vt.length }), ue === t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && yt && y.findLastTopIsoBoxCompleted(["moof"], De, ke).found && (yt = !1, Re.push({ ts: performance.now(), bytes: vt.length }));
                      var zt = y.findLastTopIsoBoxCompleted(["moov", "mdat"], De, ke);
                      if (zt.found) {
                        var hn, yn = zt.lastCompletedOffset + zt.size;
                        ue !== t.Z.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING || yt || (yt = !0, He.push({ ts: performance.now(), bytes: De.length })), yn === De.length ? (hn = De, De = new Uint8Array()) : (hn = new Uint8Array(De.subarray(0, yn)), De = De.subarray(yn)), M.progress({ data: hn.buffer, lengthComputable: !1, noTrace: !0 }), ke = 0;
                      } else ke = zt.lastCompletedOffset, Fe || (M.progress({ lengthComputable: !1, noTrace: !0 }), Fe = !0);
                    }
                    Y(M, Qe);
                  });
                }).catch(function(x) {
                  M.onerror && M.onerror(x);
                });
              });
            }
            function Y(M, H) {
              M.reader.read().then(H).catch(function(G) {
                M.onerror && M.response.status === 200 && M.onerror(G);
              });
            }
            function V(M, H) {
              try {
                if ((M = M.filter(function(ae) {
                  return ae.bytes > H / 4 / M.length;
                })).length > 1) {
                  var G = 0, pe = (M[M.length - 1].ts - M[0].ts) / M.length;
                  return M.forEach(function(ae, he) {
                    var Ee = M[he + 1];
                    if (Ee) {
                      var j = Ee.ts - ae.ts;
                      G += j < pe ? j : 0;
                    }
                  }), G;
                }
                return null;
              } catch {
                return null;
              }
            }
            return r = { load: function(M) {
              w && w.modifyRequest ? (0, Ie.k)(M, w).then(function() {
                return Z(M);
              }) : Z(M);
            }, abort: function(M) {
              if (M.abortController) M.abortController.abort();
              else if (M.reader) try {
                M.reader.cancel(), M.onabort();
              } catch {
              }
            }, calculateDownloadedTime: V, setup: function(M) {
              u = M.dashMetrics;
            } }, r;
          }
          Tn.__dashjs_factory_name = "FetchLoader";
          var Fn = v.Z.getClassFactory(Tn), On = R(1180);
          function Zn(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var rr = function() {
            function i() {
              (function(_, w) {
                if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.id = null, this.index = -1, this.adaptation = null, this.segmentInfoType = null, this.initialization = null, this.codecs = null, this.mimeType = null, this.codecPrivateData = null, this.segmentDuration = NaN, this.timescale = 1, this.startNumber = 1, this.indexRange = null, this.range = null, this.presentationTimeOffset = 0, this.MSETimeOffset = NaN, this.mediaFinishedInformation = { numberOfSegments: 0, mediaTimeOfLastSignaledSegment: NaN }, this.bandwidth = NaN, this.width = NaN, this.height = NaN, this.scanType = null, this.maxPlayoutRate = NaN, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0, this.frameRate = null;
            }
            var r, u;
            return r = i, (u = [{ key: "hasInitialization", value: function() {
              return this.initialization !== null || this.range !== null;
            } }, { key: "hasSegments", value: function() {
              return this.segmentInfoType !== e.Z.BASE_URL && this.segmentInfoType !== e.Z.SEGMENT_BASE && !this.indexRange;
            } }]) && Zn(r.prototype, u), i;
          }(), wn = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.period = null, this.index = -1, this.type = null;
          }, pr = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = -1, this.duration = NaN, this.start = NaN, this.mpd = null, this.nextPeriodId = null;
          };
          pr.DEFAULT_ID = "defaultId";
          var Qn = pr, cr = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.manifest = null, this.suggestedPresentationDelay = 0, this.availabilityStartTime = null, this.availabilityEndTime = Number.POSITIVE_INFINITY, this.timeShiftBufferDepth = Number.POSITIVE_INFINITY, this.maxSegmentDuration = Number.POSITIVE_INFINITY, this.publishTime = null, this.minimumUpdatePeriod = NaN, this.mediaPresentationDuration = NaN;
          }, Tr = R(2610), fr = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.type = "", this.duration = NaN, this.presentationTime = NaN, this.id = NaN, this.messageData = "", this.eventStream = null, this.presentationTimeDelta = NaN;
          }, Rr = function i(r, u, _, w) {
            (function(I, y) {
              if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = u || r || "", this.dvbPriority = _ || 1, this.dvbWeight = w || 1, this.availabilityTimeOffset = 0, this.availabilityTimeComplete = !0, this.queryParams = {};
          };
          Rr.DEFAULT_DVB_PRIORITY = 1, Rr.DEFAULT_DVB_WEIGHT = 1;
          var Nr = Rr, ui = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.adaptionSet = null, this.representation = null, this.period = null, this.timescale = 1, this.value = "", this.schemeIdUri = "", this.presentationTimeOffset = 0;
          }, Dt = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.inband = !1, this.type = "encoder", this.applicationScheme = null, this.wallClockTime = null, this.presentationTime = NaN, this.UTCTiming = null;
          }, Ct = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.defaultServiceLocation = null, this.defaultServiceLocationArray = [], this.queryBeforeStart = !1, this.serverUrl = null, this.clientRequirement = !0;
          };
          function Rt(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Ke = function() {
            function i() {
              (function(_, w) {
                if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.schemeIdUri = null, this.value = null, this.id = null;
            }
            var r, u;
            return r = i, (u = [{ key: "init", value: function(_) {
              return _ && (this.schemeIdUri = _.schemeIdUri ? _.schemeIdUri : null, this.value = _.value ? _.value : null, this.id = _.id ? _.id : null, _[e.Z.DVB_URL] && (this.dvbUrl = _[e.Z.DVB_URL]), _[e.Z.DVB_MIMETYPE] && (this.dvbMimeType = _[e.Z.DVB_MIMETYPE]), _[e.Z.DVB_FONTFAMILY] && (this.dvbFontFamily = _[e.Z.DVB_FONTFAMILY])), this;
            } }]) && Rt(r.prototype, u), i;
          }(), _t = R(3101), et = R.n(_t);
          function gt() {
            return { areEqual: function(i, r) {
              return et()(i, r);
            } };
          }
          gt.__dashjs_factory_name = "ObjectUtils";
          var Zt = v.Z.getSingletonFactory(gt), Gt = R(7803), an = function i(r, u) {
            (function(_, w) {
              if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = u || null, this.queryParams = {};
          }, on = function i(r, u, _) {
            (function(w, I) {
              if (!(w instanceof I)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || "", this.serviceLocation = u || null, this.ttl = _ || NaN, this.queryParams = {};
          };
          function Kt(i, r) {
            var u = Object.keys(i);
            if (Object.getOwnPropertySymbols) {
              var _ = Object.getOwnPropertySymbols(i);
              r && (_ = _.filter(function(w) {
                return Object.getOwnPropertyDescriptor(i, w).enumerable;
              })), u.push.apply(u, _);
            }
            return u;
          }
          function It(i) {
            for (var r = 1; r < arguments.length; r++) {
              var u = arguments[r] != null ? arguments[r] : {};
              r % 2 ? Kt(Object(u), !0).forEach(function(_) {
                rn(i, _, u[_]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(u)) : Kt(Object(u)).forEach(function(_) {
                Object.defineProperty(i, _, Object.getOwnPropertyDescriptor(u, _));
              });
            }
            return i;
          }
          function rn(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Jt(i, r) {
            var u;
            if (typeof Symbol > "u" || i[Symbol.iterator] == null) {
              if (Array.isArray(i) || (u = gn(i)) || r) {
                u && (i = u);
                var _ = 0, w = function() {
                };
                return { s: w, n: function() {
                  return _ >= i.length ? { done: !0 } : { done: !1, value: i[_++] };
                }, e: function(Z) {
                  throw Z;
                }, f: w };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var I, y = !0, N = !1;
            return { s: function() {
              u = i[Symbol.iterator]();
            }, n: function() {
              var Z = u.next();
              return y = Z.done, Z;
            }, e: function(Z) {
              N = !0, I = Z;
            }, f: function() {
              try {
                y || u.return == null || u.return();
              } finally {
                if (N) throw I;
              }
            } };
          }
          function gn(i, r) {
            if (i) {
              if (typeof i == "string") return bn(i, r);
              var u = Object.prototype.toString.call(i).slice(8, -1);
              return u === "Object" && i.constructor && (u = i.constructor.name), u === "Map" || u === "Set" ? Array.from(i) : u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u) ? bn(i, r) : void 0;
            }
          }
          function bn(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function Nn() {
            var i, r, u, _, w = this.context, I = (0, $e.Z)(w).getInstance(), y = Number.isInteger || function(g) {
              return typeof g == "number" && isFinite(g) && Math.floor(g) === g;
            };
            function N(g, x) {
              if (!g) throw new Error("adaptation is not defined");
              if (!x) throw new Error("type is not defined");
              if (g.Representation_asArray && g.Representation_asArray.length) {
                var O = he(g.Representation_asArray[0]);
                if (O && O.length > 0 && Gt.Y.indexOf(O[0].schemeIdUri) >= 0) return x === t.Z.IMAGE;
              }
              if (g.ContentComponent_asArray && g.ContentComponent_asArray.length > 0) {
                if (g.ContentComponent_asArray.length > 1) return x === t.Z.MUXED;
                if (g.ContentComponent_asArray[0].contentType === x) return !0;
              }
              var L = x === t.Z.TEXT ? new RegExp("(ttml|vtt|wvtt|stpp)") : new RegExp(x);
              if (g.Representation_asArray && g.Representation_asArray.length) {
                var A = g.Representation_asArray[0].codecs;
                if (L.test(A)) return !0;
              }
              if (g.hasOwnProperty(e.Z.MIME_TYPE)) return L.test(g.mimeType);
              if (g.Representation_asArray) {
                for (var oe, X = 0; X < g.Representation_asArray.length; X++) if ((oe = g.Representation_asArray[X]).hasOwnProperty(e.Z.MIME_TYPE)) return L.test(oe.mimeType);
              }
              return !1;
            }
            function Z(g) {
              if (!g) throw new Error("adaptation is not defined");
              if (g.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) || g.hasOwnProperty(e.Z.SEGMENT_TIMELINE) || g.hasOwnProperty(e.Z.SEGMENT_LIST) || g.hasOwnProperty(e.Z.SEGMENT_BASE)) return !0;
              if (g.Representation_asArray && g.Representation_asArray.length > 0) {
                var x = g.Representation_asArray[0];
                if (x.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) || x.hasOwnProperty(e.Z.SEGMENT_TIMELINE) || x.hasOwnProperty(e.Z.SEGMENT_LIST) || x.hasOwnProperty(e.Z.SEGMENT_BASE)) return !0;
              }
              return !1;
            }
            function Y(g) {
              return N(g, t.Z.VIDEO);
            }
            function V(g) {
              return N(g, t.Z.TEXT);
            }
            function M(g) {
              return N(g, t.Z.IMAGE);
            }
            function H(g) {
              return g && Array.isArray(g.Representation_asArray) && g.Representation_asArray.sort(function(x, O) {
                return x.bandwidth - O.bandwidth;
              }), g;
            }
            function G(g, x) {
              return g && g.Period_asArray && y(x) && g.Period_asArray[x] ? g.Period_asArray[x].AdaptationSet_asArray : [];
            }
            function pe(g) {
              return g && g.Period_asArray ? g.Period_asArray : [];
            }
            function ae(g) {
              var x = !1;
              return g && g.hasOwnProperty("type") && (x = g.type === e.Z.DYNAMIC), x;
            }
            function he(g) {
              return g && g.EssentialProperty_asArray && g.EssentialProperty_asArray.length ? g.EssentialProperty_asArray.map(function(x) {
                return { schemeIdUri: x.schemeIdUri, value: x.value };
              }) : null;
            }
            function Ee(g) {
              if (!g || !g.S_asArray) return NaN;
              var x = g.S_asArray[0], O = g.S_asArray[1];
              return x.hasOwnProperty("d") ? x.d : O.t - x.t;
            }
            function j(g, x) {
              if (!g) throw new Error("Period cannot be null or undefined");
              var O = Qn.DEFAULT_ID + "_" + x;
              return g.hasOwnProperty(e.Z.ID) && g.id.length > 0 && g.id !== "__proto__" && (O = g.id), O;
            }
            function ue(g, x, O) {
              var L, A = [];
              if (!g) return A;
              for (L = 0; L < g.length; L++) {
                var oe = new ui();
                if (oe.timescale = 1, oe.representation = x, !g[L].hasOwnProperty(t.Z.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                oe.schemeIdUri = g[L].schemeIdUri, g[L].hasOwnProperty(e.Z.TIMESCALE) && (oe.timescale = g[L].timescale), g[L].hasOwnProperty(e.Z.VALUE) && (oe.value = g[L].value), A.push(oe), oe.period = O;
              }
              return A;
            }
            function z(g) {
              var x = [], O = g.BaseURL_asArray || [g.baseUri], L = !1;
              return O.some(function(A) {
                if (A) {
                  var oe = new Nr(), X = A.__text || A;
                  return I.isRelative(X) && (L = !0, g.baseUri && (X = I.resolve(X, g.baseUri))), oe.url = X, A.hasOwnProperty(e.Z.SERVICE_LOCATION) && A.serviceLocation.length ? oe.serviceLocation = A.serviceLocation : oe.serviceLocation = X, A.hasOwnProperty(e.Z.DVB_PRIORITY) && (oe.dvbPriority = A[e.Z.DVB_PRIORITY]), A.hasOwnProperty(e.Z.DVB_WEIGHT) && (oe.dvbWeight = A[e.Z.DVB_WEIGHT]), A.hasOwnProperty(e.Z.AVAILABILITY_TIME_OFFSET) && (oe.availabilityTimeOffset = A[e.Z.AVAILABILITY_TIME_OFFSET]), A.hasOwnProperty(e.Z.AVAILABILITY_TIME_COMPLETE) && (oe.availabilityTimeComplete = A[e.Z.AVAILABILITY_TIME_COMPLETE] !== "false"), x.push(oe), L;
                }
              }), x;
            }
            function me(g) {
              var x = new Ct();
              return x.serverUrl = g.__text, g.hasOwnProperty(e.Z.DEFAULT_SERVICE_LOCATION) && (x.defaultServiceLocation = g[e.Z.DEFAULT_SERVICE_LOCATION], x.defaultServiceLocationArray = x.defaultServiceLocation.split(" ")), g.hasOwnProperty(e.Z.QUERY_BEFORE_START) && (x.queryBeforeStart = g[e.Z.QUERY_BEFORE_START].toLowerCase() === "true"), g.hasOwnProperty(e.Z.CLIENT_REQUIREMENT) && (x.clientRequirement = g[e.Z.CLIENT_REQUIREMENT].toLowerCase() !== "false"), x;
            }
            return i = { getIsTypeOf: N, getIsText: V, getIsFragmented: Z, getProducerReferenceTimesForAdaptation: function(g) {
              var x = g && g.hasOwnProperty(e.Z.PRODUCERREFERENCETIME_ASARRAY) ? g[e.Z.PRODUCERREFERENCETIME_ASARRAY] : [];
              (g && g.hasOwnProperty(e.Z.REPRESENTATION_ASARRAY) ? g[e.Z.REPRESENTATION_ASARRAY] : []).forEach(function(L) {
                var A;
                L.hasOwnProperty(e.Z.PRODUCERREFERENCETIME_ASARRAY) && x.push.apply(x, function(oe) {
                  if (Array.isArray(oe)) return bn(oe);
                }(A = L[e.Z.PRODUCERREFERENCETIME_ASARRAY]) || function(oe) {
                  if (typeof Symbol < "u" && Symbol.iterator in Object(oe)) return Array.from(oe);
                }(A) || gn(A) || function() {
                  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }());
              });
              var O = [];
              return x.forEach(function(L) {
                var A = new Dt();
                L.hasOwnProperty(e.Z.ID) && (A[e.Z.ID] = L[e.Z.ID], L.hasOwnProperty(e.Z.WALL_CLOCK_TIME) && (A[e.Z.WALL_CLOCK_TIME] = L[e.Z.WALL_CLOCK_TIME], L.hasOwnProperty(e.Z.PRESENTATION_TIME) && (A[e.Z.PRESENTATION_TIME] = L[e.Z.PRESENTATION_TIME], L.hasOwnProperty(e.Z.INBAND) && (A[e.Z.INBAND] = L[e.Z.INBAND] !== "false"), L.hasOwnProperty(e.Z.TYPE) && (A[e.Z.TYPE] = L[e.Z.TYPE]), O.push(A))));
              }), O;
            }, getLanguageForAdaptation: function(g) {
              var x = "";
              return g && g.hasOwnProperty(e.Z.LANG) && (x = g.lang), x;
            }, getViewpointForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.VIEWPOINT_ASARRAY) && g[e.Z.VIEWPOINT_ASARRAY].length ? g[e.Z.VIEWPOINT_ASARRAY].map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, getRolesForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ROLE_ASARRAY) && g[e.Z.ROLE_ASARRAY].length ? g[e.Z.ROLE_ASARRAY].map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, getAccessibilityForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ACCESSIBILITY_ASARRAY) && g[e.Z.ACCESSIBILITY_ASARRAY].length ? g[e.Z.ACCESSIBILITY_ASARRAY].map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, getAudioChannelConfigurationForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY) && g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].length ? g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, getAudioChannelConfigurationForRepresentation: function(g) {
              return g && g.hasOwnProperty(e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY) && g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].length ? g[e.Z.AUDIOCHANNELCONFIGURATION_ASARRAY].map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, getAdaptationForIndex: function(g, x, O) {
              var L = G(x, O);
              return L.length > 0 && y(g) ? L[g] : null;
            }, getIndexForAdaptation: function(g, x, O) {
              if (!g) return -1;
              for (var L = G(x, O), A = 0; A < L.length; A++) if (Zt(w).getInstance().areEqual(L[A], g)) return A;
              return -1;
            }, getAdaptationForId: function(g, x, O) {
              var L, A, oe = G(x, O);
              for (L = 0, A = oe.length; L < A; L++) if (oe[L].hasOwnProperty(e.Z.ID) && oe[L].id === g) return oe[L];
              return null;
            }, getAdaptationsForType: function(g, x, O) {
              var L, A, oe = G(g, x), X = [];
              for (L = 0, A = oe.length; L < A; L++) N(oe[L], O) && X.push(H(oe[L]));
              return X;
            }, getRealPeriods: pe, getRealPeriodForIndex: function(g, x) {
              var O = pe(x);
              return O.length > 0 && y(g) ? O[g] : null;
            }, getCodec: function(g, x, O) {
              var L = null;
              if (g && g.Representation_asArray && g.Representation_asArray.length > 0) {
                var A = y(x) && x >= 0 && x < g.Representation_asArray.length ? g.Representation_asArray[x] : g.Representation_asArray[0];
                A && (L = A.mimeType + ';codecs="' + A.codecs + '"', O && A.width !== void 0 && (L += ';width="' + A.width + '";height="' + A.height + '"'));
              }
              return L && (L = L.replace(/\sprofiles=[^;]*/g, "")), L;
            }, getSelectionPriority: function(g) {
              try {
                var x = g && g.selectionPriority !== void 0 ? parseInt(g.selectionPriority) : 1;
                return isNaN(x) ? 1 : x;
              } catch {
                return 1;
              }
            }, getMimeType: function(g) {
              return g && g.Representation_asArray && g.Representation_asArray.length > 0 ? g.Representation_asArray[0].mimeType : null;
            }, getKID: function(g) {
              return g && g.hasOwnProperty(e.Z.CENC_DEFAULT_KID) ? g[e.Z.CENC_DEFAULT_KID] : null;
            }, getLabelsForAdaptation: function(g) {
              if (!g || !Array.isArray(g.Label_asArray)) return [];
              for (var x = [], O = 0; O < g.Label_asArray.length; O++) x.push({ lang: g.Label_asArray[O].lang, text: g.Label_asArray[O].__text || g.Label_asArray[O] });
              return x;
            }, getContentProtectionData: function(g) {
              return g && g.hasOwnProperty(e.Z.CONTENTPROTECTION_ASARRAY) && g.ContentProtection_asArray.length !== 0 ? g.ContentProtection_asArray : null;
            }, getIsDynamic: ae, getId: function(g) {
              return g && g[e.Z.ID] || null;
            }, hasProfile: function(g, x) {
              var O = !1;
              return g && g.profiles && g.profiles.length > 0 && (O = g.profiles.indexOf(x) !== -1), O;
            }, getDuration: function(g) {
              return g && g.hasOwnProperty(e.Z.MEDIA_PRESENTATION_DURATION) ? g.mediaPresentationDuration : g && g.type == "dynamic" ? Number.POSITIVE_INFINITY : Number.MAX_SAFE_INTEGER || Number.MAX_VALUE;
            }, getBandwidth: function(g) {
              return g && g.bandwidth ? g.bandwidth : NaN;
            }, getManifestUpdatePeriod: function(g) {
              var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, O = NaN;
              return g && g.hasOwnProperty(e.Z.MINIMUM_UPDATE_PERIOD) && (O = g.minimumUpdatePeriod), isNaN(O) ? O : Math.max(O - x, 1);
            }, getPublishTime: function(g) {
              return g && g.hasOwnProperty(e.Z.PUBLISH_TIME) ? new Date(g[e.Z.PUBLISH_TIME]) : null;
            }, getRepresentationCount: function(g) {
              return g && Array.isArray(g.Representation_asArray) ? g.Representation_asArray.length : 0;
            }, getBitrateListForAdaptation: function(g) {
              var x = H(g);
              return (x && Array.isArray(x.Representation_asArray) ? x.Representation_asArray : []).map(function(O) {
                return { bandwidth: O.bandwidth, width: O.width || 0, height: O.height || 0, scanType: O.scanType || null, id: O.id || null };
              });
            }, getRepresentationFor: function(g, x) {
              return x && x.Representation_asArray && x.Representation_asArray.length > 0 && y(g) ? x.Representation_asArray[g] : null;
            }, getRepresentationsForAdaptation: function(g) {
              var x, O, L, A, oe = [], X = function(De) {
                if (De && De.period && y(De.period.index)) {
                  var ke = De.period.mpd.manifest.Period_asArray[De.period.index];
                  if (ke && ke.AdaptationSet_asArray && y(De.index)) return H(ke.AdaptationSet_asArray[De.index]);
                }
              }(g);
              if (X && X.Representation_asArray) {
                if (g && g.period && y(g.period.index)) {
                  var de = z(g.period.mpd.manifest);
                  de && (O = de[0]);
                }
                for (var ne = 0, U = X.Representation_asArray.length; ne < U; ++ne) {
                  var re = X.Representation_asArray[ne], Te = new rr();
                  if (Te.index = ne, Te.adaptation = g, re.hasOwnProperty(e.Z.ID) && (Te.id = re.id), re.hasOwnProperty(e.Z.CODECS) && (Te.codecs = re.codecs), re.hasOwnProperty(e.Z.MIME_TYPE) && (Te.mimeType = re[e.Z.MIME_TYPE]), re.hasOwnProperty(e.Z.CODEC_PRIVATE_DATA) && (Te.codecPrivateData = re.codecPrivateData), re.hasOwnProperty(e.Z.BANDWITH) && (Te.bandwidth = re.bandwidth), re.hasOwnProperty(e.Z.WIDTH) && (Te.width = re.width), re.hasOwnProperty(e.Z.HEIGHT) && (Te.height = re.height), re.hasOwnProperty(e.Z.SCAN_TYPE) && (Te.scanType = re.scanType), re.hasOwnProperty(e.Z.MAX_PLAYOUT_RATE) && (Te.maxPlayoutRate = re.maxPlayoutRate), re.hasOwnProperty(e.Z.SEGMENT_BASE) ? (x = re.SegmentBase, Te.segmentInfoType = e.Z.SEGMENT_BASE) : re.hasOwnProperty(e.Z.SEGMENT_LIST) ? (x = re.SegmentList).hasOwnProperty(e.Z.SEGMENT_TIMELINE) ? Te.segmentInfoType = e.Z.SEGMENT_TIMELINE : Te.segmentInfoType = e.Z.SEGMENT_LIST : re.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) ? ((x = re.SegmentTemplate).hasOwnProperty(e.Z.SEGMENT_TIMELINE) ? Te.segmentInfoType = e.Z.SEGMENT_TIMELINE : Te.segmentInfoType = e.Z.SEGMENT_TEMPLATE, x.hasOwnProperty(e.Z.INITIALIZATION_MINUS) && (Te.initialization = x.initialization.split("$Bandwidth$").join(re.bandwidth).split("$RepresentationID$").join(re.id))) : Te.segmentInfoType = e.Z.BASE_URL, Te.essentialProperties = he(re), x) {
                    if (x.hasOwnProperty(e.Z.INITIALIZATION)) {
                      var Fe = x.Initialization;
                      Fe.hasOwnProperty(e.Z.SOURCE_URL) && (Te.initialization = Fe.sourceURL), Fe.hasOwnProperty(e.Z.RANGE) && (Te.range = Fe.range);
                    } else V(X) && Z(X) && X.mimeType && X.mimeType.indexOf("application/mp4") === -1 && (Te.range = 0);
                    x.hasOwnProperty(e.Z.TIMESCALE) && (Te.timescale = x.timescale), x.hasOwnProperty(e.Z.DURATION) ? Te.segmentDuration = x.duration / Te.timescale : re.hasOwnProperty(e.Z.SEGMENT_TEMPLATE) && (x = re.SegmentTemplate).hasOwnProperty(e.Z.SEGMENT_TIMELINE) && (Te.segmentDuration = Ee(x.SegmentTimeline) / Te.timescale), x.hasOwnProperty(e.Z.MEDIA) && (Te.media = x.media), x.hasOwnProperty(e.Z.START_NUMBER) && (Te.startNumber = x.startNumber), x.hasOwnProperty(e.Z.INDEX_RANGE) && (Te.indexRange = x.indexRange), x.hasOwnProperty(e.Z.PRESENTATION_TIME_OFFSET) && (Te.presentationTimeOffset = x.presentationTimeOffset / Te.timescale), x.hasOwnProperty(e.Z.AVAILABILITY_TIME_OFFSET) ? Te.availabilityTimeOffset = x.availabilityTimeOffset : O && O.availabilityTimeOffset !== void 0 && (Te.availabilityTimeOffset = O.availabilityTimeOffset), x.hasOwnProperty(e.Z.AVAILABILITY_TIME_COMPLETE) ? Te.availabilityTimeComplete = x.availabilityTimeComplete !== "false" : O && O.availabilityTimeComplete !== void 0 && (Te.availabilityTimeComplete = O.availabilityTimeComplete);
                  }
                  Te.MSETimeOffset = (A = (L = Te).presentationTimeOffset, L.adaptation.period.start - A), Te.path = [g.period.index, g.index, ne], oe.push(Te);
                }
              }
              return oe;
            }, getAdaptationsForPeriod: function(g) {
              var x, O, L, A = g && y(g.index) ? g.mpd.manifest.Period_asArray[g.index] : null, oe = [];
              if (A && A.AdaptationSet_asArray) for (L = 0; L < A.AdaptationSet_asArray.length; L++) O = A.AdaptationSet_asArray[L], x = new wn(), O.hasOwnProperty(e.Z.ID) && (x.id = O.id), x.index = L, x.period = g, N(O, t.Z.MUXED) ? x.type = t.Z.MUXED : N(O, t.Z.AUDIO) ? x.type = t.Z.AUDIO : Y(O) ? x.type = t.Z.VIDEO : V(O) ? x.type = t.Z.TEXT : M(O) ? x.type = t.Z.IMAGE : r.warn("Unknown Adaptation stream type"), oe.push(x);
              return oe;
            }, getRegularPeriods: function(g) {
              var x, O, L = !!g && ae(g.manifest), A = [], oe = null, X = null, de = null, ne = null;
              for (O = 0, x = g && g.manifest && g.manifest.Period_asArray ? g.manifest.Period_asArray.length : 0; O < x; O++) (X = g.manifest.Period_asArray[O]).hasOwnProperty(e.Z.START) ? (ne = new Qn()).start = X.start : oe !== null && oe.hasOwnProperty(e.Z.DURATION) && de !== null ? (ne = new Qn()).start = parseFloat((de.start + de.duration).toFixed(5)) : O !== 0 || L || ((ne = new Qn()).start = 0), de !== null && isNaN(de.duration) && (ne !== null ? de.duration = parseFloat((ne.start - de.start).toFixed(5)) : r.warn("First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback")), ne !== null && (ne.id = j(X, O), ne.index = O, ne.mpd = g, X.hasOwnProperty(e.Z.DURATION) && (ne.duration = X.duration), de && (de.nextPeriodId = ne.id), A.push(ne), oe = X, de = ne), X = null, ne = null;
              return A.length === 0 || de !== null && isNaN(de.duration) && (de.duration = parseFloat((function(U) {
                (function() {
                  if (!u || !u.hasOwnProperty("error")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
                })();
                var re, Te = ae(U.mpd.manifest);
                return U.mpd.manifest.mediaPresentationDuration ? re = U.mpd.manifest.mediaPresentationDuration : U.duration ? re = U.duration : Te ? re = Number.POSITIVE_INFINITY : u.error(new se.Z(ee.MANIFEST_ERROR_ID_PARSE_CODE, "Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.", U)), re;
              }(de) - de.start).toFixed(5))), A;
            }, getMpd: function(g) {
              var x = new cr();
              return g && (x.manifest = g, g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME) ? x.availabilityStartTime = new Date(g.availabilityStartTime.getTime()) : g.loadedTime && (x.availabilityStartTime = new Date(g.loadedTime.getTime())), g.hasOwnProperty(e.Z.AVAILABILITY_END_TIME) && (x.availabilityEndTime = new Date(g.availabilityEndTime.getTime())), g.hasOwnProperty(e.Z.MINIMUM_UPDATE_PERIOD) && (x.minimumUpdatePeriod = g.minimumUpdatePeriod), g.hasOwnProperty(e.Z.MEDIA_PRESENTATION_DURATION) && (x.mediaPresentationDuration = g.mediaPresentationDuration), g.hasOwnProperty(e.Z.SUGGESTED_PRESENTATION_DELAY) && (x.suggestedPresentationDelay = g.suggestedPresentationDelay), g.hasOwnProperty(e.Z.TIMESHIFT_BUFFER_DEPTH) && (x.timeShiftBufferDepth = g.timeShiftBufferDepth), g.hasOwnProperty(e.Z.MAX_SEGMENT_DURATION) && (x.maxSegmentDuration = g.maxSegmentDuration), g.hasOwnProperty(e.Z.PUBLISH_TIME) && (x.publishTime = new Date(g.publishTime))), x;
            }, getEventsForPeriod: function(g) {
              var x, O, L = g && g.mpd && g.mpd.manifest ? g.mpd.manifest : null, A = L ? L.Period_asArray : null, oe = A && g && y(g.index) ? A[g.index].EventStream_asArray : null, X = [];
              if (oe) for (x = 0; x < oe.length; x++) {
                var de = new ui();
                if (de.period = g, de.timescale = 1, !oe[x].hasOwnProperty(t.Z.SCHEME_ID_URI)) throw new Error("Invalid EventStream. SchemeIdUri has to be set");
                for (de.schemeIdUri = oe[x][t.Z.SCHEME_ID_URI], oe[x].hasOwnProperty(e.Z.TIMESCALE) && (de.timescale = oe[x][e.Z.TIMESCALE]), oe[x].hasOwnProperty(e.Z.VALUE) && (de.value = oe[x][e.Z.VALUE]), oe[x].hasOwnProperty(e.Z.PRESENTATION_TIME_OFFSET) && (de.presentationTimeOffset = oe[x][e.Z.PRESENTATION_TIME_OFFSET]), O = 0; oe[x].Event_asArray && O < oe[x].Event_asArray.length; O++) {
                  var ne = oe[x].Event_asArray[O], U = new fr();
                  U.presentationTime = 0, U.eventStream = de, ne.hasOwnProperty(e.Z.PRESENTATION_TIME) && (U.presentationTime = ne.presentationTime);
                  var re = de.presentationTimeOffset ? de.presentationTimeOffset / de.timescale : 0;
                  U.calculatedPresentationTime = U.presentationTime / de.timescale + g.start - re, ne.hasOwnProperty(e.Z.DURATION) && (U.duration = ne.duration / de.timescale), ne.hasOwnProperty(e.Z.ID) ? U.id = ne.id : U.id = null, ne.Signal && ne.Signal.Binary ? U.messageData = _.decodeArray(ne.Signal.Binary.toString()) : U.messageData = ne.messageData || ne.__cdata || ne.__text, X.push(U);
                }
              }
              return X;
            }, getEssentialPropertiesForAdaptation: function(g) {
              var x = {};
              if (g && g.hasOwnProperty(e.Z.ESSENTIAL_PROPERTY_ASARRAY)) {
                var O, L = Jt(g.EssentialProperty_asArray);
                try {
                  for (L.s(); !(O = L.n()).done; ) {
                    var A = O.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (x[A[t.Z.SCHEME_ID_URI]] = It({}, A));
                  }
                } catch (oe) {
                  L.e(oe);
                } finally {
                  L.f();
                }
              }
              return x;
            }, getEssentialPropertiesAsArrayForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.ESSENTIAL_PROPERTY_ASARRAY) && g.EssentialProperty_asArray.length ? g.EssentialProperty_asArray.map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, getEssentialPropertiesForRepresentation: he, getEventStreamForAdaptationSet: function(g, x, O) {
              var L, A, oe;
              return g && g.Period_asArray && x && x.period && y(x.period.index) && (A = g.Period_asArray[x.period.index]) && A.AdaptationSet_asArray && y(x.index) && (oe = A.AdaptationSet_asArray[x.index]) && (L = oe.InbandEventStream_asArray), ue(L, null, O);
            }, getEventStreamForRepresentation: function(g, x, O) {
              var L, A, oe, X;
              return g && g.Period_asArray && x && x.adaptation && x.adaptation.period && y(x.adaptation.period.index) && (A = g.Period_asArray[x.adaptation.period.index]) && A.AdaptationSet_asArray && y(x.adaptation.index) && (oe = A.AdaptationSet_asArray[x.adaptation.index]) && oe.Representation_asArray && y(x.index) && (X = oe.Representation_asArray[x.index]) && (L = X.InbandEventStream_asArray), ue(L, x, O);
            }, getUTCTimingSources: function(g) {
              var x = ae(g), O = !!g && g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME), L = g ? g.UTCTiming_asArray : null, A = [];
              return (x || O) && L && L.forEach(function(oe) {
                var X = new Tr.Z();
                oe.hasOwnProperty(t.Z.SCHEME_ID_URI) && (X.schemeIdUri = oe.schemeIdUri, oe.hasOwnProperty(e.Z.VALUE) && (X.value = oe.value.toString(), A.push(X)));
              }), A;
            }, getBaseURLsFromElement: z, getRepresentationSortFunction: function() {
              return function(g, x) {
                return g.bandwidth - x.bandwidth;
              };
            }, getContentSteering: function(g) {
              if (g && g.hasOwnProperty(e.Z.CONTENT_STEERING_AS_ARRAY)) return me(g[e.Z.CONTENT_STEERING_AS_ARRAY][0]);
            }, getLocation: function(g) {
              return g && g.hasOwnProperty(e.Z.LOCATION_AS_ARRAY) ? g[e.Z.LOCATION_AS_ARRAY].map(function(x) {
                var O = x.__text || x, L = x.hasOwnProperty(e.Z.SERVICE_LOCATION) ? x[e.Z.SERVICE_LOCATION] : null;
                return new an(O, L);
              }) : [];
            }, getPatchLocation: function(g) {
              return g && g.hasOwnProperty(e.Z.PATCH_LOCATION_AS_ARRAY) ? g[e.Z.PATCH_LOCATION_AS_ARRAY].map(function(x) {
                var O = x.__text || x, L = x.hasOwnProperty(e.Z.SERVICE_LOCATION) ? x[e.Z.SERVICE_LOCATION] : null, A = x.hasOwnProperty(e.Z.TTL) ? 1e3 * parseFloat(x[e.Z.TTL]) : NaN;
                return new on(O, L, A);
              }) : [];
            }, getSuggestedPresentationDelay: function(g) {
              return g && g.hasOwnProperty(e.Z.SUGGESTED_PRESENTATION_DELAY) ? g.suggestedPresentationDelay : null;
            }, getAvailabilityStartTime: function(g) {
              return g && g.hasOwnProperty(e.Z.AVAILABILITY_START_TIME) && g.availabilityStartTime !== null ? g.availabilityStartTime.getTime() : null;
            }, getServiceDescriptions: function(g) {
              var x = [];
              if (g && g.hasOwnProperty(e.Z.SERVICE_DESCRIPTION)) {
                var O, L = Jt(g.ServiceDescription_asArray);
                try {
                  for (L.s(); !(O = L.n()).done; ) {
                    var A = O.value, oe = null, X = null, de = null, ne = null, U = null, re = null, Te = null;
                    for (var Fe in A) A.hasOwnProperty(Fe) && (Fe === e.Z.ID ? oe = A[Fe] : Fe === e.Z.SERVICE_DESCRIPTION_SCOPE ? X = A[Fe].schemeIdUri : Fe === e.Z.SERVICE_DESCRIPTION_LATENCY ? de = { target: parseInt(A[Fe].target), max: parseInt(A[Fe].max), min: parseInt(A[Fe].min), referenceId: parseInt(A[Fe].referenceId) } : Fe === e.Z.SERVICE_DESCRIPTION_PLAYBACK_RATE ? ne = { max: parseFloat(A[Fe].max), min: parseFloat(A[Fe].min) } : Fe === e.Z.SERVICE_DESCRIPTION_OPERATING_QUALITY ? U = { mediaType: A[Fe].mediaType, max: parseInt(A[Fe].max), min: parseInt(A[Fe].min), target: parseInt(A[Fe].target), type: A[Fe].type, maxQualityDifference: parseInt(A[Fe].maxQualityDifference) } : Fe === e.Z.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH ? re = { mediaType: A[Fe].mediaType, max: parseInt(A[Fe].max), min: parseInt(A[Fe].min), target: parseInt(A[Fe].target) } : Fe === e.Z.CONTENT_STEERING && (Te = me(A[Fe])));
                    x.push({ id: oe, schemeIdUri: X, latency: de, playbackRate: ne, operatingQuality: U, operatingBandwidth: re, contentSteering: Te });
                  }
                } catch (De) {
                  L.e(De);
                } finally {
                  L.f();
                }
              }
              return x;
            }, getSegmentAlignment: function(g) {
              return !(!g || !g.hasOwnProperty(e.Z.SEGMENT_ALIGNMENT)) && g[e.Z.SEGMENT_ALIGNMENT] === "true";
            }, getSubSegmentAlignment: function(g) {
              return !(!g || !g.hasOwnProperty(e.Z.SUB_SEGMENT_ALIGNMENT)) && g[e.Z.SUB_SEGMENT_ALIGNMENT] === "true";
            }, getSupplementalPropertiesForAdaptation: function(g) {
              var x = {};
              if (g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY)) {
                var O, L = Jt(g.SupplementalProperty_asArray);
                try {
                  for (L.s(); !(O = L.n()).done; ) {
                    var A = O.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (x[A[t.Z.SCHEME_ID_URI]] = It({}, A));
                  }
                } catch (oe) {
                  L.e(oe);
                } finally {
                  L.f();
                }
              }
              return x;
            }, getSupplementalPropertiesAsArrayForAdaptation: function(g) {
              return g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY) && g.SupplementalProperty_asArray.length ? g.SupplementalProperty_asArray.map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, getSupplementalPropertiesForRepresentation: function(g) {
              var x = {};
              if (g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY)) {
                var O, L = Jt(g.SupplementalProperty_asArray);
                try {
                  for (L.s(); !(O = L.n()).done; ) {
                    var A = O.value;
                    A.hasOwnProperty(t.Z.SCHEME_ID_URI) && (x[A[t.Z.SCHEME_ID_URI]] = It({}, A));
                  }
                } catch (oe) {
                  L.e(oe);
                } finally {
                  L.f();
                }
              }
              return x;
            }, getSupplementalPropertiesAsArrayForRepresentation: function(g) {
              return g && g.hasOwnProperty(e.Z.SUPPLEMENTAL_PROPERTY_ASARRAY) && g.SupplementalProperty_asArray.length ? g.SupplementalProperty_asArray.map(function(x) {
                return new Ke().init(x);
              }) : [];
            }, setConfig: function(g) {
              g && (g.errHandler && (u = g.errHandler), g.BASE64 && (_ = g.BASE64));
            } }, r = (0, m.Z)(w).getInstance().getLogger(i), i;
          }
          Nn.__dashjs_factory_name = "DashManifestModel";
          var un = v.Z.getSingletonFactory(Nn), St = R(703);
          function Mt(i, r) {
            var u;
            if (typeof Symbol > "u" || i[Symbol.iterator] == null) {
              if (Array.isArray(i) || (u = function(Z, Y) {
                if (Z) {
                  if (typeof Z == "string") return jt(Z, Y);
                  var V = Object.prototype.toString.call(Z).slice(8, -1);
                  return V === "Object" && Z.constructor && (V = Z.constructor.name), V === "Map" || V === "Set" ? Array.from(Z) : V === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(V) ? jt(Z, Y) : void 0;
                }
              }(i)) || r) {
                u && (i = u);
                var _ = 0, w = function() {
                };
                return { s: w, n: function() {
                  return _ >= i.length ? { done: !0 } : { done: !1, value: i[_++] };
                }, e: function(Z) {
                  throw Z;
                }, f: w };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var I, y = !0, N = !1;
            return { s: function() {
              u = i[Symbol.iterator]();
            }, n: function() {
              var Z = u.next();
              return y = Z.done, Z;
            }, e: function(Z) {
              N = !0, I = Z;
            }, f: function() {
              try {
                y || u.return == null || u.return();
              } finally {
                if (N) throw I;
              }
            } };
          }
          function jt(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function dn() {
            var i, r, u, _, w, I, y, N, Z, Y, V = this.context, M = (0, p.Z)(V).getInstance(), H = (0, Oe.Z)(V).getInstance();
            function G() {
              u = { pr: 1, nor: null, st: null, sf: null, sid: "".concat(St.Z.generateUuid()), cid: null }, Z = {}, N = {}, Y = {}, ae();
            }
            function pe() {
              ae();
            }
            function ae() {
              if (I) {
                var A = I.getStreamController();
                if (A && typeof A.getActiveStream == "function") {
                  var oe = A.getActiveStream();
                  oe && (y = oe.getProcessors());
                }
              }
            }
            function he(A, oe) {
              var X, de = {}, ne = Mt(oe);
              try {
                for (ne.s(); !(X = ne.n()).done; ) {
                  var U = X.value;
                  A[U] && (de[U] = A[U]);
                }
              } catch (re) {
                ne.e(re);
              } finally {
                ne.f();
              }
              return de;
            }
            function Ee(A) {
              var oe = H.get().streaming.cmcd.enabledKeys;
              return A.filter(function(X) {
                return oe.includes(X);
              });
            }
            function j(A) {
              try {
                return A.type === Ge.w.MPD_TYPE ? ((X = ue()).ot = "m", X) : A.type === Ge.w.MEDIA_SEGMENT_TYPE ? (oe = A.mediaType, Y.hasOwnProperty(oe) || (Y[oe] = !1), N.hasOwnProperty(oe) || (N[oe] = !1), Z.hasOwnProperty(oe) || (Z[oe] = !1), function(de) {
                  var ne, U = ue(), re = function(at) {
                    try {
                      var Bt = at.quality, Re = at.mediaInfo.bitrateList;
                      return parseInt(Re[Bt].bandwidth / 1e3);
                    } catch {
                      return null;
                    }
                  }(de), Te = function(at) {
                    try {
                      return isNaN(at.duration) ? NaN : Math.round(1e3 * at.duration);
                    } catch {
                      return null;
                    }
                  }(de), Fe = function(at) {
                    try {
                      return 100 * parseInt(_.getThroughputHistory().getSafeAverageThroughput(at) / 100);
                    } catch {
                      return null;
                    }
                  }(de.mediaType), De = function(at) {
                    try {
                      var Bt = u.pr, Re = w.getCurrentBufferLevel(at);
                      return isNaN(Bt) || isNaN(Re) ? null : 100 * parseInt(Re / Bt * 10);
                    } catch {
                      return null;
                    }
                  }(de.mediaType), ke = z(de.mediaType), Le = function(at) {
                    try {
                      var Bt = _.getTopBitrateInfoFor(at);
                      return Math.round(Bt.bitrate / 1e3);
                    } catch {
                      return null;
                    }
                  }(de.mediaType), ut = u.pr, ct = function(at) {
                    if (y && y.length !== 0) {
                      var Bt, Re = Mt(y);
                      try {
                        for (Re.s(); !(Bt = Re.n()).done; ) {
                          var He = Bt.value;
                          if (He.getType() === at) return He.probeNextRequest();
                        }
                      } catch (yt) {
                        Re.e(yt);
                      } finally {
                        Re.f();
                      }
                    }
                  }(de.mediaType);
                  de.mediaType === t.Z.VIDEO && (ne = "v"), de.mediaType === t.Z.AUDIO && (ne = "a"), de.mediaType === t.Z.TEXT && (ne = de.mediaInfo.mimeType === "application/mp4" ? "tt" : "c");
                  var rt = H.get().streaming.cmcd.rtp;
                  return rt || (rt = function(at) {
                    try {
                      var Bt = I.getPlaybackRate();
                      Bt || (Bt = 1);
                      var Re = at.quality, He = at.mediaType, yt = at.mediaInfo, Qe = at.duration;
                      if (!yt) return NaN;
                      var Tt = z(He);
                      Tt === 0 && (Tt = 500);
                      var vt = yt.bitrateList[Re].bandwidth * Qe / 1e3 / (Tt / Bt / 1e3), mt = H.get().streaming.cmcd.rtpSafetyFactor && !isNaN(H.get().streaming.cmcd.rtpSafetyFactor) ? H.get().streaming.cmcd.rtpSafetyFactor : 5;
                      return 100 * (parseInt(vt * mt / 100) + 1);
                    } catch {
                      return NaN;
                    }
                  }(de)), isNaN(rt) || (U.rtp = rt), ct && (de.url !== ct.url ? U.nor = encodeURIComponent(St.Z.getRelativeUrl(de.url, ct.url)) : ct.range && (U.nrr = ct.range)), re && (U.br = re), ne && (U.ot = ne), isNaN(Te) || (U.d = Te), isNaN(Fe) || (U.mtp = Fe), isNaN(De) || (U.dl = De), isNaN(ke) || (U.bl = ke), isNaN(Le) || (U.tb = Le), isNaN(ut) || ut === 1 || (U.pr = ut), Z[de.mediaType] && (U.bs = !0, Z[de.mediaType] = !1), !N[de.mediaType] && Y[de.mediaType] || (U.su = !0, N[de.mediaType] = !1, Y[de.mediaType] = !0), U;
                }(A)) : A.type === Ge.w.INIT_SEGMENT_TYPE ? function() {
                  var de = ue();
                  return de.ot = "i", de.su = !0, de;
                }() : A.type === Ge.w.OTHER_TYPE || A.type === Ge.w.XLINK_EXPANSION_TYPE ? function() {
                  var de = ue();
                  return de.ot = "o", de;
                }() : A.type === Ge.w.LICENSE ? function(de) {
                  var ne = ue();
                  return ne.ot = "k", ne;
                }() : null;
              } catch {
                return null;
              }
              var oe, X;
            }
            function ue() {
              var A = {}, oe = H.get().streaming.cmcd.cid ? H.get().streaming.cmcd.cid : u.cid;
              return A.v = 1, A.sid = H.get().streaming.cmcd.sid ? H.get().streaming.cmcd.sid : u.sid, A.sid = "".concat(A.sid), oe && (A.cid = "".concat(oe)), isNaN(u.pr) || u.pr === 1 || u.pr === null || (A.pr = u.pr), u.st && (A.st = u.st), u.sf && (A.sf = u.sf), A;
            }
            function z(A) {
              try {
                var oe = w.getCurrentBufferLevel(A);
                return isNaN(oe) ? null : 100 * parseInt(10 * oe);
              } catch {
                return null;
              }
            }
            function me(A) {
              try {
                u.pr = A.playbackRate;
              } catch {
              }
            }
            function g(A) {
              try {
                var oe = i.getIsDynamic(A.data) ? "l" : "v", X = A.protocol && A.protocol === "MSS" ? "s" : "d";
                u.st = "".concat(oe), u.sf = "".concat(X);
              } catch {
              }
            }
            function x(A) {
              try {
                A.state && A.mediaType && A.state === n.Z.BUFFER_EMPTY && (Z[A.mediaType] || (Z[A.mediaType] = !0), N[A.mediaType] || (N[A.mediaType] = !0));
              } catch {
              }
            }
            function O() {
              for (var A in Z) Z.hasOwnProperty(A) && (Z[A] = !0);
              for (var oe in N) N.hasOwnProperty(oe) && (N[oe] = !0);
            }
            function L(A) {
              try {
                if (!A) return null;
                var oe = Object.keys(A).sort(function(ne, U) {
                  return ne.localeCompare(U);
                }), X = oe.length, de = oe.reduce(function(ne, U, re) {
                  return U === "v" && A[U] === 1 || (typeof A[U] == "string" && U !== "ot" && U !== "sf" && U !== "st" ? ne += "".concat(U, "=").concat(JSON.stringify(A[U])) : ne += "".concat(U, "=").concat(A[U]), re < X - 1 && (ne += ",")), ne;
                }, "");
                return (de = de.replace(/=true/g, "")).replace(/,\s*$/, "");
              } catch {
                return null;
              }
            }
            return r = { getQueryParameter: function(A) {
              try {
                if (H.get().streaming.cmcd && H.get().streaming.cmcd.enabled) {
                  var oe = j(A), X = function(ne) {
                    try {
                      var U = H.get().streaming.cmcd.enabledKeys;
                      return Object.keys(ne).filter(function(re) {
                        return U.includes(re);
                      }).reduce(function(re, Te) {
                        return re[Te] = ne[Te], re;
                      }, {});
                    } catch {
                      return ne;
                    }
                  }(oe), de = L(X);
                  return M.trigger(On.Z.CMCD_DATA_GENERATED, { url: A.url, mediaType: A.mediaType, cmcdData: oe, cmcdString: de }), { key: "CMCD", value: de };
                }
                return null;
              } catch {
                return null;
              }
            }, getHeaderParameters: function(A) {
              try {
                if (H.get().streaming.cmcd && H.get().streaming.cmcd.enabled) {
                  var oe = j(A), X = he(oe, Ee(["br", "d", "ot", "tb"])), de = he(oe, Ee(["bl", "dl", "mtp", "nor", "nrr", "su"])), ne = he(oe, Ee(["bs", "rtp"])), U = he(oe, Ee(["cid", "pr", "sf", "sid", "st", "v"])), re = { "CMCD-Object": L(X), "CMCD-Request": L(de), "CMCD-Status": L(ne), "CMCD-Session": L(U) };
                  return M.trigger(On.Z.CMCD_DATA_GENERATED, { url: A.url, mediaType: A.mediaType, cmcdData: oe, headers: re }), re;
                }
                return null;
              } catch {
                return null;
              }
            }, setConfig: function(A) {
              A && (A.abrController && (_ = A.abrController), A.dashMetrics && (w = A.dashMetrics), A.playbackController && (I = A.playbackController));
            }, reset: function() {
              M.off(n.Z.PLAYBACK_RATE_CHANGED, me, this), M.off(n.Z.MANIFEST_LOADED, g, this), M.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, x, r), M.off(n.Z.PLAYBACK_SEEKED, O, r), G();
            }, initialize: function() {
              M.on(n.Z.PLAYBACK_RATE_CHANGED, me, r), M.on(n.Z.MANIFEST_LOADED, g, r), M.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, x, r), M.on(n.Z.PLAYBACK_SEEKED, O, r), M.on(n.Z.PERIOD_SWITCH_COMPLETED, pe, r);
            } }, i = un(V).getInstance(), G(), r;
          }
          dn.__dashjs_factory_name = "CmcdModel";
          var pn = v.Z.getSingletonFactory(dn);
          function Cn(i) {
            return Cn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Cn(i);
          }
          function Rn(i, r) {
            Rn = function(N, Z) {
              return new I(N, void 0, Z);
            };
            var u = or(RegExp), _ = RegExp.prototype, w = /* @__PURE__ */ new WeakMap();
            function I(N, Z, Y) {
              var V = u.call(this, N, Z);
              return w.set(V, Y || w.get(N)), V;
            }
            function y(N, Z) {
              var Y = w.get(Z);
              return Object.keys(Y).reduce(function(V, M) {
                return V[M] = N[Y[M]], V;
              }, /* @__PURE__ */ Object.create(null));
            }
            return ar(I, u), I.prototype.exec = function(N) {
              var Z = _.exec.call(this, N);
              return Z && (Z.groups = y(Z, this)), Z;
            }, I.prototype[Symbol.replace] = function(N, Z) {
              if (typeof Z == "string") {
                var Y = w.get(this);
                return _[Symbol.replace].call(this, N, Z.replace(/\$<([^>]+)>/g, function(M, H) {
                  return "$" + Y[H];
                }));
              }
              if (typeof Z == "function") {
                var V = this;
                return _[Symbol.replace].call(this, N, function() {
                  var M = [];
                  return M.push.apply(M, arguments), Cn(M[M.length - 1]) !== "object" && M.push(y(M, V)), Z.apply(this, M);
                });
              }
              return _[Symbol.replace].call(this, N, Z);
            }, Rn.apply(this, arguments);
          }
          function ar(i, r) {
            if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
            i.prototype = Object.create(r && r.prototype, { constructor: { value: i, writable: !0, configurable: !0 } }), r && Yn(i, r);
          }
          function or(i) {
            var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
            return or = function(u) {
              if (u === null || (_ = u, Function.toString.call(_).indexOf("[native code]") === -1)) return u;
              var _;
              if (typeof u != "function") throw new TypeError("Super expression must either be null or a function");
              if (r !== void 0) {
                if (r.has(u)) return r.get(u);
                r.set(u, w);
              }
              function w() {
                return Gn(u, arguments, sr(this).constructor);
              }
              return w.prototype = Object.create(u.prototype, { constructor: { value: w, enumerable: !1, writable: !0, configurable: !0 } }), Yn(w, u);
            }, or(i);
          }
          function Gn(i, r, u) {
            return Gn = er() ? Reflect.construct : function(_, w, I) {
              var y = [null];
              y.push.apply(y, w);
              var N = new (Function.bind.apply(_, y))();
              return I && Yn(N, I.prototype), N;
            }, Gn.apply(null, arguments);
          }
          function er() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }
          function Yn(i, r) {
            return Yn = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Yn(i, r);
          }
          function sr(i) {
            return sr = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, sr(i);
          }
          var qr = "static", Dr = "dynamic", Pr = "cmsd-", gr = Pr + qr, ki = Pr + Dr, ci = "stream", Zi = ["mb", "st", "sf", "v"], Bi = { video: "v", audio: "a", text: "tt", stream: ci }, Ui = /^[-0-9]/;
          function fi() {
            var i, r, u, _, w = this.context, I = (0, p.Z)(w).getInstance();
            function y() {
              u = {}, _ = {};
            }
            function N(G) {
              G && Object.keys(G).forEach(function(pe) {
                Zi.includes(pe) || delete G[pe];
              });
            }
            function Z(G) {
              return !G || G.toLowerCase() !== "false" && (Ui.test(G) ? parseInt(G, 10) : G.replace(/["]+/g, ""));
            }
            function Y(G) {
              try {
                for (var pe = {}, ae = G.split(","), he = 0; he < ae.length; he++) {
                  var Ee = ae[he].split("="), j = Ee[0], ue = Z(Ee[1]);
                  pe[j] = ue;
                }
                return pe;
              } catch (z) {
                r.error("Failed to parse CMSD-Static response header value:", z);
              }
            }
            function V(G) {
              try {
                for (var pe = {}, ae = G.split(","), he = ae[ae.length - 1].split(";"), Ee = 1; Ee < he.length; Ee++) {
                  var j = he[Ee].split("="), ue = j[0], z = Z(j[1]);
                  pe[ue] = z;
                }
                return pe;
              } catch (me) {
                return r.error("Failed to parse CMSD-Dynamic response header value:", me), [];
              }
            }
            function M(G) {
              return Bi[G] || "o";
            }
            function H(G, pe, ae) {
              var he = G === qr ? u : _, Ee = he[pe] || {}, j = he[ci] || {};
              return Ee[ae] || j[ae];
            }
            return i = { setConfig: function() {
            }, initialize: function() {
            }, reset: function() {
              y();
            }, parseResponseHeaders: function(G, pe) {
              for (var ae = null, he = null, Ee = G.split(`\r
`), j = Ee.length - 1; j >= 0; j--) {
                var ue = Ee[j].match(Rn(/^((?:(?!:)[\s\S])*):[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(.*)$/, { key: 1, value: 2 }));
                if (ue && ue.groups) {
                  var z = ue.groups.key.toLowerCase(), me = ue.groups.value;
                  switch (z) {
                    case gr:
                      ae = Y(me), I.trigger(o.Z.CMSD_STATIC_HEADER, ae);
                      break;
                    case ki:
                      he || (he = V(me));
                  }
                }
              }
              var g = ci;
              return ae && ae.ot ? g = ae.ot : pe && (g = M(pe)), N(u[g]), N(_[g]), ae && (u[g] = Object.assign(u[g] || {}, ae)), he && (_[g] = Object.assign(_[g] || {}, he)), { static: ae, dynamic: he };
            }, getMaxBitrate: function(G) {
              var pe = M(G);
              return H(Dr, pe, "mb") || -1;
            }, getEstimatedThroughput: function(G) {
              var pe = M(G);
              return H(Dr, pe, "etp") || null;
            }, getResponseDelay: function(G) {
              var pe = M(G);
              return H(Dr, pe, "rd") || null;
            }, getRoundTripTime: function(G) {
              var pe = M(G);
              return H(Dr, pe, "rtt") || null;
            } }, r = (0, m.Z)(w).getInstance().getLogger(i), y(), i;
          }
          fi.__dashjs_factory_name = "CmsdModel";
          var Ft = v.Z.getSingletonFactory(fi);
          function cn() {
            var i, r, u = this.context, _ = {};
            function w() {
              r = (0, m.Z)(u).getInstance().getLogger(i);
            }
            function I(N) {
              for (var Z = {}, Y = 0, V = 0, M = 0, H = 0, G = N.length, pe = 0; pe < G; ++pe) Y += N[pe].chunkDownloadTimeRelativeMS, V += N[pe].bufferLevel, M += N[pe].chunkDownloadTimeRelativeMS * N[pe].bufferLevel, H += N[pe].chunkDownloadTimeRelativeMS * N[pe].chunkDownloadTimeRelativeMS;
              return Z.m = (M - Y * V / G) / (H - Y * Y / G), Z.b = V / G - Z.m * Y / G, function(ae) {
                return Z.m * ae + Z.b;
              };
            }
            function y(N) {
              var Z, Y = !0, V = N.reduce(function(M, H) {
                return M + H.bufferLevelAtSegmentEnd;
              }, 0) / N.length;
              return N.forEach(function(M) {
                Math.abs(M.bufferLevelAtSegmentEnd / M.bufferLevelAtSegmentStart) < 0.95 && (Y = !1), M.bufferLevelAtSegmentEnd / V < 0.8 && (Y = !1), Z ? Z > M.bitrate && (Y = !1) : Z = M.bitrate;
              }), Y;
            }
            return i = { setup: w, addMeasurement: function(N, Z, Y, V, M) {
              N && N.mediaType && !_[N.mediaType] && (_[N.mediaType] = []);
              var H = N.mediaInfo.bitrateList.find(function(G) {
                return G.id === N.representationId;
              });
              _[N.mediaType].push({ index: N.index, repId: N.representationId, mediaType: N.mediaType, requestTimeMS: V, adjustedAvailabilityStartTimeMS: N.availabilityStartTime.getTime(), segDurationMS: 1e3 * N.duration, chunksDurationMS: Y.reduce(function(G, pe) {
                return G + pe.chunkDownloadDurationMS;
              }, 0), segmentBytes: Y.reduce(function(G, pe) {
                return G + pe.chunkBytes;
              }, 0), bitrate: H && H.bandwidth, bitrateList: N.mediaInfo.bitrateList, chunkMeasurements: Y, fetchDownloadDurationMS: Z, throughputCapacityDelayMS: M, getEstimatedBufferLevel: I(Y.slice(1)) }), _[N.mediaType].length > 10 && _[N.mediaType].shift();
            }, getThroughputCapacityDelayMS: function(N, Z) {
              var Y = _[N.mediaType] && _[N.mediaType].slice(-3);
              return !Y || Y.length < 3 ? 0 : y(Y) ? Z / 4 > 250 ? 250 : Z / 4 : 0;
            }, getEstimatedDownloadDurationMS: function(N) {
              var Z = _[N.mediaType].slice(-1).pop(), Y = _[N.mediaType].slice(-3), V = Z.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;
              Z.bufferLevelAtSegmentStart = Z.getEstimatedBufferLevel(V / 2), Z.bufferLevelAtSegmentEnd = Z.getEstimatedBufferLevel(V);
              var M = y(Y), H = M ? 0.6 : 0.8;
              if (Z.isBufferStable && 1.05 * Z.segDurationMS < Z.fetchDownloadDurationMS) return Z.fetchDownloadDurationMS;
              if (!M || Z.segDurationMS < Z.fetchDownloadDurationMS || Z.adjustedAvailabilityStartTimeMS <= Z.requestTimeMS + Z.throughputCapacityDelayMS - Z.segDurationMS) return 0.8 * Z.fetchDownloadDurationMS;
              for (var G = Z.requestTimeMS + Z.throughputCapacityDelayMS - Z.adjustedAvailabilityStartTimeMS, pe = 0, ae = 0, he = 0, Ee = 0; Ee < Z.chunkMeasurements.length; Ee++) {
                var j = Z.chunkMeasurements[Ee];
                if (G < ae + j.chunkDownloadDurationMS) break;
                ae += j.chunkDownloadDurationMS, pe += j.chunkBytes, he++;
              }
              if (G < 0 && r.warn("request time was before adjusted availibitly start time"), pe && ae && he > 0.2 * Z.chunkMeasurements.length) {
                var ue = pe / ae, z = Z.segmentBytes / ue;
                return Z.fetchDownloadDurationMS < z ? Z.fetchDownloadDurationMS * H : z * H;
              }
              var me = Z.bitrate;
              return Z.bitrateList.some(function(g) {
                if (g.bandwidth > Z.bitrate) return me = g.bandwidth, !0;
              }), me === Z.bitrate ? Z.fetchDownloadDurationMS * H : H * Z.segmentBytes * 8 * 1e3 / me;
            } }, w(), i;
          }
          cn.__dashjs_factory_name = "LowLatencyThroughputModel";
          var vn = v.Z.getSingletonFactory(cn), Kn = R(5717);
          function Dn(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function tr(i) {
            i = i || {};
            var r, u, _, w, I, y, N, Z, Y, V, M, H = this.context, G = i.errHandler, pe = i.dashMetrics, ae = i.mediaPlayerModel, he = i.requestModifier, Ee = i.boxParser, j = i.errors, ue = i.requestTimeout || 0, z = (0, p.Z)(H).getInstance(), me = (0, Oe.Z)(H).getInstance();
            function g(x, O) {
              var L, A = x.request, oe = [], X = !0, de = !0, ne = /* @__PURE__ */ new Date(), U = ne, re = 0, Te = null, Fe = null;
              if (!he || !pe || !G) throw new Error("config object is not correct or missing");
              var De, ke = function(Tt) {
                A.requestStartDate = ne, A.requestEndDate = /* @__PURE__ */ new Date(), A.firstByteDate = A.firstByteDate || ne, A.fileLoaderType = Fe;
                var vt = L.response ? L.response.responseURL : null, mt = L.response ? L.response.status : null, Wt = L.response && L.response.getAllResponseHeaders ? L.response.getAllResponseHeaders() : L.response ? L.response.responseHeaders : null, zt = Wt && me.get().streaming.cmsd && me.get().streaming.cmsd.enabled ? N.parseResponseHeaders(Wt, A.mediaType) : null;
                pe.addHttpRequest(A, vt, mt, Wt, Tt ? oe : null, zt);
              }, Le = function(Tt) {
                de = !1, ke(Tt), A.type === Ge.w.MPD_TYPE && (pe.addManifestUpdate(A), z.trigger(o.Z.MANIFEST_LOADING_FINISHED, { request: A }));
              }, ut = function() {
                if (Te && (clearTimeout(Te), Te = null), u.indexOf(L) !== -1 && (u.splice(u.indexOf(L), 1), de)) if (Le(!1), O > 0) {
                  try {
                    me.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError && A.type === Ge.w.MEDIA_SEGMENT_TYPE && ae.getRetryAttemptsForType(Ge.w.MEDIA_SEGMENT_TYPE) === O && z.trigger(o.Z.ATTEMPT_BACKGROUND_SYNC);
                  } catch {
                  }
                  O--;
                  var Tt = { config: x };
                  w.push(Tt), Tt.timeout = setTimeout(function() {
                    w.indexOf(Tt) !== -1 && (w.splice(w.indexOf(Tt), 1), g(x, O));
                  }, ae.getRetryIntervalsForType(A.type));
                } else {
                  if (A.type === Ge.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE) return;
                  G.error(new se.Z(I[A.type], A.url + " is not available", { request: A, response: L.response })), x.error && x.error(A, "error", L.response.statusText, L.response), x.complete && x.complete(A, L.response.statusText);
                }
              };
              A.hasOwnProperty("availabilityTimeComplete") && A.availabilityTimeComplete === !1 && window.fetch && A.responseType === "arraybuffer" && A.type === Ge.w.MEDIA_SEGMENT_TYPE ? ((De = Fn(H).create({ requestModifier: he, lowLatencyThroughputModel: Y, boxParser: Ee })).setup({ dashMetrics: pe }), Fe = t.Z.FILE_LOADER_TYPES.FETCH) : (De = (0, Ht.Z)(H).create({ requestModifier: he }), Fe = t.Z.FILE_LOADER_TYPES.XHR);
              var ct = null, rt = he.modifyRequestURL ? he.modifyRequestURL(A.url) : A.url;
              if (me.get().streaming.cmcd && me.get().streaming.cmcd.enabled) {
                var at = me.get().streaming.cmcd.mode;
                if (at === t.Z.CMCD_MODE_QUERY) {
                  var Bt = function(Tt) {
                    try {
                      var vt = [], mt = y.getQueryParameter(Tt);
                      return mt && vt.push(mt), vt;
                    } catch {
                      return [];
                    }
                  }(A);
                  rt = St.Z.addAditionalQueryParameterToUrl(rt, Bt);
                } else at === t.Z.CMCD_MODE_HEADER && (ct = y.getHeaderParameters(A));
              }
              var Re = Z.getXHRWithCredentialsForType(A.type);
              if (A.queryParams) {
                var He = Object.keys(A.queryParams).map(function(Tt) {
                  return { key: Tt, value: A.queryParams[Tt] };
                });
                rt = St.Z.addAditionalQueryParameterToUrl(rt, He);
              }
              A.url = rt, L = { url: rt, method: Ge.w.GET, withCredentials: Re, request: A, onload: function() {
                L.response.status >= 200 && L.response.status <= 299 && (Le(!0), x.success && x.success(L.response.response, L.response.statusText, L.response.responseURL), x.complete && x.complete(A, L.response.statusText));
              }, onend: ut, onerror: ut, progress: function(Tt) {
                var vt = /* @__PURE__ */ new Date();
                X && (X = !1, (!Tt.lengthComputable || Tt.lengthComputable && Tt.total !== Tt.loaded) && (A.firstByteDate = vt)), Tt.lengthComputable && (A.bytesLoaded = Tt.loaded, A.bytesTotal = Tt.total), Tt.noTrace || (oe.push({ s: U, d: Tt.time ? Tt.time : vt.getTime() - U.getTime(), b: [Tt.loaded ? Tt.loaded - re : 0] }), U = vt, re = Tt.loaded), Te && (clearTimeout(Te), Te = null), me.get().streaming.fragmentRequestProgressTimeout > 0 && (Te = setTimeout(function() {
                  V.warn("Abort request " + L.url + " due to progress timeout"), L.response.onabort = null, L.loader.abort(L), ut();
                }, me.get().streaming.fragmentRequestProgressTimeout)), x.progress && Tt && x.progress(Tt);
              }, onabort: function() {
                ke(!0), Te && (clearTimeout(Te), Te = null), x.abort && x.abort(A);
              }, ontimeout: function(Tt) {
                var vt;
                if (Tt.lengthComputable) {
                  var mt = Tt.loaded / Tt.total * 100;
                  vt = "Request timeout: loaded: " + Tt.loaded + ", out of: " + Tt.total + " : " + mt.toFixed(3) + "% Completed";
                } else vt = "Request timeout: non-computable download size";
                V.warn(vt);
              }, loader: De, timeout: ue, headers: ct };
              var yt = (/* @__PURE__ */ new Date()).getTime();
              if (isNaN(A.delayLoadingTime) || yt >= A.delayLoadingTime) u.push(L), De.load(L);
              else {
                var Qe = { httpRequest: L };
                _.push(Qe), Qe.delayTimeout = setTimeout(function() {
                  if (_.indexOf(Qe) !== -1) {
                    _.splice(_.indexOf(Qe), 1);
                    try {
                      ne = /* @__PURE__ */ new Date(), U = ne, u.push(Qe.httpRequest), De.load(Qe.httpRequest);
                    } catch {
                      Qe.httpRequest.onerror();
                    }
                  }
                }, A.delayLoadingTime - yt);
              }
            }
            return r = { load: function(x) {
              x.request ? g(x, ae.getRetryAttemptsForType(x.request.type)) : x.error && x.error(x.request, "error");
            }, abort: function() {
              w.forEach(function(x) {
                clearTimeout(x.timeout), x.config.request && x.config.abort && x.config.abort(x.config.request);
              }), w = [], _.forEach(function(x) {
                return clearTimeout(x.delayTimeout);
              }), _ = [], u.forEach(function(x) {
                x.request.type !== Ge.w.MSS_FRAGMENT_INFO_SEGMENT_TYPE && (x.onloadend = x.onerror = x.onprogress = void 0, x.loader.abort(x));
              }), u = [];
            } }, V = (0, m.Z)(H).getInstance().getLogger(r), u = [], _ = [], w = [], y = pn(H).getInstance(), N = Ft(H).getInstance(), Y = vn(H).getInstance(), Z = (0, Kn.Z)(H).getInstance(), Dn(M = {}, Ge.w.MPD_TYPE, j.DOWNLOAD_ERROR_ID_MANIFEST_CODE), Dn(M, Ge.w.XLINK_EXPANSION_TYPE, j.DOWNLOAD_ERROR_ID_XLINK_CODE), Dn(M, Ge.w.INIT_SEGMENT_TYPE, j.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE), Dn(M, Ge.w.MEDIA_SEGMENT_TYPE, j.DOWNLOAD_ERROR_ID_CONTENT_CODE), Dn(M, Ge.w.INDEX_SEGMENT_TYPE, j.DOWNLOAD_ERROR_ID_CONTENT_CODE), Dn(M, Ge.w.BITSTREAM_SWITCHING_SEGMENT_TYPE, j.DOWNLOAD_ERROR_ID_CONTENT_CODE), Dn(M, Ge.w.OTHER_TYPE, j.DOWNLOAD_ERROR_ID_CONTENT_CODE), I = M, r;
          }
          tr.__dashjs_factory_name = "HTTPLoader";
          var Bn = v.Z.getClassFactory(tr);
          function br() {
            var i;
            function r() {
              i = {};
            }
            function u() {
              r();
            }
            return u(), { getLoader: function(_) {
              for (var w in i) if (i.hasOwnProperty(w) && _.startsWith(w)) return i[w];
              return Bn;
            }, registerLoader: function(_, w) {
              i[_] = w;
            }, unregisterLoader: function(_) {
              i[_] && delete i[_];
            }, unregisterAllLoader: r, reset: u };
          }
          br.__dashjs_factory_name = "SchemeLoaderFactory";
          var Xn = v.Z.getSingletonFactory(br);
          function Hn(i) {
            i = i || {};
            var r, u, _ = this.context;
            return r = Xn(_).getInstance(), { load: function(w) {
              if (!u) {
                var I = r.getLoader(w && w.request ? w.request.url : null);
                u = I(_).create({ errHandler: i.errHandler, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, dashMetrics: i.dashMetrics, boxParser: i.boxParser ? i.boxParser : null, constants: i.constants ? i.constants : null, dashConstants: i.dashConstants ? i.dashConstants : null, urlUtils: i.urlUtils ? i.urlUtils : null, requestTimeout: isNaN(i.requestTimeout) ? 0 : i.requestTimeout, errors: i.errors });
              }
              u.load(w);
            }, abort: function() {
              u && u.abort();
            } };
          }
          Hn.__dashjs_factory_name = "URLLoader";
          var hr = v.Z.getClassFactory(Hn);
          function mr(i) {
            return mr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, mr(i);
          }
          function xr(i, r) {
            return xr = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, xr(i, r);
          }
          function Mr(i, r) {
            return !r || mr(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Fr(i) {
            return Fr = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Fr(i);
          }
          var Vr = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && xr(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Fr(r);
              if (u) {
                var N = Fr(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return Mr(this, I);
            });
            function w(I) {
              var y;
              return function(N, Z) {
                if (!(N instanceof Z)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (y = _.call(this, I)).checkForExistenceOnly = !0, y;
            }
            return w;
          }(S.Z);
          function Ci(i) {
            i = i || {};
            var r, u, _ = this.context, w = i.eventBus, I = i.events, y = i.urlUtils, N = i.errors, Z = i.streamId;
            return r = { checkForExistence: function(Y) {
              var V = function(H) {
                w.trigger(I.CHECK_FOR_EXISTENCE_COMPLETED, { request: Y, exists: H });
              };
              if (Y) {
                var M = new Vr(Y.url);
                u.load({ request: M, success: function() {
                  V(!0);
                }, error: function() {
                  V(!1);
                } });
              } else V(!1);
            }, load: function(Y) {
              var V = function(M, H) {
                w.trigger(I.LOADING_COMPLETED, { request: Y, response: M || null, error: H || null, sender: r });
              };
              Y ? u.load({ request: Y, progress: function(M) {
                w.trigger(I.LOADING_PROGRESS, { request: Y, stream: M.stream, streamId: Z }), M.data && w.trigger(I.LOADING_DATA_PROGRESS, { request: Y, response: M.data || null, error: null, sender: r });
              }, success: function(M) {
                V(M);
              }, error: function(M, H, G) {
                V(void 0, new se.Z(N.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE, G, H));
              }, abort: function(M) {
                M && w.trigger(I.LOADING_ABANDONED, { mediaType: M.mediaType, request: M, sender: r });
              } }) : V(void 0, new se.Z(N.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE, N.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE));
            }, abort: function() {
              u && u.abort();
            }, reset: function() {
              u && (u.abort(), u = null);
            } }, u = hr(_).create({ errHandler: i.errHandler, errors: N, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, urlUtils: y, constants: t.Z, boxParser: i.boxParser, dashConstants: i.dashConstants, requestTimeout: i.settings.get().streaming.fragmentRequestTimeout }), r;
          }
          Ci.__dashjs_factory_name = "FragmentLoader";
          var di = v.Z.getClassFactory(Ci);
          function gi() {
            return { modifyResponseAsync: function(i) {
              return Promise.resolve(i);
            } };
          }
          gi.__dashjs_factory_name = "SegmentResponseModifier";
          var Gi = v.Z.getSingletonFactory(gi);
          function Hi(i) {
            i = i || {};
            var r, u, _, w = this.context, I = (0, p.Z)(w).getInstance(), y = i.errHandler, N = i.mediaPlayerModel, Z = i.dashMetrics, Y = (0, m.Z)(w).getInstance(), V = Gi(w).getInstance(), M = i.streamInfo;
            function H() {
              return M.id;
            }
            function G() {
              for (var ae in _) _[ae].reset();
              _ = {};
            }
            function pe(ae) {
              if (ae.sender) {
                var he = ae.request, Ee = ae.response, j = he.isInitializationRequest(), ue = he.mediaInfo.streamInfo;
                if (ae.error && (he.mediaType === t.Z.AUDIO || he.mediaType === t.Z.VIDEO || he.mediaType === t.Z.TEXT && he.mediaInfo.isFragmented) && I.trigger(o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD, { entry: ae.request.serviceLocation }), Ee && ue) {
                  var z = function(me, g, x, O) {
                    var L = new Ot();
                    return L.streamId = x, L.mediaInfo = g.mediaInfo, L.segmentType = g.type, L.start = g.startTime, L.duration = g.duration, L.end = L.start + L.duration, L.bytes = me, L.index = g.index, L.quality = g.quality, L.representationId = g.representationId, L.endFragment = O, L;
                  }(Ee, he, M.id, ae.type !== o.Z.FRAGMENT_LOADING_PROGRESS);
                  V.modifyResponseAsync(z).then(function(me) {
                    I.trigger(j ? o.Z.INIT_FRAGMENT_LOADED : o.Z.MEDIA_FRAGMENT_LOADED, { chunk: me, request: he }, { streamId: ue.id, mediaType: he.mediaType });
                  }).catch(function(me) {
                    u.error(me), I.trigger(j ? o.Z.INIT_FRAGMENT_LOADED : o.Z.MEDIA_FRAGMENT_LOADED, { chunk: z, request: he }, { streamId: ue.id, mediaType: he.mediaType });
                  });
                } else u.warn("No " + he.mediaType + " bytes to push or stream is inactive.");
              }
            }
            return r = { getStreamId: H, getModel: function(ae) {
              var he = _[ae];
              return he || (he = Q(w).create({ streamInfo: M, type: ae, dashMetrics: Z, fragmentLoader: di(w).create({ dashMetrics: Z, mediaPlayerModel: N, errHandler: y, requestModifier: (0, Ie.Z)(w).getInstance(), settings: i.settings, boxParser: i.boxParser, eventBus: I, events: o.Z, errors: ee, dashConstants: i.dashConstants, urlUtils: i.urlUtils, streamId: H() }), debug: Y, eventBus: I, events: o.Z }), _[ae] = he), he;
            }, reset: function() {
              I.off(n.Z.FRAGMENT_LOADING_COMPLETED, pe, this), I.off(n.Z.FRAGMENT_LOADING_PROGRESS, pe, this), G();
            } }, u = Y.getLogger(r), G(), I.on(n.Z.FRAGMENT_LOADING_COMPLETED, pe, r), I.on(n.Z.FRAGMENT_LOADING_PROGRESS, pe, r), r;
          }
          Hi.__dashjs_factory_name = "FragmentController";
          var xa = v.Z.getClassFactory(Hi), Fa = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = null, this.width = null, this.height = null, this.x = null, this.y = null;
          }, qi = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.mediaType = null, this.bitrate = null, this.width = null, this.height = null, this.scanType = null, this.qualityIndex = NaN;
          };
          function Vi(i) {
            var r, u, _ = this.context, w = i.streamInfo;
            function I(N) {
              u.setTrackByIndex(N);
            }
            function y() {
              u && u.reset();
            }
            return r = { getStreamId: function() {
              return w.id;
            }, initialize: function() {
              u.addTracks();
              var N = u.getTracks();
              N && N.length > 0 && I(0);
            }, provide: function(N, Z) {
              if (typeof Z == "function") {
                var Y, V, M = u.getCurrentTrack();
                if (!M || M.segmentDuration <= 0 || N == null) Z(null);
                else {
                  (V = u.getThumbnailRequestForTime(N)) && (M.segmentDuration = V.duration), Y = N % M.segmentDuration;
                  var H = Math.floor(Y * M.tilesHor * M.tilesVert / M.segmentDuration), G = new Fa();
                  if (G.width = Math.floor(M.widthPerTile), G.height = Math.floor(M.heightPerTile), G.x = Math.floor(H % M.tilesHor) * M.widthPerTile, G.y = Math.floor(H / M.tilesHor) * M.heightPerTile, "readThumbnail" in M) return M.readThumbnail(N, function(ae) {
                    G.url = ae, Z(G);
                  });
                  if (V) G.url = V.url, M.segmentDuration = NaN;
                  else {
                    var pe = Math.floor(N / M.segmentDuration);
                    G.url = function(ae, he) {
                      var Ee = he + ae.startNumber, j = (0, l.vi)(ae.templateUrl, "Number", Ee);
                      return j = (0, l.vi)(j, "Time", (Ee - 1) * ae.segmentDuration * ae.timescale), j = (0, l.vi)(j, "Bandwidth", ae.bandwidth), (0, l.eR)(j);
                    }(M, pe);
                  }
                  Z(G);
                }
              }
            }, setTrackByIndex: I, getCurrentTrackIndex: function() {
              return u.getCurrentTrackIndex();
            }, getBitrateList: function() {
              var N = u.getTracks(), Z = 0;
              return N.map(function(Y) {
                var V = new qi();
                return V.mediaType = t.Z.IMAGE, V.qualityIndex = Z++, V.bitrate = Y.bitrate, V.width = Y.width, V.height = Y.height, V;
              });
            }, reset: y }, y(), u = (0, Gt.Z)(_).create({ streamInfo: w, adapter: i.adapter, baseURLController: i.baseURLController, timelineConverter: i.timelineConverter, debug: i.debug, eventBus: i.eventBus, events: i.events, dashConstants: i.dashConstants, dashMetrics: i.dashMetrics, segmentBaseController: i.segmentBaseController }), r;
          }
          Vi.__dashjs_factory_name = "ThumbnailController";
          var ka = v.Z.getClassFactory(Vi), wi = R(7417);
          function ji(i) {
            var r;
            i = i || {};
            var u = [], _ = (0, p.Z)(this.context).getInstance(), w = i.updateEventName, I = i.addBlacklistEventName;
            function y(N) {
              u.indexOf(N) === -1 && (u.push(N), _.trigger(w, { entry: N }));
            }
            return r = { add: y, contains: function(N) {
              return !!(u.length && N && N.length) && u.indexOf(N) !== -1;
            }, reset: function() {
              u = [];
            } }, I && _.on(I, function(N) {
              y(N.entry);
            }, r), r;
          }
          ji.__dashjs_factory_name = "BlackListController";
          var hi = v.Z.getClassFactory(ji), Za = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT, t.Z.MUXED, t.Z.IMAGE];
          function Un(i) {
            i = i || {};
            var r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j, ue = this.context, z = (0, p.Z)(ue).getInstance(), me = (0, $e.Z)(ue).getInstance(), g = i.manifestModel, x = i.mediaPlayerModel, O = i.dashMetrics, L = i.manifestUpdater, A = i.adapter, oe = i.timelineConverter, X = i.capabilities, de = i.errHandler, ne = i.abrController, U = i.playbackController, re = i.eventController, Te = i.mediaController, Fe = i.protectionController, De = i.textController, ke = i.videoModel, Le = i.streamInfo, ut = i.settings;
            function ct(pt, kt) {
              return new Promise(function(qt, Vt) {
                vt(), V = !0, Wt();
                var Xt = ke.getElement(), We = [];
                Za.forEach(function(Pe) {
                  (Pe !== t.Z.TEXT || pt) && (Pe !== t.Z.VIDEO || !Xt || Xt && /^VIDEO$/i.test(Xt.nodeName)) && We.push(rt(Pe, pt));
                }), Promise.all(We).then(function() {
                  return Pe = kt, new Promise(function(ft) {
                    var ye = {}, Ae = _.map(function(tt) {
                      return tt.createBufferSinks(Pe);
                    });
                    Promise.all(Ae).then(function(tt) {
                      tt.forEach(function(Nt) {
                        Nt && (ye[Nt.getType()] = Nt);
                      }), ft(ye);
                    }).catch(function() {
                      ft(ye);
                    });
                  });
                  var Pe;
                }).then(function(Pe) {
                  if (V = !1, _.length === 0) {
                    var ft = "No streams to play.";
                    de.error(new se.Z(ee.MANIFEST_ERROR_ID_NOSTREAMS_CODE, ft, g.getValue())), u.fatal(ft);
                  } else zt();
                  pt && De.createTracks(Le), qt(Pe);
                }).catch(function(Pe) {
                  Vt(Pe);
                });
              });
            }
            function rt(pt, kt) {
              var qt, Vt = A.getAllMediaInfoForType(Le, pt), Xt = [], We = null;
              if (!Vt || Vt.length === 0) return u.info("No " + pt + " data."), Promise.resolve();
              pt === t.Z.VIDEO && (N = !0), pt === t.Z.AUDIO && (Z = !0);
              for (var Pe = 0, ft = Vt.length; Pe < ft; Pe++) We = Vt[Pe], pt === t.Z.TEXT && We.isEmbedded && (De.addEmbeddedTrack(Le, We), Xt.push(We)), at(We) && Te.addTrack(We);
              if (Xt.length > 0 && (Te.setInitialMediaSettingsForType(pt, Le), De.addMediaInfosToBuffer(Le, pt, Xt)), Vt = Vt.filter(function(Ae) {
                return !Ae.isEmbedded;
              }), Vt.length === 0) return Promise.resolve();
              if (pt === t.Z.IMAGE) return (H = ka(ue).create({ streamInfo: Le, adapter: A, baseURLController: i.baseURLController, timelineConverter: i.timelineConverter, debug: he, eventBus: z, events: o.Z, dashConstants: e.Z, dashMetrics: i.dashMetrics, segmentBaseController: i.segmentBaseController })).initialize(), Promise.resolve();
              z.trigger(o.Z.STREAM_INITIALIZING, { streamInfo: Le, mediaInfo: We }), Te.setInitialMediaSettingsForType(pt, Le);
              var ye = function(Ae, tt) {
                var Nt = Ae && Ae.length > 0 ? Ae[0] : null, xt = M.getModel(Nt ? Nt.type : null), _n = Nt ? Nt.type : null, Ln = Nt ? Nt.mimeType : null, $n = Nt ? Nt.isFragmented : null, Mn = Yt(ue).create({ streamInfo: Le, type: _n, mimeType: Ln, timelineConverter: oe, adapter: A, manifestModel: g, mediaPlayerModel: x, fragmentModel: xt, dashMetrics: i.dashMetrics, baseURLController: i.baseURLController, segmentBaseController: i.segmentBaseController, abrController: ne, playbackController: U, mediaController: Te, textController: De, errHandler: de, settings: ut, boxParser: ae, segmentBlacklistController: G });
                Mn.initialize(tt, N, $n), _.push(Mn);
                for (var yr = 0; yr < Ae.length; yr++) Mn.addMediaInfo(Ae[yr]);
                return _n === t.Z.TEXT && De.addMediaInfosToBuffer(Le, _n, Ae, xt), Mn;
              }(Vt, kt);
              return (qt = Te.getCurrentTrackFor(pt, Le.id)) ? (ne.updateTopQualityIndex(qt), ye.selectMediaInfo(pt === t.Z.TEXT && qt.isEmbedded ? Vt[0] : qt)) : Promise.resolve();
            }
            function at(pt) {
              var kt, qt = pt ? pt.type : null;
              return qt === t.Z.MUXED ? (kt = "Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines", u.fatal(kt), de.error(new se.Z(ee.MANIFEST_ERROR_ID_MULTIPLEXED_CODE, kt, g.getValue())), !1) : !(qt !== t.Z.TEXT && qt !== t.Z.IMAGE && pt.contentProtection && !X.supportsEncryptedMedia() && (de.error(new se.Z(ee.CAPABILITY_MEDIAKEYS_ERROR_CODE, ee.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE)), 1));
            }
            function Bt(pt) {
              for (var kt = _ ? _.length : 0, qt = 0; qt < kt; qt++) {
                var Vt = _[qt].getFragmentModel();
                Vt.abortRequests(), Vt.resetInitialSettings(), _[qt].reset(!1, pt);
              }
              De && De.deactivateStream(Le), _ = [], I = !1, y = !1, en(!1), He(!1), z.trigger(o.Z.STREAM_DEACTIVATED, { streamInfo: Le });
            }
            function Re(pt) {
              Bt(pt), w = !1, N = !1, Z = !1, Y = {}, V = !1, Ee = !1, j = [];
            }
            function He(pt) {
              Ee = pt;
            }
            function yt() {
              return Le ? Le.start : NaN;
            }
            function Qe() {
              return Le ? Le.id : null;
            }
            function Tt() {
              return Le;
            }
            function vt() {
              if (!ke || !ne) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            function mt(pt) {
              pt.error && (de.error(pt.error), u.fatal(pt.error.message));
            }
            function Wt() {
              if (re) {
                var pt = A.getEventsFor(Le);
                pt && pt.length > 0 && re.addInlineEvents(pt, Le.id);
              }
            }
            function zt() {
              for (var pt = _.length, kt = Y.audio || Y.video ? new se.Z(ee.DATA_UPDATE_FAILED_ERROR_CODE, ee.DATA_UPDATE_FAILED_ERROR_MESSAGE) : null, qt = 0; qt < pt; qt++) if (_[qt].isUpdating() || V) return;
              if (Fe) {
                Fe.clearMediaInfoArray();
                for (var Vt = 0; Vt < pt && _[Vt]; Vt++) {
                  var Xt = _[Vt].getType(), We = _[Vt].getMediaInfo();
                  if (Xt === t.Z.AUDIO || Xt === t.Z.VIDEO || Xt === t.Z.TEXT && We.isFragmented) {
                    var Pe = _[Vt].getMediaInfo();
                    Pe && Fe.initializeForMedia(Pe);
                  }
                }
                Fe.handleKeySystemFromManifest();
              }
              kt ? de.error(kt) : w || (w = !0, ke.waitForReadyState(t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                z.trigger(o.Z.STREAM_INITIALIZED, { streamInfo: Le });
              }));
            }
            function hn() {
              var pt = wt(), kt = pt.length;
              if (kt !== 0) {
                for (var qt = 0; qt < kt; qt++) if (!pt[qt].isBufferingCompleted() && (pt[qt].getType() === t.Z.AUDIO || pt[qt].getType() === t.Z.VIDEO)) return void u.debug("onBufferingCompleted - One streamProcessor has finished but", pt[qt].getType(), "one is not buffering completed");
                u.debug("onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED"), y = !0, z.trigger(o.Z.STREAM_BUFFERING_COMPLETED, { streamInfo: Le }, { streamInfo: Le });
              } else u.warn("onBufferingCompleted - can't trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined");
            }
            function yn(pt) {
              Y[pt.mediaType] = pt.error, zt();
            }
            function ze(pt) {
              re && re.addInbandEvents(pt.events, Le.id);
            }
            function Et(pt) {
              return pt && pt.type ? lt(pt.type) : null;
            }
            function lt(pt) {
              return pt ? wt().filter(function(kt) {
                return kt.getType() === pt;
              })[0] : null;
            }
            function wt() {
              for (var pt, kt, qt = [], Vt = 0; Vt < _.length; Vt++) (pt = (kt = _[Vt]).getType()) !== t.Z.AUDIO && pt !== t.Z.VIDEO && pt !== t.Z.TEXT || qt.push(kt);
              return qt;
            }
            function Pt(pt, kt) {
              var qt = Tt(), Vt = kt.getStreamInfo();
              if (!Vt || !qt) return !0;
              var Xt = A.getAdaptationForType(Vt.index, pt, Vt), We = A.getAdaptationForType(qt.index, pt, qt);
              return Xt && We ? !(!$t(We) && $t(Xt)) : !Xt && !We;
            }
            function $t(pt) {
              return !!pt && !!(pt.ContentProtection || pt.Representation_asArray && pt.Representation_asArray.length > 0 && pt.Representation_asArray[0].ContentProtection);
            }
            function Qt(pt, kt) {
              var qt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              if (!pt || !pt.hasOwnProperty("getStreamInfo")) return !1;
              var Vt = pt.getStreamInfo(), Xt = qt ? qt.getStreamInfo() : Tt();
              if (!Vt || !Xt) return !1;
              var We = A.getAdaptationForType(Vt.index, kt, Vt), Pe = A.getAdaptationForType(Xt.index, kt, Xt);
              if (!We || !Pe) return !We && !Pe;
              var ft = We && Pe && We.mimeType === Pe.mimeType, ye = Pe.Representation_asArray.map(function(xt) {
                return xt.codecs;
              }), Ae = We.Representation_asArray.map(function(xt) {
                return xt.codecs;
              }), tt = Ae.some(function(xt) {
                return ye.indexOf(xt) > -1;
              }), Nt = Ae.some(function(xt) {
                return ye.some(function(_n) {
                  return X.codecRootCompatibleWithCodec(_n, xt);
                });
              });
              return tt || Nt && ft;
            }
            function en(pt) {
              pe = pt;
            }
            function ln() {
              return pe;
            }
            return r = { initialize: function() {
              z.on(o.Z.BUFFERING_COMPLETED, hn, r), z.on(o.Z.DATA_UPDATE_COMPLETED, yn, r), z.on(o.Z.INBAND_EVENTS, ze, r), Fe && (z.on(o.Z.KEY_ERROR, mt, r), z.on(o.Z.SERVER_CERTIFICATE_UPDATED, mt, r), z.on(o.Z.LICENSE_REQUEST_COMPLETE, mt, r), z.on(o.Z.KEY_SYSTEM_SELECTED, mt, r), z.on(o.Z.KEY_SESSION_CREATED, mt, r), z.on(o.Z.KEY_STATUSES_CHANGED, mt, r)), De.initializeForStream(Le), z.trigger(o.Z.STREAM_UPDATED, { streamInfo: Le });
            }, getStreamId: function() {
              return Le ? Le.id : null;
            }, activate: function(pt, kt) {
              return new Promise(function(qt, Vt) {
                if (!I) return ln() ? (I = !0, z.trigger(o.Z.STREAM_ACTIVATED, { streamInfo: Le }), void qt(kt)) : void function(Xt, We) {
                  return ct(Xt, We);
                }(pt, kt).then(function(Xt) {
                  I = !0, z.trigger(o.Z.STREAM_ACTIVATED, { streamInfo: Le }), qt(Xt);
                }).catch(function(Xt) {
                  Vt(Xt);
                });
                qt(kt);
              });
            }, deactivate: Bt, getIsActive: function() {
              return I;
            }, getDuration: function() {
              return Le ? Le.duration : NaN;
            }, getStartTime: yt, getId: Qe, getStreamInfo: Tt, getHasAudioTrack: function() {
              return Z;
            }, getHasVideoTrack: function() {
              return N;
            }, startPreloading: function(pt, kt) {
              return new Promise(function(qt, Vt) {
                ln() ? Vt() : (u.info("[startPreloading] Preloading next stream with id ".concat(Qe())), en(!0), ct(pt, kt).then(function() {
                  for (var Xt = 0; Xt < _.length && _[Xt]; Xt++) _[Xt].setExplicitBufferingTime(yt()), _[Xt].getScheduleController().startScheduleTimer();
                  qt();
                }).catch(function() {
                  en(!1), Vt();
                }));
              });
            }, initializeForTextWithMediaSource: function(pt) {
              return new Promise(function(kt, qt) {
                rt(t.Z.TEXT, pt).then(function() {
                  return (Vt = lt(t.Z.TEXT)) ? Vt.createBufferSinks() : Promise.resolve();
                  var Vt;
                }).then(function() {
                  De.createTracks(Le), kt();
                }).catch(function(Vt) {
                  qt(Vt);
                });
              });
            }, getThumbnailController: function() {
              return H;
            }, getBitrateListFor: function(pt) {
              if (vt(), pt === t.Z.IMAGE) return H ? H.getBitrateList() : [];
              var kt = function(qt) {
                for (var Vt = null, Xt = 0; Xt < _.length; Xt++) if ((Vt = _[Xt]).getType() === qt) return Vt.getMediaInfo();
                return null;
              }(pt);
              return ne.getBitrateList(kt);
            }, updateData: function(pt) {
              return new Promise(function(kt) {
                V = !0, Le = pt, re && Wt();
                for (var qt = [], Vt = 0, Xt = _.length; Vt < Xt; Vt++) {
                  var We = _[Vt], Pe = We.getMediaInfo();
                  qt.push(We.updateStreamInfo(Le));
                  var ft = A.getAllMediaInfoForType(Le, We.getType());
                  if (ft = ft.filter(function(tt) {
                    return !tt.isEmbedded;
                  })) {
                    We.clearMediaInfoArray();
                    for (var ye = 0; ye < ft.length; ye++) {
                      var Ae = ft[ye];
                      We.addMediaInfo(ft[ye]), A.areMediaInfosEqual(Pe, Ae) && (ne.updateTopQualityIndex(Ae), qt.push(We.selectMediaInfo(Ae)));
                    }
                  }
                }
                Promise.all(qt).then(function() {
                  for (qt = []; j.length > 0; ) {
                    var tt = j.pop(), Nt = tt.newMediaInfo, xt = Et(tt.oldMediaInfo);
                    if (!xt) return;
                    qt.push(xt.prepareTrackSwitch()), qt.push(xt.selectMediaInfo(Nt));
                  }
                  return Promise.all(qt);
                }).then(function() {
                  V = !1, zt(), z.trigger(o.Z.STREAM_UPDATED, { streamInfo: Le }), kt();
                });
              });
            }, reset: function(pt) {
              M && (M.reset(), M = null), ne && Le && ne.clearDataForStream(Le.id), G && (G.reset(), G = null), Re(pt), Le = null, z.off(o.Z.DATA_UPDATE_COMPLETED, yn, r), z.off(o.Z.BUFFERING_COMPLETED, hn, r), z.off(o.Z.INBAND_EVENTS, ze, r), Fe && (z.off(o.Z.KEY_ERROR, mt, r), z.off(o.Z.SERVER_CERTIFICATE_UPDATED, mt, r), z.off(o.Z.LICENSE_REQUEST_COMPLETE, mt, r), z.off(o.Z.KEY_SYSTEM_SELECTED, mt, r), z.off(o.Z.KEY_SESSION_CREATED, mt, r), z.off(o.Z.KEY_STATUSES_CHANGED, mt, r));
            }, getProcessors: wt, setMediaSource: function(pt) {
              return new Promise(function(kt, qt) {
                for (var Vt = [], Xt = 0; Xt < _.length; ) at(_[Xt].getMediaInfo()) ? (Vt.push(_[Xt].setMediaSource(pt)), Xt++) : (_[Xt].reset(), _.splice(Xt, 1));
                Promise.all(Vt).then(function() {
                  for (var We = 0; We < _.length; We++) _[We].dischargePreBuffer();
                  if (_.length === 0) {
                    var Pe = "No streams to play.";
                    de.error(new se.Z(ee.MANIFEST_ERROR_ID_NOSTREAMS_CODE, Pe + "nostreams", g.getValue())), u.fatal(Pe);
                  }
                  kt();
                }).catch(function(We) {
                  u.error(We), qt(We);
                });
              });
            }, isMediaCodecCompatible: function(pt) {
              var kt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return Qt(pt, t.Z.VIDEO, kt) && Qt(pt, t.Z.AUDIO, kt);
            }, isProtectionCompatible: function(pt) {
              return !pt || Pt(t.Z.VIDEO, pt) && Pt(t.Z.AUDIO, pt);
            }, getPreloaded: ln, getIsEndedEventSignaled: function() {
              return Ee;
            }, setIsEndedEventSignaled: He, getAdapter: function() {
              return A;
            }, getHasFinishedBuffering: function() {
              return y;
            }, setPreloaded: en, startScheduleControllers: function() {
              for (var pt = _.length, kt = 0; kt < pt && _[kt]; kt++) _[kt].getScheduleController().startScheduleTimer();
            }, prepareTrackChange: function(pt) {
              if (I && Le) {
                y = !1;
                var kt = pt.newMediaInfo, qt = g.getValue();
                A.setCurrentMediaInfo(Le.id, kt.type, kt);
                var Vt = Et(kt);
                if (Vt) {
                  var Xt = U.getTime();
                  u.info("Stream -  Process track changed at current time " + Xt), qt.refreshManifestOnSwitchTrack ? (j.push(pt), L.getIsUpdating() || (u.debug("Stream -  Refreshing manifest for switch track"), L.refreshManifest())) : Vt.selectMediaInfo(kt).then(function() {
                    kt.type !== t.Z.VIDEO && kt.type !== t.Z.AUDIO || ne.updateTopQualityIndex(kt), Vt.prepareTrackSwitch();
                  });
                }
              }
            }, prepareQualityChange: function(pt) {
              var kt = lt(pt.mediaType);
              kt && kt.prepareQualityChange(pt);
            } }, function() {
              try {
                he = (0, m.Z)(ue).getInstance(), u = he.getLogger(r), Re(), ae = (0, wi.Z)(ue).getInstance(), G = hi(ue).create({ updateEventName: o.Z.SEGMENT_LOCATION_BLACKLIST_CHANGED, addBlacklistEventName: o.Z.SEGMENT_LOCATION_BLACKLIST_ADD }), M = xa(ue).create({ streamInfo: Le, mediaPlayerModel: x, dashMetrics: O, errHandler: de, settings: ut, boxParser: ae, dashConstants: e.Z, urlUtils: me });
              } catch (pt) {
                throw pt;
              }
            }(), r;
          }
          Un.__dashjs_factory_name = "Stream";
          var $r = v.Z.getClassFactory(Un), mi = function i(r) {
            (function(u, _) {
              if (!(u instanceof _)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.url = r || null, this.type = Ge.w.CONTENT_STEERING_TYPE, this.responseType = "json";
          }, Jr = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.version = null, this.ttl = 300, this.reloadUri = null, this.pathwayPriority = [], this.pathwayClones = [];
          };
          function Yi() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae = this.context, he = (0, $e.Z)(ae).getInstance();
            function Ee(ne) {
              g(ne, "baseUrl");
            }
            function j(ne) {
              g(ne, "location");
            }
            function ue(ne) {
              if (ne && ne.request && ne.request.serviceLocation && ne.request.requestStartDate && ne.request.requestEndDate && !isNaN(ne.request.bytesTotal)) {
                var U = ne.request.serviceLocation, re = ne.request.requestEndDate.getTime() - ne.request.requestStartDate.getTime();
                me(U, parseInt(8 * ne.request.bytesTotal / re * 1e3));
              }
            }
            function z(ne) {
              ne && ne.httpRequest && ne.httpRequest._serviceLocation && !isNaN(ne.throughput) && me(ne.httpRequest._serviceLocation, 1e3 * ne.throughput);
            }
            function me(ne, U) {
              w[ne] || (w[ne] = []), w[ne].push(U), w[ne].length > 4 && w[ne].shift();
            }
            function g(ne, U) {
              if (ne && ne.request && ne.request.serviceLocation) {
                var re = ne.request.serviceLocation;
                _[U].all.indexOf(re) === -1 && _[U].all.push(re), _[U].current = re;
              }
            }
            function x() {
              var ne = V.getValue(), U = pe.getContentSteering(ne);
              return U || (U = H.getServiceDescriptionSettings().contentSteering), U;
            }
            function O() {
              return new Promise(function(ne) {
                try {
                  var U = x();
                  if (!U || !U.serverUrl) return void ne();
                  var re = function(Fe) {
                    var De = Fe.serverUrl;
                    u && u.reloadUri && (De = he.isRelative(u.reloadUri) ? he.resolve(u.reloadUri, Fe.serverUrl) : u.reloadUri);
                    var ke = [], Le = _.baseUrl.all.concat(_.location.all);
                    if (Le.length > 0) {
                      var ut = Le.map(function(at) {
                        var Bt = function(Re) {
                          if (!Re || !w[Re] || w[Re].length === 0) return -1;
                          var He = w[Re].reduce(function(yt, Qe) {
                            return yt + Qe;
                          }) / w[Re].length;
                          return parseInt(He);
                        }(at);
                        return { serviceLocation: at, throughput: Bt };
                      });
                      ut.sort(function(at, Bt) {
                        return Bt.throughput - at.throughput;
                      });
                      var ct = "", rt = "";
                      ut.forEach(function(at, Bt) {
                        Bt !== 0 && (ct = "".concat(ct, ","), at.throughput > -1 && (rt = "".concat(rt, ","))), ct = "".concat(ct).concat(at.serviceLocation), at.throughput > -1 && (rt = "".concat(rt).concat(at.throughput));
                      }), ke.push({ key: "_DASH_pathway", value: '"'.concat(ct, '"') }), ke.push({ key: "_DASH_throughput", value: rt });
                    }
                    return De = St.Z.addAditionalQueryParameterToUrl(De, ke);
                  }(U), Te = new mi(re);
                  y.load({ request: Te, success: function(Fe) {
                    (function(De) {
                      De && De[e.Z.CONTENT_STEERING_RESPONSE.VERSION] && parseInt(De[e.Z.CONTENT_STEERING_RESPONSE.VERSION]) === 1 && ((u = new Jr()).version = De[e.Z.CONTENT_STEERING_RESPONSE.VERSION], De[e.Z.CONTENT_STEERING_RESPONSE.TTL] && !isNaN(De[e.Z.CONTENT_STEERING_RESPONSE.TTL]) && (u.ttl = De[e.Z.CONTENT_STEERING_RESPONSE.TTL]), De[e.Z.CONTENT_STEERING_RESPONSE.RELOAD_URI] && (u.reloadUri = De[e.Z.CONTENT_STEERING_RESPONSE.RELOAD_URI]), De[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_PRIORITY] && (u.pathwayPriority = De[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_PRIORITY]), De[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_CLONES] && (u.pathwayClones = De[e.Z.CONTENT_STEERING_RESPONSE.PATHWAY_CLONES], u.pathwayClones = u.pathwayClones.filter(function(ke) {
                        return function(Le) {
                          return Le[e.Z.CONTENT_STEERING_RESPONSE.BASE_ID] && Le[e.Z.CONTENT_STEERING_RESPONSE.ID] && Le[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT] && Le[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.HOST];
                        }(ke);
                      })), oe());
                    })(Fe), G.trigger(n.Z.CONTENT_STEERING_REQUEST_COMPLETED, { currentSteeringResponseData: u, url: re }), ne();
                  }, error: function(Fe, De, ke, Le) {
                    (function(ut, ct) {
                      try {
                        switch (r.warn("Error fetching data from content steering server", ut), ct.status) {
                          case 410:
                            break;
                          case 429:
                            var rt = ct && ct.getResponseHeader ? ct.getResponseHeader("retry-after") : null;
                            rt !== null && (u || (u = {}), u.ttl = parseInt(rt)), oe();
                            break;
                          default:
                            oe();
                        }
                      } catch (at) {
                        r.error(at);
                      }
                    })(Fe, Le), ne(Fe);
                  }, complete: function() {
                    _.baseUrl.all = L(_.baseUrl), _.location.all = L(_.location);
                  } });
                } catch (Fe) {
                  ne(Fe);
                }
              });
            }
            function L(ne) {
              return ne.all && ne.all.length !== 0 && ne.current ? ne.all.filter(function(U) {
                return U === ne.current;
              }) : [];
            }
            function A(ne) {
              try {
                var U = [];
                return ne && ne.length !== 0 && u && u.pathwayClones && u.pathwayClones.length !== 0 && u.pathwayClones.forEach(function(re) {
                  var Te = ne.filter(function(ut) {
                    return re[e.Z.CONTENT_STEERING_RESPONSE.BASE_ID] === ut.serviceLocation;
                  }), Fe = null;
                  if (Te && Te.length > 0 && (Fe = Te[0]), Fe) {
                    var De = new URL(Fe.url), ke = re[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.HOST];
                    ke = St.Z.stringHasProtocol(ke) ? ke : "".concat(De.protocol, "//").concat(ke);
                    var Le = { synthesizedUrl: "".concat(ke).concat(De.pathname), serviceLocation: re[e.Z.CONTENT_STEERING_RESPONSE.ID], queryParams: re[e.Z.CONTENT_STEERING_RESPONSE.URI_REPLACEMENT][e.Z.CONTENT_STEERING_RESPONSE.PARAMS], reference: Fe };
                    U.push(Le);
                  }
                }), U;
              } catch (re) {
                return r.error(re), [];
              }
            }
            function oe() {
              u && u.ttl && !isNaN(u.ttl) && (I && clearTimeout(I), I = setTimeout(function() {
                O();
              }, 1e3 * u.ttl));
            }
            function X() {
              I && clearTimeout(I), I = null;
            }
            function de() {
              u = null, w = {}, _ = { baseUrl: { current: null, all: [] }, location: { current: null, all: [] } }, X();
            }
            return i = { reset: function() {
              de(), G.off(n.Z.FRAGMENT_LOADING_STARTED, Ee, i), G.off(n.Z.MANIFEST_LOADING_STARTED, j, i), G.off(n.Z.MANIFEST_LOADING_FINISHED, ue, i), G.off(n.Z.THROUGHPUT_MEASUREMENT_STORED, z, i);
            }, setConfig: function(ne) {
              ne && (ne.adapter && (pe = ne.adapter), ne.errHandler && (N = ne.errHandler), ne.dashMetrics && (Z = ne.dashMetrics), ne.mediaPlayerModel && (Y = ne.mediaPlayerModel), ne.requestModifier && (M = ne.requestModifier), ne.manifestModel && (V = ne.manifestModel), ne.serviceDescriptionController && (H = ne.serviceDescriptionController), ne.eventBus && (G = ne.eventBus));
            }, loadSteeringData: O, getCurrentSteeringResponseData: function() {
              return u;
            }, shouldQueryBeforeStart: function() {
              var ne = x();
              return !!ne && ne.queryBeforeStart;
            }, getSteeringDataFromManifest: x, stopSteeringRequestTimer: X, getSynthesizedBaseUrlElements: function(ne) {
              try {
                return A(ne).map(function(U) {
                  var re = new Nr(U.synthesizedUrl, U.serviceLocation);
                  return re.queryParams = U.queryParams, re.dvbPriority = U.reference.dvbPriority, re.dvbWeight = U.reference.dvbWeight, re.availabilityTimeOffset = U.reference.availabilityTimeOffset, re.availabilityTimeComplete = U.reference.availabilityTimeComplete, re;
                });
              } catch (U) {
                return r.error(U), [];
              }
            }, getSynthesizedLocationElements: function(ne) {
              try {
                return A(ne).map(function(U) {
                  var re = new an(U.synthesizedUrl, U.serviceLocation);
                  return re.queryParams = U.queryParams, re;
                });
              } catch (U) {
                return r.error(U), [];
              }
            }, initialize: function() {
              y = hr(ae).create({ errHandler: N, dashMetrics: Z, mediaPlayerModel: Y, requestModifier: M, errors: ee }), G.on(n.Z.FRAGMENT_LOADING_STARTED, Ee, i), G.on(n.Z.MANIFEST_LOADING_STARTED, j, i), G.on(n.Z.MANIFEST_LOADING_FINISHED, ue, i), G.on(n.Z.THROUGHPUT_MEASUREMENT_STORED, z, i);
            } }, r = (0, m.Z)(ae).getInstance().getLogger(i), de(), i;
          }
          Yi.__dashjs_factory_name = "ContentSteeringController";
          var Or = v.Z.getSingletonFactory(Yi);
          function Ki() {
            var i, r, u, _ = this.context, w = (0, Oe.Z)(_).getInstance();
            return i = { select: function(I) {
              if (!I || I.length === 0) return null;
              var y = null;
              return w.get().streaming.applyContentSteering && (y = function(N) {
                var Z = u.getCurrentSteeringResponseData();
                return Z && Z.pathwayPriority && Z.pathwayPriority.length > 0 ? function() {
                  for (var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], M = 0, H = null, G = function() {
                    var pe = Y[M], ae = V.findIndex(function(he) {
                      return he.serviceLocation && he.serviceLocation === pe;
                    });
                    if (ae !== -1 && !r.contains(V[ae].serviceLocation)) return H = V[ae], "break";
                    M += 1;
                  }; M < Y.length && G() !== "break"; ) ;
                  return H;
                }(Z.pathwayPriority, N) : null;
              }(I)), y || (y = function(N) {
                return N[0];
              }(I)), y;
            }, setConfig: function(I) {
              I.blacklistController && (r = I.blacklistController), I.contentSteeringController && (u = I.contentSteeringController);
            }, reset: function() {
              r.reset();
            } }, r = hi(_).create({ updateEventName: o.Z.SERVICE_LOCATION_LOCATION_BLACKLIST_CHANGED, addBlacklistEventName: o.Z.SERVICE_LOCATION_LOCATION_BLACKLIST_ADD }), u = Or(_).getInstance(), i;
          }
          Ki.__dashjs_factory_name = "LocationSelector";
          var jr = v.Z.getClassFactory(Ki);
          function zi() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe = this.context, ae = (0, p.Z)(pe).getInstance(), he = (0, $e.Z)(pe).getInstance();
            function Ee() {
              u = NaN, y = !1, w = !0, I = !1, j();
            }
            function j() {
              _ !== null && (clearTimeout(_), _ = null);
            }
            function ue(X) {
              j(), I || (isNaN(X) && !isNaN(u) && (X = 1e3 * u), isNaN(X) || (r.debug("Refresh manifest in " + X + " milliseconds."), _ = setTimeout(x, X)));
            }
            function z() {
              var X = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              y = !0;
              var de = Z.getValue(), ne = de.url, U = null, re = V.getPatchLocation(de), Te = Y.select(re), Fe = null;
              if (Te && !X) ne = Te.url, U = Te.serviceLocation, Fe = Te.queryParams;
              else {
                var De = me(de), ke = Y.select(De);
                ke && (ne = ke.url, U = ke.serviceLocation, Fe = ke.queryParams);
              }
              he.isRelative(ne) && (ne = he.resolve(ne, de.url)), N.load(ne, U, Fe);
            }
            function me(X) {
              var de = V.getLocation(X), ne = H.getSynthesizedLocationElements(de);
              return de.concat(ne);
            }
            function g(X) {
              if (X) {
                if (V.getIsPatch(X)) {
                  var de = X;
                  X = Z.getValue();
                  var ne = V.isPatchValid(X, de), U = ne;
                  if (ne) {
                    var re = V.getPublishTime(X);
                    U = V.applyPatchToManifest(X, de);
                    var Te = V.getPublishTime(X);
                    U = re.getTime() != Te.getTime();
                  }
                  if (!U) return r.debug("Patch provided is invalid, performing full manifest refresh"), void z(!0);
                  X.loadedTime = /* @__PURE__ */ new Date();
                }
              } else (X = Z.getValue()).loadedTime = /* @__PURE__ */ new Date();
              if (Z.getValue() && Z.getValue().type === e.Z.DYNAMIC && X.type === e.Z.STATIC) return ae.trigger(o.Z.DYNAMIC_TO_STATIC), y = !1, void (I = !0);
              Z.setValue(X);
              var Fe = /* @__PURE__ */ new Date(), De = (Fe.getTime() - X.loadedTime.getTime()) / 1e3;
              1e3 * (u = V.getManifestUpdatePeriod(X, De)) > 2147483647 && (u = 2147483647e-3), ae.trigger(o.Z.MANIFEST_UPDATED, { manifest: X }), r.info("Manifest has been refreshed at " + Fe + "[" + Fe.getTime() / 1e3 + "] "), w || ue();
            }
            function x() {
              w || (y ? ue(G.get().streaming.manifestUpdateRetryInterval) : z());
            }
            function O(X) {
              X.error ? X.error.code === ee.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE && M.error(X.error) : g(X.manifest);
            }
            function L() {
              w = !1, ue();
            }
            function A() {
              (w = !G.get().streaming.scheduling.scheduleWhilePaused) && j();
            }
            function oe() {
              y = !1;
            }
            return i = { initialize: function() {
              Ee(), ae.on(o.Z.STREAMS_COMPOSED, oe, this), ae.on(n.Z.PLAYBACK_STARTED, L, this), ae.on(n.Z.PLAYBACK_PAUSED, A, this), ae.on(o.Z.INTERNAL_MANIFEST_LOADED, O, this);
            }, setManifest: function(X) {
              g(X);
            }, refreshManifest: z, getIsUpdating: function() {
              return y;
            }, setConfig: function(X) {
              X && (X.manifestModel && (Z = X.manifestModel), X.adapter && (V = X.adapter), X.manifestLoader && (N = X.manifestLoader), X.errHandler && (M = X.errHandler), X.locationSelector && (Y = X.locationSelector), X.settings && (G = X.settings), X.contentSteeringController && (H = X.contentSteeringController));
            }, reset: function() {
              ae.off(n.Z.PLAYBACK_STARTED, L, this), ae.off(n.Z.PLAYBACK_PAUSED, A, this), ae.off(o.Z.STREAMS_COMPOSED, oe, this), ae.off(o.Z.INTERNAL_MANIFEST_LOADED, O, this), Ee();
            } }, r = (0, m.Z)(pe).getInstance().getLogger(i), Y = jr(pe).create(), i;
          }
          zi.__dashjs_factory_name = "ManifestUpdater";
          var Po = v.Z.getClassFactory(zi);
          function Ba() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he = this.context, Ee = (0, p.Z)(he).getInstance(), j = (0, $e.Z)(he).getInstance();
            function ue() {
              N = [], Z = [], Y = null, V = null, H = null, M = NaN, u = !1, _ = !1, G = w.get().streaming.utcSynchronization.timeBetweenSyncAttempts;
            }
            function z() {
              w.get().streaming.utcSynchronization.enabled && !u && !_ && H && H.value && H.schemeIdUri && !isNaN(M) && !isNaN(w.get().streaming.utcSynchronization.backgroundAttempts) && (V && (Date.now() - V) / 1e3 < 30 || (N = [], _ = !0, me(isNaN(w.get().streaming.utcSynchronization.backgroundAttempts) ? 2 : w.get().streaming.utcSynchronization.backgroundAttempts)));
            }
            function me(ke) {
              try {
                if (ke <= 0) return void Fe();
                var Le = Date.now();
                I[H.schemeIdUri](H.value, function(ut) {
                  var ct = Date.now(), rt = x(Le, ct, ut);
                  N.push(rt), me(ke - 1);
                }, function() {
                  Fe();
                });
              } catch {
                Fe();
              }
            }
            function g() {
              var ke = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Le = ke || 0;
              if (!Z || Z.length === 0 || Le >= Z.length) O();
              else {
                var ut = Z[Le];
                if (ut) if (I.hasOwnProperty(ut.schemeIdUri)) {
                  var ct = (/* @__PURE__ */ new Date()).getTime();
                  I[ut.schemeIdUri](ut.value, function(rt) {
                    var at = (/* @__PURE__ */ new Date()).getTime(), Bt = x(ct, at, rt);
                    H = ut, O(Bt);
                  }, function() {
                    g(Le + 1);
                  });
                } else g(Le + 1);
                else O();
              }
            }
            function x(ke, Le, ut) {
              return ut - (Le - (Le - ke) / 2);
            }
            function O() {
              var ke = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN, Le = isNaN(ke);
              Le && w.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource ? re() : Te(Le, ke);
            }
            function L(ke) {
              var Le = Date.parse(ke);
              return isNaN(Le) && (Le = function(ut) {
                var ct, rt, at = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/.exec(ut);
                return ct = Date.UTC(parseInt(at[1], 10), parseInt(at[2], 10) - 1, parseInt(at[3], 10), parseInt(at[4], 10), parseInt(at[5], 10), at[6] && (parseInt(at[6], 10) || 0), at[7] && 1e3 * parseFloat(at[7]) || 0), at[9] && at[10] && (rt = 60 * parseInt(at[9], 10) + parseInt(at[10], 10), ct += (at[8] === "+" ? -1 : 1) * rt * 60 * 1e3), new Date(ct).getTime();
              }(ke)), Le;
            }
            function A(ke) {
              return Date.parse(ke);
            }
            function oe(ke) {
              return Date.parse(ke);
            }
            function X(ke, Le, ut) {
              ut();
            }
            function de(ke, Le, ut) {
              var ct = L(ke);
              isNaN(ct) ? ut() : Le(ct);
            }
            function ne(ke, Le, ut, ct, rt) {
              var at, Bt, Re = !1, He = new XMLHttpRequest(), yt = rt ? Ge.w.HEAD : Ge.w.GET, Qe = Le.match(/\S+/g);
              if (Le = Qe.shift(), at = function() {
                Re || (Re = !0, Qe.length ? ne(ke, Qe.join(" "), ut, ct, rt) : ct());
              }, Bt = function() {
                var vt, mt;
                He.status === 200 && (vt = rt ? He.getResponseHeader("Date") : He.response, mt = ke(vt), isNaN(mt) || (ut(mt), Re = !0));
              }, j.isRelative(Le)) {
                var Tt = ae.resolve();
                Tt && (Le = j.resolve(Le, Tt.url));
              }
              He.open(yt, Le), He.timeout = 5e3, He.onload = Bt, He.onloadend = at, He.send();
            }
            function U(ke, Le, ut) {
              ne(oe, ke, Le, ut, !0);
            }
            function re() {
              var ke = y.getLatestMPDRequestHeaderValueByID("Date"), Le = ke !== null ? new Date(ke).getTime() : Number.NaN;
              isNaN(Le) ? Te(!0) : Te(!1, Le - Date.now());
            }
            function Te(ke, Le) {
              if (isNaN(M) || isNaN(Le) || ke || function(ct) {
                try {
                  var rt, at = De(ct), Bt = isNaN(G) ? 30 : G, Re = isNaN(w.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor) ? 2 : w.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor, He = isNaN(w.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts) ? 600 : w.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts, yt = isNaN(w.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts) ? 2 : w.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts;
                  at ? (rt = Math.min(Bt * Re, He), r.debug("Increasing timeBetweenSyncAttempts to ".concat(rt))) : (rt = Math.max(Bt / Re, yt), r.debug("Decreasing timeBetweenSyncAttempts to ".concat(rt))), G = rt;
                } catch {
                }
              }(Le), !ke && !isNaN(Le)) {
                Y = Date.now(), u = !1;
                var ut = isNaN(M);
                M = Le, ut && z(), r.debug("Completed UTC sync. Setting client - server offset to ".concat(Le));
              }
              ke && (H = null, u = !1, pe.error(new se.Z(ee.TIME_SYNC_FAILED_ERROR_CODE, ee.TIME_SYNC_FAILED_ERROR_MESSAGE))), Ee.trigger(o.Z.UPDATE_TIME_SYNC_OFFSET, { offset: Le }), Ee.trigger(o.Z.TIME_SYNCHRONIZATION_COMPLETED);
            }
            function Fe() {
              if (N && N.length !== 0) {
                var ke = N.reduce(function(Le, ut) {
                  return Le + ut;
                }, 0) / N.length;
                De(ke) ? r.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted.") : (r.debug("Completed background UTC sync. Setting client - server offset to ".concat(ke)), M = ke, Ee.trigger(o.Z.UPDATE_TIME_SYNC_OFFSET, { offset: M })), _ = !1, V = Date.now();
              }
            }
            function De(ke) {
              try {
                if (isNaN(M)) return !0;
                var Le = w.get().streaming.utcSynchronization.maximumAllowedDrift && !isNaN(w.get().streaming.utcSynchronization.maximumAllowedDrift) ? w.get().streaming.utcSynchronization.maximumAllowedDrift : 100;
                return ke >= M - Le && ke <= M + Le;
              } catch {
                return !0;
              }
            }
            return i = { initialize: function() {
              ue(), I = { "urn:mpeg:dash:utc:http-head:2014": U, "urn:mpeg:dash:utc:http-xsdate:2014": ne.bind(null, L), "urn:mpeg:dash:utc:http-iso:2014": ne.bind(null, A), "urn:mpeg:dash:utc:direct:2014": de, "urn:mpeg:dash:utc:http-head:2012": U, "urn:mpeg:dash:utc:http-xsdate:2012": ne.bind(null, L), "urn:mpeg:dash:utc:http-iso:2012": ne.bind(null, A), "urn:mpeg:dash:utc:direct:2012": de, "urn:mpeg:dash:utc:http-ntp:2014": X, "urn:mpeg:dash:utc:ntp:2014": X, "urn:mpeg:dash:utc:sntp:2014": X };
            }, attemptSync: function(ke, Le) {
              Z = ke, u || (function(ut) {
                try {
                  if (!ut || !w.get().streaming.utcSynchronization.enabled) return !1;
                  var ct = isNaN(G) ? 30 : G;
                  return !(Y && ct && !isNaN(ct)) || (Date.now() - Y) / 1e3 >= ct;
                } catch {
                  return !0;
                }
              }(Le) ? (u = !0, g()) : Ee.trigger(o.Z.TIME_SYNCHRONIZATION_COMPLETED));
            }, setConfig: function(ke) {
              ke && (ke.dashMetrics && (y = ke.dashMetrics), ke.baseURLController && (ae = ke.baseURLController), ke.errHandler && (pe = ke.errHandler), ke.settings && (w = ke.settings));
            }, reset: function() {
              ue(), Ee.off(o.Z.ATTEMPT_BACKGROUND_SYNC, z, i);
            } }, r = (0, m.Z)(he).getInstance().getLogger(i), Ee.on(o.Z.ATTEMPT_BACKGROUND_SYNC, z, i), i;
          }
          Ba.__dashjs_factory_name = "TimeSyncController";
          var Ua = v.Z.getSingletonFactory(Ba);
          Ua.HTTP_TIMEOUT_MS = 5e3, v.Z.updateSingletonFactory(Ba.__dashjs_factory_name, Ua);
          var jl = Ua;
          function xo() {
            var i, r, u, _, w, I = this.context, y = (0, p.Z)(I).getInstance();
            return i = { attachMediaSource: function(N) {
              var Z = window.URL.createObjectURL(r);
              return N.setSource(Z), _ === "managedMediaSource" && (N.setDisableRemotePlayback(!0), r.addEventListener("startstreaming", function() {
                y.trigger(n.Z.MANAGED_MEDIA_SOURCE_START_STREAMING);
              }), r.addEventListener("endstreaming", function() {
                y.trigger(n.Z.MANAGED_MEDIA_SOURCE_END_STREAMING);
              })), Z;
            }, createMediaSource: function() {
              var N = "WebKitMediaSource" in window, Z = "MediaSource" in window;
              return "ManagedMediaSource" in window ? (r = new ManagedMediaSource(), _ = "managedMediaSource", w.info("Created ManagedMediaSource")) : Z ? (r = new MediaSource(), _ = "mediaSource", w.info("Created MediaSource")) : N && (r = new WebKitMediaSource(), w.info("Created WebkitMediaSource")), r;
            }, detachMediaSource: function(N) {
              N.setSource(null);
            }, setConfig: function(N) {
              N && N.settings && (u = N.settings);
            }, setDuration: function N(Z) {
              r && r.readyState === "open" && (Z === null && isNaN(Z) || r.duration !== Z && (Z !== 1 / 0 || u.get().streaming.buffer.mediaSourceDurationInfinity || (Z = Math.pow(2, 32)), function(Y) {
                for (var V = Y.sourceBuffers, M = 0; M < V.length; M++) if (V[M].updating) return !0;
                return !1;
              }(r) ? setTimeout(N.bind(null, Z), 50) : (w.info("Set MediaSource duration:" + Z), r.duration = Z)));
            }, setSeekable: function(N, Z) {
              r && typeof r.setLiveSeekableRange == "function" && typeof r.clearLiveSeekableRange == "function" && r.readyState === "open" && N >= 0 && N < Z && (r.clearLiveSeekableRange(), r.setLiveSeekableRange(N, Z));
            }, signalEndOfStream: function(N) {
              if (N && N.readyState === "open") {
                for (var Z = N.sourceBuffers, Y = 0; Y < Z.length; Y++)
                  if (Z[Y].updating || Z[Y].buffered.length === 0) return;
                w.info("call to mediaSource endOfStream"), N.endOfStream();
              }
            } }, w = (0, m.Z)(I).getInstance().getLogger(i), i;
          }
          xo.__dashjs_factory_name = "MediaSourceController";
          var Yl = v.Z.getSingletonFactory(xo);
          function Fo() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M = "urn:mpeg:dash:event:2012", H = "discarded", G = "updated", pe = "added", ae = this.context, he = (0, p.Z)(ae).getInstance();
            function Ee() {
              if (!y || !N) throw new Error("setConfig function has to be called previously");
            }
            function j() {
              V = !1, u = {}, _ = {}, w = null, Y = !1, I = Date.now() / 1e3;
            }
            function ue() {
              try {
                if (!Y) {
                  Y = !0;
                  var X = N.getTime(), de = X - I;
                  de = I > 0 ? Math.max(0, de) : 0, z(_, de, X), z(u, de, X), me(_), me(u), I = X, Y = !1;
                }
              } catch (ne) {
                Y = !1, r.error(ne);
              }
            }
            function z(X, de, ne) {
              try {
                L(X, function(U) {
                  if (U !== void 0) {
                    var re = isNaN(U.duration) ? 0 : U.duration;
                    U.calculatedPresentationTime <= ne && U.calculatedPresentationTime + de + re >= ne ? oe(U, n.Z.EVENT_MODE_ON_START) : (A(ne, re + de, U.calculatedPresentationTime) || function(Te) {
                      try {
                        var Fe = Te.eventStream.period.start + Te.eventStream.period.duration;
                        return Te.calculatedPresentationTime > Fe;
                      } catch (De) {
                        return r.error(De), !1;
                      }
                    }(U)) && (r.debug("Removing event ".concat(U.id, " from period ").concat(U.eventStream.period.id, " as it is expired or invalid")), function(Te, Fe) {
                      try {
                        var De = Fe.eventStream.schemeIdUri, ke = Fe.eventStream.period.id, Le = Fe.eventStream.value, ut = Fe.id;
                        Te[ke][De] = Te[ke][De].filter(function(ct) {
                          return Le && ct.eventStream.value && ct.eventStream.value !== Le || ct.id !== ut;
                        }), Te[ke][De].length === 0 && delete Te[ke][De];
                      } catch (ct) {
                        r.error(ct);
                      }
                    }(X, U));
                  }
                });
              } catch (U) {
                r.error(U);
              }
            }
            function me(X) {
              try {
                for (var de in X) X.hasOwnProperty(de) && Object.keys(X[de]).length === 0 && delete X[de];
              } catch (ne) {
                r.error(ne);
              }
            }
            function g(X, de) {
              var ne = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], U = X.eventStream.schemeIdUri, re = X.eventStream.value, Te = X.id, Fe = H;
              de[U] || (de[U] = []);
              var De = de[U].findIndex(function(Le) {
                return (!re || Le.eventStream.value && Le.eventStream.value === re) && Le.id === Te;
              });
              if (De === -1) de[U].push(X), X.triggeredReceivedEvent = !1, X.triggeredStartEvent = !1, Fe = pe;
              else if (ne) {
                var ke = de[U][De];
                X.triggeredReceivedEvent = ke.triggeredReceivedEvent, X.triggeredStartEvent = ke.triggeredStartEvent, de[U][De] = X, Fe = G;
              }
              return Fe;
            }
            function x(X) {
              try {
                if (X.eventStream.value == 1) {
                  var de, ne = X.calculatedPresentationTime;
                  de = X.calculatedPresentationTime == 4294967295 ? NaN : X.calculatedPresentationTime + X.duration, he.trigger(n.Z.MANIFEST_VALIDITY_CHANGED, { id: X.id, validUntil: ne, newDuration: de, newManifestValidAfter: NaN }, { mode: n.Z.EVENT_MODE_ON_START });
                }
              } catch (U) {
                r.error(U);
              }
            }
            function O(X) {
              try {
                var de = N.getTime();
                L(X, function(ne) {
                  var U = ne.eventStream && ne.eventStream.period && !isNaN(ne.eventStream.period.duration) ? ne.eventStream.period.duration : NaN, re = ne.eventStream && ne.eventStream.period && !isNaN(ne.eventStream.period.start) ? ne.eventStream.period.start : NaN;
                  if (!isNaN(U) && !isNaN(re)) {
                    var Te = ne.calculatedPresentationTime;
                    Math.abs(Te - de) < 300 && oe(ne, n.Z.EVENT_MODE_ON_START);
                  }
                });
              } catch (ne) {
                r.error(ne);
              }
            }
            function L(X, de) {
              try {
                if (X) for (var ne = Object.keys(X), U = 0; U < ne.length; U++) for (var re = X[ne[U]], Te = Object.keys(re), Fe = 0; Fe < Te.length; Fe++) re[Te[Fe]].forEach(function(De) {
                  De !== void 0 && de(De);
                });
              } catch (De) {
                r.error(De);
              }
            }
            function A(X, de, ne) {
              try {
                return X - de > ne;
              } catch (U) {
                return r.error(U), !1;
              }
            }
            function oe(X, de) {
              try {
                var ne = N.getTime(), U = X.id;
                if (de === n.Z.EVENT_MODE_ON_RECEIVE && !X.triggeredReceivedEvent) return r.debug("Received event ".concat(U)), X.triggeredReceivedEvent = !0, void he.trigger(X.eventStream.schemeIdUri, { event: X }, { mode: de });
                X.triggeredStartEvent || (X.eventStream.schemeIdUri === M && X.eventStream.value == 1 ? X.duration === 0 && X.presentationTimeDelta === 0 || (r.debug("Starting manifest refresh event ".concat(U, " at ").concat(ne)), function() {
                  try {
                    Ee(), y.refreshManifest();
                  } catch (re) {
                    r.error(re);
                  }
                }()) : X.eventStream.schemeIdUri === "urn:mpeg:dash:event:callback:2015" && X.eventStream.value == 1 ? (r.debug("Starting callback event ".concat(U, " at ").concat(ne)), function(re) {
                  try {
                    (0, Ht.Z)(ae).create({}).load({ method: "get", url: re, request: { responseType: "arraybuffer" } });
                  } catch (Te) {
                    r.error(Te);
                  }
                }(X.messageData)) : (r.debug("Starting event ".concat(U, " from period ").concat(X.eventStream.period.id, " at ").concat(ne)), he.trigger(X.eventStream.schemeIdUri, { event: X }, { mode: de })), X.triggeredStartEvent = !0);
              } catch (re) {
                r.error(re);
              }
            }
            return i = { addInlineEvents: function(X, de) {
              try {
                if (Ee(), u[de] || (u[de] = {}), X) for (var ne = 0; ne < X.length; ne++) {
                  var U = X[ne];
                  if (!A(N.getTime(), isNaN(U.duration) ? 0 : U.duration, U.calculatedPresentationTime)) {
                    var re = g(U, u[de], !0);
                    re === pe ? (r.debug("Added inline event with id ".concat(U.id, " from period ").concat(de)), oe(U, n.Z.EVENT_MODE_ON_RECEIVE)) : re === G && r.debug("Updated inline event with id ".concat(U.id, " from period ").concat(de));
                  }
                }
              } catch (Te) {
                throw Te;
              }
            }, addInbandEvents: function(X, de) {
              try {
                Ee(), _[de] || (_[de] = {});
                for (var ne = 0; ne < X.length; ne++) {
                  var U = X[ne];
                  A(N.getTime(), isNaN(U.duration) ? 0 : U.duration, U.calculatedPresentationTime) || (g(U, _[de], !1) === pe ? (U.eventStream.schemeIdUri === M && x(U), r.debug("Added inband event with id ".concat(U.id, " from period ").concat(de)), oe(U, n.Z.EVENT_MODE_ON_RECEIVE)) : r.debug("Inband event with scheme_id_uri ".concat(U.eventStream.schemeIdUri, ", value ").concat(U.eventStream.value, ", period id ").concat(de, " and event id ").concat(U.id, " was ignored because it has been added before.")));
                }
                ue();
              } catch (re) {
                throw re;
              }
            }, getInbandEvents: function() {
              return _;
            }, getInlineEvents: function() {
              return u;
            }, start: function() {
              try {
                Ee(), r.debug("Start Event Controller");
                var X = Z.get().streaming.eventControllerRefreshDelay;
                V || isNaN(X) || (V = !0, w = setInterval(ue, X));
              } catch (de) {
                throw de;
              }
            }, setConfig: function(X) {
              try {
                if (!X) return;
                X.manifestUpdater && (y = X.manifestUpdater), X.playbackController && (N = X.playbackController), X.settings && (Z = X.settings);
              } catch (de) {
                throw de;
              }
            }, reset: function() {
              (function() {
                try {
                  w !== null && V && (clearInterval(w), w = null, V = !1, function() {
                    try {
                      O(_), O(u);
                    } catch (X) {
                      r.error(X);
                    }
                  }());
                } catch (X) {
                  throw X;
                }
              })(), j();
            } }, r = (0, m.Z)(ae).getInstance().getLogger(i), j(), i;
          }
          Fo.__dashjs_factory_name = "EventController";
          var Kl = v.Z.getSingletonFactory(Fo), pi = { LEVELS: { SUGGESTION: "Suggestion", WARNING: "Warning", ERROR: "Error" }, EVENTS: { NO_UTC_TIMING_ELEMENT: { key: "NO_UTC_TIMING_ELEMENT", message: "No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/" }, NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE: { key: "NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE", message: 'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"' }, INVALID_DVR_WINDOW: { key: "INVALID_DVR_WINDOW", message: "No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback." } } };
          function Ga(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function ko() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j, ue, z, me, g, x, O, L, A, oe, X, de, ne, U, re, Te, Fe, De, ke, Le, ut, ct, rt, at, Bt, Re, He, yt, Qe, Tt, vt = this.context, mt = (0, p.Z)(vt).getInstance();
            function Wt() {
              if (!(I && I.hasOwnProperty("load") && z && z.hasOwnProperty("initialize") && z.hasOwnProperty("reset") && z.hasOwnProperty("getClientTimeOffset") && y && ue && Z && re)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            function zt() {
              if (!w || !w.hasOwnProperty("setManifest")) throw new Error("initialize function has to be called previously");
            }
            function hn() {
              (function() {
                try {
                  var nt = N.getStreamsInfo();
                  if (!g && nt.length === 0) throw new Error("There are no periods in the MPD");
                  g && nt.length > 0 && Z.updateManifestUpdateInfo({ currentTime: re.getTime(), buffered: U.getBufferRange(), presentationStartTime: nt[0].start, clientTimeOffset: z.getClientTimeOffset() }), me.length > 0 && function(In) {
                    In.length !== 0 ? me = me.filter(function(En) {
                      var Vn = In.filter(function(kn) {
                        return kn.id === En.getId();
                      }).length > 0 || En.getId() === g.getId();
                      return Vn || (r.debug("Removing stream ".concat(En.getId())), En.reset(!0)), Vn;
                    }) : r.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");
                  }(nt);
                  for (var Lt = [], sn = 0, mn = nt.length; sn < mn; sn++) {
                    var Sn = nt[sn];
                    Lt.push(ze(Sn)), Z.addManifestUpdateStreamInfo(Sn);
                  }
                  Promise.all(Lt).then(function() {
                    return new Promise(function(In, En) {
                      g ? In() : Et(nt, In, En);
                    });
                  }).then(function() {
                    mt.trigger(o.Z.STREAMS_COMPOSED), xt();
                  }).catch(function(In) {
                    throw In;
                  });
                } catch (In) {
                  ue.error(new se.Z(ee.MANIFEST_ERROR_ID_NOSTREAMS_CODE, In.message + " nostreamscomposed", y.getValue())), de = !0, zr();
                }
              })();
            }
            function yn() {
              He = !0;
            }
            function ze(nt) {
              var Lt = Mi(nt.id);
              return Lt ? Lt.updateData(nt) : (Lt = $r(vt).create({ manifestModel: y, mediaPlayerModel: Fe, dashMetrics: Z, manifestUpdater: w, adapter: N, timelineConverter: z, capabilities: u, capabilitiesFilter: _, errHandler: ue, baseURLController: H, segmentBaseController: G, textController: O, abrController: ae, playbackController: re, eventController: Ee, mediaController: he, protectionController: x, videoModel: U, streamInfo: nt, settings: Re }), me.push(Lt), Lt.initialize(), Promise.resolve());
            }
            function Et(nt, Lt, sn) {
              try {
                Xt();
                var mn = Z.getCurrentDVRInfo().range;
                if (mn.end < mn.start) {
                  yt && clearTimeout(yt);
                  var Sn = Math.min(1e3 * (-1 * (mn.end - mn.start) + 2), 2147483647);
                  return r.debug("Waiting for ".concat(Sn, " ms before playback can start")), mt.trigger(o.Z.AST_IN_FUTURE, { delay: Sn }), void (yt = setTimeout(function() {
                    Et(nt, Lt, sn);
                  }, Sn));
                }
                Re.get().streaming.applyProducerReferenceTime && Te.calculateProducerReferenceTimeOffsets(nt);
                var In = nt[0].manifestInfo;
                if (Re.get().streaming.applyServiceDescription && Te.applyServiceDescription(In), N.getIsDynamic()) {
                  var En = ei(nt, In);
                  re.computeAndSetLiveDelay(En, In);
                }
                (Re.get().streaming.applyContentSteering && M.shouldQueryBeforeStart() ? M.loadSteeringData() : Promise.resolve()).then(function() {
                  var Vn = y.getValue();
                  Vn && H.update(Vn), lt(), Lt();
                }).catch(function(Vn) {
                  r.error(Vn), lt(), Lt();
                });
              } catch (Vn) {
                sn(Vn);
              }
            }
            function lt() {
              var nt = function() {
                var mn;
                if (N.getIsDynamic()) {
                  var Sn = Z.getCurrentDVRInfo();
                  mn = (Sn && Sn.range ? Sn.range.end : 0) - re.getOriginalLiveDelay();
                  var In = Sn ? Sn.range : null;
                  if (In) {
                    if (isNaN(Qe) && Qe.toString().indexOf("posix:") === -1) {
                      var En = yr(!0);
                      isNaN(En) || (r.info("Start time from URI parameters: ".concat(En)), mn = Math.min(mn, En));
                    } else {
                      r.info("Start time provided by the app: ".concat(Qe));
                      var Vn = nr(!0, Qe);
                      isNaN(Vn) || (mn = Math.min(mn, Vn));
                    }
                    var kn = Re.get().streaming.timeShiftBuffer.calcFromSegmentTimeline ? 0.1 : 0;
                    mn = Math.max(mn, In.start + kn);
                  }
                } else if (mn = ri()[0].getStreamInfo().start, isNaN(Qe)) {
                  var Gr = yr(!1);
                  isNaN(Gr) || (r.info("Start time from URI parameters: ".concat(Gr)), mn = Math.max(mn, Gr));
                } else {
                  r.info("Start time provided by the app: ".concat(Qe));
                  var vi = nr(!1, Qe);
                  isNaN(vi) || (mn = Math.max(mn, vi));
                }
                return mn;
              }(), Lt = Vt(nt), sn = Lt !== null ? Lt : me[0];
              mt.trigger(o.Z.INITIAL_STREAM_SWITCH, { startTime: nt }), wt(sn, null, nt), ct || (ct = setInterval(function() {
                !oe && re.getTimeToStreamEnd() <= 0 && !re.isSeeking() && mt.trigger(o.Z.PLAYBACK_ENDED, { isLast: Lr().isLast });
              }, 200));
            }
            function wt(nt, Lt, sn) {
              try {
                if (oe || !nt || Lt === nt && nt.getIsActive()) return;
                oe = !0, mt.trigger(o.Z.PERIOD_SWITCH_STARTED, { fromStreamInfo: Lt ? Lt.getStreamInfo() : null, toStreamInfo: nt.getStreamInfo() });
                var mn = !1;
                g = nt, Lt && (mn = kt(nt, Lt), Lt.deactivate(mn)), sn = isNaN(sn) ? !mn && Lt ? nt.getStreamInfo().start : NaN : sn, r.info("Switch to stream ".concat(nt.getId(), ". Seektime is ").concat(sn, ", current playback time is ").concat(re.getTime(), ". Seamless period switch is set to ").concat(mn)), at = at.filter(function(Sn) {
                  return Sn.getId() !== g.getId();
                }), re.initialize(Lr(), !!Lt), U.getElement() ? Pt(sn, mn, !1) : $t(sn, mn);
              } catch {
                oe = !1;
              }
            }
            function Pt(nt, Lt) {
              var sn, mn = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              function Sn() {
                if (ne && ne.readyState === "open") {
                  r.debug("MediaSource is open!"), window.URL.revokeObjectURL(sn), ne.removeEventListener("sourceopen", Sn), ne.removeEventListener("webkitsourceopen", Sn), Mn();
                  var En = Z.getCurrentDVRInfo();
                  Y.setSeekable(En.range.start, En.range.end), mn ? (isNaN(nt) || re.seek(nt, !0, !0), g.setMediaSource(ne).then(function() {
                    g.initializeForTextWithMediaSource(ne);
                  })) : $t(nt, Lt);
                }
              }
              function In() {
                ne.addEventListener("sourceopen", Sn, !1), ne.addEventListener("webkitsourceopen", Sn, !1), sn = Y.attachMediaSource(U), r.debug("MediaSource attached to element.  Waiting on open...");
              }
              ne ? Lt ? $t(nt, Lt) : (Y.detachMediaSource(U), In()) : (ne = Y.createMediaSource(), In());
            }
            function $t(nt, Lt) {
              g.activate(ne, Lt ? rt : void 0, nt).then(function(sn) {
                if (sn) {
                  var mn = Object.keys(sn);
                  mn.length > 0 && sn[mn[0]].getBuffer().changeType && (Bt = !0), rt = sn;
                }
                isNaN(nt) || (mt.trigger(o.Z.SEEK_TARGET, { time: nt }, { streamId: g.getId() }), re.seek(nt, !1, !0), g.startScheduleControllers()), oe = !1, mt.trigger(o.Z.PERIOD_SWITCH_COMPLETED, { toStreamInfo: Lr() });
              });
            }
            function Qt(nt) {
              var Lt = Vt(nt.seekTime);
              Lt && Lt !== g ? Lt && Lt !== g && (en(), function(sn, mn) {
                var Sn = sn && !isNaN(sn.seekTime) ? sn.seekTime : NaN, In = g.getProcessors().map(function(En) {
                  return En.prepareOuterPeriodPlaybackSeeking(sn);
                });
                Promise.all(In).then(function() {
                  wt(mn, g, Sn);
                }).catch(function(En) {
                  ue.error(En);
                });
              }(nt, Lt)) : (en(), function(sn) {
                g.getProcessors().forEach(function(mn) {
                  return mn.prepareInnerPeriodPlaybackSeeking(sn);
                }), _r(Me.USER_REQUEST_STOP_REASON);
              }(nt)), Kr(xe.SEEK_START_REASON);
            }
            function en() {
              ln();
            }
            function ln() {
              at && at.length > 0 && (at.forEach(function(nt) {
                nt.deactivate(!0);
              }), at = []);
            }
            function pt(nt) {
              if (nt.newMediaInfo.streamInfo.id === g.getId()) {
                if (ln(), Re.get().streaming.buffer.resetSourceBuffersForTrackSwitch && nt.oldMediaInfo && nt.oldMediaInfo.codec !== nt.newMediaInfo.codec) {
                  var Lt = re.getTime();
                  return g.deactivate(!1), void Pt(Lt, !1, !1);
                }
                g.prepareTrackChange(nt);
              }
            }
            function kt(nt, Lt) {
              try {
                return Re.get().streaming.buffer.reuseExistingSourceBuffers && (Lt.isProtectionCompatible(nt) || He) && (Bt && Re.get().streaming.buffer.useChangeTypeForTrackSwitch || Lt.isMediaCodecCompatible(nt, Lt));
              } catch {
                return !1;
              }
            }
            function qt(nt) {
              var Lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (ne && !nt.getPreloaded()) {
                var sn = kt(nt, Lt);
                sn && nt.startPreloading(ne, rt).then(function() {
                  at.push(nt);
                });
              }
            }
            function Vt(nt) {
              if (isNaN(nt)) return null;
              for (var Lt = me.length, sn = 0; sn < Lt; sn++) {
                var mn = me[sn];
                if (nt < parseFloat((mn.getStartTime() + mn.getDuration()).toFixed(5))) return mn;
              }
              return null;
            }
            function Xt() {
              try {
                var nt = N.getIsDynamic(), Lt = N.getStreamsInfo()[0].manifestInfo, sn = re.getTime(), mn = z.calcTimeShiftBufferWindow(me, nt), Sn = Ln();
                if (mn.start === void 0 || mn.end === void 0) return;
                Sn && Sn.length !== 0 ? Sn.forEach(function(In) {
                  Z.addDVRInfo(In.getType(), sn, Lt, mn);
                }) : Z.addDVRInfo(t.Z.VIDEO, sn, Lt, mn);
              } catch {
              }
            }
            function We(nt) {
              if (Le && A) {
                var Lt = Fe.getInitialBufferLevel(), sn = [t.Z.TEXT];
                (isNaN(Lt) || Lt <= re.getBufferLevel(sn) || N.getIsDynamic() && Lt > re.getLiveDelay()) && (Le = !1, Kr(xe.INITIAL_PLAYOUT_START_REASON), re.play());
              }
              nt && nt.mediaType && Z.addBufferLevel(nt.mediaType, /* @__PURE__ */ new Date(), 1e3 * nt.bufferLevel);
            }
            function Pe(nt) {
              nt.streamInfo.id === g.getId() && nt.reason && nt.reason.forceReplace && ln(), Mi(nt.streamInfo.id).prepareQualityChange(nt);
            }
            function ft() {
              if (N.getIsDynamic() && re.getOriginalLiveDelay() !== 0 && g) {
                var nt = N.getStreamsInfo();
                if (nt.length > 0) {
                  var Lt = nt[0].manifestInfo, sn = ei(nt, Lt);
                  re.computeAndSetLiveDelay(sn, Lt);
                }
              }
            }
            function ye() {
              if (kr()) {
                var nt = U.getPlaybackQuality();
                nt && Z.addDroppedFrames(nt);
              }
            }
            function Ae() {
              r.debug("[onPlaybackStarted]"), !Le && ke && Kr(xe.RESUME_FROM_PAUSE_START_REASON), Le && (Le = !1), ut && (ut = !1, Re.get().streaming.applyContentSteering && !M.shouldQueryBeforeStart() && M.loadSteeringData()), ke = !1;
            }
            function tt(nt) {
              r.debug("[onPlaybackPaused]"), nt.ended || (ke = !0, _r(Me.USER_REQUEST_STOP_REASON));
            }
            function Nt(nt) {
              r.debug("Stream with id ".concat(nt.streamInfo.id, " finished buffering"));
              var Lt = nt.streamInfo.isLast;
              ne && Lt ? (r.info("[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController."), Y.signalEndOfStream(ne)) : xt();
            }
            function xt() {
              if (g && g.getHasFinishedBuffering()) for (var nt = function() {
                var Sn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                try {
                  var In = Sn || g || null;
                  if (In) {
                    var En = In.getStreamInfo();
                    return me.filter(function(Vn) {
                      var kn = Vn.getStreamInfo();
                      return kn.start > En.start && En.id !== kn.id;
                    });
                  }
                } catch {
                  return [];
                }
              }(g), Lt = 0; Lt < nt.length; ) {
                var sn = nt[Lt], mn = Lt === 0 ? g : nt[Lt - 1];
                !sn.getPreloaded() && mn.getHasFinishedBuffering() && ne && qt(sn, mn), Lt += 1;
              }
            }
            function _n() {
              ct && (clearInterval(ct), ct = null);
            }
            function Ln() {
              return g ? g.getProcessors() : [];
            }
            function $n(nt) {
              if (g && !g.getIsEndedEventSignaled()) {
                g.setIsEndedEventSignaled(!0);
                var Lt = function() {
                  var sn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, mn = sn || g || null;
                  if (!mn) return null;
                  for (var Sn = mn.getStreamInfo(), In = Sn.start, En = 0, Vn = -1, kn = NaN; En < me.length; ) {
                    var Gr = me[En].getStreamInfo(), vi = Gr.start - In;
                    vi > 0 && (isNaN(kn) || vi < kn) && Sn.id !== Gr.id && (kn = vi, Vn = En), En += 1;
                  }
                  return Vn >= 0 ? me[Vn] : null;
                }();
                Lt ? (r.debug("StreamController onEnded, found next stream with id ".concat(Lt.getStreamInfo().id, ". Switching from ").concat(g.getStreamInfo().id, " to ").concat(Lt.getStreamInfo().id)), wt(Lt, g, NaN)) : (r.debug("StreamController no next stream found"), g.setIsEndedEventSignaled(!1)), _r(Lt ? Me.END_OF_PERIOD_STOP_REASON : Me.END_OF_CONTENT_STOP_REASON);
              }
              nt && nt.isLast && (_n(), M.stopSteeringRequestTimer());
            }
            function Mn(nt) {
              var Lt = nt || Lr().manifestInfo.duration;
              Y.setDuration(Lt);
            }
            function yr(nt) {
              var Lt = pe.getURIFragmentData();
              if (!Lt || !Lt.t) return NaN;
              var sn = ri()[0].getStreamInfo().start;
              return Lt.t = Lt.t.split(",")[0], Yr(nt, Lt.t, sn);
            }
            function nr(nt, Lt) {
              var sn = 0;
              return nt || (sn = ri()[0].getStreamInfo().start), Yr(nt, Lt, sn);
            }
            function Yr(nt, Lt, sn) {
              var mn = N.getRegularPeriods()[0], Sn = Lt.toString(), In = Sn.indexOf("posix:") !== -1 ? Sn.substring(6) === "now" ? Date.now() / 1e3 : parseFloat(Sn.substring(6)) : NaN;
              return nt && !isNaN(In) ? z.calcPresentationTimeFromWallTime(new Date(1e3 * In), mn) : parseFloat(Sn) + sn;
            }
            function ei(nt, Lt) {
              try {
                var sn = NaN;
                if (Lt && !isNaN(Lt.maxFragmentDuration) && isFinite(Lt.maxFragmentDuration)) return Lt.maxFragmentDuration;
                if (nt && nt.length === 1) {
                  var mn = nt[0], Sn = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT].reduce(function(En, Vn) {
                    var kn = N.getMediaInfoForType(mn, Vn);
                    return kn && kn.isFragmented !== !1 && En.push(kn), En;
                  }, []).reduce(function(En, Vn) {
                    var kn = N.getVoRepresentations(Vn);
                    return kn && kn.length > 0 && kn.forEach(function(Gr) {
                      Gr && En.push(Gr);
                    }), En;
                  }, []).reduce(function(En, Vn) {
                    var kn = N.convertRepresentationToRepresentationInfo(Vn);
                    return kn && kn.fragmentDuration && !isNaN(kn.fragmentDuration) && En.push(kn.fragmentDuration), En;
                  }, []);
                  sn = Math.max.apply(Math, function(En) {
                    if (Array.isArray(En)) return Ga(En);
                  }(In = Sn) || function(En) {
                    if (typeof Symbol < "u" && Symbol.iterator in Object(En)) return Array.from(En);
                  }(In) || function(En, Vn) {
                    if (En) {
                      if (typeof En == "string") return Ga(En, Vn);
                      var kn = Object.prototype.toString.call(En).slice(8, -1);
                      return kn === "Object" && En.constructor && (kn = En.constructor.name), kn === "Map" || kn === "Set" ? Array.from(En) : kn === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(kn) ? Ga(En, Vn) : void 0;
                    }
                  }(In) || function() {
                    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                  }());
                }
                return isFinite(sn) ? sn : NaN;
              } catch {
                return NaN;
              }
              var In;
            }
            function ti(nt) {
              if (nt.error) de = !0, zr();
              else {
                r.info("Manifest updated... updating data system wide.");
                var Lt = nt.manifest;
                N.updatePeriods(Lt);
                var sn = N.getUTCTimingSources();
                !N.getIsDynamic() || sn && sn.length !== 0 || mt.trigger(n.Z.CONFORMANCE_VIOLATION, { level: pi.LEVELS.WARNING, event: pi.EVENTS.NO_UTC_TIMING_ELEMENT });
                var mn = N.getIsDynamic() ? sn.concat(De.getUTCTimingSources()) : sn;
                _.filterUnsupportedFeatures(Lt).then(function() {
                  H.initialize(Lt), V.attemptSync(mn, N.getIsDynamic());
                });
              }
            }
            function kr() {
              return !!g && g.getHasVideoTrack();
            }
            function Ur() {
              return !!g && g.getHasAudioTrack();
            }
            function _r(nt, Lt) {
              Lt = Lt || /* @__PURE__ */ new Date(), Ln().forEach(function(sn) {
                sn.finalisePlayList(Lt, nt);
              }), Z.addPlayList();
            }
            function Kr(nt) {
              Z.createPlaylistMetrics(1e3 * re.getTime(), nt);
            }
            function ni(nt) {
              if (nt.error) {
                var Lt = "";
                switch (nt.error.code) {
                  case 1:
                    Lt = "MEDIA_ERR_ABORTED";
                    break;
                  case 2:
                    Lt = "MEDIA_ERR_NETWORK";
                    break;
                  case 3:
                    Lt = "MEDIA_ERR_DECODE", Tt.counts.mediaErrorDecode += 1;
                    break;
                  case 4:
                    Lt = "MEDIA_ERR_SRC_NOT_SUPPORTED";
                    break;
                  case 5:
                    Lt = "MEDIA_ERR_ENCRYPTED";
                    break;
                  default:
                    Lt = "UNKNOWN";
                }
                Lt === "MEDIA_ERR_DECODE" && Re.get().errors.recoverAttempts.mediaErrorDecode >= Tt.counts.mediaErrorDecode ? function() {
                  r.warn("A MEDIA_ERR_DECODE occured: Resetting the MediaSource");
                  var sn = re.getTime();
                  g.deactivate(!1), r.warn("MediaSource has been resetted. Resuming playback from time ".concat(sn)), Pt(sn, !1, !1);
                }() : (X = !0, nt.error.message && (Lt += " (" + nt.error.message + ")"), nt.error.msExtendedCode && (Lt += " (0x" + (nt.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ")"), r.fatal("Video Element Error: " + Lt), nt.error && r.fatal(nt.error), ue.error(new se.Z(nt.error.code, Lt)), zr());
              }
            }
            function Lr() {
              return g ? g.getStreamInfo() : null;
            }
            function Mi(nt) {
              for (var Lt = 0, sn = me.length; Lt < sn; Lt++) if (me[Lt].getId() === nt) return me[Lt];
              return null;
            }
            function ua(nt) {
              isNaN(nt.newDuration) || Mn(nt.newDuration);
            }
            function ca() {
              me = [], Qe = NaN, x = null, oe = !1, g = null, X = !1, de = !1, Le = !0, ut = !0, ke = !1, A = !0, ct = null, He = !1, Bt = !1, at = [], yt = null, Tt = { counts: { mediaErrorDecode: 0 } };
            }
            function zr() {
              Wt(), V.reset(), _r(X || de ? Me.FAILURE_STOP_REASON : Me.USER_REQUEST_STOP_REASON);
              for (var nt = 0, Lt = me ? me.length : 0; nt < Lt; nt++) me[nt].reset(X);
              mt.off(n.Z.PLAYBACK_TIME_UPDATED, ye, i), mt.off(n.Z.PLAYBACK_SEEKING, Qt, i), mt.off(n.Z.PLAYBACK_ERROR, ni, i), mt.off(n.Z.PLAYBACK_STARTED, Ae, i), mt.off(n.Z.PLAYBACK_PAUSED, tt, i), mt.off(n.Z.PLAYBACK_ENDED, $n, i), mt.off(n.Z.METRIC_ADDED, fa, i), mt.off(n.Z.MANIFEST_VALIDITY_CHANGED, ua, i), mt.off(n.Z.BUFFER_LEVEL_UPDATED, We, i), mt.off(n.Z.QUALITY_CHANGE_REQUESTED, Pe, i), o.Z.KEY_SESSION_UPDATED && mt.off(o.Z.KEY_SESSION_UPDATED, yn, i), mt.off(o.Z.MANIFEST_UPDATED, ti, i), mt.off(o.Z.STREAM_BUFFERING_COMPLETED, Nt, i), mt.off(o.Z.TIME_SYNCHRONIZATION_COMPLETED, hn, i), mt.off(o.Z.CURRENT_TRACK_CHANGED, pt, i), mt.off(o.Z.SETTING_UPDATED_LIVE_DELAY, ft, i), mt.off(o.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, ft, i), H.reset(), w.reset(), Ee.reset(), Z.clearAllCurrentMetrics(), y.setValue(null), I.reset(), z.reset(), j.reset(), ne && (Y.detachMediaSource(U), ne = null), U = null, x && (x = null, L = null, y.getValue() && mt.trigger(o.Z.PROTECTION_DESTROYED, { data: y.getValue().url })), _n(), mt.trigger(o.Z.STREAM_TEARDOWN_COMPLETE), ca();
            }
            function fa(nt) {
              if (nt.metric === h.Z.DVR_INFO) {
                var Lt = Ur() ? t.Z.AUDIO : t.Z.VIDEO;
                nt.mediaType === Lt && Y.setSeekable(nt.value.range.start, nt.value.range.end);
              }
            }
            function ri() {
              return me;
            }
            return i = { initialize: function(nt, Lt) {
              Wt(), A = nt, L = Lt, z.initialize(), (w = Po(vt).create()).setConfig({ manifestModel: y, adapter: N, manifestLoader: I, errHandler: ue, settings: Re, contentSteeringController: M }), w.initialize(), (Ee = Kl(vt).getInstance()).setConfig({ manifestUpdater: w, playbackController: re, settings: Re }), Ee.start(), V.setConfig({ dashMetrics: Z, baseURLController: H, errHandler: ue, settings: Re }), V.initialize(), Y.setConfig({ settings: Re }), x && (mt.trigger(o.Z.PROTECTION_CREATED, { controller: x }), x.setMediaElement(U.getElement()), L && x.setProtectionData(L)), mt.on(n.Z.PLAYBACK_TIME_UPDATED, ye, i), mt.on(n.Z.PLAYBACK_SEEKING, Qt, i), mt.on(n.Z.PLAYBACK_ERROR, ni, i), mt.on(n.Z.PLAYBACK_STARTED, Ae, i), mt.on(n.Z.PLAYBACK_PAUSED, tt, i), mt.on(n.Z.PLAYBACK_ENDED, $n, i), mt.on(n.Z.METRIC_ADDED, fa, i), mt.on(n.Z.MANIFEST_VALIDITY_CHANGED, ua, i), mt.on(n.Z.BUFFER_LEVEL_UPDATED, We, i), mt.on(n.Z.QUALITY_CHANGE_REQUESTED, Pe, i), o.Z.KEY_SESSION_UPDATED && mt.on(o.Z.KEY_SESSION_UPDATED, yn, i), mt.on(o.Z.MANIFEST_UPDATED, ti, i), mt.on(o.Z.STREAM_BUFFERING_COMPLETED, Nt, i), mt.on(o.Z.TIME_SYNCHRONIZATION_COMPLETED, hn, i), mt.on(o.Z.CURRENT_TRACK_CHANGED, pt, i), mt.on(o.Z.SETTING_UPDATED_LIVE_DELAY, ft, i), mt.on(o.Z.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, ft, i);
            }, getActiveStreamInfo: Lr, addDVRMetric: Xt, hasVideoTrack: kr, hasAudioTrack: Ur, getStreamById: Mi, getStreamForTime: Vt, getTimeRelativeToStreamId: function(nt, Lt) {
              for (var sn = null, mn = 0, Sn = 0, In = null, En = 0; En < me.length; En++) {
                if (Sn = (sn = me[En]).getStartTime(), In = sn.getDuration(), Number.isFinite(Sn) && (mn = Sn), sn.getId() === Lt) return nt - mn;
                Number.isFinite(In) && (mn += In);
              }
              return null;
            }, load: function(nt) {
              var Lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              Wt(), Qe = Lt, I.load(nt);
            }, loadWithManifest: function(nt) {
              var Lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              zt(), Qe = Lt, w.setManifest(nt);
            }, getActiveStreamProcessors: Ln, setConfig: function(nt) {
              nt && (nt.capabilities && (u = nt.capabilities), nt.capabilitiesFilter && (_ = nt.capabilitiesFilter), nt.manifestLoader && (I = nt.manifestLoader), nt.manifestModel && (y = nt.manifestModel), nt.mediaPlayerModel && (Fe = nt.mediaPlayerModel), nt.customParametersModel && (De = nt.customParametersModel), nt.protectionController && (x = nt.protectionController), nt.adapter && (N = nt.adapter), nt.dashMetrics && (Z = nt.dashMetrics), nt.errHandler && (ue = nt.errHandler), nt.timelineConverter && (z = nt.timelineConverter), nt.videoModel && (U = nt.videoModel), nt.playbackController && (re = nt.playbackController), nt.serviceDescriptionController && (Te = nt.serviceDescriptionController), nt.contentSteeringController && (M = nt.contentSteeringController), nt.textController && (O = nt.textController), nt.abrController && (ae = nt.abrController), nt.mediaController && (he = nt.mediaController), nt.settings && (Re = nt.settings), nt.baseURLController && (H = nt.baseURLController), nt.uriFragmentModel && (pe = nt.uriFragmentModel), nt.segmentBaseController && (G = nt.segmentBaseController), nt.manifestUpdater && (w = nt.manifestUpdater));
            }, setProtectionData: function(nt) {
              L = nt, x && x.setProtectionData(L);
            }, getIsStreamSwitchInProgress: function() {
              return oe;
            }, switchToVideoElement: function(nt) {
              g && (re.initialize(Lr()), Pt(nt, !1, !0));
            }, getHasMediaOrInitialisationError: function() {
              return X || de;
            }, getStreams: ri, getActiveStream: function() {
              return g;
            }, getInitialPlayback: function() {
              return Le;
            }, getAutoPlay: function() {
              return A;
            }, refreshManifest: function() {
              w.getIsUpdating() || w.refreshManifest();
            }, reset: zr }, r = (0, m.Z)(vt).getInstance().getLogger(i), V = jl(vt).getInstance(), Y = Yl(vt).getInstance(), j = we(vt).getInstance(), ca(), i;
          }
          ko.__dashjs_factory_name = "StreamController";
          var Zo = v.Z.getSingletonFactory(ko);
          function Bo() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H = this.context, G = (0, p.Z)(H).getInstance();
            function pe() {
              M.debug("Stopping the gap controller"), w && (clearInterval(w), w = null), function() {
                G.off(o.Z.WALLCLOCK_TIME_UPDATED, ue, this), G.off(o.Z.INITIAL_STREAM_SWITCH, j, this), G.off(o.Z.PLAYBACK_SEEKING, ae, this), G.off(o.Z.BUFFER_REPLACEMENT_STARTED, he, i), G.off(o.Z.TRACK_CHANGE_RENDERED, Ee, i);
              }(), w = null, I = NaN, _ = 0, Y = null, V = {};
            }
            function ae() {
              Y && (clearTimeout(Y), Y = null);
            }
            function he(L) {
              try {
                if (L.streamId !== N.getActiveStreamInfo().id || L.mediaType !== t.Z.VIDEO && L.mediaType !== t.Z.AUDIO) return;
                L.streamId === N.getActiveStreamInfo().id && (V[L.mediaType] = !0);
              } catch (A) {
                M.error(A);
              }
            }
            function Ee(L) {
              L && L.mediaType && (V[L.mediaType] = !1);
            }
            function j() {
              w || function() {
                try {
                  w || (M.debug("Starting the gap controller"), w = setInterval(function() {
                    z() && O(y.getTime());
                  }, 100));
                } catch {
                }
              }();
            }
            function ue() {
              if (z(u.get().streaming.gaps.enableSeekFix) && ++_ >= 10) {
                var L = y.getTime();
                r === L ? O(L, !0) : (r = L, I = NaN), _ = 0;
              }
            }
            function z() {
              var L = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
              if (!N.getActiveStream()) return !1;
              var A = Object.keys(V).some(function(X) {
                return V[X];
              }), oe = !!L && me();
              return !A && u.get().streaming.gaps.jumpGaps && N.getActiveStreamProcessors().length > 0 && (!y.isSeeking() || oe) && !y.isPaused() && !N.getIsStreamSwitchInProgress() && !N.getHasMediaOrInitialisationError();
            }
            function me() {
              var L = N.getActiveStream(), A = parseFloat((L.getStartTime() + L.getDuration()).toFixed(5));
              return y.getTime() + u.get().streaming.gaps.threshold >= A;
            }
            function g(L, A) {
              try {
                if (!L || L.length <= 1 && A > 0) return NaN;
                for (var oe = NaN, X = 0; isNaN(oe) && X < L.length; ) {
                  var de = X > 0 ? L.end(X - 1) : 0;
                  A < L.start(X) && de - A < u.get().streaming.gaps.threshold && (oe = X), X += 1;
                }
                return oe;
              } catch {
                return null;
              }
            }
            function x(L, A) {
              for (var oe = 0, X = L.length; oe < X; oe++) if (A >= L.start(oe) && A <= L.end(oe)) return !0;
              return !1;
            }
            function O(L) {
              var A, oe = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], X = u.get().streaming.gaps.enableStallFix, de = u.get().streaming.gaps.stallSeek, ne = u.get().streaming.gaps.smallGapLimit, U = u.get().streaming.gaps.jumpLargeGaps, re = Z.getBufferRange(), Te = NaN, Fe = !1;
              if (A = g(re, L), !isNaN(A)) {
                var De = re.start(A), ke = De - L;
                ke > 0 && (ke <= ne || U) && (Te = De);
              }
              var Le = y.getTimeToStreamEnd();
              if (isNaN(Te) && oe && isFinite(Le) && !isNaN(Le) && Le < ne && (Te = parseFloat(y.getStreamEndTime().toFixed(5)), Fe = !0), X && isNaN(Te) && oe && isNaN(A) && x(re, L) && (de === 0 ? (M.warn("Toggle play pause to break stall"), Z.pause(), Z.play()) : (M.warn("Jumping ".concat(de, "s to break stall")), Te = L + de)), Te > 0 && I !== Te && Te > L && !Y) {
                var ut = Te - L;
                if (Fe) {
                  var ct = N.getStreamForTime(Te), rt = ct && !!ct.getPreloaded();
                  M.warn("Jumping to end of stream because of gap from ".concat(L, " to ").concat(Te, ". Gap duration: ").concat(ut)), y.seek(Te, !0, rt);
                } else {
                  var at = y.getIsDynamic(), Bt = A > 0 ? re.end(A - 1) : L, Re = at ? 1e3 * Math.max(0, ut - 0.1) : 0;
                  Y = window.setTimeout(function() {
                    y.seek(Te, !0, !0), M.warn("Jumping gap occuring in period ".concat(N.getActiveStream().getStreamId(), " starting at ").concat(Bt, " and ending at ").concat(Te, ". Jumping by: ").concat(Te - Bt)), Y = null;
                  }, Re);
                }
                I = Te;
              }
            }
            return i = { reset: pe, setConfig: function(L) {
              L && (L.settings && (u = L.settings), L.playbackController && (y = L.playbackController), L.streamController && (N = L.streamController), L.videoModel && (Z = L.videoModel));
            }, initialize: function() {
              (function() {
                G.on(o.Z.WALLCLOCK_TIME_UPDATED, ue, this), G.on(o.Z.INITIAL_STREAM_SWITCH, j, this), G.on(o.Z.PLAYBACK_SEEKING, ae, this), G.on(o.Z.BUFFER_REPLACEMENT_STARTED, he, i), G.on(o.Z.TRACK_CHANGE_RENDERED, Ee, i);
              })();
            } }, M = (0, m.Z)(H).getInstance().getLogger(i), pe(), i;
          }
          Bo.__dashjs_factory_name = "GapController";
          var zl = v.Z.getSingletonFactory(Bo);
          function Uo() {
            var i, r, u, _, w, I, y, N, Z, Y, V = this.context, M = (0, p.Z)(V).getInstance();
            function H() {
              r = !1;
              var me = St.Z.parseUserAgent();
              u = me && me.browser && me.browser.name && me.browser.name.toLowerCase() === "safari";
            }
            function G() {
              r = !1;
            }
            function pe(me) {
              if (me.streamId === I.getActiveStreamInfo().id && Z) {
                var g = y.getLiveDelay();
                y.getBufferLevel() > g / 2 && (Z = !1);
              }
            }
            function ae(me) {
              me.streamId === I.getActiveStreamInfo().id && (Z = me.state === h.Z.BUFFER_EMPTY);
            }
            function he() {
              N.getCatchupModeEnabled() || _.setPlaybackRate(1);
            }
            function Ee() {
              y.getIsDynamic() && N.getCatchupModeEnabled() && (N.getCatchupPlaybackRates().max > 0 || N.getCatchupPlaybackRates().min < 0) && !y.isPaused() && !y.isSeeking() && function() {
                try {
                  return !(!y.getTime() > 0 || r) && (ue() === t.Z.LIVE_CATCHUP_MODE_LOLP ? function(me, g) {
                    try {
                      return Math.abs(j()) > 0 || me < g;
                    } catch {
                      return !1;
                    }
                  }(y.getBufferLevel(), w.get().streaming.liveCatchup.playbackBufferMin) : function() {
                    try {
                      return Math.abs(j()) > 0;
                    } catch {
                      return !1;
                    }
                  }());
                } catch {
                  return !1;
                }
              }() && function() {
                if (!r && _) {
                  var me, g = _.getPlaybackRate(), x = N.getCatchupPlaybackRates(), O = y.getBufferLevel(), L = j(), A = N.getCatchupMaxDrift();
                  if (!isNaN(A) && A > 0 && L > A) Y.info("[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point"), r = !0, y.seekToCurrentLive(!0, !1);
                  else {
                    var oe = y.getCurrentLiveLatency(), X = y.getLiveDelay();
                    me = ue() === t.Z.LIVE_CATCHUP_MODE_LOLP ? function(ne, U, re, Te, Fe) {
                      var De;
                      if (Fe < Te) {
                        var ke = Math.abs(ne.min), Le = 5 * (Fe - Te);
                        De = 1 - ke + 2 * ke / (1 + Math.pow(Math.E, -Le)), Y.debug("[LoL+ playback control_buffer-based] bufferLevel: " + Fe + ", newRate: " + De);
                      } else {
                        if (Math.abs(U - re) <= 0.02 * re) De = 1;
                        else {
                          var ut = U - re, ct = ut < 0 ? Math.abs(ne.min) : ne.max, rt = 5 * ut;
                          De = 1 - ct + 2 * ct / (1 + Math.pow(Math.E, -rt));
                        }
                        Y.debug("[LoL+ playback control_latency-based] latency: " + U + ", newRate: " + De);
                      }
                      return De;
                    }(x, oe, X, w.get().streaming.liveCatchup.playbackBufferMin, O) : function(ne, U, re, Te) {
                      if (Z) return 1;
                      var Fe = U - re, De = Fe < 0 ? Math.abs(ne.min) : ne.max, ke = 5 * Fe, Le = 1 - De + 2 * De / (1 + Math.pow(Math.E, -ke));
                      return y.getPlaybackStalled() && Te <= re / 2 && Fe > 0 && (Le = 1), Le;
                    }(x, oe, X, O);
                    var de = u ? 0.25 : 0.02 / (0.5 / x.max);
                    me && Math.abs(g - me) >= de && (Y.debug("[CatchupController]: Setting playback rate to ".concat(me)), _.setPlaybackRate(me));
                  }
                }
              }();
            }
            function j() {
              return y.getCurrentLiveLatency() - y.getLiveDelay();
            }
            function ue() {
              var me = w.get().streaming.liveCatchup.playbackBufferMin;
              return w.get().streaming.liveCatchup.mode !== t.Z.LIVE_CATCHUP_MODE_LOLP || me === null || isNaN(me) ? t.Z.LIVE_CATCHUP_MODE_DEFAULT : t.Z.LIVE_CATCHUP_MODE_LOLP;
            }
            function z() {
              N.getCatchupPlaybackRates(!0);
            }
            return i = { reset: function() {
              M.off(n.Z.BUFFER_LEVEL_UPDATED, pe, i), M.off(n.Z.BUFFER_LEVEL_STATE_CHANGED, ae, i), M.off(n.Z.PLAYBACK_PROGRESS, Ee, i), M.off(n.Z.PLAYBACK_TIME_UPDATED, Ee, i), M.off(n.Z.PLAYBACK_SEEKED, G, i), M.off(o.Z.SETTING_UPDATED_CATCHUP_ENABLED, he, i), M.off(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, z, i), M.off(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX, z, i), M.off(n.Z.STREAM_INITIALIZED, z, i), H(), _.setPlaybackRate(1, !0);
            }, setConfig: function(me) {
              me && (me.settings && (w = me.settings), me.videoModel && (_ = me.videoModel), me.streamController && (I = me.streamController), me.playbackController && (y = me.playbackController), me.mediaPlayerModel && (N = me.mediaPlayerModel));
            }, initialize: function() {
              M.on(n.Z.BUFFER_LEVEL_UPDATED, pe, i), M.on(n.Z.BUFFER_LEVEL_STATE_CHANGED, ae, i), M.on(n.Z.PLAYBACK_PROGRESS, Ee, i), M.on(n.Z.PLAYBACK_TIME_UPDATED, Ee, i), M.on(n.Z.PLAYBACK_SEEKED, G, i), M.on(o.Z.SETTING_UPDATED_CATCHUP_ENABLED, he, i), M.on(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MIN, z, i), M.on(o.Z.SETTING_UPDATED_PLAYBACK_RATE_MAX, z, i), M.on(n.Z.STREAM_INITIALIZED, z, i), z();
            } }, Y = (0, m.Z)(V).getInstance().getLogger(i), H(), i;
          }
          Uo.__dashjs_factory_name = "CatchupController";
          var Wl = v.Z.getSingletonFactory(Uo), Ql = [t.Z.SERVICE_DESCRIPTION_DVB_LL_SCHEME], Go = "video", Ho = "audio";
          function qo() {
            var i, r, u, _, w, I = this.context;
            function y() {
              r = { liveDelay: NaN, liveCatchup: { maxDrift: NaN, playbackRate: { min: NaN, max: NaN } }, minBitrate: {}, maxBitrate: {}, initialBitrate: {}, contentSteering: null }, u = [];
            }
            function N(Z, Y, V) {
              try {
                r[Z][Y] = V / 1e3;
              } catch (M) {
                _.error(M);
              }
            }
            return i = { getServiceDescriptionSettings: function() {
              return r;
            }, getProducerReferenceTimeOffsets: function() {
              return u;
            }, calculateProducerReferenceTimeOffsets: function(Z) {
              try {
                var Y = [];
                if (Z && Z.length > 0) {
                  var V = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT], M = w.getAvailabilityStartTime() / 1e3;
                  Z.forEach(function(H) {
                    var G = V.reduce(function(pe, ae) {
                      return pe.concat(w.getAllMediaInfoForType(H, ae));
                    }, []).reduce(function(pe, ae) {
                      return w.getProducerReferenceTimes(H, ae).forEach(function(he) {
                        var Ee = w.getVoRepresentations(ae);
                        if (Ee && Ee.length > 0 && Ee[0].adaptation && Ee[0].segmentInfoType === e.Z.SEGMENT_TEMPLATE) {
                          var j = Ee[0], ue = new Date(he[e.Z.WALL_CLOCK_TIME]).getTime() / 1e3 - (he[e.Z.PRESENTATION_TIME] / j[e.Z.TIMESCALE] - j[e.Z.PRESENTATION_TIME_OFFSET] + H.start), z = M - ue;
                          pe.push({ id: he[e.Z.ID], to: z });
                        }
                      }), pe;
                    }, []);
                    Y = Y.concat(G);
                  });
                }
                u = Y;
              } catch (H) {
                _.error(H), u = [];
              }
            }, applyServiceDescription: function(Z) {
              if (Z && Z.serviceDescriptions) {
                var Y = Z.serviceDescriptions.filter(function(H) {
                  return Ql.includes(H.schemeIdUri);
                }), V = Z.serviceDescriptions.filter(function(H) {
                  return H.schemeIdUri == null;
                }), M = Y.length > 0 ? Y[Y.length - 1] : V[V.length - 1];
                M && (M.latency && M.latency.target > 0 && function(H) {
                  var G;
                  if (H.schemeIdUri, t.Z.SERVICE_DESCRIPTION_DVB_LL_SCHEME, G = function(Ee) {
                    return { liveDelay: Ee.latency.target / 1e3, maxDrift: !isNaN(Ee.latency.max) && Ee.latency.max > Ee.latency.target ? (Ee.latency.max - Ee.latency.target + 500) / 1e3 : NaN, referenceId: Ee.latency.referenceId || NaN };
                  }(H), u.length > 0) {
                    var pe = function(Ee) {
                      var j, ue = 0, z = u.filter(function(me) {
                        return me.id === Ee.referenceId;
                      });
                      return z.length === 0 ? (ue = u.length > 0 ? u[0].to : 0, j = u[0].id || NaN) : (ue = z[0].to || 0, j = z[0].id || NaN), { to: ue, id: j };
                    }(G), ae = pe.to, he = pe.id;
                    r.liveDelay = G.liveDelay - ae, r.liveCatchup.maxDrift = G.maxDrift, _.debug(`
                Found latency properties coming from service description. Applied time offset of `.concat(ae, " from ProducerReferenceTime element with id ").concat(he, `.
                Live Delay: `).concat(G.liveDelay - ae, ", Live catchup max drift: ").concat(G.maxDrift, `
            `));
                  } else r.liveDelay = G.liveDelay, r.liveCatchup.maxDrift = G.maxDrift, _.debug("Found latency properties coming from service description: Live Delay: ".concat(G.liveDelay, ", Live catchup max drift: ").concat(G.maxDrift));
                }(M), M.playbackRate && function(H) {
                  var G = H.playbackRate.min ? Math.round(1e3 * (H.playbackRate.min - 1)) / 1e3 : NaN, pe = H.playbackRate.max ? Math.round(1e3 * (H.playbackRate.max - 1)) / 1e3 : NaN;
                  r.liveCatchup.playbackRate.min = G, r.liveCatchup.playbackRate.max = pe, _.debug("Found latency properties coming from service description: Live catchup min playback rate: ".concat(G)), _.debug("Found latency properties coming from service description: Live catchup max playback rate: ".concat(pe));
                }(M), M.operatingQuality, M.operatingBandwidth && function(H) {
                  if (H && H.operatingBandwidth && H.operatingBandwidth.mediaType && H.operatingBandwidth.mediaType !== "all") {
                    var G = {};
                    G.minBandwidth = H.operatingBandwidth.min, G.maxBandwidth = H.operatingBandwidth.max, G.targetBandwidth = H.operatingBandwidth.target;
                    var pe = [];
                    H.operatingBandwidth.mediaType === Go || H.operatingBandwidth.mediaType === Ho ? pe.push(H.operatingBandwidth.mediaType) : H.operatingBandwidth.mediaType === "any" && (pe.push(Ho), pe.push(Go)), pe.forEach(function(ae) {
                      isNaN(G.minBandwidth) || N("minBitrate", ae, G.minBandwidth), isNaN(G.maxBandwidth) || N("maxBitrate", ae, G.maxBandwidth), isNaN(G.targetBandwidth) || N("initialBitrate", ae, G.targetBandwidth);
                    });
                  }
                }(M), M.contentSteering && function(H) {
                  r.contentSteering = H.contentSteering;
                }(M));
              }
            }, reset: function() {
              y();
            }, setConfig: function(Z) {
              Z && Z.adapter && (w = Z.adapter);
            } }, _ = (0, m.Z)(I).getInstance().getLogger(i), y(), i;
          }
          qo.__dashjs_factory_name = "ServiceDescriptionController";
          var Xl = v.Z.getSingletonFactory(qo), $l = R(3973), Wi = R.n($l), Vo = R(3039);
          function Ha() {
            var i, r, u, _, w, I, y, N, Z = this.context, Y = (0, p.Z)(Z).getInstance();
            function V(U, re) {
              return U && u[re] && u[re][U] ? u[re][U].list : [];
            }
            function M(U, re) {
              return U && u[re] && u[re][U] ? u[re][U].current : null;
            }
            function H(U) {
              var re = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              if (U && U.streamInfo) {
                var Te = U.type, Fe = U.streamInfo, De = Fe.id, ke = M(Te, De);
                if (u[De] && u[De][Te] && (u[De][Te].current = U, u[De][Te].current && (Te !== t.Z.TEXT && !ae(U, ke) || Te === t.Z.TEXT && U.isFragmented) && Y.trigger(o.Z.CURRENT_TRACK_CHANGED, { oldMediaInfo: ke, newMediaInfo: U, switchMode: _.get().streaming.trackSwitchMode[Te] }, { streamId: De }), !re)) {
                  var Le = Ee(U);
                  if (!Le || !u[De][Te].storeLastSettings) return;
                  Le.roles && (Le.role = Le.roles[0], delete Le.roles), Le.accessibility && (Le.accessibility = Le.accessibility[0]), Le.audioChannelConfiguration && (Le.audioChannelConfiguration = Le.audioChannelConfiguration[0]), I[Te] = Le, N.setSavedMediaSettings(Te, Le);
                }
              }
            }
            function G(U, re) {
              U && re && (w[U] = re);
            }
            function pe(U) {
              return U ? w[U] : null;
            }
            function ae(U, re) {
              if (!U && !re) return !0;
              if (!U || !re) return !1;
              var Te = U.id === re.id, Fe = U.viewpoint === re.viewpoint, De = JSON.stringify(U.viewpointsWithSchemeIdUri) === JSON.stringify(re.viewpointsWithSchemeIdUri), ke = U.lang === re.lang, Le = U.codec === re.codec, ut = U.roles.toString() === re.roles.toString(), ct = JSON.stringify(U.rolesWithSchemeIdUri) === JSON.stringify(re.rolesWithSchemeIdUri), rt = U.accessibility.toString() === re.accessibility.toString(), at = JSON.stringify(U.accessibilitiesWithSchemeIdUri) === JSON.stringify(re.accessibilitiesWithSchemeIdUri), Bt = U.audioChannelConfiguration.toString() === re.audioChannelConfiguration.toString(), Re = JSON.stringify(U.audioChannelConfigurationsWithSchemeIdUri) === JSON.stringify(re.audioChannelConfigurationsWithSchemeIdUri);
              return Te && Le && Fe && De && ke && ut && ct && rt && at && Bt && Re;
            }
            function he() {
              u = {}, I = {}, w = { audio: null, video: null, text: null };
            }
            function Ee(U) {
              var re = { lang: U.lang, viewpoint: U.viewpoint, roles: U.roles, accessibility: U.accessibility, audioChannelConfiguration: U.audioChannelConfiguration, codec: U.codec };
              return re.lang || re.viewpoint || re.role && re.role.length > 0 || re.accessibility && re.accessibility.length > 0 || re.audioChannelConfiguration && re.audioChannelConfiguration.length > 0 ? re : null;
            }
            function j(U, re, Te) {
              var Fe = [];
              return U.forEach(function(De) {
                re(Te, De) && Fe.push(De);
              }), Fe.length !== 0 ? Fe : U;
            }
            function ue(U, re) {
              try {
                return !U.lang || U.lang instanceof RegExp ? re.lang.match(U.lang) : re.lang !== "" && (0, Vo.extendedFilter)(re.lang, Wi()(U.lang)).length > 0;
              } catch {
                return !1;
              }
            }
            function z(U, re) {
              return U.index === void 0 || U.index === null || re.index === U.index;
            }
            function me(U, re) {
              return !U.viewpoint || U.viewpoint === re.viewpoint;
            }
            function g(U, re) {
              var Te = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], Fe = !U.role || !!re.roles.filter(function(De) {
                return De === U.role;
              })[0];
              return Fe || re.type === t.Z.AUDIO && Te;
            }
            function x(U, re) {
              return U.accessibility ? !!re.accessibility.filter(function(Te) {
                return Te === U.accessibility;
              })[0] : !re.accessibility.length;
            }
            function O(U, re) {
              return !U.audioChannelConfiguration || !!re.audioChannelConfiguration.filter(function(Te) {
                return Te === U.audioChannelConfiguration;
              })[0];
            }
            function L(U, re) {
              return !U.codec || U.codec === re.codec;
            }
            function A(U) {
              var re, Te = 0, Fe = [];
              return U.forEach(function(De) {
                (re = Math.max.apply(Math, De.bitrateList.map(function(ke) {
                  return ke.bandwidth;
                }))) > Te ? (Te = re, Fe = [De]) : re === Te && Fe.push(De);
              }), Fe;
            }
            function oe(U) {
              var re, Te = 1 / 0, Fe = [];
              return U.forEach(function(De) {
                var ke = De.bitrateList.reduce(function(Le, ut) {
                  var ct = Math.max(1, ut.width * ut.height);
                  return Le + ut.bandwidth / ct;
                }, 0);
                (re = ke / De.bitrateList.length) < Te ? (Te = re, Fe = [De]) : re === Te && Fe.push(De);
              }), Fe;
            }
            function X(U) {
              var re, Te = 0, Fe = [];
              return U.forEach(function(De) {
                (re = De.representationCount) > Te ? (Te = re, Fe = [De]) : re === Te && Fe.push(De);
              }), Fe;
            }
            function de(U, re) {
              if (U === t.Z.TEXT) return re[0];
              var Te, Fe = _.get().streaming.selectionModeForInitialTrack, De = y.getCustomInitialTrackSelectionFunction();
              if (De && typeof De == "function") Te = De(re);
              else switch (Fe) {
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:
                  Te = function(ke) {
                    var Le, ut, ct = (Le = 0, ut = [], ke.forEach(function(rt) {
                      isNaN(rt.selectionPriority) || (rt.selectionPriority > Le ? (Le = rt.selectionPriority, ut = [rt]) : rt.selectionPriority === Le && ut.push(rt));
                    }), ut);
                    return ct.length > 1 && (ct = A(ct)), ct.length > 1 && (ct = X(ct)), ct;
                  }(re);
                  break;
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_BITRATE:
                  Te = function(ke) {
                    var Le = A(ke);
                    return Le.length > 1 && (Le = X(Le)), Le;
                  }(re);
                  break;
                case t.Z.TRACK_SELECTION_MODE_FIRST_TRACK:
                  Te = ne(re);
                  break;
                case t.Z.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:
                  Te = function(ke) {
                    var Le = oe(ke);
                    return Le.length > 1 && (Le = A(Le)), Le;
                  }(re);
                  break;
                case t.Z.TRACK_SELECTION_MODE_WIDEST_RANGE:
                  Te = function(ke) {
                    var Le = X(ke);
                    return Le.length > 1 && (Le = A(ke)), Le;
                  }(re);
                  break;
                default:
                  r.warn("Track selection mode ".concat(Fe, " is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK")), Te = ne(re);
              }
              return Te.length > 0 ? Te[0] : re[0];
            }
            function ne(U) {
              return U[0];
            }
            return i = { setInitialMediaSettingsForType: function(U, re) {
              var Te = I[U] || pe(U), Fe = V(U, re.id), De = [];
              Te || ((Te = N.getSavedMediaSettings(U)) && delete Te.codec, G(U, Te)), Fe && Fe.length !== 0 && (Te && (De = j(De = Array.from(Fe), ue, Te), De = j(De, z, Te), De = j(De, me, Te), U === t.Z.AUDIO && I[U] || (De = j(De, g, Te)), De = j(De, x, Te), De = j(De, O, Te), De = j(De, L, Te)), De.length === 0 ? H(de(U, Fe), !0) : De.length > 1 ? H(de(U, De)) : H(De[0]));
            }, addTrack: function(U) {
              if (U) {
                var re = U.type;
                if ((Te = re) === t.Z.AUDIO || Te === t.Z.VIDEO || Te === t.Z.TEXT || Te === t.Z.IMAGE) {
                  var Te, Fe, De = U.streamInfo.id;
                  u[De] || (u[De] = { audio: { list: [], storeLastSettings: Fe = _.get().streaming.saveLastMediaSettingsForCurrentStreamingSession, current: null }, video: { list: [], storeLastSettings: Fe, current: null }, text: { list: [], storeLastSettings: Fe, current: null }, image: { list: [], storeLastSettings: Fe, current: null } });
                  for (var ke = u[De][re].list, Le = 0, ut = ke.length; Le < ut; ++Le) if (ae(ke[Le], U)) return;
                  ke.push(U);
                }
              }
            }, getTracksFor: V, getCurrentTrackFor: M, isCurrentTrack: function(U) {
              if (!U) return !1;
              var re = U.type, Te = U.streamInfo.id;
              return u[Te] && u[Te][re] && ae(u[Te][re].current, U);
            }, setTrack: H, selectInitialTrack: de, setInitialSettings: G, getInitialSettings: pe, getTracksWithHighestBitrate: A, getTracksWithHighestEfficiency: oe, getTracksWithWidestRange: X, isTracksEqual: ae, matchSettings: function(U, re) {
              var Te = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              try {
                var Fe = !1;
                if (U.lang) {
                  if (U.lang instanceof RegExp) Fe = re.lang.match(U.lang);
                  else if (re.lang !== "") {
                    var De = Wi()(U.lang);
                    De && (Fe = (0, Vo.extendedFilter)(re.lang, De).length > 0);
                  }
                } else Fe = !0;
                var ke = U.index === void 0 || U.index === null || re.index === U.index, Le = !U.viewpoint || U.viewpoint === re.viewpoint, ut = !U.role || !!re.roles.filter(function(at) {
                  return at === U.role;
                })[0], ct = !U.accessibility || !!re.accessibility.filter(function(at) {
                  return at === U.accessibility;
                })[0], rt = !U.audioChannelConfiguration || !!re.audioChannelConfiguration.filter(function(at) {
                  return at === U.audioChannelConfiguration;
                })[0];
                return Fe && ke && Le && (ut || re.type === t.Z.AUDIO && Te) && ct && rt;
              } catch {
                return !1;
              }
            }, matchSettingsLang: ue, matchSettingsIndex: z, matchSettingsViewPoint: me, matchSettingsRole: g, matchSettingsAccessibility: x, matchSettingsAudioChannelConfig: O, saveTextSettingsDisabled: function() {
              N.setSavedMediaSettings(t.Z.TEXT, null);
            }, setConfig: function(U) {
              U && (U.domStorage && (N = U.domStorage), U.settings && (_ = U.settings), U.customParametersModel && (y = U.customParametersModel));
            }, reset: he }, r = (0, m.Z)(Z).getInstance().getLogger(i), he(), i;
          }
          Ha.__dashjs_factory_name = "MediaController";
          var jo = v.Z.getSingletonFactory(Ha);
          v.Z.updateSingletonFactory(Ha.__dashjs_factory_name, jo);
          var Jl = jo, Qi = NaN, Yo = function i(r, u) {
            (function(_, w) {
              if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.data = { baseUrls: r || null, selectedIdx: u || Qi }, this.children = [];
          };
          function Ko() {
            var i, r, u, _, w = this.context, I = Zt(w).getInstance();
            function y(V, M, H) {
              var G = N(H);
              V[M] ? I.areEqual(G, V[M].data.baseUrls) || (V[M].data.baseUrls = G, V[M].data.selectedIdx = Qi) : V[M] = new Yo(G);
            }
            function N(V) {
              var M = u.getBaseURLsFromElement(V), H = _.getSynthesizedBaseUrlElements(M);
              return H && H.length > 0 && (M = M.concat(H)), M;
            }
            function Z(V, M) {
              var H = M || r;
              V(H.data), H.children && H.children.forEach(function(G) {
                return Z(V, G);
              });
            }
            function Y() {
              r = new Yo();
            }
            return i = { reset: Y, update: function(V) {
              (function(M) {
                (function() {
                  if (!u || !u.hasOwnProperty("getBaseURLsFromElement") || !u.hasOwnProperty("getRepresentationSortFunction")) throw new Error("setConfig function has to be called previously");
                })();
                var H = N(M);
                I.areEqual(H, r.data.baseUrls) || (r.data.baseUrls = H, r.data.selectedIdx = Qi), M && M.Period_asArray && M.Period_asArray.forEach(function(G, pe) {
                  y(r.children, pe, G), G.AdaptationSet_asArray && G.AdaptationSet_asArray.forEach(function(ae, he) {
                    y(r.children[pe].children, he, ae), ae.Representation_asArray && ae.Representation_asArray.sort(u.getRepresentationSortFunction()).forEach(function(Ee, j) {
                      y(r.children[pe].children[he].children, j, Ee);
                    });
                  });
                });
              })(V);
            }, getForPath: function(V) {
              var M = r, H = [M.data];
              return V && V.forEach(function(G) {
                (M = M.children[G]) && H.push(M.data);
              }), H.filter(function(G) {
                return G.baseUrls.length;
              });
            }, invalidateSelectedIndexes: function(V) {
              Z(function(M) {
                isNaN(M.selectedIdx) || V === M.baseUrls[M.selectedIdx].serviceLocation && (M.selectedIdx = Qi);
              });
            }, setConfig: function(V) {
              V.adapter && (u = V.adapter), V.contentSteeringController && (_ = V.contentSteeringController);
            }, getBaseUrls: function(V) {
              return N(V);
            } }, Y(), i;
          }
          Ko.__dashjs_factory_name = "BaseURLTreeModel";
          var eu = v.Z.getClassFactory(Ko);
          function zo(i) {
            var r = (i = i || {}).blacklistController;
            return { select: function(u) {
              return u && function(w) {
                var I, y, N = 0, Z = [], Y = 0;
                if ((y = w.sort(function(V, M) {
                  var H = V.dvbPriority - M.dvbPriority;
                  return isNaN(H) ? 0 : H;
                }).filter(function(V, M, H) {
                  return !M || H[0].dvbPriority && V.dvbPriority && H[0].dvbPriority === V.dvbPriority;
                })).length) return y.length > 1 && (y.forEach(function(V) {
                  N += V.dvbWeight, Z.push(N);
                }), I = Math.floor(Math.random() * (N - 1)), Z.every(function(V, M) {
                  return Y = M, !(I < V);
                })), y[Y];
              }((_ = [], u.filter(function(w) {
                return !r.contains(w.serviceLocation) || (w.dvbPriority && _.push(w.dvbPriority), !1);
              }).filter(function(w) {
                return !_.length || !w.dvbPriority || _.indexOf(w.dvbPriority) === -1;
              })));
              var _;
            } };
          }
          zo.__dashjs_factory_name = "DVBSelector";
          var tu = v.Z.getClassFactory(zo);
          function Wo(i) {
            var r = (i = i || {}).blacklistController;
            return { select: function(u) {
              var _, w = 0;
              return u && u.some(function(I, y) {
                return w = y, !r.contains(I.serviceLocation);
              }) && (_ = u[w]), _;
            } };
          }
          Wo.__dashjs_factory_name = "BasicSelector";
          var nu = v.Z.getClassFactory(Wo);
          function Qo() {
            var i, r, u, _ = this.context;
            function w() {
              for (var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], N = 0, Z = NaN, Y = function() {
                var M = I[N], H = y.findIndex(function(G) {
                  return G.serviceLocation && G.serviceLocation === M;
                });
                if (H !== -1 && !u.contains(y[H].serviceLocation)) return Z = H, "break";
                N += 1;
              }; N < I.length; ) {
                var V = Y();
                if (V === "break") break;
              }
              return Z;
            }
            return i = { selectBaseUrlIndex: function(I) {
              var y = NaN;
              if (isNaN(I.selectedIdx)) {
                var N = r.getSteeringDataFromManifest();
                N && N.defaultServiceLocationArray.length > 0 && (y = w(N.defaultServiceLocationArray, I.baseUrls));
              }
              var Z = r.getCurrentSteeringResponseData();
              return I.baseUrls && I.baseUrls.length && Z && Z.pathwayPriority && Z.pathwayPriority.length && (y = w(Z.pathwayPriority, I.baseUrls)), y;
            }, setConfig: function(I) {
              I.blacklistController && (u = I.blacklistController), I.contentSteeringController && (r = I.contentSteeringController);
            } }, r = Or(_).getInstance(), i;
          }
          Qo.__dashjs_factory_name = "ContentSteeringSelector";
          var ru = v.Z.getClassFactory(Qo);
          function Xo() {
            var i, r, u, _, w, I, y = this.context, N = (0, p.Z)(y).getInstance(), Z = (0, Oe.Z)(y).getInstance();
            function Y() {
              r.reset();
            }
            return i = { chooseSelector: function(V) {
              (0, $.PS)(V, "boolean"), I = V ? _ : u;
            }, select: function(V) {
              if (V) {
                if (Z.get().streaming.applyContentSteering) {
                  var M = w.selectBaseUrlIndex(V);
                  isNaN(M) || M === -1 || (V.selectedIdx = M);
                }
                if (!isNaN(V.selectedIdx)) return V.baseUrls[V.selectedIdx];
                var H = I.select(V.baseUrls);
                return H ? (V.selectedIdx = V.baseUrls.indexOf(H), H) : (N.trigger(o.Z.URL_RESOLUTION_FAILED, { error: new se.Z(ee.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, ee.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE) }), void (I === u && Y()));
              }
            }, reset: Y, setConfig: function(V) {
              V.selector && (I = V.selector), V.contentSteeringSelector && (w = V.contentSteeringSelector);
            } }, r = hi(y).create({ updateEventName: o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, addBlacklistEventName: o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_ADD }), u = nu(y).create({ blacklistController: r }), _ = tu(y).create({ blacklistController: r }), (w = ru(y).create()).setConfig({ blacklistController: r }), I = u, i;
          }
          Xo.__dashjs_factory_name = "BaseURLSelector";
          var iu = v.Z.getClassFactory(Xo);
          function $o() {
            var i, r, u, _, w, I = this.context, y = (0, p.Z)(I).getInstance(), N = (0, $e.Z)(I).getInstance();
            function Z(V) {
              u.update(V), _.chooseSelector(r.getIsDVB(V)), y.trigger(n.Z.BASE_URLS_UPDATED, { baseUrls: Y(V) });
            }
            function Y(V) {
              return u.getBaseUrls(V);
            }
            return i = { reset: function() {
              u.reset(), _.reset();
            }, initialize: function(V) {
              u.setConfig({ adapter: r, contentSteeringController: w }), Z(V);
            }, resolve: function(V) {
              var M = u.getForPath(V).reduce(function(H, G) {
                var pe = _.select(G);
                return pe ? (N.isRelative(pe.url) ? H.url = N.resolve(pe.url, H.url) : (H.url = pe.url, H.serviceLocation = pe.serviceLocation), H.availabilityTimeOffset = pe.availabilityTimeOffset, H.availabilityTimeComplete = pe.availabilityTimeComplete, H.queryParams = pe.queryParams, H) : new Nr();
              }, new Nr());
              if (!N.isRelative(M.url)) return M;
            }, setConfig: function(V) {
              V.baseURLTreeModel && (u = V.baseURLTreeModel), V.baseURLSelector && (_ = V.baseURLSelector), V.adapter && (r = V.adapter), V.contentSteeringController && (w = V.contentSteeringController);
            }, getBaseUrls: Y, update: Z }, u = eu(I).create(), _ = iu(I).create(), y.on(o.Z.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, function(V) {
              u.invalidateSelectedIndexes(V.entry);
            }, i), i;
          }
          $o.__dashjs_factory_name = "BaseURLController";
          var au = v.Z.getClassFactory($o);
          function qa(i) {
            return qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, qa(i);
          }
          function Va(i, r) {
            return Va = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Va(i, r);
          }
          function ou(i, r) {
            return !r || qa(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Xi(i) {
            return Xi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Xi(i);
          }
          var Jo = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y && y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), y && Va(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Xi(r);
              if (u) {
                var N = Xi(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return ou(this, I);
            });
            function w(I, y) {
              var N;
              return function(Z, Y) {
                if (!(Z instanceof Y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (N = _.call(this)).url = I || null, N.type = y || null, N.mediaType = t.Z.STREAM, N.responseType = "", N;
            }
            return w;
          }(S.Z);
          function es(i) {
            i = i || {};
            var r = this.context, u = (0, p.Z)(r).getInstance(), _ = hr(r).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, errors: ee });
            return { load: function(w, I, y) {
              var N = function(Y, V) {
                I.resolved = !0, I.resolvedContent = Y || null, u.trigger(o.Z.XLINK_ELEMENT_LOADED, { element: I, resolveObject: y, error: Y || V ? null : new se.Z(ee.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE, ee.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE + w) });
              };
              if (w === "urn:mpeg:dash:resolve-to-zero:2013") N(null, !0);
              else {
                var Z = new Jo(w, Ge.w.XLINK_EXPANSION_TYPE);
                _.load({ request: Z, success: function(Y) {
                  N(Y);
                }, error: function() {
                  N(null);
                } });
              }
            }, reset: function() {
              _ && (_.abort(), _ = null);
            } };
          }
          es.__dashjs_factory_name = "XlinkLoader";
          var su = v.Z.getClassFactory(es), ts = function(i) {
            (i = i || {}).escapeMode === void 0 && (i.escapeMode = !0), i.attributePrefix === void 0 && (i.attributePrefix = "_"), i.arrayAccessForm = i.arrayAccessForm || "none", i.emptyNodeForm = i.emptyNodeForm || "text", i.enableToStringFunc === void 0 && (i.enableToStringFunc = !0), i.arrayAccessFormPaths = i.arrayAccessFormPaths || [], i.skipEmptyTextNodesForObj === void 0 && (i.skipEmptyTextNodesForObj = !0), i.stripWhitespaces === void 0 && (i.stripWhitespaces = !0), i.datetimeAccessFormPaths = i.datetimeAccessFormPaths || [], i.useDoubleQuotes === void 0 && (i.useDoubleQuotes = !1), i.xmlElementsFilter = i.xmlElementsFilter || [], i.jsonPropertiesFilter = i.jsonPropertiesFilter || [], i.keepCData === void 0 && (i.keepCData = !1), i.ignoreRoot === void 0 && (i.ignoreRoot = !1);
            function r(j) {
              var ue = j.localName;
              return ue == null && (ue = j.baseName), ue != null && ue != "" || (ue = j.nodeName), ue;
            }
            function u(j) {
              return typeof j == "string" ? j.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") : j;
            }
            function _(j, ue, z, me) {
              for (var g = 0; g < j.length; g++) {
                var x = j[g];
                if (typeof x == "string") {
                  if (x == me) break;
                } else if (x instanceof RegExp) {
                  if (x.test(me)) break;
                } else if (typeof x == "function" && x(ue, z, me)) break;
              }
              return g != j.length;
            }
            function w(j, ue, z) {
              i.arrayAccessForm === "property" && (j[ue] instanceof Array ? j[ue + "_asArray"] = j[ue] : j[ue + "_asArray"] = [j[ue]]), !(j[ue] instanceof Array) && i.arrayAccessFormPaths.length > 0 && _(i.arrayAccessFormPaths, j, ue, z) && (j[ue] = [j[ue]]);
            }
            function I(j) {
              var ue = j.split(/[-T:+Z]/g), z = new Date(ue[0], ue[1] - 1, ue[2]), me = ue[5].split(".");
              if (z.setHours(ue[3], ue[4], me[0]), me.length > 1 && z.setMilliseconds(me[1]), ue[6] && ue[7]) {
                var g = 60 * ue[6] + Number(ue[7]);
                g = 0 + ((/\d\d-\d\d:\d\d$/.test(j) ? "-" : "+") == "-" ? -1 * g : g), z.setMinutes(z.getMinutes() - g - z.getTimezoneOffset());
              } else j.indexOf("Z", j.length - 1) !== -1 && (z = new Date(Date.UTC(z.getFullYear(), z.getMonth(), z.getDate(), z.getHours(), z.getMinutes(), z.getSeconds(), z.getMilliseconds())));
              return z;
            }
            function y(j, ue, z, me) {
              return !(ue == 1 && i.xmlElementsFilter.length > 0) || _(i.xmlElementsFilter, j, z, me);
            }
            function N(j, ue) {
              if (j.nodeType == 9) {
                for (var z = new Object(), me = j.childNodes, g = 0; g < me.length; g++) (O = me[g]).nodeType == 1 && (i.ignoreRoot ? z = N(O) : (z = {})[L = r(O)] = N(O));
                return z;
              }
              if (j.nodeType == 1) {
                (z = new Object()).__cnt = 0;
                var x = [];
                for (me = j.childNodes, g = 0; g < me.length; g++) {
                  var O, L = r(O = me[g]);
                  if (O.nodeType != 8) {
                    var A = ue + "." + L;
                    if (y(z, O.nodeType, L, A)) if (z.__cnt++, z[L] == null) {
                      var oe = N(O, A);
                      (L != "#text" || /[^\s]/.test(oe)) && ((X = {})[L] = oe, x.push(X)), z[L] = oe, w(z, L, A);
                    } else {
                      var X;
                      z[L] != null && (z[L] instanceof Array || (z[L] = [z[L]], w(z, L, A))), oe = N(O, A), (L != "#text" || /[^\s]/.test(oe)) && ((X = {})[L] = oe, x.push(X)), z[L][z[L].length] = oe;
                    }
                  }
                }
                z.__children = x;
                for (var de = r(j), ne = 0; ne < j.attributes.length; ne++) {
                  var U = j.attributes[ne];
                  z.__cnt++;
                  for (var re = U.value, Te = 0, Fe = i.matchers.length; Te < Fe; Te++) {
                    var De = i.matchers[Te];
                    De.test(U, de) && (re = De.converter(U.value));
                  }
                  z[i.attributePrefix + U.name] = re;
                }
                var ke = function(Le) {
                  return Le.prefix;
                }(j);
                return ke != null && ke != "" && (z.__cnt++, z.__prefix = ke), z["#text"] != null && (z.__text = z["#text"], z.__text instanceof Array && (z.__text = z.__text.join(`
`)), i.stripWhitespaces && (z.__text = z.__text.trim()), delete z["#text"], i.arrayAccessForm == "property" && delete z["#text_asArray"], z.__text = function(Le, ut, ct) {
                  if (i.datetimeAccessFormPaths.length > 0) {
                    var rt = ct.split(".#")[0];
                    return _(i.datetimeAccessFormPaths, Le, ut, rt) ? I(Le) : Le;
                  }
                  return Le;
                }(z.__text, L, ue + "." + L)), z["#cdata-section"] != null && (z.__cdata = z["#cdata-section"], delete z["#cdata-section"], i.arrayAccessForm == "property" && delete z["#cdata-section_asArray"]), z.__cnt == 0 && i.emptyNodeForm == "text" ? z = "" : z.__cnt == 1 && z.__text != null ? z = z.__text : z.__cnt != 1 || z.__cdata == null || i.keepCData ? z.__cnt > 1 && z.__text != null && i.skipEmptyTextNodesForObj && (i.stripWhitespaces && z.__text == "" || z.__text.trim() == "") && delete z.__text : z = z.__cdata, delete z.__cnt, !i.enableToStringFunc || z.__text == null && z.__cdata == null || (z.toString = function() {
                  return (this.__text != null ? this.__text : "") + (this.__cdata != null ? this.__cdata : "");
                }), z;
              }
              if (j.nodeType == 3 || j.nodeType == 4) return j.nodeValue;
            }
            function Z(j, ue, z, me) {
              var g = "<" + (j != null && j.__prefix != null ? j.__prefix + ":" : "") + ue;
              if (z != null) for (var x = 0; x < z.length; x++) {
                var O = z[x], L = j[O];
                i.escapeMode && (L = u(L)), g += " " + O.substr(i.attributePrefix.length) + "=", i.useDoubleQuotes ? g += '"' + L + '"' : g += "'" + L + "'";
              }
              return g + (me ? "/>" : ">");
            }
            function Y(j, ue) {
              return "</" + (j.__prefix != null ? j.__prefix + ":" : "") + ue + ">";
            }
            function V(j, ue) {
              return i.arrayAccessForm == "property" && (me = "_asArray", (z = ue.toString()).indexOf(me, z.length - me.length) !== -1) || ue.toString().indexOf(i.attributePrefix) == 0 || ue.toString().indexOf("__") == 0 || j[ue] instanceof Function;
              var z, me;
            }
            function M(j) {
              var ue = 0;
              if (j instanceof Object) for (var z in j) V(j, z) || ue++;
              return ue;
            }
            function H(j, ue, z) {
              return i.jsonPropertiesFilter.length == 0 || z == "" || _(i.jsonPropertiesFilter, j, ue, z);
            }
            function G(j) {
              var ue = [];
              if (j instanceof Object) for (var z in j) z.toString().indexOf("__") == -1 && z.toString().indexOf(i.attributePrefix) == 0 && ue.push(z);
              return ue;
            }
            function pe(j) {
              var ue = "";
              return j instanceof Object ? ue += function(z) {
                var me = "";
                return z.__cdata != null && (me += "<![CDATA[" + z.__cdata + "]]>"), z.__text != null && (i.escapeMode ? me += u(z.__text) : me += z.__text), me;
              }(j) : j != null && (i.escapeMode ? ue += u(j) : ue += j), ue;
            }
            function ae(j, ue) {
              return j === "" ? ue : j + "." + ue;
            }
            function he(j, ue, z, me) {
              var g = "";
              if (j.length == 0) g += Z(j, ue, z, !0);
              else for (var x = 0; x < j.length; x++) g += Z(j[x], ue, G(j[x]), !1), g += Ee(j[x], ae(me, ue)), g += Y(j[x], ue);
              return g;
            }
            function Ee(j, ue) {
              var z = "";
              if (M(j) > 0) {
                for (var me in j) if (!V(j, me) && (ue == "" || H(j, me, ae(ue, me)))) {
                  var g = j[me], x = G(g);
                  g == null || g == null ? z += Z(g, me, x, !0) : g instanceof Object ? g instanceof Array ? z += he(g, me, x, ue) : g instanceof Date ? (z += Z(g, me, x, !1), z += g.toISOString(), z += Y(g, me)) : M(g) > 0 || g.__text != null || g.__cdata != null ? (z += Z(g, me, x, !1), z += Ee(g, ae(ue, me)), z += Y(g, me)) : z += Z(g, me, x, !0) : (z += Z(g, me, x, !1), z += pe(g), z += Y(g, me));
                }
              }
              return z + pe(j);
            }
            this.parseXmlString = function(j) {
              var ue;
              if (j === void 0) return null;
              if (window.DOMParser) {
                var z = new window.DOMParser();
                try {
                  (ue = z.parseFromString(j, "text/xml")).getElementsByTagNameNS("*", "parsererror").length > 0 && (ue = null);
                } catch {
                  ue = null;
                }
              } else j.indexOf("<?") == 0 && (j = j.substr(j.indexOf("?>") + 2)), (ue = new ActiveXObject("Microsoft.XMLDOM")).async = "false", ue.loadXML(j);
              return ue;
            }, this.asArray = function(j) {
              return j === void 0 || j == null ? [] : j instanceof Array ? j : [j];
            }, this.toXmlDateTime = function(j) {
              return j instanceof Date ? j.toISOString() : typeof j == "number" ? new Date(j).toISOString() : null;
            }, this.asDateTime = function(j) {
              return typeof j == "string" ? I(j) : j;
            }, this.xml2json = function(j) {
              return N(j);
            }, this.xml_str2json = function(j) {
              var ue = this.parseXmlString(j);
              return ue != null ? this.xml2json(ue) : null;
            }, this.json2xml_str = function(j) {
              return Ee(j, "");
            }, this.json2xml = function(j) {
              var ue = this.json2xml_str(j);
              return this.parseXmlString(ue);
            }, this.getVersion = function() {
              return "1.2.0";
            };
          }, yi = "onLoad";
          function ns(i) {
            i = i || {};
            var r, u, _, w, I, y, N = this.context, Z = (0, p.Z)(N).getInstance(), Y = (0, $e.Z)(N).getInstance();
            function V(ae, he, Ee) {
              var j, ue, z = {};
              z.elements = ae, z.type = he, z.resolveType = Ee, z.elements.length === 0 && H(z);
              for (var me = 0; me < z.elements.length; me++) j = z.elements[me], ue = Y.isHTTPURL(j.url) ? j.url : j.originalContent.BaseURL + j.url, y.load(ue, j, z);
            }
            function M(ae) {
              var he, Ee, j = "";
              if (he = ae.element, Ee = ae.resolveObject, he.resolvedContent) {
                var ue = 0;
                he.resolvedContent.indexOf("<?xml") === 0 && (ue = he.resolvedContent.indexOf("?>") + 2), j = he.resolvedContent.substr(0, ue) + "<response>" + he.resolvedContent.substr(ue) + "</response>", he.resolvedContent = I.xml_str2json(j);
              }
              (function(z) {
                var me;
                for (me = 0; me < z.elements.length; me++) if (z.elements[me].resolved === !1) return !1;
                return !0;
              })(Ee) && H(Ee);
            }
            function H(ae) {
              var he, Ee, j = [];
              if (function(ue) {
                var z, me, g, x, O, L, A = [];
                for (x = ue.elements.length - 1; x >= 0; x--) {
                  if (me = (z = ue.elements[x]).type + "_asArray", z.resolvedContent) {
                    if (z.resolvedContent) for (O = 0; O < z.resolvedContent[me].length; O++) g = z.resolvedContent[me][O], A.push(g);
                  } else delete z.originalContent["xlink:actuate"], delete z.originalContent["xlink:href"], A.push(z.originalContent);
                  for (z.parentElement[me].splice(z.index, 1), L = 0; L < A.length; L++) z.parentElement[me].splice(z.index + L, 0, A[L]);
                  A = [];
                }
                ue.elements.length > 0 && _.run(w);
              }(ae), ae.resolveType === "onActuate" && Z.trigger(o.Z.XLINK_READY, { manifest: w }), ae.resolveType === yi) switch (ae.type) {
                case e.Z.PERIOD:
                  for (he = 0; he < w[e.Z.PERIOD + "_asArray"].length; he++) (Ee = w[e.Z.PERIOD + "_asArray"][he]).hasOwnProperty(e.Z.ADAPTATION_SET + "_asArray") && (j = j.concat(G(Ee[e.Z.ADAPTATION_SET + "_asArray"], Ee, e.Z.ADAPTATION_SET, yi))), Ee.hasOwnProperty(e.Z.EVENT_STREAM + "_asArray") && (j = j.concat(G(Ee[e.Z.EVENT_STREAM + "_asArray"], Ee, e.Z.EVENT_STREAM, yi)));
                  V(j, e.Z.ADAPTATION_SET, yi);
                  break;
                case e.Z.ADAPTATION_SET:
                  Z.trigger(o.Z.XLINK_READY, { manifest: w });
              }
            }
            function G(ae, he, Ee, j) {
              var ue, z, me, g = [];
              for (z = ae.length - 1; z >= 0; z--) (ue = ae[z]).hasOwnProperty("xlink:href") && ue["xlink:href"] === "urn:mpeg:dash:resolve-to-zero:2013" && ae.splice(z, 1);
              for (z = 0; z < ae.length; z++) (ue = ae[z]).hasOwnProperty("xlink:href") && ue.hasOwnProperty("xlink:actuate") && ue["xlink:actuate"] === j && (me = pe(ue["xlink:href"], he, Ee, z, j, ue), g.push(me));
              return g;
            }
            function pe(ae, he, Ee, j, ue, z) {
              return { url: ae, parentElement: he, type: Ee, index: j, resolveType: ue, originalContent: z, resolvedContent: null, resolved: !1 };
            }
            return r = { resolveManifestOnLoad: function(ae) {
              I = new ts({ escapeMode: !1, attributePrefix: "", arrayAccessForm: "property", emptyNodeForm: "object", stripWhitespaces: !1, enableToStringFunc: !1, ignoreRoot: !0, matchers: u }), (w = ae).Period_asArray ? V(G(w.Period_asArray, w, e.Z.PERIOD, yi), e.Z.PERIOD, yi) : Z.trigger(o.Z.XLINK_READY, { manifest: w });
            }, setMatchers: function(ae) {
              ae && (u = ae);
            }, setIron: function(ae) {
              ae && (_ = ae);
            }, reset: function() {
              Z.off(o.Z.XLINK_ELEMENT_LOADED, M, r), y && (y.reset(), y = null);
            } }, Z.on(o.Z.XLINK_ELEMENT_LOADED, M, r), y = su(N).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, settings: i.settings }), r;
          }
          ns.__dashjs_factory_name = "XlinkController";
          var lu = v.Z.getClassFactory(ns);
          function Ri(i) {
            return Ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ri(i);
          }
          function rs(i) {
            function r(w, I) {
              for (var y in w) I.hasOwnProperty(y) || (I[y] = w[y]);
            }
            function u(w, I, y) {
              for (var N = 0, Z = w.length; N < Z; ++N) {
                var Y = w[N];
                if (I[Y.name]) if (y[Y.name]) {
                  if (Y.merge) {
                    var V = I[Y.name], M = y[Y.name];
                    Ri(V) === "object" && Ri(M) === "object" ? r(V, M) : y[Y.name] = V + M;
                  }
                } else y[Y.name] = I[Y.name];
              }
            }
            function _(w, I) {
              for (var y = 0, N = w.children.length; y < N; ++y) {
                var Z = w.children[y], Y = I[Z.name + "_asArray"];
                if (Y) for (var V = 0, M = Y.length; V < M; ++V) {
                  var H = Y[V];
                  u(w.properties, I, H), _(Z, H);
                }
              }
            }
            return { run: function(w) {
              if (w === null || Ri(w) !== "object") return w;
              if (w.Period_asArray && "period" in i) for (var I = i.period, y = w.Period_asArray, N = 0, Z = y.length; N < Z; ++N) {
                var Y = y[N];
                if (_(I, Y), "adaptationset" in i) {
                  var V = Y.AdaptationSet_asArray;
                  if (V) for (var M = i.adaptationset, H = 0, G = V.length; H < G; ++H) _(M, V[H]);
                }
              }
              return w;
            } };
          }
          rs.__dashjs_factory_name = "ObjectIron";
          var uu = v.Z.getClassFactory(rs);
          function cu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Ni = function() {
            function i(_, w) {
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._test = _, this._converter = w;
            }
            var r, u;
            return r = i, (u = [{ key: "test", get: function() {
              return this._test;
            } }, { key: "converter", get: function() {
              return this._converter;
            } }]) && cu(r.prototype, u), i;
          }();
          function ja(i) {
            return ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, ja(i);
          }
          function qn(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Ya(i, r) {
            return Ya = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Ya(i, r);
          }
          function fu(i, r) {
            return !r || ja(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function $i(i) {
            return $i = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, $i(i);
          }
          var du = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Ya(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = $i(r);
              if (u) {
                var N = $i(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return fu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I, y) {
                var N, Z = (qn(N = {}, e.Z.MPD, [e.Z.ID, e.Z.PROFILES]), qn(N, e.Z.PERIOD, [e.Z.ID]), qn(N, e.Z.BASE_URL, [e.Z.SERVICE_LOCATION, e.Z.BYTE_RANGE]), qn(N, e.Z.SEGMENT_BASE, [e.Z.INDEX_RANGE]), qn(N, e.Z.INITIALIZATION, [e.Z.RANGE]), qn(N, e.Z.REPRESENTATION_INDEX, [e.Z.RANGE]), qn(N, e.Z.SEGMENT_LIST, [e.Z.INDEX_RANGE]), qn(N, e.Z.BITSTREAM_SWITCHING, [e.Z.RANGE]), qn(N, e.Z.SEGMENT_URL, [e.Z.MEDIA_RANGE, e.Z.INDEX_RANGE]), qn(N, e.Z.SEGMENT_TEMPLATE, [e.Z.INDEX_RANGE, e.Z.MEDIA, e.Z.INDEX, e.Z.INITIALIZATION_MINUS, e.Z.BITSTREAM_SWITCHING_MINUS]), qn(N, e.Z.ASSET_IDENTIFIER, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.EVENT_STREAM, [e.Z.VALUE]), qn(N, e.Z.ADAPTATION_SET, [e.Z.PROFILES, e.Z.MIME_TYPE, e.Z.SEGMENT_PROFILES, e.Z.CODECS, e.Z.CONTENT_TYPE]), qn(N, e.Z.FRAME_PACKING, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.AUDIO_CHANNEL_CONFIGURATION, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.CONTENT_PROTECTION, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.ESSENTIAL_PROPERTY, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.SUPPLEMENTAL_PROPERTY, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.INBAND_EVENT_STREAM, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.ACCESSIBILITY, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.ROLE, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.RATING, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.VIEWPOINT, [e.Z.VALUE, e.Z.ID]), qn(N, e.Z.CONTENT_COMPONENT, [e.Z.CONTENT_TYPE]), qn(N, e.Z.REPRESENTATION, [e.Z.ID, e.Z.DEPENDENCY_ID, e.Z.MEDIA_STREAM_STRUCTURE_ID]), qn(N, e.Z.SUBSET, [e.Z.ID]), qn(N, e.Z.METRICS, [e.Z.METRICS_MINUS]), qn(N, e.Z.REPORTING, [e.Z.VALUE, e.Z.ID]), N);
                if (Z.hasOwnProperty(y)) {
                  var Y = Z[y];
                  return Y !== void 0 && Y.indexOf(I.name) >= 0;
                }
                return !1;
              }, function(I) {
                return String(I);
              });
            }
            return w;
          }(Ni);
          function Ka(i) {
            return Ka = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ka(i);
          }
          function za(i, r) {
            return za = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, za(i, r);
          }
          function gu(i, r) {
            return !r || Ka(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function Ji(i) {
            return Ji = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, Ji(i);
          }
          var is = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/, hu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), za(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = Ji(r);
              if (u) {
                var N = Ji(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return gu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I) {
                for (var y = [e.Z.MIN_BUFFER_TIME, e.Z.MEDIA_PRESENTATION_DURATION, e.Z.MINIMUM_UPDATE_PERIOD, e.Z.TIMESHIFT_BUFFER_DEPTH, e.Z.MAX_SEGMENT_DURATION, e.Z.MAX_SUBSEGMENT_DURATION, e.Z.SUGGESTED_PRESENTATION_DELAY, e.Z.START, t.Z.START_TIME, e.Z.DURATION], N = y.length, Z = 0; Z < N; Z++) if (I.nodeName === y[Z]) return is.test(I.value);
                return !1;
              }, function(I) {
                var y = is.exec(I), N = 31536e3 * parseFloat(y[3] || 0) + 2592e3 * parseFloat(y[5] || 0) + 86400 * parseFloat(y[7] || 0) + 3600 * parseFloat(y[9] || 0) + 60 * parseFloat(y[11] || 0) + parseFloat(y[13] || 0);
                return y[1] !== void 0 && (N = -N), N;
              });
            }
            return w;
          }(Ni);
          function Wa(i) {
            return Wa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Wa(i);
          }
          function Qa(i, r) {
            return Qa = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, Qa(i, r);
          }
          function mu(i, r) {
            return !r || Wa(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function ea(i) {
            return ea = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ea(i);
          }
          var as = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/, pu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), Qa(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ea(r);
              if (u) {
                var N = ea(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return mu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I) {
                return as.test(I.value);
              }, function(I) {
                var y, N = as.exec(I);
                if (y = Date.UTC(parseInt(N[1], 10), parseInt(N[2], 10) - 1, parseInt(N[3], 10), parseInt(N[4], 10), parseInt(N[5], 10), N[6] && parseInt(N[6], 10) || 0, N[7] && 1e3 * parseFloat(N[7]) || 0), N[9] && N[10]) {
                  var Z = 60 * parseInt(N[9], 10) + parseInt(N[10], 10);
                  y += (N[8] === "+" ? -1 : 1) * Z * 60 * 1e3;
                }
                return new Date(y);
              });
            }
            return w;
          }(Ni);
          function Xa(i) {
            return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Xa(i);
          }
          function $a(i, r) {
            return $a = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, $a(i, r);
          }
          function yu(i, r) {
            return !r || Xa(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function ta(i) {
            return ta = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ta(i);
          }
          var _u = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/, Eu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), $a(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ta(r);
              if (u) {
                var N = ta(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return yu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I) {
                return _u.test(I.value);
              }, function(I) {
                return parseFloat(I);
              });
            }
            return w;
          }(Ni);
          function Ja(i) {
            return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, Ja(i);
          }
          function Di(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function eo(i, r) {
            return eo = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, eo(i, r);
          }
          function vu(i, r) {
            return !r || Ja(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function na(i) {
            return na = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, na(i);
          }
          var Tu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), eo(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = na(r);
              if (u) {
                var N = na(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return vu(this, I);
            });
            function w() {
              return function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              }(this, w), _.call(this, function(I, y) {
                var N, Z = (Di(N = {}, e.Z.ADAPTATION_SET, [e.Z.LANG]), Di(N, e.Z.REPRESENTATION, [e.Z.LANG]), Di(N, e.Z.CONTENT_COMPONENT, [e.Z.LANG]), Di(N, e.Z.LABEL, [e.Z.LANG]), Di(N, e.Z.GROUP_LABEL, [e.Z.LANG]), N);
                if (Z.hasOwnProperty(y)) {
                  var Y = Z[y];
                  return Y !== void 0 && Y.indexOf(I.name) >= 0;
                }
                return !1;
              }, function(I) {
                return Wi()(I) || String(I);
              });
            }
            return w;
          }(Ni);
          function bu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var Su = function() {
            function i(_) {
              var w;
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._name = _, this._merge = (w = _) && w.length && w.charAt(0) === w.charAt(0).toUpperCase();
            }
            var r, u;
            return r = i, (u = [{ key: "name", get: function() {
              return this._name;
            } }, { key: "merge", get: function() {
              return this._merge;
            } }]) && bu(r.prototype, u), i;
          }();
          function Au(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var _i = function() {
            function i(_, w, I) {
              var y = this;
              (function(N, Z) {
                if (!(N instanceof Z)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this._name = _ || "", this._properties = [], this._children = I || [], Array.isArray(w) && w.forEach(function(N) {
                y._properties.push(new Su(N));
              });
            }
            var r, u;
            return r = i, (u = [{ key: "name", get: function() {
              return this._name;
            } }, { key: "children", get: function() {
              return this._children;
            } }, { key: "properties", get: function() {
              return this._properties;
            } }]) && Au(r.prototype, u), i;
          }();
          function to(i) {
            return to = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, to(i);
          }
          function no(i, r) {
            return no = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, no(i, r);
          }
          function Iu(i, r) {
            return !r || to(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function ra(i) {
            return ra = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ra(i);
          }
          var Cu = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), no(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ra(r);
              if (u) {
                var N = ra(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return Iu(this, I);
            });
            function w() {
              (function(y, N) {
                if (!(y instanceof N)) throw new TypeError("Cannot call a class as a function");
              })(this, w);
              var I = [e.Z.PROFILES, e.Z.WIDTH, e.Z.HEIGHT, e.Z.SAR, e.Z.FRAMERATE, e.Z.AUDIO_SAMPLING_RATE, e.Z.MIME_TYPE, e.Z.SEGMENT_PROFILES, e.Z.CODECS, e.Z.MAXIMUM_SAP_PERIOD, e.Z.START_WITH_SAP, e.Z.MAX_PLAYOUT_RATE, e.Z.CODING_DEPENDENCY, e.Z.SCAN_TYPE, e.Z.FRAME_PACKING, e.Z.AUDIO_CHANNEL_CONFIGURATION, e.Z.CONTENT_PROTECTION, e.Z.ESSENTIAL_PROPERTY, e.Z.ESSENTIAL_PROPERTY + "_asArray", e.Z.SUPPLEMENTAL_PROPERTY, e.Z.INBAND_EVENT_STREAM];
              return _.call(this, e.Z.ADAPTATION_SET, I, [new _i(e.Z.REPRESENTATION, I, [new _i(e.Z.SUB_REPRESENTATION, I)])]);
            }
            return w;
          }(_i);
          function ro(i) {
            return ro = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, ro(i);
          }
          function io(i, r) {
            return io = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, io(i, r);
          }
          function wu(i, r) {
            return !r || ro(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function ia(i) {
            return ia = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, ia(i);
          }
          var Ru = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), io(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = ia(r);
              if (u) {
                var N = ia(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return wu(this, I);
            });
            function w() {
              (function(y, N) {
                if (!(y instanceof N)) throw new TypeError("Cannot call a class as a function");
              })(this, w);
              var I = [e.Z.SEGMENT_BASE, e.Z.SEGMENT_TEMPLATE, e.Z.SEGMENT_LIST];
              return _.call(this, e.Z.PERIOD, I, [new _i(e.Z.ADAPTATION_SET, I, [new _i(e.Z.REPRESENTATION, I)])]);
            }
            return w;
          }(_i);
          function os(i) {
            i = i || {};
            var r, u, _, w, I, y = this.context, N = i.debug;
            return r = { parse: function(Z) {
              var Y, V = window.performance.now();
              if (!(Y = w.xml_str2json(Z))) throw new Error("parsing the manifest failed");
              var M = window.performance.now();
              Y.Patch ? ((Y = Y.Patch).add_asArray && Y.add_asArray.forEach(function(G) {
                return I.run(G);
              }), Y.replace_asArray && Y.replace_asArray.forEach(function(G) {
                return I.run(G);
              })) : (Y = Y.MPD, I.run(Y));
              var H = window.performance.now();
              return u.info("Parsing complete: ( xml2json: " + (M - V).toPrecision(3) + "ms, objectiron: " + (H - M).toPrecision(3) + "ms, total: " + ((H - V) / 1e3).toPrecision(3) + "s)"), Y.protocol = "DASH", Y;
            }, getMatchers: function() {
              return _;
            }, getIron: function() {
              return I;
            } }, u = N.getLogger(r), _ = [new hu(), new pu(), new Eu(), new Tu(), new du()], w = new ts({ escapeMode: !1, attributePrefix: "", arrayAccessForm: "property", emptyNodeForm: "object", stripWhitespaces: !1, enableToStringFunc: !0, ignoreRoot: !1, matchers: _ }), I = uu(y).create({ adaptationset: new Cu(), period: new Ru() }), r;
          }
          os.__dashjs_factory_name = "DashParser";
          var Nu = v.Z.getClassFactory(os);
          function ss(i) {
            i = i || {};
            var r, u, _, w, I, y = this.context, N = i.debug, Z = i.settings, Y = (0, p.Z)(y).getInstance(), V = (0, $e.Z)(y).getInstance(), M = i.mssHandler, H = i.errHandler;
            function G(ae) {
              Y.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: ae.manifest });
            }
            function pe(ae) {
              var he = null;
              return ae.indexOf("SmoothStreamingMedia") > -1 ? (M && (he = M.createMssParser(), M.createMssFragmentProcessor(), M.registerEvents()), he) : ae.indexOf("MPD") > -1 || ae.indexOf("Patch") > -1 ? Nu(y).create({ debug: N }) : he;
            }
            return r = { load: function(ae) {
              var he = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, Ee = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, j = /* @__PURE__ */ new Date(), ue = new Jo(ae, Ge.w.MPD_TYPE);
              he && (ue.serviceLocation = he), Ee && (ue.queryParams = Ee), ue.requestStartDate || (ue.requestStartDate = j), Y.trigger(o.Z.MANIFEST_LOADING_STARTED, { request: ue }), _.load({ request: ue, success: function(z, me, g) {
                var x, O, L;
                if (w) if (g && g !== ae ? (O = V.parseBaseUrl(g), x = g) : (V.isRelative(ae) && (ae = V.resolve(ae, window.location.href)), O = V.parseBaseUrl(ae)), me != "No Content") if (I === null && (I = pe(z)), I !== null) {
                  w.setMatchers(I.getMatchers()), w.setIron(I.getIron());
                  try {
                    L = I.parse(z);
                  } catch {
                    return void Y.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z(ee.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, ee.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae)) });
                  }
                  if (L) {
                    if (L.url = x || ae, L.originalUrl || (L.originalUrl = L.url), Z && Z.get().streaming.enableManifestDurationMismatchFix && L.mediaPresentationDuration && L.Period_asArray.length > 1) {
                      var A = L.Period_asArray.reduce(function(oe, X) {
                        return oe + X.duration;
                      }, 0);
                      !isNaN(A) && L.mediaPresentationDuration > A && (u.warn("Media presentation duration greater than duration of all periods. Setting duration to total period duration"), L.mediaPresentationDuration = A);
                    }
                    L.baseUri = O, L.loadedTime = /* @__PURE__ */ new Date(), w.resolveManifestOnLoad(L), Y.trigger(o.Z.ORIGINAL_MANIFEST_LOADED, { originalManifest: z });
                  } else Y.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z(ee.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, ee.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae)) });
                } else Y.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z(ee.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, ee.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(ae)) });
                else Y.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null });
              }, error: function(z, me, g) {
                Y.trigger(o.Z.INTERNAL_MANIFEST_LOADED, { manifest: null, error: new se.Z(ee.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE, ee.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE + "".concat(ae, ", ").concat(g)) });
              } });
            }, reset: function() {
              Y.off(o.Z.XLINK_READY, G, r), M && M.reset(), w && (w.reset(), w = null), _ && (_.abort(), _ = null);
            } }, u = N.getLogger(r), Y.on(o.Z.XLINK_READY, G, r), _ = hr(y).create({ errHandler: i.errHandler, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, urlUtils: V, constants: t.Z, dashConstants: e.Z, errors: ee, requestTimeout: i.settings.get().streaming.manifestRequestTimeout }), w = lu(y).create({ errHandler: H, dashMetrics: i.dashMetrics, mediaPlayerModel: i.mediaPlayerModel, requestModifier: i.requestModifier, settings: i.settings }), I = null, r;
          }
          ss.__dashjs_factory_name = "ManifestLoader";
          var Du = v.Z.getClassFactory(ss);
          function ls() {
            var i = this.context, r = (0, p.Z)(i).getInstance();
            return { error: function(u) {
              r.trigger(o.Z.ERROR, { error: u });
            } };
          }
          ls.__dashjs_factory_name = "ErrorHandler";
          var Mu = v.Z.getSingletonFactory(ls), us = R(1715);
          function cs() {
            var i, r, u, _, w, I, y = this.context, N = (0, p.Z)(y).getInstance();
            function Z(Y, V) {
              if (!V || !V.Period_asArray || V.Period_asArray.length === 0) return Promise.resolve();
              var M = [];
              return V.Period_asArray.forEach(function(H) {
                M.push(function(G, pe) {
                  return new Promise(function(ae) {
                    if (G && G.AdaptationSet_asArray && G.AdaptationSet_asArray.length !== 0) {
                      var he = [];
                      G.AdaptationSet_asArray.forEach(function(Ee) {
                        r.getIsTypeOf(Ee, pe) && he.push(function(j, ue) {
                          return new Promise(function(z) {
                            if (j.Representation_asArray && j.Representation_asArray.length !== 0) {
                              var me = [], g = [];
                              j.Representation_asArray.forEach(function(x, O) {
                                var L = r.getCodec(j, O, !1), A = function(oe, X, de) {
                                  switch (oe) {
                                    case t.Z.VIDEO:
                                      return function(ne, U) {
                                        return { codec: U, width: ne.width || null, height: ne.height || null, framerate: ne.frameRate || null, bitrate: ne.bandwidth || null };
                                      }(X, de);
                                    case t.Z.AUDIO:
                                      return function(ne, U) {
                                        var re = ne.audioSamplingRate || null;
                                        return { codec: U, bitrate: ne.bandwidth || null, samplerate: re };
                                      }(X, de);
                                    default:
                                      return null;
                                  }
                                }(ue, x, L);
                                g.push(A), me.push(u.supportsCodec(A, ue));
                              }), Promise.all(me).then(function(x) {
                                j.Representation_asArray = j.Representation_asArray.filter(function(O, L) {
                                  return x[L] || I.debug("[Stream] Codec ".concat(g[L].codec, " not supported ")), x[L];
                                }), z();
                              }).catch(function() {
                                z();
                              });
                            } else z();
                          });
                        }(Ee, pe));
                      }), Promise.all(he).then(function() {
                        G.AdaptationSet_asArray = G.AdaptationSet_asArray.filter(function(Ee) {
                          var j = Ee.Representation_asArray && Ee.Representation_asArray.length > 0;
                          return j || (N.trigger(o.Z.ADAPTATION_SET_REMOVED_NO_CAPABILITIES, { adaptationSet: Ee }), I.warn("AdaptationSet has been removed because of no supported Representation")), j;
                        }), ae();
                      }).catch(function() {
                        ae();
                      });
                    } else ae();
                  });
                }(H, Y));
              }), Promise.all(M);
            }
            return i = { setConfig: function(Y) {
              Y && (Y.adapter && (r = Y.adapter), Y.capabilities && (u = Y.capabilities), Y.settings && (_ = Y.settings), Y.customParametersModel && (w = Y.customParametersModel));
            }, filterUnsupportedFeatures: function(Y) {
              return new Promise(function(V) {
                var M = [];
                M.push(Z(t.Z.VIDEO, Y)), M.push(Z(t.Z.AUDIO, Y)), Promise.all(M).then(function() {
                  _.get().streaming.capabilities.filterUnsupportedEssentialProperties && function(H) {
                    H && H.Period_asArray && H.Period_asArray.length !== 0 && H.Period_asArray.forEach(function(G) {
                      G.AdaptationSet_asArray = G.AdaptationSet_asArray.filter(function(pe) {
                        return !pe.Representation_asArray || pe.Representation_asArray.length === 0 || (pe.Representation_asArray = pe.Representation_asArray.filter(function(ae) {
                          var he = r.getEssentialPropertiesForRepresentation(ae);
                          if (he && he.length > 0) for (var Ee = 0; Ee < he.length; ) {
                            if (!u.supportsEssentialProperty(he[Ee])) return I.debug("[Stream] EssentialProperty not supported: " + he[Ee].schemeIdUri), !1;
                            Ee += 1;
                          }
                          return !0;
                        }), pe.Representation_asArray && pe.Representation_asArray.length > 0);
                      });
                    });
                  }(Y), function(H) {
                    var G = w.getCustomCapabilitiesFilters();
                    G && G.length !== 0 && H && H.Period_asArray && H.Period_asArray.length !== 0 && H.Period_asArray.forEach(function(pe) {
                      pe.AdaptationSet_asArray = pe.AdaptationSet_asArray.filter(function(ae) {
                        return !ae.Representation_asArray || ae.Representation_asArray.length === 0 || (ae.Representation_asArray = ae.Representation_asArray.filter(function(he) {
                          return !G.some(function(Ee) {
                            return !Ee(he);
                          });
                        }), ae.Representation_asArray && ae.Representation_asArray.length > 0);
                      });
                    });
                  }(Y), V();
                }).catch(function() {
                  V();
                });
              });
            } }, I = (0, m.Z)(y).getInstance().getLogger(i), i;
          }
          cs.__dashjs_factory_name = "CapabilitiesFilter";
          var Ou = v.Z.getSingletonFactory(cs), Lu = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.xywh = null, this.track = null, this.id = null, this.s = null, this.r = null;
          };
          function fs() {
            var i;
            return { initialize: function(r) {
              if (i = new Lu(), !r) return null;
              var u = r.indexOf("#");
              if (u !== -1) for (var _ = r.substr(u + 1).split("&"), w = 0, I = _.length; w < I; ++w) {
                var y = _[w], N = y.indexOf("=");
                if (N !== -1) {
                  var Z = y.substring(0, N);
                  i.hasOwnProperty(Z) && (i[Z] = y.substr(N + 1));
                }
              }
            }, getURIFragmentData: function() {
              return i;
            } };
          }
          fs.__dashjs_factory_name = "URIFragmentModel";
          var Pu = v.Z.getSingletonFactory(fs);
          function ds() {
            var i, r = this.context, u = (0, p.Z)(r).getInstance();
            return { getValue: function() {
              return i;
            }, setValue: function(_) {
              i = _, _ && u.trigger(o.Z.MANIFEST_LOADED, { data: _ });
            } };
          }
          ds.__dashjs_factory_name = "ManifestModel";
          var xu = v.Z.getSingletonFactory(ds), ao = -0.5;
          function gs() {
            var i, r, u, _, w = this.context, I = (0, Oe.Z)(w).getInstance();
            function y(Y, V) {
              return isNaN(Y) ? 0 : Y > 0 ? (V && r.warn("Supplied minimum playback rate is a positive value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : Y < ao ? (V && r.warn("Supplied minimum playback rate is out of range and will be limited to ".concat(ao, ": ").concat(-50, "% playback speed.")), ao) : Y;
            }
            function N(Y, V) {
              return isNaN(Y) ? 0 : Y < 0 ? (V && r.warn("Supplied maximum playback rate is a negative value when it should be negative or 0. The supplied rate will not be applied and set to 0: 100% playback speed."), 0) : Y > 1 ? (V && r.warn("Supplied maximum playback rate is out of range and will be limited to ".concat(1, ": ").concat(200, "% playback speed.")), 1) : Y;
            }
            function Z() {
              var Y = I.get().streaming.buffer.stableBufferTime > 0 ? I.get().streaming.buffer.stableBufferTime : I.get().streaming.buffer.fastSwitchEnabled ? 20 : 12, V = u.getLiveDelay();
              return !isNaN(V) && V > 0 ? Math.min(Y, V) : Y;
            }
            return i = { getCatchupMaxDrift: function() {
              if (!isNaN(I.get().streaming.liveCatchup.maxDrift) && I.get().streaming.liveCatchup.maxDrift > 0) return I.get().streaming.liveCatchup.maxDrift;
              var Y = _.getServiceDescriptionSettings();
              return Y && Y.liveCatchup && !isNaN(Y.liveCatchup.maxDrift) && Y.liveCatchup.maxDrift > 0 ? Y.liveCatchup.maxDrift : 12;
            }, getCatchupModeEnabled: function() {
              return I.get().streaming.liveCatchup.enabled !== null ? I.get().streaming.liveCatchup.enabled : u.getInitialCatchupModeActivated();
            }, getStableBufferTime: Z, getInitialBufferLevel: function() {
              var Y = I.get().streaming.buffer.initialBufferLevel;
              return isNaN(Y) || Y < 0 ? 0 : Math.min(Z(), Y);
            }, getRetryAttemptsForType: function(Y) {
              var V = isNaN(I.get().streaming.retryAttempts.lowLatencyMultiplyFactor) ? 5 : I.get().streaming.retryAttempts.lowLatencyMultiplyFactor;
              return u.getLowLatencyModeEnabled() ? I.get().streaming.retryAttempts[Y] * V : I.get().streaming.retryAttempts[Y];
            }, getRetryIntervalsForType: function(Y) {
              var V = isNaN(I.get().streaming.retryIntervals.lowLatencyReductionFactor) ? 10 : I.get().streaming.retryIntervals.lowLatencyReductionFactor;
              return u.getLowLatencyModeEnabled() ? I.get().streaming.retryIntervals[Y] / V : I.get().streaming.retryIntervals[Y];
            }, getCatchupPlaybackRates: function(Y) {
              var V = I.get().streaming.liveCatchup.playbackRate;
              if (!isNaN(V.min) || !isNaN(V.max)) return { min: y(V.min, Y), max: N(V.max, Y) };
              var M = _.getServiceDescriptionSettings();
              if (M && M.liveCatchup && (!isNaN(M.liveCatchup.playbackRate.min) || !isNaN(M.liveCatchup.playbackRate.max))) {
                var H = M.liveCatchup.playbackRate;
                return { min: y(H.min, Y), max: N(H.max, Y) };
              }
              return { min: -0.5, max: 0.5 };
            }, getAbrBitrateParameter: function(Y, V) {
              try {
                var M = I.get().streaming.abr[Y][V];
                if (!isNaN(M) && M !== -1) return M;
                var H = _.getServiceDescriptionSettings();
                return H && H[Y] && !isNaN(H[Y][V]) ? H[Y][V] : -1;
              } catch {
                return -1;
              }
            }, setConfig: function(Y) {
              Y.playbackController && (u = Y.playbackController), Y.serviceDescriptionController && (_ = Y.serviceDescriptionController);
            }, reset: function() {
            } }, r = (0, m.Z)(w).getInstance().getLogger(i), i;
          }
          gs.__dashjs_factory_name = "MediaPlayerModel";
          var Fu = v.Z.getSingletonFactory(gs), ku = R(1767);
          function hs(i) {
            var r = (i = i || {}).abrController, u = i.switchHistory, _ = i.droppedFramesHistory, w = i.currentRequest, I = i.useBufferOccupancyABR, y = i.useL2AABR, N = i.useLoLPABR, Z = i.streamProcessor ? i.streamProcessor.getScheduleController() : null, Y = i.streamProcessor ? i.streamProcessor.getRepresentationInfo() : null, V = i.videoModel ? i.videoModel : null;
            function M() {
              return Y ? Y.mediaInfo : null;
            }
            return { getMediaType: function() {
              var H = M();
              return H ? H.type : null;
            }, getMediaInfo: M, getDroppedFramesHistory: function() {
              return _;
            }, getCurrentRequest: function() {
              return w;
            }, getSwitchHistory: function() {
              return u;
            }, getStreamInfo: function() {
              var H = M();
              return H ? H.streamInfo : null;
            }, getScheduleController: function() {
              return Z;
            }, getAbrController: function() {
              return r;
            }, getRepresentationInfo: function() {
              return Y;
            }, useBufferOccupancyABR: function() {
              return I;
            }, useL2AABR: function() {
              return y;
            }, useLoLPABR: function() {
              return N;
            }, getVideoModel: function() {
              return V;
            } };
          }
          hs.__dashjs_factory_name = "RulesContext";
          var ms = v.Z.getClassFactory(hs), aa = R(2068);
          function ps() {
            var i = [], r = [];
            return { push: function(u) {
              u.newValue === aa.Z.NO_CHANGE && (u.newValue = u.oldValue), i[u.oldValue] || (i[u.oldValue] = { noDrops: 0, drops: 0, dropSize: 0 });
              var _ = u.newValue - u.oldValue, w = _ < 0 ? 1 : 0, I = w ? -_ : 0, y = w ? 0 : 1;
              if (i[u.oldValue].drops += w, i[u.oldValue].dropSize += I, i[u.oldValue].noDrops += y, r.push({ idx: u.oldValue, noDrop: y, drop: w, dropSize: I }), r.length > 8) {
                var N = r.shift();
                i[N.idx].drops -= N.drop, i[N.idx].dropSize -= N.dropSize, i[N.idx].noDrops -= N.noDrop;
              }
            }, getSwitchRequests: function() {
              return i;
            }, reset: function() {
              i = [], r = [];
            } };
          }
          ps.__dashjs_factory_name = "SwitchRequestHistory";
          var Zu = v.Z.getClassFactory(ps);
          function ys() {
            var i = {}, r = {}, u = {};
            return { push: function(_, w, I) {
              if (w) {
                i[_] || (i[_] = [], r[_] = 0, u[_] = 0);
                var y = I && I.droppedVideoFrames ? I.droppedVideoFrames : 0, N = I && I.totalVideoFrames ? I.totalVideoFrames : 0, Z = y - r[_];
                r[_] = y;
                var Y = N - u[_];
                u[_] = N;
                var V = i[_];
                isNaN(w) || (V[w] ? (V[w].droppedVideoFrames += Z, V[w].totalVideoFrames += Y) : V[w] = { droppedVideoFrames: Z, totalVideoFrames: Y });
              }
            }, getFrameHistory: function(_) {
              return i[_];
            }, clearForStream: function(_) {
              try {
                delete i[_], delete r[_], delete u[_];
              } catch {
              }
            }, reset: function() {
              i = {}, r = {}, u = {};
            } };
          }
          ys.__dashjs_factory_name = "DroppedFramesHistory";
          var Bu = v.Z.getClassFactory(ys);
          function _s(i) {
            var r, u, _, w, I, y = this.context, N = (i = i || {}).settings, Z = (0, p.Z)(y).getInstance();
            function Y(ae, he, Ee, j) {
              var ue = Math.pow(0.5, Ee / j.fast);
              ae.fastEstimate = (1 - ue) * he + ue * ae.fastEstimate;
              var z = Math.pow(0.5, Ee / j.slow);
              ae.slowEstimate = (1 - z) * he + z * ae.slowEstimate, ae.totalWeight += Ee;
            }
            function V(ae, he, Ee) {
              return N.get().streaming.abr.movingAverageMethod !== t.Z.MOVING_AVERAGE_SLIDING_WINDOW ? function(j, ue) {
                var z = j ? I.throughputHalfLife : I.latencyHalfLife, me = j ? _[ue] : w[ue];
                if (!me || me.totalWeight <= 0) return NaN;
                var g = me.fastEstimate / (1 - Math.pow(0.5, me.totalWeight / z.fast)), x = me.slowEstimate / (1 - Math.pow(0.5, me.totalWeight / z.slow));
                return j ? Math.min(g, x) : Math.max(g, x);
              }(ae, he) : function(j, ue, z) {
                var me = function(x, O, L) {
                  var A, oe;
                  if (x ? (A = r[O], oe = L ? 3 : 4) : (A = u[O], oe = 4), A) {
                    if (oe >= A.length) oe = A.length;
                    else if (x) for (var X = 1; X < oe; ++X) {
                      var de = A[A.length - X] / A[A.length - X - 1];
                      if ((de >= 1.3 || de <= 0.7692307692307692) && (oe += 1) === A.length) break;
                    }
                  } else oe = 0;
                  return oe;
                }(j, ue, z), g = (j ? r : u)[ue];
                return me !== 0 && g && g.length !== 0 ? (g = g.slice(-me)).reduce(function(x, O) {
                  return x + O;
                }) / g.length : NaN;
              }(ae, he, Ee);
            }
            function M(ae, he) {
              return V(!0, ae, he);
            }
            function H(ae) {
              r[ae] = r[ae] || [], u[ae] = u[ae] || [], _[ae] = _[ae] || { fastEstimate: 0, slowEstimate: 0, totalWeight: 0 }, w[ae] = w[ae] || { fastEstimate: 0, slowEstimate: 0, totalWeight: 0 };
            }
            function G() {
              r = {}, u = {}, _ = {}, w = {};
            }
            var pe = { push: function(ae, he, Ee) {
              if (he.trace && he.trace.length) {
                var j, ue = he.tresponse.getTime() - he.trequest.getTime() || 1, z = he._tfinish.getTime() - he.tresponse.getTime() || 1, me = he.trace.reduce(function(L, A) {
                  return L + A.b[0];
                }, 0), g = 0;
                if ((j = he._fileLoaderType && he._fileLoaderType === t.Z.FILE_LOADER_TYPES.FETCH ? he.trace.reduce(function(L, A) {
                  return L + A.d;
                }, 0) : Ee ? z : ue + z) !== 0 && (g = Math.round(8 * me / j)), he.cmsd) {
                  var x = he.cmsd.dynamic && he.cmsd.dynamic.etp ? he.cmsd.dynamic.etp : null;
                  if (x) {
                    var O = N.get().streaming.cmsd.abr.etpWeightRatio;
                    O > 0 && O <= 1 && (g = g * (1 - O) + x * O);
                  }
                }
                if (H(ae), function(L, A, oe) {
                  return L === t.Z.VIDEO ? oe < N.get().streaming.cacheLoadThresholds[t.Z.VIDEO] : L === t.Z.AUDIO ? oe < N.get().streaming.cacheLoadThresholds[t.Z.AUDIO] : void 0;
                }(ae, 0, z)) {
                  if (r[ae].length > 0 && !r[ae].hasCachedEntries) return;
                  r[ae].hasCachedEntries = !0;
                } else r[ae] && r[ae].hasCachedEntries && function(L) {
                  delete r[L], delete u[L], delete _[L], delete w[L], H(L);
                }(ae);
                r[ae].push(g), Z.trigger(n.Z.THROUGHPUT_MEASUREMENT_STORED, { throughput: g, mediaType: ae, httpRequest: he }), r[ae].length > 20 && r[ae].shift(), u[ae].push(ue), u[ae].length > 20 && u[ae].shift(), Y(_[ae], g, 1e-3 * z, I.throughputHalfLife), Y(w[ae], ue, 1, I.latencyHalfLife);
              }
            }, getAverageThroughput: M, getSafeAverageThroughput: function(ae, he) {
              var Ee = M(ae, he);
              return isNaN(Ee) || (Ee *= N.get().streaming.abr.bandwidthSafetyFactor), Ee;
            }, getAverageLatency: function(ae) {
              return V(!1, ae);
            }, reset: G };
            return I = { throughputHalfLife: { fast: 3, slow: 8 }, latencyHalfLife: { fast: 1, slow: 2 } }, G(), pe;
          }
          _s.__dashjs_factory_name = "ThroughputHistory";
          var Uu = v.Z.getClassFactory(_s);
          function oo() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j, ue, z, me, g, x, O, L, A, oe = this.context, X = (0, m.Z)(oe).getInstance(), de = (0, p.Z)(oe).getInstance();
            function ne() {
              w = {}, I = {}, N = {}, y = {}, ue = {}, g = {}, x = {}, O = {}, Y === void 0 && (Y = !1), z && z.reset(), j = void 0, z = void 0, me = void 0, clearTimeout(Z), Z = null;
            }
            function U(Re) {
              var He = Re.request.mediaType, yt = Re.streamId;
              if (He && yt && y[yt] && A.get().streaming.abr.autoSwitchBitrate[He]) {
                var Qe = y[yt][He];
                if (Qe) {
                  var Tt = ms(oe).create({ abrController: i, streamProcessor: Qe, currentRequest: Re.request, useBufferOccupancyABR: g[He], useL2AABR: x[He], useLoLPABR: O[He], videoModel: G }), vt = u.shouldAbandonFragment(Tt, yt);
                  vt.quality > aa.Z.NO_CHANGE && Qe.getFragmentModel().getRequests({ state: Q.FRAGMENT_MODEL_LOADING, index: Re.request.index })[0] && (N[yt][He].state = h.Z.ABANDON_LOAD, ue[yt][He].reset(), ue[yt][He].push({ oldValue: ke(He, yt), newValue: vt.quality, confidence: 1, reason: vt.reason }), Le(He, _.getActiveStreamInfo(), vt.quality, vt.reason), clearTimeout(Z), Z = setTimeout(function() {
                    N[yt][He].state = h.Z.ALLOW_LOAD, Z = null;
                  }, A.get().streaming.abandonLoadTimeout));
                }
              }
            }
            function re(Re) {
              Re.mediaType === t.Z.VIDEO && (j !== void 0 && z.push(Re.streamId, j, G.getPlaybackQuality()), j = Re.newQuality);
            }
            function Te(Re) {
              var He, yt;
              Re.metric !== h.Z.HTTP_REQUEST || !Re.value || Re.value.type !== Ge.w.MEDIA_SEGMENT_TYPE || Re.mediaType !== t.Z.AUDIO && Re.mediaType !== t.Z.VIDEO || me.push(Re.mediaType, Re.value, A.get().streaming.abr.useDeadTimeLatency), Re.metric !== h.Z.BUFFER_LEVEL || Re.mediaType !== t.Z.AUDIO && Re.mediaType !== t.Z.VIDEO || (He = Re.mediaType, yt = 1e-3 * Re.value.level, A.get().streaming.abr.ABRStrategy === t.Z.ABR_STRATEGY_DYNAMIC && function(Qe, Tt) {
                try {
                  var vt = pe.getStableBufferTime(), mt = vt, Wt = 0.5 * vt, zt = g[Qe], hn = Tt > (zt ? Wt : mt);
                  g[Qe] = hn, hn !== zt && (hn ? r.info("[" + Qe + "] switching from throughput to buffer occupancy ABR rule (buffer: " + Tt.toFixed(3) + ").") : r.info("[" + Qe + "] switching from buffer occupancy to throughput ABR rule (buffer: " + Tt.toFixed(3) + ")."));
                } catch (yn) {
                  r.error(yn);
                }
              }(He, yt));
            }
            function Fe(Re, He) {
              try {
                var yt;
                return w[He] = w[He] || {}, w[He].hasOwnProperty(Re) || (w[He][Re] = 0), yt = function(Qe, Tt) {
                  var vt = w[Tt][Qe], mt = vt;
                  if (!y[Tt] || !y[Tt][Qe]) return mt;
                  var Wt = De(Qe, Tt);
                  Wt !== void 0 && (mt = Math.max(vt, Wt));
                  var zt = function(hn, yn) {
                    try {
                      var ze = pe.getAbrBitrateParameter("maxBitrate", hn);
                      return ze > -1 ? rt(y[yn][hn].getMediaInfo(), ze, yn) : void 0;
                    } catch {
                      return;
                    }
                  }(Qe, Tt);
                  return zt !== void 0 && (mt = Math.min(mt, zt)), mt;
                }(Re, He), yt = function(Qe, Tt, vt) {
                  var mt = w[vt][Tt], Wt = A.get().streaming.abr.maxRepresentationRatio[Tt];
                  return isNaN(Wt) || Wt >= 1 || Wt < 0 ? Qe : Math.min(Qe, Math.round(mt * Wt));
                }(yt, Re, He), yt = function(Qe, Tt, vt) {
                  if (Tt !== t.Z.VIDEO || !A.get().streaming.abr.limitBitrateByPortal || !y[vt] || !y[vt][Tt]) return Qe;
                  Y || Bt();
                  var mt = y[vt][Tt].getStreamInfo(), Wt = H.getAdaptationForType(mt.index, Tt, mt).Representation_asArray, zt = Qe;
                  if (V > 0 && M > 0) {
                    for (; zt > 0 && Wt[zt] && V < Wt[zt].width && V - Wt[zt - 1].width < Wt[zt].width - V; ) zt -= 1;
                    for (; zt < Wt.length - 1 && Wt[zt].width === Wt[zt + 1].width; ) zt += 1;
                  }
                  return zt;
                }(yt, Re, He), A.get().streaming.cmsd.enabled && A.get().streaming.cmsd.abr.applyMb && (yt = function(Qe, Tt, vt) {
                  if (Tt !== "video") return Qe;
                  var mt = he.getMaxBitrate(Tt);
                  if (mt < 0) return Qe;
                  var Wt = ct(vt, "audio", ke("audio", vt));
                  mt -= Wt ? Wt.bitrate / 1e3 : 0;
                  var zt = rt(y[vt][Tt].getMediaInfo(), mt, vt);
                  return r.debug("Stream ID: " + vt + " [" + Tt + "] Apply max bit rate from CMSD: " + mt), Math.min(Qe, zt);
                }(yt, Re, He)), yt;
              } catch {
                return;
              }
            }
            function De(Re, He) {
              try {
                return function(yt, Qe) {
                  try {
                    var Tt = pe.getAbrBitrateParameter("minBitrate", yt);
                    if (Tt > -1) {
                      var vt = y[Qe][yt].getMediaInfo(), mt = at(vt), Wt = rt(vt, Tt, Qe);
                      return mt[Wt] && Wt < mt.length - 1 && mt[Wt].bitrate < 1e3 * Tt && Wt++, Wt;
                    }
                    return;
                  } catch {
                    return;
                  }
                }(Re, He);
              } catch {
                return;
              }
            }
            function ke(Re) {
              var He = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              try {
                return He || (He = _.getActiveStreamInfo().id), Re && y[He] && y[He][Re] && He ? (I[He] = I[He] || {}, I[He].hasOwnProperty(Re) || (I[He][Re] = 0), I[He][Re]) : 0;
              } catch {
                return 0;
              }
            }
            function Le(Re, He, yt) {
              var Qe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
              if (He && He.id && Re) {
                var Tt = He.id, vt = ke(Re, Tt);
                (0, $.SE)(yt);
                var mt = Fe(Re, Tt);
                yt !== vt && yt >= 0 && yt <= mt && ut(Re, vt, yt, mt, Qe, Tt);
              }
            }
            function ut(Re, He, yt, Qe, Tt, vt) {
              if (Re && y[vt] && y[vt][Re]) {
                var mt = y[vt][Re].getStreamInfo(), Wt = mt && mt.manifestInfo && mt.manifestInfo.isDynamic, zt = L.getCurrentBufferLevel(Re);
                r.info("Stream ID: " + vt + " [" + Re + "] switch from " + He + " to " + yt + "/" + Qe + " (buffer: " + zt + ") " + (Tt ? JSON.stringify(Tt) : ".")), I[vt] = I[vt] || {}, I[vt][Re] = yt;
                var hn = ct(vt, Re, yt);
                de.trigger(o.Z.QUALITY_CHANGE_REQUESTED, { oldQuality: He, newQuality: yt, reason: Tt, streamInfo: mt, bitrateInfo: hn, maxIdx: Qe, mediaType: Re }, { streamId: mt.id, mediaType: Re });
                var yn = me.getAverageThroughput(Re, Wt);
                isNaN(yn) || Ee.setSavedBitrateSettings(Re, yn);
              }
            }
            function ct(Re, He, yt) {
              if (He && y && y[Re] && y[Re][He]) {
                var Qe = at(y[Re][He].getMediaInfo());
                return Qe[yt] ? Qe[yt] : null;
              }
              return null;
            }
            function rt(Re, He, yt) {
              var Qe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, Tt = Re && Re.type ? y[yt][Re.type].getRepresentationInfo() : null;
              if (A.get().streaming.abr.useDeadTimeLatency && Qe && Tt && Tt.fragmentDuration) {
                Qe /= 1e3;
                var vt = Tt.fragmentDuration;
                if (Qe > vt) return 0;
                var mt = Qe / vt;
                He *= 1 - mt;
              }
              for (var Wt = at(Re), zt = Wt.length - 1; zt >= 0; zt--) {
                var hn = Wt[zt];
                if (1e3 * He >= hn.bitrate) return zt;
              }
              return 0;
            }
            function at(Re) {
              var He = [];
              if (!Re || !Re.bitrateList) return He;
              for (var yt, Qe = Re.bitrateList, Tt = Re.type, vt = 0, mt = Qe.length; vt < mt; vt++) (yt = new qi()).mediaType = Tt, yt.qualityIndex = vt, yt.bitrate = Qe[vt].bandwidth, yt.width = Qe[vt].width, yt.height = Qe[vt].height, yt.scanType = Qe[vt].scanType, He.push(yt);
              return He;
            }
            function Bt() {
              if (G) {
                var Re = A.get().streaming.abr.usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty("devicePixelRatio") ? window.devicePixelRatio : 1;
                V = G.getClientWidth() * Re, M = G.getClientHeight() * Re;
              }
            }
            return i = { initialize: function() {
              z = Bu(oe).create(), me = Uu(oe).create({ settings: A }), (u = (0, ku.Z)(oe).create({ dashMetrics: L, customParametersModel: ae, mediaPlayerModel: pe, settings: A })).initialize(), de.on(n.Z.QUALITY_CHANGE_RENDERED, re, i), de.on(n.Z.METRIC_ADDED, Te, i), de.on(o.Z.LOADING_PROGRESS, U, i);
            }, isPlayingAtTopQuality: function(Re) {
              var He = Re ? Re.id : null, yt = ke(t.Z.AUDIO, He), Qe = ke(t.Z.VIDEO, He);
              return yt === Fe(t.Z.AUDIO, He) && Qe === Fe(t.Z.VIDEO, He);
            }, updateTopQualityIndex: function(Re) {
              var He = Re.type, yt = Re.streamInfo.id, Qe = Re.representationCount - 1;
              return w[yt] = w[yt] || {}, w[yt][He] = Qe, Qe;
            }, clearDataForStream: function(Re) {
              z && z.clearForStream(Re), y[Re] && delete y[Re], ue[Re] && delete ue[Re], N[Re] && delete N[Re];
            }, getThroughputHistory: function() {
              return me;
            }, getBitrateList: at, getQualityForBitrate: rt, getTopBitrateInfoFor: function(Re) {
              var He = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (He || (He = _.getActiveStreamInfo().id), Re && y && y[He] && y[He][Re]) {
                var yt = Fe(Re, He), Qe = at(y[He][Re].getMediaInfo());
                return Qe[yt] ? Qe[yt] : null;
              }
              return null;
            }, getMinAllowedIndexFor: De, getMaxAllowedIndexFor: Fe, getInitialBitrateFor: function(Re, He) {
              if (function() {
                if (!Ee || !Ee.hasOwnProperty("getSavedBitrateSettings")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              }(), Re === t.Z.TEXT) return NaN;
              var yt = Ee.getSavedBitrateSettings(Re), Qe = pe.getAbrBitrateParameter("initialBitrate", Re), Tt = A.get().streaming.abr.initialRepresentationRatio[Re];
              if (Qe === -1) if (Tt > -1) {
                var vt = y[He][Re].getStreamInfo(), mt = H.getAdaptationForType(vt.index, Re, vt).Representation_asArray;
                Qe = Array.isArray(mt) ? mt[Math.max(Math.round(mt.length * Tt) - 1, 0)].bandwidth / 1e3 : 0;
              } else Qe = isNaN(yt) ? Re === t.Z.VIDEO ? 1e3 : 100 : yt;
              return Qe;
            }, getQualityFor: ke, getAbandonmentStateFor: function(Re, He) {
              return N[Re] && N[Re][He] ? N[Re][He].state : null;
            }, setPlaybackQuality: Le, checkPlaybackQuality: function(Re, He) {
              try {
                if (!(Re && y && y[He] && y[He][Re])) return !1;
                if (z) {
                  var yt = G.getPlaybackQuality();
                  yt && z.push(He, j, yt);
                }
                if (!A.get().streaming.abr.autoSwitchBitrate[Re]) return !1;
                var Qe = ke(Re, He), Tt = ms(oe).create({ abrController: i, switchHistory: ue[He][Re], droppedFramesHistory: z, streamProcessor: y[He][Re], currentValue: Qe, useBufferOccupancyABR: g[Re], useL2AABR: x[Re], useLoLPABR: O[Re], videoModel: G }), vt = De(Re, He), mt = Fe(Re, He), Wt = u.getMaxQuality(Tt), zt = Wt.quality;
                return vt !== void 0 && (zt > aa.Z.NO_CHANGE ? zt : Qe) < vt && (zt = vt), zt > mt && (zt = mt), ue[He][Re].push({ oldValue: Qe, newValue: zt }), zt > aa.Z.NO_CHANGE && zt !== Qe && (N[He][Re].state === h.Z.ALLOW_LOAD || zt < Qe) && (ut(Re, Qe, zt, mt, Wt.reason, He), !0);
              } catch {
                return !1;
              }
            }, setElementSize: Bt, setWindowResizeEventCalled: function(Re) {
              Y = Re;
            }, registerStreamType: function(Re, He) {
              var yt = He.getStreamInfo().id;
              y[yt] || (y[yt] = {}), ue[yt] || (ue[yt] = {}), N[yt] || (N[yt] = {}), ue[yt][Re] = Zu(oe).create(), y[yt][Re] = He, N[yt][Re] = {}, N[yt][Re].state = h.Z.ALLOW_LOAD, function(Qe) {
                var Tt = A.get().streaming.abr.ABRStrategy;
                Tt === t.Z.ABR_STRATEGY_L2A ? (g[Qe] = !1, O[Qe] = !1, x[Qe] = !0) : Tt === t.Z.ABR_STRATEGY_LoLP ? (g[Qe] = !1, O[Qe] = !0, x[Qe] = !1) : Tt === t.Z.ABR_STRATEGY_BOLA ? (g[Qe] = !0, O[Qe] = !1, x[Qe] = !1) : Tt === t.Z.ABR_STRATEGY_THROUGHPUT ? (g[Qe] = !1, O[Qe] = !1, x[Qe] = !1) : Tt === t.Z.ABR_STRATEGY_DYNAMIC && (g[Qe] = !(!g || !g[Qe]) && g[Qe], O[Qe] = !1, x[Qe] = !1);
              }(Re), Re === t.Z.VIDEO && Bt();
            }, unRegisterStreamType: function(Re, He) {
              try {
                y[Re] && y[Re][He] && delete y[Re][He], ue[Re] && ue[Re][He] && delete ue[Re][He], N[Re] && N[Re][He] && delete N[Re][He];
              } catch {
              }
            }, setConfig: function(Re) {
              Re && (Re.streamController && (_ = Re.streamController), Re.domStorage && (Ee = Re.domStorage), Re.mediaPlayerModel && (pe = Re.mediaPlayerModel), Re.customParametersModel && (ae = Re.customParametersModel), Re.cmsdModel && (he = Re.cmsdModel), Re.dashMetrics && (L = Re.dashMetrics), Re.adapter && (H = Re.adapter), Re.videoModel && (G = Re.videoModel), Re.settings && (A = Re.settings));
            }, reset: function() {
              ne(), de.off(o.Z.LOADING_PROGRESS, U, i), de.off(n.Z.QUALITY_CHANGE_RENDERED, re, i), de.off(n.Z.METRIC_ADDED, Te, i), u && u.reset();
            } }, r = X.getLogger(i), ne(), i;
          }
          oo.__dashjs_factory_name = "AbrController";
          var so = v.Z.getSingletonFactory(oo);
          so.QUALITY_DEFAULT = 0, v.Z.updateSingletonFactory(oo.__dashjs_factory_name, so);
          var Gu = so, Hu = /* @__PURE__ */ new Map([[t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, "loadedmetadata"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA, "loadeddata"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA, "canplay"], [t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA, "canplaythrough"]]);
          function Es() {
            var i, r, u, _, w, I, y, N, Z = this.context, Y = (0, p.Z)(Z).getInstance(), V = [];
            function M() {
              u && (u.playbackRate = 1, u.removeEventListener("canplay", M));
            }
            function H() {
              return V.length > 0;
            }
            function G() {
              if (u && H() && u.playbackRate === 0) {
                var z = document.createEvent("Event");
                z.initEvent("waiting", !0, !1), u.dispatchEvent(z);
              }
            }
            function pe(z, me) {
              u && u.addEventListener(z, me);
            }
            function ae(z, me) {
              u && u.removeEventListener(z, me);
            }
            function he() {
              return u ? u.readyState : NaN;
            }
            function Ee() {
              return u ? u.buffered : null;
            }
            function j(z, me, g, x, O) {
              if (u) {
                for (var L = 0; L < u.textTracks.length; L++) if (u.textTracks[L].kind === z && (!me || u.textTracks[L].label == me) && u.textTracks[L].language === g && u.textTracks[L].isTTML === x && u.textTracks[L].isEmbedded === O) return u.textTracks[L];
              }
              return null;
            }
            function ue(z, me) {
              return z === t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING || he() >= z ? (me(), null) : function(g, x) {
                var O = function L() {
                  ae(g, L), x(g);
                };
                return pe(g, O), { func: O, event: g };
              }(Hu.get(z), me);
            }
            return i = { addEventListener: pe, addTextTrack: function(z, me, g, x, O) {
              if (!u) return null;
              var L = j(z, me, g, x, O);
              return L || ((L = u.addTextTrack(z, me, g)).isEmbedded = O, L.isTTML = x), L;
            }, appendChild: function(z) {
              u && (u.appendChild(z), z.isTTML !== void 0 && (u.textTracks[u.textTracks.length - 1].isTTML = z.isTTML, u.textTracks[u.textTracks.length - 1].isEmbedded = z.isEmbedded));
            }, getBufferRange: Ee, getClientHeight: function() {
              return u ? u.clientHeight : NaN;
            }, getClientWidth: function() {
              return u ? u.clientWidth : NaN;
            }, getElement: function() {
              return u;
            }, getEnded: function() {
              return u ? u.ended : null;
            }, getPlaybackQuality: function() {
              if (!u) return null;
              var z = "webkitDroppedFrameCount" in u && "webkitDecodedFrameCount" in u, me = null;
              return "getVideoPlaybackQuality" in u ? me = u.getVideoPlaybackQuality() : z && (me = { droppedVideoFrames: u.webkitDroppedFrameCount, totalVideoFrames: u.webkitDroppedFrameCount + u.webkitDecodedFrameCount, creationTime: /* @__PURE__ */ new Date() }), me;
            }, getPlaybackRate: function() {
              return u ? u.playbackRate : null;
            }, getPlayedRanges: function() {
              return u ? u.played : null;
            }, getReadyState: he, getSource: function() {
              return u ? u.src : null;
            }, getTTMLRenderingDiv: function() {
              return I;
            }, getTextTrack: j, getTextTracks: function() {
              return u ? u.textTracks : [];
            }, getTime: function() {
              return u ? isNaN(_) ? u.currentTime : _ : null;
            }, getVideoHeight: function() {
              return u ? u.videoHeight : NaN;
            }, getVideoRelativeOffsetLeft: function() {
              if (u) {
                var z = u.parentNode.host || u.parentNode;
                return z ? u.getBoundingClientRect().left - z.getBoundingClientRect().left : NaN;
              }
              return NaN;
            }, getVideoRelativeOffsetTop: function() {
              if (u) {
                var z = u.parentNode.host || u.parentNode;
                return z ? u.getBoundingClientRect().top - z.getBoundingClientRect().top : NaN;
              }
              return NaN;
            }, getVideoWidth: function() {
              return u ? u.videoWidth : NaN;
            }, getVttRenderingDiv: function() {
              return y;
            }, initialize: function() {
              Y.on(o.Z.PLAYBACK_PLAYING, G, this);
            }, isPaused: function() {
              return u ? u.paused : null;
            }, isSeeking: function() {
              return u ? u.seeking || !isNaN(_) : null;
            }, isStalled: H, pause: function() {
              u && (u.pause(), u.autoplay = !1);
            }, play: function() {
              if (u) {
                u.autoplay = !0;
                var z = u.play();
                z && z.catch && typeof Promise < "u" && z.catch(function(me) {
                  me.name === "NotAllowedError" && Y.trigger(o.Z.PLAYBACK_NOT_ALLOWED), r.warn("Caught pending play exception - continuing (".concat(me, ")"));
                });
              }
            }, removeChild: function(z) {
              u && u.removeChild(z);
            }, removeEventListener: ae, reset: function() {
              clearTimeout(N), Y.off(o.Z.PLAYBACK_PLAYING, G, this);
            }, setCurrentTime: function(z, me) {
              u && (w && w.func && w.event && ae(w.event, w.func), _ = z, w = ue(t.Z.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function() {
                if (u) if (u.currentTime !== _) try {
                  _ = me ? function(g) {
                    var x = Ee(), O = g, L = 9999999999;
                    if (x) for (var A = 0; A < x.length; A++) {
                      var oe = x.start(A), X = x.end(A), de = Math.abs(oe - g), ne = Math.abs(X - g);
                      if (g >= oe && g <= X) return g;
                      de < L && (L = de, O = oe), ne < L && (L = ne, O = X);
                    }
                    return O;
                  }(_) : _, isNaN(_) || (u.currentTime = _), _ = NaN;
                } catch (g) {
                  u.readyState === 0 && g.code === g.INVALID_STATE_ERR && (N = setTimeout(function() {
                    u.currentTime = _, _ = NaN;
                  }, 400));
                }
                else _ = NaN;
              }));
            }, setElement: function(z) {
              if (!(z == null || z && /^(VIDEO|AUDIO)$/i.test(z.nodeName))) throw "element is not video or audio DOM type!";
              (u = z) && (u.preload = "auto");
            }, setPlaybackRate: function(z) {
              var me = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              u && (!me && u.readyState <= 2 && z > 0 ? u.addEventListener("canplay", M) : u.playbackRate = z);
            }, setSource: function(z) {
              u && (z ? u.src = z : (u.removeAttribute("src"), u.load()));
            }, setStallState: function(z, me) {
              (function(g, x) {
                x ? function(O) {
                  O !== null && u && !u.seeking && V.indexOf(O) === -1 && V.push(O);
                }(g) : function(O) {
                  var L = V.indexOf(O);
                  O !== null && L !== -1 && V.splice(L, 1);
                }(g);
              })(z, me);
            }, setTTMLRenderingDiv: function(z) {
              (I = z).style.position = "absolute", I.style.display = "flex", I.style.overflow = "hidden", I.style.pointerEvents = "none", I.style.top = 0, I.style.left = 0;
            }, setVttRenderingDiv: function(z) {
              y = z;
            }, waitForReadyState: ue, setDisableRemotePlayback: function(z) {
              u && (u.disableRemotePlayback = z);
            } }, r = (0, m.Z)(Z).getInstance().getLogger(i), _ = NaN, i;
          }
          Es.__dashjs_factory_name = "VideoModel";
          var qu = v.Z.getSingletonFactory(Es), Vu = [{ oldKey: "dashjs_vbitrate", newKey: "dashjs_video_bitrate" }, { oldKey: "dashjs_abitrate", newKey: "dashjs_audio_bitrate" }, { oldKey: "dashjs_vsettings", newKey: "dashjs_video_settings" }, { oldKey: "dashjs_asettings", newKey: "dashjs_audio_settings" }], vs = "dashjs_?_bitrate", Ts = "dashjs_?_settings", Ei = "localStorage", bs = "lastBitrate", Ss = "lastMediaSettings";
          function As(i) {
            i = i || {};
            var r, u, _, w = this.context, I = i.settings;
            function y(V) {
              if (_ !== void 0) return _;
              var M;
              _ = !1;
              try {
                typeof window < "u" && (M = window[V]);
              } catch (H) {
                return u.warn("DOMStorage access denied: " + H.message), _;
              }
              if (!M || V !== Ei) return _;
              try {
                M.setItem("1", "1"), M.removeItem("1"), _ = !0;
              } catch (H) {
                u.warn("DOMStorage is supported, but cannot be used: " + H.message);
              }
              return _;
            }
            function N() {
              var V = 6e5;
              return Math.round((/* @__PURE__ */ new Date()).getTime() / V) * V;
            }
            function Z(V, M) {
              return y(V) && I.get().streaming[M + "CachingInfo"].enabled;
            }
            function Y() {
              if (!I) throw new Error(t.Z.MISSING_CONFIG_ERROR);
            }
            return r = { getSavedBitrateSettings: function(V) {
              if (Y(), !I.get().streaming.lastBitrateCachingInfo.enabled) return NaN;
              var M = NaN;
              if (Z(Ei, bs)) {
                var H = vs.replace(/\?/, V);
                try {
                  var G = JSON.parse(localStorage.getItem(H)) || {}, pe = (/* @__PURE__ */ new Date()).getTime() - parseInt(G.timestamp, 10) >= I.get().streaming.lastBitrateCachingInfo.ttl || !1, ae = parseFloat(G.bitrate);
                  isNaN(ae) || pe ? pe && localStorage.removeItem(H) : (M = ae, u.debug("Last saved bitrate for " + V + " was " + ae));
                } catch {
                  return null;
                }
              }
              return M;
            }, setSavedBitrateSettings: function(V, M) {
              if (Z(Ei, bs) && M) {
                var H = vs.replace(/\?/, V);
                try {
                  localStorage.setItem(H, JSON.stringify({ bitrate: M.toFixed(3), timestamp: N() }));
                } catch (G) {
                  u.error(G.message);
                }
              }
            }, getSavedMediaSettings: function(V) {
              if (Y(), !I.get().streaming.lastMediaSettingsCachingInfo.enabled) return null;
              var M = null;
              if (Z(Ei, Ss)) {
                var H = Ts.replace(/\?/, V);
                try {
                  var G = JSON.parse(localStorage.getItem(H)) || {}, pe = (/* @__PURE__ */ new Date()).getTime() - parseInt(G.timestamp, 10) >= I.get().streaming.lastMediaSettingsCachingInfo.ttl || !1;
                  M = G.settings, pe && (localStorage.removeItem(H), M = null);
                } catch {
                  return null;
                }
              }
              return M;
            }, setSavedMediaSettings: function(V, M) {
              if (Z(Ei, Ss)) {
                var H = Ts.replace(/\?/, V);
                try {
                  localStorage.setItem(H, JSON.stringify({ settings: M, timestamp: N() }));
                } catch (G) {
                  u.error(G.message);
                }
              }
            } }, u = (0, m.Z)(w).getInstance().getLogger(r), y(Ei) && Vu.forEach(function(V) {
              var M = localStorage.getItem(V.oldKey);
              if (M) {
                localStorage.removeItem(V.oldKey);
                try {
                  localStorage.setItem(V.newKey, M);
                } catch (H) {
                  u.error(H.message);
                }
              }
            }), r;
          }
          As.__dashjs_factory_name = "DOMStorage";
          var ju = v.Z.getSingletonFactory(As), Yu = R(2032), Is = R(2011);
          function Cs() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G = this.context;
            function pe(j, ue, z, me) {
              var g = null, x = j ? H.resolve(j.path) : null, O = me || { init: !0, url: x ? x.url : void 0, range: { start: 0, end: 1500 }, searching: !1, bytesLoaded: 0, bytesToLoad: 1500, mediaType: ue };
              r.debug("Start searching for initialization.");
              var L = Ee(O);
              N.load({ request: L, success: function(A) {
                if (O.bytesLoaded = O.range.end, !(g = _.findInitRange(A))) return O.range.end = O.bytesLoaded + O.bytesToLoad, pe(j, ue, z, O);
                j.range = g, z(j);
              }, error: function() {
                z(j);
              } }), r.debug("Perform init search: " + O.url);
            }
            function ae(j, ue, z, me, g, x) {
              if (z && (z.start === void 0 || z.end === void 0)) {
                var O = z ? z.toString().split("-") : null;
                z = O ? { start: parseFloat(O[0]), end: parseFloat(O[1]) } : null;
              }
              g = g || he;
              var L = null, A = null, oe = !!z, X = j ? H.resolve(j.path) : null, de = { init: !1, url: X ? X.url : void 0, range: oe ? z : { start: 0, end: 1500 }, searching: !oe, bytesLoaded: x ? x.bytesLoaded : 0, bytesToLoad: 1500, mediaType: ue }, ne = Ee(de);
              N.load({ request: ne, success: function(U) {
                var re = de.bytesToLoad, Te = U.byteLength;
                if (de.bytesLoaded = de.range.end - de.range.start, L = _.parse(U), (A = L.getBox("sidx")) && A.isComplete) {
                  var Fe, De, ke = A.references;
                  if (ke != null && ke.length > 0 && (Fe = ke[0].reference_type === 1), Fe) {
                    var Le, ut, ct, rt;
                    r.debug("Initiate multiple SIDX load."), de.range.end = de.range.start + A.size;
                    var at = [], Bt = 0, Re = (A.offset || de.range.start) + A.size, He = function(Qe) {
                      Qe ? (at = at.concat(Qe), ++Bt >= ut && (at.sort(function(Tt, vt) {
                        return Tt.startTime - vt.startTime < 0 ? -1 : 0;
                      }), g(at, j, me))) : g(null, j, me);
                    };
                    for (Le = 0, ut = ke.length; Le < ut; Le++) ct = Re, rt = Re + ke[Le].referenced_size - 1, Re += ke[Le].referenced_size, ae(j, ue, { start: ct, end: rt }, me, He, de);
                  } else r.debug("Parsing segments from SIDX. representation " + ue + " - id: " + j.id + " for range : " + de.range.start + " - " + de.range.end), De = function(Qe, Tt) {
                    for (var vt, mt, Wt, zt, hn = Qe.references, yn = hn.length, ze = Qe.timescale, Et = Qe.earliest_presentation_time, lt = Tt.range.start + Qe.offset + Qe.first_offset + Qe.size, wt = [], Pt = 0; Pt < yn; Pt++) Wt = hn[Pt].subsegment_duration, zt = hn[Pt].referenced_size, (vt = new Is.Z()).duration = Wt, vt.startTime = Et, vt.timescale = ze, mt = lt + zt - 1, vt.mediaRange = lt + "-" + mt, wt.push(vt), Et += Wt, lt += zt;
                    return wt;
                  }(A, de), g(De, j, me);
                } else {
                  if (A) de.range.start = A.offset || de.range.start, de.range.end = de.range.start + (A.size || re);
                  else {
                    if (Te < de.bytesLoaded) return void g(null, j, me);
                    var yt = L.getLastBox();
                    yt && yt.size ? (de.range.start = yt.offset + yt.size, de.range.end = de.range.start + re) : de.range.end += re;
                  }
                  ae(j, ue, de.range, me, null, de);
                }
              }, error: function() {
                g(null, j, me);
              } }), r.debug("Perform SIDX load for type ".concat(ue, " : ").concat(de.url, " with range ").concat(de.range.start, " - ").concat(de.range.end));
            }
            function he(j, ue, z) {
              z({ segments: j, representation: ue, error: j ? void 0 : new se.Z(Z.SEGMENT_BASE_LOADER_ERROR_CODE, Z.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
            }
            function Ee(j) {
              if (j.url) {
                var ue = new S.Z();
                return ue.setInfo(j), ue;
              }
            }
            return i = { setConfig: function(j) {
              j.baseURLController && (H = j.baseURLController), j.dashMetrics && (I = j.dashMetrics), j.mediaPlayerModel && (y = j.mediaPlayerModel), j.errHandler && (u = j.errHandler), j.boxParser && (_ = j.boxParser), j.debug && (r = j.debug.getLogger(i)), j.requestModifier && (w = j.requestModifier), j.errors && (Z = j.errors), j.urlUtils && (M = j.urlUtils), j.constants && (Y = j.constants), j.dashConstants && (V = j.dashConstants);
            }, initialize: function() {
              N = hr(G).create({ errHandler: u, dashMetrics: I, mediaPlayerModel: y, requestModifier: w, boxParser: _, errors: Z, urlUtils: M, constants: Y, dashConstants: V });
            }, loadInitialization: function(j, ue) {
              return new Promise(function(z) {
                pe(j, ue, z);
              });
            }, loadSegments: function(j, ue, z) {
              return new Promise(function(me) {
                ae(j, ue, z, me);
              });
            }, reset: function() {
              N && (N.abort(), N = null);
            } };
          }
          Cs.__dashjs_factory_name = "SegmentBaseLoader";
          var Ku = v.Z.getSingletonFactory(Cs);
          function ws(i) {
            var r;
            i = i || {};
            var u = new DataView(i.data), _ = 0;
            function w(y, N) {
              var Z = !0, Y = 0;
              if (N === void 0 && (N = !1), y.tag > 16777215 ? (u.getUint32(_) !== y.tag && (Z = !1), Y = 4) : y.tag > 65535 ? (256 * u.getUint16(_) + u.getUint8(_ + 2) !== y.tag && (Z = !1), Y = 3) : y.tag > 255 ? (u.getUint16(_) !== y.tag && (Z = !1), Y = 2) : (u.getUint8(_) !== y.tag && (Z = !1), Y = 1), !Z && y.required && !N) throw new Error("required tag not found");
              return Z && (_ += Y), Z;
            }
            function I(y) {
              var N = 1, Z = 128, Y = -1, V = 0, M = u.getUint8(_), H = 0;
              for (H = 0; H < 8; H += 1) {
                if ((M & Z) === Z) {
                  V = y === void 0 ? M & ~Z : M, Y = H;
                  break;
                }
                Z >>= 1;
              }
              for (H = 0; H < Y; H += 1, N += 1) V = V << 8 | 255 & u.getUint8(_ + N);
              return _ += N, V;
            }
            return r = { getPos: function() {
              return _;
            }, setPos: function(y) {
              _ = y;
            }, consumeTag: w, consumeTagAndSize: function(y, N) {
              var Z = w(y, N);
              return Z && I(), Z;
            }, parseTag: function(y) {
              var N;
              return w(y), N = I(), r[y.parse](N);
            }, skipOverElement: function(y, N) {
              var Z, Y = w(y, N);
              return Y && (Z = I(), _ += Z), Y;
            }, getMatroskaCodedNum: I, getMatroskaFloat: function(y) {
              var N;
              switch (y) {
                case 4:
                  N = u.getFloat32(_), _ += 4;
                  break;
                case 8:
                  N = u.getFloat64(_), _ += 8;
              }
              return N;
            }, getMatroskaUint: function(y) {
              if (y > 4) return function(Y) {
                for (var V = Math.floor(Number.MAX_SAFE_INTEGER / 256), M = 0, H = 0; H < Y; H += 1) {
                  if (M > V) throw new Error("Value exceeds safe integer limit");
                  M *= 256;
                  var G = u.getUint8(_ + H);
                  if (M > Number.MAX_SAFE_INTEGER - G) throw new Error("Value exceeds safe integer limit");
                  M += G;
                }
                return _ += Y, M;
              }(y);
              for (var N = 0, Z = 0; Z < y; Z += 1) N <<= 8, N |= 255 & u.getUint8(_ + Z);
              return _ += y, N >>> 0;
            }, moreData: function() {
              return _ < u.byteLength;
            } };
          }
          ws.__dashjs_factory_name = "EBMLParser";
          var Rs = v.Z.getClassFactory(ws);
          function Ns() {
            var i, r, u, _, w, I, y, N, Z, Y, V = this.context;
            function M(H) {
              var G = new S.Z();
              return G.setInfo(H), G;
            }
            return i = { setConfig: function(H) {
              if (!(H.baseURLController && H.dashMetrics && H.mediaPlayerModel && H.errHandler)) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              Y = H.baseURLController, I = H.dashMetrics, y = H.mediaPlayerModel, _ = H.errHandler, Z = H.errors, r = H.debug.getLogger(i), w = H.requestModifier;
            }, initialize: function() {
              N = hr(V).create({ errHandler: _, dashMetrics: I, mediaPlayerModel: y, requestModifier: w, errors: Z });
            }, loadInitialization: function(H, G) {
              return new Promise(function(pe) {
                var ae = null, he = H ? Y.resolve(H.path) : null, Ee = H ? H.range.split("-") : null, j = { range: { start: Ee ? parseFloat(Ee[0]) : null, end: Ee ? parseFloat(Ee[1]) : null }, request: ae, url: he ? he.url : void 0, init: !0, mediaType: G };
                r.info("Start loading initialization."), ae = M(j), N.load({ request: ae, success: function() {
                  pe(H);
                }, error: function() {
                  pe(H);
                } }), r.debug("Perform init load: " + j.url);
              });
            }, loadSegments: function(H, G, pe) {
              return new Promise(function(ae) {
                var he = null, Ee = H ? Y.resolve(H.path) : null, j = Ee ? Ee.url : void 0;
                he = M({ bytesLoaded: 0, bytesToLoad: 8192, range: { start: 0, end: 8192 }, request: he, url: j, init: !1, mediaType: G }), r.debug("Parsing ebml header"), N.load({ request: he, success: function(ue) {
                  (function(z, me, g, x) {
                    if (z && z.byteLength !== 0) {
                      var O, L, A, oe, X = Rs(V).create({ data: z }), de = g ? g.split("-") : null, ne = null, U = { url: me, range: { start: de ? parseFloat(de[0]) : null, end: de ? parseFloat(de[1]) : null }, request: ne };
                      for (r.debug("Parse EBML header: " + U.url), X.skipOverElement(u.EBML), X.consumeTag(u.Segment), A = X.getMatroskaCodedNum(), A += X.getPos(), oe = X.getPos(); X.moreData() && !X.consumeTagAndSize(u.Segment.Info, !0); ) if (!(X.skipOverElement(u.Segment.SeekHead, !0) || X.skipOverElement(u.Segment.Tracks, !0) || X.skipOverElement(u.Segment.Cues, !0) || X.skipOverElement(u.Void, !0))) throw new Error("no valid top level element found");
                      for (; O === void 0; ) {
                        var re = X.getMatroskaCodedNum(!0), Te = X.getMatroskaCodedNum();
                        re === u.Segment.Info.Duration.tag ? O = X[u.Segment.Info.Duration.parse](Te) : X.setPos(X.getPos() + Te);
                      }
                      ne = M(U), N.load({ request: ne, success: function(Fe) {
                        L = function(De, ke, Le, ut) {
                          var ct, rt, at, Bt, Re, He, yt, Qe;
                          for (at = [], Re = 0, He = (rt = function(Tt) {
                            var vt, mt, Wt = [], zt = Rs(V).create({ data: Tt });
                            for (zt.consumeTagAndSize(u.Segment.Cues); zt.moreData() && zt.consumeTagAndSize(u.Segment.Cues.CuePoint, !0); ) {
                              for ((vt = {}).CueTime = zt.parseTag(u.Segment.Cues.CuePoint.CueTime), vt.CueTracks = []; zt.moreData() && zt.consumeTag(u.Segment.Cues.CuePoint.CueTrackPositions, !0); ) {
                                var hn = zt.getMatroskaCodedNum(), yn = zt.getPos();
                                if ((mt = {}).Track = zt.parseTag(u.Segment.Cues.CuePoint.CueTrackPositions.CueTrack), mt.Track === 0) throw new Error("Cue track cannot be 0");
                                mt.ClusterPosition = zt.parseTag(u.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition), vt.CueTracks.push(mt), zt.setPos(yn + hn);
                              }
                              if (vt.CueTracks.length === 0) throw new Error("Mandatory cuetrack not found");
                              Wt.push(vt);
                            }
                            if (Wt.length === 0) throw new Error("mandatory cuepoint not found");
                            return Wt;
                          }(De)).length; Re < He; Re += 1) Bt = new Is.Z(), ct = Re < rt.length - 1 ? rt[Re + 1].CueTime - rt[Re].CueTime : ut - rt[Re].CueTime, Bt.duration = ct, Bt.startTime = rt[Re].CueTime, Bt.timescale = 1e3, yt = rt[Re].CueTracks[0].ClusterPosition + ke, Qe = Re < rt.length - 1 ? rt[Re + 1].CueTracks[0].ClusterPosition + ke - 1 : Le - 1, Bt.mediaRange = yt + "-" + Qe, at.push(Bt);
                          return r.debug("Parsed cues: " + at.length + " cues."), at;
                        }(Fe, oe, A, O), x(L);
                      }, error: function() {
                        r.error("Download Error: Cues " + U.url), x(null);
                      } }), r.debug("Perform cues load: " + U.url + " bytes=" + U.range.start + "-" + U.range.end);
                    } else x(null);
                  })(ue, j, pe, function(z) {
                    ae({ segments: z, representation: H, error: z ? void 0 : new se.Z(Z.SEGMENT_BASE_LOADER_ERROR_CODE, Z.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
                  });
                }, error: function() {
                  ae({ representation: H, error: new se.Z(Z.SEGMENT_BASE_LOADER_ERROR_CODE, Z.SEGMENT_BASE_LOADER_ERROR_MESSAGE) });
                } });
              });
            }, reset: function() {
              N && (N.abort(), N = null);
            } }, u = { EBML: { tag: 440786851, required: !0 }, Segment: { tag: 408125543, required: !0, SeekHead: { tag: 290298740, required: !0 }, Info: { tag: 357149030, required: !0, TimecodeScale: { tag: 2807729, required: !0, parse: "getMatroskaUint" }, Duration: { tag: 17545, required: !0, parse: "getMatroskaFloat" } }, Tracks: { tag: 374648427, required: !0 }, Cues: { tag: 475249515, required: !0, CuePoint: { tag: 187, required: !0, CueTime: { tag: 179, required: !0, parse: "getMatroskaUint" }, CueTrackPositions: { tag: 183, required: !0, CueTrack: { tag: 247, required: !0, parse: "getMatroskaUint" }, CueClusterPosition: { tag: 241, required: !0, parse: "getMatroskaUint" } } } } }, Void: { tag: 236, required: !0 } }, i;
          }
          Ns.__dashjs_factory_name = "WebmSegmentBaseLoader";
          var zu = v.Z.getSingletonFactory(Ns);
          function Ds(i) {
            i = i || {};
            var r, u, _, w = this.context, I = i.eventBus, y = i.events, N = i.dashMetrics, Z = i.mediaPlayerModel, Y = i.errHandler, V = i.baseURLController, M = i.debug, H = i.boxParser, G = i.requestModifier, pe = i.errors;
            function ae(he) {
              return (he ? he.split("/")[1] : "").toLowerCase() === "webm";
            }
            return r = { initialize: function() {
              u.initialize(), _.initialize();
            }, getSegmentBaseInitSegment: function(he) {
              return ae(he.representation.mimeType) ? _.loadInitialization(he.representation, he.mediaType) : u.loadInitialization(he.representation, he.mediaType);
            }, getSegmentList: function(he) {
              return ae(he.mimeType) ? _.loadSegments(he.representation, he.mediaType, he.representation ? he.representation.indexRange : null) : u.loadSegments(he.representation, he.mediaType, he.representation ? he.representation.indexRange : null);
            }, reset: function() {
              u.reset(), _.reset();
            } }, u = Ku(w).getInstance(), _ = zu(w).getInstance(), u.setConfig({ baseURLController: V, dashMetrics: N, mediaPlayerModel: Z, errHandler: Y, eventBus: I, events: y, errors: pe, debug: M, boxParser: H, requestModifier: G }), _.setConfig({ baseURLController: V, dashMetrics: N, mediaPlayerModel: Z, errHandler: Y, eventBus: I, events: y, errors: pe, debug: M, requestModifier: G }), r;
          }
          Ds.__dashjs_factory_name = "SegmentBaseController";
          var Wu = v.Z.getSingletonFactory(Ds), Ms = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.quality = null, this.fragmentDuration = null, this.mediaInfo = null, this.MSETimeOffset = null;
          }, lo = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = null, this.type = null, this.streamInfo = null, this.representationCount = 0, this.labels = null, this.lang = null, this.viewpoint = null, this.viewpointsWithSchemeIdUri = null, this.accessibility = null, this.accessibilitiesWithSchemeIdUri = null, this.audioChannelConfiguration = null, this.audioChannelConfigurationsWithSchemeIdUri = null, this.roles = null, this.rolesWithSchemeIdUri = null, this.codec = null, this.mimeType = null, this.contentProtection = null, this.isText = !1, this.KID = null, this.bitrateList = null, this.isFragmented = null, this.isEmbedded = null, this.selectionPriority = 1, this.supplementalProperties = {}, this.supplementalPropertiesAsArray = [], this.essentialProperties = {}, this.essentialPropertiesAsArray = [], this.segmentAlignment = !1, this.subSegmentAlignment = !1;
          }, Os = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.id = null, this.index = null, this.start = NaN, this.duration = NaN, this.manifestInfo = null, this.isLast = !0;
          }, Qu = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.dvrWindowSize = NaN, this.loadedTime = null, this.availableFrom = null, this.minBufferTime = NaN, this.duration = NaN, this.isDynamic = !1, this.maxFragmentDuration = null, this.serviceDescriptions = [], this.protocol = null;
          };
          function Xu(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var $u = function() {
            function i(_) {
              var w = this;
              (function(I, y) {
                if (!(I instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.valid = _[0] == "/", this.path = _.split("/").filter(function(I) {
                return I.length !== 0;
              }).map(function(I) {
                var y = { name: I }, N = I.indexOf("[");
                if (N != -1) {
                  y.name = I.substring(0, N);
                  var Z = I.substring(N + 1, I.length - 1);
                  w.valid = w.valid && Z.indexOf("[") == -1;
                  var Y = Z.indexOf("=");
                  Y != -1 ? (y.attribute = { name: Z.substring(1, Y), value: Z.substring(Y + 1) }, ["'", '"'].indexOf(y.attribute.value[0]) != -1 && (y.attribute.value = y.attribute.value.substring(1, y.attribute.value.length - 1))) : y.position = parseInt(Z, 10) - 1;
                }
                return y;
              });
            }
            var r, u;
            return r = i, (u = [{ key: "isValid", value: function() {
              return this.valid;
            } }, { key: "findsElement", value: function() {
              return !this.findsAttribute();
            } }, { key: "findsAttribute", value: function() {
              return this.path[this.path.length - 1].name.startsWith("@");
            } }, { key: "findsTextReplace", value: function() {
              return this.path[this.path.length - 1].name === "text()";
            } }, { key: "getMpdTarget", value: function(_, w) {
              for (var I = null, y = _, N = 1, Z = "MPD"; N < this.path.length && y !== null; ) {
                I = y;
                var Y = this.path[N];
                if (Z = Y.name, N !== this.path.length - 1 || !Z.startsWith("@") && Z !== "text()") {
                  var V = I[Z + "_asArray"] || [];
                  V.length === 0 && I[Z] && V.push(I[Z]), Y.position ? y = V[Y.position] || null : Y.attribute ? function() {
                    var M = Y.attribute;
                    y = V.filter(function(H) {
                      return H[M.name] == M.value;
                    })[0] || null;
                  }() : y = V[0] || null;
                }
                N++;
              }
              return y === null ? null : Z.startsWith("@") ? { name: Z.substring(1), leaf: y, target: y } : Z === "text()" ? { name: "__text", leaf: y, target: y } : { name: Z, leaf: y, target: w ? I : y };
            } }]) && Xu(r.prototype, u), i;
          }();
          function Ju(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var ec = function() {
            function i(_, w, I) {
              (function(y, N) {
                if (!(y instanceof N)) throw new TypeError("Cannot call a class as a function");
              })(this, i), this.action = _, this.xpath = w, this.value = I, this.position = null;
            }
            var r, u;
            return r = i, (u = [{ key: "getMpdTarget", value: function(_) {
              var w = this.action === "remove" || this.action === "replace" || this.position === "before" || this.position === "after";
              return this.xpath.getMpdTarget(_, w);
            } }]) && Ju(r.prototype, u), i;
          }();
          function Ls() {
            var i, r, u = this.context;
            return i = { getIsPatch: function(_) {
              return _ && _.hasOwnProperty(e.Z.ORIGINAL_MPD_ID) || !1;
            }, getPublishTime: function(_) {
              return _ && _.hasOwnProperty(e.Z.PUBLISH_TIME) ? new Date(_[e.Z.PUBLISH_TIME]) : null;
            }, getOriginalPublishTime: function(_) {
              return _ && _.hasOwnProperty(e.Z.ORIGINAL_PUBLISH_TIME) ? new Date(_[e.Z.ORIGINAL_PUBLISH_TIME]) : null;
            }, getMpdId: function(_) {
              return _ && _[e.Z.ORIGINAL_MPD_ID] || null;
            }, getPatchOperations: function(_) {
              return _ ? (_.__children || []).map(function(w) {
                var I = Object.keys(w)[0];
                if (I !== "add" && I !== "remove" && I !== "replace") return r.warn("Ignoring node of invalid action: ".concat(I)), null;
                var y = w[I], N = y.sel;
                if (I === "add" && y.type) {
                  if (!y.type.startsWith("@")) return r.warn("Ignoring add action for prefixed namespace declaration: ".concat(y.type, "=").concat(y.__text)), null;
                  N = "".concat(N, "/").concat(y.type);
                }
                var Z = new $u(N);
                if (!Z.isValid()) return r.warn("Ignoring action with invalid selector: ".concat(I, " - ").concat(N)), null;
                var Y = null;
                Z.findsAttribute() || Z.findsTextReplace() ? Y = y.__text || "" : I !== "remove" && (Y = y.__children.reduce(function(M, H) {
                  var G = Object.keys(H)[0];
                  return G !== "#text" && (M[G] = M[G] || [], M[G].push(H[G])), M;
                }, {}));
                var V = new ec(I, Z, Y);
                return I === "add" && (V.position = y.pos), V;
              }).filter(function(w) {
                return !!w;
              }) : [];
            } }, r = (0, m.Z)(u).getInstance().getLogger(i), i;
          }
          Ls.__dashjs_factory_name = "PatchManifestModel";
          var tc = v.Z.getSingletonFactory(Ls);
          function Ps() {
            var i, r, u, _, w, I, y, N = this.context;
            function Z(O, L, A) {
              var oe, X = r.getAdaptationsForType(_[0].mpd.manifest, O, L);
              if (!X || X.length === 0) return null;
              if (X.length > 1 && A) {
                var de = M(A, L);
                if (w[A.id] && w[A.id][L]) {
                  for (var ne = 0, U = X.length; ne < U; ne++) if (Y(w[A.id][L], de[ne])) return X[ne];
                }
                for (var re = 0, Te = X.length; re < Te; re++) if (oe = X[re], r.getRolesForAdaptation(oe).filter(function(Fe) {
                  return Fe.value === e.Z.MAIN;
                })[0]) return X[re];
              }
              return X[0];
            }
            function Y(O, L) {
              if (!O || !L) return !1;
              var A = O.id === L.id, oe = O.codec === L.codec, X = O.viewpoint === L.viewpoint, de = JSON.stringify(O.viewpointsWithSchemeIdUri) === JSON.stringify(L.viewpointsWithSchemeIdUri), ne = O.lang === L.lang, U = O.roles.toString() === L.roles.toString(), re = JSON.stringify(O.rolesWithSchemeIdUri) === JSON.stringify(L.rolesWithSchemeIdUri), Te = O.accessibility.toString() === L.accessibility.toString(), Fe = JSON.stringify(O.accessibilitiesWithSchemeIdUri) === JSON.stringify(L.accessibilitiesWithSchemeIdUri), De = O.audioChannelConfiguration.toString() === L.audioChannelConfiguration.toString(), ke = JSON.stringify(O.audioChannelConfigurationsWithSchemeIdUri) === JSON.stringify(L.audioChannelConfigurationsWithSchemeIdUri);
              return A && oe && X && de && ne && U && re && Te && Fe && De && ke;
            }
            function V(O, L, A, oe, X, de) {
              var ne, U, re, Te, Fe, De, ke = [];
              if (!oe || oe.length === 0) return [];
              var Le = r.getAdaptationsForPeriod(L);
              for (Te = 0, De = oe.length; Te < De; Te++) if (ne = oe[Te], U = j(Le[re = r.getIndexForAdaptation(ne, O, A.index)]), de) {
                var ut = U.accessibility.length;
                for (Fe = 0; Fe < ut; Fe++) if (U) {
                  var ct = U.accessibility[Fe];
                  if (ct.indexOf("cea-608:") === 0) {
                    var rt = ct.substring(8).split(";");
                    if (rt[0].substring(0, 2) === "CC") for (Fe = 0; Fe < rt.length; Fe++) U || (U = j.call(this, Le[re])), ue(U, rt[Fe].substring(0, 3), rt[Fe].substring(4)), ke.push(U), U = null;
                    else for (Fe = 0; Fe < rt.length; Fe++) U || (U = j.call(this, Le[re])), ue(U, "CC" + (Fe + 1), rt[Fe]), ke.push(U), U = null;
                  } else ct.indexOf("cea-608") === 0 && (ue(U, I.CC1, "eng"), ke.push(U), U = null);
                }
              } else X === I.IMAGE ? (U.type = I.IMAGE, ke.push(U), U = null) : U && ke.push(U);
              return ke;
            }
            function M(O, L, A) {
              var oe = _, X = A, de = [];
              if (X) me(), oe = H(X);
              else {
                if (!(_.length > 0)) return de;
                X = _[0].mpd.manifest;
              }
              var ne = Ee(O, oe), U = r.getAdaptationsForType(X, O ? O.index : null, L);
              return de = V(X, ne, O, U, L), L === I.TEXT && (U = r.getAdaptationsForType(X, O ? O.index : null, I.VIDEO), de = de.concat(V(X, ne, O, U, L, !0))), de;
            }
            function H(O) {
              var L = G(O);
              return r.getRegularPeriods(L);
            }
            function G(O) {
              var L = ae(O);
              return r.getMpd(L);
            }
            function pe() {
              _ = [], w = {};
            }
            function ae(O) {
              return O || (_.length > 0 ? _[0].mpd.manifest : null);
            }
            function he(O) {
              try {
                var L = Ee(O.streamInfo, _), A = r.getAdaptationsForPeriod(L);
                return O && O.streamInfo && O.streamInfo.id !== void 0 && A ? A[O.index] : null;
              } catch {
                return null;
              }
            }
            function Ee(O, L) {
              for (var A = L.length, oe = 0; oe < A; oe++) {
                var X = L[oe];
                if (O && O.id === X.id) return X;
              }
              return null;
            }
            function j(O) {
              if (!O) return null;
              var L, A, oe, X, de, ne = new lo(), U = O.period.mpd.manifest.Period_asArray[O.period.index].AdaptationSet_asArray[O.index];
              if (ne.id = O.id, ne.index = O.index, ne.type = O.type, ne.streamInfo = z(O.period), ne.representationCount = r.getRepresentationCount(U), ne.labels = r.getLabelsForAdaptation(U), ne.lang = r.getLanguageForAdaptation(U), ne.segmentAlignment = r.getSegmentAlignment(U), ne.subSegmentAlignment = r.getSubSegmentAlignment(U), L = r.getViewpointForAdaptation(U), ne.viewpoint = L.length ? L[0].value : void 0, ne.viewpointsWithSchemeIdUri = L, de = r.getAccessibilityForAdaptation(U), ne.accessibility = de.map(function(ke) {
                var Le = ke.value, ut = Le;
                return ke.schemeIdUri && ke.schemeIdUri.search("cea-608") >= 0 && y !== void 0 && (ut = Le ? "cea-608:" + Le : "cea-608", ne.embeddedCaptions = !0), ut;
              }), ne.accessibilitiesWithSchemeIdUri = de, A = r.getAudioChannelConfigurationForAdaptation(U), ne.audioChannelConfiguration = A.map(function(ke) {
                return ke.value;
              }), ne.audioChannelConfigurationsWithSchemeIdUri = A, ne.audioChannelConfiguration.length === 0 && Array.isArray(U.Representation_asArray) && U.Representation_asArray.length > 0 && (oe = r.getAudioChannelConfigurationForRepresentation(U.Representation_asArray[0]), ne.audioChannelConfiguration = oe.map(function(ke) {
                return ke.value;
              }), ne.audioChannelConfigurationsWithSchemeIdUri = oe), X = r.getRolesForAdaptation(U), ne.roles = X.map(function(ke) {
                return ke.value;
              }), ne.rolesWithSchemeIdUri = X, ne.codec = r.getCodec(U), ne.mimeType = r.getMimeType(U), ne.contentProtection = r.getContentProtectionData(U), ne.bitrateList = r.getBitrateListForAdaptation(U), ne.selectionPriority = r.getSelectionPriority(U), ne.contentProtection) {
                var re = ne.contentProtection.map(function(ke) {
                  return r.getKID(ke);
                }).filter(function(ke) {
                  return ke !== null;
                });
                if (re.length) {
                  var Te = re[0];
                  ne.contentProtection.forEach(function(ke) {
                    ke.keyId = Te;
                  });
                }
              }
              if (ne.isText = r.getIsText(U), ne.supplementalProperties = r.getSupplementalPropertiesForAdaptation(U), (!ne.supplementalProperties || Object.keys(ne.supplementalProperties).length === 0) && Array.isArray(U.Representation_asArray) && U.Representation_asArray.length > 0) {
                var Fe = U.Representation_asArray.map(function(ke) {
                  return r.getSupplementalPropertiesForRepresentation(ke);
                });
                Fe.every(function(ke) {
                  return JSON.stringify(ke) === JSON.stringify(Fe[0]);
                }) && (ne.supplementalProperties = Fe[0]);
              }
              if (ne.supplementalPropertiesAsArray = r.getSupplementalPropertiesAsArrayForAdaptation(U), (!ne.supplementalPropertiesAsArray || ne.supplementalPropertiesAsArray.length === 0) && Array.isArray(U.Representation_asArray) && U.Representation_asArray.length > 0) {
                var De = U.Representation_asArray.map(function(ke) {
                  return r.getSupplementalPropertiesAsArrayForRepresentation(ke);
                });
                De.every(function(ke) {
                  return JSON.stringify(ke) === JSON.stringify(De[0]);
                }) && (ne.supplementalPropertiesAsArray = De[0]);
              }
              return ne.essentialProperties = r.getEssentialPropertiesForAdaptation(U), ne.essentialPropertiesAsArray = r.getEssentialPropertiesAsArrayForAdaptation(U), ne.isFragmented = r.getIsFragmented(U), ne.isEmbedded = !1, ne;
            }
            function ue(O, L, A) {
              O.id = L, O.index = 100 + parseInt(L.substring(2, 3)), O.type = I.TEXT, O.codec = "cea-608-in-SEI", O.isEmbedded = !0, O.isFragmented = !1;
              var oe = Wi()(A);
              O.lang = oe || A, O.roles = ["caption"], O.rolesWithSchemeIdUri = [{ schemeIdUri: "urn:mpeg:dash:role:2011", value: "caption" }];
            }
            function z(O) {
              var L, A, oe = new Os();
              return oe.id = O.id, oe.index = O.index, oe.start = O.start, oe.duration = O.duration, oe.manifestInfo = (L = O.mpd, (A = new Qu()).dvrWindowSize = L.timeShiftBufferDepth, A.loadedTime = L.manifest.loadedTime, A.availableFrom = L.availabilityStartTime, A.minBufferTime = L.manifest.minBufferTime, A.maxFragmentDuration = L.maxSegmentDuration, A.duration = r.getDuration(L.manifest), A.isDynamic = r.getIsDynamic(L.manifest), A.serviceDescriptions = r.getServiceDescriptions(L.manifest), A.protocol = L.manifest.protocol, A), oe.isLast = O.mpd.manifest.Period_asArray.length === 1 || Math.abs(oe.start + oe.duration - oe.manifestInfo.duration) < 1, oe;
            }
            function me() {
              if (!I) throw new Error("setConfig function has to be called previously");
            }
            function g(O) {
              return _.length > 0 ? _[0].mpd.manifest.Period_asArray[O] : null;
            }
            function x(O, L, A) {
              var oe, X, de, ne, U;
              if (O) {
                for (oe = O.AdaptationSet_asArray, ne = 0; ne < oe.length; ne += 1) for (de = oe[ne].Representation_asArray, U = 0; U < de.length; U += 1) if (L === (X = de[U]).id) return A ? U : X;
              }
              return null;
            }
            return i = { getBandwidthForRepresentation: function(O, L) {
              var A;
              return (A = x(g(L), O)) ? A.bandwidth : null;
            }, getIndexForRepresentation: function(O, L) {
              return function(A, oe) {
                var X = x(A, oe, !0);
                return X !== null ? X : -1;
              }(g(L), O);
            }, getMaxIndexForBufferType: function(O, L) {
              return function(A, oe) {
                var X, de, ne, U;
                if (!A || !oe) return -1;
                for (de = A.AdaptationSet_asArray, U = 0; U < de.length; U += 1) if (ne = (X = de[U]).Representation_asArray, r.getIsTypeOf(X, oe)) return ne.length;
                return -1;
              }(g(L), O);
            }, convertRepresentationToRepresentationInfo: function(O) {
              if (O) {
                var L = new Ms(), A = O.adaptation.period.mpd.manifest.Period_asArray[O.adaptation.period.index].AdaptationSet_asArray[O.adaptation.index], oe = r.getRepresentationFor(O.index, A);
                return L.id = O.id, L.quality = O.index, L.bandwidth = r.getBandwidth(oe), L.fragmentDuration = O.segmentDuration || (O.segments && O.segments.length > 0 ? O.segments[0].duration : NaN), L.MSETimeOffset = O.MSETimeOffset, L.mediaInfo = j(O.adaptation), L;
              }
              return null;
            }, getStreamsInfo: function(O, L) {
              var A = [], oe = _;
              if (O && (me(), oe = H(O)), oe.length > 0) {
                (!L || L > oe.length) && (L = oe.length);
                for (var X = 0; X < L; X++) A.push(z(oe[X]));
              }
              return A;
            }, getMediaInfoForType: function(O, L) {
              if (_.length === 0 || !O) return null;
              var A = Ee(O, _);
              if (!A) return null;
              var oe = r.getAdaptationsForPeriod(A), X = Z(O.index, L, O);
              return X ? j(oe[r.getIndexForAdaptation(X, _[0].mpd.manifest, O.index)]) : null;
            }, getAllMediaInfoForType: M, getAdaptationForType: Z, getRealAdaptation: function(O, L) {
              var A, oe, X = Ee(O, _);
              return A = L ? L.id : null, _.length > 0 && X && (oe = A ? r.getAdaptationForId(A, _[0].mpd.manifest, X.index) : r.getAdaptationForIndex(L ? L.index : null, _[0].mpd.manifest, X.index)), oe;
            }, getProducerReferenceTimes: function(O, L) {
              var A, oe, X = Ee(O, _);
              return A = L ? L.id : null, _.length > 0 && X && (oe = A ? r.getAdaptationForId(A, _[0].mpd.manifest, X.index) : r.getAdaptationForIndex(L ? L.index : null, _[0].mpd.manifest, X.index)), oe ? r.getProducerReferenceTimesForAdaptation(oe) : [];
            }, getRealPeriodByIndex: function(O) {
              return r.getRealPeriodForIndex(O, _[0].mpd.manifest);
            }, getEssentialPropertiesForRepresentation: function(O) {
              try {
                return r.getEssentialPropertiesForRepresentation(O);
              } catch {
                return [];
              }
            }, getVoRepresentations: function(O) {
              var L = he(O);
              return r.getRepresentationsForAdaptation(L);
            }, getEventsFor: function(O, L, A) {
              var oe = [];
              if (_.length > 0) {
                var X = _[0].mpd.manifest;
                if (O instanceof Os) {
                  var de = Ee(O, _);
                  oe = r.getEventsForPeriod(de);
                } else if (O instanceof lo) {
                  var ne = Ee(A, _);
                  oe = r.getEventStreamForAdaptationSet(X, he(O), ne);
                } else if (O instanceof Ms) {
                  var U = Ee(A, _);
                  oe = r.getEventStreamForRepresentation(X, L, U);
                }
              }
              return oe;
            }, getEvent: function(O, L, A, oe) {
              try {
                if (!O || !L || isNaN(A) || !oe) return null;
                var X = O.scheme_id_uri, de = O.value;
                if (!L[X + "/" + de]) return null;
                var ne, U = new fr(), re = O.timescale || 1, Te = oe.adaptation.period.start, Fe = L[X + "/" + de], De = isNaN(oe.presentationTimeOffset) ? isNaN(Fe.presentationTimeOffset) ? 0 : Fe.presentationTimeOffset : oe.presentationTimeOffset, ke = O.presentation_time_delta / re;
                ne = O.version === 0 ? Te + A - De + ke : Te - De + ke;
                var Le = O.event_duration / re, ut = O.id, ct = O.message_data;
                return U.eventStream = Fe, U.eventStream.value = de, U.eventStream.timescale = re, U.duration = Le, U.id = ut, U.calculatedPresentationTime = ne, U.messageData = ct, U.presentationTimeDelta = ke, U;
              } catch {
                return null;
              }
            }, getMpd: G, setConfig: function(O) {
              O && (O.constants && (I = O.constants), O.cea608parser && (y = O.cea608parser), O.errHandler && r.setConfig({ errHandler: O.errHandler }), O.BASE64 && r.setConfig({ BASE64: O.BASE64 }));
            }, updatePeriods: function(O) {
              if (!O) return null;
              me(), _ = H(O);
            }, getIsTextTrack: function(O) {
              return r.getIsText(O);
            }, getUTCTimingSources: function() {
              var O = ae();
              return r.getUTCTimingSources(O);
            }, getSuggestedPresentationDelay: function() {
              var O = _.length > 0 ? _[0].mpd : null;
              return r.getSuggestedPresentationDelay(O);
            }, getAvailabilityStartTime: function(O) {
              var L = G(O);
              return r.getAvailabilityStartTime(L);
            }, getIsTypeOf: function(O, L) {
              return r.getIsTypeOf(O, L);
            }, getIsDynamic: function(O) {
              var L = ae(O);
              return r.getIsDynamic(L);
            }, getDuration: function(O) {
              var L = ae(O);
              return r.getDuration(L);
            }, getRegularPeriods: H, getContentSteering: function(O) {
              return r.getContentSteering(O);
            }, getLocation: function(O) {
              return r.getLocation(O);
            }, getPatchLocation: function(O) {
              var L = r.getPatchLocation(O), A = r.getPublishTime(O);
              return L && L.length !== 0 && A ? L.filter(function(oe) {
                return isNaN(oe.ttl) || A.getTime() + oe.ttl > (/* @__PURE__ */ new Date()).getTime();
              }) : [];
            }, getManifestUpdatePeriod: function(O) {
              var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              return r.getManifestUpdatePeriod(O, L);
            }, getPublishTime: function(O) {
              return r.getPublishTime(O);
            }, getIsDVB: function(O) {
              return r.hasProfile(O, "urn:dvb:dash:profile:dvb-dash:2014");
            }, getIsPatch: function(O) {
              return u.getIsPatch(O);
            }, getBaseURLsFromElement: function(O) {
              return r.getBaseURLsFromElement(O);
            }, getRepresentationSortFunction: function() {
              return r.getRepresentationSortFunction();
            }, getCodec: function(O, L, A) {
              return r.getCodec(O, L, A);
            }, getPeriodById: function(O) {
              if (!O || _.length === 0) return null;
              var L = _.filter(function(A) {
                return A.id === O;
              });
              return L && L.length > 0 ? L[0] : null;
            }, setCurrentMediaInfo: function(O, L, A) {
              w[O] = w[O] || {}, w[O][L] = w[O][L] || {}, w[O][L] = A;
            }, isPatchValid: function(O, L) {
              var A = r.getId(O), oe = u.getMpdId(L), X = r.getPublishTime(O), de = u.getPublishTime(L), ne = u.getOriginalPublishTime(L);
              return !!(A && oe && A == oe && X && ne && X.getTime() == ne.getTime() && de && X.getTime() < de.getTime());
            }, applyPatchToManifest: function(O, L) {
              u.getPatchOperations(L).forEach(function(A) {
                var oe = A.getMpdTarget(O);
                if (oe !== null) {
                  var X = oe.name, de = oe.target, ne = oe.leaf;
                  if (A.xpath.findsAttribute() || X === "__text") switch (A.action) {
                    case "add":
                    case "replace":
                      de[X] = A.value;
                      break;
                    case "remove":
                      delete de[X];
                  }
                  else {
                    var U = (de[X + "_asArray"] || []).indexOf(ne), re = A.position === "prepend" || A.position === "before";
                    if ((A.action === "remove" || A.action === "replace") && (delete de[X], U != -1)) {
                      var Te = de[X + "_asArray"];
                      Te.splice(U, 1), Te.length > 1 ? de[X] = Te : Te.length == 1 ? de[X] = Te[0] : delete de[X + "_asArray"];
                    }
                    A.action !== "add" && A.action !== "replace" || Object.keys(A.value).forEach(function(Fe) {
                      var De = A.value[Fe], ke = de[Fe + "_asArray"] || [];
                      if (ke.length === 0 && de[Fe] && ke.push(de[Fe]), ke.length === 0) ke = De;
                      else {
                        var Le = ke.length;
                        Le = Fe == X && U != -1 ? U + (re ? 0 : 1) + (A.action == "replace" ? -1 : 0) : re ? 0 : ke.length, ke.splice.apply(ke, [Le, 0].concat(De));
                      }
                      de[Fe + "_asArray"] = ke, de[Fe] = ke.length == 1 ? ke[0] : ke;
                    });
                  }
                }
              });
            }, areMediaInfosEqual: Y, reset: pe }, r = un(N).getInstance(), u = tc(N).getInstance(), pe(), i;
          }
          Ps.__dashjs_factory_name = "DashAdapter";
          var nc = v.Z.getSingletonFactory(Ps);
          function rc(i, r) {
            for (var u = 0; u < r.length; u++) {
              var _ = r[u];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(i, _.key, _);
            }
          }
          var ic = function() {
            function i() {
              (function(_, w) {
                if (!(_ instanceof w)) throw new TypeError("Cannot call a class as a function");
              })(this, i);
            }
            var r, u;
            return r = i, u = [{ key: "round10", value: function(_, w) {
              return function(I, y, N) {
                return N === void 0 || +N == 0 ? Math[I](y) : (N = +N, (y = +y) === null || isNaN(y) || typeof N != "number" || N % 1 != 0 ? NaN : (y = y.toString().split("e"), +((y = (y = Math[I](+(y[0] + "e" + (y[1] ? +y[1] - N : -N)))).toString().split("e"))[0] + "e" + (y[1] ? +y[1] + N : N))));
              }("round", _, w);
            } }], u && rc(r, u), i;
          }(), ac = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.TcpList = [], this.HttpList = [], this.RepSwitchList = [], this.BufferLevel = [], this.BufferState = [], this.PlayList = [], this.DroppedFrames = [], this.SchedulingInfo = [], this.DVRInfo = [], this.ManifestUpdate = [], this.RequestsQueue = null, this.DVBErrors = [];
          }, oc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.mt = null, this.to = null, this.lto = null;
          }, sc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.t = null, this.level = null;
          }, lc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.target = null, this.state = h.Z.BUFFER_EMPTY;
          }, uc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.time = null, this.range = null, this.manifestInfo = null;
          }, cc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.time = null, this.droppedFrames = null;
          };
          function uo(i, r) {
            if (!(i instanceof r)) throw new TypeError("Cannot call a class as a function");
          }
          var fc = function i() {
            uo(this, i), this.mediaType = null, this.type = null, this.requestTime = null, this.fetchTime = null, this.availabilityStartTime = null, this.presentationStartTime = 0, this.clientTimeOffset = 0, this.currentTime = null, this.buffered = null, this.latency = 0, this.streamInfo = [], this.representationInfo = [];
          }, dc = function i() {
            uo(this, i), this.id = null, this.index = null, this.start = null, this.duration = null;
          }, gc = function i() {
            uo(this, i), this.id = null, this.index = null, this.mediaType = null, this.streamIndex = null, this.presentationTimeOffset = null, this.startNumber = null, this.fragmentInfoType = null;
          }, hc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.mediaType = null, this.t = null, this.type = null, this.startTime = null, this.availabilityStartTime = null, this.duration = null, this.quality = null, this.range = null, this.state = null;
          }, mc = function i() {
            (function(r, u) {
              if (!(r instanceof u)) throw new TypeError("Cannot call a class as a function");
            })(this, i), this.loadingRequests = [], this.executedRequests = [];
          };
          function xs(i) {
            var r, u, _ = (i = i || {}).settings, w = this.context, I = (0, p.Z)(w).getInstance();
            function y() {
              I.trigger(o.Z.METRICS_CHANGED);
            }
            function N(G) {
              I.trigger(o.Z.METRIC_CHANGED, { mediaType: G }), y();
            }
            function Z(G, pe, ae) {
              I.trigger(o.Z.METRIC_UPDATED, { mediaType: G, metric: pe, value: ae }), N(G);
            }
            function Y(G, pe, ae) {
              I.trigger(o.Z.METRIC_ADDED, { mediaType: G, metric: pe, value: ae }), N(G);
            }
            function V(G, pe) {
              var ae = null;
              return G && (u.hasOwnProperty(G) ? ae = u[G] : pe || (ae = new ac(), u[G] = ae)), ae;
            }
            function M(G, pe, ae) {
              var he = V(G);
              he !== null && (he[pe].push(ae), he[pe].length > _.get().streaming.metrics.maxListDepth && he[pe].shift());
            }
            function H(G, pe, ae) {
              M(G, pe, ae), Y(G, pe, ae);
            }
            return r = { clearCurrentMetricsForType: function(G) {
              delete u[G], N(G);
            }, clearAllCurrentMetrics: function() {
              u = {}, y();
            }, getMetricsFor: V, addHttpRequest: function G(pe, ae, he, Ee, j, ue, z, me, g, x, O, L, A, oe, X, de, ne) {
              var U = new Ge.w();
              ue != null && ue !== Ee && (G(pe, null, he, Ee, j, null, null, me, g, null, null, null, A, null, null, de, ne), U.actualurl = ue), U.tcpid = ae, U.type = he, U.url = Ee, U.range = me, U.trequest = g, U.tresponse = x, U.responsecode = L, U.cmsd = ne, U._tfinish = O, U._stream = pe, U._mediaduration = A, U._quality = j, U._responseHeaders = oe, U._serviceLocation = z, U._fileLoaderType = de, X ? X.forEach(function(re) {
                (function(Te, Fe, De, ke) {
                  var Le = new Ge.O();
                  Le.s = Fe, Le.d = De, Le.b = ke, Te.trace.push(Le), Te.interval || (Te.interval = 0), Te.interval += De;
                })(U, re.s, re.d, re.b);
              }) : (delete U.interval, delete U.trace), H(pe, h.Z.HTTP_REQUEST, U);
            }, addRepresentationSwitch: function(G, pe, ae, he, Ee) {
              var j = new oc();
              j.t = pe, j.mt = ae, j.to = he, Ee ? j.lto = Ee : delete j.lto, H(G, h.Z.TRACK_SWITCH, j);
            }, addBufferLevel: function(G, pe, ae) {
              var he = new sc();
              he.t = pe, he.level = ae, H(G, h.Z.BUFFER_LEVEL, he);
            }, addBufferState: function(G, pe, ae) {
              var he = new lc();
              he.target = ae, he.state = pe, H(G, h.Z.BUFFER_STATE, he);
            }, addDVRInfo: function(G, pe, ae, he) {
              var Ee = new uc();
              Ee.time = pe, Ee.range = he, Ee.manifestInfo = ae, H(G, h.Z.DVR_INFO, Ee);
            }, addDroppedFrames: function(G, pe) {
              var ae = new cc(), he = V(G).DroppedFrames;
              pe && (ae.time = pe.creationTime, ae.droppedFrames = pe.droppedVideoFrames, he.length > 0 && he[he.length - 1] == ae || H(G, h.Z.DROPPED_FRAMES, ae));
            }, addSchedulingInfo: function(G, pe, ae, he, Ee, j, ue, z, me) {
              var g = new hc();
              g.mediaType = G, g.t = pe, g.type = ae, g.startTime = he, g.availabilityStartTime = Ee, g.duration = j, g.quality = ue, g.range = z, g.state = me, H(G, h.Z.SCHEDULING_INFO, g);
            }, addRequestsQueue: function(G, pe, ae) {
              var he = new mc();
              he.loadingRequests = pe, he.executedRequests = ae, V(G).RequestsQueue = he, Y(G, h.Z.REQUESTS_QUEUE, he);
            }, addManifestUpdate: function(G, pe, ae, he, Ee, j, ue, z, me, g) {
              var x = new fc();
              x.mediaType = G, x.type = pe, x.requestTime = ae, x.fetchTime = he, x.availabilityStartTime = Ee, x.presentationStartTime = j, x.clientTimeOffset = ue, x.currentTime = z, x.buffered = me, x.latency = g, M(t.Z.STREAM, h.Z.MANIFEST_UPDATE, x), Y(G, h.Z.MANIFEST_UPDATE, x);
            }, updateManifestUpdateInfo: function(G, pe) {
              if (G) {
                for (var ae in pe) G[ae] = pe[ae];
                Z(G.mediaType, h.Z.MANIFEST_UPDATE, G);
              }
            }, addManifestUpdateStreamInfo: function(G, pe, ae, he, Ee) {
              if (G) {
                var j = new dc();
                j.id = pe, j.index = ae, j.start = he, j.duration = Ee, G.streamInfo.push(j), Z(G.mediaType, h.Z.MANIFEST_UPDATE_STREAM_INFO, G);
              }
            }, addManifestUpdateRepresentationInfo: function(G, pe, ae, he, Ee, j, ue, z) {
              if (G && G.representationInfo) {
                var me = new gc();
                me.id = pe, me.index = ae, me.streamIndex = he, me.mediaType = Ee, me.startNumber = ue, me.fragmentInfoType = z, me.presentationTimeOffset = j, G.representationInfo.push(me), Z(G.mediaType, h.Z.MANIFEST_UPDATE_TRACK_INFO, G);
              }
            }, addPlayList: function(G) {
              G.trace && Array.isArray(G.trace) ? G.trace.forEach(function(pe) {
                pe.hasOwnProperty("subreplevel") && !pe.subreplevel && delete pe.subreplevel;
              }) : delete G.trace, H(t.Z.STREAM, h.Z.PLAY_LIST, G);
            }, addDVBErrors: function(G) {
              H(t.Z.STREAM, h.Z.DVB_ERRORS, G);
            } }, u = {}, r;
          }
          xs.__dashjs_factory_name = "MetricsModel";
          var pc = v.Z.getSingletonFactory(xs);
          function Fs(i) {
            i = i || {};
            var r, u, _, w, I = this.context, y = i.metricsModel;
            function N(V) {
              var M = y.getMetricsFor(V, !0);
              if (!M) return null;
              var H, G = M.HttpList, pe = null;
              if (!G || G.length <= 0) return null;
              for (H = G.length - 1; H >= 0; ) {
                if (G[H].responsecode) {
                  pe = G[H];
                  break;
                }
                H--;
              }
              return pe;
            }
            function Z(V) {
              var M = y.getMetricsFor(V, !0);
              return M && M.HttpList ? M.HttpList : [];
            }
            function Y(V, M) {
              if (!V) return null;
              var H = V[M];
              return H && H.length !== 0 ? H[H.length - 1] : null;
            }
            return r = { getCurrentRepresentationSwitch: function(V) {
              return Y(y.getMetricsFor(V, !0), h.Z.TRACK_SWITCH);
            }, getCurrentBufferState: function(V) {
              return Y(y.getMetricsFor(V, !0), h.Z.BUFFER_STATE);
            }, getCurrentBufferLevel: function(V) {
              var M = Y(y.getMetricsFor(V, !0), h.Z.BUFFER_LEVEL);
              return M ? ic.round10(M.level / 1e3, -3) : 0;
            }, getCurrentHttpRequest: N, getHttpRequests: Z, getCurrentDroppedFrames: function() {
              return Y(y.getMetricsFor(t.Z.VIDEO, !0), h.Z.DROPPED_FRAMES);
            }, getCurrentSchedulingInfo: function(V) {
              return Y(y.getMetricsFor(V, !0), h.Z.SCHEDULING_INFO);
            }, getCurrentDVRInfo: function(V) {
              return Y(V ? y.getMetricsFor(V, !0) : y.getMetricsFor(t.Z.VIDEO, !0) || y.getMetricsFor(t.Z.AUDIO, !0), h.Z.DVR_INFO);
            }, getCurrentManifestUpdate: function() {
              return Y(y.getMetricsFor(t.Z.STREAM), h.Z.MANIFEST_UPDATE);
            }, getLatestFragmentRequestHeaderValueByID: function(V, M) {
              if (!M) return null;
              var H = {}, G = N(V);
              G && (H = St.Z.parseHttpHeaders(G._responseHeaders));
              var pe = H[M.toLowerCase()];
              return pe === void 0 ? null : pe;
            }, getLatestMPDRequestHeaderValueByID: function(V) {
              if (!V) return null;
              var M, H, G, pe = {};
              for (G = (M = Z(t.Z.STREAM)).length - 1; G >= 0; G--) if ((H = M[G]).type === Ge.w.MPD_TYPE) {
                pe = St.Z.parseHttpHeaders(H._responseHeaders);
                break;
              }
              var ae = pe[V.toLowerCase()];
              return ae === void 0 ? null : ae;
            }, addRepresentationSwitch: function(V, M, H, G, pe) {
              y.addRepresentationSwitch(V, M, H, G, pe);
            }, addDVRInfo: function(V, M, H, G) {
              y.addDVRInfo(V, M, H, G);
            }, updateManifestUpdateInfo: function(V) {
              var M = this.getCurrentManifestUpdate();
              y.updateManifestUpdateInfo(M, V);
            }, addManifestUpdateStreamInfo: function(V) {
              if (V) {
                var M = this.getCurrentManifestUpdate();
                y.addManifestUpdateStreamInfo(M, V.id, V.index, V.start, V.duration);
              }
            }, addManifestUpdateRepresentationInfo: function(V, M) {
              if (V) {
                var H = this.getCurrentManifestUpdate();
                y.addManifestUpdateRepresentationInfo(H, V.id, V.index, V.streamIndex, M, V.presentationTimeOffset, V.startNumber, V.fragmentInfoType);
              }
            }, addManifestUpdate: function(V) {
              y.addManifestUpdate(t.Z.STREAM, V.type, V.requestStartDate, V.requestEndDate);
            }, addHttpRequest: function(V, M, H, G, pe, ae) {
              y.addHttpRequest(V.mediaType, null, V.type, V.url, V.quality, M, V.serviceLocation || null, V.range || null, V.requestStartDate, V.firstByteDate, V.requestEndDate, H, V.duration, G, pe, V.fileLoaderType, ae);
            }, addSchedulingInfo: function(V, M) {
              y.addSchedulingInfo(V.mediaType, /* @__PURE__ */ new Date(), V.type, V.startTime, V.availabilityStartTime, V.duration, V.quality, V.range, M);
            }, addRequestsQueue: function(V, M, H) {
              y.addRequestsQueue(V, M, H);
            }, addBufferLevel: function(V, M, H) {
              y.addBufferLevel(V, M, H);
            }, addBufferState: function(V, M, H) {
              y.addBufferState(V, M, H);
            }, addDroppedFrames: function(V) {
              y.addDroppedFrames(t.Z.VIDEO, V);
            }, addPlayList: function() {
              w && (y.addPlayList(w), w = null);
            }, addDVBErrors: function(V) {
              y.addDVBErrors(V);
            }, createPlaylistMetrics: function(V, M) {
              (w = new xe()).start = /* @__PURE__ */ new Date(), w.mstart = V, w.starttype = M;
            }, createPlaylistTraceMetrics: function(V, M, H) {
              u === !0 && (u = !1, (_ = new Me()).representationid = V, _.start = /* @__PURE__ */ new Date(), _.mstart = M, _.playbackspeed = H !== null ? H.toString() : null);
            }, updatePlayListTraceMetrics: function(V) {
              if (_) for (var M in _) _[M] = V[M];
            }, pushPlayListTraceMetrics: function(V, M) {
              if (u === !1 && w && _ && _.start) {
                var H = _.start, G = V.getTime() - H.getTime();
                _.duration = G, _.stopreason = M, w.trace.push(_), u = !0;
              }
            }, clearAllCurrentMetrics: function() {
              y.clearAllCurrentMetrics();
            } }, y = y || pc(I).getInstance({ settings: i.settings }), u = !0, _ = null, w = null, r;
          }
          Fs.__dashjs_factory_name = "DashMetrics";
          var yc = v.Z.getSingletonFactory(Fs);
          function ks() {
            var i, r, u, _, w = this.context, I = (0, p.Z)(w).getInstance(), y = (0, Oe.Z)(w).getInstance();
            function N(Ee) {
              _ = Ee;
            }
            function Z(Ee, j, ue, z) {
              var me, g = j.adaptation.period.mpd, x = g.availabilityStartTime;
              if (z) me = ue && g.timeShiftBufferDepth !== Number.POSITIVE_INFINITY ? new Date(x.getTime() + 1e3 * (Ee + g.timeShiftBufferDepth)) : g.availabilityEndTime;
              else if (ue) {
                var O = j.availabilityTimeOffset;
                me = new Date(x.getTime() + 1e3 * (Ee - O));
              } else me = x;
              return me;
            }
            function Y(Ee, j) {
              return (Ee.getTime() - j.mpd.availabilityStartTime.getTime() + 1e3 * _) / 1e3;
            }
            function V(Ee, j) {
              return Ee + (j.adaptation.period.start - j.presentationTimeOffset);
            }
            function M(Ee) {
              var j = { start: NaN, end: NaN }, ue = Ee[0].getAdapter().getRegularPeriods()[0], z = Y(/* @__PURE__ */ new Date(), ue);
              if (!Ee || Ee.length === 0) return { range: j, now: z };
              Ee.forEach(function(g) {
                var x = g.getAdapter(), O = x.getMediaInfoForType(g.getStreamInfo(), t.Z.VIDEO) || x.getMediaInfoForType(g.getStreamInfo(), t.Z.AUDIO), L = x.getVoRepresentations(O)[0], A = { start: NaN, end: NaN };
                if (L) if (L.segmentInfoType === e.Z.SEGMENT_TIMELINE) A = function(X) {
                  var de, ne, U, re, Te = X.adaptation.period.mpd.manifest.Period_asArray[X.adaptation.period.index].AdaptationSet_asArray[X.adaptation.index], Fe = r.getRepresentationFor(X.index, Te), De = Fe.SegmentTemplate || Fe.SegmentList, ke = De.SegmentTimeline, Le = De.timescale, ut = ke.S_asArray, ct = { start: 0, end: 0 }, rt = ut[0].t, at = !isNaN(rt), Bt = at ? rt : 0, Re = 0;
                  for (at && (ct.start = V(Bt / Le, X)), U = 0, re = ut.length; U < re; U++) ne = 0, (de = ut[U]).hasOwnProperty("r") && (ne = de.r), Re += de.d * (1 + ne);
                  return ct.end = V((Bt + Re) / Le, X), ct;
                }(L);
                else {
                  var oe = L.adaptation.period;
                  A.start = oe.start, A.end = Math.max(z, oe.start + oe.duration);
                }
                !isNaN(A.start) && (isNaN(j.start) || j.start > A.start) && (j.start = A.start), !isNaN(A.end) && (isNaN(j.end) || j.end < A.end) && (j.end = A.end);
              }), j.end = Math.min(z, j.end);
              var me = G(Ee, j.end, !0);
              return j.end = isNaN(me) ? j.end : me, j.start = ue && ue.mpd && ue.mpd.timeShiftBufferDepth && !isNaN(ue.mpd.timeShiftBufferDepth) && !isNaN(j.end) ? Math.max(j.end - ue.mpd.timeShiftBufferDepth, j.start) : j.start, j.start = G(Ee, j.start), { range: j, now: z };
            }
            function H(Ee, j) {
              u = Ee - j.end;
            }
            function G(Ee, j) {
              var ue = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              try {
                for (var z = 0, me = !1, g = NaN; !me && z < Ee.length; ) {
                  var x = Ee[z].getStreamInfo();
                  x.start <= j && (!isFinite(x.duration) || x.start + x.duration >= j) ? (g = j, me = !0) : !ue && x.start > j && (isNaN(g) || x.start < g) ? g = x.start : ue && x.start + x.duration < j && (isNaN(g) || x.start + x.duration > g) && (g = x.start + x.duration), z += 1;
                }
                return g;
              } catch {
                return j;
              }
            }
            function pe(Ee) {
              Ee.offset === void 0 || isNaN(Ee.offset) || N(Ee.offset / 1e3);
            }
            function ae() {
              _ = 0, u = 0;
            }
            function he() {
              I.off(o.Z.UPDATE_TIME_SYNC_OFFSET, pe, this), ae();
            }
            return i = { initialize: function() {
              ae(), I.on(o.Z.UPDATE_TIME_SYNC_OFFSET, pe, this);
            }, getClientTimeOffset: function() {
              return _;
            }, setClientTimeOffset: N, getClientReferenceTime: function() {
              return Date.now() - 1e3 * u + 1e3 * _;
            }, calcAvailabilityStartTimeFromPresentationTime: function(Ee, j, ue) {
              return Z(Ee, j, ue);
            }, calcAvailabilityEndTimeFromPresentationTime: function(Ee, j, ue) {
              return Z(Ee, j, ue, !0);
            }, calcPresentationTimeFromWallTime: Y, calcPresentationTimeFromMediaTime: V, calcPeriodRelativeTimeFromMpdRelativeTime: function(Ee, j) {
              return j - Ee.adaptation.period.start;
            }, calcMediaTimeFromPresentationTime: function(Ee, j) {
              return Ee - j.adaptation.period.start + j.presentationTimeOffset;
            }, calcWallTimeForSegment: function(Ee, j) {
              var ue, z, me;
              return j && (ue = Ee.representation.adaptation.period.mpd.suggestedPresentationDelay, z = Ee.presentationStartTime + ue, me = new Date(Ee.availabilityStartTime.getTime() + 1e3 * z)), me;
            }, calcTimeShiftBufferWindow: function(Ee, j) {
              if (!j) return function(z) {
                var me = { start: NaN, end: NaN }, g = 0, x = NaN;
                return z.forEach(function(O) {
                  var L = O.getStreamInfo();
                  g += L.duration, (isNaN(x) || L.start < x) && (x = L.start);
                }), me.start = x, me.end = x + g, me;
              }(Ee);
              if (y.get().streaming.timeShiftBuffer.calcFromSegmentTimeline) {
                var ue = M(Ee);
                return H(ue.now, ue.range), ue.range;
              }
              return function(z) {
                var me = { start: NaN, end: NaN };
                if (!z || z.length === 0) return me;
                var g = z[0].getAdapter().getRegularPeriods()[0], x = Y(/* @__PURE__ */ new Date(), g), O = g.mpd.timeShiftBufferDepth, L = isNaN(O) ? 0 : x - O;
                if (me.start = G(z, L), me.end = !isNaN(me.start) && x < me.start ? x : G(z, x, !0), !isNaN(O) && me.end < x - O && (me.end = NaN), y.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline) {
                  var A = M(z);
                  if (A.range.end < me.start) return I.trigger(n.Z.CONFORMANCE_VIOLATION, { level: pi.LEVELS.WARNING, event: pi.EVENTS.INVALID_DVR_WINDOW }), H(A.now, A.range), A.range;
                }
                return me;
              }(Ee);
            }, reset: he }, r = un(w).getInstance(), he(), i;
          }
          ks.__dashjs_factory_name = "TimelineConverter";
          var _c = v.Z.getSingletonFactory(ks), co = R(4593), oa = R(6934);
          function fo(i) {
            return fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
              return typeof r;
            } : function(r) {
              return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
            }, fo(i);
          }
          function go(i, r) {
            return go = Object.setPrototypeOf || function(u, _) {
              return u.__proto__ = _, u;
            }, go(i, r);
          }
          function Ec(i, r) {
            return !r || fo(r) !== "object" && typeof r != "function" ? function(u) {
              if (u === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return u;
            }(i) : r;
          }
          function sa(i) {
            return sa = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
              return r.__proto__ || Object.getPrototypeOf(r);
            }, sa(i);
          }
          var vc = function(i) {
            (function(I, y) {
              if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(y.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), go(I, y);
            })(w, i);
            var r, u, _ = (r = w, u = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var I, y = sa(r);
              if (u) {
                var N = sa(this).constructor;
                I = Reflect.construct(y, arguments, N);
              } else I = y.apply(this, arguments);
              return Ec(this, I);
            });
            function w() {
              var I;
              return function(y, N) {
                if (!(y instanceof N)) throw new TypeError("Cannot call a class as a function");
              }(this, w), (I = _.call(this)).captionData = null, I.label = null, I.defaultTrack = !1, I.kind = null, I.isFragmented = !1, I.isEmbedded = !1, I.isTTML = null, I;
            }
            return w;
          }(lo), Tc = R(2295);
          function Zs() {
            var i = 0;
            function r(N) {
              for (var Z = "", Y = 0; Y < N.length; ++Y) Z += N[Y].uchar;
              return Z.length - Z.replace(/^\s+/, "").length;
            }
            function u(N) {
              return "left: " + 3.125 * N.x + "%; top: " + 6.66 * N.y1 + "%; width: " + (100 - 3.125 * N.x) + "%; height: " + 6.66 * Math.max(N.y2 - 1 - N.y1, 1) + "%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;";
            }
            function _(N) {
              return N === "red" ? "rgb(255, 0, 0)" : N === "green" ? "rgb(0, 255, 0)" : N === "blue" ? "rgb(0, 0, 255)" : N === "cyan" ? "rgb(0, 255, 255)" : N === "magenta" ? "rgb(255, 0, 255)" : N === "yellow" ? "rgb(255, 255, 0)" : N === "white" ? "rgb(255, 255, 255)" : N === "black" ? "rgb(0, 0, 0)" : N;
            }
            function w(N, Z) {
              var Y = N.videoHeight / 15;
              return Z ? "font-size: " + Y + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; color: " + (Z.foreground ? _(Z.foreground) : "rgb(255, 255, 255)") + "; font-style: " + (Z.italics ? "italic" : "normal") + "; text-decoration: " + (Z.underline ? "underline" : "none") + "; white-space: pre; background-color: " + (Z.background ? _(Z.background) : "transparent") + ";" : "font-size: " + Y + "px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;";
            }
            function I(N) {
              return N.replace(/^\s+/g, "");
            }
            function y(N) {
              return N.replace(/\s+$/g, "");
            }
            return { createHTMLCaptionsFromScreen: function(N, Z, Y, V) {
              var M, H, G = null, pe = !1, ae = -1, he = { start: Z, end: Y, spans: [] }, Ee = "style_cea608_white_black", j = {}, ue = {}, z = [];
              for (M = 0; M < 15; ++M) {
                var me = V.rows[M], g = "", x = null;
                if (me.isEmpty() === !1) {
                  var O = r(me.chars);
                  G === null && (G = { x: O, y1: M, y2: M + 1, p: [] }), O !== ae && pe && (G.p.push(he), he = { start: Z, end: Y, spans: [] }, G.y2 = M, G.name = "region_" + G.x + "_" + G.y1 + "_" + G.y2, j.hasOwnProperty(G.name) === !1 ? (z.push(G), j[G.name] = G) : j[G.name].p.contat(G.p), G = { x: O, y1: M, y2: M + 1, p: [] });
                  for (var L = 0; L < me.chars.length; ++L) {
                    var A = me.chars[L], oe = A.penState;
                    if (x === null || !oe.equals(x)) {
                      g.trim().length > 0 && (he.spans.push({ name: Ee, line: g, row: M }), g = "");
                      var X = "style_cea608_" + oe.foreground + "_" + oe.background;
                      oe.underline && (X += "_underline"), oe.italics && (X += "_italics"), ue.hasOwnProperty(X) || (ue[X] = JSON.parse(JSON.stringify(oe))), x = oe, Ee = X;
                    }
                    g += A.uchar;
                  }
                  g.trim().length > 0 && he.spans.push({ name: Ee, line: g, row: M }), pe = !0, ae = O;
                } else pe = !1, ae = -1, G && (G.p.push(he), he = { start: Z, end: Y, spans: [] }, G.y2 = M, G.name = "region_" + G.x + "_" + G.y1 + "_" + G.y2, j.hasOwnProperty(G.name) === !1 ? (z.push(G), j[G.name] = G) : j[G.name].p.contat(G.p), G = null);
              }
              G && (G.p.push(he), G.y2 = M + 1, G.name = "region_" + G.x + "_" + G.y1 + "_" + G.y2, j.hasOwnProperty(G.name) === !1 ? (z.push(G), j[G.name] = G) : j[G.name].p.contat(G.p), G = null);
              var de = [];
              for (M = 0; M < z.length; ++M) {
                var ne = z[M], U = "sub_cea608_" + i++, re = document.createElement("div");
                re.id = U;
                var Te = u(ne);
                re.style.cssText = "position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;" + Te;
                var Fe = document.createElement("div");
                Fe.className = "paragraph bodyStyle", Fe.style.cssText = w(N);
                var De = document.createElement("div");
                De.className = "cueUniWrapper", De.style.cssText = "unicode-bidi: normal; direction: ltr;";
                for (var ke = 0; ke < ne.p.length; ++ke) {
                  var Le = ne.p[ke], ut = 0;
                  for (H = 0; H < Le.spans.length; ++H) {
                    var ct = Le.spans[H];
                    if (ct.line.length > 0) {
                      if (H !== 0 && ut != ct.row) {
                        var rt = document.createElement("br");
                        rt.className = "lineBreak", De.appendChild(rt);
                      }
                      var at = !1;
                      ut === ct.row && (at = !0), ut = ct.row;
                      var Bt = ue[ct.name], Re = document.createElement("span");
                      Re.className = "spanPadding " + ct.name + " customSpanColor", Re.style.cssText = w(N, Bt), H !== 0 && at ? H === Le.spans.length - 1 ? Re.textContent = y(ct.line) : Re.textContent = ct.line : Le.spans.length > 1 && H < Le.spans.length - 1 && ct.row === Le.spans[H + 1].row ? Re.textContent = I(ct.line) : Re.textContent = ct.line.trim(), De.appendChild(Re);
                    }
                  }
                }
                Fe.appendChild(De), re.appendChild(Fe);
                var He = { bodyStyle: ["%", 90] };
                for (var yt in ue) ue.hasOwnProperty(yt) && (He[yt] = ["%", 90]);
                de.push({ type: "html", start: Z, end: Y, cueHTMLElement: re, cueID: U, cellResolution: [32, 15], isFromCEA608: !0, fontSize: He, lineHeight: {}, linePadding: {} });
              }
              return de;
            } };
          }
          Zs.__dashjs_factory_name = "EmbeddedTextHtmlRender";
          var bc = v.Z.getSingletonFactory(Zs);
          function Bs(i) {
            var r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j = i.errHandler, ue = i.manifestModel, z = i.mediaController, me = i.videoModel, g = i.textTracks, x = i.vttParser, O = i.vttCustomRenderingParser, L = i.ttmlParser, A = i.streamInfo, oe = i.settings, X = this.context, de = (0, p.Z)(X).getInstance(), ne = !1;
            function U() {
              y = null, Z = NaN, Y = [], V = null, N = !1, I = [], w = null;
            }
            function re(rt) {
              var at = new vc();
              for (var Bt in rt) at[Bt] = rt[Bt];
              at.labels = rt.labels, at.defaultTrack = function(Re) {
                var He = !1;
                return H.length > 1 && Re.isEmbedded ? He = Re.id && Re.id === t.Z.CC1 : H.length === 1 ? Re.id && typeof Re.id == "string" && Re.id.substring(0, 2) === "CC" && (He = !0) : H.length === 0 && (He = Re.index === I[0].index), He;
              }(rt), at.isFragmented = rt.isFragmented, at.isEmbedded = !!rt.isEmbedded, at.isTTML = function(Re) {
                return Re.codec && Re.codec.search(t.Z.STPP) >= 0 || Re.mimeType && Re.mimeType.search(t.Z.TTML) >= 0;
              }(rt), at.kind = function(Re, He) {
                var yt = Re.roles && Re.roles.length > 0 ? He[Re.roles[0]] : He.caption;
                return yt = yt === He.caption || yt === He.subtitle ? yt : He.caption;
              }(rt, { subtitle: "subtitles", caption: "captions" }), g.addTextTrack(at);
            }
            function Te(rt) {
              var at = rt.chunk;
              at.mediaInfo.embeddedCaptions && De(at.bytes, at);
            }
            function Fe(rt) {
              M = rt;
            }
            function De(rt, at) {
              var Bt = at.mediaInfo, Re = Bt.type, He = Bt.mimeType, yt = Bt.codec || He;
              yt ? Bt.codec.indexOf("application/mp4") !== -1 ? function(Qe, Tt, vt) {
                var mt;
                if (Tt.segmentType === "InitializationSegment") N = !0, Z = _.getMediaTimescaleFromMoov(Qe);
                else {
                  if (!N) return;
                  (mt = _.getSamplesInfo(Qe).sampleList).length > 0 && (V = mt[0].cts - Tt.start * Z), vt.search(t.Z.STPP) >= 0 ? function(Wt, zt, hn) {
                    var yn, ze;
                    for (w = w !== null ? w : ut(hn), yn = 0; yn < zt.length; yn++) {
                      var Et = zt[yn], lt = Et.cts, wt = Le(), Pt = wt + lt / Z, $t = Pt + Et.duration / Z;
                      r.buffered.add(Pt, $t);
                      var Qt = new DataView(Wt, Et.offset, Et.subSizes[0]), en = oa.Utils.dataViewToString(Qt, t.Z.UTF8), ln = [], pt = Et.offset + Et.subSizes[0];
                      for (ze = 1; ze < Et.subSizes.length; ze++) {
                        var kt = new Uint8Array(Wt, pt, Et.subSizes[ze]), qt = String.fromCharCode.apply(null, kt);
                        ln.push(qt), pt += Et.subSizes[ze];
                      }
                      try {
                        var Vt = ue.getValue().ttmlTimeIsRelative ? lt / Z : 0, Xt = w.parse(en, Vt, lt / Z, (lt + Et.duration) / Z, ln);
                        g.addCaptions(M, wt, Xt);
                      } catch (We) {
                        y.removeExecutedRequestsBeforeTime(), this.remove(), u.error("TTML parser error: " + We.message);
                      }
                    }
                  }(Qe, mt, vt) : function(Wt, zt) {
                    var hn, yn, ze, Et = [];
                    for (hn = 0; hn < zt.length; hn++) {
                      var lt = zt[hn];
                      lt.cts -= V;
                      var wt = Le() + lt.cts / Z, Pt = wt + lt.duration / Z;
                      r.buffered.add(wt, Pt);
                      var $t = Wt.slice(lt.offset, lt.offset + lt.size), Qt = oa.parseBuffer($t);
                      for (yn = 0; yn < Qt.boxes.length; yn++) {
                        var en = Qt.boxes[yn];
                        if (u.debug("VTT box1: " + en.type), en.type !== "vtte" && en.type === "vttc") {
                          u.debug("VTT vttc boxes.length = " + en.boxes.length);
                          var ln = { styles: {} };
                          for (ze = 0; ze < en.boxes.length; ze++) {
                            var pt = en.boxes[ze];
                            if (u.debug("VTT box2: " + pt.type), pt.type === "payl") ln.start = lt.cts / Z, ln.end = (lt.cts + lt.duration) / Z, ln.data = pt.cue_text;
                            else if (pt.type === "sttg" && pt.settings && pt.settings !== "") try {
                              var kt = pt.settings.split(" ");
                              ln.styles = x.getCaptionStyles(kt);
                            } catch {
                            }
                          }
                          ln && ln.data && (Et.push(ln), u.debug("VTT  ".concat(ln.start, " - ").concat(ln.end, " :  ").concat(ln.data)));
                        }
                      }
                    }
                    Et.length > 0 && g.addCaptions(M, 0, Et);
                  }(Qe, mt);
                }
              }(rt, at, yt) : Re === t.Z.VIDEO ? function(Qe, Tt) {
                var vt, mt;
                if (Tt.segmentType === Ge.w.INIT_SEGMENT_TYPE) G === 0 && (G = _.getMediaTimescaleFromMoov(Qe));
                else if (Tt.segmentType === Ge.w.MEDIA_SEGMENT_TYPE) {
                  if (G === 0) return void u.warn("CEA-608: No timescale for embeddedTextTrack yet");
                  var Wt = (mt = _.getSamplesInfo(Qe)).lastSequenceNumber, zt = Math.trunc(Tt.start), hn = Math.trunc(Tt.end);
                  if (he[0] || he[1] || function() {
                    for (var wt, Pt = 0; Pt < H.length; Pt++) {
                      if ((wt = g.getTrackIdxForId(H[Pt].id)) === -1) return void u.warn("CEA-608: data before track is ready.");
                      var $t = ke(wt);
                      he[Pt] = new (E()).Cea608Parser(Pt + 1, { newCue: $t }, null);
                    }
                  }(), G) {
                    if (function(wt, Pt, $t, Qt, en) {
                      return wt !== null && Pt !== null && Qt !== null && en !== null && (Pt === wt ? Qt !== en : Pt !== wt + $t);
                    }(pe, Wt, mt.numSequences, ae, zt)) for (vt = 0; vt < he.length; vt++) he[vt] && he[vt].reset();
                    for (var yn = function(wt, Pt) {
                      if (Pt.length === 0) return null;
                      for (var $t = { splits: [], fields: [[], []] }, Qt = new DataView(wt), en = 0; en < Pt.length; en++) for (var ln = Pt[en], pt = E().findCea608Nalus(Qt, ln.offset, ln.size), kt = null, qt = 0, Vt = 0; Vt < pt.length; Vt++) for (var Xt = E().extractCea608DataFromRange(Qt, pt[Vt]), We = 0; We < 2; We++) if (Xt[We].length > 0) {
                        ln.cts !== kt ? qt = 0 : qt += 1;
                        var Pe = Le();
                        $t.fields[We].push([ln.cts + Pe * G, Xt[We], qt]), kt = ln.cts;
                      }
                      return $t.fields.forEach(function(ft) {
                        ft.sort(function(ye, Ae) {
                          return ye[0] === Ae[0] ? ye[2] - Ae[2] : ye[0] - Ae[0];
                        });
                      }), $t;
                    }(Qe, mt.sampleList), ze = 0; ze < he.length; ze++) {
                      var Et = yn.fields[ze], lt = he[ze];
                      if (lt) for (vt = 0; vt < Et.length; vt++) lt.addData(Et[vt][0] / G, Et[vt][1]);
                    }
                    pe = Wt, ae = hn;
                  }
                }
              }(rt, at) : function(Qe, Tt, vt) {
                var mt, Wt, zt = new DataView(Qe, 0, Qe.byteLength);
                Wt = oa.Utils.dataViewToString(zt, t.Z.UTF8);
                try {
                  mt = ut(vt).parse(Wt, 0), g.addCaptions(g.getCurrentTrackIdx(), 0, mt), r.buffered && r.buffered.add(Tt.start, Tt.end);
                } catch (hn) {
                  j.error(new se.Z(ee.TIMED_TEXT_ERROR_ID_PARSE_CODE, ee.TIMED_TEXT_ERROR_MESSAGE_PARSE + hn.message, Wt));
                }
              }(rt, at, yt) : u.error("No text type defined");
            }
            function ke(rt) {
              return function(at, Bt, Re) {
                var He;
                (He = me.getTTMLRenderingDiv() ? Ee.createHTMLCaptionsFromScreen(me.getElement(), at, Bt, Re) : [{ start: at, end: Bt, data: Re.getDisplayText(), styles: {} }]) && g.addCaptions(rt, 0, He);
              };
            }
            function Le() {
              return isNaN(r.timestampOffset) ? 0 : r.timestampOffset;
            }
            function ut(rt) {
              var at;
              return rt.search(t.Z.VTT) >= 0 ? at = oe.get().streaming.text.webvtt.customRenderingEnabled && O ? O : x : (rt.search(t.Z.TTML) >= 0 || rt.search(t.Z.STPP) >= 0) && (at = L), at;
            }
            function ct(rt) {
              H.forEach(function(at) {
                var Bt = g.getTrackIdxForId(at.id);
                Bt >= 0 && g.deleteCuesFromTrackIdx(Bt, rt.from, rt.to);
              });
            }
            return r = { initialize: function() {
              ne || (H = [], M = null, G = 0, he = [], pe = null, ae = null, ne = !0, Ee = bc(X).getInstance(), de.on(o.Z.VIDEO_CHUNK_RECEIVED, Te, r), de.on(o.Z.BUFFER_CLEARED, ct, r));
            }, addMediaInfos: function(rt, at, Bt) {
              if (I = I.concat(at), rt === t.Z.TEXT && at[0].isFragmented && !at[0].isEmbedded) {
                y = Bt, r.buffered = (0, Tc.Z)(X).create(), Y = z.getTracksFor(t.Z.TEXT, A.id).filter(function(Qe) {
                  return Qe.isFragmented;
                });
                for (var Re = z.getCurrentTrackFor(t.Z.TEXT, A.id), He = 0; He < Y.length; He++) if (Y[He] === Re) {
                  Fe(He);
                  break;
                }
              }
              for (var yt = 0; yt < at.length; yt++) re(at[yt]);
            }, resetMediaInfos: function() {
              I = [];
            }, getStreamId: function() {
              return A.id;
            }, append: De, abort: function() {
            }, addEmbeddedTrack: function(rt) {
              if (ne && rt) if (rt.id === t.Z.CC1 || rt.id === t.Z.CC3) {
                for (var at = 0; at < H.length; at++) if (H[at].id === rt.id) return;
                H.push(rt);
              } else u.warn("Embedded track " + rt.id + " not supported!");
            }, resetEmbedded: function() {
              de.off(o.Z.VIDEO_CHUNK_RECEIVED, Te, r), de.off(o.Z.BUFFER_CLEARED, ct, r), g && g.deleteAllTextTracks(), ne = !1, H = [], he = [null, null], pe = null, ae = null;
            }, getConfig: function() {
              return { fragmentModel: y, fragmentedTracks: Y, videoModel: me };
            }, setCurrentFragmentedTrackIdx: Fe, remove: function(rt, at) {
              rt === void 0 && rt === at && (rt = r.buffered.start(0), at = r.buffered.end(r.buffered.length - 1)), r.buffered.remove(rt, at), g.deleteCuesFromTrackIdx(M, rt, at);
            }, reset: function() {
              U(), I = [], _ = null;
            } }, u = (0, m.Z)(X).getInstance().getLogger(r), _ = (0, wi.Z)(X).getInstance(), U(), r;
          }
          Bs.__dashjs_factory_name = "TextSourceBuffer";
          var Sc = v.Z.getClassFactory(Bs), ho = R(4403);
          function Us(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          var Ac = ["text", "align", "fontSize", "id", "isd", "line", "lineAlign", "lineHeight", "linePadding", "position", "positionAlign", "region", "size", "snapToLines", "vertical"];
          function Gs(i) {
            var r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j, ue, z, me = this.context, g = (0, p.Z)(me).getInstance(), x = i.videoModel, O = i.streamInfo, L = i.settings;
            function A(ze, Et, lt, wt, Pt, $t) {
              var Qt = 0, en = 0;
              ze / Et > lt / wt ? Qt = (en = Et) / wt * lt : en = (Qt = ze) / lt * wt;
              var ln, pt, kt = 0, qt = 0;
              return Qt / en > Pt ? (qt = en, kt = en * Pt) : (kt = Qt, qt = Qt / Pt), ln = (ze - kt) / 2, pt = (Et - qt) / 2, $t ? { x: ln + 0.1 * kt, y: pt + 0.1 * qt, w: 0.8 * kt, h: 0.8 * qt } : { x: ln, y: pt, w: kt, h: qt };
            }
            function oe(ze, Et) {
              var lt = x.getClientWidth(), wt = x.getClientHeight(), Pt = x.getVideoWidth(), $t = x.getVideoHeight(), Qt = x.getVideoRelativeOffsetTop(), en = x.getVideoRelativeOffsetLeft();
              if (Pt !== 0 && $t !== 0) {
                var ln = Pt / $t, pt = !1;
                ze.isFromCEA608 && (ln = 1.1666666666666667, pt = !0);
                var kt = A.call(this, lt, wt, Pt, $t, ln, pt), qt = kt.w, Vt = kt.h, Xt = kt.x, We = kt.y;
                if (qt != Y || Vt != V || Xt != N || We != Z || Et) {
                  if (N = Xt + en, Z = We + Qt, Y = qt, V = Vt, M) {
                    var Pe = M.style;
                    Pe && (Pe.left = N + "px", Pe.top = Z + "px", Pe.width = Y + "px", Pe.height = V + "px", Pe.zIndex = pe && document[pe] || ae ? Ee : null, g.trigger(n.Z.CAPTION_CONTAINER_RESIZE));
                  }
                  var ft = ze.activeCues;
                  if (ft) for (var ye = ft.length, Ae = 0; Ae < ye; ++Ae) {
                    var tt = ft[Ae];
                    tt.scaleCue(tt);
                  }
                }
              }
            }
            function X(ze) {
              var Et, lt, wt, Pt, $t, Qt = Y, en = V;
              if (ze.cellResolution) {
                var ln = [Qt / ze.cellResolution[0], en / ze.cellResolution[1]];
                if (ze.linePadding) {
                  for (Et in ze.linePadding) if (ze.linePadding.hasOwnProperty(Et)) {
                    lt = (ze.linePadding[Et] * ln[0]).toString();
                    for (var pt = document.getElementsByClassName("spanPadding"), kt = 0; kt < pt.length; kt++) pt[kt].style.cssText = pt[kt].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt), pt[kt].style.cssText = pt[kt].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt);
                  }
                }
                if (ze.fontSize) {
                  for (Et in ze.fontSize) if (ze.fontSize.hasOwnProperty(Et)) {
                    ze.fontSize[Et][0] === "%" ? wt = ze.fontSize[Et][1] / 100 : ze.fontSize[Et][0] === "c" && (wt = ze.fontSize[Et][1]), lt = (wt * ln[1]).toString(), $t = Et !== "defaultFontSize" ? document.getElementsByClassName(Et) : document.getElementsByClassName("paragraph");
                    for (var qt = 0; qt < $t.length; qt++) $t[qt].style.cssText = $t[qt].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt);
                  }
                  if (ze.lineHeight) {
                    for (Et in ze.lineHeight) if (ze.lineHeight.hasOwnProperty(Et)) {
                      ze.lineHeight[Et][0] === "%" ? Pt = ze.lineHeight[Et][1] / 100 : ze.fontSize[Et][0] === "c" && (Pt = ze.lineHeight[Et][1]), lt = (Pt * ln[1]).toString(), $t = document.getElementsByClassName(Et);
                      for (var Vt = 0; Vt < $t.length; Vt++) $t[Vt].style.cssText = $t[Vt].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, "$1" + lt);
                    }
                  }
                }
              }
              if (ze.isd) {
                var Xt = document.getElementById(ze.cueID);
                Xt && M.removeChild(Xt), ne(ze);
              }
            }
            function de(ze, Et) {
              var lt = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/, wt = /^#(.*)$/;
              if (lt.test(Et)) {
                var Pt = lt.exec(Et), $t = parseInt(Pt[4], 10) - 1;
                return "data:image/png;base64," + btoa(ze.images[$t]);
              }
              if (wt.test(Et)) {
                var Qt = wt.exec(Et)[1];
                return "data:image/png;base64," + ze.embeddedImages[Qt];
              }
              return Et;
            }
            function ne(ze) {
              if (M) {
                yn.call(this);
                var Et = document.createElement("div");
                M.appendChild(Et), he = (0, ho.renderHTML)(ze.isd, Et, function(lt) {
                  return de(ze, lt);
                }, M.clientHeight, M.clientWidth, L.get().streaming.text.imsc.displayForcedOnlyMode, function(lt) {
                  u.info("renderCaption :", lt);
                }, he, L.get().streaming.text.imsc.enableRollUp), Et.id = ze.cueID, g.trigger(n.Z.CAPTION_RENDERED, { captionDiv: Et, currentTrackIdx: y });
              }
            }
            function U(ze, Et) {
              return !!Et && Et.endTime >= ze.startTime;
            }
            function re(ze, Et) {
              return !!L.get().streaming.text.extendSegmentedCues && !!function(lt, wt, Pt) {
                for (var $t = 0; $t < Pt.length; $t++) {
                  var Qt = Pt[$t];
                  if (JSON.stringify(lt[Qt]) !== JSON.stringify(wt[Qt])) return !1;
                }
                return !0;
              }(Et, ze, Ac) && (Et.endTime = Math.max(Et.endTime, ze.endTime), !0);
            }
            function Te(ze, Et) {
              Et && Et.forEach(function(lt) {
                lt.kind && lt.kind === "image" && (lt.src = de(ze, lt.src)), Te(ze, lt.contents);
              });
            }
            function Fe(ze, Et, lt) {
              var wt = He(ze), Pt = L.get().streaming.text.dispatchForManualRendering;
              if (wt && Array.isArray(lt) && lt.length !== 0) for (var $t = 0; $t < lt.length; $t++) {
                var Qt = null, en = lt[$t];
                wt.cellResolution = en.cellResolution, wt.isFromCEA608 = en.isFromCEA608, isNaN(en.start) || isNaN(en.end) || (Pt ? Qt = De(en, Et) : rt(en) && M ? Qt = ut(en, Et, wt) : en.data && (Qt = ct(en, Et, wt)));
                try {
                  if (Qt) {
                    if (!Tt(wt, Qt)) if (L.get().streaming.text.webvtt.customRenderingEnabled) wt.manualCueList || (wt.manualCueList = []), wt.manualCueList.push(Qt);
                    else {
                      var ln = void 0;
                      wt.cues && wt.cues.length !== 0 && (ln = wt.cues[wt.cues.length - 1]), U(Qt, ln) ? re(Qt, ln) || (ln.isd && (ln.onexit = function() {
                      }), wt.mode !== t.Z.TEXT_DISABLED && wt.addCue(Qt)) : wt.mode !== t.Z.TEXT_DISABLED && wt.addCue(Qt);
                    }
                    var pt = L.get().streaming.buffer.bufferToKeep;
                    mt(wt, 0, x.getTime() - pt);
                  } else u.error("Impossible to display subtitles. You might have missed setting a TTML rendering div via player.attachTTMLRenderingDiv(TTMLRenderingDiv)");
                } catch (kt) {
                  throw Wt(wt), wt.addCue(Qt), kt;
                }
              }
            }
            function De(ze, Et) {
              var lt = at(ze, Et);
              return lt.onenter = function() {
                rt(ze) && z && z.cueID !== lt.cueID && Le(z), delete lt.type, z = lt, ke(lt);
              }, lt.onexit = function() {
                Le(lt), z = null;
              }, lt;
            }
            function ke(ze) {
              g.trigger(n.Z.CUE_ENTER, ze);
            }
            function Le(ze) {
              g.trigger(n.Z.CUE_EXIT, { cueID: ze.cueID });
            }
            function ut(ze, Et, lt) {
              var wt = this, Pt = at(ze, Et);
              return M.style.left = N + "px", M.style.top = Z + "px", M.style.width = Y + "px", M.style.height = V + "px", Pt.onenter = function() {
                var $t = this;
                lt.mode === t.Z.TEXT_SHOWING && (this.isd ? (ue ? requestAnimationFrame(function() {
                  return ne($t);
                }) : ne(this), u.debug("Cue enter id:" + this.cueID)) : (M.appendChild(this.cueHTMLElement), X.call(wt, this), g.trigger(n.Z.CAPTION_RENDERED, { captionDiv: this.cueHTMLElement, currentTrackIdx: y })));
              }, Pt.onexit = function() {
                if (M) for (var $t = M.childNodes, Qt = 0; Qt < $t.length; ++Qt) $t[Qt].id === this.cueID && (u.debug("Cue exit id:" + $t[Qt].id), M.removeChild($t[Qt]), --Qt);
              }, Pt;
            }
            function ct(ze, Et, lt) {
              var wt = at(ze, Et);
              if (wt.isActive = !1, ze.styles) try {
                ze.styles.align !== void 0 && "align" in wt && (wt.align = ze.styles.align), ze.styles.line !== void 0 && "line" in wt && (wt.line = ze.styles.line), ze.styles.snapToLines !== void 0 && "snapToLines" in wt && (wt.snapToLines = ze.styles.snapToLines), ze.styles.position !== void 0 && "position" in wt && (wt.position = ze.styles.position), ze.styles.size !== void 0 && "size" in wt && (wt.size = ze.styles.size);
              } catch (Pt) {
                u.error(Pt);
              }
              return wt.onenter = function() {
                lt.mode === t.Z.TEXT_SHOWING && g.trigger(n.Z.CAPTION_RENDERED, { currentTrackIdx: y });
              }, wt;
            }
            function rt(ze) {
              return ze.type === "html";
            }
            function at(ze, Et) {
              return rt(ze) ? function(lt, wt) {
                var Pt = new _(lt.start + wt, lt.end + wt, "");
                return Pt.cueHTMLElement = lt.cueHTMLElement, Pt.isd = lt.isd, Pt.images = lt.images, Pt.embeddedImages = lt.embeddedImages, Pt.cueID = lt.cueID, Pt.scaleCue = X.bind(self), Pt.cellResolution = lt.cellResolution, Pt.lineHeight = lt.lineHeight, Pt.linePadding = lt.linePadding, Pt.fontSize = lt.fontSize, Pt.isd && Te(Pt, Pt.isd.contents), Pt;
              }(ze, Et) : function(lt, wt) {
                var Pt = new _(lt.start - wt, lt.end - wt, lt.data);
                return Pt.cueID = "".concat(Pt.startTime, "_").concat(Pt.endTime), Pt;
              }(ze, Et);
            }
            function Bt(ze) {
              if (H) for (var Et = H.childNodes, lt = 0; lt < Et.length; ++lt) Et[lt].id === ze.cueID && (H.removeChild(Et[lt]), --lt);
            }
            function Re() {
              var ze, Et = [], lt = function(Pt, $t) {
                var Qt;
                if (typeof Symbol > "u" || Pt[Symbol.iterator] == null) {
                  if (Array.isArray(Pt) || (Qt = function(Vt, Xt) {
                    if (Vt) {
                      if (typeof Vt == "string") return Us(Vt, Xt);
                      var We = Object.prototype.toString.call(Vt).slice(8, -1);
                      return We === "Object" && Vt.constructor && (We = Vt.constructor.name), We === "Map" || We === "Set" ? Array.from(Vt) : We === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(We) ? Us(Vt, Xt) : void 0;
                    }
                  }(Pt)) || $t) {
                    Qt && (Pt = Qt);
                    var en = 0, ln = function() {
                    };
                    return { s: ln, n: function() {
                      return en >= Pt.length ? { done: !0 } : { done: !1, value: Pt[en++] };
                    }, e: function(Vt) {
                      throw Vt;
                    }, f: ln };
                  }
                  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }
                var pt, kt = !0, qt = !1;
                return { s: function() {
                  Qt = Pt[Symbol.iterator]();
                }, n: function() {
                  var Vt = Qt.next();
                  return kt = Vt.done, Vt;
                }, e: function(Vt) {
                  qt = !0, pt = Vt;
                }, f: function() {
                  try {
                    kt || Qt.return == null || Qt.return();
                  } finally {
                    if (qt) throw pt;
                  }
                } };
              }(x.getTextTracks());
              try {
                for (lt.s(); !(ze = lt.n()).done; ) {
                  var wt = ze.value;
                  wt.manualMode === t.Z.TEXT_SHOWING && Et.push(wt);
                }
              } catch (Pt) {
                lt.e(Pt);
              } finally {
                lt.f();
              }
              return Et;
            }
            function He(ze) {
              return ze >= 0 && w[ze] ? x.getTextTrack(w[ze].kind, w[ze].id, w[ze].lang, w[ze].isTTML, w[ze].isEmbedded) : null;
            }
            function yt(ze) {
              var Et = this;
              if (ze !== y) {
                var lt = He(y = ze);
                Qe.call(this, lt), G && (clearInterval(G), G = null), lt && lt.renderingType === "html" && (oe.call(this, lt, !0), window.ResizeObserver ? (j = new window.ResizeObserver(function() {
                  oe.call(Et, lt, !0);
                })).observe(x.getElement()) : G = setInterval(oe.bind(this, lt), 500));
              }
            }
            function Qe(ze) {
              yn.call(this), ze && ze.renderingType === "html" ? zt.call(this) : hn.call(this);
            }
            function Tt(ze, Et) {
              if (!ze.cues) return !1;
              for (var lt = 0; lt < ze.cues.length; lt++) if (ze.cues[lt].startTime === Et.startTime && ze.cues[lt].endTime === Et.endTime) return !0;
              return !1;
            }
            function vt(ze, Et, lt) {
              var wt = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
              return !!ze && (isNaN(Et) || (wt ? ze.startTime : ze.endTime) >= Et) && (isNaN(lt) || (wt ? ze.endTime : ze.startTime) <= lt);
            }
            function mt(ze, Et, lt) {
              var wt, Pt;
              if (!(lt < Et) && ze && (ze.cues || ze.manualCueList)) {
                var $t = ze.cues && ze.cues.length > 0 ? "native" : "custom", Qt = $t === "native" ? ze.cues : ze.manualCueList;
                if (!Qt || Qt.length === 0) return;
                for (var en = Qt.length - 1; en >= 0; en--) !vt(Qt[en], Et, lt, !0) || (wt = Qt[en], Pt = x.getTime(), wt.startTime >= Pt && wt.endTime <= Pt) || ($t === "native" ? ze.removeCue(Qt[en]) : (Bt(Qt[en]), delete ze.manualCueList[en]));
              }
            }
            function Wt(ze, Et, lt) {
              var wt = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
              if (ze && (ze.cues || ze.manualCueList)) {
                var Pt = ze.cues && ze.cues.length > 0 ? "native" : "custom", $t = Pt === "native" ? ze.cues : ze.manualCueList;
                if (!$t || $t.length === 0) return;
                for (var Qt = $t.length - 1, en = Qt; en >= 0; en--) vt($t[en], Et, lt, wt) && (Pt === "native" ? ($t[en].onexit && $t[en].onexit(), ze.removeCue($t[en])) : (Bt($t[en]), delete ze.manualCueList[en]));
              }
            }
            function zt() {
              var ze = document.getElementById("native-cue-style");
              if (!ze) {
                (ze = document.createElement("style")).id = "native-cue-style", document.head.appendChild(ze);
                var Et = ze.sheet, lt = x.getElement();
                try {
                  lt && (lt.id ? Et.insertRule("#" + lt.id + "::cue {background: transparent}", 0) : lt.classList.length !== 0 ? Et.insertRule("." + lt.className + "::cue {background: transparent}", 0) : Et.insertRule("video::cue {background: transparent}", 0));
                } catch (wt) {
                  u.info("" + wt.message);
                }
              }
            }
            function hn() {
              var ze = document.getElementById("native-cue-style");
              ze && document.head.removeChild(ze);
            }
            function yn() {
              if (M) for (; M.firstChild; ) M.removeChild(M.firstChild);
            }
            return r = { initialize: function() {
              typeof window < "u" && typeof navigator < "u" && (_ = window.VTTCue || window.TextTrackCue, w = [], I = [], y = -1, N = 0, Z = 0, Y = 0, V = 0, M = null, H = null, G = null, ae = !1, Ee = 2147483647, he = null, ue = "requestAnimationFrame" in window, document.fullscreenElement !== void 0 ? pe = "fullscreenElement" : document.webkitIsFullScreen !== void 0 ? pe = "webkitIsFullScreen" : document.msFullscreenElement ? pe = "msFullscreenElement" : document.mozFullScreen && (pe = "mozFullScreen"));
            }, getStreamId: function() {
              return O.id;
            }, addTextTrack: function(ze) {
              w.push(ze);
            }, addCaptions: Fe, createTracks: function() {
              var ze = L.get().streaming.text.dispatchForManualRendering;
              w.sort(function(Xt, We) {
                return Xt.index - We.index;
              }), M = x.getTTMLRenderingDiv(), H = x.getVttRenderingDiv();
              for (var Et, lt, wt, Pt, $t, Qt, en = -1, ln = 0; ln < w.length; ln++) {
                var pt = (lt = (Et = w[ln]).kind, wt = Et.id !== void 0 ? Et.id : Et.lang, Pt = Et.lang, $t = Et.isTTML, Qt = Et.isEmbedded, x.addTextTrack(lt, wt, Pt, $t, Qt));
                I.push(pt), w[ln].defaultTrack && (pt.default = !0, en = ln);
                var kt = He(ln);
                kt && (kt.mode = t.Z.TEXT_SHOWING, M && (w[ln].isTTML || w[ln].isEmbedded) ? kt.renderingType = "html" : kt.renderingType = "default"), Fe(ln, 0, w[ln].captionData), g.trigger(n.Z.TEXT_TRACK_ADDED);
              }
              if (yt.call(this, en), en >= 0) {
                g.on(n.Z.PLAYBACK_METADATA_LOADED, function Xt() {
                  var We = He(en);
                  We && We.renderingType === "html" && oe.call(this, We, !0), g.off(n.Z.PLAYBACK_METADATA_LOADED, Xt, this);
                }, this);
                for (var qt = 0; qt < w.length; qt++) {
                  var Vt = He(qt);
                  Vt && (Vt.mode = qt !== en || ze ? t.Z.TEXT_HIDDEN : t.Z.TEXT_SHOWING, Vt.manualMode = qt === en ? t.Z.TEXT_SHOWING : t.Z.TEXT_HIDDEN);
                }
              }
              g.trigger(o.Z.TEXT_TRACKS_QUEUE_INITIALIZED, { index: y, tracks: w, streamId: O.id });
            }, getCurrentTrackIdx: function() {
              return y;
            }, setCurrentTrackIdx: yt, getTrackIdxForId: function(ze) {
              for (var Et = -1, lt = 0; lt < w.length; lt++) if (w[lt].id === ze) {
                Et = lt;
                break;
              }
              return Et;
            }, getCurrentTrackInfo: function() {
              return w[y];
            }, setModeForTrackIdx: function(ze, Et) {
              var lt = He(ze);
              lt && lt.mode !== Et && (lt.mode = Et), lt && lt.manualMode !== Et && (lt.manualMode = Et);
            }, deleteCuesFromTrackIdx: function(ze, Et, lt) {
              var wt = He(ze);
              wt && Wt(wt, Et, lt);
            }, deleteAllTextTracks: function() {
              for (var ze = I ? I.length : 0, Et = 0; Et < ze; Et++) {
                var lt = He(Et);
                lt && Wt.call(this, lt, O.start, O.start + O.duration, !1);
              }
              I = [], w = [], G && (clearInterval(G), G = null), j && x && (j.unobserve(x.getElement()), j = null), y = -1, yn.call(this);
            }, manualCueProcessing: function(ze) {
              var Et = Re();
              if (Et.length > 0) {
                var lt = Et[0].manualCueList;
                lt && lt.length > 0 && lt.forEach(function(wt) {
                  wt.startTime <= ze && wt.endTime >= ze && !wt.isActive ? (wt.isActive = !0, L.get().streaming.text.dispatchForManualRendering ? ke(wt) : WebVTT.processCues(window, [wt], H, wt.cueID)) : wt.isActive && (wt.startTime > ze || wt.endTime < ze) && (wt.isActive = !1, L.get().streaming.text.dispatchForManualRendering ? Le(wt) : Bt(wt));
                });
              }
            }, disableManualTracks: function() {
              var ze = Re();
              if (ze.length > 0) {
                var Et = ze[0].manualCueList;
                Et && Et.length > 0 && Et.forEach(function(lt) {
                  if (lt.isActive) {
                    if (lt.isActive = !1, L.get().streaming.text.dispatchForManualRendering) Le(lt);
                    else if (H) for (var wt = H.childNodes, Pt = 0; Pt < wt.length; ++Pt) wt[Pt].id === lt.cueID && (H.removeChild(wt[Pt]), --Pt);
                  }
                });
              }
            } }, u = (0, m.Z)(me).getInstance().getLogger(r), r;
          }
          Gs.__dashjs_factory_name = "TextTracks";
          var Ic = v.Z.getClassFactory(Gs);
          function Hs() {
            var i, r, u, _, w, I, y = this.context;
            function N(M) {
              var H = M.split(":"), G = H.length - 1;
              return M = 60 * parseInt(H[G - 1], 10) + parseFloat(H[G]), G === 2 && (M += 3600 * parseInt(H[0], 10)), M;
            }
            function Z(M) {
              var H = M.split(_), G = H[1].split(I);
              return G.shift(), H[1] = G[0], G.shift(), { cuePoints: H, styles: Y(G) };
            }
            function Y(M) {
              var H = {};
              return M.forEach(function(G) {
                if (G.split(/:/).length > 1) {
                  var pe = G.split(/:/)[1], ae = !1;
                  pe && pe.search(/%/) != -1 && (ae = !0, pe = parseInt(pe.replace(/%/, ""), 10)), (G.match(/align/) || G.match(/A/)) && (H.align = pe), (G.match(/line/) || G.match(/L/)) && (H.line = pe === "auto" ? pe : parseInt(pe, 10), ae && (H.snapToLines = !1)), (G.match(/position/) || G.match(/P/)) && (H.position = pe), (G.match(/size/) || G.match(/S/)) && (H.size = pe);
                }
              }), H;
            }
            function V(M, H) {
              for (var G, pe = H, ae = "", he = ""; M[pe] !== "" && pe < M.length; ) pe++;
              if ((G = pe - H) > 1) for (var Ee = 0; Ee < G; Ee++) {
                if ((he = M[H + Ee]).match(_)) {
                  ae = "";
                  break;
                }
                ae += he, Ee !== G - 1 && (ae += `
`);
              }
              else (he = M[H]).match(_) || (ae = he);
              return ae;
            }
            return i = { parse: function(M) {
              var H, G, pe = [];
              if (!M) return pe;
              H = (M = M.split(u)).length, G = -1;
              for (var ae = 0; ae < H; ae++) {
                var he = M[ae];
                if (he.length > 0 && he !== "WEBVTT" && he.match(_)) {
                  var Ee = Z(he), j = Ee.cuePoints, ue = Ee.styles, z = V(M, ae + 1), me = N(j[0].replace(w, "")), g = N(j[1].replace(w, ""));
                  !isNaN(me) && !isNaN(g) && me >= G && g > me ? z !== "" ? (G = me, pe.push({ start: me, end: g, data: z, styles: ue })) : r.error("Skipping cue due to empty/malformed cue text") : r.error("Skipping cue due to incorrect cue timing");
                }
              }
              return pe;
            }, getCaptionStyles: Y }, r = (0, m.Z)(y).getInstance().getLogger(i), u = /(?:\r\n|\r|\n)/gm, _ = /-->/, w = /(^[\s]+|[\s]+$)/g, I = /\s\b/g, i;
          }
          Hs.__dashjs_factory_name = "VTTParser";
          var Cc = v.Z.getSingletonFactory(Hs);
          function qs() {
            var i, r;
            return i = { parse: function(u) {
              var _ = [];
              return r.oncue = function(w) {
                w.start = w.startTime, w.end = w.endTime, w.data = w.text, w.styles = { align: w.align, line: w.line, position: w.position, size: w.size }, _.push(w);
              }, r.parse(u), _;
            } }, function() {
              try {
                window && window.WebVTT && window.WebVTT.Parser && (r = new window.WebVTT.Parser(window, window.vttjs, window.WebVTT.StringDecoder()));
              } catch {
              }
            }(), i;
          }
          qs.__dashjs_factory_name = "VttCustomRenderingParser";
          var wc = v.Z.getSingletonFactory(qs);
          function Vs() {
            var i, r, u = this.context, _ = (0, p.Z)(u).getInstance(), w = 0;
            return i = { parse: function(I, y, N, Z, Y) {
              var V, M, H, G = "", pe = [], ae = {}, he = {}, Ee = "", j = "", ue = { onOpenTag: function(O, L, A) {
                if (A[" imagetype"] && !A[" imageType"] && (_.trigger(n.Z.CONFORMANCE_VIOLATION, { level: pi.LEVELS.ERROR, event: pi.EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE }), A[" imageType"] = A[" imagetype"]), L === "image" && (O === "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt" || O === "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt")) {
                  if (!A[" imageType"] || A[" imageType"].value !== "PNG") return void r.warn("smpte-tt imageType != PNG. Discarded");
                  Ee = A["http://www.w3.org/XML/1998/namespace id"].value;
                }
              }, onCloseTag: function() {
                Ee && (he[Ee] = j.trim()), j = "", Ee = "";
              }, onText: function(O) {
                Ee && (j += O);
              } };
              if (!I) throw G = "no ttml data to parse", new Error(G);
              ae.data = I, _.trigger(o.Z.TTML_TO_PARSE, ae);
              var z = (0, ho.fromXML)(ae.data, function(O) {
                G = O;
              }, ue);
              _.trigger(o.Z.TTML_PARSED, { ttmlString: ae.data, ttmlDoc: z });
              var me, g = z.getMediaTimeEvents();
              for (H = 0; H < g.length; H++) {
                var x = (0, ho.generateISD)(z, g[H], function(O) {
                  G = O;
                });
                x.contents.some(function(O) {
                  return O.contents.length;
                }) && (V = g[H] + y) < (M = g[H + 1] + y) && pe.push({ start: V, end: M, type: "html", cueID: (me = "cue_TTML_" + w, w++, me), isd: x, images: Y, embeddedImages: he });
              }
              if (G !== "") throw r.error(G), new Error(G);
              return pe;
            } }, r = (0, m.Z)(u).getInstance().getLogger(i), i;
          }
          Vs.__dashjs_factory_name = "TTMLParser";
          var Rc = v.Z.getSingletonFactory(Vs);
          function js(i, r) {
            var u = Object.keys(i);
            if (Object.getOwnPropertySymbols) {
              var _ = Object.getOwnPropertySymbols(i);
              r && (_ = _.filter(function(w) {
                return Object.getOwnPropertyDescriptor(i, w).enumerable;
              })), u.push.apply(u, _);
            }
            return u;
          }
          function Ys(i) {
            for (var r = 1; r < arguments.length; r++) {
              var u = arguments[r] != null ? arguments[r] : {};
              r % 2 ? js(Object(u), !0).forEach(function(_) {
                Nc(i, _, u[_]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(u)) : js(Object(u)).forEach(function(_) {
                Object.defineProperty(i, _, Object.getOwnPropertyDescriptor(u, _));
              });
            }
            return i;
          }
          function Nc(i, r, u) {
            return r in i ? Object.defineProperty(i, r, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : i[r] = u, i;
          }
          function Ks(i, r) {
            (r == null || r > i.length) && (r = i.length);
            for (var u = 0, _ = new Array(r); u < r; u++) _[u] = i[u];
            return _;
          }
          function zs(i) {
            var r, u, _, w = this.context, I = (0, p.Z)(w).getInstance(), y = (0, $e.Z)(w).getInstance(), N = i.adapter, Z = i.baseURLController;
            function Y(H, G) {
              var pe, ae, he = !1;
              if (Z.resolve()) {
                var Ee = N.getVoRepresentations(H);
                Ee && Ee.length > 0 && (pe = Z.resolve(Ee[0].path).url);
              }
              var j = H.essentialPropertiesAsArray.filter(function(z) {
                return z.schemeIdUri && z.schemeIdUri === t.Z.FONT_DOWNLOAD_DVB_SCHEME;
              }), ue = H.supplementalPropertiesAsArray.filter(function(z) {
                return z.schemeIdUri && z.schemeIdUri === t.Z.FONT_DOWNLOAD_DVB_SCHEME;
              });
              j.length > 0 ? (he = !0, ae = j) : ae = ue, ae.forEach(function(z) {
                if (function(O) {
                  return !(!(O.value && O.value === "1" && O.dvbUrl && O.dvbUrl.length > 0 && O.dvbFontFamily && O.dvbFontFamily.length > 0 && O.dvbMimeType) || O.dvbMimeType !== t.Z.OFF_MIMETYPE && O.dvbMimeType !== t.Z.WOFF_MIMETYPE);
                }(z)) {
                  var me = (g = z.dvbUrl, x = pe, y.isPathAbsolute(g) ? g : y.isRelative(g) ? x ? y.resolve(g, x) : y.resolve(g) : g);
                  _.push({ fontFamily: z.dvbFontFamily, url: me, mimeType: z.dvbMimeType, trackId: H.id, streamId: G, isEssential: he, status: "unloaded", fontFace: new FontFace(z.dvbFontFamily, "url(".concat(me, ")"), { display: "swap" }) });
                }
                var g, x;
              });
            }
            function V(H, G) {
              var pe = _[H];
              _[H] = Ys(Ys({}, pe), {}, { status: G });
            }
            function M() {
              _ = [];
            }
            return r = { addFontsFromTracks: function(H, G) {
              if (H && Array.isArray(H) && G) for (var pe = 0; pe < H.length; pe++) Y(H[pe], G);
            }, downloadFonts: function() {
              for (var H = function(pe) {
                var ae = _[pe];
                document.fonts.add(ae.fontFace), I.trigger(n.Z.DVB_FONT_DOWNLOAD_ADDED, ae), ae.fontFace.load().then(function() {
                  V(pe, "loaded"), I.trigger(n.Z.DVB_FONT_DOWNLOAD_COMPLETE, ae);
                }, function(he) {
                  V(pe, "error"), u.debug("Font download error: ", he), I.trigger(n.Z.DVB_FONT_DOWNLOAD_FAILED, ae);
                });
              }, G = 0; G < _.length; G++) H(G);
            }, getFonts: function() {
              return _;
            }, getFontsForTrackId: function(H) {
              return _.filter(function(G) {
                return G.trackId && G.trackId === H;
              });
            }, reset: function() {
              (function() {
                var H, G = function(he, Ee) {
                  var j;
                  if (typeof Symbol > "u" || he[Symbol.iterator] == null) {
                    if (Array.isArray(he) || (j = function(O, L) {
                      if (O) {
                        if (typeof O == "string") return Ks(O, L);
                        var A = Object.prototype.toString.call(O).slice(8, -1);
                        return A === "Object" && O.constructor && (A = O.constructor.name), A === "Map" || A === "Set" ? Array.from(O) : A === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(A) ? Ks(O, L) : void 0;
                      }
                    }(he)) || Ee) {
                      j && (he = j);
                      var ue = 0, z = function() {
                      };
                      return { s: z, n: function() {
                        return ue >= he.length ? { done: !0 } : { done: !1, value: he[ue++] };
                      }, e: function(O) {
                        throw O;
                      }, f: z };
                    }
                    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                  }
                  var me, g = !0, x = !1;
                  return { s: function() {
                    j = he[Symbol.iterator]();
                  }, n: function() {
                    var O = j.next();
                    return g = O.done, O;
                  }, e: function(O) {
                    x = !0, me = O;
                  }, f: function() {
                    try {
                      g || j.return == null || j.return();
                    } finally {
                      if (x) throw me;
                    }
                  } };
                }(_);
                try {
                  for (G.s(); !(H = G.n()).done; ) {
                    var pe = H.value, ae = document.fonts.delete(pe.fontFace);
                    u.debug("Removal of fontFamily: ".concat(pe.fontFamily, " was ").concat(ae ? "successful" : "unsuccessful"));
                  }
                } catch (he) {
                  G.e(he);
                } finally {
                  G.f();
                }
              })(), M();
            } }, u = (0, m.Z)(w).getInstance().getLogger(r), M(), r;
          }
          zs.__dashjs_factory_name = "DVBFonts";
          var Dc = v.Z.getClassFactory(zs);
          function Ws(i) {
            var r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae = this.context, he = i.adapter, Ee = i.errHandler, j = i.manifestModel, ue = i.mediaController, z = i.baseURLController, me = i.videoModel, g = i.settings;
            function x(re) {
              if (pe.error("Could not download ".concat(re.isEssential ? "an essential" : "a", " font - fontFamily: ").concat(re.fontFamily, ", url: ").concat(re.url)), re.isEssential) {
                var Te = w[re.streamId].getTrackIdxForId(re.trackId);
                w[re.streamId].setModeForTrackIdx(Te, t.Z.TEXT_DISABLED);
              }
            }
            function O(re) {
              if (pe.debug("Successfully downloaded ".concat(re.isEssential ? "an essential" : "a", " font - fontFamily: ").concat(re.fontFamily, ", url: ").concat(re.url)), re.isEssential) {
                var Te = w[re.streamId].getTrackIdxForId(re.trackId);
                Te === w[re.streamId].getCurrentTrackIdx() ? w[re.streamId].setModeForTrackIdx(Te, t.Z.TEXT_SHOWING) : w[re.streamId].setModeForTrackIdx(Te, t.Z.TEXT_HIDDEN);
              }
            }
            function L(re) {
              var Te = re.tracks, Fe = re.index, De = re.streamId;
              if (g.get().streaming.text.defaultEnabled === !1 && !X() || H) de(De, -1);
              else {
                var ke = ue.getCurrentTrackFor(t.Z.TEXT, De);
                if (ke) {
                  var Le = { lang: ke.lang, role: ke.roles[0], index: ke.index, codec: ke.codec, accessibility: ke.accessibility[0] };
                  Te.some(function(ut, ct) {
                    if (ue.matchSettings(Le, ut)) return de(De, ct), Fe = ct, !0;
                  });
                }
                Y = !1;
              }
              u[De].lastEnabledIndex = Fe, Z.trigger(n.Z.TEXT_TRACKS_ADDED, { enabled: X(), index: Fe, tracks: Te, streamId: De }), M = !0, G.addFontsFromTracks(Te, De), G.getFonts().forEach(function(ut) {
                if (ut.isEssential) {
                  var ct = w[ut.streamId].getTrackIdxForId(ut.trackId);
                  w[ut.streamId].setModeForTrackIdx(ct, t.Z.TEXT_DISABLED);
                }
              }), G.downloadFonts();
            }
            function A(re) {
              try {
                var Te = re.streamId;
                if (!w[Te] || isNaN(re.time)) return;
                w[Te].manualCueProcessing(re.time);
              } catch {
              }
            }
            function oe(re) {
              try {
                var Te = re.streamId;
                if (!w[Te]) return;
                w[Te].disableManualTracks();
              } catch {
              }
            }
            function X() {
              var re = !0;
              return Y && !V && (re = !1), re;
            }
            function de(re, Te) {
              (Y = Te === -1) && ue && ue.saveTextSettingsDisabled();
              var Fe = ne(re);
              if (Fe !== Te && w[re]) {
                w[re].disableManualTracks();
                var De = w[re].getCurrentTrackInfo(), ke = De ? me.getTextTrack(De.kind, De.id, De.lang, De.isTTML, De.isEmbedded) : null;
                ke && ke.mode !== t.Z.TEXT_DISABLED && w[re].setModeForTrackIdx(Fe, t.Z.TEXT_HIDDEN), w[re].setCurrentTrackIdx(Te), De = w[re].getCurrentTrackInfo();
                var Le = g.get().streaming.text.dispatchForManualRendering;
                De && !Le && De.mode !== t.Z.TEXT_DISABLED && w[re].setModeForTrackIdx(Te, t.Z.TEXT_SHOWING), De && De.isFragmented && !De.isEmbedded ? function(ut, ct, rt) {
                  if (_[ut]) for (var at = _[ut].getConfig().fragmentedTracks, Bt = 0; Bt < at.length; Bt++) {
                    var Re = at[Bt];
                    if (ct.lang === Re.lang && (Re.id ? ct.id === Re.id : ct.index === Re.index)) {
                      var He = ue.getCurrentTrackFor(t.Z.TEXT, ut);
                      (Re.id ? He.id !== Re.id : He.index !== Re.index) ? (w[ut].deleteCuesFromTrackIdx(rt), _[ut].setCurrentFragmentedTrackIdx(Bt)) : rt === -1 && Z.trigger(o.Z.SET_FRAGMENTED_TEXT_AFTER_DISABLED, {}, { streamId: ut, mediaType: t.Z.TEXT });
                    }
                  }
                }(re, De, Fe) : De && !De.isFragmented && function(ut, ct) {
                  Z.trigger(o.Z.SET_NON_FRAGMENTED_TEXT, { currentTrackInfo: ct }, { streamId: ut, mediaType: t.Z.TEXT });
                }(re, De), ue.setTrack(De);
              }
            }
            function ne(re) {
              return w[re].getCurrentTrackIdx();
            }
            function U() {
              _ = {}, w = {}, u = {}, Y = !0, M = !1, H = !1;
            }
            return r = { deactivateStream: function(re) {
              if (re) {
                var Te = re.id;
                _[Te] && _[Te].resetMediaInfos(), w[Te] && w[Te].deleteAllTextTracks();
              }
            }, initialize: function() {
              G = Dc(ae).create({ adapter: he, baseURLController: z }), Z.on(o.Z.TEXT_TRACKS_QUEUE_INITIALIZED, L, r), Z.on(o.Z.DVB_FONT_DOWNLOAD_FAILED, x, r), Z.on(o.Z.DVB_FONT_DOWNLOAD_COMPLETE, O, r), g.get().streaming.text.webvtt.customRenderingEnabled && (Z.on(o.Z.PLAYBACK_TIME_UPDATED, A, r), Z.on(o.Z.PLAYBACK_SEEKING, oe, r));
            }, initializeForStream: function(re) {
              var Te = re.id, Fe = Ic(ae).create({ videoModel: me, settings: g, streamInfo: re });
              Fe.initialize(), w[Te] = Fe;
              var De = Sc(ae).create({ errHandler: Ee, adapter: he, dvbFonts: G, manifestModel: j, mediaController: ue, videoModel: me, textTracks: Fe, vttParser: I, vttCustomRenderingParser: y, ttmlParser: N, streamInfo: re, settings: g });
              De.initialize(), _[Te] = De, u[Te] = {}, u[Te].lastEnabledIndex = -1;
            }, createTracks: function(re) {
              var Te = re.id;
              w[Te] && w[Te].createTracks();
            }, getTextSourceBuffer: function(re) {
              var Te = re.id;
              if (_ && _[Te]) return _[Te];
            }, getAllTracksAreDisabled: function() {
              return Y;
            }, addEmbeddedTrack: function(re, Te) {
              var Fe = re.id;
              _[Fe] && _[Fe].addEmbeddedTrack(Te);
            }, enableText: function(re, Te) {
              return (0, $.PS)(Te, "boolean"), X() !== Te && (Te && de(re, u[re].lastEnabledIndex), Te || (u[re].lastEnabledIndex = ne(re), M ? de(re, -1) : H = !0)), !0;
            }, isTextEnabled: X, setTextTrack: de, getCurrentTrackIdx: ne, enableForcedTextStreaming: function(re) {
              return (0, $.PS)(re, "boolean"), V = re, !0;
            }, addMediaInfosToBuffer: function(re, Te, Fe) {
              var De = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, ke = re.id;
              _[ke] && _[ke].addMediaInfos(Te, Fe, De);
            }, reset: function() {
              G.reset(), U(), Z.off(o.Z.TEXT_TRACKS_QUEUE_INITIALIZED, L, r), Z.off(o.Z.DVB_FONT_DOWNLOAD_FAILED, x, r), Z.off(o.Z.DVB_FONT_DOWNLOAD_COMPLETE, O, r), g.get().streaming.text.webvtt.customRenderingEnabled && (Z.off(o.Z.PLAYBACK_TIME_UPDATED, A, r), Z.off(o.Z.PLAYBACK_SEEKING, oe, r)), Object.keys(_).forEach(function(re) {
                _[re].resetEmbedded(), _[re].reset();
              });
            } }, V = !1, M = !1, H = !1, I = Cc(ae).getInstance(), y = wc(ae).getInstance(), N = Rc(ae).getInstance(), Z = (0, p.Z)(ae).getInstance(), pe = (0, m.Z)(ae).getInstance().getLogger(r), U(), r;
          }
          Ws.__dashjs_factory_name = "TextController";
          var Mc = v.Z.getClassFactory(Ws);
          function mo() {
            var i, r, u, _, w, I, y, N, Z, Y, V, M, H, G, pe, ae, he, Ee, j, ue, z, me, g, x, O, L, A, oe, X, de, ne, U, re, Te, Fe, De, ke, Le, ut, ct = "You must first call initialize() and set a source before calling this method", rt = "You must first call initialize() and set a valid source and view before calling this method", at = "You must first call attachView() to set the video element before calling this method", Bt = "You must first call attachSource() with a valid source before calling this method", Re = "MediaPlayer not initialized!", He = this.context, yt = (0, p.Z)(He).getInstance(), Qe = (0, Oe.Z)(He).getInstance(), Tt = (0, m.Z)(He).getInstance({ settings: Qe });
            function vt() {
              ln(null), Qt(null), _ = null, G && (G.reset(), G = null), pe && (pe.reset(), pe = null), ue && ue.reset(), Qe.reset(), he && (he.reset(), he = null);
            }
            function mt() {
              return !!u && !!De.getElement();
            }
            function Wt() {
              return (0, Yu.e)();
            }
            function zt() {
              if (!y) throw rt;
              return oe.isPaused();
            }
            function hn() {
              if (!y) throw rt;
              return oe.getIsDynamic();
            }
            function yn(ye) {
              var Ae = O && O.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, tt = U.getCurrentDVRInfo(Ae);
              if (!tt) return 0;
              var Nt = oe.getOriginalLiveDelay(), xt = tt.range.start + ye;
              return xt > tt.range.end - Nt && (xt = tt.range.end - Nt), xt;
            }
            function ze(ye) {
              if (!y) throw rt;
              var Ae = $t().currentTime;
              if (ye !== void 0) Ae = O.getTimeRelativeToStreamId(Ae, ye);
              else if (oe.getIsDynamic()) {
                var tt = O && O.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Nt = U.getCurrentDVRInfo(tt);
                Ae = Nt === null || Ae === 0 ? 0 : Math.max(0, Ae - Nt.range.start);
              }
              return Ae;
            }
            function Et() {
              if (!y) throw rt;
              var ye = $t().duration;
              if (oe.getIsDynamic()) {
                var Ae = O && O.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, tt = U.getCurrentDVRInfo(Ae);
                ye = tt ? tt.range.end - tt.range.start : 0;
              }
              return ye;
            }
            function lt(ye) {
              (0, $.PS)(ye, "boolean"), N = ye;
            }
            function wt() {
              ue.restoreDefaultUTCTimingSources();
            }
            function Pt() {
              return U;
            }
            function $t() {
              if (!De.getElement()) throw at;
              return De.getElement();
            }
            function Qt(ye) {
              if (!w) throw Re;
              De.setElement(ye), ye && (Xt(), function() {
                if (!pe) {
                  var Ae = dashjs.MetricsReporting;
                  if (typeof Ae == "function") {
                    var tt = Ae(He).create();
                    pe = tt.createMetricsReporting({ debug: Tt, eventBus: yt, mediaElement: $t(), adapter: Ee, dashMetrics: U, mediaPlayerModel: j, events: o.Z, constants: t.Z, metricsConstants: h.Z });
                  }
                }
              }(), function() {
                if (!ae) {
                  var Ae = dashjs.MssHandler;
                  typeof Ae == "function" && (ee.extend(Ae.errors), ae = Ae(He).create({ eventBus: yt, mediaPlayerModel: j, dashMetrics: U, manifestModel: re, playbackController: oe, streamController: O, protectionController: G, baseURLController: me, errHandler: z, events: o.Z, constants: t.Z, debug: Tt, initSegmentType: Ge.w.INIT_SEGMENT_TYPE, BASE64: co, ISOBoxer: oa, settings: Qe }));
                }
              }(), O && O.switchToVideoElement(Z)), y && kt(), ft(Z);
            }
            function en(ye) {
              if (!I) throw ct;
              var Ae = O.getActiveStreamInfo();
              return Ae ? H.getTracksFor(ye, Ae.id) : [];
            }
            function ln(ye) {
              var Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              if (!w) throw Re;
              typeof ye == "string" && ke.initialize(ye), Ae == null && (Ae = NaN), isNaN(Ae) || (Ae = Math.max(0, Ae)), Z = Ae, u = ye, (I || y) && kt(), mt() && ft(Z);
            }
            function pt() {
              if (!I) throw ct;
              var ye = O.getActiveStreamInfo();
              return ye ? O.getStreamById(ye.id) : null;
            }
            function kt() {
              y = !1, I = !1, Ee.reset(), O.reset(), A.reset(), ne.reset(), oe.reset(), X.reset(), de.reset(), Y.reset(), H.reset(), ut.reset(), G && (Qe.get().streaming.protection.keepProtectionMediaKeys ? G.stop() : (G.reset(), G = null, Xt())), L.reset(), Te.reset(), Fe.reset();
            }
            function qt() {
              var ye = Vt();
              O || (O = Zo(He).getInstance()), L || (L = Mc(He).create({ errHandler: z, manifestModel: re, adapter: Ee, mediaController: H, baseURLController: me, videoModel: De, settings: Qe })), x.setConfig({ capabilities: g, customParametersModel: ue, adapter: Ee, settings: Qe, manifestModel: re, errHandler: z }), O.setConfig({ capabilities: g, capabilitiesFilter: x, manifestLoader: ye, manifestModel: re, mediaPlayerModel: j, customParametersModel: ue, protectionController: G, textController: L, adapter: Ee, dashMetrics: U, errHandler: z, timelineConverter: M, videoModel: De, playbackController: oe, serviceDescriptionController: X, contentSteeringController: de, abrController: Y, mediaController: H, settings: Qe, baseURLController: me, uriFragmentModel: ke, segmentBaseController: ut }), A.setConfig({ settings: Qe, playbackController: oe, streamController: O, videoModel: De, timelineConverter: M, adapter: Ee }), oe.setConfig({ streamController: O, serviceDescriptionController: X, dashMetrics: U, adapter: Ee, videoModel: De, timelineConverter: M, settings: Qe }), ne.setConfig({ streamController: O, playbackController: oe, mediaPlayerModel: j, videoModel: De, settings: Qe }), Y.setConfig({ streamController: O, domStorage: Le, mediaPlayerModel: j, customParametersModel: ue, cmsdModel: Fe, dashMetrics: U, adapter: Ee, videoModel: De, settings: Qe }), Te.setConfig({ abrController: Y, dashMetrics: U, playbackController: oe }), Fe.setConfig({}), Y.initialize(), O.initialize(N, _), L.initialize(), A.initialize(), ne.initialize(), Te.initialize(), Fe.initialize(), de.initialize(), ut.initialize();
            }
            function Vt() {
              return Du(He).create({ debug: Tt, errHandler: z, dashMetrics: U, mediaPlayerModel: j, requestModifier: (0, Ie.Z)(He).getInstance(), mssHandler: ae, settings: Qe });
            }
            function Xt() {
              if (G) return G;
              var ye = dashjs.Protection;
              if (typeof ye == "function") {
                var Ae = ye(He).create();
                return o.Z.extend(ye.events), n.Z.extend(ye.events, { publicOnly: !0 }), ee.extend(ye.errors), g || (g = (0, us.Z)(He).getInstance()), G = Ae.createProtectionSystem({ debug: Tt, errHandler: z, videoModel: De, customParametersModel: ue, capabilities: g, eventBus: yt, events: o.Z, BASE64: co, constants: t.Z, cmcdModel: Te, settings: Qe });
              }
              return null;
            }
            function We() {
              if (!w) throw Re;
              if (he) return he;
              var ye = dashjs.OfflineController;
              if (typeof ye == "function") {
                o.Z.extend(ye.events), n.Z.extend(ye.events, { publicOnly: !0 }), ee.extend(ye.errors);
                var Ae = Vt(), tt = Po(He).create();
                return tt.setConfig({ manifestModel: re, adapter: Ee, manifestLoader: Ae, errHandler: z, contentSteeringController: de }), he = ye(He).create({ debug: Tt, manifestUpdater: tt, baseURLController: me, manifestLoader: Ae, manifestModel: re, mediaPlayerModel: j, abrController: Y, playbackController: oe, adapter: Ee, errHandler: z, dashMetrics: U, timelineConverter: M, segmentBaseController: ut, schemeLoaderFactory: V, eventBus: yt, events: o.Z, errors: ee, constants: t.Z, settings: Qe, dashConstants: e.Z, urlUtils: (0, $e.Z)(He).getInstance() });
              }
              return null;
            }
            function Pe(ye) {
              var Ae = O && O.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, tt = U.getCurrentDVRInfo(Ae);
              return tt ? ye + (tt.manifestInfo.availableFrom.getTime() / 1e3 + tt.range.start) : 0;
            }
            function ft() {
              var ye = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN;
              he && he.resetRecords(), !I && u && (I = !0, r.info("Streaming Initialized"), qt(), typeof u == "string" ? O.load(u, ye) : O.loadWithManifest(u, ye)), !y && mt() && (y = !0, r.info("Playback Initialized"));
            }
            return i = { initialize: function(ye, Ae, tt) {
              var Nt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : NaN;
              g || (g = (0, us.Z)(He).getInstance()).setConfig({ settings: Qe }), z || (z = Mu(He).getInstance()), g.supportsMediaSource() ? (w || (w = !0, M = _c(He).getInstance(), Y || (Y = Gu(He).getInstance()).setConfig({ settings: Qe }), V || (V = Xn(He).getInstance()), oe || (oe = f(He).getInstance()), H || (H = Jl(He).getInstance()), O || (O = Zo(He).getInstance()), A || (A = zl(He).getInstance()), ne || (ne = Wl(He).getInstance()), X || (X = Xl(He).getInstance()), de || (de = Or(He).getInstance()), x || (x = Ou(He).getInstance()), Ee = nc(He).getInstance(), re = xu(He).getInstance(), Te = pn(He).getInstance(), Fe = Ft(He).getInstance(), U = yc(He).getInstance({ settings: Qe }), Le = ju(He).getInstance({ settings: Qe }), Ee.setConfig({ constants: t.Z, cea608parser: E(), errHandler: z, BASE64: co }), me || (me = au(He).create()), me.setConfig({ adapter: Ee, contentSteeringController: de }), X.setConfig({ adapter: Ee }), ut || (ut = Wu(He).getInstance({ dashMetrics: U, mediaPlayerModel: j, errHandler: z, baseURLController: me, events: o.Z, eventBus: yt, debug: Tt, boxParser: (0, wi.Z)(He).getInstance(), requestModifier: (0, Ie.Z)(He).getInstance(), errors: ee })), H.setConfig({ domStorage: Le, settings: Qe, customParametersModel: ue }), j.setConfig({ playbackController: oe, serviceDescriptionController: X }), de.setConfig({ adapter: Ee, errHandler: z, dashMetrics: U, mediaPlayerModel: j, manifestModel: re, serviceDescriptionController: X, eventBus: yt, requestModifier: (0, Ie.Z)(He).getInstance() }), wt(), lt(tt === void 0 || tt), We()), ye && Qt(ye), Ae && ln(Ae, Nt), r.info("[dash.js " + Wt() + "] MediaPlayer has been initialized")) : z.error(new se.Z(ee.CAPABILITY_MEDIASOURCE_ERROR_CODE, ee.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE));
            }, setConfig: function(ye) {
              ye && (ye.capabilities && (g = ye.capabilities), ye.capabilitiesFilter && (x = ye.capabilitiesFilter), ye.streamController && (O = ye.streamController), ye.textController && (L = ye.textController), ye.gapController && (A = ye.gapController), ye.playbackController && (oe = ye.playbackController), ye.serviceDescriptionController && (X = ye.serviceDescriptionController), ye.contentSteeringController && (de = ye.contentSteeringController), ye.catchupController && (ne = ye.catchupController), ye.mediaPlayerModel && (j = ye.mediaPlayerModel), ye.customParametersModel && (ue = ye.customParametersModel), ye.abrController && (Y = ye.abrController), ye.schemeLoaderFactory && (V = ye.schemeLoaderFactory), ye.mediaController && (H = ye.mediaController), ye.settings && (Qe = ye.settings));
            }, on: function(ye, Ae, tt, Nt) {
              yt.on(ye, Ae, tt, Nt);
            }, off: function(ye, Ae, tt) {
              yt.off(ye, Ae, tt);
            }, extend: function(ye, Ae, tt) {
              v.Z.extend(ye, Ae, tt, He);
            }, attachView: Qt, attachSource: ln, refreshManifest: function(ye) {
              if (!w) throw Re;
              if (!mt()) return ye(null, Bt);
              var Ae = this;
              typeof ye == "function" && yt.on(o.Z.INTERNAL_MANIFEST_LOADED, function tt(Nt) {
                yt.off(o.Z.INTERNAL_MANIFEST_LOADED, tt, Ae), Nt.error ? ye(null, Nt.error) : ye(Nt.manifest);
              }, Ae), O.refreshManifest();
            }, isReady: mt, preload: function() {
              if (!De.getElement() && !I) {
                if (!u) throw Bt;
                ft(Z);
              }
            }, play: function() {
              if (!y) throw rt;
              (!N || zt() && y) && oe.play(!0);
            }, isPaused: zt, pause: function() {
              if (!y) throw rt;
              oe.pause();
            }, isSeeking: function() {
              if (!y) throw rt;
              return oe.isSeeking();
            }, isDynamic: hn, getLowLatencyModeEnabled: function() {
              if (!y) throw rt;
              return oe.getLowLatencyModeEnabled();
            }, seek: function(ye) {
              if (!y) throw rt;
              if ((0, $.PS)(ye, "number"), isNaN(ye)) throw t.Z.BAD_ARGUMENT_ERROR;
              ye < 0 && (ye = 0);
              var Ae = oe.getIsDynamic() ? yn(ye) : ye, tt = $t();
              !oe.getIsDynamic() && tt.duration && (Ae = Math.min(tt.duration, Ae)), oe.seek(Ae, !1, !1, !0);
            }, seekToOriginalLive: function() {
              y && hn() && oe.seekToOriginalLive();
            }, setPlaybackRate: function(ye) {
              $t().playbackRate = ye;
            }, getPlaybackRate: function() {
              return $t().playbackRate;
            }, setMute: function(ye) {
              (0, $.PS)(ye, "boolean"), $t().muted = ye;
            }, isMuted: function() {
              return $t().muted;
            }, setVolume: function(ye) {
              if (typeof ye != "number" || isNaN(ye) || ye < 0 || ye > 1) throw t.Z.BAD_ARGUMENT_ERROR;
              $t().volume = ye;
            }, getVolume: function() {
              return $t().volume;
            }, time: ze, duration: Et, timeAsUTC: function() {
              if (!y) throw rt;
              return ze() < 0 ? NaN : Pe(ze());
            }, durationAsUTC: function() {
              if (!y) throw rt;
              return Pe(Et());
            }, getActiveStream: pt, getDVRWindowSize: function() {
              var ye = O && O.hasVideoTrack() ? t.Z.VIDEO : t.Z.AUDIO, Ae = U.getCurrentDVRInfo(ye);
              return Ae ? Ae.manifestInfo.dvrWindowSize : 0;
            }, getDVRSeekOffset: yn, getAvailableBaseUrls: function() {
              var ye = re.getValue();
              return ye ? me.getBaseUrls(ye) : [];
            }, getAvailableLocations: function() {
              var ye = re.getValue();
              if (!ye) return [];
              var Ae = Ee.getLocation(ye), tt = de.getSynthesizedLocationElements(Ae);
              return Ae.concat(tt);
            }, getTargetLiveDelay: function() {
              if (!y) throw rt;
              return oe.getOriginalLiveDelay();
            }, convertToTimeCode: function(ye) {
              ye = Math.max(ye, 0);
              var Ae = Math.floor(ye / 3600), tt = Math.floor(ye % 3600 / 60), Nt = Math.floor(ye % 3600 % 60);
              return (Ae === 0 ? "" : Ae < 10 ? "0" + Ae.toString() + ":" : Ae.toString() + ":") + (tt < 10 ? "0" + tt.toString() : tt.toString()) + ":" + (Nt < 10 ? "0" + Nt.toString() : Nt.toString());
            }, formatUTC: function(ye, Ae, tt) {
              var Nt = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], xt = new Date(1e3 * ye), _n = xt.toLocaleDateString(Ae), Ln = xt.toLocaleTimeString(Ae, { hour12: tt });
              return Nt ? Ln + " " + _n : Ln;
            }, getVersion: Wt, getDebug: function() {
              return Tt;
            }, getBufferLength: function(ye) {
              var Ae = [t.Z.VIDEO, t.Z.AUDIO, t.Z.TEXT];
              if (ye) return Ae.indexOf(ye) !== -1 ? Pt().getCurrentBufferLevel(ye) || NaN : (r.warn("getBufferLength requested for invalid type"), NaN);
              var tt = Ae.map(function(Nt) {
                return en(Nt).length > 0 ? Pt().getCurrentBufferLevel(Nt) : Number.MAX_VALUE;
              }).reduce(function(Nt, xt) {
                return Math.min(Nt, xt);
              });
              return tt === Number.MAX_VALUE ? NaN : tt;
            }, getTTMLRenderingDiv: function() {
              return De ? De.getTTMLRenderingDiv() : null;
            }, getVideoElement: $t, getSource: function() {
              if (!u) throw Bt;
              return u;
            }, updateSource: function(ye) {
              u = ye, O.load(u);
            }, getCurrentLiveLatency: function() {
              if (!w) throw Re;
              return y ? oe.getCurrentLiveLatency() : NaN;
            }, getTopBitrateInfoFor: function(ye) {
              if (!I) throw ct;
              return Y.getTopBitrateInfoFor(ye);
            }, setAutoPlay: lt, getAutoPlay: function() {
              return N;
            }, getDashMetrics: Pt, getQualityFor: function(ye) {
              if (!I) throw ct;
              if (ye === t.Z.IMAGE) {
                var Ae = pt();
                if (!Ae) return -1;
                var tt = Ae.getThumbnailController();
                return tt ? tt.getCurrentTrackIndex() : -1;
              }
              return Y.getQualityFor(ye);
            }, setQualityFor: function(ye, Ae) {
              var tt = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
              if (!I) throw ct;
              if (ye === t.Z.IMAGE) {
                var Nt = pt();
                if (!Nt) return;
                var xt = Nt.getThumbnailController();
                xt && xt.setTrackByIndex(Ae);
              }
              Y.setPlaybackQuality(ye, O.getActiveStreamInfo(), Ae, { forceReplace: tt });
            }, updatePortalSize: function() {
              Y.setElementSize(), Y.setWindowResizeEventCalled(!0);
            }, enableText: function(ye) {
              var Ae = O.getActiveStreamInfo();
              return !(!Ae || !L) && L.enableText(Ae.id, ye);
            }, enableForcedTextStreaming: function(ye) {
              return !(!O.getActiveStreamInfo() || !L) && L.enableForcedTextStreaming(ye);
            }, isTextEnabled: function() {
              var ye = O.getActiveStreamInfo();
              return !(!ye || !L) && L.isTextEnabled(ye);
            }, setTextTrack: function(ye) {
              if (!y) throw rt;
              var Ae = O.getActiveStreamInfo();
              Ae && L && L.setTextTrack(Ae.id, ye);
            }, getBitrateInfoListFor: function(ye) {
              if (!I) throw ct;
              var Ae = pt();
              return Ae ? Ae.getBitrateListFor(ye) : [];
            }, getStreamsFromManifest: function(ye) {
              if (!I) throw ct;
              return Ee.getStreamsInfo(ye);
            }, getTracksFor: en, getTracksForTypeFromManifest: function(ye, Ae, tt) {
              if (!I) throw ct;
              return (tt = tt || Ee.getStreamsInfo(Ae, 1)[0]) ? Ee.getAllMediaInfoForType(tt, ye, Ae) : [];
            }, getCurrentTrackFor: function(ye) {
              if (!I) throw ct;
              var Ae = O.getActiveStreamInfo();
              return H.getCurrentTrackFor(ye, Ae.id);
            }, setInitialMediaSettingsFor: function(ye, Ae) {
              if (!w) throw Re;
              H.setInitialSettings(ye, Ae);
            }, getInitialMediaSettingsFor: function(ye) {
              if (!w) throw Re;
              return H.getInitialSettings(ye);
            }, setCurrentTrack: function(ye) {
              var Ae = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              if (!I) throw ct;
              H.setTrack(ye, Ae);
            }, addABRCustomRule: function(ye, Ae, tt) {
              ue.addAbrCustomRule(ye, Ae, tt);
            }, removeABRCustomRule: function(ye) {
              ue.removeAbrCustomRule(ye);
            }, removeAllABRCustomRule: function() {
              ue.removeAllAbrCustomRule();
            }, getABRCustomRules: function() {
              return ue.getAbrCustomRules();
            }, getAverageThroughput: function(ye) {
              var Ae = Y.getThroughputHistory(), tt = oe.getIsDynamic();
              return Ae ? Ae.getAverageThroughput(ye, tt) : 0;
            }, retrieveManifest: function(ye, Ae) {
              var tt = Vt(), Nt = this;
              yt.on(o.Z.INTERNAL_MANIFEST_LOADED, function xt(_n) {
                _n.error ? Ae(null, _n.error) : Ae(_n.manifest), yt.off(o.Z.INTERNAL_MANIFEST_LOADED, xt, Nt), tt.reset();
              }, Nt), ke.initialize(ye), tt.load(ye);
            }, addUTCTimingSource: function(ye, Ae) {
              ue.addUTCTimingSource(ye, Ae);
            }, removeUTCTimingSource: function(ye, Ae) {
              ue.removeUTCTimingSource(ye, Ae);
            }, clearDefaultUTCTimingSources: function() {
              ue.clearDefaultUTCTimingSources();
            }, restoreDefaultUTCTimingSources: wt, setXHRWithCredentialsForType: function(ye, Ae) {
              ue.setXHRWithCredentialsForType(ye, Ae);
            }, getXHRWithCredentialsForType: function(ye) {
              return ue.getXHRWithCredentialsForType(ye);
            }, getProtectionController: function() {
              return Xt();
            }, attachProtectionController: function(ye) {
              G = ye;
            }, setProtectionData: function(ye) {
              _ = ye, O && O.setProtectionData(_);
            }, registerLicenseRequestFilter: function(ye) {
              ue.registerLicenseRequestFilter(ye);
            }, registerLicenseResponseFilter: function(ye) {
              ue.registerLicenseResponseFilter(ye);
            }, unregisterLicenseRequestFilter: function(ye) {
              ue.unregisterLicenseRequestFilter(ye);
            }, unregisterLicenseResponseFilter: function(ye) {
              ue.unregisterLicenseResponseFilter(ye);
            }, registerCustomCapabilitiesFilter: function(ye) {
              ue.registerCustomCapabilitiesFilter(ye);
            }, unregisterCustomCapabilitiesFilter: function(ye) {
              ue.unregisterCustomCapabilitiesFilter(ye);
            }, setCustomInitialTrackSelectionFunction: function(ye) {
              ue.setCustomInitialTrackSelectionFunction(ye);
            }, resetCustomInitialTrackSelectionFunction: function() {
              ue.resetCustomInitialTrackSelectionFunction(null);
            }, attachTTMLRenderingDiv: function(ye) {
              if (!De.getElement()) throw at;
              De.setTTMLRenderingDiv(ye);
            }, attachVttRenderingDiv: function(ye) {
              if (!De.getElement()) throw at;
              De.setVttRenderingDiv(ye);
            }, getCurrentTextTrackIndex: function() {
              var ye = O.getActiveStreamInfo();
              if (ye && L) return L.getCurrentTrackIdx(ye.id);
            }, provideThumbnail: function(ye, Ae) {
              if (typeof Ae == "function") if (ye < 0) Ae(null);
              else {
                var tt = oe.getIsDynamic() ? yn(ye) : ye, Nt = O.getStreamForTime(tt);
                if (Nt !== null) {
                  var xt = Nt.getThumbnailController();
                  if (xt) return xt.provide(tt, Ae);
                  Ae(null);
                } else Ae(null);
              }
            }, getDashAdapter: function() {
              return Ee;
            }, getOfflineController: function() {
              return We();
            }, triggerSteeringRequest: function() {
              if (de) return de.loadSteeringData();
            }, getCurrentSteeringResponseData: function() {
              if (de) return de.getCurrentSteeringResponseData();
            }, getSettings: function() {
              return Qe.get();
            }, updateSettings: function(ye) {
              Qe.update(ye);
            }, resetSettings: function() {
              Qe.reset();
            }, reset: vt, destroy: function() {
              vt(), v.Z.deleteSingletonInstances(He);
            } }, r = Tt.getLogger(i), w = !1, y = !1, I = !1, N = !0, Z = NaN, G = null, he = null, _ = null, Ee = null, ut = null, o.Z.extend(n.Z), j = Fu(He).getInstance(), ue = (0, Kn.Z)(He).getInstance(), De = qu(He).getInstance(), ke = Pu(He).getInstance(), i;
          }
          mo.__dashjs_factory_name = "MediaPlayer";
          var la = v.Z.getClassFactory(mo);
          la.events = n.Z, la.errors = ee, v.Z.updateClassFactory(mo.__dashjs_factory_name, la);
          var Oc = la;
        }, 8825: function(_e, fe, R) {
          function J(p) {
            return J = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
              return typeof o;
            } : function(o) {
              return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, J(p);
          }
          function E(p, o) {
            return E = Object.setPrototypeOf || function(v, m) {
              return v.__proto__ = m, v;
            }, E(p, o);
          }
          function t(p, o) {
            return !o || J(o) !== "object" && typeof o != "function" ? function(v) {
              if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }(p) : o;
          }
          function e(p) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            }, e(p);
          }
          var h = new (function(p) {
            (function(c, f) {
              if (typeof f != "function" && f !== null) throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(f && f.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), f && E(c, f);
            })(n, p);
            var o, v, m = (o = n, v = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var c, f = e(o);
              if (v) {
                var S = e(this).constructor;
                c = Reflect.construct(f, arguments, S);
              } else c = f.apply(this, arguments);
              return t(this, c);
            });
            function n() {
              var c;
              return function(f, S) {
                if (!(f instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (c = m.call(this)).AST_IN_FUTURE = "astInFuture", c.BASE_URLS_UPDATED = "baseUrlsUpdated", c.BUFFER_EMPTY = "bufferStalled", c.BUFFER_LOADED = "bufferLoaded", c.BUFFER_LEVEL_STATE_CHANGED = "bufferStateChanged", c.BUFFER_LEVEL_UPDATED = "bufferLevelUpdated", c.DVB_FONT_DOWNLOAD_ADDED = "dvbFontDownloadAdded", c.DVB_FONT_DOWNLOAD_COMPLETE = "dvbFontDownloadComplete", c.DVB_FONT_DOWNLOAD_FAILED = "dvbFontDownloadFailed", c.DYNAMIC_TO_STATIC = "dynamicToStatic", c.ERROR = "error", c.FRAGMENT_LOADING_COMPLETED = "fragmentLoadingCompleted", c.FRAGMENT_LOADING_PROGRESS = "fragmentLoadingProgress", c.FRAGMENT_LOADING_STARTED = "fragmentLoadingStarted", c.FRAGMENT_LOADING_ABANDONED = "fragmentLoadingAbandoned", c.LOG = "log", c.MANIFEST_LOADING_STARTED = "manifestLoadingStarted", c.MANIFEST_LOADING_FINISHED = "manifestLoadingFinished", c.MANIFEST_LOADED = "manifestLoaded", c.METRICS_CHANGED = "metricsChanged", c.METRIC_CHANGED = "metricChanged", c.METRIC_ADDED = "metricAdded", c.METRIC_UPDATED = "metricUpdated", c.PERIOD_SWITCH_STARTED = "periodSwitchStarted", c.PERIOD_SWITCH_COMPLETED = "periodSwitchCompleted", c.QUALITY_CHANGE_REQUESTED = "qualityChangeRequested", c.QUALITY_CHANGE_RENDERED = "qualityChangeRendered", c.TRACK_CHANGE_RENDERED = "trackChangeRendered", c.STREAM_INITIALIZING = "streamInitializing", c.STREAM_UPDATED = "streamUpdated", c.STREAM_ACTIVATED = "streamActivated", c.STREAM_DEACTIVATED = "streamDeactivated", c.STREAM_INITIALIZED = "streamInitialized", c.STREAM_TEARDOWN_COMPLETE = "streamTeardownComplete", c.TEXT_TRACKS_ADDED = "allTextTracksAdded", c.TEXT_TRACK_ADDED = "textTrackAdded", c.CUE_ENTER = "cueEnter", c.CUE_EXIT = "cueExit", c.THROUGHPUT_MEASUREMENT_STORED = "throughputMeasurementStored", c.TTML_PARSED = "ttmlParsed", c.TTML_TO_PARSE = "ttmlToParse", c.CAPTION_RENDERED = "captionRendered", c.CAPTION_CONTAINER_RESIZE = "captionContainerResize", c.CAN_PLAY = "canPlay", c.CAN_PLAY_THROUGH = "canPlayThrough", c.PLAYBACK_ENDED = "playbackEnded", c.PLAYBACK_ERROR = "playbackError", c.PLAYBACK_NOT_ALLOWED = "playbackNotAllowed", c.PLAYBACK_METADATA_LOADED = "playbackMetaDataLoaded", c.PLAYBACK_LOADED_DATA = "playbackLoadedData", c.PLAYBACK_PAUSED = "playbackPaused", c.PLAYBACK_PLAYING = "playbackPlaying", c.PLAYBACK_PROGRESS = "playbackProgress", c.PLAYBACK_RATE_CHANGED = "playbackRateChanged", c.PLAYBACK_SEEKED = "playbackSeeked", c.PLAYBACK_SEEKING = "playbackSeeking", c.PLAYBACK_STALLED = "playbackStalled", c.PLAYBACK_STARTED = "playbackStarted", c.PLAYBACK_TIME_UPDATED = "playbackTimeUpdated", c.PLAYBACK_VOLUME_CHANGED = "playbackVolumeChanged", c.PLAYBACK_WAITING = "playbackWaiting", c.MANIFEST_VALIDITY_CHANGED = "manifestValidityChanged", c.EVENT_MODE_ON_START = "eventModeOnStart", c.EVENT_MODE_ON_RECEIVE = "eventModeOnReceive", c.CONFORMANCE_VIOLATION = "conformanceViolation", c.REPRESENTATION_SWITCH = "representationSwitch", c.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = "adaptationSetRemovedNoCapabilities", c.CONTENT_STEERING_REQUEST_COMPLETED = "contentSteeringRequestCompleted", c.INBAND_PRFT = "inbandPrft", c.MANAGED_MEDIA_SOURCE_START_STREAMING = "managedMediaSourceStartStreaming", c.MANAGED_MEDIA_SOURCE_END_STREAMING = "managedMediaSourceEndStreaming", c;
            }
            return n;
          }(R(8342).Z))();
          fe.Z = h;
        }, 3393: function(_e, fe) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var h = t[e];
              h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(E, h.key, h);
            }
          }
          var J = new (function() {
            function E() {
              (function(h, p) {
                if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E), this.init();
            }
            var t, e;
            return t = E, (e = [{ key: "init", value: function() {
              this.STREAM = "stream", this.VIDEO = "video", this.AUDIO = "audio", this.TEXT = "text", this.MUXED = "muxed", this.IMAGE = "image", this.STPP = "stpp", this.TTML = "ttml", this.VTT = "vtt", this.WVTT = "wvtt", this.CONTENT_STEERING = "contentSteering", this.ABR_STRATEGY_DYNAMIC = "abrDynamic", this.ABR_STRATEGY_BOLA = "abrBola", this.ABR_STRATEGY_L2A = "abrL2A", this.ABR_STRATEGY_LoLP = "abrLoLP", this.ABR_STRATEGY_THROUGHPUT = "abrThroughput", this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA = "abrFetchThroughputCalculationDownloadedData", this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING = "abrFetchThroughputCalculationMoofParsing", this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST = "abrFetchThroughputCalculationAAST", this.LIVE_CATCHUP_MODE_DEFAULT = "liveCatchupModeDefault", this.LIVE_CATCHUP_MODE_LOLP = "liveCatchupModeLoLP", this.MOVING_AVERAGE_SLIDING_WINDOW = "slidingWindow", this.MOVING_AVERAGE_EWMA = "ewma", this.BAD_ARGUMENT_ERROR = "Invalid Arguments", this.MISSING_CONFIG_ERROR = "Missing config parameter(s)", this.TRACK_SWITCH_MODE_ALWAYS_REPLACE = "alwaysReplace", this.TRACK_SWITCH_MODE_NEVER_REPLACE = "neverReplace", this.TRACK_SELECTION_MODE_FIRST_TRACK = "firstTrack", this.TRACK_SELECTION_MODE_HIGHEST_BITRATE = "highestBitrate", this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY = "highestEfficiency", this.TRACK_SELECTION_MODE_WIDEST_RANGE = "widestRange", this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY = "highestSelectionPriority", this.CMCD_MODE_QUERY = "query", this.CMCD_MODE_HEADER = "header", this.INITIALIZE = "initialize", this.TEXT_SHOWING = "showing", this.TEXT_HIDDEN = "hidden", this.TEXT_DISABLED = "disabled", this.CC1 = "CC1", this.CC3 = "CC3", this.UTF8 = "utf-8", this.SCHEME_ID_URI = "schemeIdUri", this.START_TIME = "starttime", this.SERVICE_DESCRIPTION_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:scope:2019", this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME = "urn:dvb:dash:lowlatency:critical:2019", this.FONT_DOWNLOAD_DVB_SCHEME = "urn:dvb:dash:fontdownload:2014", this.XML = "XML", this.ARRAY_BUFFER = "ArrayBuffer", this.DVB_REPORTING_URL = "dvb:reportingUrl", this.DVB_PROBABILITY = "dvb:probability", this.OFF_MIMETYPE = "application/font-sfnt", this.WOFF_MIMETYPE = "application/font-woff", this.VIDEO_ELEMENT_READY_STATES = { HAVE_NOTHING: 0, HAVE_METADATA: 1, HAVE_CURRENT_DATA: 2, HAVE_FUTURE_DATA: 3, HAVE_ENOUGH_DATA: 4 }, this.FILE_LOADER_TYPES = { FETCH: "fetch_loader", XHR: "xhr_loader" };
            } }]) && R(t.prototype, e), E;
          }())();
          fe.Z = J;
        }, 3860: function(_e, fe) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var h = t[e];
              h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(E, h.key, h);
            }
          }
          var J = new (function() {
            function E() {
              (function(h, p) {
                if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
              })(this, E), this.init();
            }
            var t, e;
            return t = E, (e = [{ key: "init", value: function() {
              this.TCP_CONNECTION = "TcpList", this.HTTP_REQUEST = "HttpList", this.TRACK_SWITCH = "RepSwitchList", this.BUFFER_LEVEL = "BufferLevel", this.BUFFER_LOADED = "bufferLoaded", this.ABANDON_LOAD = "abandonload", this.ALLOW_LOAD = "allowload", this.BUFFER_EMPTY = "bufferStalled", this.BUFFER_STATE = "BufferState", this.DVR_INFO = "DVRInfo", this.DROPPED_FRAMES = "DroppedFrames", this.SCHEDULING_INFO = "SchedulingInfo", this.REQUESTS_QUEUE = "RequestsQueue", this.MANIFEST_UPDATE = "ManifestUpdate", this.MANIFEST_UPDATE_STREAM_INFO = "ManifestUpdatePeriodInfo", this.MANIFEST_UPDATE_TRACK_INFO = "ManifestUpdateRepresentationInfo", this.PLAY_LIST = "PlayList", this.DVB_ERRORS = "DVBErrors", this.HTTP_REQUEST_DVB_REPORTING_TYPE = "DVBReporting";
            } }]) && R(t.prototype, e), E;
          }())();
          fe.Z = J;
        }, 8080: function(_e, fe, R) {
          R.d(fe, { default: function() {
            return T;
          } });
          var J = function b() {
            (function($, W) {
              if (!($ instanceof W)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.mpdurl = null, this.errorcode = null, this.terror = null, this.url = null, this.ipaddress = null, this.servicelocation = null;
          };
          J.SSL_CONNECTION_FAILED_PREFIX = "SSL", J.DNS_RESOLUTION_FAILED = "C00", J.HOST_UNREACHABLE = "C01", J.CONNECTION_REFUSED = "C02", J.CONNECTION_ERROR = "C03", J.CORRUPT_MEDIA_ISOBMFF = "M00", J.CORRUPT_MEDIA_OTHER = "M01", J.BASE_URL_CHANGED = "F00", J.BECAME_REPORTER = "S00";
          var E = J, t = R(1180);
          function e(b) {
            var $, W, Ie = (b = b || {}).eventBus, $e = b.dashMetrics, Ze = b.metricsConstants, xe = b.events;
            function Me(Ot) {
              var Ht = new E();
              if (W) {
                for (var Ut in Ot) Ot.hasOwnProperty(Ut) && (Ht[Ut] = Ot[Ut]);
                Ht.mpdurl || (Ht.mpdurl = W.originalUrl || W.url), Ht.terror || (Ht.terror = /* @__PURE__ */ new Date()), $e.addDVBErrors(Ht);
              }
            }
            function Ve(Ot) {
              Ot.error || (W = Ot.manifest);
            }
            function ot(Ot) {
              Me({ errorcode: E.BASE_URL_CHANGED, servicelocation: Ot.entry });
            }
            function bt() {
              Me({ errorcode: E.BECAME_REPORTER });
            }
            function dt(Ot) {
              var Ht;
              Ot.metric === Ze.HTTP_REQUEST && ((Ht = Ot.value).responsecode === 0 || Ht.responsecode == null || Ht.responsecode >= 400 || Ht.responsecode < 100 || Ht.responsecode >= 600) && Me({ errorcode: Ht.responsecode || E.CONNECTION_ERROR, url: Ht.url, terror: Ht.tresponse, servicelocation: Ht._serviceLocation });
            }
            function Yt(Ot) {
              var Ht;
              switch (Ot.error ? Ot.error.code : 0) {
                case MediaError.MEDIA_ERR_NETWORK:
                  Ht = E.CONNECTION_ERROR;
                  break;
                case MediaError.MEDIA_ERR_DECODE:
                  Ht = E.CORRUPT_MEDIA_OTHER;
                  break;
                default:
                  return;
              }
              Me({ errorcode: Ht });
            }
            return $ = { initialize: function() {
              Ie.on(xe.MANIFEST_UPDATED, Ve, $), Ie.on(xe.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, ot, $), Ie.on(xe.METRIC_ADDED, dt, $), Ie.on(xe.METRIC_UPDATED, dt, $), Ie.on(xe.PLAYBACK_ERROR, Yt, $), Ie.on(t.Z.BECAME_REPORTING_PLAYER, bt, $);
            }, reset: function() {
              Ie.off(xe.MANIFEST_UPDATED, Ve, $), Ie.off(xe.SERVICE_LOCATION_BASE_URL_BLACKLIST_CHANGED, ot, $), Ie.off(xe.METRIC_ADDED, dt, $), Ie.off(xe.METRIC_UPDATED, dt, $), Ie.off(xe.PLAYBACK_ERROR, Yt, $), Ie.off(t.Z.BECAME_REPORTING_PLAYER, bt, $);
            } };
          }
          e.__dashjs_factory_name = "DVBErrorsTranslator";
          var h = dashjs.FactoryMaker.getSingletonFactory(e), p = R(2295);
          function o(b) {
            b = b || {};
            var $, W, Ie = !1, $e = this.context, Ze = b.mediaElement;
            return $ = { initialize: function(xe) {
              xe && xe.length && (xe.forEach(function(Me) {
                var Ve = Me.starttime, ot = Ve + Me.duration;
                W.add(Ve, ot);
              }), Ie = !!xe[0]._useWallClockTime);
            }, reset: function() {
              W.clear();
            }, isEnabled: function() {
              var xe, Me = W.length;
              if (!Me) return !0;
              xe = Ie ? (/* @__PURE__ */ new Date()).getTime() / 1e3 : Ze.currentTime;
              for (var Ve = 0; Ve < Me; Ve += 1) {
                var ot = W.start(Ve), bt = W.end(Ve);
                if (ot <= xe && xe < bt) return !0;
              }
              return !1;
            } }, W = (0, p.Z)($e).create(), $;
          }
          o.__dashjs_factory_name = "RangeController";
          var v = dashjs.FactoryMaker.getClassFactory(o);
          function m() {
            return { serialise: function b($) {
              var W, Ie, $e = [], Ze = [];
              for (W in $) if ($.hasOwnProperty(W) && W.indexOf("_") !== 0) {
                if ((Ie = $[W]) == null && (Ie = ""), Array.isArray(Ie)) {
                  if (!Ie.length) continue;
                  Ze = [], Ie.forEach(function(xe) {
                    var Me = Object.prototype.toString.call(xe).slice(8, -1) !== "Object";
                    Ze.push(Me ? xe : b(xe));
                  }), Ie = Ze.map(encodeURIComponent).join(",");
                } else typeof Ie == "string" ? Ie = encodeURIComponent(Ie) : Ie instanceof Date ? Ie = Ie.toISOString() : typeof Ie == "number" && (Ie = Math.round(Ie));
                $e.push(W + "=" + Ie);
              }
              return $e.join("&");
            } };
          }
          m.__dashjs_factory_name = "MetricSerialiser";
          var n = dashjs.FactoryMaker.getSingletonFactory(m);
          function c() {
            var b, $, W, Ie = window.crypto || window.msCrypto, $e = Uint32Array, Ze = Math.pow(2, 8 * $e.BYTES_PER_ELEMENT) - 1;
            function xe() {
              Ie && (b || (b = new $e(10)), Ie.getRandomValues(b), $ = 0);
            }
            return W = { random: function(Me, Ve) {
              var ot;
              return Me || (Me = 0), Ve || (Ve = 1), Ie ? ($ === b.length && xe(), ot = b[$] / Ze, $ += 1) : ot = Math.random(), ot * (Ve - Me) + Me;
            } }, xe(), W;
          }
          c.__dashjs_factory_name = "RNG";
          var f = dashjs.FactoryMaker.getSingletonFactory(c), S = R(5717);
          function k(b) {
            var $;
            b = b || {};
            var W, Ie, $e, Ze, xe, Me, Ve, ot = this.context, bt = [], dt = b.metricsConstants;
            function Yt() {
              Ze = !1, xe = !1, Me = null, Ve = null;
            }
            return $ = { report: function(Ot, Ht) {
              Array.isArray(Ht) || (Ht = [Ht]), xe && Ve.isEnabled() && Ht.forEach(function(Ut) {
                var fn = W.serialise(Ut);
                Ot !== dt.DVB_ERRORS && (fn = "metricname=".concat(Ot, "&").concat(fn)), function(Tn, Fn, On) {
                  var Zn = new XMLHttpRequest();
                  Zn.withCredentials = Ie.getXHRWithCredentialsForType(dt.HTTP_REQUEST_DVB_REPORTING_TYPE);
                  var rr = function() {
                    var wn = bt.indexOf(Zn);
                    wn !== -1 && (bt.splice(wn, 1), !(Zn.status >= 200 && Zn.status < 300) && On());
                  };
                  bt.push(Zn);
                  try {
                    Zn.open("GET", Tn), Zn.onloadend = rr, Zn.onerror = rr, Zn.send();
                  } catch {
                    Zn.onerror();
                  }
                }(fn = "".concat(Me, "?").concat(fn), 0, function() {
                  xe = !1;
                });
              });
            }, initialize: function(Ot, Ht) {
              var Ut;
              if (Ve = Ht, !(Me = Ot.dvbReportingUrl)) throw new Error("required parameter missing (dvb:reportingUrl)");
              Ze || ((Ut = Ot.dvbProbability) && (Ut === 1e3 || Ut / 1e3 >= $e.random()) && (xe = !0), Ze = !0);
            }, reset: function() {
              Yt();
            } }, W = n(ot).getInstance(), $e = f(ot).getInstance(), Ie = (0, S.Z)(ot).getInstance(), Yt(), $;
          }
          k.__dashjs_factory_name = "DVBReporting";
          var q = dashjs.FactoryMaker.getClassFactory(k);
          function F(b) {
            b = b || {};
            var $, W = { "urn:dvb:dash:reporting:2014": q }, Ie = this.context, $e = b.debug ? b.debug.getLogger($) : {}, Ze = b.metricsConstants, xe = b.mediaPlayerModel || {};
            return { create: function(Me, Ve) {
              var ot;
              try {
                (ot = W[Me.schemeIdUri](Ie).create({ metricsConstants: Ze, mediaPlayerModel: xe })).initialize(Me, Ve);
              } catch (bt) {
                ot = null, $e.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(Me.schemeIdUri, " (").concat(bt.message, ")"));
              }
              return ot;
            }, register: function(Me, Ve) {
              W[Me] = Ve;
            }, unregister: function(Me) {
              delete W[Me];
            } };
          }
          F.__dashjs_factory_name = "ReportingFactory";
          var te = dashjs.FactoryMaker.getSingletonFactory(F);
          function P(b) {
            var $ = [], W = te(this.context).getInstance(b);
            return { initialize: function(Ie, $e) {
              Ie.some(function(Ze) {
                var xe = W.create(Ze, $e);
                if (xe) return $.push(xe), !0;
              });
            }, reset: function() {
              $.forEach(function(Ie) {
                return Ie.reset();
              }), $ = [];
            }, report: function(Ie, $e) {
              $.forEach(function(Ze) {
                return Ze.report(Ie, $e);
              });
            } };
          }
          P.__dashjs_factory_name = "ReportingController";
          var Q = dashjs.FactoryMaker.getClassFactory(P);
          function se() {
            return { reconstructFullMetricName: function(b, $, W) {
              var Ie = b;
              return $ && (Ie += "(" + $, W && W.length && (Ie += "," + W), Ie += ")"), Ie;
            }, validateN: function(b) {
              if (!b) throw new Error("missing n");
              if (isNaN(b)) throw new Error("n is NaN");
              if (b < 0) throw new Error("n must be positive");
              return b;
            } };
          }
          se.__dashjs_factory_name = "HandlerHelpers";
          var K = dashjs.FactoryMaker.getSingletonFactory(se);
          function ie(b) {
            var $, W, Ie, $e, Ze;
            b = b || {};
            var xe = this.context, Me = K(xe).getInstance(), Ve = [], ot = b.metricsConstants;
            function bt() {
              var dt = function() {
                try {
                  return Object.keys(Ve).map(function(Yt) {
                    return Ve[Yt];
                  }).reduce(function(Yt, Ot) {
                    return Yt.level < Ot.level ? Yt : Ot;
                  });
                } catch {
                  return;
                }
              }();
              dt && Ze !== dt.t && (Ze = dt.t, $.report(Ie, dt));
            }
            return { initialize: function(dt, Yt, Ot) {
              Yt && (W = Me.validateN(Ot), $ = Yt, Ie = Me.reconstructFullMetricName(dt, Ot), $e = setInterval(bt, W));
            }, reset: function() {
              clearInterval($e), $e = null, W = 0, $ = null, Ze = null;
            }, handleNewMetric: function(dt, Yt, Ot) {
              dt === ot.BUFFER_LEVEL && (Ve[Ot] = Yt);
            } };
          }
          ie.__dashjs_factory_name = "BufferLevelHandler";
          var ge = dashjs.FactoryMaker.getClassFactory(ie), Ne = dashjs.FactoryMaker.getClassFactory(function(b) {
            var $, W = (b = b || {}).eventBus, Ie = b.metricsConstants;
            function $e() {
              W.off(t.Z.METRICS_INITIALISATION_COMPLETE, $e, this), W.trigger(t.Z.BECAME_REPORTING_PLAYER);
            }
            return { initialize: function(Ze, xe) {
              xe && ($ = xe, W.on(t.Z.METRICS_INITIALISATION_COMPLETE, $e, this));
            }, reset: function() {
              $ = null;
            }, handleNewMetric: function(Ze, xe) {
              Ze === Ie.DVB_ERRORS && $ && $.report(Ze, xe);
            } };
          });
          function ee(b) {
            var $, W, Ie, $e, Ze;
            b = b || {};
            var xe = [], Me = K(this.context).getInstance(), Ve = b.metricsConstants;
            function ot() {
              var bt = xe;
              bt.length && $ && $.report($e, bt), xe = [];
            }
            return { initialize: function(bt, dt, Yt, Ot) {
              dt && (W = Me.validateN(Yt), $ = dt, Ot && Ot.length && (Ie = Ot), $e = Me.reconstructFullMetricName(bt, Yt, Ot), Ze = setInterval(ot, W));
            }, reset: function() {
              clearInterval(Ze), Ze = null, W = null, Ie = null, xe = [], $ = null;
            }, handleNewMetric: function(bt, dt) {
              bt === Ve.HTTP_REQUEST && (Ie && Ie !== dt.type || xe.push(dt));
            } };
          }
          ee.__dashjs_factory_name = "HttpListHandler";
          var Oe = dashjs.FactoryMaker.getClassFactory(ee);
          function Ge() {
            var b, $;
            return { initialize: function(W, Ie) {
              b = W, $ = Ie;
            }, reset: function() {
              $ = null, b = void 0;
            }, handleNewMetric: function(W, Ie) {
              W === b && $ && $.report(b, Ie);
            } };
          }
          Ge.__dashjs_factory_name = "GenericMetricHandler";
          var Xe = dashjs.FactoryMaker.getClassFactory(Ge);
          function Ce(b) {
            var $, W = (b = b || {}).debug ? b.debug.getLogger($) : {}, Ie = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/, $e = this.context, Ze = { BufferLevel: ge, DVBErrors: Ne, HttpList: Oe, PlayList: Xe, RepSwitchList: Xe, TcpList: Xe };
            return { create: function(xe, Me) {
              var Ve, ot = xe.match(Ie);
              if (ot) {
                try {
                  (Ve = Ze[ot[1]]($e).create({ eventBus: b.eventBus, metricsConstants: b.metricsConstants })).initialize(ot[1], Me, ot[3], ot[5]);
                } catch (bt) {
                  Ve = null, W.error("MetricsHandlerFactory: Could not create handler for type ".concat(ot[1], " with args ").concat(ot[3], ", ").concat(ot[5], " (").concat(bt.message, ")"));
                }
                return Ve;
              }
            }, register: function(xe, Me) {
              Ze[xe] = Me;
            }, unregister: function(xe) {
              delete Ze[xe];
            } };
          }
          Ce.__dashjs_factory_name = "MetricsHandlerFactory";
          var Ue = dashjs.FactoryMaker.getSingletonFactory(Ce);
          function Je(b) {
            b = b || {};
            var $, W = [], Ie = this.context, $e = b.eventBus, Ze = b.events, xe = Ue(Ie).getInstance({ debug: b.debug, eventBus: b.eventBus, metricsConstants: b.metricsConstants });
            function Me(Ve) {
              W.forEach(function(ot) {
                ot.handleNewMetric(Ve.metric, Ve.value, Ve.mediaType);
              });
            }
            return $ = { initialize: function(Ve, ot) {
              Ve.split(",").forEach(function(bt, dt, Yt) {
                var Ot;
                if (bt.indexOf("(") !== -1 && bt.indexOf(")") === -1) {
                  var Ht = Yt[dt + 1];
                  Ht && Ht.indexOf("(") === -1 && Ht.indexOf(")") !== -1 && (bt += "," + Ht, delete Yt[dt + 1]);
                }
                (Ot = xe.create(bt, ot)) && W.push(Ot);
              }), $e.on(Ze.METRIC_ADDED, Me, $), $e.on(Ze.METRIC_UPDATED, Me, $);
            }, reset: function() {
              $e.off(Ze.METRIC_ADDED, Me, $), $e.off(Ze.METRIC_UPDATED, Me, $), W.forEach(function(Ve) {
                return Ve.reset();
              }), W = [];
            } };
          }
          Je.__dashjs_factory_name = "MetricsHandlersController";
          var st = dashjs.FactoryMaker.getClassFactory(Je);
          function we(b) {
            var $, W, Ie;
            b = b || {};
            var $e = this.context;
            function Ze() {
              $ && $.reset(), W && W.reset(), Ie && Ie.reset();
            }
            return { initialize: function(xe) {
              try {
                (Ie = v($e).create({ mediaElement: b.mediaElement })).initialize(xe.Range), (W = Q($e).create({ debug: b.debug, metricsConstants: b.metricsConstants, mediaPlayerModel: b.mediaPlayerModel })).initialize(xe.Reporting, Ie), ($ = st($e).create({ debug: b.debug, eventBus: b.eventBus, metricsConstants: b.metricsConstants, events: b.events })).initialize(xe.metrics, W);
              } catch (Me) {
                throw Ze(), Me;
              }
            }, reset: Ze };
          }
          we.__dashjs_factory_name = "MetricsController";
          var Be = dashjs.FactoryMaker.getClassFactory(we), At = function b() {
            (function($, W) {
              if (!($ instanceof W)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.metrics = "", this.Range = [], this.Reporting = [];
          }, ht = function b() {
            (function($, W) {
              if (!($ instanceof W)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.starttime = 0, this.duration = 1 / 0, this._useWallClockTime = !1;
          }, je = function b() {
            (function($, W) {
              if (!($ instanceof W)) throw new TypeError("Cannot call a class as a function");
            })(this, b), this.schemeIdUri = "", this.value = "", this.dvbReportingUrl = "", this.dvbProbability = 1e3;
          };
          function it(b) {
            var $ = (b = b || {}).adapter, W = b.constants;
            return { getMetrics: function(Ie) {
              var $e = [];
              return Ie && Ie.Metrics_asArray && Ie.Metrics_asArray.forEach(function(Ze) {
                var xe = new At(), Me = $.getIsDynamic(Ie);
                Ze.hasOwnProperty("metrics") && (xe.metrics = Ze.metrics, Ze.Range_asArray && Ze.Range_asArray.forEach(function(Ve) {
                  var ot = new ht();
                  ot.starttime = function(bt, dt, Yt) {
                    var Ot, Ht, Ut = 0;
                    return dt ? Ut = $.getAvailabilityStartTime(bt) / 1e3 : (Ot = $.getRegularPeriods(bt)).length && (Ut = Ot[0].start), Ht = Ut, Yt && Yt.hasOwnProperty(W.START_TIME) && (Ht += Yt.starttime), Ht;
                  }(Ie, Me, Ve), Ve.hasOwnProperty("duration") ? ot.duration = Ve.duration : ot.duration = $.getDuration(Ie), ot._useWallClockTime = Me, xe.Range.push(ot);
                }), Ze.Reporting_asArray && (Ze.Reporting_asArray.forEach(function(Ve) {
                  var ot = new je();
                  Ve.hasOwnProperty(W.SCHEME_ID_URI) && (ot.schemeIdUri = Ve.schemeIdUri, Ve.hasOwnProperty("value") && (ot.value = Ve.value), Ve.hasOwnProperty(W.DVB_REPORTING_URL) && (ot.dvbReportingUrl = Ve[W.DVB_REPORTING_URL]), Ve.hasOwnProperty(W.DVB_PROBABILITY) && (ot.dvbProbability = Ve[W.DVB_PROBABILITY]), xe.Reporting.push(ot));
                }), $e.push(xe)));
              }), $e;
            } };
          }
          it.__dashjs_factory_name = "ManifestParsing";
          var ve = dashjs.FactoryMaker.getSingletonFactory(it);
          function Se(b) {
            var $;
            b = b || {};
            var W = {}, Ie = this.context, $e = b.eventBus, Ze = b.events;
            function xe(Ve) {
              if (!Ve.error) {
                var ot = Object.keys(W);
                ve(Ie).getInstance({ adapter: b.adapter, constants: b.constants }).getMetrics(Ve.manifest).forEach(function(bt) {
                  var dt = JSON.stringify(bt);
                  if (W.hasOwnProperty(dt)) ot.splice(dt, 1);
                  else try {
                    var Yt = Be(Ie).create(b);
                    Yt.initialize(bt), W[dt] = Yt;
                  } catch {
                  }
                }), ot.forEach(function(bt) {
                  W[bt].reset(), delete W[bt];
                }), $e.trigger(t.Z.METRICS_INITIALISATION_COMPLETE);
              }
            }
            function Me() {
              Object.keys(W).forEach(function(Ve) {
                W[Ve].reset();
              }), W = {};
            }
            return $ = { reset: function() {
              $e.off(Ze.MANIFEST_UPDATED, xe, $), $e.off(Ze.STREAM_TEARDOWN_COMPLETE, Me, $);
            } }, $e.on(Ze.MANIFEST_UPDATED, xe, $), $e.on(Ze.STREAM_TEARDOWN_COMPLETE, Me, $), $;
          }
          Se.__dashjs_factory_name = "MetricsCollectionController";
          var Ye = dashjs.FactoryMaker.getClassFactory(Se);
          function d() {
            var b = this.context;
            return { createMetricsReporting: function($) {
              return h(b).getInstance({ eventBus: $.eventBus, dashMetrics: $.dashMetrics, metricsConstants: $.metricsConstants, events: $.events }).initialize(), Ye(b).create($);
            }, getReportingFactory: function() {
              return te(b).getInstance();
            }, getMetricsHandlerFactory: function() {
              return Ue(b).getInstance();
            } };
          }
          d.__dashjs_factory_name = "MetricsReporting";
          var l = dashjs.FactoryMaker.getClassFactory(d);
          l.events = t.Z, dashjs.FactoryMaker.updateClassFactory(d.__dashjs_factory_name, l);
          var T = l;
        }, 1180: function(_e, fe, R) {
          function J(p) {
            return J = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
              return typeof o;
            } : function(o) {
              return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, J(p);
          }
          function E(p, o) {
            return E = Object.setPrototypeOf || function(v, m) {
              return v.__proto__ = m, v;
            }, E(p, o);
          }
          function t(p, o) {
            return !o || J(o) !== "object" && typeof o != "function" ? function(v) {
              if (v === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return v;
            }(p) : o;
          }
          function e(p) {
            return e = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            }, e(p);
          }
          var h = new (function(p) {
            (function(c, f) {
              if (typeof f != "function" && f !== null) throw new TypeError("Super expression must either be null or a function");
              c.prototype = Object.create(f && f.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), f && E(c, f);
            })(n, p);
            var o, v, m = (o = n, v = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var c, f = e(o);
              if (v) {
                var S = e(this).constructor;
                c = Reflect.construct(f, arguments, S);
              } else c = f.apply(this, arguments);
              return t(this, c);
            });
            function n() {
              var c;
              return function(f, S) {
                if (!(f instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, n), (c = m.call(this)).METRICS_INITIALISATION_COMPLETE = "internal_metricsReportingInitialized", c.BECAME_REPORTING_PLAYER = "internal_becameReportingPlayer", c.CMCD_DATA_GENERATED = "cmcdDataGenerated", c;
            }
            return n;
          }(R(8342).Z))();
          fe.Z = h;
        }, 5717: function(_e, fe, R) {
          var J = R(2610), E = R(5448), t = R(1264), e = R(3106), h = R(1767), p = R(3393);
          function o() {
            var v, m, n, c, f, S, k, q, F = this.context, te = (0, t.Z)(F).getInstance();
            function P() {
              c = [], f = [], S = [], q = [], k = null, m = [];
            }
            function Q(ge, Ne) {
              var ee = -1;
              ge.some(function(Oe, Ge) {
                if (Oe === Ne) return ee = Ge, !0;
              }), ee < 0 || ge.splice(ee, 1);
            }
            function se(ge) {
              var Ne;
              for (Ne = 0; Ne < q.length; Ne++) if (q[Ne].rulename === ge) return Ne;
              return -1;
            }
            function K(ge, Ne) {
              ie(ge, Ne);
              var ee = new J.Z();
              ee.schemeIdUri = ge, ee.value = Ne, m.push(ee);
            }
            function ie(ge, Ne) {
              (0, e.PS)(ge, "string"), (0, e.PS)(Ne, "string"), m.forEach(function(ee, Oe) {
                ee.schemeIdUri === ge && ee.value === Ne && m.splice(Oe, 1);
              });
            }
            return v = { getCustomInitialTrackSelectionFunction: function() {
              return k;
            }, setCustomInitialTrackSelectionFunction: function(ge) {
              k = ge;
            }, resetCustomInitialTrackSelectionFunction: function() {
              k = null;
            }, getLicenseResponseFilters: function() {
              return f;
            }, getLicenseRequestFilters: function() {
              return c;
            }, getCustomCapabilitiesFilters: function() {
              return S;
            }, registerCustomCapabilitiesFilter: function(ge) {
              S.push(ge);
            }, registerLicenseResponseFilter: function(ge) {
              f.push(ge);
            }, registerLicenseRequestFilter: function(ge) {
              c.push(ge);
            }, unregisterCustomCapabilitiesFilter: function(ge) {
              Q(S, ge);
            }, unregisterLicenseResponseFilter: function(ge) {
              Q(f, ge);
            }, unregisterLicenseRequestFilter: function(ge) {
              Q(c, ge);
            }, addAbrCustomRule: function(ge, Ne, ee) {
              if (typeof ge != "string" || ge !== h.Z.ABANDON_FRAGMENT_RULES && ge !== h.Z.QUALITY_SWITCH_RULES || typeof Ne != "string") throw p.Z.BAD_ARGUMENT_ERROR;
              var Oe = se(Ne);
              Oe === -1 ? q.push({ type: ge, rulename: Ne, rule: ee }) : (q[Oe].type = ge, q[Oe].rule = ee);
            }, removeAllAbrCustomRule: function() {
              q = [];
            }, removeAbrCustomRule: function(ge) {
              if (ge) {
                var Ne = se(ge);
                Ne !== -1 && q.splice(Ne, 1);
              } else q = [];
            }, getAbrCustomRules: function() {
              return q;
            }, addUTCTimingSource: K, removeUTCTimingSource: ie, getUTCTimingSources: function() {
              return m;
            }, clearDefaultUTCTimingSources: function() {
              m = [];
            }, restoreDefaultUTCTimingSources: function() {
              var ge = te.get().streaming.utcSynchronization.defaultTimingSource;
              K(ge.scheme, ge.value);
            }, setXHRWithCredentialsForType: function ge(Ne, ee) {
              Ne ? n[Ne] = !!ee : Object.keys(n).forEach(function(Oe) {
                ge(Oe, ee);
              });
            }, getXHRWithCredentialsForType: function(ge) {
              var Ne = n[ge];
              return Ne === void 0 ? n.default : Ne;
            }, setConfig: function() {
            }, reset: function() {
              P();
            } }, n = { default: !1 }, P(), v;
          }
          o.__dashjs_factory_name = "CustomParametersModel", fe.Z = E.Z.getSingletonFactory(o);
        }, 9032: function(_e, fe, R) {
          var J = R(5448), E = R(7473);
          function t(h) {
            var p = (h = h || {}).requestModifier;
            function o(v) {
              var m = /* @__PURE__ */ new Date(), n = v.request, c = new XMLHttpRequest();
              if (c.open(v.method, v.url, !0), n.responseType && (c.responseType = n.responseType), n.range && c.setRequestHeader("Range", "bytes=" + n.range), n.requestStartDate || (n.requestStartDate = m), p && p.modifyRequestHeader && (c = p.modifyRequestHeader(c, { url: v.url })), v.headers) for (var f in v.headers) {
                var S = v.headers[f];
                S && c.setRequestHeader(f, S);
              }
              c.withCredentials = v.withCredentials, c.onload = v.onload, c.onloadend = v.onend, c.onerror = v.onerror, c.onprogress = v.progress, c.onabort = v.onabort, c.ontimeout = v.ontimeout, c.timeout = v.timeout, c.send(), v.response = c;
            }
            return { load: function(v) {
              p && p.modifyRequest ? (0, E.k)(v, p).then(function() {
                return o(v);
              }) : o(v);
            }, abort: function(v) {
              var m = v.response;
              m.onloadend = m.onerror = m.onprogress = void 0, m.abort();
            } };
          }
          t.__dashjs_factory_name = "XHRLoader";
          var e = J.Z.getClassFactory(t);
          fe.Z = e;
        }, 1737: function(_e, fe, R) {
          function J(Dt, Ct) {
            for (var Rt = 0; Rt < Ct.length; Rt++) {
              var Ke = Ct[Rt];
              Ke.enumerable = Ke.enumerable || !1, Ke.configurable = !0, "value" in Ke && (Ke.writable = !0), Object.defineProperty(Dt, Ke.key, Ke);
            }
          }
          R.d(fe, { default: function() {
            return ui;
          } });
          var E = { attributes: ["Laurl", "laurl"], prefixes: ["clearkey", "dashif"] }, t = function() {
            function Dt() {
              (function(Ke, _t) {
                if (!(Ke instanceof _t)) throw new TypeError("Cannot call a class as a function");
              })(this, Dt);
            }
            var Ct, Rt;
            return Ct = Dt, Rt = [{ key: "findCencContentProtection", value: function(Ke) {
              for (var _t = null, et = 0; et < Ke.length; ++et) {
                var gt = Ke[et];
                gt.schemeIdUri.toLowerCase() !== "urn:mpeg:dash:mp4protection:2011" || gt.value.toLowerCase() !== "cenc" && gt.value.toLowerCase() !== "cbcs" || (_t = gt);
              }
              return _t;
            } }, { key: "getPSSHData", value: function(Ke) {
              var _t = 8, et = new DataView(Ke), gt = et.getUint8(_t);
              return _t += 20, gt > 0 && (_t += 4 + 16 * et.getUint32(_t)), _t += 4, Ke.slice(_t);
            } }, { key: "getPSSHForKeySystem", value: function(Ke, _t) {
              var et = Dt.parsePSSHList(_t);
              return Ke && et.hasOwnProperty(Ke.uuid.toLowerCase()) ? et[Ke.uuid.toLowerCase()] : null;
            } }, { key: "parseInitDataFromContentProtection", value: function(Ke, _t) {
              return "pssh" in Ke ? (Ke.pssh.__text = Ke.pssh.__text.replace(/\r?\n|\r/g, "").replace(/\s+/g, ""), _t.decodeArray(Ke.pssh.__text).buffer) : null;
            } }, { key: "parsePSSHList", value: function(Ke) {
              if (Ke == null) return [];
              for (var _t = new DataView(Ke.buffer || Ke), et = {}, gt = 0; ; ) {
                var Zt, Gt, an = void 0, on = gt;
                if (gt >= _t.buffer.byteLength) break;
                if (Zt = gt + _t.getUint32(gt), gt += 4, _t.getUint32(gt) === 1886614376) if (gt += 4, (Gt = _t.getUint8(gt)) === 0 || Gt === 1) {
                  gt++, gt += 3, an = "";
                  var Kt = void 0, It = void 0;
                  for (Kt = 0; Kt < 4; Kt++) an += (It = _t.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + It : It;
                  for (gt += 4, an += "-", Kt = 0; Kt < 2; Kt++) an += (It = _t.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + It : It;
                  for (gt += 2, an += "-", Kt = 0; Kt < 2; Kt++) an += (It = _t.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + It : It;
                  for (gt += 2, an += "-", Kt = 0; Kt < 2; Kt++) an += (It = _t.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + It : It;
                  for (gt += 2, an += "-", Kt = 0; Kt < 6; Kt++) an += (It = _t.getUint8(gt + Kt).toString(16)).length === 1 ? "0" + It : It;
                  gt += 6, gt += 4, et[an = an.toLowerCase()] = _t.buffer.slice(on, Zt), gt = Zt;
                } else gt = Zt;
                else gt = Zt;
              }
              return et;
            } }, { key: "getLicenseServerUrlFromMediaInfo", value: function(Ke, _t) {
              try {
                if (!Ke || Ke.length === 0) return null;
                for (var et = 0, gt = null; et < Ke.length && !gt; ) {
                  var Zt = Ke[et];
                  if (Zt && Zt.contentProtection && Zt.contentProtection.length > 0) {
                    var Gt = Zt.contentProtection.filter(function(gn) {
                      return gn.schemeIdUri && gn.schemeIdUri === _t;
                    });
                    if (Gt && Gt.length > 0) for (var an = 0; an < Gt.length && !gt; ) {
                      for (var on = Gt[an], Kt = 0; Kt < E.attributes.length && !gt; ) {
                        for (var It = 0, rn = E.attributes[Kt]; It < E.prefixes.length && !gt; ) {
                          var Jt = E.prefixes[It];
                          on[rn] && on[rn].__prefix && on[rn].__prefix === Jt && on[rn].__text && (gt = on[rn].__text), It += 1;
                        }
                        Kt += 1;
                      }
                      an += 1;
                    }
                  }
                  et += 1;
                }
                return gt;
              } catch {
                return null;
              }
            } }], Rt && J(Ct, Rt), Dt;
          }(), e = function Dt(Ct, Rt) {
            (function(Ke, _t) {
              if (!(Ke instanceof _t)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.contentType = Ct, this.robustness = Rt;
          }, h = function Dt(Ct, Rt, Ke, _t, et) {
            (function(gt, Zt) {
              if (!(gt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.initDataTypes = ["cenc"], Ct && Ct.length && (this.audioCapabilities = Ct), Rt && Rt.length && (this.videoCapabilities = Rt), this.distinctiveIdentifier = Ke, this.persistentState = _t, this.sessionTypes = et;
          };
          function p(Dt) {
            return p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ct) {
              return typeof Ct;
            } : function(Ct) {
              return Ct && typeof Symbol == "function" && Ct.constructor === Symbol && Ct !== Symbol.prototype ? "symbol" : typeof Ct;
            }, p(Dt);
          }
          function o(Dt, Ct) {
            return o = Object.setPrototypeOf || function(Rt, Ke) {
              return Rt.__proto__ = Ke, Rt;
            }, o(Dt, Ct);
          }
          function v(Dt, Ct) {
            return !Ct || p(Ct) !== "object" && typeof Ct != "function" ? function(Rt) {
              if (Rt === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return Rt;
            }(Dt) : Ct;
          }
          function m(Dt) {
            return m = Object.setPrototypeOf ? Object.getPrototypeOf : function(Ct) {
              return Ct.__proto__ || Object.getPrototypeOf(Ct);
            }, m(Dt);
          }
          var n = new (function(Dt) {
            (function(et, gt) {
              if (typeof gt != "function" && gt !== null) throw new TypeError("Super expression must either be null or a function");
              et.prototype = Object.create(gt && gt.prototype, { constructor: { value: et, writable: !0, configurable: !0 } }), gt && o(et, gt);
            })(_t, Dt);
            var Ct, Rt, Ke = (Ct = _t, Rt = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var et, gt = m(Ct);
              if (Rt) {
                var Zt = m(this).constructor;
                et = Reflect.construct(gt, arguments, Zt);
              } else et = gt.apply(this, arguments);
              return v(this, et);
            });
            function _t() {
              var et;
              return function(gt, Zt) {
                if (!(gt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
              }(this, _t), (et = Ke.call(this)).MEDIA_KEYERR_CODE = 100, et.MEDIA_KEYERR_UNKNOWN_CODE = 101, et.MEDIA_KEYERR_CLIENT_CODE = 102, et.MEDIA_KEYERR_SERVICE_CODE = 103, et.MEDIA_KEYERR_OUTPUT_CODE = 104, et.MEDIA_KEYERR_HARDWARECHANGE_CODE = 105, et.MEDIA_KEYERR_DOMAIN_CODE = 106, et.MEDIA_KEY_MESSAGE_ERROR_CODE = 107, et.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE = 108, et.SERVER_CERTIFICATE_UPDATED_ERROR_CODE = 109, et.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE = 110, et.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE = 111, et.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE = 112, et.KEY_SESSION_CREATED_ERROR_CODE = 113, et.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE = 114, et.MEDIA_KEYERR_UNKNOWN_MESSAGE = "An unspecified error occurred. This value is used for errors that don't match any of the other codes.", et.MEDIA_KEYERR_CLIENT_MESSAGE = "The Key System could not be installed or updated.", et.MEDIA_KEYERR_SERVICE_MESSAGE = "The message passed into update indicated an error from the license service.", et.MEDIA_KEYERR_OUTPUT_MESSAGE = "There is no available output device with the required characteristics for the content protection system.", et.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE = "A hardware configuration change caused a content protection error.", et.MEDIA_KEYERR_DOMAIN_MESSAGE = "An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.", et.MEDIA_KEY_MESSAGE_ERROR_MESSAGE = "Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!", et.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE = "DRM: Empty key message from CDM", et.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE = "Error updating server certificate -- ", et.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE = "DRM: KeyStatusChange error! -- License has expired", et.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE = "DRM: No license server URL specified!", et.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE = "DRM: KeySystem Access Denied! -- ", et.KEY_SESSION_CREATED_ERROR_MESSAGE = "DRM: unable to create session! --", et.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE = "DRM: licenser error! --", et;
            }
            return _t;
          }(R(2230).Z))(), c = R(5459), f = function Dt(Ct, Rt, Ke, _t, et, gt, Zt, Gt) {
            (function(an, on) {
              if (!(an instanceof on)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.url = Ct, this.method = Rt, this.responseType = Ke, this.headers = _t, this.withCredentials = et, this.messageType = gt, this.sessionId = Zt, this.data = Gt;
          }, S = function Dt(Ct, Rt, Ke) {
            (function(_t, et) {
              if (!(_t instanceof et)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.url = Ct, this.headers = Rt, this.data = Ke;
          }, k = R(7855), q = R(703), F = R(3393), te = R(5448);
          function P(Dt) {
            return P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ct) {
              return typeof Ct;
            } : function(Ct) {
              return Ct && typeof Symbol == "function" && Ct.constructor === Symbol && Ct !== Symbol.prototype ? "symbol" : typeof Ct;
            }, P(Dt);
          }
          function Q(Dt) {
            var Ct, Rt, Ke, _t, et, gt, Zt, Gt, an, on, Kt, It = (Dt = Dt || {}).protectionKeyController, rn = Dt.protectionModel, Jt = Dt.eventBus, gn = Dt.events, bn = Dt.debug, Nn = Dt.BASE64, un = Dt.constants, St = [], Mt = Dt.cmcdModel, jt = Dt.settings, dn = Dt.customParametersModel;
            function pn() {
              if (!(Jt && Jt.hasOwnProperty("on") && It && It.hasOwnProperty("getSupportedKeySystemsFromContentProtection"))) throw new Error("Missing config parameter(s)");
            }
            function Cn(Ft, cn) {
              Gt || an ? Gt && Rn() : function(vn, Kn) {
                if (!an) {
                  an = !0;
                  var Dn, tr = [];
                  vn = vn.sort(function(Xn, Hn) {
                    return (et && et[Xn.ks.systemString] && et[Xn.ks.systemString].priority >= 0 ? et[Xn.ks.systemString].priority : vn.length) - (et && et[Hn.ks.systemString] && et[Hn.ks.systemString].priority >= 0 ? et[Hn.ks.systemString].priority : vn.length);
                  });
                  for (var Bn = 0; Bn < vn.length; Bn++) {
                    var br = qr(vn[Bn]);
                    tr.push({ ks: vn[Bn].ks, configs: [br], protData: vn[Bn].protData });
                  }
                  rn.requestKeySystemAccess(tr).then(function(Xn) {
                    var Hn = (Dn = Xn.data).mksa && Dn.mksa.selectedSystemString ? Dn.mksa.selectedSystemString : Dn.keySystem.systemString;
                    return Rt.info("DRM: KeySystem Access Granted for system string (" + Hn + ")!  Selecting key system..."), rn.selectKeySystem(Dn);
                  }).then(function(Xn) {
                    if (Gt = Xn, an = !1, rn) {
                      Jt.trigger(gn.KEY_SYSTEM_SELECTED, { data: Dn });
                      var Hn = er(Gt);
                      Hn && Hn.serverCertificate && Hn.serverCertificate.length > 0 && rn.setServerCertificate(Nn.decodeArray(Hn.serverCertificate).buffer), Rn();
                    }
                  }).catch(function(Xn) {
                    Gt = null, an = !1, Kn || Jt.trigger(gn.KEY_SYSTEM_SELECTED, { data: null, error: new c.Z(n.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE, n.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE + "Error selecting key system! -- " + Xn.error) });
                  });
                }
              }(Ft, cn);
            }
            function Rn() {
              for (var Ft, cn = 0; cn < Ke.length; cn++) for (Ft = 0; Ft < Ke[cn].length; Ft++) if (Gt === Ke[cn][Ft].ks) {
                ar(Ke[cn][Ft]);
                break;
              }
              Ke = [];
            }
            function ar(Ft) {
              if (It.isClearKey(Gt) && Ft.protData && Ft.protData.hasOwnProperty("clearkeys") && Object.keys(Ft.protData.clearkeys).length !== 0) {
                var cn = { kids: Object.keys(Ft.protData.clearkeys) };
                Ft.initData = new TextEncoder().encode(JSON.stringify(cn));
              }
              Ft.sessionId ? or(Ft) : Ft.initData !== null && Gn(Ft);
            }
            function or(Ft) {
              pn(), rn.loadKeySession(Ft);
            }
            function Gn(Ft) {
              var cn = t.getPSSHForKeySystem(Gt, Ft ? Ft.initData : null);
              if (cn) {
                if (function(vn) {
                  if (!vn) return !1;
                  try {
                    for (var Kn = rn.getSessions(), Dn = 0; Dn < Kn.length; Dn++) if (Kn[Dn].getKeyId() === vn) return !0;
                    return !1;
                  } catch {
                    return !1;
                  }
                }(Ft.keyId) || Yn(cn)) return;
                try {
                  Ft.initData = cn, rn.createKeySession(Ft);
                } catch (vn) {
                  Jt.trigger(gn.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + vn.message) });
                }
              } else Ft && Ft.initData ? rn.createKeySession(Ft) : Jt.trigger(gn.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Selected key system is " + (Gt ? Gt.systemString : null) + ".  needkey/encrypted event contains no initData corresponding to that key system!") });
            }
            function er(Ft) {
              if (Ft) {
                var cn = Ft.systemString;
                if (et) return cn in et ? et[cn] : null;
              }
              return null;
            }
            function Yn(Ft) {
              if (!Ft) return !1;
              try {
                for (var cn = rn.getAllInitData(), vn = 0; vn < cn.length; vn++) if (It.initDataEquals(Ft, cn[vn])) return Rt.debug("DRM: Ignoring initData because we have already seen it!"), !0;
                return !1;
              } catch {
                return !1;
              }
            }
            function sr(Ft) {
              pn(), Ft ? (rn.setMediaElement(Ft), Jt.on(gn.NEED_KEY, fi, Ct)) : Ft === null && (rn.setMediaElement(Ft), Jt.off(gn.NEED_KEY, fi, Ct));
            }
            function qr(Ft) {
              var cn = Ft.protData, vn = [], Kn = [], Dn = cn && cn.audioRobustness && cn.audioRobustness.length > 0 ? cn.audioRobustness : Zt, tr = cn && cn.videoRobustness && cn.videoRobustness.length > 0 ? cn.videoRobustness : Zt, Bn = Ft.sessionType, br = cn && cn.distinctiveIdentifier ? cn.distinctiveIdentifier : "optional", Xn = cn && cn.persistentState ? cn.persistentState : Bn === "temporary" ? "optional" : "required";
              return _t.forEach(function(Hn) {
                Hn.type === un.AUDIO ? vn.push(new e(Hn.codec, Dn)) : Hn.type === un.VIDEO && Kn.push(new e(Hn.codec, tr));
              }), new h(vn, Kn, br, Xn, [Bn]);
            }
            function Dr(Ft) {
              Ft.error ? Jt.trigger(gn.KEY_STATUSES_CHANGED, { data: null, error: Ft.error }) : Rt.debug("DRM: key status = " + Ft.status);
            }
            function Pr(Ft) {
              Rt.debug("DRM: onKeyMessage");
              var cn = Ft.data;
              Jt.trigger(gn.KEY_MESSAGE, { data: cn });
              var vn = cn.messageType ? cn.messageType : "license-request", Kn = cn.message, Dn = cn.sessionToken, tr = er(Gt), Bn = It.getLicenseServerModelInstance(Gt, tr, vn), br = { sessionToken: Dn, messageType: vn };
              if (Kn && Kn.byteLength !== 0) {
                if (!Bn) return Rt.debug("DRM: License server request not required for this message (type = " + Ft.data.messageType + ").  Session ID = " + Dn.getSessionId()), void gr(br);
                if (It.isClearKey(Gt)) {
                  var Xn = It.processClearKeyLicenseRequest(Gt, tr, Kn);
                  if (Xn && Xn.keyPairs && Xn.keyPairs.length > 0) return Rt.debug("DRM: ClearKey license request handled by application!"), gr(br), void rn.updateKeySession(Dn, Xn);
                }
                (function(Hn, hr, mr) {
                  var xr = Hn.sessionToken, Mr = Hn.messageType ? Hn.messageType : "license-request", Fr = { sessionToken: xr, messageType: Mr }, Vr = Gt ? Gt.systemString : null, Ci = function(Un, $r, mi, Jr, Yi) {
                    var Or = null, Ki = Jr.message;
                    if (Un && Un.serverURL) {
                      var jr = Un.serverURL;
                      typeof jr == "string" && jr !== "" ? Or = jr : P(jr) === "object" && jr.hasOwnProperty($r) && (Or = jr[$r]);
                    } else if (Un && Un.laURL && Un.laURL !== "") Or = Un.laURL;
                    else if (!(Or = t.getLicenseServerUrlFromMediaInfo(_t, Gt.schemeIdURI)) && !It.isClearKey(Gt)) {
                      var zi = t.getPSSHData(mi.initData);
                      (Or = Gt.getLicenseServerURLFromInitData(zi)) || (Or = Jr.laURL);
                    }
                    return Or = Yi.getServerURLFromMessage(Or, Ki, $r);
                  }(mr, Mr, xr, Hn, hr);
                  if (Ci) {
                    var di = {}, gi = !1;
                    mr && Zi(di, mr.httpRequestHeaders);
                    var Gi = Hn.message;
                    Zi(di, Gt.getRequestHeadersFromMessage(Gi)), Object.keys(di).forEach(function(Un) {
                      Un.toLowerCase() === "authorization" && (gi = !0);
                    }), mr && typeof mr.withCredentials == "boolean" && (gi = mr.withCredentials);
                    var Hi = function(Un) {
                      if (rn) if (Un.status >= 200 && Un.status <= 299) {
                        var $r = q.Z.parseHttpHeaders(Un.getAllResponseHeaders ? Un.getAllResponseHeaders() : null), mi = new S(Un.responseURL, $r, Un.response);
                        Ui(dn.getLicenseResponseFilters(), mi).then(function() {
                          var Jr = hr.getLicenseMessage(mi.data, Vr, Mr);
                          Jr !== null ? (gr(Fr), rn.updateKeySession(xr, Jr)) : Bi(Un, Fr, Vr, Mr, hr);
                        });
                      } else Bi(Un, Fr, Vr, Mr, hr);
                    }, xa = function(Un) {
                      gr(Fr, new c.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + Vr + ' update, XHR aborted. status is "' + Un.statusText + '" (' + Un.status + "), readyState is " + Un.readyState));
                    }, Fa = function(Un) {
                      gr(Fr, new c.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + Vr + ' update, XHR error. status is "' + Un.statusText + '" (' + Un.status + "), readyState is " + Un.readyState));
                    }, qi = Gt.getLicenseRequestFromMessage(Gi), Vi = hr.getHTTPMethod(Mr), ka = hr.getResponseType(Vr, Mr), wi = mr && !isNaN(mr.httpTimeout) ? mr.httpTimeout : 8e3, ji = xr.getSessionId() || null, hi = new f(Ci, Vi, ka, di, gi, Mr, ji, qi), Za = isNaN(jt.get().streaming.retryAttempts[k.w.LICENSE]) ? 3 : jt.get().streaming.retryAttempts[k.w.LICENSE];
                    Ui(dn.getLicenseRequestFilters(), hi).then(function() {
                      ki(hi, Za, wi, Hi, xa, Fa);
                    });
                  } else gr(Fr, new c.Z(n.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE, n.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));
                })(cn, Bn, tr);
              } else gr(br, new c.Z(n.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE, n.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE));
            }
            function gr(Ft, cn) {
              Jt.trigger(gn.LICENSE_REQUEST_COMPLETE, { data: Ft, error: cn });
            }
            function ki(Ft, cn, vn, Kn, Dn, tr) {
              var Bn = new XMLHttpRequest();
              if (jt.get().streaming.cmcd && jt.get().streaming.cmcd.enabled && jt.get().streaming.cmcd.mode === F.Z.CMCD_MODE_QUERY) {
                var br = Mt.getQueryParameter({ url: Ft.url, type: k.w.LICENSE });
                br && (Ft.url = q.Z.addAditionalQueryParameterToUrl(Ft.url, [br]));
              }
              for (var Xn in Bn.open(Ft.method, Ft.url, !0), Bn.responseType = Ft.responseType, Bn.withCredentials = Ft.withCredentials, vn > 0 && (Bn.timeout = vn), Ft.headers) Bn.setRequestHeader(Xn, Ft.headers[Xn]);
              if (jt.get().streaming.cmcd && jt.get().streaming.cmcd.enabled && jt.get().streaming.cmcd.mode === F.Z.CMCD_MODE_HEADER) {
                var Hn = Mt.getHeaderParameters({ url: Ft.url, type: k.w.LICENSE });
                if (Hn) for (var hr in Hn) {
                  var mr = Hn[hr];
                  mr && Bn.setRequestHeader(hr, mr);
                }
              }
              var xr = function() {
                cn--;
                var Mr = isNaN(jt.get().streaming.retryIntervals[k.w.LICENSE]) ? 1e3 : jt.get().streaming.retryIntervals[k.w.LICENSE];
                Kt = setTimeout(function() {
                  ki(Ft, cn, vn, Kn, Dn, tr);
                }, Mr);
              };
              Bn.onload = function() {
                on = null, this.status >= 200 && this.status <= 299 || cn <= 0 ? Kn(this) : (Rt.warn("License request failed (" + this.status + "). Retrying it... Pending retries: " + cn), xr());
              }, Bn.ontimeout = Bn.onerror = function() {
                on = null, cn <= 0 ? tr(this) : (Rt.warn("License request network request failed . Retrying it... Pending retries: " + cn), xr());
              }, Bn.onabort = function() {
                Dn(this);
              }, Jt.trigger(gn.LICENSE_REQUEST_SENDING, { url: Ft.url, headers: Ft.headers, payload: Ft.data, sessionId: Ft.sessionId }), on = Bn, Bn.send(Ft.data);
            }
            function ci() {
              on && (on.onloadend = on.onerror = on.onprogress = void 0, on.abort(), on = null), Kt && (clearTimeout(Kt), Kt = null);
            }
            function Zi(Ft, cn) {
              if (cn) for (var vn in cn) Ft[vn] = cn[vn];
            }
            function Bi(Ft, cn, vn, Kn, Dn) {
              var tr = "NONE", Bn = null;
              Ft.response && (tr = Dn.getErrorResponse(Ft.response, vn, Kn), Bn = { serverResponse: Ft.response || null, responseCode: Ft.status || null, responseText: Ft.statusText || null }), gr(cn, new c.Z(n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, n.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + vn + ' update, XHR complete. status is "' + Ft.statusText + '" (' + Ft.status + "), readyState is " + Ft.readyState + ".  Response is " + tr, Bn));
            }
            function Ui(Ft, cn) {
              return Ft ? Ft.reduce(function(vn, Kn) {
                return vn.then(function() {
                  return Kn(cn);
                });
              }, Promise.resolve()) : Promise.resolve();
            }
            function fi(Ft, cn) {
              if (!jt.get().streaming.protection.ignoreEmeEncryptedEvent) {
                if (Rt.debug("DRM: onNeedKey"), Ft.key.initDataType !== "cenc") return void Rt.warn("DRM:  Only 'cenc' initData is supported!  Ignoring initData of type: " + Ft.key.initDataType);
                if (_t.length === 0 && (Rt.warn("DRM: onNeedKey called before initializeForMedia, wait until initialized"), (cn = cn === void 0 ? 1 : cn + 1) < 5)) return void St.push(setTimeout(function() {
                  fi(Ft, cn);
                }, 500));
                var vn = Ft.key.initData;
                if (ArrayBuffer.isView(vn) && (vn = vn.buffer), Gt) {
                  var Kn = t.getPSSHForKeySystem(Gt, vn);
                  if (Kn && Yn(Kn)) return;
                }
                Rt.debug("DRM: initData:", String.fromCharCode.apply(null, new Uint8Array(vn)));
                var Dn = It.getSupportedKeySystemsFromSegmentPssh(vn, et, gt);
                if (Dn.length === 0) return void Rt.debug("DRM: Received needkey event with initData, but we don't support any of the key systems!");
                (function(tr) {
                  Ke.push(tr), Cn(tr, !1);
                })(Dn);
              }
            }
            return Ct = { initializeForMedia: function(Ft) {
              if (!Ft) throw new Error("mediaInfo can not be null or undefined");
              pn(), _t.push(Ft);
            }, clearMediaInfoArray: function() {
              _t = [];
            }, handleKeySystemFromManifest: function() {
              if (_t && _t.length !== 0) {
                var Ft = [];
                _t.forEach(function(cn) {
                  var vn = It.getSupportedKeySystemsFromContentProtection(cn.contentProtection, et, gt);
                  vn.length > 0 && (Ft.length === 0 && (Ft = vn), Ke.push(vn));
                }), Ft && Ft.length > 0 && Cn(Ft, !0);
              }
            }, createKeySession: Gn, loadKeySession: or, removeKeySession: function(Ft) {
              pn(), rn.removeKeySession(Ft);
            }, closeKeySession: function(Ft) {
              pn(), rn.closeKeySession(Ft);
            }, setServerCertificate: function(Ft) {
              pn(), rn.setServerCertificate(Ft);
            }, setMediaElement: sr, setSessionType: function(Ft) {
              gt = Ft;
            }, setRobustnessLevel: function(Ft) {
              Zt = Ft;
            }, setProtectionData: function(Ft) {
              et = Ft, It.setProtectionData(Ft);
            }, getSupportedKeySystemsFromContentProtection: function(Ft) {
              return pn(), It.getSupportedKeySystemsFromContentProtection(Ft, et, gt);
            }, getKeySystems: function() {
              return It ? It.getKeySystems() : [];
            }, setKeySystems: function(Ft) {
              It && It.setKeySystems(Ft);
            }, stop: function() {
              ci(), rn && rn.stop();
            }, reset: function() {
              Jt.off(gn.INTERNAL_KEY_MESSAGE, Pr, Ct), Jt.off(gn.INTERNAL_KEY_STATUS_CHANGED, Dr, Ct), pn(), ci(), sr(null), Gt = null, an = !1, rn && (rn.reset(), rn = null), St.forEach(function(Ft) {
                return clearTimeout(Ft);
              }), St = [], _t = [], Ke = [];
            } }, Rt = bn.getLogger(Ct), Ke = [], _t = [], gt = "temporary", Zt = "", on = null, Kt = null, Jt.on(gn.INTERNAL_KEY_MESSAGE, Pr, Ct), Jt.on(gn.INTERNAL_KEY_STATUS_CHANGED, Dr, Ct), Ct;
          }
          Q.__dashjs_factory_name = "ProtectionController";
          var se = te.Z.getClassFactory(Q), K = function Dt(Ct, Rt) {
            (function(Ke, _t) {
              if (!(Ke instanceof _t)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.keyID = Ct, this.key = Rt;
          };
          function ie(Dt, Ct) {
            for (var Rt = 0; Rt < Ct.length; Rt++) {
              var Ke = Ct[Rt];
              Ke.enumerable = Ke.enumerable || !1, Ke.configurable = !0, "value" in Ke && (Ke.writable = !0), Object.defineProperty(Dt, Ke.key, Ke);
            }
          }
          var ge = function() {
            function Dt(Ke, _t) {
              if (function(et, gt) {
                if (!(et instanceof gt)) throw new TypeError("Cannot call a class as a function");
              }(this, Dt), _t && _t !== "persistent" && _t !== "temporary") throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");
              this.keyPairs = Ke, this.type = _t;
            }
            var Ct, Rt;
            return Ct = Dt, (Rt = [{ key: "toJWK", value: function() {
              var Ke, _t = this.keyPairs.length, et = { keys: [] };
              for (Ke = 0; Ke < _t; Ke++) {
                var gt = { kty: "oct", alg: "A128KW", kid: this.keyPairs[Ke].keyID, k: this.keyPairs[Ke].key };
                et.keys.push(gt);
              }
              this.type && (et.type = this.type);
              var Zt = JSON.stringify(et), Gt = Zt.length, an = new ArrayBuffer(Gt), on = new Uint8Array(an);
              for (Ke = 0; Ke < Gt; Ke++) on[Ke] = Zt.charCodeAt(Ke);
              return an;
            } }]) && ie(Ct.prototype, Rt), Dt;
          }();
          function Ne(Dt, Ct) {
            for (var Rt = 0; Rt < Ct.length; Rt++) {
              var Ke = Ct[Rt];
              Ke.enumerable = Ke.enumerable || !1, Ke.configurable = !0, "value" in Ke && (Ke.writable = !0), Object.defineProperty(Dt, Ke.key, Ke);
            }
          }
          var ee = new (function() {
            function Dt() {
              (function(Ke, _t) {
                if (!(Ke instanceof _t)) throw new TypeError("Cannot call a class as a function");
              })(this, Dt), this.init();
            }
            var Ct, Rt;
            return Ct = Dt, (Rt = [{ key: "init", value: function() {
              this.CLEARKEY_KEYSTEM_STRING = "org.w3.clearkey", this.WIDEVINE_KEYSTEM_STRING = "com.widevine.alpha", this.PLAYREADY_KEYSTEM_STRING = "com.microsoft.playready", this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING = "com.microsoft.playready.recommendation", this.INITIALIZATION_DATA_TYPE_CENC = "cenc", this.INITIALIZATION_DATA_TYPE_KEYIDS = "keyids", this.INITIALIZATION_DATA_TYPE_WEBM = "webm";
            } }]) && Ne(Ct.prototype, Rt), Dt;
          }())(), Oe = "e2719d58-a985-b3c9-781a-b030af78d30e", Ge = ee.CLEARKEY_KEYSTEM_STRING, Xe = "urn:uuid:" + Oe;
          function Ce(Dt) {
            var Ct = (Dt = Dt || {}).BASE64;
            return { uuid: Oe, schemeIdURI: Xe, systemString: Ge, getInitData: function(Rt, Ke) {
              try {
                var _t = t.parseInitDataFromContentProtection(Rt, Ct);
                if (!_t && Ke) {
                  var et = { kids: [function(gt) {
                    try {
                      var Zt = gt.replace(/-/g, "");
                      return (Zt = btoa(Zt.match(/\w{2}/g).map(function(Gt) {
                        return String.fromCharCode(parseInt(Gt, 16));
                      }).join(""))).replace(/=/g, "").replace(/\//g, "_").replace(/\+/g, "-");
                    } catch {
                      return null;
                    }
                  }(Ke["cenc:default_KID"])] };
                  _t = new TextEncoder().encode(JSON.stringify(et));
                }
                return _t;
              } catch {
                return null;
              }
            }, getRequestHeadersFromMessage: function() {
              return { "Content-Type": "application/json" };
            }, getLicenseRequestFromMessage: function(Rt) {
              return JSON.stringify(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(Rt))));
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            }, getClearKeysFromProtectionData: function(Rt, Ke) {
              var _t = null;
              if (Rt) {
                for (var et = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(Ke))), gt = [], Zt = 0; Zt < et.kids.length; Zt++) {
                  var Gt = et.kids[Zt], an = Rt.clearkeys && Rt.clearkeys.hasOwnProperty(Gt) ? Rt.clearkeys[Gt] : null;
                  if (!an) throw new Error("DRM: ClearKey keyID (" + Gt + ") is not known!");
                  gt.push(new K(Gt, an));
                }
                _t = new ge(gt);
              }
              return _t;
            } };
          }
          Ce.__dashjs_factory_name = "KeySystemClearKey";
          var Ue = dashjs.FactoryMaker.getSingletonFactory(Ce), Je = "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b", st = ee.CLEARKEY_KEYSTEM_STRING, we = "urn:uuid:" + Je;
          function Be(Dt) {
            var Ct, Rt = Dt.BASE64, Ke = Dt.debug.getLogger(Ct);
            return { uuid: Je, schemeIdURI: we, systemString: st, getInitData: function(_t) {
              return t.parseInitDataFromContentProtection(_t, Rt);
            }, getRequestHeadersFromMessage: function() {
              return null;
            }, getLicenseRequestFromMessage: function(_t) {
              return new Uint8Array(_t);
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            }, getClearKeysFromProtectionData: function(_t, et) {
              var gt = null;
              if (_t) {
                for (var Zt = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(et))), Gt = [], an = 0; an < Zt.kids.length; an++) {
                  var on = Zt.kids[an], Kt = _t.clearkeys && _t.clearkeys.hasOwnProperty(on) ? _t.clearkeys[on] : null;
                  if (!Kt) throw new Error("DRM: ClearKey keyID (" + on + ") is not known!");
                  Gt.push(new K(on, Kt));
                }
                gt = new ge(Gt), Ke.warn("ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4");
              }
              return gt;
            } };
          }
          Be.__dashjs_factory_name = "KeySystemW3CClearKey";
          var At = dashjs.FactoryMaker.getSingletonFactory(Be), ht = "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", je = ee.WIDEVINE_KEYSTEM_STRING, it = "urn:uuid:" + ht;
          function ve(Dt) {
            var Ct = (Dt = Dt || {}).BASE64;
            return { uuid: ht, schemeIdURI: it, systemString: je, getInitData: function(Rt) {
              return t.parseInitDataFromContentProtection(Rt, Ct);
            }, getRequestHeadersFromMessage: function() {
              return null;
            }, getLicenseRequestFromMessage: function(Rt) {
              return new Uint8Array(Rt);
            }, getLicenseServerURLFromInitData: function() {
              return null;
            }, getCDMData: function() {
              return null;
            } };
          }
          ve.__dashjs_factory_name = "KeySystemWidevine";
          var Se = dashjs.FactoryMaker.getSingletonFactory(ve), Ye = "9a04f079-9840-4286-ab92-e65be0885f95", d = ee.PLAYREADY_KEYSTEM_STRING, l = "urn:uuid:" + Ye;
          function T(Dt) {
            var Ct = "utf-16", Rt = (Dt = Dt || {}).BASE64, Ke = Dt.settings;
            function _t() {
              if (!Rt || !Rt.hasOwnProperty("decodeArray") || !Rt.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
            }
            return { uuid: Ye, schemeIdURI: l, systemString: d, getInitData: function(et) {
              var gt, Zt, Gt, an, on, Kt = new Uint8Array([112, 115, 115, 104, 0, 0, 0, 0]), It = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]), rn = 0, Jt = null;
              if (_t(), !et) return null;
              if ("pssh" in et) return t.parseInitDataFromContentProtection(et, Rt);
              if ("pro" in et) Jt = Rt.decodeArray(et.pro.__text);
              else {
                if (!("prheader" in et)) return null;
                Jt = Rt.decodeArray(et.prheader.__text);
              }
              return gt = Jt.length, Zt = 4 + Kt.length + It.length + 4 + gt, Gt = new ArrayBuffer(Zt), an = new Uint8Array(Gt), (on = new DataView(Gt)).setUint32(rn, Zt), rn += 4, an.set(Kt, rn), rn += Kt.length, an.set(It, rn), rn += It.length, on.setUint32(rn, gt), rn += 4, an.set(Jt, rn), rn += gt, an.buffer;
            }, getRequestHeadersFromMessage: function(et) {
              var gt, Zt, Gt = {}, an = new DOMParser();
              if (Ke && Ke.get().streaming.protection.detectPlayreadyMessageFormat && Ct === "utf-16" && et && et.byteLength % 2 == 1) return Gt["Content-Type"] = "text/xml; charset=utf-8", Gt;
              var on = Ct === "utf-16" ? new Uint16Array(et) : new Uint8Array(et);
              gt = String.fromCharCode.apply(null, on);
              for (var Kt = (Zt = an.parseFromString(gt, "application/xml")).getElementsByTagName("name"), It = Zt.getElementsByTagName("value"), rn = 0; rn < Kt.length; rn++) Gt[Kt[rn].childNodes[0].nodeValue] = It[rn].childNodes[0].nodeValue;
              return Gt.hasOwnProperty("Content") && (Gt["Content-Type"] = Gt.Content, delete Gt.Content), Gt.hasOwnProperty("Content-Type") || (Gt["Content-Type"] = "text/xml; charset=utf-8"), Gt;
            }, getLicenseRequestFromMessage: function(et) {
              var gt = null, Zt = new DOMParser();
              if (Ke && Ke.get().streaming.protection.detectPlayreadyMessageFormat && Ct === "utf-16" && et && et.byteLength % 2 == 1) return et;
              var Gt = Ct === "utf-16" ? new Uint16Array(et) : new Uint8Array(et);
              _t();
              var an = String.fromCharCode.apply(null, Gt), on = Zt.parseFromString(an, "application/xml");
              if (!on.getElementsByTagName("PlayReadyKeyMessage")[0]) return et;
              var Kt = on.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;
              return Kt && (gt = Rt.decode(Kt)), gt;
            }, getLicenseServerURLFromInitData: function(et) {
              if (et) for (var gt = new DataView(et), Zt = gt.getUint16(4, !0), Gt = 6, an = new DOMParser(), on = 0; on < Zt; on++) {
                var Kt = gt.getUint16(Gt, !0);
                Gt += 2;
                var It = gt.getUint16(Gt, !0);
                if (Gt += 2, Kt === 1) {
                  var rn = et.slice(Gt, Gt + It), Jt = String.fromCharCode.apply(null, new Uint16Array(rn)), gn = an.parseFromString(Jt, "application/xml");
                  if (gn.getElementsByTagName("LA_URL")[0]) {
                    var bn = gn.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;
                    if (bn) return bn;
                  }
                  if (gn.getElementsByTagName("LUI_URL")[0]) {
                    var Nn = gn.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;
                    if (Nn) return Nn;
                  }
                } else Gt += It;
              }
              return null;
            }, getCDMData: function(et) {
              var gt, Zt, Gt, an;
              if (_t(), !et) return null;
              for (gt = [], an = 0; an < et.length; ++an) gt.push(et.charCodeAt(an)), gt.push(0);
              for (gt = String.fromCharCode.apply(null, gt), gt = Rt.encode(gt), Zt = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>'.replace("%CUSTOMDATA%", gt), Gt = [], an = 0; an < Zt.length; ++an) Gt.push(Zt.charCodeAt(an)), Gt.push(0);
              return new Uint8Array(Gt).buffer;
            }, setPlayReadyMessageFormat: function(et) {
              if (et !== "utf-8" && et !== "utf-16") throw new Error('Specified message format is not one of "utf-8" or "utf-16"');
              Ct = et;
            } };
          }
          T.__dashjs_factory_name = "KeySystemPlayReady";
          var b = dashjs.FactoryMaker.getSingletonFactory(T);
          function $(Dt) {
            var Ct = (Dt = Dt || {}).BASE64, Rt = {};
            return Rt[ee.WIDEVINE_KEYSTEM_STRING] = { responseType: "json", getLicenseMessage: function(Ke) {
              return Ct.decodeArray(Ke.license);
            }, getErrorResponse: function(Ke) {
              return Ke;
            } }, Rt[ee.PLAYREADY_KEYSTEM_STRING] = { responseType: "arraybuffer", getLicenseMessage: function(Ke) {
              return Ke;
            }, getErrorResponse: function(Ke) {
              return String.fromCharCode.apply(null, new Uint8Array(Ke));
            } }, { getServerURLFromMessage: function(Ke) {
              return Ke;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function(Ke) {
              return Rt[Ke].responseType;
            }, getLicenseMessage: function(Ke, _t) {
              return function() {
                if (!Ct || !Ct.hasOwnProperty("decodeArray")) throw new Error("Missing config parameter(s)");
              }(), Rt[_t].getLicenseMessage(Ke);
            }, getErrorResponse: function(Ke, _t) {
              return Rt[_t].getErrorResponse(Ke);
            } };
          }
          $.__dashjs_factory_name = "DRMToday";
          var W = dashjs.FactoryMaker.getSingletonFactory($);
          function Ie() {
            var Dt = "http://schemas.xmlsoap.org/soap/envelope/";
            function Ct(_t) {
              var et = String.fromCharCode.apply(null, new Uint8Array(_t));
              return decodeURIComponent(escape(et));
            }
            function Rt(_t) {
              if (window.DOMParser) {
                var et = Ct(_t), gt = new window.DOMParser().parseFromString(et, "text/xml"), Zt = gt ? gt.getElementsByTagNameNS(Dt, "Envelope")[0] : null, Gt = Zt ? Zt.getElementsByTagNameNS(Dt, "Body")[0] : null;
                if (Gt && Gt.getElementsByTagNameNS(Dt, "Fault")[0]) return null;
              }
              return _t;
            }
            function Ke(_t) {
              var et = "", gt = "", Zt = "", Gt = -1, an = -1;
              if (window.DOMParser) {
                var on = Ct(_t), Kt = new window.DOMParser().parseFromString(on, "text/xml"), It = Kt ? Kt.getElementsByTagNameNS(Dt, "Envelope")[0] : null, rn = It ? It.getElementsByTagNameNS(Dt, "Body")[0] : null, Jt = rn ? rn.getElementsByTagNameNS(Dt, "Fault")[0] : null, gn = Jt ? Jt.getElementsByTagName("detail")[0] : null, bn = gn ? gn.getElementsByTagName("Exception")[0] : null, Nn = null;
                if (Jt === null) return on;
                et = (Nn = Jt.getElementsByTagName("faultstring")[0].firstChild) ? Nn.nodeValue : null, bn !== null && (gt = (Nn = bn.getElementsByTagName("StatusCode")[0]) ? Nn.firstChild.nodeValue : null, Gt = (Zt = (Nn = bn.getElementsByTagName("Message")[0]) ? Nn.firstChild.nodeValue : null) ? Zt.lastIndexOf("[") + 1 : -1, an = Zt ? Zt.indexOf("]") : -1, Zt = Zt ? Zt.substring(Gt, an) : "");
              }
              var un = "code: ".concat(gt, ", name: ").concat(et);
              return Zt && (un += ", message: ".concat(Zt)), un;
            }
            return { getServerURLFromMessage: function(_t) {
              return _t;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "arraybuffer";
            }, getLicenseMessage: function(_t) {
              return Rt.call(this, _t);
            }, getErrorResponse: function(_t) {
              return Ke.call(this, _t);
            } };
          }
          Ie.__dashjs_factory_name = "PlayReady";
          var $e = te.Z.getSingletonFactory(Ie);
          function Ze() {
            return { getServerURLFromMessage: function(Dt) {
              return Dt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "arraybuffer";
            }, getLicenseMessage: function(Dt) {
              return Dt;
            }, getErrorResponse: function(Dt) {
              return String.fromCharCode.apply(null, new Uint8Array(Dt));
            } };
          }
          Ze.__dashjs_factory_name = "Widevine";
          var xe = dashjs.FactoryMaker.getSingletonFactory(Ze);
          function Me() {
            return { getServerURLFromMessage: function(Dt) {
              return Dt;
            }, getHTTPMethod: function() {
              return "POST";
            }, getResponseType: function() {
              return "json";
            }, getLicenseMessage: function(Dt) {
              if (!Dt.hasOwnProperty("keys")) return null;
              for (var Ct = [], Rt = 0; Rt < Dt.keys.length; Rt++) {
                var Ke = Dt.keys[Rt], _t = Ke.kid.replace(/=/g, ""), et = Ke.k.replace(/=/g, "");
                Ct.push(new K(_t, et));
              }
              return new ge(Ct);
            }, getErrorResponse: function(Dt) {
              return String.fromCharCode.apply(null, new Uint8Array(Dt));
            } };
          }
          Me.__dashjs_factory_name = "ClearKey";
          var Ve = dashjs.FactoryMaker.getSingletonFactory(Me);
          function ot() {
            var Dt, Ct, Rt, Ke, _t, et, gt, Zt, Gt = this.context;
            function an(It, rn) {
              return rn && It in rn ? rn[It] : null;
            }
            function on(It, rn) {
              return It && It.sessionId ? It.sessionId : rn && rn.sessionId ? rn.sessionId : null;
            }
            function Kt(It, rn) {
              return It && It.sessionType ? It.sessionType : rn;
            }
            return Dt = { initialize: function() {
              var It;
              Ke = [], It = b(Gt).getInstance({ BASE64: _t, settings: et }), Ke.push(It), It = Se(Gt).getInstance({ BASE64: _t }), Ke.push(It), It = Ue(Gt).getInstance({ BASE64: _t }), Ke.push(It), gt = It, It = At(Gt).getInstance({ BASE64: _t, debug: Ct }), Ke.push(It), Zt = It;
            }, setProtectionData: function(It) {
              for (var rn, Jt, gn = 0; gn < Ke.length; gn++) {
                var bn = Ke[gn];
                bn.hasOwnProperty("init") && bn.init((rn = bn.systemString, Jt = void 0, Jt = null, It && (Jt = rn in It ? It[rn] : null), Jt));
              }
            }, isClearKey: function(It) {
              return It === gt || It === Zt;
            }, initDataEquals: function(It, rn) {
              if (It.byteLength === rn.byteLength) {
                for (var Jt = new Uint8Array(It), gn = new Uint8Array(rn), bn = 0; bn < Jt.length; bn++) if (Jt[bn] !== gn[bn]) return !1;
                return !0;
              }
              return !1;
            }, getKeySystems: function() {
              return Ke;
            }, setKeySystems: function(It) {
              Ke = It;
            }, getKeySystemBySystemString: function(It) {
              for (var rn = 0; rn < Ke.length; rn++) if (Ke[rn].systemString === It) return Ke[rn];
              return null;
            }, getSupportedKeySystemsFromContentProtection: function(It, rn, Jt) {
              var gn, bn, Nn, un, St = [];
              if (It) {
                var Mt = t.findCencContentProtection(It);
                for (Nn = 0; Nn < Ke.length; ++Nn) {
                  var jt = an((bn = Ke[Nn]).systemString, rn);
                  for (un = 0; un < It.length; ++un) if ((gn = It[un]).schemeIdUri.toLowerCase() === bn.schemeIdURI) {
                    var dn = bn.getInitData(gn, Mt);
                    St.push({ ks: Ke[Nn], keyId: gn.keyId, initData: dn, protData: jt, cdmData: bn.getCDMData(jt ? jt.cdmData : null), sessionId: on(jt, gn), sessionType: Kt(jt, Jt) });
                  }
                }
              }
              return St;
            }, getSupportedKeySystemsFromSegmentPssh: function(It, rn, Jt) {
              for (var gn, bn = [], Nn = t.parsePSSHList(It), un = 0; un < Ke.length; ++un) {
                var St = an((gn = Ke[un]).systemString, rn);
                gn.uuid in Nn && bn.push({ ks: gn, initData: Nn[gn.uuid], protData: St, cdmData: gn.getCDMData(St ? St.cdmData : null), sessionId: on(St), sessionType: Kt(St, Jt) });
              }
              return bn;
            }, getLicenseServerModelInstance: function(It, rn, Jt) {
              if (Jt === "license-release" || Jt === "individualization-request") return null;
              var gn = null;
              return rn && rn.hasOwnProperty("drmtoday") ? gn = W(Gt).getInstance({ BASE64: _t }) : It.systemString === ee.WIDEVINE_KEYSTEM_STRING ? gn = xe(Gt).getInstance() : It.systemString === ee.PLAYREADY_KEYSTEM_STRING ? gn = $e(Gt).getInstance() : It.systemString === ee.CLEARKEY_KEYSTEM_STRING && (gn = Ve(Gt).getInstance()), gn;
            }, processClearKeyLicenseRequest: function(It, rn, Jt) {
              try {
                return It.getClearKeysFromProtectionData(rn, Jt);
              } catch {
                return Rt.error("Failed to retrieve clearkeys from ProtectionData"), null;
              }
            }, setConfig: function(It) {
              It && (It.debug && (Ct = It.debug, Rt = Ct.getLogger(Dt)), It.BASE64 && (_t = It.BASE64), It.settings && (et = It.settings));
            } }, Dt;
          }
          ot.__dashjs_factory_name = "ProtectionKeyController";
          var bt = dashjs.FactoryMaker.getSingletonFactory(ot);
          function dt(Dt) {
            return dt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ct) {
              return typeof Ct;
            } : function(Ct) {
              return Ct && typeof Symbol == "function" && Ct.constructor === Symbol && Ct !== Symbol.prototype ? "symbol" : typeof Ct;
            }, dt(Dt);
          }
          function Yt(Dt, Ct) {
            return Yt = Object.setPrototypeOf || function(Rt, Ke) {
              return Rt.__proto__ = Ke, Rt;
            }, Yt(Dt, Ct);
          }
          function Ot(Dt, Ct) {
            return !Ct || dt(Ct) !== "object" && typeof Ct != "function" ? function(Rt) {
              if (Rt === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return Rt;
            }(Dt) : Ct;
          }
          function Ht(Dt) {
            return Ht = Object.setPrototypeOf ? Object.getPrototypeOf : function(Ct) {
              return Ct.__proto__ || Object.getPrototypeOf(Ct);
            }, Ht(Dt);
          }
          var Ut = new (function(Dt) {
            (function(et, gt) {
              if (typeof gt != "function" && gt !== null) throw new TypeError("Super expression must either be null or a function");
              et.prototype = Object.create(gt && gt.prototype, { constructor: { value: et, writable: !0, configurable: !0 } }), gt && Yt(et, gt);
            })(_t, Dt);
            var Ct, Rt, Ke = (Ct = _t, Rt = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }(), function() {
              var et, gt = Ht(Ct);
              if (Rt) {
                var Zt = Ht(this).constructor;
                et = Reflect.construct(gt, arguments, Zt);
              } else et = gt.apply(this, arguments);
              return Ot(this, et);
            });
            function _t() {
              var et;
              return function(gt, Zt) {
                if (!(gt instanceof Zt)) throw new TypeError("Cannot call a class as a function");
              }(this, _t), (et = Ke.call(this)).INTERNAL_KEY_MESSAGE = "internalKeyMessage", et.INTERNAL_KEY_STATUS_CHANGED = "internalkeyStatusChanged", et.KEY_ADDED = "public_keyAdded", et.KEY_ERROR = "public_keyError", et.KEY_MESSAGE = "public_keyMessage", et.KEY_SESSION_CLOSED = "public_keySessionClosed", et.KEY_SESSION_CREATED = "public_keySessionCreated", et.KEY_SESSION_REMOVED = "public_keySessionRemoved", et.KEY_STATUSES_CHANGED = "public_keyStatusesChanged", et.KEY_SYSTEM_ACCESS_COMPLETE = "public_keySystemAccessComplete", et.KEY_SYSTEM_SELECTED = "public_keySystemSelected", et.LICENSE_REQUEST_COMPLETE = "public_licenseRequestComplete", et.LICENSE_REQUEST_SENDING = "public_licenseRequestSending", et.NEED_KEY = "needkey", et.PROTECTION_CREATED = "public_protectioncreated", et.PROTECTION_DESTROYED = "public_protectiondestroyed", et.SERVER_CERTIFICATE_UPDATED = "serverCertificateUpdated", et.TEARDOWN_COMPLETE = "protectionTeardownComplete", et.VIDEO_ELEMENT_SELECTED = "videoElementSelected", et.KEY_SESSION_UPDATED = "public_keySessionUpdated", et;
            }
            return _t;
          }(R(8342).Z))(), fn = function Dt(Ct, Rt) {
            (function(Ke, _t) {
              if (!(Ke instanceof _t)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.initData = Ct, this.initDataType = Rt;
          }, Tn = function Dt(Ct, Rt, Ke, _t) {
            (function(et, gt) {
              if (!(et instanceof gt)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.sessionToken = Ct, this.message = Rt, this.defaultURL = Ke, this.messageType = _t || "license-request";
          }, Fn = function Dt(Ct, Rt) {
            (function(Ke, _t) {
              if (!(Ke instanceof _t)) throw new TypeError("Cannot call a class as a function");
            })(this, Dt), this.keySystem = Ct, this.ksConfiguration = Rt;
          }, On = {};
          function Zn(Dt) {
            Dt = Dt || {};
            var Ct, Rt, Ke, _t, et, gt, Zt, Gt, an = this.context, on = Dt.eventBus, Kt = Dt.events, It = Dt.debug;
            function rn(St, Mt, jt, dn) {
              if (navigator.requestMediaKeySystemAccess === void 0 || typeof navigator.requestMediaKeySystemAccess != "function") {
                var pn = "Insecure origins are not allowed";
                return on.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { error: pn }), void dn({ error: pn });
              }
              var Cn = St[Mt].protData && St[Mt].protData.systemStringPriority ? St[Mt].protData.systemStringPriority : null, Rn = St[Mt].configs, ar = St[Mt].ks, or = ar.systemString;
              (function(Gn, er) {
                return new Promise(function(Yn, sr) {
                  Jt(Gn, er, 0, Yn, sr);
                });
              })(Cn || (On[or] ? On[or] : [or]), Rn).then(function(Gn) {
                var er = typeof Gn.getConfiguration == "function" ? Gn.getConfiguration() : null, Yn = new Fn(ar, er);
                Yn.mksa = Gn, on.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { data: Yn }), jt({ data: Yn });
              }).catch(function(Gn) {
                if (Mt + 1 < St.length) rn(St, Mt + 1, jt, dn);
                else {
                  var er = "Key system access denied! ";
                  on.trigger(Kt.KEY_SYSTEM_ACCESS_COMPLETE, { error: er + Gn.message }), dn({ error: er + Gn.message });
                }
              });
            }
            function Jt(St, Mt, jt, dn, pn) {
              var Cn = St[jt];
              Rt.debug("Requesting key system access for system string ".concat(Cn)), navigator.requestMediaKeySystemAccess(Cn, Mt).then(function(Rn) {
                Rn.selectedSystemString = Cn, dn(Rn);
              }).catch(function(Rn) {
                jt + 1 < St.length ? Jt(St, Mt, jt + 1, dn, pn) : pn(Rn);
              });
            }
            function gn(St) {
              if (!St || !St.session) return Promise.resolve;
              var Mt = St.session;
              return Mt.removeEventListener("keystatuseschange", St), Mt.removeEventListener("message", St), Mt.close();
            }
            function bn(St) {
              for (var Mt = 0; Mt < gt.length; Mt++) if (gt[Mt] === St) {
                gt.splice(Mt, 1);
                break;
              }
            }
            function Nn(St) {
              var Mt, jt;
              return St && St.length > 0 && (St[0] && (typeof St[0] == "string" ? Mt = St[0] : jt = St[0]), St[1] && (typeof St[1] == "string" ? Mt = St[1] : jt = St[1])), { status: Mt, keyId: jt };
            }
            function un(St, Mt) {
              var jt = { session: St, keyId: Mt.keyId, initData: Mt.initData, sessionId: Mt.sessionId, sessionType: Mt.sessionType, handleEvent: function(dn) {
                switch (dn.type) {
                  case "keystatuseschange":
                    on.trigger(Kt.KEY_STATUSES_CHANGED, { data: this }), dn.target.keyStatuses.forEach(function() {
                      var Cn = Nn(arguments);
                      Cn.status === "expired" ? on.trigger(Kt.INTERNAL_KEY_STATUS_CHANGED, { error: new c.Z(n.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE, n.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE) }) : on.trigger(Kt.INTERNAL_KEY_STATUS_CHANGED, Cn);
                    });
                    break;
                  case "message":
                    var pn = ArrayBuffer.isView(dn.message) ? dn.message.buffer : dn.message;
                    on.trigger(Kt.INTERNAL_KEY_MESSAGE, { data: new Tn(this, pn, void 0, dn.messageType) });
                }
              }, getKeyId: function() {
                return this.keyId;
              }, getSessionId: function() {
                return St.sessionId;
              }, getSessionType: function() {
                return this.sessionType;
              }, getExpirationTime: function() {
                return St.expiration;
              }, getKeyStatuses: function() {
                return St.keyStatuses;
              }, getUsable: function() {
                var dn = !1;
                return St.keyStatuses.forEach(function() {
                  var pn = Nn(arguments);
                  pn.status === "usable" && (dn = !0);
                }), dn;
              } };
              return St.addEventListener("keystatuseschange", jt), St.addEventListener("message", jt), St.closed.then(function() {
                bn(jt), Rt.debug("DRM: Session closed.  SessionID = " + jt.getSessionId()), on.trigger(Kt.KEY_SESSION_CLOSED, { data: jt.getSessionId() });
              }), gt.push(jt), jt;
            }
            return Ct = { getAllInitData: function() {
              for (var St = [], Mt = 0; Mt < gt.length; Mt++) gt[Mt].initData && St.push(gt[Mt].initData);
              return St;
            }, getSessions: function() {
              return gt;
            }, requestKeySystemAccess: function(St) {
              return new Promise(function(Mt, jt) {
                rn(St, 0, Mt, jt);
              });
            }, selectKeySystem: function(St) {
              return new Promise(function(Mt, jt) {
                St.mksa.createMediaKeys().then(function(dn) {
                  return Ke = St.keySystem, et = dn, _t ? _t.setMediaKeys(et) : Promise.resolve();
                }).then(function() {
                  Mt(Ke);
                }).catch(function() {
                  jt({ error: "Error selecting keys system (" + St.keySystem.systemString + ")! Could not create MediaKeys -- TODO" });
                });
              });
            }, setMediaElement: function(St) {
              _t !== St && (_t && (_t.removeEventListener("encrypted", Zt), _t.setMediaKeys && _t.setMediaKeys(null)), (_t = St) && (_t.addEventListener("encrypted", Zt), _t.setMediaKeys && et && _t.setMediaKeys(et)));
            }, setServerCertificate: function(St) {
              if (!Ke || !et) throw new Error("Can not set server certificate until you have selected a key system");
              et.setServerCertificate(St).then(function() {
                Rt.info("DRM: License server certificate successfully updated."), on.trigger(Kt.SERVER_CERTIFICATE_UPDATED);
              }).catch(function(Mt) {
                on.trigger(Kt.SERVER_CERTIFICATE_UPDATED, { error: new c.Z(n.SERVER_CERTIFICATE_UPDATED_ERROR_CODE, n.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE + Mt.name) });
              });
            }, createKeySession: function(St) {
              if (!Ke || !et) throw new Error("Can not create sessions until you have selected a key system");
              var Mt = et.createSession(St.sessionType), jt = un(Mt, St), dn = Ke.systemString === ee.CLEARKEY_KEYSTEM_STRING && (St.initData || St.protData && St.protData.clearkeys) ? ee.INITIALIZATION_DATA_TYPE_KEYIDS : ee.INITIALIZATION_DATA_TYPE_CENC;
              Mt.generateRequest(dn, St.initData).then(function() {
                Rt.debug("DRM: Session created.  SessionID = " + jt.getSessionId()), on.trigger(Kt.KEY_SESSION_CREATED, { data: jt });
              }).catch(function(pn) {
                bn(jt), on.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Error generating key request -- " + pn.name) });
              });
            }, updateKeySession: function(St, Mt) {
              var jt = St.session;
              Gt.isClearKey(Ke) && (Mt = Mt.toJWK()), jt.update(Mt).then(function() {
                on.trigger(Kt.KEY_SESSION_UPDATED);
              }).catch(function(dn) {
                on.trigger(Kt.KEY_ERROR, { error: new c.Z(n.MEDIA_KEYERR_CODE, "Error sending update() message! " + dn.name, St) });
              });
            }, loadKeySession: function(St) {
              if (!Ke || !et) throw new Error("Can not load sessions until you have selected a key system");
              for (var Mt = St.sessionId, jt = 0; jt < gt.length; jt++) if (Mt === gt[jt].sessionId) return void Rt.warn("DRM: Ignoring session ID because we have already seen it!");
              var dn = et.createSession(St.sessionType), pn = un(dn, St);
              dn.load(Mt).then(function(Cn) {
                Cn ? (Rt.debug("DRM: Session loaded.  SessionID = " + pn.getSessionId()), on.trigger(Kt.KEY_SESSION_CREATED, { data: pn })) : (bn(pn), on.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session! Invalid Session ID (" + Mt + ")") }));
              }).catch(function(Cn) {
                bn(pn), on.trigger(Kt.KEY_SESSION_CREATED, { data: null, error: new c.Z(n.KEY_SESSION_CREATED_ERROR_CODE, n.KEY_SESSION_CREATED_ERROR_MESSAGE + "Could not load session (" + Mt + ")! " + Cn.name) });
              });
            }, removeKeySession: function(St) {
              St.session.remove().then(function() {
                Rt.debug("DRM: Session removed.  SessionID = " + St.getSessionId()), on.trigger(Kt.KEY_SESSION_REMOVED, { data: St.getSessionId() });
              }, function(Mt) {
                on.trigger(Kt.KEY_SESSION_REMOVED, { data: null, error: "Error removing session (" + St.getSessionId() + "). " + Mt.name });
              });
            }, closeKeySession: function(St) {
              gn(St).catch(function(Mt) {
                bn(St), on.trigger(Kt.KEY_SESSION_CLOSED, { data: null, error: "Error closing session (" + St.getSessionId() + ") " + Mt.name });
              });
            }, stop: function() {
              for (var St, Mt = 0; Mt < gt.length; Mt++) (St = gt[Mt]).getUsable() || (gn(St), bn(St));
            }, reset: function() {
              var St, Mt = gt.length;
              Mt !== 0 ? function() {
                for (var jt = function(pn) {
                  bn(pn), gt.length === 0 && (_t ? (_t.removeEventListener("encrypted", Zt), _t.setMediaKeys(null).then(function() {
                    on.trigger(Kt.TEARDOWN_COMPLETE);
                  })) : on.trigger(Kt.TEARDOWN_COMPLETE));
                }, dn = 0; dn < Mt; dn++) (function(pn) {
                  gn(St), jt(pn);
                })(St = gt[dn]);
              }() : on.trigger(Kt.TEARDOWN_COMPLETE);
            } }, Rt = It.getLogger(Ct), Ke = null, _t = null, et = null, gt = [], Gt = bt(an).getInstance(), Zt = { handleEvent: function(St) {
              if (St.type === "encrypted" && St.initData) {
                var Mt = ArrayBuffer.isView(St.initData) ? St.initData.buffer : St.initData;
                on.trigger(Kt.NEED_KEY, { key: new fn(Mt, St.initDataType) });
              }
            } }, Ct;
          }
          On[ee.PLAYREADY_KEYSTEM_STRING] = [ee.PLAYREADY_KEYSTEM_STRING, ee.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING], On[ee.WIDEVINE_KEYSTEM_STRING] = [ee.WIDEVINE_KEYSTEM_STRING], On[ee.CLEARKEY_KEYSTEM_STRING] = [ee.CLEARKEY_KEYSTEM_STRING], Zn.__dashjs_factory_name = "ProtectionModel_21Jan2015";
          var rr = dashjs.FactoryMaker.getClassFactory(Zn);
          function wn(Dt) {
            Dt = Dt || {};
            var Ct, Rt, Ke, _t, et, gt, Zt, Gt, an, on = this.context, Kt = Dt.eventBus, It = Dt.events, rn = Dt.debug, Jt = Dt.api;
            function gn() {
              try {
                for (var un = 0; un < Zt.length; un++) bn(Zt[un]);
                Ke && Ke.removeEventListener(Jt.needkey, Gt), Kt.trigger(It.TEARDOWN_COMPLETE);
              } catch (St) {
                Kt.trigger(It.TEARDOWN_COMPLETE, { error: "Error tearing down key sessions and MediaKeys! -- " + St.message });
              }
            }
            function bn(un) {
              var St = un.session;
              St.removeEventListener(Jt.error, un), St.removeEventListener(Jt.message, un), St.removeEventListener(Jt.ready, un), St.removeEventListener(Jt.close, un);
              for (var Mt = 0; Mt < Zt.length; Mt++) if (Zt[Mt] === un) {
                Zt.splice(Mt, 1);
                break;
              }
              St[Jt.release]();
            }
            function Nn() {
              var un = null, St = function() {
                Ke.removeEventListener("loadedmetadata", un), Ke[Jt.setMediaKeys](et), Kt.trigger(It.VIDEO_ELEMENT_SELECTED);
              };
              Ke.readyState >= 1 ? St() : (un = St.bind(this), Ke.addEventListener("loadedmetadata", un));
            }
            return Ct = { getAllInitData: function() {
              for (var un = [], St = 0; St < Zt.length; St++) un.push(Zt[St].initData);
              return un;
            }, getSessions: function() {
              return Zt;
            }, requestKeySystemAccess: function(un) {
              return new Promise(function(St, Mt) {
                for (var jt = !1, dn = 0; dn < un.length; dn++) for (var pn = un[dn].ks.systemString, Cn = un[dn].configs, Rn = null, ar = null, or = 0; or < Cn.length; or++) {
                  var Gn = Cn[or].audioCapabilities, er = Cn[or].videoCapabilities;
                  if (Gn && Gn.length !== 0) {
                    Rn = [];
                    for (var Yn = 0; Yn < Gn.length; Yn++) window[Jt.MediaKeys].isTypeSupported(pn, Gn[Yn].contentType) && Rn.push(Gn[Yn]);
                  }
                  if (er && er.length !== 0) {
                    ar = [];
                    for (var sr = 0; sr < er.length; sr++) window[Jt.MediaKeys].isTypeSupported(pn, er[sr].contentType) && ar.push(er[sr]);
                  }
                  if (!(!Rn && !ar || Rn && Rn.length === 0 || ar && ar.length === 0)) {
                    jt = !0;
                    var qr = new h(Rn, ar), Dr = an.getKeySystemBySystemString(pn), Pr = new Fn(Dr, qr);
                    Kt.trigger(It.KEY_SYSTEM_ACCESS_COMPLETE, { data: Pr }), St({ data: Pr });
                    break;
                  }
                }
                if (!jt) {
                  var gr = "Key system access denied! -- No valid audio/video content configurations detected!";
                  Kt.trigger(It.KEY_SYSTEM_ACCESS_COMPLETE, { error: gr }), Mt({ error: gr });
                }
              });
            }, selectKeySystem: function(un) {
              return new Promise(function(St, Mt) {
                try {
                  et = un.mediaKeys = new window[Jt.MediaKeys](un.keySystem.systemString), _t = un.keySystem, gt = un, Ke && Nn(), St(_t);
                } catch {
                  Mt({ error: "Error selecting keys system (" + _t.systemString + ")! Could not create MediaKeys -- TODO" });
                }
              });
            }, setMediaElement: function(un) {
              Ke !== un && (Ke && Ke.removeEventListener(Jt.needkey, Gt), (Ke = un) && (Ke.addEventListener(Jt.needkey, Gt), et && Nn()));
            }, createKeySession: function(un) {
              if (!_t || !et || !gt) throw new Error("Can not create sessions until you have selected a key system");
              var St = null;
              if (gt.ksConfiguration.videoCapabilities && gt.ksConfiguration.videoCapabilities.length > 0 && (St = gt.ksConfiguration.videoCapabilities[0]), St === null && gt.ksConfiguration.audioCapabilities && gt.ksConfiguration.audioCapabilities.length > 0 && (St = gt.ksConfiguration.audioCapabilities[0]), St === null) throw new Error("Can not create sessions for unknown content types.");
              var Mt = St.contentType, jt = et.createSession(Mt, new Uint8Array(un.initData), un.cdmData ? new Uint8Array(un.cdmData) : null), dn = function(pn, Cn) {
                return { session: pn, keyId: Cn.keyId, initData: Cn.initData, getKeyId: function() {
                  return this.keyId;
                }, getSessionId: function() {
                  return this.session.sessionId;
                }, getExpirationTime: function() {
                  return NaN;
                }, getSessionType: function() {
                  return "temporary";
                }, handleEvent: function(Rn) {
                  switch (Rn.type) {
                    case Jt.error:
                      Kt.trigger(It.KEY_ERROR, { error: new c.Z(n.MEDIA_KEYERR_CODE, "KeyError", this) });
                      break;
                    case Jt.message:
                      var ar = ArrayBuffer.isView(Rn.message) ? Rn.message.buffer : Rn.message;
                      Kt.trigger(It.INTERNAL_KEY_MESSAGE, { data: new Tn(this, ar, Rn.destinationURL) });
                      break;
                    case Jt.ready:
                      Rt.debug("DRM: Key added."), Kt.trigger(It.KEY_ADDED);
                      break;
                    case Jt.close:
                      Rt.debug("DRM: Session closed.  SessionID = " + this.getSessionId()), Kt.trigger(It.KEY_SESSION_CLOSED, { data: this.getSessionId() });
                  }
                } };
              }(jt, un);
              jt.addEventListener(Jt.error, dn), jt.addEventListener(Jt.message, dn), jt.addEventListener(Jt.ready, dn), jt.addEventListener(Jt.close, dn), Zt.push(dn), Rt.debug("DRM: Session created.  SessionID = " + dn.getSessionId()), Kt.trigger(It.KEY_SESSION_CREATED, { data: dn });
            }, updateKeySession: function(un, St) {
              var Mt = un.session;
              an.isClearKey(_t) ? Mt.update(new Uint8Array(St.toJWK())) : Mt.update(new Uint8Array(St)), Kt.trigger(It.KEY_SESSION_UPDATED);
            }, closeKeySession: bn, setServerCertificate: function() {
            }, loadKeySession: function() {
            }, removeKeySession: function() {
            }, stop: gn, reset: gn }, Rt = rn.getLogger(Ct), Ke = null, _t = null, et = null, gt = null, Zt = [], an = bt(on).getInstance(), Gt = { handleEvent: function(un) {
              if (un.type === Jt.needkey && un.initData) {
                var St = ArrayBuffer.isView(un.initData) ? un.initData.buffer : un.initData;
                Kt.trigger(It.NEED_KEY, { key: new fn(St, "cenc") });
              }
            } }, Ct;
          }
          wn.__dashjs_factory_name = "ProtectionModel_3Feb2014";
          var pr = dashjs.FactoryMaker.getClassFactory(wn);
          function Qn(Dt) {
            Dt = Dt || {};
            var Ct, Rt, Ke, _t, et, gt, Zt, Gt, an, on = this.context, Kt = Dt.eventBus, It = Dt.events, rn = Dt.debug, Jt = Dt.api, gn = Dt.errHandler;
            function bn() {
              Ke && St();
              for (var Mt = 0; Mt < Zt.length; Mt++) Nn(Zt[Mt]);
              Kt.trigger(It.TEARDOWN_COMPLETE);
            }
            function Nn(Mt) {
              try {
                Ke[Jt.cancelKeyRequest](_t.systemString, Mt.sessionId);
              } catch (jt) {
                Kt.trigger(It.KEY_SESSION_CLOSED, { data: null, error: "Error closing session (" + Mt.sessionId + ") " + jt.message });
              }
            }
            function un(Mt, jt) {
              if (jt && Mt) {
                for (var dn = Mt.length, pn = 0; pn < dn; pn++) if (Mt[pn].sessionId == jt) return Mt[pn];
                return null;
              }
              return null;
            }
            function St() {
              Ke.removeEventListener(Jt.keyerror, an), Ke.removeEventListener(Jt.needkey, an), Ke.removeEventListener(Jt.keymessage, an), Ke.removeEventListener(Jt.keyadded, an);
            }
            return Ct = { getAllInitData: function() {
              for (var Mt = [], jt = 0; jt < gt.length; jt++) Mt.push(gt[jt].initData);
              for (var dn = 0; dn < Zt.length; dn++) Mt.push(Zt[dn].initData);
              return Mt;
            }, getSessions: function() {
              return Zt.concat(gt);
            }, requestKeySystemAccess: function(Mt) {
              return new Promise(function(jt, dn) {
                var pn = Ke;
                pn || (pn = document.createElement("video"));
                for (var Cn = !1, Rn = 0; Rn < Mt.length; Rn++) for (var ar = Mt[Rn].ks.systemString, or = Mt[Rn].configs, Gn = null, er = 0; er < or.length; er++) {
                  var Yn = or[er].videoCapabilities;
                  if (Yn && Yn.length !== 0) {
                    Gn = [];
                    for (var sr = 0; sr < Yn.length; sr++) pn.canPlayType(Yn[sr].contentType, ar) !== "" && Gn.push(Yn[sr]);
                  }
                  if (Gn && (!Gn || Gn.length !== 0)) {
                    Cn = !0;
                    var qr = new h(null, Gn), Dr = et.getKeySystemBySystemString(ar), Pr = new Fn(Dr, qr);
                    Kt.trigger(It.KEY_SYSTEM_ACCESS_COMPLETE, { data: Pr }), jt({ data: Pr });
                    break;
                  }
                }
                if (!Cn) {
                  var gr = "Key system access denied! -- No valid audio/video content configurations detected!";
                  Kt.trigger(It.KEY_SYSTEM_ACCESS_COMPLETE, { error: gr }), dn({ error: gr });
                }
              });
            }, selectKeySystem: function(Mt) {
              return _t = Mt.keySystem, Promise.resolve(_t);
            }, setMediaElement: function(Mt) {
              if (Ke !== Mt) {
                if (Ke) {
                  St();
                  for (var jt = 0; jt < Zt.length; jt++) Nn(Zt[jt]);
                  Zt = [];
                }
                (Ke = Mt) && (Ke.addEventListener(Jt.keyerror, an), Ke.addEventListener(Jt.needkey, an), Ke.addEventListener(Jt.keymessage, an), Ke.addEventListener(Jt.keyadded, an), Kt.trigger(It.VIDEO_ELEMENT_SELECTED));
              }
            }, createKeySession: function(Mt) {
              if (!_t) throw new Error("Can not create sessions until you have selected a key system");
              if (Gt || Zt.length === 0) {
                var jt = { sessionId: null, keyId: Mt.keyId, initData: Mt.initData, getKeyId: function() {
                  return this.keyId;
                }, getSessionId: function() {
                  return this.sessionId;
                }, getExpirationTime: function() {
                  return NaN;
                }, getSessionType: function() {
                  return "temporary";
                } };
                return gt.push(jt), Ke[Jt.generateKeyRequest](_t.systemString, new Uint8Array(Mt.initData)), jt;
              }
              throw new Error("Multiple sessions not allowed!");
            }, updateKeySession: function(Mt, jt) {
              var dn = Mt.sessionId;
              if (et.isClearKey(_t)) for (var pn = 0; pn < jt.keyPairs.length; pn++) Ke[Jt.addKey](_t.systemString, jt.keyPairs[pn].key, jt.keyPairs[pn].keyID, dn);
              else Ke[Jt.addKey](_t.systemString, new Uint8Array(jt), new Uint8Array(Mt.initData), dn);
              Kt.trigger(It.KEY_SESSION_UPDATED);
            }, closeKeySession: Nn, setServerCertificate: function() {
            }, loadKeySession: function() {
            }, removeKeySession: function() {
            }, stop: bn, reset: bn }, Rt = rn.getLogger(Ct), Ke = null, _t = null, gt = [], Zt = [], et = bt(on).getInstance(), an = { handleEvent: function(Mt) {
              var jt = null;
              switch (Mt.type) {
                case Jt.needkey:
                  var dn = ArrayBuffer.isView(Mt.initData) ? Mt.initData.buffer : Mt.initData;
                  Kt.trigger(It.NEED_KEY, { key: new fn(dn, "cenc") });
                  break;
                case Jt.keyerror:
                  if ((jt = un(Zt, Mt.sessionId)) || (jt = un(gt, Mt.sessionId)), jt) {
                    var pn = n.MEDIA_KEYERR_CODE, Cn = "";
                    switch (Mt.errorCode.code) {
                      case 1:
                        pn = n.MEDIA_KEYERR_UNKNOWN_CODE, Cn += "MEDIA_KEYERR_UNKNOWN - " + n.MEDIA_KEYERR_UNKNOWN_MESSAGE;
                        break;
                      case 2:
                        pn = n.MEDIA_KEYERR_CLIENT_CODE, Cn += "MEDIA_KEYERR_CLIENT - " + n.MEDIA_KEYERR_CLIENT_MESSAGE;
                        break;
                      case 3:
                        pn = n.MEDIA_KEYERR_SERVICE_CODE, Cn += "MEDIA_KEYERR_SERVICE - " + n.MEDIA_KEYERR_SERVICE_MESSAGE;
                        break;
                      case 4:
                        pn = n.MEDIA_KEYERR_OUTPUT_CODE, Cn += "MEDIA_KEYERR_OUTPUT - " + n.MEDIA_KEYERR_OUTPUT_MESSAGE;
                        break;
                      case 5:
                        pn = n.MEDIA_KEYERR_HARDWARECHANGE_CODE, Cn += "MEDIA_KEYERR_HARDWARECHANGE - " + n.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;
                        break;
                      case 6:
                        pn = n.MEDIA_KEYERR_DOMAIN_CODE, Cn += "MEDIA_KEYERR_DOMAIN - " + n.MEDIA_KEYERR_DOMAIN_MESSAGE;
                    }
                    Cn += "  System Code = " + Mt.systemCode, Kt.trigger(It.KEY_ERROR, { error: new c.Z(pn, Cn, jt) });
                  } else Rt.error("No session token found for key error");
                  break;
                case Jt.keyadded:
                  (jt = un(Zt, Mt.sessionId)) || (jt = un(gt, Mt.sessionId)), jt ? (Rt.debug("DRM: Key added."), Kt.trigger(It.KEY_ADDED, { data: jt })) : Rt.debug("No session token found for key added");
                  break;
                case Jt.keymessage:
                  if ((Gt = Mt.sessionId !== null && Mt.sessionId !== void 0) ? !(jt = un(Zt, Mt.sessionId)) && gt.length > 0 && (jt = gt.shift(), Zt.push(jt), jt.sessionId = Mt.sessionId, Kt.trigger(It.KEY_SESSION_CREATED, { data: jt })) : gt.length > 0 && (jt = gt.shift(), Zt.push(jt), gt.length !== 0 && gn.error(new c.Z(n.MEDIA_KEY_MESSAGE_ERROR_CODE, n.MEDIA_KEY_MESSAGE_ERROR_MESSAGE))), jt) {
                    var Rn = ArrayBuffer.isView(Mt.message) ? Mt.message.buffer : Mt.message;
                    jt.keyMessage = Rn, Kt.trigger(It.INTERNAL_KEY_MESSAGE, { data: new Tn(jt, Rn, Mt.defaultURL) });
                  } else Rt.warn("No session token found for key message");
              }
            } }, Ct;
          }
          Qn.__dashjs_factory_name = "ProtectionModel_01b";
          var cr = dashjs.FactoryMaker.getClassFactory(Qn), Tr = [{ generateKeyRequest: "generateKeyRequest", addKey: "addKey", cancelKeyRequest: "cancelKeyRequest", needkey: "needkey", keyerror: "keyerror", keyadded: "keyadded", keymessage: "keymessage" }, { generateKeyRequest: "webkitGenerateKeyRequest", addKey: "webkitAddKey", cancelKeyRequest: "webkitCancelKeyRequest", needkey: "webkitneedkey", keyerror: "webkitkeyerror", keyadded: "webkitkeyadded", keymessage: "webkitkeymessage" }], fr = [{ setMediaKeys: "setMediaKeys", MediaKeys: "MediaKeys", release: "close", needkey: "needkey", error: "keyerror", message: "keymessage", ready: "keyadded", close: "keyclose" }, { setMediaKeys: "msSetMediaKeys", MediaKeys: "MSMediaKeys", release: "close", needkey: "msneedkey", error: "mskeyerror", message: "mskeymessage", ready: "mskeyadded", close: "mskeyclose" }];
          function Rr() {
            var Dt, Ct = this.context;
            function Rt(Ke, _t) {
              for (var et = 0; et < _t.length; et++) {
                var gt = _t[et];
                if (typeof Ke[gt[Object.keys(gt)[0]]] == "function") return gt;
              }
              return null;
            }
            return Dt = { createProtectionSystem: function(Ke) {
              var _t = null, et = bt(Ct).getInstance();
              et.setConfig({ debug: Ke.debug, BASE64: Ke.BASE64, settings: Ke.settings }), et.initialize();
              var gt = function(Zt) {
                var Gt = Zt.debug, an = Gt.getLogger(Dt), on = Zt.eventBus, Kt = Zt.errHandler, It = Zt.videoModel ? Zt.videoModel.getElement() : null;
                return It && It.onencrypted === void 0 || It && It.mediaKeys === void 0 ? Rt(It, fr) ? (an.info("EME detected on this user agent! (ProtectionModel_3Feb2014)"), pr(Ct).create({ debug: Gt, eventBus: on, events: Zt.events, api: Rt(It, fr) })) : Rt(It, Tr) ? (an.info("EME detected on this user agent! (ProtectionModel_01b)"), cr(Ct).create({ debug: Gt, eventBus: on, errHandler: Kt, events: Zt.events, api: Rt(It, Tr) })) : (an.warn("No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!"), null) : (an.info("EME detected on this user agent! (ProtectionModel_21Jan2015)"), rr(Ct).create({ debug: Gt, eventBus: on, events: Zt.events }));
              }(Ke);
              return !_t && gt && (_t = se(Ct).create({ protectionModel: gt, protectionKeyController: et, eventBus: Ke.eventBus, debug: Ke.debug, events: Ke.events, BASE64: Ke.BASE64, constants: Ke.constants, cmcdModel: Ke.cmcdModel, customParametersModel: Ke.customParametersModel, settings: Ke.settings }), Ke.capabilities.setEncryptedMediaSupported(!0)), _t;
            } };
          }
          Rr.__dashjs_factory_name = "Protection";
          var Nr = dashjs.FactoryMaker.getClassFactory(Rr);
          Nr.events = Ut, Nr.errors = n, dashjs.FactoryMaker.updateClassFactory(Rr.__dashjs_factory_name, Nr);
          var ui = Nr;
        }, 2068: function(_e, fe, R) {
          var J = R(5448), E = { DEFAULT: 0.5, STRONG: 1, WEAK: 0 };
          function t(h, p, o) {
            var v, m;
            return v = h === void 0 ? -1 : h, m = function(n) {
              var c = E.DEFAULT;
              return n !== E.DEFAULT && n !== E.STRONG && n !== E.WEAK || (c = n), c;
            }(o), { quality: v, reason: p === void 0 ? null : p, priority: m };
          }
          t.__dashjs_factory_name = "SwitchRequest";
          var e = J.Z.getClassFactory(t);
          e.NO_CHANGE = -1, e.PRIORITY = E, J.Z.updateClassFactory(t.__dashjs_factory_name, e), fe.Z = e;
        }, 1767: function(_e, fe, R) {
          var J = R(5628), E = R(6535), t = R(7423), e = R(895), h = R(6070), p = R(3112), o = R(1914), v = R(5435), m = R(5448), n = R(2068), c = R(3393), f = "qualitySwitchRules", S = "abandonFragmentRules";
          function k(F) {
            F = F || {};
            var te, P, Q = this.context, se = F.mediaPlayerModel, K = F.customParametersModel, ie = F.dashMetrics, ge = F.settings;
            function Ne(Oe) {
              return Oe.filter(function(Ge) {
                return Ge.quality > n.Z.NO_CHANGE;
              });
            }
            function ee(Oe) {
              var Ge, Xe, Ce, Ue, Je, st = {}, we = null;
              if (Oe.length !== 0) {
                for (st[n.Z.PRIORITY.STRONG] = { quality: n.Z.NO_CHANGE, reason: null }, st[n.Z.PRIORITY.WEAK] = { quality: n.Z.NO_CHANGE, reason: null }, st[n.Z.PRIORITY.DEFAULT] = { quality: n.Z.NO_CHANGE, reason: null }, Ge = 0, Xe = Oe.length; Ge < Xe; Ge += 1) (Ce = Oe[Ge]).quality !== n.Z.NO_CHANGE && (st[Ce.priority].quality === n.Z.NO_CHANGE || st[Ce.priority].quality > Ce.quality) && (st[Ce.priority].quality = Ce.quality, st[Ce.priority].reason = Ce.reason || null);
                return st[n.Z.PRIORITY.WEAK].quality !== n.Z.NO_CHANGE && (we = st[n.Z.PRIORITY.WEAK]), st[n.Z.PRIORITY.DEFAULT].quality !== n.Z.NO_CHANGE && (we = st[n.Z.PRIORITY.DEFAULT]), st[n.Z.PRIORITY.STRONG].quality !== n.Z.NO_CHANGE && (we = st[n.Z.PRIORITY.STRONG]), we && (Ue = we.quality, Je = we.reason), (0, n.Z)(Q).create(Ue, Je);
              }
            }
            return { initialize: function() {
              te = [], P = [], ge.get().streaming.abr.useDefaultABRRules && (ge.get().streaming.abr.ABRStrategy === c.Z.ABR_STRATEGY_L2A ? te.push((0, o.Z)(Q).create({ dashMetrics: ie, settings: ge })) : ge.get().streaming.abr.ABRStrategy === c.Z.ABR_STRATEGY_LoLP ? te.push((0, v.Z)(Q).create({ dashMetrics: ie })) : (te.push((0, p.Z)(Q).create({ dashMetrics: ie, mediaPlayerModel: se, settings: ge })), te.push((0, J.Z)(Q).create({ dashMetrics: ie })), ge.get().streaming.abr.additionalAbrRules.insufficientBufferRule && te.push((0, E.Z)(Q).create({ dashMetrics: ie, settings: ge })), ge.get().streaming.abr.additionalAbrRules.switchHistoryRule && te.push((0, h.Z)(Q).create()), ge.get().streaming.abr.additionalAbrRules.droppedFramesRule && te.push((0, e.Z)(Q).create()), ge.get().streaming.abr.additionalAbrRules.abandonRequestsRule && P.push((0, t.Z)(Q).create({ dashMetrics: ie, mediaPlayerModel: se, settings: ge })))), K.getAbrCustomRules().forEach(function(Oe) {
                Oe.type === f && te.push(Oe.rule(Q).create()), Oe.type === S && P.push(Oe.rule(Q).create());
              });
            }, reset: function() {
              [te, P].forEach(function(Oe) {
                Oe && Oe.length && Oe.forEach(function(Ge) {
                  return Ge.reset && Ge.reset();
                });
              }), te = [], P = [];
            }, getMaxQuality: function(Oe) {
              return ee(Ne(te.map(function(Ge) {
                return Ge.getMaxIndex(Oe);
              }))) || (0, n.Z)(Q).create();
            }, getMinSwitchRequest: ee, shouldAbandonFragment: function(Oe, Ge) {
              var Xe = ee(Ne(P.map(function(Ce) {
                return Ce.shouldAbandon(Oe, Ge);
              })));
              return Xe && (Xe.reason.forceAbandon = !0), Xe || (0, n.Z)(Q).create();
            }, getQualitySwitchRules: function() {
              return te;
            } };
          }
          k.__dashjs_factory_name = "ABRRulesCollection";
          var q = m.Z.getClassFactory(k);
          q.QUALITY_SWITCH_RULES = f, q.ABANDON_FRAGMENT_RULES = S, m.Z.updateSingletonFactory(k.__dashjs_factory_name, q), fe.Z = q;
        }, 7423: function(_e, fe, R) {
          var J = R(2068), E = R(5448), t = R(6398);
          function e(h) {
            h = h || {};
            var p, o, v, m, n, c = this.context, f = h.mediaPlayerModel, S = h.dashMetrics, k = h.settings;
            function q() {
              v = {}, m = {}, n = [];
            }
            return p = { shouldAbandon: function(F) {
              var te = (0, J.Z)(c).create(J.Z.NO_CHANGE, { name: e.__dashjs_factory_name });
              if (!(F && F.hasOwnProperty("getMediaInfo") && F.hasOwnProperty("getMediaType") && F.hasOwnProperty("getCurrentRequest") && F.hasOwnProperty("getRepresentationInfo") && F.hasOwnProperty("getAbrController"))) return te;
              var P, Q, se = F.getMediaInfo(), K = F.getMediaType(), ie = F.getStreamInfo(), ge = ie ? ie.id : null, Ne = F.getCurrentRequest();
              if (!isNaN(Ne.index)) {
                P = K, Q = Ne.index, v[P] = v[P] || {}, v[P][Q] = v[P][Q] || {};
                var ee = f.getStableBufferTime();
                if (S.getCurrentBufferLevel(K) > ee) return te;
                var Oe = v[K][Ne.index];
                if (Oe === null || Ne.firstByteDate === null || m.hasOwnProperty(Oe.id)) return te;
                if (Oe.firstByteTime === void 0 && (n[K] = [], Oe.firstByteTime = Ne.firstByteDate.getTime(), Oe.segmentDuration = Ne.duration, Oe.bytesTotal = Ne.bytesTotal, Oe.id = Ne.index), Oe.bytesLoaded = Ne.bytesLoaded, Oe.elapsedTime = (/* @__PURE__ */ new Date()).getTime() - Oe.firstByteTime, Oe.bytesLoaded > 0 && Oe.elapsedTime > 0 && function(Be, At) {
                  n[Be] = n[Be] || [], n[Be].push(At);
                }(K, Math.round(8 * Oe.bytesLoaded / Oe.elapsedTime)), n[K].length >= k.get().streaming.abr.abrRulesParameters.abandonRequestsRule.minLengthToAverage && Oe.elapsedTime > k.get().streaming.abr.abrRulesParameters.abandonRequestsRule.graceTimeThreshold && Oe.bytesLoaded < Oe.bytesTotal) {
                  var Ge = n[K].reduce(function(Be, At) {
                    return Be + At;
                  }, 0);
                  if (Oe.measuredBandwidthInKbps = Math.round(Ge / n[K].length), Oe.estimatedTimeOfDownload = +(8 * Oe.bytesTotal / Oe.measuredBandwidthInKbps / 1e3).toFixed(2), Oe.estimatedTimeOfDownload < Oe.segmentDuration * k.get().streaming.abr.abrRulesParameters.abandonRequestsRule.abandonMultiplier || F.getRepresentationInfo().quality === 0) return te;
                  if (!m.hasOwnProperty(Oe.id)) {
                    var Xe = F.getAbrController(), Ce = Oe.bytesTotal - Oe.bytesLoaded, Ue = Xe.getBitrateList(se), Je = Xe.getQualityForBitrate(se, Oe.measuredBandwidthInKbps * k.get().streaming.abr.bandwidthSafetyFactor, ge), st = Xe.getMinAllowedIndexFor(K, ge), we = st !== void 0 ? Math.max(st, Je) : Je;
                    Ce > Oe.bytesTotal * Ue[we].bitrate / Ue[Xe.getQualityFor(K, ge)].bitrate && (te.quality = we, te.reason.throughput = Oe.measuredBandwidthInKbps, te.reason.fragmentID = Oe.id, te.reason.rule = this.getClassName(), m[Oe.id] = Oe, o.debug("[" + K + "] frag id", Oe.id, " is asking to abandon and switch to quality to ", we, " measured bandwidth was", Oe.measuredBandwidthInKbps), delete v[K][Oe.id]);
                  }
                } else Oe.bytesLoaded === Oe.bytesTotal && delete v[K][Oe.id];
              }
              return te;
            }, reset: q }, o = (0, t.Z)(c).getInstance().getLogger(p), q(), p;
          }
          e.__dashjs_factory_name = "AbandonRequestsRule", fe.Z = E.Z.getClassFactory(e);
        }, 3112: function(_e, fe, R) {
          var J = R(3860), E = R(2068), t = R(5448), e = R(7855), h = R(5595), p = R(8512), o = R(6398), v = R(8825), m = R(3393), n = 10;
          function c(f) {
            f = f || {};
            var S, k, q, F = this.context, te = f.dashMetrics, P = f.mediaPlayerModel, Q = (0, h.Z)(F).getInstance();
            function se(we, Be, At) {
              var ht = At.reduce(function(ve, Se, Ye) {
                return Se > At[ve] ? Ye : ve;
              }, 0);
              if (ht === 0) return null;
              var je = Math.max(we, n + 2 * Be.length), it = (At[ht] - 1) / (je / n - 1);
              return { gp: it, Vp: n / it };
            }
            function K(we) {
              we.placeholderBuffer = 0, we.mostAdvancedSegmentStart = NaN, we.lastSegmentWasReplacement = !1, we.lastSegmentStart = NaN, we.lastSegmentDurationS = NaN, we.lastSegmentRequestTimeMs = NaN, we.lastSegmentFinishTimeMs = NaN;
            }
            function ie(we, Be) {
              var At = P.getStableBufferTime();
              if (we.stableBufferTime !== At) {
                var ht = se(At, we.bitrates, we.utilities);
                if (ht.Vp !== we.Vp || ht.gp !== we.gp) {
                  var je = te.getCurrentBufferLevel(Be), it = je + we.placeholderBuffer;
                  it -= n, it *= ht.Vp / we.Vp, it += n, we.stableBufferTime = At, we.Vp = ht.Vp, we.gp = ht.gp, we.placeholderBuffer = Math.max(0, it - je);
                }
              }
            }
            function ge(we, Be) {
              return we.Vp * (we.utilities[Be] + we.gp);
            }
            function Ne(we, Be) {
              for (var At = we.bitrates[Be], ht = we.utilities[Be], je = 0, it = Be - 1; it >= 0; --it) if (we.utilities[it] < we.utilities[Be]) {
                var ve = we.bitrates[it], Se = we.utilities[it], Ye = we.Vp * (we.gp + (At * Se - ve * ht) / (At - ve));
                je = Math.max(je, Ye);
              }
              return je;
            }
            function ee(we) {
              var Be = we.mediaType === m.Z.AUDIO ? [m.Z.AUDIO] : q;
              for (var At in Be) q.hasOwnProperty(At) && q[At].state === 2 && (q[At].placeholderBuffer = 0);
            }
            function Oe() {
              for (var we in q) if (q.hasOwnProperty(we)) {
                var Be = q[we];
                Be.state !== 0 && (Be.state = 1, K(Be));
              }
            }
            function Ge(we) {
              if (we && we.chunk && we.chunk.mediaInfo) {
                var Be = q[we.chunk.mediaInfo.type];
                if (Be && Be.state !== 0) {
                  var At = we.chunk.start;
                  isNaN(Be.mostAdvancedSegmentStart) || At > Be.mostAdvancedSegmentStart ? (Be.mostAdvancedSegmentStart = At, Be.lastSegmentWasReplacement = !1) : Be.lastSegmentWasReplacement = !0, Be.lastSegmentStart = At, Be.lastSegmentDurationS = we.chunk.duration, Be.lastQuality = we.chunk.quality, Ce(Be, we.chunk.mediaInfo.type);
                }
              }
            }
            function Xe(we) {
              if (we && we.metric === J.Z.HTTP_REQUEST && we.value && we.value.type === e.w.MEDIA_SEGMENT_TYPE && we.value.trace && we.value.trace.length) {
                var Be = q[we.mediaType];
                Be && Be.state !== 0 && (Be.lastSegmentRequestTimeMs = we.value.trequest.getTime(), Be.lastSegmentFinishTimeMs = we.value._tfinish.getTime(), Ce(Be, we.mediaType));
              }
            }
            function Ce(we, Be) {
              if (!isNaN(we.lastSegmentStart) && !isNaN(we.lastSegmentRequestTimeMs) && !isNaN(we.placeholderBuffer)) {
                if (we.placeholderBuffer *= 0.99, !isNaN(we.lastSegmentFinishTimeMs)) {
                  var At = te.getCurrentBufferLevel(Be) + 1e-3 * (we.lastSegmentFinishTimeMs - we.lastSegmentRequestTimeMs), ht = ge(we, we.lastQuality), je = Math.max(0, ht - At);
                  we.placeholderBuffer = Math.min(je, we.placeholderBuffer);
                }
                we.lastSegmentWasReplacement && !isNaN(we.lastSegmentDurationS) && (we.placeholderBuffer += we.lastSegmentDurationS), we.lastSegmentStart = NaN, we.lastSegmentRequestTimeMs = NaN;
              }
            }
            function Ue(we) {
              if (we) {
                var Be = q[we.mediaType];
                Be && Be.state !== 0 && (Be.abrQuality = we.newQuality);
              }
            }
            function Je(we) {
              if (we) {
                var Be = q[we.mediaType];
                if (Be && Be.state !== 0) {
                  var At, ht = te.getCurrentBufferLevel(we.mediaType);
                  At = Be.abrQuality > 0 ? Ne(Be, Be.abrQuality) : n;
                  var je = Math.max(0, At - ht);
                  Be.placeholderBuffer = Math.min(Be.placeholderBuffer, je);
                }
              }
            }
            function st() {
              q = {};
            }
            return S = { getMaxIndex: function(we) {
              var Be = (0, E.Z)(F).create();
              if (!(we && we.hasOwnProperty("getMediaInfo") && we.hasOwnProperty("getMediaType") && we.hasOwnProperty("getScheduleController") && we.hasOwnProperty("getStreamInfo") && we.hasOwnProperty("getAbrController") && we.hasOwnProperty("useBufferOccupancyABR"))) return Be;
              var At = we.getMediaInfo(), ht = we.getMediaType(), je = we.getScheduleController(), it = we.getStreamInfo(), ve = we.getAbrController(), Se = ve.getThroughputHistory(), Ye = it ? it.id : null, d = it && it.manifestInfo && it.manifestInfo.isDynamic, l = we.useBufferOccupancyABR();
              if (Be.reason = Be.reason || {}, !l) return Be;
              je.setTimeToLoadDelay(0);
              var T = function(Me) {
                var Ve = Me.getMediaType(), ot = q[Ve];
                return ot ? ot.state !== 0 && ie(ot, Ve) : (ot = function(bt) {
                  var dt = {}, Yt = bt.getMediaInfo().bitrateList.map(function(fn) {
                    return fn.bandwidth;
                  }), Ot = function(fn) {
                    return fn.map(function(Tn) {
                      return Math.log(Tn);
                    });
                  }(Yt);
                  Ot = Ot.map(function(fn) {
                    return fn - Ot[0] + 1;
                  });
                  var Ht = P.getStableBufferTime(), Ut = se(Ht, Yt, Ot);
                  return Ut ? (dt.state = 1, dt.bitrates = Yt, dt.utilities = Ot, dt.stableBufferTime = Ht, dt.Vp = Ut.Vp, dt.gp = Ut.gp, dt.lastQuality = 0, K(dt)) : dt.state = 0, dt;
                }(Me), q[Ve] = ot), ot;
              }(we);
              if (T.state === 0) return Be;
              var b, $ = te.getCurrentBufferLevel(ht), W = Se.getAverageThroughput(ht, d), Ie = Se.getSafeAverageThroughput(ht, d), $e = Se.getAverageLatency(ht);
              if (Be.reason.state = T.state, Be.reason.throughput = W, Be.reason.latency = $e, isNaN(W)) return Be;
              switch (T.state) {
                case 1:
                  b = ve.getQualityForBitrate(At, Ie, Ye, $e), Be.quality = b, Be.reason.throughput = Ie, T.placeholderBuffer = Math.max(0, Ne(T, b) - $), T.lastQuality = b, !isNaN(T.lastSegmentDurationS) && $ >= T.lastSegmentDurationS && (T.state = 2);
                  break;
                case 2:
                  (function(Me, Ve) {
                    var ot = Date.now();
                    if (isNaN(Me.lastSegmentFinishTimeMs)) {
                      if (!isNaN(Me.lastCallTimeMs)) {
                        var bt = 1e-3 * (ot - Me.lastCallTimeMs);
                        Me.placeholderBuffer += Math.max(0, bt);
                      }
                    } else {
                      var dt = 1e-3 * (ot - Me.lastSegmentFinishTimeMs);
                      Me.placeholderBuffer += Math.max(0, dt);
                    }
                    Me.lastCallTimeMs = ot, Me.lastSegmentStart = NaN, Me.lastSegmentRequestTimeMs = NaN, Me.lastSegmentFinishTimeMs = NaN, ie(Me, Ve);
                  })(T, ht), b = function(Me, Ve) {
                    for (var ot = Me.bitrates.length, bt = NaN, dt = NaN, Yt = 0; Yt < ot; ++Yt) {
                      var Ot = (Me.Vp * (Me.utilities[Yt] + Me.gp) - Ve) / Me.bitrates[Yt];
                      (isNaN(dt) || Ot >= dt) && (dt = Ot, bt = Yt);
                    }
                    return bt;
                  }(T, $ + T.placeholderBuffer);
                  var Ze = ve.getQualityForBitrate(At, Ie, Ye, $e);
                  b > T.lastQuality && b > Ze && (b = Math.max(Ze, T.lastQuality));
                  var xe = Math.max(0, $ + T.placeholderBuffer - ge(T, b));
                  xe <= T.placeholderBuffer ? (T.placeholderBuffer -= xe, xe = 0) : (xe -= T.placeholderBuffer, T.placeholderBuffer = 0, b < ve.getMaxAllowedIndexFor(ht, Ye) ? je.setTimeToLoadDelay(1e3 * xe) : xe = 0), Be.quality = b, Be.reason.throughput = W, Be.reason.latency = $e, Be.reason.bufferLevel = $, Be.reason.placeholderBuffer = T.placeholderBuffer, Be.reason.delay = xe, T.lastQuality = b;
                  break;
                default:
                  k.debug("BOLA ABR rule invoked in bad state."), Be.quality = ve.getQualityForBitrate(At, Ie, Ye, $e), Be.reason.state = T.state, Be.reason.throughput = Ie, Be.reason.latency = $e, T.state = 1, K(T);
              }
              return Be;
            }, reset: function() {
              st(), Q.off(v.Z.BUFFER_EMPTY, ee, S), Q.off(v.Z.PLAYBACK_SEEKING, Oe, S), Q.off(v.Z.METRIC_ADDED, Xe, S), Q.off(v.Z.QUALITY_CHANGE_REQUESTED, Ue, S), Q.off(v.Z.FRAGMENT_LOADING_ABANDONED, Je, S), Q.off(p.Z.MEDIA_FRAGMENT_LOADED, Ge, S);
            } }, k = (0, o.Z)(F).getInstance().getLogger(S), st(), Q.on(v.Z.BUFFER_EMPTY, ee, S), Q.on(v.Z.PLAYBACK_SEEKING, Oe, S), Q.on(v.Z.METRIC_ADDED, Xe, S), Q.on(v.Z.QUALITY_CHANGE_REQUESTED, Ue, S), Q.on(v.Z.FRAGMENT_LOADING_ABANDONED, Je, S), Q.on(p.Z.MEDIA_FRAGMENT_LOADED, Ge, S), S;
          }
          c.__dashjs_factory_name = "BolaRule", fe.Z = t.Z.getClassFactory(c);
        }, 895: function(_e, fe, R) {
          var J = R(5448), E = R(2068), t = R(6398);
          function e() {
            var h, p, o = this.context;
            return h = { getMaxIndex: function(v) {
              var m = (0, E.Z)(o).create();
              if (!v || !v.hasOwnProperty("getDroppedFramesHistory")) return m;
              var n = v.getDroppedFramesHistory(), c = v.getStreamInfo().id;
              if (n) {
                var f = n.getFrameHistory(c);
                if (!f || f.length === 0) return m;
                for (var S = 0, k = 0, q = E.Z.NO_CHANGE, F = 1; F < f.length; F++) if (f[F] && (S = f[F].droppedVideoFrames, (k = f[F].totalVideoFrames) > 375 && S / k > 0.15)) {
                  q = F - 1, p.debug("index: " + q + " Dropped Frames: " + S + " Total Frames: " + k);
                  break;
                }
                return (0, E.Z)(o).create(q, { droppedFrames: S });
              }
              return m;
            } }, p = (0, t.Z)(o).getInstance().getLogger(h), h;
          }
          e.__dashjs_factory_name = "DroppedFramesRule", fe.Z = J.Z.getClassFactory(e);
        }, 6535: function(_e, fe, R) {
          var J = R(5595), E = R(8512), t = R(5448), e = R(6398), h = R(2068), p = R(3393), o = R(3860), v = R(8825);
          function m(n) {
            n = n || {};
            var c, f, S, k = this.context, q = (0, J.Z)(k).getInstance(), F = n.dashMetrics;
            function te() {
              (S = {})[p.Z.VIDEO] = { ignoreCount: 2 }, S[p.Z.AUDIO] = { ignoreCount: 2 };
            }
            function P() {
              te();
            }
            function Q(se) {
              isNaN(se.startTime) || se.mediaType !== p.Z.AUDIO && se.mediaType !== p.Z.VIDEO || S[se.mediaType].ignoreCount > 0 && S[se.mediaType].ignoreCount--;
            }
            return c = { getMaxIndex: function(se) {
              var K = (0, h.Z)(k).create();
              if (!se || !se.hasOwnProperty("getMediaType")) return K;
              (function() {
                if (!F || !F.hasOwnProperty("getCurrentBufferLevel") || !F.hasOwnProperty("getCurrentBufferState")) throw new Error(p.Z.MISSING_CONFIG_ERROR);
              })();
              var ie = se.getMediaType(), ge = F.getCurrentBufferState(ie), Ne = se.getRepresentationInfo().fragmentDuration, ee = se.getStreamInfo(), Oe = ee ? ee.id : null, Ge = se.getScheduleController(), Xe = ee && ee.manifestInfo && ee.manifestInfo.isDynamic;
              if (function(ht, je) {
                return !ht && S[je].ignoreCount > 0;
              }(Ge.getPlaybackController().getLowLatencyModeEnabled(), ie) || !Ne) return K;
              if (ge && ge.state === o.Z.BUFFER_EMPTY) f.debug("[" + ie + "] Switch to index 0; buffer is empty."), K.quality = 0, K.reason = "InsufficientBufferRule: Buffer is empty";
              else {
                var Ce = se.getMediaInfo(), Ue = se.getAbrController(), Je = Ue.getThroughputHistory(), st = F.getCurrentBufferLevel(ie), we = Je.getAverageThroughput(ie, Xe), Be = Je.getAverageLatency(ie), At = we * (st / Ne) * 0.5;
                K.quality = Ue.getQualityForBitrate(Ce, At, Oe, Be), K.reason = "InsufficientBufferRule: being conservative to avoid immediate rebuffering";
              }
              return K;
            }, reset: function() {
              te(), q.off(v.Z.PLAYBACK_SEEKING, P, c), q.off(E.Z.BYTES_APPENDED_END_FRAGMENT, Q, c);
            } }, f = (0, e.Z)(k).getInstance().getLogger(c), te(), q.on(v.Z.PLAYBACK_SEEKING, P, c), q.on(E.Z.BYTES_APPENDED_END_FRAGMENT, Q, c), c;
          }
          m.__dashjs_factory_name = "InsufficientBufferRule", fe.Z = t.Z.getClassFactory(m);
        }, 1914: function(_e, fe, R) {
          var J = R(3860), E = R(2068), t = R(5448), e = R(7855), h = R(5595), p = R(8512), o = R(6398), v = R(3393);
          function m(n) {
            n = n || {};
            var c, f, S, k, q = this.context, F = n.dashMetrics, te = (0, h.Z)(q).getInstance();
            function P(Oe) {
              Oe.placeholderBuffer = 0, Oe.mostAdvancedSegmentStart = NaN, Oe.lastSegmentWasReplacement = !1, Oe.lastSegmentStart = NaN, Oe.lastSegmentDurationS = NaN, Oe.lastSegmentRequestTimeMs = NaN, Oe.lastSegmentFinishTimeMs = NaN, Oe.lastSegmentUrl = "";
            }
            function Q() {
              for (var Oe in f) if (f.hasOwnProperty(Oe)) {
                var Ge = f[Oe];
                Ge.state !== 0 && (Ge.state = 1, P(Ge));
              }
            }
            function se(Oe) {
              if (Oe && Oe.chunk && Oe.chunk.mediaInfo) {
                var Ge = f[Oe.chunk.mediaInfo.type], Xe = S[Oe.chunk.mediaInfo.type];
                if (Ge && Ge.state !== 0) {
                  var Ce = Oe.chunk.start;
                  isNaN(Ge.mostAdvancedSegmentStart) || Ce > Ge.mostAdvancedSegmentStart ? (Ge.mostAdvancedSegmentStart = Ce, Ge.lastSegmentWasReplacement = !1) : Ge.lastSegmentWasReplacement = !0, Ge.lastSegmentStart = Ce, Ge.lastSegmentDurationS = Oe.chunk.duration, Ge.lastQuality = Oe.chunk.quality, ie(Ge, Xe);
                }
              }
            }
            function K(Oe) {
              if (Oe && Oe.metric === J.Z.HTTP_REQUEST && Oe.value && Oe.value.type === e.w.MEDIA_SEGMENT_TYPE && Oe.value.trace && Oe.value.trace.length) {
                var Ge = f[Oe.mediaType], Xe = S[Oe.mediaType];
                Ge && Ge.state !== 0 && (Ge.lastSegmentRequestTimeMs = Oe.value.trequest.getTime(), Ge.lastSegmentFinishTimeMs = Oe.value._tfinish.getTime(), ie(Ge, Xe));
              }
            }
            function ie(Oe, Ge) {
              isNaN(Oe.lastSegmentStart) || isNaN(Oe.lastSegmentRequestTimeMs) || (Ge.segment_request_start_s = 1e-3 * Oe.lastSegmentRequestTimeMs, Ge.segment_download_finish_s = 1e-3 * Oe.lastSegmentFinishTimeMs, Oe.lastSegmentStart = NaN, Oe.lastSegmentRequestTimeMs = NaN);
            }
            function ge(Oe) {
              if (Oe && Oe.mediaType) {
                var Ge = f[Oe.mediaType];
                Ge && Ge.state !== 0 && (Ge.abrQuality = Oe.newQuality);
              }
            }
            function Ne(Oe, Ge) {
              if (Oe.length !== Ge.length) return -1;
              for (var Xe = 0, Ce = 0; Ce < Oe.length; Ce++) Xe += Oe[Ce] * Ge[Ce];
              return Xe;
            }
            function ee() {
              f = {}, S = {};
            }
            return c = { getMaxIndex: function(Oe) {
              var Ge, Xe = (0, E.Z)(q).create(), Ce = Math.pow(4, 0.99), Ue = Math.max(Math.pow(4, 1), Ce * Math.sqrt(4)), Je = Oe.getMediaInfo(), st = Oe.getMediaType(), we = Je.bitrateList.map(function(Ut) {
                return Ut.bandwidth;
              }), Be = we.length, At = Oe.getScheduleController(), ht = Oe.getStreamInfo(), je = Oe.getAbrController(), it = je.getThroughputHistory(), ve = ht && ht.manifestInfo && ht.manifestInfo.isDynamic, Se = Oe.useL2AABR(), Ye = F.getCurrentBufferLevel(st, !0), d = it.getSafeAverageThroughput(st, ve), l = it.getAverageThroughput(st, ve), T = it.getAverageLatency(st), b = Oe.getVideoModel().getPlaybackRate();
              if (!(Oe && Oe.hasOwnProperty("getMediaInfo") && Oe.hasOwnProperty("getMediaType") && Oe.hasOwnProperty("getScheduleController") && Oe.hasOwnProperty("getStreamInfo") && Oe.hasOwnProperty("getAbrController") && Oe.hasOwnProperty("useL2AABR")) || (Xe.reason = Xe.reason || {}, !Se || st === v.Z.AUDIO)) return Xe;
              At.setTimeToLoadDelay(0);
              var $ = function(Ut) {
                var fn = Ut.getMediaType(), Tn = f[fn];
                return Tn || (Tn = function(Fn) {
                  var On = {}, Zn = Fn.getMediaInfo(), rr = Zn.bitrateList.map(function(wn) {
                    return wn.bandwidth / 1e3;
                  });
                  return On.state = 1, On.bitrates = rr, On.lastQuality = 0, function(wn) {
                    wn && wn.type && (S[wn.type] = {}, S[wn.type].w = [], S[wn.type].prev_w = [], S[wn.type].Q = 0, S[wn.type].segment_request_start_s = 0, S[wn.type].segment_download_finish_s = 0, S[wn.type].B_target = 1.5);
                  }(Zn), P(On), On;
                }(Ut), f[fn] = Tn), Tn;
              }(Oe);
              if ($.state === 0) return Xe;
              var W = S[st];
              if (!W || (Xe.reason.state = $.state, Xe.reason.throughput = l, Xe.reason.latency = T, isNaN(l))) return Xe;
              switch ($.state) {
                case 1:
                  if (Ge = je.getQualityForBitrate(Je, d, ht.id, T), Xe.quality = Ge, Xe.reason.throughput = d, $.lastQuality = Ge, !isNaN($.lastSegmentDurationS) && Ye >= W.B_target) {
                    $.state = 2, W.Q = Ce;
                    for (var Ie = 0; Ie < Be; ++Ie) Ie === $.lastQuality ? W.prev_w[Ie] = 1 : W.prev_w[Ie] = 0;
                  }
                  break;
                case 2:
                  var $e = [], Ze = F.getCurrentHttpRequest(st).trace.reduce(function(Ut, fn) {
                    return Ut + fn.d;
                  }, 0), xe = F.getCurrentHttpRequest(st).trace.reduce(function(Ut, fn) {
                    return Ut + fn.b[0];
                  }, 0), Me = Math.round(8 * xe / Ze), Ve = F.getCurrentHttpRequest(st);
                  if (Me < 1 && (Me = 1), Ve.url === $.lastSegmentUrl || Ve.type === e.w.INIT_SEGMENT_TYPE) Ge = $.lastQuality;
                  else {
                    for (var ot = $.lastSegmentDurationS, bt = 1, dt = 0; dt < Be; ++dt) we[dt] = we[dt] / 1e3, b * we[dt] > Me && (bt = -1), W.w[dt] = W.prev_w[dt] + bt * (ot / (2 * Ue)) * ((W.Q + Ce) * (b * we[dt] / Me));
                    W.w = function(Ut) {
                      for (var fn = Ut.length, Tn = !1, Fn = [], On = 0; On < fn; ++On) Fn[On] = Ut[On];
                      for (var Zn = Ut.sort(function(Tr, fr) {
                        return fr - Tr;
                      }), rr = 0, wn = 0, pr = [], Qn = 0; Qn < fn - 1; ++Qn) if ((wn = ((rr += Zn[Qn]) - 1) / (Qn + 1)) >= Zn[Qn + 1]) {
                        Tn = !0;
                        break;
                      }
                      Tn || (wn = (rr + Zn[fn - 1] - 1) / fn);
                      for (var cr = 0; cr < fn; ++cr) pr[cr] = Math.max(Fn[cr] - wn, 0);
                      return pr;
                    }(W.w);
                    for (var Yt = 0; Yt < Be; ++Yt) $e[Yt] = W.w[Yt] - W.prev_w[Yt], W.prev_w[Yt] = W.w[Yt];
                    W.Q = Math.max(0, W.Q - ot + ot * b * ((Ne(we, W.prev_w) + Ne(we, $e)) / Me));
                    for (var Ot = [], Ht = 0; Ht < Be; ++Ht) Ot[Ht] = Math.abs(we[Ht] - Ne(W.w, we));
                    (Ge = Ot.indexOf(Math.min.apply(Math, Ot))) > $.lastQuality && we[$.lastQuality + 1] <= Me && (Ge = $.lastQuality + 1), we[Ge] >= Me && (W.Q = 2 * Math.max(Ce, W.Q)), $.lastSegmentUrl = Ve.url;
                  }
                  Xe.quality = Ge, Xe.reason.throughput = l, Xe.reason.latency = T, Xe.reason.bufferLevel = Ye, $.lastQuality = Xe.quality;
                  break;
                default:
                  k.debug("L2A ABR rule invoked in bad state."), Xe.quality = je.getQualityForBitrate(Je, d, ht.id, T), Xe.reason.state = $.state, Xe.reason.throughput = d, Xe.reason.latency = T, $.state = 1, P($);
              }
              return Xe;
            }, reset: function() {
              ee(), te.off(p.Z.PLAYBACK_SEEKING, Q, c), te.off(p.Z.MEDIA_FRAGMENT_LOADED, se, c), te.off(p.Z.METRIC_ADDED, K, c), te.off(p.Z.QUALITY_CHANGE_REQUESTED, ge, c);
            } }, k = (0, o.Z)(q).getInstance().getLogger(c), ee(), te.on(p.Z.PLAYBACK_SEEKING, Q, c), te.on(p.Z.MEDIA_FRAGMENT_LOADED, se, c), te.on(p.Z.METRIC_ADDED, K, c), te.on(p.Z.QUALITY_CHANGE_REQUESTED, ge, c), c;
          }
          m.__dashjs_factory_name = "L2ARule", fe.Z = t.Z.getClassFactory(m);
        }, 6070: function(_e, fe, R) {
          var J = R(5448), E = R(6398), t = R(2068);
          function e() {
            var h, p, o = this.context;
            return h = { getMaxIndex: function(v) {
              for (var m = v ? v.getSwitchHistory() : null, n = m ? m.getSwitchRequests() : [], c = 0, f = 0, S = 0, k = (0, t.Z)(o).create(), q = 0; q < n.length; q++) if (n[q] !== void 0 && (c += n[q].drops, f += n[q].noDrops, S += n[q].dropSize, c + f >= 6 && c / f > 0.075)) {
                k.quality = q > 0 && n[q].drops > 0 ? q - 1 : q, k.reason = { index: k.quality, drops: c, noDrops: f, dropSize: S }, p.debug("Switch history rule index: " + k.quality + " samples: " + (c + f) + " drops: " + c);
                break;
              }
              return k;
            } }, p = (0, E.Z)(o).getInstance().getLogger(h), h;
          }
          e.__dashjs_factory_name = "SwitchHistoryRule", fe.Z = J.Z.getClassFactory(e);
        }, 5628: function(_e, fe, R) {
          var J = R(5448), E = R(2068), t = R(3393), e = R(3860);
          function h(p) {
            p = p || {};
            var o = this.context, v = p.dashMetrics;
            return { getMaxIndex: function(m) {
              var n = (0, E.Z)(o).create();
              if (!(m && m.hasOwnProperty("getMediaInfo") && m.hasOwnProperty("getMediaType") && m.hasOwnProperty("useBufferOccupancyABR") && m.hasOwnProperty("getAbrController") && m.hasOwnProperty("getScheduleController"))) return n;
              (function() {
                if (!v || !v.hasOwnProperty("getCurrentBufferState")) throw new Error(t.Z.MISSING_CONFIG_ERROR);
              })();
              var c = m.getMediaInfo(), f = m.getMediaType(), S = v.getCurrentBufferState(f), k = m.getScheduleController(), q = m.getAbrController(), F = m.getStreamInfo(), te = F ? F.id : null, P = F && F.manifestInfo ? F.manifestInfo.isDynamic : null, Q = q.getThroughputHistory(), se = Q.getSafeAverageThroughput(f, P), K = Q.getAverageLatency(f), ie = m.useBufferOccupancyABR();
              return isNaN(se) || !S || ie || q.getAbandonmentStateFor(te, f) !== e.Z.ABANDON_LOAD && (S.state === e.Z.BUFFER_LOADED || P) && (n.quality = q.getQualityForBitrate(c, se, te, K), k.setTimeToLoadDelay(0), n.reason = { throughput: se, latency: K }), n;
            }, reset: function() {
            } };
          }
          h.__dashjs_factory_name = "ThroughputRule", fe.Z = J.Z.getClassFactory(h);
        }, 4722: function(_e, fe, R) {
          var J = R(5448), E = R(6398);
          function t() {
            var e, h, p, o, v, m, n, c, f, S = this.context;
            function k() {
              p = null, o = 1, v = 100, m = 0, n = null, c = null, f = "dynamic_weight_selection";
            }
            function q() {
              var se = 0;
              if (p) for (var K = 0; K < p.length; K++) {
                var ie = p[K];
                ie.state.throughput > se && (se = ie.state.throughput);
              }
              return se;
            }
            function F(se, K, ie) {
              var ge = se.map(function(Ne, ee) {
                return ie[ee] * Math.pow(Ne - K[ee], 2);
              }).reduce(function(Ne, ee) {
                return Ne + ee;
              });
              return (ge < 0 ? -1 : 1) * Math.sqrt(Math.abs(ge));
            }
            function te(se, K) {
              return F([se.state.throughput, se.state.latency, se.state.rebuffer, se.state.switch], [K.state.throughput, K.state.latency, K.state.rebuffer, K.state.switch], [1, 1, 1, 1]);
            }
            function P(se, K, ie) {
              for (var ge = 0; ge < K.length; ge++) {
                var Ne = K[ge], ee = te(Ne, se);
                Q(Ne, ie, Math.exp(-1 * Math.pow(ee, 2) / (2 * Math.pow(0.1, 2))));
              }
            }
            function Q(se, K, ie) {
              var ge = se.state, Ne = [0.01, 0.01, 0.01, 0.01];
              ge.throughput = ge.throughput + (K[0] - ge.throughput) * Ne[0] * ie, ge.latency = ge.latency + (K[1] - ge.latency) * Ne[1] * ie, ge.rebuffer = ge.rebuffer + (K[2] - ge.rebuffer) * Ne[2] * ie, ge.switch = ge.switch + (K[3] - ge.switch) * Ne[3] * ie;
            }
            return e = { getNextQuality: function(se, K, ie, ge, Ne, ee, Oe) {
              var Ge = ie, Xe = ge, Ce = K, Ue = function(W) {
                if (!p) {
                  p = [];
                  var Ie = W.bitrateList, $e = [];
                  m = Ie[0].bandwidth, Ie.forEach(function(Ve) {
                    $e.push(Ve.bandwidth), Ve.bandwidth < m && (m = Ve.bandwidth);
                  }), Me = $e.map(function(Ve) {
                    return Math.pow(Ve, 2);
                  }).reduce(function(Ve, ot) {
                    return Ve + ot;
                  }), o = Math.sqrt(Me);
                  for (var Ze = 0; Ze < Ie.length; Ze++) {
                    var xe = { qualityIndex: Ze, bitrate: Ie[Ze].bandwidth, state: { throughput: Ie[Ze].bandwidth / o, latency: 0, rebuffer: 0, switch: 0 } };
                    p.push(xe);
                  }
                  c = function(Ve) {
                    var ot = [], bt = function(ui) {
                      for (var Dt = [], Ct = 0; Ct < ui; Ct++) {
                        var Rt = [Math.random() * q(), Math.random(), Math.random(), Math.random()];
                        Dt.push(Rt);
                      }
                      return Dt;
                    }(Math.pow(Ve.length, 2));
                    ot.push(bt[0]);
                    for (var dt = [1, 1, 1, 1], Yt = 1; Yt < Ve.length; Yt++) {
                      for (var Ot = null, Ht = null, Ut = 0; Ut < bt.length; Ut++) {
                        for (var fn = bt[Ut], Tn = null, Fn = 0; Fn < ot.length; Fn++) {
                          var On = F(fn, ot[Fn], dt);
                          (Tn === null || On < Tn) && (Tn = On);
                        }
                        (Ht === null || Tn > Ht) && (Ot = fn, Ht = Tn);
                      }
                      ot.push(Ot);
                    }
                    for (var Zn = null, rr = null, wn = 0; wn < ot.length; wn++) {
                      for (var pr = 0, Qn = 0; Qn < ot.length; Qn++) wn !== Qn && (pr += F(ot[wn], ot[Qn], dt));
                      (Zn === null || pr > Zn) && (Zn = pr, rr = wn);
                    }
                    var cr = [];
                    for (cr.push(ot[rr]), ot.splice(rr, 1); ot.length > 0; ) {
                      for (var Tr = null, fr = null, Rr = 0; Rr < ot.length; Rr++) {
                        var Nr = F(cr[0], ot[Rr], dt);
                        (Tr === null || Nr < Tr) && (Tr = Nr, fr = Rr);
                      }
                      cr.push(ot[fr]), ot.splice(fr, 1);
                    }
                    return cr;
                  }(p);
                }
                var Me;
                return p;
              }(se), Je = K / o;
              Je > 1 && (Je = q()), ie /= v, h.debug("getNextQuality called throughput:".concat(Je, " latency:").concat(ie, " bufferSize:").concat(ge, " currentQualityIndex:").concat(ee, " playbackRate:").concat(Ne));
              var st = Ue[ee], we = st.bitrate * Oe.getSegmentDuration() / Ce, Be = Math.max(0, we - Xe);
              if (Xe - we < Oe.getMinBuffer()) return h.debug("Buffer is low for bitrate= ".concat(st.bitrate, " downloadTime=").concat(we, " currentBuffer=").concat(Xe, " rebuffer=").concat(Be)), function(W, Ie) {
                var $e = 0, Ze = W;
                if (p) for (var xe = 0; xe < p.length; xe++) {
                  var Me = p[xe];
                  Me.bitrate < W.bitrate && Me.bitrate > $e && Ie > Me.bitrate && ($e = Me.bitrate, Ze = Me);
                }
                return Ze;
              }(st, Ce).qualityIndex;
              switch (f) {
                case "manual_weight_selection":
                  n = [0.4, 0.4, 0.4, 0.4];
                  break;
                case "random_weight_selection":
                  (function(W) {
                    n = function(Ie, $e) {
                      for (var Ze = [], xe = Math.sqrt(2 / Ie), Me = 0; Me < 4; Me++) Ze.push(Math.random() * xe);
                      return n = Ze;
                    }(W.length);
                  })(Ue);
                  break;
                default:
                  (function(W, Ie, $e, Ze, xe, Me, Ve) {
                    n || (n = c[c.length - 1]);
                    var ot = W.findWeightVector(Ie, $e, Ze, xe, Me, Ve);
                    ot !== null && ot !== -1 && (n = ot);
                  })(Oe, Ue, Ge, Xe, Be, Ce, Ne);
              }
              for (var At = null, ht = null, je = null, it = 0; it < Ue.length; it++) {
                var ve = Ue[it], Se = ve.state, Ye = [Se.throughput, Se.latency, Se.rebuffer, Se.switch], d = n.slice(), l = Oe.getNextBufferWithBitrate(ve.bitrate, Xe, Ce), T = l < Oe.getMinBuffer();
                T && h.debug("Buffer is low for bitrate=".concat(ve.bitrate, " downloadTime=").concat(we, " currentBuffer=").concat(Xe, " nextBuffer=").concat(l)), (ve.bitrate > K - 1e4 || T) && ve.bitrate !== m && (d[0] = 100);
                var b = F(Ye, [Je, 0, 0, 0], d);
                (At === null || b < At) && (At = b, ht = ve.qualityIndex, je = ve);
              }
              var $ = Math.abs(st.bitrate - je.bitrate) / o;
              return P(st, Ue, [Je, ie, Be, $]), P(je, Ue, [Je, 0, 0, $]), ht;
            }, reset: function() {
              k();
            } }, h = (0, E.Z)(S).getInstance().getLogger(e), k(), e;
          }
          t.__dashjs_factory_name = "LearningAbrController", fe.Z = J.Z.getClassFactory(t);
        }, 5317: function(_e, fe, R) {
          var J = R(5448), E = R(2298);
          function t() {
            var e, h, p, o, v;
            function m() {
              h = null, p = null, o = null, v = null;
            }
            function n(f, S, k, q) {
              var F = new E.Z();
              return F.type = f, F.weights.bitrateReward = S || 1, F.weights.bitrateSwitchPenalty = 1, F.weights.rebufferPenalty = k || 1e3, F.weights.latencyPenalty = [], F.weights.latencyPenalty.push({ threshold: 1.1, penalty: 0.05 * q }), F.weights.latencyPenalty.push({ threshold: 1e8, penalty: 0.1 * k }), F.weights.playbackSpeedPenalty = q || 200, F;
            }
            function c(f, S, k, q, F) {
              F.bitrateWSum += F.weights.bitrateReward * f, F.lastBitrate && (F.bitrateSwitchWSum += F.weights.bitrateSwitchPenalty * Math.abs(f - F.lastBitrate)), F.lastBitrate = f, F.rebufferWSum += F.weights.rebufferPenalty * S;
              for (var te = 0; te < F.weights.latencyPenalty.length; te++) {
                var P = F.weights.latencyPenalty[te];
                if (k <= P.threshold) {
                  F.latencyWSum += P.penalty * k;
                  break;
                }
              }
              F.playbackSpeedWSum += F.weights.playbackSpeedPenalty * Math.abs(1 - q), F.totalQoe = F.bitrateWSum - F.bitrateSwitchWSum - F.rebufferWSum - F.latencyWSum - F.playbackSpeedWSum;
            }
            return e = { setupPerSegmentQoe: function(f, S, k) {
              h = n("segment", f, S, k), p = f, o = S, v = k;
            }, logSegmentMetrics: function(f, S, k, q) {
              h && c(f, S, k, q, h);
            }, getPerSegmentQoe: function() {
              return h;
            }, calculateSingleUseQoe: function(f, S, k, q) {
              var F = null;
              return p && o && v && (F = n("segment", p, o, v)), F ? (c(f, S, k, q, F), F.totalQoe) : 0;
            }, reset: function() {
              m();
            } }, m(), e;
          }
          t.__dashjs_factory_name = "LoLpQoeEvaluator", fe.Z = J.Z.getClassFactory(t);
        }, 5435: function(_e, fe, R) {
          var J = R(6398), E = R(5448), t = R(4722), e = R(5317), h = R(2068), p = R(3860), o = R(6523), v = R(3393);
          function m(n) {
            var c, f, S, k, q = (n = n || {}).dashMetrics, F = this.context;
            return f = { getMaxIndex: function(te) {
              try {
                var P = (0, h.Z)(F).create(), Q = te.getMediaInfo().type, se = te.getAbrController(), K = te.getStreamInfo(), ie = se.getQualityFor(Q, K.id), ge = te.getMediaInfo(), Ne = q.getCurrentBufferState(Q), ee = te.getScheduleController(), Oe = q.getCurrentBufferLevel(Q, !0), Ge = K && K.manifestInfo ? K.manifestInfo.isDynamic : null, Xe = ee.getPlaybackController(), Ce = Xe.getCurrentLiveLatency();
                if (!te.useLoLPABR() || Q === v.Z.AUDIO) return P;
                Ce || (Ce = 0);
                var Ue = Xe.getPlaybackRate(), Je = se.getThroughputHistory().getSafeAverageThroughput(Q, Ge);
                if (c.debug("Throughput ".concat(Math.round(Je), " kbps")), isNaN(Je) || !Ne || se.getAbandonmentStateFor(K.id, Q) === p.Z.ABANDON_LOAD) return P;
                for (var st = ge.bitrateList, we = te.getRepresentationInfo().fragmentDuration, Be = st[0].bandwidth / 1e3, At = st[st.length - 1].bandwidth / 1e3, ht = 0; ht < st.length; ht++) {
                  var je = st[ht].bandwidth / 1e3;
                  je > At ? At = je : je < Be && (Be = je);
                }
                var it = st[ie].bandwidth / 1e3, ve = q.getCurrentHttpRequest(Q, !0), Se = (ve.tresponse.getTime() - ve.trequest.getTime()) / 1e3, Ye = Se > we ? Se - we : 0;
                k.setupPerSegmentQoe(we, At, Be), k.logSegmentMetrics(it, Ye, Ce, Ue);
                var d = (0, o.Z)(F).create({ targetLatency: 1.5, bufferMin: 0.3, segmentDuration: we, qoeEvaluator: k });
                return P.quality = S.getNextQuality(ge, 1e3 * Je, Ce, Oe, Ue, ie, d), P.reason = { throughput: Je, latency: Ce }, P.priority = h.Z.PRIORITY.STRONG, ee.setTimeToLoadDelay(0), P.quality !== ie && c.debug("[TgcLearningRule][" + Q + "] requesting switch to index: ", P.quality, "Average throughput", Math.round(Je), "kbps"), P;
              } catch (l) {
                throw l;
              }
            }, reset: function() {
              S.reset(), k.reset();
            } }, c = (0, J.Z)(F).getInstance().getLogger(f), S = (0, t.Z)(F).create(), k = (0, e.Z)(F).create(), f;
          }
          m.__dashjs_factory_name = "LoLPRule", fe.Z = E.Z.getClassFactory(m);
        }, 6523: function(_e, fe, R) {
          var J = R(5448);
          function E(t) {
            var e, h, p, o, v = t.targetLatency, m = t.bufferMin, n = t.segmentDuration, c = t.qoeEvaluator;
            function f() {
              return n;
            }
            function S(k, q) {
              var F = f();
              return q > F ? k - F : k + F - q;
            }
            return e = { getMinBuffer: function() {
              return m;
            }, getSegmentDuration: f, getNextBufferWithBitrate: function(k, q, F) {
              return S(q, k * n / F);
            }, getNextBuffer: S, findWeightVector: function(k, q, F, te, P, Q) {
              var se = null, K = null, ie = null, ge = Math.abs(q - p);
              return k.forEach(function(Ne) {
                h.forEach(function(ee) {
                  ee[0];
                  var Oe = ee[1], Ge = ee[2], Xe = (ee[3], Ne.bitrate * n / P), Ce = S(F, Xe), Ue = (Ge === 0 ? 10 : 1 / Ge) * Math.max(1e-5, Xe - Ce), Je = (Oe === 0 ? 10 : 1 / Oe) * Ne.state.latency, st = c.calculateSingleUseQoe(Ne.bitrate, Ue, Je, Q);
                  (se === null || st > se) && function(we, Be, At) {
                    return !(we > v + At) && Be >= m;
                  }(q, Ce, ge) && (se = st, K = ee, ie = Ne.bitrate);
                });
              }), K === null && ie === null && (K = -1), p = q, K;
            } }, h = function k(q, F, te) {
              if (te === F) return q;
              for (var P = q.length, Q = 0; Q < P; Q++) for (var se = q.shift(), K = 0; K < o.length; K++) q.push(se.concat(o[K]));
              return k(q, F, te + 1);
            }((o = [0.2, 0.4, 0.6, 0.8, 1]).map(function(k) {
              return [k];
            }), 4, 1), p = 0, e;
          }
          E.__dashjs_factory_name = "LoLpWeightSelector", fe.Z = J.Z.getClassFactory(E);
        }, 2298: function(_e, fe) {
          fe.Z = function R() {
            (function(J, E) {
              if (!(J instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.type = null, this.lastBitrate = null, this.weights = {}, this.weights.bitrateReward = null, this.weights.bitrateSwitchPenalty = null, this.weights.rebufferPenalty = null, this.weights.latencyPenalty = null, this.weights.playbackSpeedPenalty = null, this.bitrateWSum = 0, this.bitrateSwitchWSum = 0, this.rebufferWSum = 0, this.latencyWSum = 0, this.playbackSpeedWSum = 0, this.totalQoe = 0;
          };
        }, 7803: function(_e, fe, R) {
          R.d(fe, { Y: function() {
            return c;
          } });
          var J = R(3393), E = R(1553), t = R(5448), e = R(2128), h = R(2594), p = R(7387), o = R(7417), v = R(9032), m = R(9326), n = R(7802), c = ["http://dashif.org/thumbnail_tile", "http://dashif.org/guidelines/thumbnail_tile"];
          function f(S) {
            var k, q, F, te, P, Q, se, K, ie = this.context, ge = S.adapter, Ne = S.baseURLController, ee = S.streamInfo, Oe = S.timelineConverter, Ge = S.debug, Xe = S.eventBus, Ce = S.events, Ue = S.dashConstants, Je = (0, h.Z)(ie).getInstance();
            function st(Be, At) {
              var ht = new e.Z();
              ht.id = Be.id, ht.bitrate = Be.bandwidth, ht.width = Be.width, ht.height = Be.height, ht.tilesHor = 1, ht.tilesVert = 1, Be.essentialProperties && Be.essentialProperties.forEach(function(je) {
                if (c.indexOf(je.schemeIdUri) >= 0 && je.value) {
                  var it = je.value.split("x");
                  it.length !== 2 || isNaN(it[0]) || isNaN(it[1]) || (ht.tilesHor = parseInt(it[0], 10), ht.tilesVert = parseInt(it[1], 10));
                }
              }), At ? Q.updateSegmentData(Be).then(function(je) {
                (function(it, ve, Se) {
                  var Ye = [], d = function(l, T) {
                    var b, $, W, Ie, $e = [], Ze = 0;
                    for (b = 0, $ = l.segments.length; b < $; b++) W = l.segments[b], (Ie = (0, p.TJ)(Oe, ge.getIsDynamic(), T, W.startTime, W.duration, W.timescale, W.media, W.mediaRange, Ze)) && ($e.push(Ie), Ie = null, Ze++);
                    return $e;
                  }(Se, ve);
                  ve.segments = d, it.segmentDuration = ve.segments[0].duration, it.readThumbnail = function(l, T) {
                    var b = null;
                    Ye.some(function($) {
                      if ($.start <= l && $.end > l) return b = $.url, !0;
                    }), b ? T(b) : ve.segments.some(function($) {
                      if ($.mediaStartTime <= l && $.mediaStartTime + $.duration > l) {
                        var W = Ne.resolve(ve.path);
                        return se.load({ method: "get", url: W.url, request: { range: $.mediaRange, responseType: "arraybuffer" }, onload: function(Ie) {
                          var $e = K.getSamplesInfo(Ie.target.response), Ze = new Blob([Ie.target.response.slice($e.sampleList[0].offset, $e.sampleList[0].offset + $e.sampleList[0].size)], { type: "image/jpeg" }), xe = window.URL.createObjectURL(Ze);
                          Ye.push({ start: $.mediaStartTime, end: $.mediaStartTime + $.duration, url: xe }), T && T(xe);
                        } }), !0;
                      }
                    });
                  };
                })(ht, Be, je);
              }) : (ht.startNumber = Be.startNumber, ht.segmentDuration = Be.segmentDuration, ht.timescale = Be.timescale, ht.templateUrl = function(je) {
                var it = Je.isRelative(je.media) ? Je.resolve(je.media, Ne.resolve(je.path).url) : je.media;
                return it ? (0, p.Aj)(it, je.id) : "";
              }(Be)), ht.tilesHor > 0 && ht.tilesVert > 0 && (ht.widthPerTile = ht.width / ht.tilesHor, ht.heightPerTile = ht.height / ht.tilesVert, q.push(ht));
            }
            function we() {
              q = [], te = -1, P = null;
            }
            return k = { getTracks: function() {
              return q;
            }, addTracks: function() {
              if (ee && ge && (P = ge.getMediaInfoForType(ee, J.Z.IMAGE))) {
                var Be = ge.getVoRepresentations(P);
                Be && Be.length > 0 && Be.forEach(function(At) {
                  (At.segmentInfoType === E.Z.SEGMENT_TEMPLATE && At.segmentDuration > 0 && At.media || At.segmentInfoType === E.Z.SEGMENT_TIMELINE) && st(At), At.segmentInfoType === E.Z.SEGMENT_BASE && st(At, !0);
                }), q.length > 0 && q.sort(function(At, ht) {
                  return At.bitrate - ht.bitrate;
                });
              }
            }, reset: we, setTrackByIndex: function(Be) {
              q && q.length !== 0 && (Be >= q.length && (Be = q.length - 1), te = Be);
            }, getCurrentTrack: function() {
              return te < 0 ? null : q[te];
            }, getCurrentTrackIndex: function() {
              return te;
            }, getThumbnailRequestForTime: function(Be) {
              for (var At, ht = ge.getVoRepresentations(P), je = 0; je < ht.length; je++) if (q[te].id === ht[je].id) {
                At = ht[je];
                break;
              }
              return F.getSegmentRequestForTime(P, At, Be);
            } }, we(), se = (0, v.Z)(ie).create({}), K = (0, o.Z)(ie).getInstance(), Q = (0, n.Z)(ie).create({ events: Ce, eventBus: Xe, streamInfo: ee, timelineConverter: Oe, dashConstants: Ue, dashMetrics: S.dashMetrics, segmentBaseController: S.segmentBaseController, type: J.Z.IMAGE }), (F = (0, m.Z)(ie).create({ streamInfo: ee, type: J.Z.IMAGE, timelineConverter: Oe, segmentsController: Q, baseURLController: Ne, debug: Ge, eventBus: Xe, events: Ce, dashConstants: Ue, urlUtils: Je })).initialize(!!ge && ge.getIsDynamic()), k;
          }
          f.__dashjs_factory_name = "ThumbnailTracks", fe.Z = t.Z.getClassFactory(f);
        }, 7417: function(_e, fe, R) {
          var J = R(6398), E = R(8260), t = R(5448), e = R(6934), h = R(9597);
          function p() {
            var o, v, m = this.context;
            function n(S) {
              if (!S) return null;
              S.fileStart === void 0 && (S.fileStart = 0);
              var k = e.parseBuffer(S), q = (0, E.Z)(m).create();
              return q.setData(k), q;
            }
            function c(S, k) {
              return S[k + 3] >>> 0 | S[k + 2] << 8 >>> 0 | S[k + 1] << 16 >>> 0 | S[k] << 24 >>> 0;
            }
            function f(S, k) {
              return String.fromCharCode(S[k++]) + String.fromCharCode(S[k++]) + String.fromCharCode(S[k++]) + String.fromCharCode(S[k]);
            }
            return v = { parse: n, findLastTopIsoBoxCompleted: function(S, k, q) {
              if (q === void 0 && (q = 0), !k || q + 8 >= k.byteLength) return new h.Z(0, !1);
              for (var F, te = k instanceof ArrayBuffer ? new Uint8Array(k) : k, P = 0; q < te.byteLength; ) {
                var Q = c(te, q), se = f(te, q + 4);
                if (Q === 0) break;
                q + Q <= te.byteLength && (S.indexOf(se) >= 0 ? F = new h.Z(q, !0, Q) : P = q + Q), q += Q;
              }
              return F || new h.Z(P, !1);
            }, getMediaTimescaleFromMoov: function(S) {
              var k = n(S), q = k ? k.getBox("mdhd") : void 0;
              return q ? q.timescale : NaN;
            }, getSamplesInfo: function(S) {
              if (!S || S.byteLength === 0) return { sampleList: [], lastSequenceNumber: NaN, totalDuration: NaN, numSequences: NaN };
              var k, q, F, te, P, Q, se, K, ie, ge, Ne, ee, Oe, Ge, Xe, Ce, Ue = n(S), Je = Ue.getBoxes("moof"), st = Ue.getBoxes("mfhd");
              Xe = Ue.getBoxes("moof").length, Ge = st[st.length - 1].sequence_number, q = 0, P = [];
              var we = -1, Be = -1;
              for (ge = 0; ge < Je.length; ge++) {
                var At = Je[ge], ht = At.getChildBoxes("traf");
                for (K = 0; K < ht.length; K++) {
                  var je = ht[K], it = je.getChildBox("tfhd"), ve = je.getChildBox("tfdt");
                  te = ve.baseMediaDecodeTime;
                  var Se = je.getChildBoxes("trun"), Ye = je.getChildBoxes("subs");
                  for (ie = 0; ie < Se.length; ie++) {
                    var d = Se[ie];
                    for (q = d.sample_count, Oe = (it.base_data_offset || 0) + (d.data_offset || 0), se = 0; se < q; se++) {
                      k = (Q = d.samples[se]).sample_duration !== void 0 ? Q.sample_duration : it.default_sample_duration, F = Q.sample_size !== void 0 ? Q.sample_size : it.default_sample_size;
                      var l = { dts: te, cts: te + (Q.sample_composition_time_offset !== void 0 ? Q.sample_composition_time_offset : 0), duration: k, offset: At.offset + Oe, size: F, subSizes: [F] };
                      if (Ye) for (Ne = 0; Ne < Ye.length; Ne++) {
                        var T = Ye[Ne];
                        if (we < T.entry_count - 1 && se > Be && (we++, Be += T.entries[we].sample_delta), se == Be) {
                          l.subSizes = [];
                          var b = T.entries[we];
                          for (ee = 0; ee < b.subsample_count; ee++) l.subSizes.push(b.subsamples[ee].subsample_size);
                        }
                      }
                      P.push(l), Oe += F, te += k;
                    }
                  }
                  Ce = te - ve.baseMediaDecodeTime;
                }
              }
              return { sampleList: P, lastSequenceNumber: Ge, totalDuration: Ce, numSequences: Xe };
            }, findInitRange: function(S) {
              var k = null, q = n(S);
              if (!q) return k;
              var F = q.getBox("ftyp"), te = q.getBox("moov");
              return o.debug("Searching for initialization."), te && te.isComplete && (k = (F ? F.offset : te.offset) + "-" + (te.offset + te.size - 1), o.debug("Found the initialization.  Range: " + k)), k;
            }, parsePayload: function(S, k, q) {
              if (q === void 0 && (q = 0), !k || q + 8 >= k.byteLength) return new h.Z(0, !1);
              for (var F, te = k instanceof ArrayBuffer ? new Uint8Array(k) : k, P = 0; q < te.byteLength; ) {
                var Q = c(te, q), se = f(te, q + 4);
                if (Q === 0) break;
                q + Q <= te.byteLength && (S.indexOf(se) >= 0 ? F = new h.Z(q, !0, Q, se) : P = q + Q), q += Q;
              }
              return F || new h.Z(P, !1);
            } }, o = (0, J.Z)(m).getInstance().getLogger(v), v;
          }
          p.__dashjs_factory_name = "BoxParser", fe.Z = t.Z.getSingletonFactory(p);
        }, 1715: function(_e, fe, R) {
          R.d(fe, { B: function() {
            return h;
          } });
          var J = R(5448), E = R(7803), t = R(3393), e = [{ codec: "avc1", compatibleCodecs: ["avc3"] }, { codec: "avc3", compatibleCodecs: ["avc1"] }];
          function h() {
            var o = "ManagedMediaSource" in window, v = "WebKitMediaSource" in window, m = "MediaSource" in window;
            return o || v || m;
          }
          function p() {
            var o, v, m;
            return o = { setConfig: function(n) {
              n && n.settings && (v = n.settings);
            }, supportsMediaSource: h, supportsEncryptedMedia: function() {
              return m;
            }, supportsCodec: function(n, c) {
              return c !== t.Z.AUDIO && c !== t.Z.VIDEO ? Promise.resolve(!0) : function(f, S) {
                return v.get().streaming.capabilities.useMediaCapabilitiesApi && navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo && (f.codec && S === t.Z.AUDIO || S === t.Z.VIDEO && f.codec && f.width && f.height && f.bitrate && f.framerate);
              }(n, c) ? function(f, S) {
                return new Promise(function(k) {
                  if (f && f.codec) {
                    var q = { type: "media-source" };
                    q[S] = {}, q[S].contentType = f.codec, q[S].width = f.width, q[S].height = f.height, q[S].bitrate = parseInt(f.bitrate), q[S].framerate = parseFloat(f.framerate), navigator.mediaCapabilities.decodingInfo(q).then(function(F) {
                      k(F.supported);
                    }).catch(function() {
                      k(!1);
                    });
                  } else k(!1);
                });
              }(n, c) : function(f) {
                return new Promise(function(S) {
                  if (f && f.codec) {
                    var k = f.codec;
                    f.width && f.height && (k += ';width="' + f.width + '";height="' + f.height + '"'), "ManagedMediaSource" in window && ManagedMediaSource.isTypeSupported(k) || "MediaSource" in window && MediaSource.isTypeSupported(k) || "WebKitMediaSource" in window && WebKitMediaSource.isTypeSupported(k) ? S(!0) : S(!1);
                  } else S(!1);
                });
              }(n);
            }, setEncryptedMediaSupported: function(n) {
              m = n;
            }, supportsEssentialProperty: function(n) {
              try {
                return E.Y.indexOf(n.schemeIdUri) !== -1 || t.Z.FONT_DOWNLOAD_DVB_SCHEME === n.schemeIdUri;
              } catch {
                return !0;
              }
            }, codecRootCompatibleWithCodec: function(n, c) {
              for (var f, S = n.split(".")[0], k = c.indexOf(S) === 0, q = 0; q < e.length; q++) if (e[q].codec === S) {
                f = e[q];
                break;
              }
              return f ? k || f.compatibleCodecs.some(function(F) {
                return c.indexOf(F) === 0;
              }) : k;
            } }, m = !1, o;
          }
          p.__dashjs_factory_name = "Capabilities", fe.Z = J.Z.getSingletonFactory(p);
        }, 2295: function(_e, fe, R) {
          var J = R(5448), E = R(3106);
          function t() {
            return { customTimeRangeArray: [], length: 0, add: function(e, h) {
              var p;
              for (p = 0; p < this.customTimeRangeArray.length && e > this.customTimeRangeArray[p].start; p++) ;
              for (this.customTimeRangeArray.splice(p, 0, { start: e, end: h }), p = 0; p < this.customTimeRangeArray.length - 1; p++) this.mergeRanges(p, p + 1) && p--;
              this.length = this.customTimeRangeArray.length;
            }, clear: function() {
              this.customTimeRangeArray = [], this.length = 0;
            }, remove: function(e, h) {
              for (var p = 0; p < this.customTimeRangeArray.length; p++) if (e <= this.customTimeRangeArray[p].start && h >= this.customTimeRangeArray[p].end) this.customTimeRangeArray.splice(p, 1), p--;
              else {
                if (e > this.customTimeRangeArray[p].start && h < this.customTimeRangeArray[p].end) {
                  this.customTimeRangeArray.splice(p + 1, 0, { start: h, end: this.customTimeRangeArray[p].end }), this.customTimeRangeArray[p].end = e;
                  break;
                }
                e > this.customTimeRangeArray[p].start && e < this.customTimeRangeArray[p].end ? this.customTimeRangeArray[p].end = e : h > this.customTimeRangeArray[p].start && h < this.customTimeRangeArray[p].end && (this.customTimeRangeArray[p].start = h);
              }
              this.length = this.customTimeRangeArray.length;
            }, mergeRanges: function(e, h) {
              var p = this.customTimeRangeArray[e], o = this.customTimeRangeArray[h];
              return p.start <= o.start && o.start <= p.end && p.end <= o.end ? (p.end = o.end, this.customTimeRangeArray.splice(h, 1), !0) : o.start <= p.start && p.start <= o.end && o.end <= p.end ? (p.start = o.start, this.customTimeRangeArray.splice(h, 1), !0) : o.start <= p.start && p.start <= o.end && p.end <= o.end ? (this.customTimeRangeArray.splice(e, 1), !0) : p.start <= o.start && o.start <= p.end && o.end <= p.end && (this.customTimeRangeArray.splice(h, 1), !0);
            }, start: function(e) {
              return (0, E.SE)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].start;
            }, end: function(e) {
              return (0, E.SE)(e), e >= this.customTimeRangeArray.length || e < 0 ? NaN : this.customTimeRangeArray[e].end;
            } };
          }
          t.__dashjs_factory_name = "CustomTimeRanges", fe.Z = J.Z.getClassFactory(t);
        }, 5: function(_e, fe, R) {
          var J = R(5448);
          function E() {
            var t, e = /^[a-z][a-z0-9+\-_.]*:/i, h = /^https?:\/\//i, p = /^https:\/\//i, o = /^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i, v = function(F, te) {
              try {
                return new window.URL(F, te).toString();
              } catch {
                return F;
              }
            }, m = function(F, te) {
              var P = n;
              if (!te || !S(F)) return F;
              k(F) && (P = c), q(F) && (P = f);
              var Q = P(te), se = Q.charAt(Q.length - 1) !== "/" && F.charAt(0) !== "/" ? "/" : "";
              return [Q, F].join(se);
            };
            function n(F) {
              var te = F.indexOf("/"), P = F.lastIndexOf("/");
              return te !== -1 ? P === te + 1 ? F : (F.indexOf("?") !== -1 && (F = F.substring(0, F.indexOf("?"))), F.substring(0, P + 1)) : "";
            }
            function c(F) {
              var te = F.match(o);
              return te ? te[1] : "";
            }
            function f(F) {
              var te = F.match(e);
              return te ? te[0] : "";
            }
            function S(F) {
              return !e.test(F);
            }
            function k(F) {
              return S(F) && F.charAt(0) === "/";
            }
            function q(F) {
              return F.indexOf("//") === 0;
            }
            return function() {
              try {
                new window.URL("x", "http://y"), t = v;
              } catch {
              } finally {
                t = t || m;
              }
            }(), { parseBaseUrl: n, parseOrigin: c, parseScheme: f, isRelative: S, isPathAbsolute: k, isSchemeRelative: q, isHTTPURL: function(F) {
              return h.test(F);
            }, isHTTPS: function(F) {
              return p.test(F);
            }, removeHostname: function(F) {
              return /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(F)[2].substring(1);
            }, resolve: function(F, te) {
              return t(F, te);
            } };
          }
          E.__dashjs_factory_name = "DefaultURLUtils", fe.Z = J.Z.getSingletonFactory(E);
        }, 8260: function(_e, fe, R) {
          var J = R(2839), E = R(5448);
          function t() {
            var e;
            function h(o) {
              var v = [];
              if (!o || !e || typeof e.fetchAll != "function") return v;
              for (var m, n = e.fetchAll(o), c = 0, f = n.length; c < f; c++) (m = p(n[c])) && v.push(m);
              return v;
            }
            function p(o) {
              if (!o) return null;
              var v = new J.Z(o);
              return o.hasOwnProperty("_incomplete") && (v.isComplete = !o._incomplete), v;
            }
            return { getBox: function(o) {
              return o && e && e.boxes && e.boxes.length !== 0 && typeof e.fetch == "function" ? p(e.fetch(o)) : null;
            }, getBoxes: h, setData: function(o) {
              e = o;
            }, getLastBox: function() {
              if (!e || !e.boxes || !e.boxes.length) return null;
              var o = h(e.boxes[e.boxes.length - 1].type);
              return o.length > 0 ? o[o.length - 1] : null;
            } };
          }
          t.__dashjs_factory_name = "IsoFile", fe.Z = E.Z.getClassFactory(t);
        }, 7473: function(_e, fe, R) {
          R.d(fe, { k: function() {
            return E;
          } });
          var J = R(5448);
          function E(e, h) {
            var p = { url: e.url, method: e.method, headers: Object.assign({}, e.headers), credentials: e.withCredentials ? "include" : void 0, range: e.request.range };
            return Promise.resolve(h.modifyRequest(p)).then(function() {
              return Object.assign(e, p, { withCredentials: p.credentials === "include" });
            });
          }
          function t() {
            return { modifyRequest: null, modifyRequestURL: function(e) {
              return e;
            }, modifyRequestHeader: function(e, h) {
              return h.url, e;
            } };
          }
          t.__dashjs_factory_name = "RequestModifier", fe.Z = J.Z.getSingletonFactory(t);
        }, 3106: function(_e, fe, R) {
          R.d(fe, { PS: function() {
            return t;
          }, SE: function() {
            return e;
          } });
          var J = R(3393);
          function E(h) {
            return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
              return typeof p;
            } : function(p) {
              return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
            }, E(h);
          }
          function t(h, p) {
            if (E(h) !== p) throw J.Z.BAD_ARGUMENT_ERROR;
          }
          function e(h) {
            if (h === null || isNaN(h) || h % 1 != 0) throw J.Z.BAD_ARGUMENT_ERROR + " : argument is not an integer";
          }
        }, 2594: function(_e, fe, R) {
          var J = R(5448), E = R(5);
          function t() {
            var h, p = [], o = this.context;
            function v(m, n, c) {
              var f = function(S) {
                var k;
                for (k = 0; k < p.length; k++) if (p[k].regex.test(S)) return p[k].utils;
                return h;
              }(c || n);
              return f && typeof f[m] == "function" ? f[m](n, c) : h[m](n, c);
            }
            return h = (0, E.Z)(o).getInstance(), { registerUrlRegex: function(m, n) {
              p.push({ regex: m, utils: n });
            }, parseBaseUrl: function(m) {
              return v("parseBaseUrl", m);
            }, parseOrigin: function(m) {
              return v("parseOrigin", m);
            }, parseScheme: function(m) {
              return v("parseScheme", m);
            }, isRelative: function(m) {
              return v("isRelative", m);
            }, isPathAbsolute: function(m) {
              return v("isPathAbsolute", m);
            }, isSchemeRelative: function(m) {
              return v("isSchemeRelative", m);
            }, isHTTPURL: function(m) {
              return v("isHTTPURL", m);
            }, isHTTPS: function(m) {
              return v("isHTTPS", m);
            }, removeHostname: function(m) {
              return v("removeHostname", m);
            }, resolve: function(m, n) {
              return v("resolve", m, n);
            } };
          }
          t.__dashjs_factory_name = "URLUtils";
          var e = J.Z.getSingletonFactory(t);
          fe.Z = e;
        }, 5459: function(_e, fe) {
          fe.Z = function R(J, E, t) {
            (function(e, h) {
              if (!(e instanceof h)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.code = J || null, this.message = E || null, this.data = t || null;
          };
        }, 3186: function(_e, fe, R) {
          var J = R(7855);
          function E(e, h) {
            for (var p = 0; p < h.length; p++) {
              var o = h[p];
              o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
          }
          var t = function() {
            function e(o) {
              (function(v, m) {
                if (!(v instanceof m)) throw new TypeError("Cannot call a class as a function");
              })(this, e), this.action = e.ACTION_DOWNLOAD, this.startTime = NaN, this.mediaStartTime = NaN, this.mediaType = null, this.mediaInfo = null, this.type = null, this.duration = NaN, this.timescale = NaN, this.range = null, this.url = o || null, this.serviceLocation = null, this.requestStartDate = null, this.firstByteDate = null, this.requestEndDate = null, this.quality = NaN, this.index = NaN, this.availabilityStartTime = null, this.availabilityEndTime = null, this.wallStartTime = null, this.bytesLoaded = NaN, this.bytesTotal = NaN, this.delayLoadingTime = NaN, this.responseType = "arraybuffer", this.representationId = null;
            }
            var h, p;
            return h = e, (p = [{ key: "isInitializationRequest", value: function() {
              return this.type && this.type === J.w.INIT_SEGMENT_TYPE;
            } }, { key: "setInfo", value: function(o) {
              this.type = o && o.init ? J.w.INIT_SEGMENT_TYPE : J.w.MEDIA_SEGMENT_TYPE, this.url = o && o.url ? o.url : null, this.range = o && o.range ? o.range.start + "-" + o.range.end : null, this.mediaType = o && o.mediaType ? o.mediaType : null;
            } }]) && E(h.prototype, p), e;
          }();
          t.ACTION_DOWNLOAD = "download", t.ACTION_COMPLETE = "complete", fe.Z = t;
        }, 2839: function(_e, fe) {
          function R(E, t) {
            for (var e = 0; e < t.length; e++) {
              var h = t[e];
              h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(E, h.key, h);
            }
          }
          var J = function() {
            function E(h) {
              if (function(f, S) {
                if (!(f instanceof S)) throw new TypeError("Cannot call a class as a function");
              }(this, E), this.offset = h._offset, this.type = h.type, this.size = h.size, this.boxes = [], h.boxes) for (var p = 0; p < h.boxes.length; p++) this.boxes.push(new E(h.boxes[p]));
              switch (this.isComplete = !0, h.type) {
                case "sidx":
                  if (this.timescale = h.timescale, this.earliest_presentation_time = h.earliest_presentation_time, this.first_offset = h.first_offset, this.references = h.references, h.references) {
                    this.references = [];
                    for (var o = 0; o < h.references.length; o++) {
                      var v = { reference_type: h.references[o].reference_type, referenced_size: h.references[o].referenced_size, subsegment_duration: h.references[o].subsegment_duration };
                      this.references.push(v);
                    }
                  }
                  break;
                case "emsg":
                  this.id = h.id, this.version = h.version === 1 ? 1 : 0, this.value = h.value, this.timescale = h.timescale, this.scheme_id_uri = h.scheme_id_uri, this.presentation_time_delta = h.version === 1 ? h.presentation_time : h.presentation_time_delta, this.event_duration = h.event_duration, this.message_data = h.message_data;
                  break;
                case "mdhd":
                  this.timescale = h.timescale;
                  break;
                case "mfhd":
                  this.sequence_number = h.sequence_number;
                  break;
                case "subs":
                  this.entry_count = h.entry_count, this.entries = h.entries;
                  break;
                case "tfhd":
                  this.base_data_offset = h.base_data_offset, this.sample_description_index = h.sample_description_index, this.default_sample_duration = h.default_sample_duration, this.default_sample_size = h.default_sample_size, this.default_sample_flags = h.default_sample_flags, this.flags = h.flags;
                  break;
                case "tfdt":
                  this.version = h.version, this.baseMediaDecodeTime = h.baseMediaDecodeTime, this.flags = h.flags;
                  break;
                case "trun":
                  if (this.sample_count = h.sample_count, this.first_sample_flags = h.first_sample_flags, this.data_offset = h.data_offset, this.flags = h.flags, this.samples = h.samples, h.samples) {
                    this.samples = [];
                    for (var m = 0, n = h.samples.length; m < n; m++) {
                      var c = { sample_size: h.samples[m].sample_size, sample_duration: h.samples[m].sample_duration, sample_composition_time_offset: h.samples[m].sample_composition_time_offset };
                      this.samples.push(c);
                    }
                  }
                  break;
                case "prft":
                  this.version = h.version, this.reference_track_ID = h.reference_track_ID, this.ntp_timestamp_sec = h.ntp_timestamp_sec, this.ntp_timestamp_frac = h.ntp_timestamp_frac, this.media_time = h.media_time, this.flags = h.flags;
              }
            }
            var t, e;
            return t = E, (e = [{ key: "getChildBox", value: function(h) {
              for (var p = 0; p < this.boxes.length; p++) if (this.boxes[p].type === h) return this.boxes[p];
            } }, { key: "getChildBoxes", value: function(h) {
              for (var p = [], o = 0; o < this.boxes.length; o++) this.boxes[o].type === h && p.push(this.boxes[o]);
              return p;
            } }]) && R(t.prototype, e), E;
          }();
          fe.Z = J;
        }, 9597: function(_e, fe) {
          fe.Z = function R(J, E, t) {
            (function(e, h) {
              if (!(e instanceof h)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.lastCompletedOffset = J, this.found = E, this.size = t;
          };
        }, 2128: function(_e, fe) {
          fe.Z = function R() {
            (function(J, E) {
              if (!(J instanceof E)) throw new TypeError("Cannot call a class as a function");
            })(this, R), this.bitrate = 0, this.width = 0, this.height = 0, this.tilesHor = 0, this.tilesVert = 0, this.widthPerTile = 0, this.heightPerTile = 0, this.startNumber = 0, this.segmentDuration = 0, this.timescale = 0, this.templateUrl = "", this.id = "";
          };
        }, 7855: function(_e, fe, R) {
          function J(e, h) {
            if (!(e instanceof h)) throw new TypeError("Cannot call a class as a function");
          }
          R.d(fe, { O: function() {
            return t;
          }, w: function() {
            return E;
          } });
          var E = function e() {
            J(this, e), this.tcpid = null, this.type = null, this.url = null, this.actualurl = null, this.range = null, this.trequest = null, this.tresponse = null, this.responsecode = null, this.interval = null, this.trace = [], this.cmsd = null, this._stream = null, this._tfinish = null, this._mediaduration = null, this._quality = null, this._responseHeaders = null, this._serviceLocation = null, this._fileLoaderType = null;
          }, t = function e() {
            J(this, e), this.s = null, this.d = null, this.b = [];
          };
          E.GET = "GET", E.HEAD = "HEAD", E.MPD_TYPE = "MPD", E.XLINK_EXPANSION_TYPE = "XLinkExpansion", E.INIT_SEGMENT_TYPE = "InitializationSegment", E.INDEX_SEGMENT_TYPE = "IndexSegment", E.MEDIA_SEGMENT_TYPE = "MediaSegment", E.BITSTREAM_SWITCHING_SEGMENT_TYPE = "BitstreamSwitchingSegment", E.MSS_FRAGMENT_INFO_SEGMENT_TYPE = "FragmentInfoSegment", E.DVB_REPORTING_TYPE = "DVBReporting", E.LICENSE = "license", E.CONTENT_STEERING_TYPE = "ContentSteering", E.OTHER_TYPE = "other";
        }, 3039: function(_e, fe) {
          function R(E, t) {
            return function(e, h) {
              for (var p, o, v, m = J(e, "tag"), n = J(h ?? "*", "range"), c = [], f = -1; ++f < n.length; ) if (p = n[f].toLowerCase(), t || p !== "*") {
                for (o = -1, v = []; ++o < m.length; ) if (E(m[o].toLowerCase(), p)) {
                  if (!t) return m[o];
                  c.push(m[o]);
                } else v.push(m[o]);
                m = v;
              }
              return t ? c : void 0;
            };
          }
          function J(E, t) {
            var e = E && typeof E == "string" ? [E] : E;
            if (!e || typeof e != "object" || !("length" in e)) throw new Error("Invalid " + t + " `" + e + "`, expected non-empty string");
            return e;
          }
          fe.basicFilter = R(function(E, t) {
            return t === "*" || E === t || E.indexOf(t + "-") > -1;
          }, !0), fe.extendedFilter = R(function(E, t) {
            var e = E.split("-"), h = t.split("-"), p = 0, o = 0;
            if (h[o] !== "*" && e[p] !== h[o]) return !1;
            for (p++, o++; o < h.length; ) if (h[o] !== "*") {
              if (!e[p]) return !1;
              if (e[p] !== h[o]) {
                if (e[p].length === 1) return !1;
                p++;
              } else p++, o++;
            } else o++;
            return !0;
          }, !0), fe.lookup = R(function(E, t) {
            for (var e, h = t; ; ) {
              if (h === "*" || E === h) return !0;
              if ((e = h.lastIndexOf("-")) < 0) return !1;
              h.charAt(e - 2) === "-" && (e -= 2), h = h.slice(0, e);
            }
          });
        }, 3973: function(_e, fe, R) {
          _e.exports = R(3854);
        }, 3854: function(_e, fe, R) {
          var J = R(2415), E = R(3039), t = R(7778), e = R(5813), h = R(3165), p = R(9460);
          _e.exports = function(k, q) {
            var F, te = q || {}, P = J.parse(String(k || "").toLowerCase(), te), Q = J.stringify(P), se = -1;
            if (!Q) return Q;
            for (; ++se < t.length; ) E.extendedFilter(Q, t[se].from).length && (n(P, t[se].from, t[se].to), Q = J.stringify(P));
            for (se = -1; ++se < e.length; ) c(P, e[se].from.field, e[se].from.value) && f(P, e[se].to.field, e[se].to.value);
            for (Q = J.stringify(Object.assign({}, P, m)), se = -1; ++se < h.length; ) Q === h[se] && (n(P, h[se], h[se].split("-").slice(0, -1).join("-")), Q = J.stringify(Object.assign({}, P, m)));
            if (P.extensions.sort(S), te.warning) for (F in p) o.call(p[F], P[F]) && te.warning("Deprecated " + F + " `" + P[F] + "`, expected one of `" + p[F][P[F]].join("`, `") + "`", null, 7);
            return P.script && (P.script = P.script.charAt(0).toUpperCase() + P.script.slice(1)), P.region && (P.region = P.region.toUpperCase()), J.stringify(P);
          };
          var o = {}.hasOwnProperty, v = new Intl.Collator(), m = { variants: [], extensions: [], privateuse: [], irregular: null, regular: null };
          function n(k, q, F) {
            var te, P = J.parse(q), Q = J.parse(F), se = [];
            for (te in P) P[te] && P[te].length && c(k, te, P[te]) && se.push(te);
            for (te in Q) Q[te] && Q[te].length && (se.indexOf(te) > -1 || !k[te] || !k[te].length) && f(k, te, Q[te]);
          }
          function c(k, q, F) {
            var te, P, Q, se, K = !1;
            if (F) {
              if (P = te = k[q], te && typeof te == "object") for (P = [], Q = -1; ++Q < te.length; ) se = te[Q], F.indexOf(se) < 0 ? P.push(se) : K = !0;
              else te === F && (P = null, K = !0);
              k[q] = P;
            }
            return K;
          }
          function f(k, q, F) {
            var te, P, Q, se = k[q];
            if (se && typeof se == "object") for (te = [].concat(F), P = -1; ++P < te.length; ) Q = te[P], se.indexOf(Q) < 0 && se.push(Q);
            else k[q] = F;
          }
          function S(k, q) {
            return v.compare(k.singleton, q.singleton);
          }
        }, 2415: function(_e, fe, R) {
          fe.parse = R(6903), fe.stringify = R(6713);
        }, 6903: function(_e, fe, R) {
          var J = R(2219), E = R(3516), t = R(395), e = R(858), h = R(8589);
          _e.exports = function o(v, m) {
            var n, c, f, S = m || {}, k = { language: null, extendedLanguageSubtags: [], script: null, region: null, variants: [], extensions: [], privateuse: [], irregular: null, regular: null }, q = String(v), F = q.toLowerCase(), te = 0;
            if (v == null) throw new Error("Expected string, got `" + v + "`");
            if (p.call(h, F)) return (S.normalize == null || S.normalize) && h[F] ? o(h[F]) : (k[e.indexOf(F) === -1 ? "irregular" : "regular"] = q, k);
            for (; E(F.charCodeAt(te)) && te < 9; ) te++;
            if (te > 1 && te < 9) {
              if (k.language = q.slice(0, te), te < 4) for (c = 0; F.charCodeAt(te) === 45 && E(F.charCodeAt(te + 1)) && E(F.charCodeAt(te + 2)) && E(F.charCodeAt(te + 3)) && !E(F.charCodeAt(te + 4)); ) {
                if (c > 2) return P(te, 3, "Too many extended language subtags, expected at most 3 subtags");
                k.extendedLanguageSubtags.push(q.slice(te + 1, te + 4)), te += 4, c++;
              }
              for (F.charCodeAt(te) === 45 && E(F.charCodeAt(te + 1)) && E(F.charCodeAt(te + 2)) && E(F.charCodeAt(te + 3)) && E(F.charCodeAt(te + 4)) && !E(F.charCodeAt(te + 5)) && (k.script = q.slice(te + 1, te + 5), te += 5), F.charCodeAt(te) === 45 && (E(F.charCodeAt(te + 1)) && E(F.charCodeAt(te + 2)) && !E(F.charCodeAt(te + 3)) ? (k.region = q.slice(te + 1, te + 3), te += 3) : t(F.charCodeAt(te + 1)) && t(F.charCodeAt(te + 2)) && t(F.charCodeAt(te + 3)) && !t(F.charCodeAt(te + 4)) && (k.region = q.slice(te + 1, te + 4), te += 4)); F.charCodeAt(te) === 45; ) {
                for (f = n = te + 1; J(F.charCodeAt(f)); ) {
                  if (f - n > 7) return P(f, 1, "Too long variant, expected at most 8 characters");
                  f++;
                }
                if (!(f - n > 4 || f - n > 3 && t(F.charCodeAt(n)))) break;
                k.variants.push(q.slice(n, f)), te = f;
              }
              for (; F.charCodeAt(te) === 45 && F.charCodeAt(te + 1) !== 120 && J(F.charCodeAt(te + 1)) && F.charCodeAt(te + 2) === 45 && J(F.charCodeAt(te + 3)); ) {
                for (f = te + 2, c = 0; F.charCodeAt(f) === 45 && J(F.charCodeAt(f + 1)) && J(F.charCodeAt(f + 2)); ) for (f = (n = f + 1) + 2, c++; J(F.charCodeAt(f)); ) {
                  if (f - n > 7) return P(f, 2, "Too long extension, expected at most 8 characters");
                  f++;
                }
                if (!c) return P(f, 4, "Empty extension, extensions must have at least 2 characters of content");
                k.extensions.push({ singleton: q.charAt(te + 1), extensions: q.slice(te + 3, f).split("-") }), te = f;
              }
            } else te = 0;
            if (te === 0 && F.charCodeAt(te) === 120 || F.charCodeAt(te) === 45 && F.charCodeAt(te + 1) === 120) for (f = te = te ? te + 2 : 1; F.charCodeAt(f) === 45 && J(F.charCodeAt(f + 1)); ) {
              for (f = n = te + 1; J(F.charCodeAt(f)); ) {
                if (f - n > 7) return P(f, 5, "Too long private-use area, expected at most 8 characters");
                f++;
              }
              k.privateuse.push(q.slice(te + 1, f)), te = f;
            }
            return te !== q.length ? P(te, 6, "Found superfluous content after tag") : k;
            function P(Q, se, K) {
              return S.warning && S.warning(K, se, Q), S.forgiving ? k : { language: null, extendedLanguageSubtags: [], script: null, region: null, variants: [], extensions: [], privateuse: [], irregular: null, regular: null };
            }
          };
          var p = {}.hasOwnProperty;
        }, 6713: function(_e) {
          _e.exports = function(fe) {
            var R, J, E, t = fe || {}, e = [];
            if (t.irregular || t.regular) return t.irregular || t.regular;
            if (t.language) for (e = e.concat(t.language, t.extendedLanguageSubtags || [], t.script || [], t.region || [], t.variants || []), R = t.extensions || [], J = -1; ++J < R.length; ) (E = R[J]).singleton && E.extensions && E.extensions.length && (e = e.concat(E.singleton, E.extensions));
            return t.privateuse && t.privateuse.length && (e = e.concat("x", t.privateuse)), e.join("-");
          };
        }, 1549: function(_e, fe, R) {
          var J = R(6693), E = R(2165), t = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
          fe.Buffer = p, fe.SlowBuffer = function(d) {
            return +d != d && (d = 0), p.alloc(+d);
          }, fe.INSPECT_MAX_BYTES = 50;
          var e = 2147483647;
          function h(d) {
            if (d > e) throw new RangeError('The value "' + d + '" is invalid for option "size"');
            var l = new Uint8Array(d);
            return Object.setPrototypeOf(l, p.prototype), l;
          }
          function p(d, l, T) {
            if (typeof d == "number") {
              if (typeof l == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
              return m(d);
            }
            return o(d, l, T);
          }
          function o(d, l, T) {
            if (typeof d == "string") return function(W, Ie) {
              if (typeof Ie == "string" && Ie !== "" || (Ie = "utf8"), !p.isEncoding(Ie)) throw new TypeError("Unknown encoding: " + Ie);
              var $e = 0 | S(W, Ie), Ze = h($e), xe = Ze.write(W, Ie);
              return xe !== $e && (Ze = Ze.slice(0, xe)), Ze;
            }(d, l);
            if (ArrayBuffer.isView(d)) return function(W) {
              if (ve(W, Uint8Array)) {
                var Ie = new Uint8Array(W);
                return c(Ie.buffer, Ie.byteOffset, Ie.byteLength);
              }
              return n(W);
            }(d);
            if (d == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof d);
            if (ve(d, ArrayBuffer) || d && ve(d.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ve(d, SharedArrayBuffer) || d && ve(d.buffer, SharedArrayBuffer))) return c(d, l, T);
            if (typeof d == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
            var b = d.valueOf && d.valueOf();
            if (b != null && b !== d) return p.from(b, l, T);
            var $ = function(W) {
              if (p.isBuffer(W)) {
                var Ie = 0 | f(W.length), $e = h(Ie);
                return $e.length === 0 || W.copy($e, 0, 0, Ie), $e;
              }
              return W.length !== void 0 ? typeof W.length != "number" || Se(W.length) ? h(0) : n(W) : W.type === "Buffer" && Array.isArray(W.data) ? n(W.data) : void 0;
            }(d);
            if ($) return $;
            if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof d[Symbol.toPrimitive] == "function") return p.from(d[Symbol.toPrimitive]("string"), l, T);
            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof d);
          }
          function v(d) {
            if (typeof d != "number") throw new TypeError('"size" argument must be of type number');
            if (d < 0) throw new RangeError('The value "' + d + '" is invalid for option "size"');
          }
          function m(d) {
            return v(d), h(d < 0 ? 0 : 0 | f(d));
          }
          function n(d) {
            for (var l = d.length < 0 ? 0 : 0 | f(d.length), T = h(l), b = 0; b < l; b += 1) T[b] = 255 & d[b];
            return T;
          }
          function c(d, l, T) {
            if (l < 0 || d.byteLength < l) throw new RangeError('"offset" is outside of buffer bounds');
            if (d.byteLength < l + (T || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var b;
            return b = l === void 0 && T === void 0 ? new Uint8Array(d) : T === void 0 ? new Uint8Array(d, l) : new Uint8Array(d, l, T), Object.setPrototypeOf(b, p.prototype), b;
          }
          function f(d) {
            if (d >= e) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + e.toString(16) + " bytes");
            return 0 | d;
          }
          function S(d, l) {
            if (p.isBuffer(d)) return d.length;
            if (ArrayBuffer.isView(d) || ve(d, ArrayBuffer)) return d.byteLength;
            if (typeof d != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof d);
            var T = d.length, b = arguments.length > 2 && arguments[2] === !0;
            if (!b && T === 0) return 0;
            for (var $ = !1; ; ) switch (l) {
              case "ascii":
              case "latin1":
              case "binary":
                return T;
              case "utf8":
              case "utf-8":
                return ht(d).length;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * T;
              case "hex":
                return T >>> 1;
              case "base64":
                return je(d).length;
              default:
                if ($) return b ? -1 : ht(d).length;
                l = ("" + l).toLowerCase(), $ = !0;
            }
          }
          function k(d, l, T) {
            var b = !1;
            if ((l === void 0 || l < 0) && (l = 0), l > this.length || ((T === void 0 || T > this.length) && (T = this.length), T <= 0) || (T >>>= 0) <= (l >>>= 0)) return "";
            for (d || (d = "utf8"); ; ) switch (d) {
              case "hex":
                return Xe(this, l, T);
              case "utf8":
              case "utf-8":
                return Ne(this, l, T);
              case "ascii":
                return Oe(this, l, T);
              case "latin1":
              case "binary":
                return Ge(this, l, T);
              case "base64":
                return ge(this, l, T);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return Ce(this, l, T);
              default:
                if (b) throw new TypeError("Unknown encoding: " + d);
                d = (d + "").toLowerCase(), b = !0;
            }
          }
          function q(d, l, T) {
            var b = d[l];
            d[l] = d[T], d[T] = b;
          }
          function F(d, l, T, b, $) {
            if (d.length === 0) return -1;
            if (typeof T == "string" ? (b = T, T = 0) : T > 2147483647 ? T = 2147483647 : T < -2147483648 && (T = -2147483648), Se(T = +T) && (T = $ ? 0 : d.length - 1), T < 0 && (T = d.length + T), T >= d.length) {
              if ($) return -1;
              T = d.length - 1;
            } else if (T < 0) {
              if (!$) return -1;
              T = 0;
            }
            if (typeof l == "string" && (l = p.from(l, b)), p.isBuffer(l)) return l.length === 0 ? -1 : te(d, l, T, b, $);
            if (typeof l == "number") return l &= 255, typeof Uint8Array.prototype.indexOf == "function" ? $ ? Uint8Array.prototype.indexOf.call(d, l, T) : Uint8Array.prototype.lastIndexOf.call(d, l, T) : te(d, [l], T, b, $);
            throw new TypeError("val must be string, number or Buffer");
          }
          function te(d, l, T, b, $) {
            var W, Ie = 1, $e = d.length, Ze = l.length;
            if (b !== void 0 && ((b = String(b).toLowerCase()) === "ucs2" || b === "ucs-2" || b === "utf16le" || b === "utf-16le")) {
              if (d.length < 2 || l.length < 2) return -1;
              Ie = 2, $e /= 2, Ze /= 2, T /= 2;
            }
            function xe(bt, dt) {
              return Ie === 1 ? bt[dt] : bt.readUInt16BE(dt * Ie);
            }
            if ($) {
              var Me = -1;
              for (W = T; W < $e; W++) if (xe(d, W) === xe(l, Me === -1 ? 0 : W - Me)) {
                if (Me === -1 && (Me = W), W - Me + 1 === Ze) return Me * Ie;
              } else Me !== -1 && (W -= W - Me), Me = -1;
            } else for (T + Ze > $e && (T = $e - Ze), W = T; W >= 0; W--) {
              for (var Ve = !0, ot = 0; ot < Ze; ot++) if (xe(d, W + ot) !== xe(l, ot)) {
                Ve = !1;
                break;
              }
              if (Ve) return W;
            }
            return -1;
          }
          function P(d, l, T, b) {
            T = Number(T) || 0;
            var $ = d.length - T;
            b ? (b = Number(b)) > $ && (b = $) : b = $;
            var W = l.length;
            b > W / 2 && (b = W / 2);
            for (var Ie = 0; Ie < b; ++Ie) {
              var $e = parseInt(l.substr(2 * Ie, 2), 16);
              if (Se($e)) return Ie;
              d[T + Ie] = $e;
            }
            return Ie;
          }
          function Q(d, l, T, b) {
            return it(ht(l, d.length - T), d, T, b);
          }
          function se(d, l, T, b) {
            return it(function($) {
              for (var W = [], Ie = 0; Ie < $.length; ++Ie) W.push(255 & $.charCodeAt(Ie));
              return W;
            }(l), d, T, b);
          }
          function K(d, l, T, b) {
            return it(je(l), d, T, b);
          }
          function ie(d, l, T, b) {
            return it(function($, W) {
              for (var Ie, $e, Ze, xe = [], Me = 0; Me < $.length && !((W -= 2) < 0); ++Me) $e = (Ie = $.charCodeAt(Me)) >> 8, Ze = Ie % 256, xe.push(Ze), xe.push($e);
              return xe;
            }(l, d.length - T), d, T, b);
          }
          function ge(d, l, T) {
            return l === 0 && T === d.length ? J.fromByteArray(d) : J.fromByteArray(d.slice(l, T));
          }
          function Ne(d, l, T) {
            T = Math.min(d.length, T);
            for (var b = [], $ = l; $ < T; ) {
              var W, Ie, $e, Ze, xe = d[$], Me = null, Ve = xe > 239 ? 4 : xe > 223 ? 3 : xe > 191 ? 2 : 1;
              if ($ + Ve <= T) switch (Ve) {
                case 1:
                  xe < 128 && (Me = xe);
                  break;
                case 2:
                  (192 & (W = d[$ + 1])) == 128 && (Ze = (31 & xe) << 6 | 63 & W) > 127 && (Me = Ze);
                  break;
                case 3:
                  W = d[$ + 1], Ie = d[$ + 2], (192 & W) == 128 && (192 & Ie) == 128 && (Ze = (15 & xe) << 12 | (63 & W) << 6 | 63 & Ie) > 2047 && (Ze < 55296 || Ze > 57343) && (Me = Ze);
                  break;
                case 4:
                  W = d[$ + 1], Ie = d[$ + 2], $e = d[$ + 3], (192 & W) == 128 && (192 & Ie) == 128 && (192 & $e) == 128 && (Ze = (15 & xe) << 18 | (63 & W) << 12 | (63 & Ie) << 6 | 63 & $e) > 65535 && Ze < 1114112 && (Me = Ze);
              }
              Me === null ? (Me = 65533, Ve = 1) : Me > 65535 && (Me -= 65536, b.push(Me >>> 10 & 1023 | 55296), Me = 56320 | 1023 & Me), b.push(Me), $ += Ve;
            }
            return function(ot) {
              var bt = ot.length;
              if (bt <= ee) return String.fromCharCode.apply(String, ot);
              for (var dt = "", Yt = 0; Yt < bt; ) dt += String.fromCharCode.apply(String, ot.slice(Yt, Yt += ee));
              return dt;
            }(b);
          }
          fe.kMaxLength = e, p.TYPED_ARRAY_SUPPORT = function() {
            try {
              var d = new Uint8Array(1), l = { foo: function() {
                return 42;
              } };
              return Object.setPrototypeOf(l, Uint8Array.prototype), Object.setPrototypeOf(d, l), d.foo() === 42;
            } catch {
              return !1;
            }
          }(), p.TYPED_ARRAY_SUPPORT || typeof console > "u" || typeof console.error != "function" || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(p.prototype, "parent", { enumerable: !0, get: function() {
            if (p.isBuffer(this)) return this.buffer;
          } }), Object.defineProperty(p.prototype, "offset", { enumerable: !0, get: function() {
            if (p.isBuffer(this)) return this.byteOffset;
          } }), p.poolSize = 8192, p.from = function(d, l, T) {
            return o(d, l, T);
          }, Object.setPrototypeOf(p.prototype, Uint8Array.prototype), Object.setPrototypeOf(p, Uint8Array), p.alloc = function(d, l, T) {
            return function(b, $, W) {
              return v(b), b <= 0 ? h(b) : $ !== void 0 ? typeof W == "string" ? h(b).fill($, W) : h(b).fill($) : h(b);
            }(d, l, T);
          }, p.allocUnsafe = function(d) {
            return m(d);
          }, p.allocUnsafeSlow = function(d) {
            return m(d);
          }, p.isBuffer = function(d) {
            return d != null && d._isBuffer === !0 && d !== p.prototype;
          }, p.compare = function(d, l) {
            if (ve(d, Uint8Array) && (d = p.from(d, d.offset, d.byteLength)), ve(l, Uint8Array) && (l = p.from(l, l.offset, l.byteLength)), !p.isBuffer(d) || !p.isBuffer(l)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
            if (d === l) return 0;
            for (var T = d.length, b = l.length, $ = 0, W = Math.min(T, b); $ < W; ++$) if (d[$] !== l[$]) {
              T = d[$], b = l[$];
              break;
            }
            return T < b ? -1 : b < T ? 1 : 0;
          }, p.isEncoding = function(d) {
            switch (String(d).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, p.concat = function(d, l) {
            if (!Array.isArray(d)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (d.length === 0) return p.alloc(0);
            var T;
            if (l === void 0) for (l = 0, T = 0; T < d.length; ++T) l += d[T].length;
            var b = p.allocUnsafe(l), $ = 0;
            for (T = 0; T < d.length; ++T) {
              var W = d[T];
              if (ve(W, Uint8Array)) $ + W.length > b.length ? p.from(W).copy(b, $) : Uint8Array.prototype.set.call(b, W, $);
              else {
                if (!p.isBuffer(W)) throw new TypeError('"list" argument must be an Array of Buffers');
                W.copy(b, $);
              }
              $ += W.length;
            }
            return b;
          }, p.byteLength = S, p.prototype._isBuffer = !0, p.prototype.swap16 = function() {
            var d = this.length;
            if (d % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var l = 0; l < d; l += 2) q(this, l, l + 1);
            return this;
          }, p.prototype.swap32 = function() {
            var d = this.length;
            if (d % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var l = 0; l < d; l += 4) q(this, l, l + 3), q(this, l + 1, l + 2);
            return this;
          }, p.prototype.swap64 = function() {
            var d = this.length;
            if (d % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var l = 0; l < d; l += 8) q(this, l, l + 7), q(this, l + 1, l + 6), q(this, l + 2, l + 5), q(this, l + 3, l + 4);
            return this;
          }, p.prototype.toString = function() {
            var d = this.length;
            return d === 0 ? "" : arguments.length === 0 ? Ne(this, 0, d) : k.apply(this, arguments);
          }, p.prototype.toLocaleString = p.prototype.toString, p.prototype.equals = function(d) {
            if (!p.isBuffer(d)) throw new TypeError("Argument must be a Buffer");
            return this === d || p.compare(this, d) === 0;
          }, p.prototype.inspect = function() {
            var d = "", l = fe.INSPECT_MAX_BYTES;
            return d = this.toString("hex", 0, l).replace(/(.{2})/g, "$1 ").trim(), this.length > l && (d += " ... "), "<Buffer " + d + ">";
          }, t && (p.prototype[t] = p.prototype.inspect), p.prototype.compare = function(d, l, T, b, $) {
            if (ve(d, Uint8Array) && (d = p.from(d, d.offset, d.byteLength)), !p.isBuffer(d)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof d);
            if (l === void 0 && (l = 0), T === void 0 && (T = d ? d.length : 0), b === void 0 && (b = 0), $ === void 0 && ($ = this.length), l < 0 || T > d.length || b < 0 || $ > this.length) throw new RangeError("out of range index");
            if (b >= $ && l >= T) return 0;
            if (b >= $) return -1;
            if (l >= T) return 1;
            if (this === d) return 0;
            for (var W = ($ >>>= 0) - (b >>>= 0), Ie = (T >>>= 0) - (l >>>= 0), $e = Math.min(W, Ie), Ze = this.slice(b, $), xe = d.slice(l, T), Me = 0; Me < $e; ++Me) if (Ze[Me] !== xe[Me]) {
              W = Ze[Me], Ie = xe[Me];
              break;
            }
            return W < Ie ? -1 : Ie < W ? 1 : 0;
          }, p.prototype.includes = function(d, l, T) {
            return this.indexOf(d, l, T) !== -1;
          }, p.prototype.indexOf = function(d, l, T) {
            return F(this, d, l, T, !0);
          }, p.prototype.lastIndexOf = function(d, l, T) {
            return F(this, d, l, T, !1);
          }, p.prototype.write = function(d, l, T, b) {
            if (l === void 0) b = "utf8", T = this.length, l = 0;
            else if (T === void 0 && typeof l == "string") b = l, T = this.length, l = 0;
            else {
              if (!isFinite(l)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              l >>>= 0, isFinite(T) ? (T >>>= 0, b === void 0 && (b = "utf8")) : (b = T, T = void 0);
            }
            var $ = this.length - l;
            if ((T === void 0 || T > $) && (T = $), d.length > 0 && (T < 0 || l < 0) || l > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            b || (b = "utf8");
            for (var W = !1; ; ) switch (b) {
              case "hex":
                return P(this, d, l, T);
              case "utf8":
              case "utf-8":
                return Q(this, d, l, T);
              case "ascii":
              case "latin1":
              case "binary":
                return se(this, d, l, T);
              case "base64":
                return K(this, d, l, T);
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return ie(this, d, l, T);
              default:
                if (W) throw new TypeError("Unknown encoding: " + b);
                b = ("" + b).toLowerCase(), W = !0;
            }
          }, p.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          };
          var ee = 4096;
          function Oe(d, l, T) {
            var b = "";
            T = Math.min(d.length, T);
            for (var $ = l; $ < T; ++$) b += String.fromCharCode(127 & d[$]);
            return b;
          }
          function Ge(d, l, T) {
            var b = "";
            T = Math.min(d.length, T);
            for (var $ = l; $ < T; ++$) b += String.fromCharCode(d[$]);
            return b;
          }
          function Xe(d, l, T) {
            var b = d.length;
            (!l || l < 0) && (l = 0), (!T || T < 0 || T > b) && (T = b);
            for (var $ = "", W = l; W < T; ++W) $ += Ye[d[W]];
            return $;
          }
          function Ce(d, l, T) {
            for (var b = d.slice(l, T), $ = "", W = 0; W < b.length - 1; W += 2) $ += String.fromCharCode(b[W] + 256 * b[W + 1]);
            return $;
          }
          function Ue(d, l, T) {
            if (d % 1 != 0 || d < 0) throw new RangeError("offset is not uint");
            if (d + l > T) throw new RangeError("Trying to access beyond buffer length");
          }
          function Je(d, l, T, b, $, W) {
            if (!p.isBuffer(d)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (l > $ || l < W) throw new RangeError('"value" argument is out of bounds');
            if (T + b > d.length) throw new RangeError("Index out of range");
          }
          function st(d, l, T, b, $, W) {
            if (T + b > d.length) throw new RangeError("Index out of range");
            if (T < 0) throw new RangeError("Index out of range");
          }
          function we(d, l, T, b, $) {
            return l = +l, T >>>= 0, $ || st(d, 0, T, 4), E.write(d, l, T, b, 23, 4), T + 4;
          }
          function Be(d, l, T, b, $) {
            return l = +l, T >>>= 0, $ || st(d, 0, T, 8), E.write(d, l, T, b, 52, 8), T + 8;
          }
          p.prototype.slice = function(d, l) {
            var T = this.length;
            (d = ~~d) < 0 ? (d += T) < 0 && (d = 0) : d > T && (d = T), (l = l === void 0 ? T : ~~l) < 0 ? (l += T) < 0 && (l = 0) : l > T && (l = T), l < d && (l = d);
            var b = this.subarray(d, l);
            return Object.setPrototypeOf(b, p.prototype), b;
          }, p.prototype.readUintLE = p.prototype.readUIntLE = function(d, l, T) {
            d >>>= 0, l >>>= 0, T || Ue(d, l, this.length);
            for (var b = this[d], $ = 1, W = 0; ++W < l && ($ *= 256); ) b += this[d + W] * $;
            return b;
          }, p.prototype.readUintBE = p.prototype.readUIntBE = function(d, l, T) {
            d >>>= 0, l >>>= 0, T || Ue(d, l, this.length);
            for (var b = this[d + --l], $ = 1; l > 0 && ($ *= 256); ) b += this[d + --l] * $;
            return b;
          }, p.prototype.readUint8 = p.prototype.readUInt8 = function(d, l) {
            return d >>>= 0, l || Ue(d, 1, this.length), this[d];
          }, p.prototype.readUint16LE = p.prototype.readUInt16LE = function(d, l) {
            return d >>>= 0, l || Ue(d, 2, this.length), this[d] | this[d + 1] << 8;
          }, p.prototype.readUint16BE = p.prototype.readUInt16BE = function(d, l) {
            return d >>>= 0, l || Ue(d, 2, this.length), this[d] << 8 | this[d + 1];
          }, p.prototype.readUint32LE = p.prototype.readUInt32LE = function(d, l) {
            return d >>>= 0, l || Ue(d, 4, this.length), (this[d] | this[d + 1] << 8 | this[d + 2] << 16) + 16777216 * this[d + 3];
          }, p.prototype.readUint32BE = p.prototype.readUInt32BE = function(d, l) {
            return d >>>= 0, l || Ue(d, 4, this.length), 16777216 * this[d] + (this[d + 1] << 16 | this[d + 2] << 8 | this[d + 3]);
          }, p.prototype.readIntLE = function(d, l, T) {
            d >>>= 0, l >>>= 0, T || Ue(d, l, this.length);
            for (var b = this[d], $ = 1, W = 0; ++W < l && ($ *= 256); ) b += this[d + W] * $;
            return b >= ($ *= 128) && (b -= Math.pow(2, 8 * l)), b;
          }, p.prototype.readIntBE = function(d, l, T) {
            d >>>= 0, l >>>= 0, T || Ue(d, l, this.length);
            for (var b = l, $ = 1, W = this[d + --b]; b > 0 && ($ *= 256); ) W += this[d + --b] * $;
            return W >= ($ *= 128) && (W -= Math.pow(2, 8 * l)), W;
          }, p.prototype.readInt8 = function(d, l) {
            return d >>>= 0, l || Ue(d, 1, this.length), 128 & this[d] ? -1 * (255 - this[d] + 1) : this[d];
          }, p.prototype.readInt16LE = function(d, l) {
            d >>>= 0, l || Ue(d, 2, this.length);
            var T = this[d] | this[d + 1] << 8;
            return 32768 & T ? 4294901760 | T : T;
          }, p.prototype.readInt16BE = function(d, l) {
            d >>>= 0, l || Ue(d, 2, this.length);
            var T = this[d + 1] | this[d] << 8;
            return 32768 & T ? 4294901760 | T : T;
          }, p.prototype.readInt32LE = function(d, l) {
            return d >>>= 0, l || Ue(d, 4, this.length), this[d] | this[d + 1] << 8 | this[d + 2] << 16 | this[d + 3] << 24;
          }, p.prototype.readInt32BE = function(d, l) {
            return d >>>= 0, l || Ue(d, 4, this.length), this[d] << 24 | this[d + 1] << 16 | this[d + 2] << 8 | this[d + 3];
          }, p.prototype.readFloatLE = function(d, l) {
            return d >>>= 0, l || Ue(d, 4, this.length), E.read(this, d, !0, 23, 4);
          }, p.prototype.readFloatBE = function(d, l) {
            return d >>>= 0, l || Ue(d, 4, this.length), E.read(this, d, !1, 23, 4);
          }, p.prototype.readDoubleLE = function(d, l) {
            return d >>>= 0, l || Ue(d, 8, this.length), E.read(this, d, !0, 52, 8);
          }, p.prototype.readDoubleBE = function(d, l) {
            return d >>>= 0, l || Ue(d, 8, this.length), E.read(this, d, !1, 52, 8);
          }, p.prototype.writeUintLE = p.prototype.writeUIntLE = function(d, l, T, b) {
            d = +d, l >>>= 0, T >>>= 0, b || Je(this, d, l, T, Math.pow(2, 8 * T) - 1, 0);
            var $ = 1, W = 0;
            for (this[l] = 255 & d; ++W < T && ($ *= 256); ) this[l + W] = d / $ & 255;
            return l + T;
          }, p.prototype.writeUintBE = p.prototype.writeUIntBE = function(d, l, T, b) {
            d = +d, l >>>= 0, T >>>= 0, b || Je(this, d, l, T, Math.pow(2, 8 * T) - 1, 0);
            var $ = T - 1, W = 1;
            for (this[l + $] = 255 & d; --$ >= 0 && (W *= 256); ) this[l + $] = d / W & 255;
            return l + T;
          }, p.prototype.writeUint8 = p.prototype.writeUInt8 = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 1, 255, 0), this[l] = 255 & d, l + 1;
          }, p.prototype.writeUint16LE = p.prototype.writeUInt16LE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 2, 65535, 0), this[l] = 255 & d, this[l + 1] = d >>> 8, l + 2;
          }, p.prototype.writeUint16BE = p.prototype.writeUInt16BE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 2, 65535, 0), this[l] = d >>> 8, this[l + 1] = 255 & d, l + 2;
          }, p.prototype.writeUint32LE = p.prototype.writeUInt32LE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 4, 4294967295, 0), this[l + 3] = d >>> 24, this[l + 2] = d >>> 16, this[l + 1] = d >>> 8, this[l] = 255 & d, l + 4;
          }, p.prototype.writeUint32BE = p.prototype.writeUInt32BE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 4, 4294967295, 0), this[l] = d >>> 24, this[l + 1] = d >>> 16, this[l + 2] = d >>> 8, this[l + 3] = 255 & d, l + 4;
          }, p.prototype.writeIntLE = function(d, l, T, b) {
            if (d = +d, l >>>= 0, !b) {
              var $ = Math.pow(2, 8 * T - 1);
              Je(this, d, l, T, $ - 1, -$);
            }
            var W = 0, Ie = 1, $e = 0;
            for (this[l] = 255 & d; ++W < T && (Ie *= 256); ) d < 0 && $e === 0 && this[l + W - 1] !== 0 && ($e = 1), this[l + W] = (d / Ie >> 0) - $e & 255;
            return l + T;
          }, p.prototype.writeIntBE = function(d, l, T, b) {
            if (d = +d, l >>>= 0, !b) {
              var $ = Math.pow(2, 8 * T - 1);
              Je(this, d, l, T, $ - 1, -$);
            }
            var W = T - 1, Ie = 1, $e = 0;
            for (this[l + W] = 255 & d; --W >= 0 && (Ie *= 256); ) d < 0 && $e === 0 && this[l + W + 1] !== 0 && ($e = 1), this[l + W] = (d / Ie >> 0) - $e & 255;
            return l + T;
          }, p.prototype.writeInt8 = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 1, 127, -128), d < 0 && (d = 255 + d + 1), this[l] = 255 & d, l + 1;
          }, p.prototype.writeInt16LE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 2, 32767, -32768), this[l] = 255 & d, this[l + 1] = d >>> 8, l + 2;
          }, p.prototype.writeInt16BE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 2, 32767, -32768), this[l] = d >>> 8, this[l + 1] = 255 & d, l + 2;
          }, p.prototype.writeInt32LE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 4, 2147483647, -2147483648), this[l] = 255 & d, this[l + 1] = d >>> 8, this[l + 2] = d >>> 16, this[l + 3] = d >>> 24, l + 4;
          }, p.prototype.writeInt32BE = function(d, l, T) {
            return d = +d, l >>>= 0, T || Je(this, d, l, 4, 2147483647, -2147483648), d < 0 && (d = 4294967295 + d + 1), this[l] = d >>> 24, this[l + 1] = d >>> 16, this[l + 2] = d >>> 8, this[l + 3] = 255 & d, l + 4;
          }, p.prototype.writeFloatLE = function(d, l, T) {
            return we(this, d, l, !0, T);
          }, p.prototype.writeFloatBE = function(d, l, T) {
            return we(this, d, l, !1, T);
          }, p.prototype.writeDoubleLE = function(d, l, T) {
            return Be(this, d, l, !0, T);
          }, p.prototype.writeDoubleBE = function(d, l, T) {
            return Be(this, d, l, !1, T);
          }, p.prototype.copy = function(d, l, T, b) {
            if (!p.isBuffer(d)) throw new TypeError("argument should be a Buffer");
            if (T || (T = 0), b || b === 0 || (b = this.length), l >= d.length && (l = d.length), l || (l = 0), b > 0 && b < T && (b = T), b === T || d.length === 0 || this.length === 0) return 0;
            if (l < 0) throw new RangeError("targetStart out of bounds");
            if (T < 0 || T >= this.length) throw new RangeError("Index out of range");
            if (b < 0) throw new RangeError("sourceEnd out of bounds");
            b > this.length && (b = this.length), d.length - l < b - T && (b = d.length - l + T);
            var $ = b - T;
            return this === d && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(l, T, b) : Uint8Array.prototype.set.call(d, this.subarray(T, b), l), $;
          }, p.prototype.fill = function(d, l, T, b) {
            if (typeof d == "string") {
              if (typeof l == "string" ? (b = l, l = 0, T = this.length) : typeof T == "string" && (b = T, T = this.length), b !== void 0 && typeof b != "string") throw new TypeError("encoding must be a string");
              if (typeof b == "string" && !p.isEncoding(b)) throw new TypeError("Unknown encoding: " + b);
              if (d.length === 1) {
                var $ = d.charCodeAt(0);
                (b === "utf8" && $ < 128 || b === "latin1") && (d = $);
              }
            } else typeof d == "number" ? d &= 255 : typeof d == "boolean" && (d = Number(d));
            if (l < 0 || this.length < l || this.length < T) throw new RangeError("Out of range index");
            if (T <= l) return this;
            var W;
            if (l >>>= 0, T = T === void 0 ? this.length : T >>> 0, d || (d = 0), typeof d == "number") for (W = l; W < T; ++W) this[W] = d;
            else {
              var Ie = p.isBuffer(d) ? d : p.from(d, b), $e = Ie.length;
              if ($e === 0) throw new TypeError('The value "' + d + '" is invalid for argument "value"');
              for (W = 0; W < T - l; ++W) this[W + l] = Ie[W % $e];
            }
            return this;
          };
          var At = /[^+/0-9A-Za-z-_]/g;
          function ht(d, l) {
            var T;
            l = l || 1 / 0;
            for (var b = d.length, $ = null, W = [], Ie = 0; Ie < b; ++Ie) {
              if ((T = d.charCodeAt(Ie)) > 55295 && T < 57344) {
                if (!$) {
                  if (T > 56319) {
                    (l -= 3) > -1 && W.push(239, 191, 189);
                    continue;
                  }
                  if (Ie + 1 === b) {
                    (l -= 3) > -1 && W.push(239, 191, 189);
                    continue;
                  }
                  $ = T;
                  continue;
                }
                if (T < 56320) {
                  (l -= 3) > -1 && W.push(239, 191, 189), $ = T;
                  continue;
                }
                T = 65536 + ($ - 55296 << 10 | T - 56320);
              } else $ && (l -= 3) > -1 && W.push(239, 191, 189);
              if ($ = null, T < 128) {
                if ((l -= 1) < 0) break;
                W.push(T);
              } else if (T < 2048) {
                if ((l -= 2) < 0) break;
                W.push(T >> 6 | 192, 63 & T | 128);
              } else if (T < 65536) {
                if ((l -= 3) < 0) break;
                W.push(T >> 12 | 224, T >> 6 & 63 | 128, 63 & T | 128);
              } else {
                if (!(T < 1114112)) throw new Error("Invalid code point");
                if ((l -= 4) < 0) break;
                W.push(T >> 18 | 240, T >> 12 & 63 | 128, T >> 6 & 63 | 128, 63 & T | 128);
              }
            }
            return W;
          }
          function je(d) {
            return J.toByteArray(function(l) {
              if ((l = (l = l.split("=")[0]).trim().replace(At, "")).length < 2) return "";
              for (; l.length % 4 != 0; ) l += "=";
              return l;
            }(d));
          }
          function it(d, l, T, b) {
            for (var $ = 0; $ < b && !($ + T >= l.length || $ >= d.length); ++$) l[$ + T] = d[$];
            return $;
          }
          function ve(d, l) {
            return d instanceof l || d != null && d.constructor != null && d.constructor.name != null && d.constructor.name === l.name;
          }
          function Se(d) {
            return d != d;
          }
          var Ye = function() {
            for (var d = "0123456789abcdef", l = new Array(256), T = 0; T < 16; ++T) for (var b = 16 * T, $ = 0; $ < 16; ++$) l[b + $] = d[T] + d[$];
            return l;
          }();
        }, 6693: function(_e, fe) {
          fe.byteLength = function(v) {
            var m = p(v), n = m[0], c = m[1];
            return 3 * (n + c) / 4 - c;
          }, fe.toByteArray = function(v) {
            var m, n, c = p(v), f = c[0], S = c[1], k = new E(function(te, P, Q) {
              return 3 * (P + Q) / 4 - Q;
            }(0, f, S)), q = 0, F = S > 0 ? f - 4 : f;
            for (n = 0; n < F; n += 4) m = J[v.charCodeAt(n)] << 18 | J[v.charCodeAt(n + 1)] << 12 | J[v.charCodeAt(n + 2)] << 6 | J[v.charCodeAt(n + 3)], k[q++] = m >> 16 & 255, k[q++] = m >> 8 & 255, k[q++] = 255 & m;
            return S === 2 && (m = J[v.charCodeAt(n)] << 2 | J[v.charCodeAt(n + 1)] >> 4, k[q++] = 255 & m), S === 1 && (m = J[v.charCodeAt(n)] << 10 | J[v.charCodeAt(n + 1)] << 4 | J[v.charCodeAt(n + 2)] >> 2, k[q++] = m >> 8 & 255, k[q++] = 255 & m), k;
          }, fe.fromByteArray = function(v) {
            for (var m, n = v.length, c = n % 3, f = [], S = 16383, k = 0, q = n - c; k < q; k += S) f.push(o(v, k, k + S > q ? q : k + S));
            return c === 1 ? (m = v[n - 1], f.push(R[m >> 2] + R[m << 4 & 63] + "==")) : c === 2 && (m = (v[n - 2] << 8) + v[n - 1], f.push(R[m >> 10] + R[m >> 4 & 63] + R[m << 2 & 63] + "=")), f.join("");
          };
          for (var R = [], J = [], E = typeof Uint8Array < "u" ? Uint8Array : Array, t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, h = t.length; e < h; ++e) R[e] = t[e], J[t.charCodeAt(e)] = e;
          function p(v) {
            var m = v.length;
            if (m % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var n = v.indexOf("=");
            return n === -1 && (n = m), [n, n === m ? 0 : 4 - n % 4];
          }
          function o(v, m, n) {
            for (var c, f, S = [], k = m; k < n; k += 3) c = (v[k] << 16 & 16711680) + (v[k + 1] << 8 & 65280) + (255 & v[k + 2]), S.push(R[(f = c) >> 18 & 63] + R[f >> 12 & 63] + R[f >> 6 & 63] + R[63 & f]);
            return S.join("");
          }
          J[45] = 62, J[95] = 63;
        }, 2165: function(_e, fe) {
          fe.read = function(R, J, E, t, e) {
            var h, p, o = 8 * e - t - 1, v = (1 << o) - 1, m = v >> 1, n = -7, c = E ? e - 1 : 0, f = E ? -1 : 1, S = R[J + c];
            for (c += f, h = S & (1 << -n) - 1, S >>= -n, n += o; n > 0; h = 256 * h + R[J + c], c += f, n -= 8) ;
            for (p = h & (1 << -n) - 1, h >>= -n, n += t; n > 0; p = 256 * p + R[J + c], c += f, n -= 8) ;
            if (h === 0) h = 1 - m;
            else {
              if (h === v) return p ? NaN : 1 / 0 * (S ? -1 : 1);
              p += Math.pow(2, t), h -= m;
            }
            return (S ? -1 : 1) * p * Math.pow(2, h - t);
          }, fe.write = function(R, J, E, t, e, h) {
            var p, o, v, m = 8 * h - e - 1, n = (1 << m) - 1, c = n >> 1, f = e === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, S = t ? 0 : h - 1, k = t ? 1 : -1, q = J < 0 || J === 0 && 1 / J < 0 ? 1 : 0;
            for (J = Math.abs(J), isNaN(J) || J === 1 / 0 ? (o = isNaN(J) ? 1 : 0, p = n) : (p = Math.floor(Math.log(J) / Math.LN2), J * (v = Math.pow(2, -p)) < 1 && (p--, v *= 2), (J += p + c >= 1 ? f / v : f * Math.pow(2, 1 - c)) * v >= 2 && (p++, v /= 2), p + c >= n ? (o = 0, p = n) : p + c >= 1 ? (o = (J * v - 1) * Math.pow(2, e), p += c) : (o = J * Math.pow(2, c - 1) * Math.pow(2, e), p = 0)); e >= 8; R[E + S] = 255 & o, S += k, o /= 256, e -= 8) ;
            for (p = p << e | o, m += e; m > 0; R[E + S] = 255 & p, S += k, p /= 256, m -= 8) ;
            R[E + S - k] |= 128 * q;
          };
        }, 6934: function(_e, fe) {
          var R = { parseBuffer: function(t) {
            return new J(t).parse();
          }, addBoxProcessor: function(t, e) {
            typeof t == "string" && typeof e == "function" && (E.prototype._boxProcessors[t] = e);
          }, createFile: function() {
            return new J();
          }, createBox: function(t, e, h) {
            var p = E.create(t);
            return e && e.append(p, h), p;
          }, createFullBox: function(t, e, h) {
            var p = R.createBox(t, e, h);
            return p.version = 0, p.flags = 0, p;
          }, Utils: {} };
          R.Utils.dataViewToString = function(t, e) {
            var h = e || "utf-8";
            if (typeof TextDecoder < "u") return new TextDecoder(h).decode(t);
            var p = [], o = 0;
            if (h === "utf-8") for (; o < t.byteLength; ) {
              var v = t.getUint8(o++);
              v < 128 || (v < 224 ? (v = (31 & v) << 6, v |= 63 & t.getUint8(o++)) : v < 240 ? (v = (15 & v) << 12, v |= (63 & t.getUint8(o++)) << 6, v |= 63 & t.getUint8(o++)) : (v = (7 & v) << 18, v |= (63 & t.getUint8(o++)) << 12, v |= (63 & t.getUint8(o++)) << 6, v |= 63 & t.getUint8(o++))), p.push(String.fromCharCode(v));
            }
            else for (; o < t.byteLength; ) p.push(String.fromCharCode(t.getUint8(o++)));
            return p.join("");
          }, R.Utils.utf8ToByteArray = function(t) {
            var e, h;
            if (typeof TextEncoder < "u") e = new TextEncoder().encode(t);
            else for (e = [], h = 0; h < t.length; ++h) {
              var p = t.charCodeAt(h);
              p < 128 ? e.push(p) : p < 2048 ? (e.push(192 | p >> 6), e.push(128 | 63 & p)) : p < 65536 ? (e.push(224 | p >> 12), e.push(128 | 63 & p >> 6), e.push(128 | 63 & p)) : (e.push(240 | p >> 18), e.push(128 | 63 & p >> 12), e.push(128 | 63 & p >> 6), e.push(128 | 63 & p));
            }
            return e;
          }, R.Utils.appendBox = function(t, e, h) {
            if (e._offset = t._cursor.offset, e._root = t._root ? t._root : t, e._raw = t._raw, e._parent = t, h !== -1) if (h != null) {
              var p, o = -1;
              if (typeof h == "number") o = h;
              else {
                if (typeof h == "string") p = h;
                else {
                  if (typeof h != "object" || !h.type) return void t.boxes.push(e);
                  p = h.type;
                }
                for (var v = 0; v < t.boxes.length; v++) if (p === t.boxes[v].type) {
                  o = v + 1;
                  break;
                }
              }
              t.boxes.splice(o, 0, e);
            } else t.boxes.push(e);
          }, fe.parseBuffer = R.parseBuffer, fe.addBoxProcessor = R.addBoxProcessor, fe.createFile = R.createFile, fe.createBox = R.createBox, fe.createFullBox = R.createFullBox, fe.Utils = R.Utils, R.Cursor = function(t) {
            this.offset = t === void 0 ? 0 : t;
          };
          var J = function(t) {
            this._cursor = new R.Cursor(), this.boxes = [], t && (this._raw = new DataView(t));
          };
          J.prototype.fetch = function(t) {
            var e = this.fetchAll(t, !0);
            return e.length ? e[0] : null;
          }, J.prototype.fetchAll = function(t, e) {
            var h = [];
            return J._sweep.call(this, t, h, e), h;
          }, J.prototype.parse = function() {
            for (this._cursor.offset = 0, this.boxes = []; this._cursor.offset < this._raw.byteLength; ) {
              var t = E.parse(this);
              if (t.type === void 0) break;
              this.boxes.push(t);
            }
            return this;
          }, J._sweep = function(t, e, h) {
            for (var p in this.type && this.type == t && e.push(this), this.boxes) {
              if (e.length && h) return;
              J._sweep.call(this.boxes[p], t, e, h);
            }
          }, J.prototype.write = function() {
            var t, e = 0;
            for (t = 0; t < this.boxes.length; t++) e += this.boxes[t].getLength(!1);
            var h = new Uint8Array(e);
            for (this._rawo = new DataView(h.buffer), this.bytes = h, this._cursor.offset = 0, t = 0; t < this.boxes.length; t++) this.boxes[t].write();
            return h.buffer;
          }, J.prototype.append = function(t, e) {
            R.Utils.appendBox(this, t, e);
          };
          var E = function() {
            this._cursor = new R.Cursor();
          };
          E.parse = function(t) {
            var e = new E();
            return e._offset = t._cursor.offset, e._root = t._root ? t._root : t, e._raw = t._raw, e._parent = t, e._parseBox(), t._cursor.offset = e._raw.byteOffset + e._raw.byteLength, e;
          }, E.create = function(t) {
            var e = new E();
            return e.type = t, e.boxes = [], e;
          }, E.prototype._boxContainers = ["dinf", "edts", "mdia", "meco", "mfra", "minf", "moof", "moov", "mvex", "stbl", "strk", "traf", "trak", "tref", "udta", "vttc", "sinf", "schi", "encv", "enca"], E.prototype._boxProcessors = {}, E.prototype._procField = function(t, e, h) {
            this._parsing ? this[t] = this._readField(e, h) : this._writeField(e, h, this[t]);
          }, E.prototype._procFieldArray = function(t, e, h, p) {
            var o;
            if (this._parsing) for (this[t] = [], o = 0; o < e; o++) this[t][o] = this._readField(h, p);
            else for (o = 0; o < this[t].length; o++) this._writeField(h, p, this[t][o]);
          }, E.prototype._procFullBox = function() {
            this._procField("version", "uint", 8), this._procField("flags", "uint", 24);
          }, E.prototype._procEntries = function(t, e, h) {
            var p;
            if (this._parsing) for (this[t] = [], p = 0; p < e; p++) this[t].push({}), h.call(this, this[t][p]);
            else for (p = 0; p < e; p++) h.call(this, this[t][p]);
          }, E.prototype._procSubEntries = function(t, e, h, p) {
            var o;
            if (this._parsing) for (t[e] = [], o = 0; o < h; o++) t[e].push({}), p.call(this, t[e][o]);
            else for (o = 0; o < h; o++) p.call(this, t[e][o]);
          }, E.prototype._procEntryField = function(t, e, h, p) {
            this._parsing ? t[e] = this._readField(h, p) : this._writeField(h, p, t[e]);
          }, E.prototype._procSubBoxes = function(t, e) {
            var h;
            if (this._parsing) for (this[t] = [], h = 0; h < e; h++) this[t].push(E.parse(this));
            else for (h = 0; h < e; h++) this._rawo ? this[t][h].write() : this.size += this[t][h].getLength();
          }, E.prototype._readField = function(t, e) {
            switch (t) {
              case "uint":
                return this._readUint(e);
              case "int":
                return this._readInt(e);
              case "template":
                return this._readTemplate(e);
              case "string":
                return e === -1 ? this._readTerminatedString() : this._readString(e);
              case "data":
                return this._readData(e);
              case "utf8":
                return this._readUTF8String();
              default:
                return -1;
            }
          }, E.prototype._readInt = function(t) {
            var e = null, h = this._cursor.offset - this._raw.byteOffset;
            switch (t) {
              case 8:
                e = this._raw.getInt8(h);
                break;
              case 16:
                e = this._raw.getInt16(h);
                break;
              case 32:
                e = this._raw.getInt32(h);
                break;
              case 64:
                var p = this._raw.getInt32(h), o = this._raw.getInt32(h + 4);
                e = p * Math.pow(2, 32) + o;
            }
            return this._cursor.offset += t >> 3, e;
          }, E.prototype._readUint = function(t) {
            var e, h, p = null, o = this._cursor.offset - this._raw.byteOffset;
            switch (t) {
              case 8:
                p = this._raw.getUint8(o);
                break;
              case 16:
                p = this._raw.getUint16(o);
                break;
              case 24:
                p = ((e = this._raw.getUint16(o)) << 8) + (h = this._raw.getUint8(o + 2));
                break;
              case 32:
                p = this._raw.getUint32(o);
                break;
              case 64:
                e = this._raw.getUint32(o), h = this._raw.getUint32(o + 4), p = e * Math.pow(2, 32) + h;
            }
            return this._cursor.offset += t >> 3, p;
          }, E.prototype._readString = function(t) {
            for (var e = "", h = 0; h < t; h++) {
              var p = this._readUint(8);
              e += String.fromCharCode(p);
            }
            return e;
          }, E.prototype._readTemplate = function(t) {
            return this._readUint(t / 2) + this._readUint(t / 2) / Math.pow(2, t / 2);
          }, E.prototype._readTerminatedString = function() {
            for (var t = ""; this._cursor.offset - this._offset < this._raw.byteLength; ) {
              var e = this._readUint(8);
              if (e === 0) break;
              t += String.fromCharCode(e);
            }
            return t;
          }, E.prototype._readData = function(t) {
            var e = t > 0 ? t : this._raw.byteLength - (this._cursor.offset - this._offset);
            if (e > 0) {
              var h = new Uint8Array(this._raw.buffer, this._cursor.offset, e);
              return this._cursor.offset += e, h;
            }
            return null;
          }, E.prototype._readUTF8String = function() {
            var t = this._raw.byteLength - (this._cursor.offset - this._offset), e = null;
            return t > 0 && (e = new DataView(this._raw.buffer, this._cursor.offset, t), this._cursor.offset += t), e && R.Utils.dataViewToString(e);
          }, E.prototype._parseBox = function() {
            if (this._parsing = !0, this._cursor.offset = this._offset, this._offset + 8 > this._raw.buffer.byteLength) this._root._incomplete = !0;
            else {
              switch (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this.size) {
                case 0:
                  this._raw = new DataView(this._raw.buffer, this._offset);
                  break;
                case 1:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
                  break;
                default:
                  this._offset + this.size > this._raw.buffer.byteLength ? (this._incomplete = !0, this._root._incomplete = !0) : this._raw = new DataView(this._raw.buffer, this._offset, this.size);
              }
              this._incomplete || (this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1 ? this._parseContainerBox() : this._data = this._readData());
            }
          }, E.prototype._parseFullBox = function() {
            this.version = this._readUint(8), this.flags = this._readUint(24);
          }, E.prototype._parseContainerBox = function() {
            for (this.boxes = []; this._cursor.offset - this._raw.byteOffset < this._raw.byteLength; ) this.boxes.push(E.parse(this));
          }, E.prototype.append = function(t, e) {
            R.Utils.appendBox(this, t, e);
          }, E.prototype.getLength = function() {
            if (this._parsing = !1, this._rawo = null, this.size = 0, this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1) for (var t = 0; t < this.boxes.length; t++) this.size += this.boxes[t].getLength();
            return this._data && this._writeData(this._data), this.size;
          }, E.prototype.write = function() {
            switch (this._parsing = !1, this._cursor.offset = this._parent._cursor.offset, this.size) {
              case 0:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.parent._rawo.byteLength - this._cursor.offset);
                break;
              case 1:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
                break;
              default:
                this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
            }
            if (this._procField("size", "uint", 32), this._procField("type", "string", 4), this.size === 1 && this._procField("largesize", "uint", 64), this.type === "uuid" && this._procFieldArray("usertype", 16, "uint", 8), this._boxProcessors[this.type] && this._boxProcessors[this.type].call(this), this._boxContainers.indexOf(this.type) !== -1) for (var t = 0; t < this.boxes.length; t++) this.boxes[t].write();
            return this._data && this._writeData(this._data), this._parent._cursor.offset += this.size, this.size;
          }, E.prototype._writeInt = function(t, e) {
            if (this._rawo) {
              var h = this._cursor.offset - this._rawo.byteOffset;
              switch (t) {
                case 8:
                  this._rawo.setInt8(h, e);
                  break;
                case 16:
                  this._rawo.setInt16(h, e);
                  break;
                case 32:
                  this._rawo.setInt32(h, e);
                  break;
                case 64:
                  var p = Math.floor(e / Math.pow(2, 32)), o = e - p * Math.pow(2, 32);
                  this._rawo.setUint32(h, p), this._rawo.setUint32(h + 4, o);
              }
              this._cursor.offset += t >> 3;
            } else this.size += t >> 3;
          }, E.prototype._writeUint = function(t, e) {
            if (this._rawo) {
              var h, p, o = this._cursor.offset - this._rawo.byteOffset;
              switch (t) {
                case 8:
                  this._rawo.setUint8(o, e);
                  break;
                case 16:
                  this._rawo.setUint16(o, e);
                  break;
                case 24:
                  h = (16776960 & e) >> 8, p = 255 & e, this._rawo.setUint16(o, h), this._rawo.setUint8(o + 2, p);
                  break;
                case 32:
                  this._rawo.setUint32(o, e);
                  break;
                case 64:
                  p = e - (h = Math.floor(e / Math.pow(2, 32))) * Math.pow(2, 32), this._rawo.setUint32(o, h), this._rawo.setUint32(o + 4, p);
              }
              this._cursor.offset += t >> 3;
            } else this.size += t >> 3;
          }, E.prototype._writeString = function(t, e) {
            for (var h = 0; h < t; h++) this._writeUint(8, e.charCodeAt(h));
          }, E.prototype._writeTerminatedString = function(t) {
            if (t.length !== 0) {
              for (var e = 0; e < t.length; e++) this._writeUint(8, t.charCodeAt(e));
              this._writeUint(8, 0);
            }
          }, E.prototype._writeTemplate = function(t, e) {
            var h = Math.floor(e), p = (e - h) * Math.pow(2, t / 2);
            this._writeUint(t / 2, h), this._writeUint(t / 2, p);
          }, E.prototype._writeData = function(t) {
            if (t) if (this._rawo) {
              if (t instanceof Array) {
                for (var e = this._cursor.offset - this._rawo.byteOffset, h = 0; h < t.length; h++) this._rawo.setInt8(e + h, t[h]);
                this._cursor.offset += t.length;
              }
              t instanceof Uint8Array && (this._root.bytes.set(t, this._cursor.offset), this._cursor.offset += t.length);
            } else this.size += t.length;
          }, E.prototype._writeUTF8String = function(t) {
            var e = R.Utils.utf8ToByteArray(t);
            if (this._rawo) for (var h = new DataView(this._rawo.buffer, this._cursor.offset, e.length), p = 0; p < e.length; p++) h.setUint8(p, e[p]);
            else this.size += e.length;
          }, E.prototype._writeField = function(t, e, h) {
            switch (t) {
              case "uint":
                this._writeUint(e, h);
                break;
              case "int":
                this._writeInt(e, h);
                break;
              case "template":
                this._writeTemplate(e, h);
                break;
              case "string":
                e == -1 ? this._writeTerminatedString(h) : this._writeString(e, h);
                break;
              case "data":
                this._writeData(h);
                break;
              case "utf8":
                this._writeUTF8String(h);
            }
          }, E.prototype._boxProcessors.avc1 = E.prototype._boxProcessors.avc2 = E.prototype._boxProcessors.avc3 = E.prototype._boxProcessors.avc4 = E.prototype._boxProcessors.hvc1 = E.prototype._boxProcessors.hev1 = E.prototype._boxProcessors.encv = function() {
            this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procField("pre_defined1", "uint", 16), this._procField("reserved2", "uint", 16), this._procFieldArray("pre_defined2", 3, "uint", 32), this._procField("width", "uint", 16), this._procField("height", "uint", 16), this._procField("horizresolution", "template", 32), this._procField("vertresolution", "template", 32), this._procField("reserved3", "uint", 32), this._procField("frame_count", "uint", 16), this._procFieldArray("compressorname", 32, "uint", 8), this._procField("depth", "uint", 16), this._procField("pre_defined3", "int", 16), this._procField("config", "data", -1);
          }, E.prototype._boxProcessors.ctts = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_count", "uint", 32), this._procEntryField(t, "sample_offset", this.version === 1 ? "int" : "uint", 32);
            });
          }, E.prototype._boxProcessors.dref = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
          }, E.prototype._boxProcessors.elst = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "segment_duration", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "media_time", "int", this.version === 1 ? 64 : 32), this._procEntryField(t, "media_rate_integer", "int", 16), this._procEntryField(t, "media_rate_fraction", "int", 16);
            });
          }, E.prototype._boxProcessors.emsg = function() {
            this._procFullBox(), this.version == 1 ? (this._procField("timescale", "uint", 32), this._procField("presentation_time", "uint", 64), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32), this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1)) : (this._procField("scheme_id_uri", "string", -1), this._procField("value", "string", -1), this._procField("timescale", "uint", 32), this._procField("presentation_time_delta", "uint", 32), this._procField("event_duration", "uint", 32), this._procField("id", "uint", 32)), this._procField("message_data", "data", -1);
          }, E.prototype._boxProcessors.free = E.prototype._boxProcessors.skip = function() {
            this._procField("data", "data", -1);
          }, E.prototype._boxProcessors.frma = function() {
            this._procField("data_format", "uint", 32);
          }, E.prototype._boxProcessors.ftyp = E.prototype._boxProcessors.styp = function() {
            this._procField("major_brand", "string", 4), this._procField("minor_version", "uint", 32);
            var t = -1;
            this._parsing && (t = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4), this._procFieldArray("compatible_brands", t, "string", 4);
          }, E.prototype._boxProcessors.hdlr = function() {
            this._procFullBox(), this._procField("pre_defined", "uint", 32), this._procField("handler_type", "string", 4), this._procFieldArray("reserved", 3, "uint", 32), this._procField("name", "string", -1);
          }, E.prototype._boxProcessors.mdat = function() {
            this._procField("data", "data", -1);
          }, E.prototype._boxProcessors.mdhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._parsing || typeof this.language != "string" || (this.language = this.language.charCodeAt(0) - 96 << 10 | this.language.charCodeAt(1) - 96 << 5 | this.language.charCodeAt(2) - 96), this._procField("language", "uint", 16), this._parsing && (this.language = String.fromCharCode(96 + (this.language >> 10 & 31), 96 + (this.language >> 5 & 31), 96 + (31 & this.language))), this._procField("pre_defined", "uint", 16);
          }, E.prototype._boxProcessors.mehd = function() {
            this._procFullBox(), this._procField("fragment_duration", "uint", this.version == 1 ? 64 : 32);
          }, E.prototype._boxProcessors.mfhd = function() {
            this._procFullBox(), this._procField("sequence_number", "uint", 32);
          }, E.prototype._boxProcessors.mfro = function() {
            this._procFullBox(), this._procField("mfra_size", "uint", 32);
          }, E.prototype._boxProcessors.mp4a = E.prototype._boxProcessors.enca = function() {
            this._procFieldArray("reserved1", 6, "uint", 8), this._procField("data_reference_index", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("channelcount", "uint", 16), this._procField("samplesize", "uint", 16), this._procField("pre_defined", "uint", 16), this._procField("reserved3", "uint", 16), this._procField("samplerate", "template", 32), this._procField("esds", "data", -1);
          }, E.prototype._boxProcessors.mvhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("timescale", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procField("rate", "template", 32), this._procField("volume", "template", 16), this._procField("reserved1", "uint", 16), this._procFieldArray("reserved2", 2, "uint", 32), this._procFieldArray("matrix", 9, "template", 32), this._procFieldArray("pre_defined", 6, "uint", 32), this._procField("next_track_ID", "uint", 32);
          }, E.prototype._boxProcessors.payl = function() {
            this._procField("cue_text", "utf8");
          }, E.prototype._boxProcessors.prft = function() {
            this._procFullBox(), this._procField("reference_track_ID", "uint", 32), this._procField("ntp_timestamp_sec", "uint", 32), this._procField("ntp_timestamp_frac", "uint", 32), this._procField("media_time", "uint", this.version == 1 ? 64 : 32);
          }, E.prototype._boxProcessors.pssh = function() {
            this._procFullBox(), this._procFieldArray("SystemID", 16, "uint", 8), this._procField("DataSize", "uint", 32), this._procFieldArray("Data", this.DataSize, "uint", 8);
          }, E.prototype._boxProcessors.schm = function() {
            this._procFullBox(), this._procField("scheme_type", "uint", 32), this._procField("scheme_version", "uint", 32), 1 & this.flags && this._procField("scheme_uri", "string", -1);
          }, E.prototype._boxProcessors.sdtp = function() {
            this._procFullBox();
            var t = -1;
            this._parsing && (t = this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)), this._procFieldArray("sample_dependency_table", t, "uint", 8);
          }, E.prototype._boxProcessors.sidx = function() {
            this._procFullBox(), this._procField("reference_ID", "uint", 32), this._procField("timescale", "uint", 32), this._procField("earliest_presentation_time", "uint", this.version == 1 ? 64 : 32), this._procField("first_offset", "uint", this.version == 1 ? 64 : 32), this._procField("reserved", "uint", 16), this._procField("reference_count", "uint", 16), this._procEntries("references", this.reference_count, function(t) {
              this._parsing || (t.reference = (1 & t.reference_type) << 31, t.reference |= 2147483647 & t.referenced_size, t.sap = (1 & t.starts_with_SAP) << 31, t.sap |= (3 & t.SAP_type) << 28, t.sap |= 268435455 & t.SAP_delta_time), this._procEntryField(t, "reference", "uint", 32), this._procEntryField(t, "subsegment_duration", "uint", 32), this._procEntryField(t, "sap", "uint", 32), this._parsing && (t.reference_type = t.reference >> 31 & 1, t.referenced_size = 2147483647 & t.reference, t.starts_with_SAP = t.sap >> 31 & 1, t.SAP_type = t.sap >> 28 & 7, t.SAP_delta_time = 268435455 & t.sap);
            });
          }, E.prototype._boxProcessors.smhd = function() {
            this._procFullBox(), this._procField("balance", "uint", 16), this._procField("reserved", "uint", 16);
          }, E.prototype._boxProcessors.ssix = function() {
            this._procFullBox(), this._procField("subsegment_count", "uint", 32), this._procEntries("subsegments", this.subsegment_count, function(t) {
              this._procEntryField(t, "ranges_count", "uint", 32), this._procSubEntries(t, "ranges", t.ranges_count, function(e) {
                this._procEntryField(e, "level", "uint", 8), this._procEntryField(e, "range_size", "uint", 24);
              });
            });
          }, E.prototype._boxProcessors.stsd = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procSubBoxes("entries", this.entry_count);
          }, E.prototype._boxProcessors.sttg = function() {
            this._procField("settings", "utf8");
          }, E.prototype._boxProcessors.stts = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_count", "uint", 32), this._procEntryField(t, "sample_delta", "uint", 32);
            });
          }, E.prototype._boxProcessors.subs = function() {
            this._procFullBox(), this._procField("entry_count", "uint", 32), this._procEntries("entries", this.entry_count, function(t) {
              this._procEntryField(t, "sample_delta", "uint", 32), this._procEntryField(t, "subsample_count", "uint", 16), this._procSubEntries(t, "subsamples", t.subsample_count, function(e) {
                this._procEntryField(e, "subsample_size", "uint", this.version === 1 ? 32 : 16), this._procEntryField(e, "subsample_priority", "uint", 8), this._procEntryField(e, "discardable", "uint", 8), this._procEntryField(e, "codec_specific_parameters", "uint", 32);
              });
            });
          }, E.prototype._boxProcessors.tenc = function() {
            this._procFullBox(), this._procField("default_IsEncrypted", "uint", 24), this._procField("default_IV_size", "uint", 8), this._procFieldArray("default_KID", 16, "uint", 8);
          }, E.prototype._boxProcessors.tfdt = function() {
            this._procFullBox(), this._procField("baseMediaDecodeTime", "uint", this.version == 1 ? 64 : 32);
          }, E.prototype._boxProcessors.tfhd = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), 1 & this.flags && this._procField("base_data_offset", "uint", 64), 2 & this.flags && this._procField("sample_description_offset", "uint", 32), 8 & this.flags && this._procField("default_sample_duration", "uint", 32), 16 & this.flags && this._procField("default_sample_size", "uint", 32), 32 & this.flags && this._procField("default_sample_flags", "uint", 32);
          }, E.prototype._boxProcessors.tfra = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), this._parsing || (this.reserved = 0, this.reserved |= (48 & this.length_size_of_traf_num) << 4, this.reserved |= (12 & this.length_size_of_trun_num) << 2, this.reserved |= 3 & this.length_size_of_sample_num), this._procField("reserved", "uint", 32), this._parsing && (this.length_size_of_traf_num = (48 & this.reserved) >> 4, this.length_size_of_trun_num = (12 & this.reserved) >> 2, this.length_size_of_sample_num = 3 & this.reserved), this._procField("number_of_entry", "uint", 32), this._procEntries("entries", this.number_of_entry, function(t) {
              this._procEntryField(t, "time", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "moof_offset", "uint", this.version === 1 ? 64 : 32), this._procEntryField(t, "traf_number", "uint", 8 * (this.length_size_of_traf_num + 1)), this._procEntryField(t, "trun_number", "uint", 8 * (this.length_size_of_trun_num + 1)), this._procEntryField(t, "sample_number", "uint", 8 * (this.length_size_of_sample_num + 1));
            });
          }, E.prototype._boxProcessors.tkhd = function() {
            this._procFullBox(), this._procField("creation_time", "uint", this.version == 1 ? 64 : 32), this._procField("modification_time", "uint", this.version == 1 ? 64 : 32), this._procField("track_ID", "uint", 32), this._procField("reserved1", "uint", 32), this._procField("duration", "uint", this.version == 1 ? 64 : 32), this._procFieldArray("reserved2", 2, "uint", 32), this._procField("layer", "uint", 16), this._procField("alternate_group", "uint", 16), this._procField("volume", "template", 16), this._procField("reserved3", "uint", 16), this._procFieldArray("matrix", 9, "template", 32), this._procField("width", "template", 32), this._procField("height", "template", 32);
          }, E.prototype._boxProcessors.trex = function() {
            this._procFullBox(), this._procField("track_ID", "uint", 32), this._procField("default_sample_description_index", "uint", 32), this._procField("default_sample_duration", "uint", 32), this._procField("default_sample_size", "uint", 32), this._procField("default_sample_flags", "uint", 32);
          }, E.prototype._boxProcessors.trun = function() {
            this._procFullBox(), this._procField("sample_count", "uint", 32), 1 & this.flags && this._procField("data_offset", "int", 32), 4 & this.flags && this._procField("first_sample_flags", "uint", 32), this._procEntries("samples", this.sample_count, function(t) {
              256 & this.flags && this._procEntryField(t, "sample_duration", "uint", 32), 512 & this.flags && this._procEntryField(t, "sample_size", "uint", 32), 1024 & this.flags && this._procEntryField(t, "sample_flags", "uint", 32), 2048 & this.flags && this._procEntryField(t, "sample_composition_time_offset", this.version === 1 ? "int" : "uint", 32);
            });
          }, E.prototype._boxProcessors["url "] = E.prototype._boxProcessors["urn "] = function() {
            this._procFullBox(), this.type === "urn " && this._procField("name", "string", -1), this._procField("location", "string", -1);
          }, E.prototype._boxProcessors.vlab = function() {
            this._procField("source_label", "utf8");
          }, E.prototype._boxProcessors.vmhd = function() {
            this._procFullBox(), this._procField("graphicsmode", "uint", 16), this._procFieldArray("opcolor", 3, "uint", 16);
          }, E.prototype._boxProcessors.vttC = function() {
            this._procField("config", "utf8");
          }, E.prototype._boxProcessors.vtte = function() {
          };
        }, 5530: function(_e, fe, R) {
          _e.exports = R(6146).polyfill();
        }, 6146: function(_e, fe, R) {
          _e.exports = function() {
            function J(je) {
              return typeof je == "function";
            }
            var E = Array.isArray ? Array.isArray : function(je) {
              return Object.prototype.toString.call(je) === "[object Array]";
            }, t = 0, e = void 0, h = void 0, p = function(je, it) {
              S[t] = je, S[t + 1] = it, (t += 2) === 2 && (h ? h(k) : Q());
            }, o = typeof window < "u" ? window : void 0, v = o || {}, m = v.MutationObserver || v.WebKitMutationObserver, n = typeof self > "u" && typeof process < "u" && {}.toString.call(process) === "[object process]", c = typeof Uint8ClampedArray < "u" && typeof importScripts < "u" && typeof MessageChannel < "u";
            function f() {
              var je = setTimeout;
              return function() {
                return je(k, 1);
              };
            }
            var S = new Array(1e3);
            function k() {
              for (var je = 0; je < t; je += 2) (0, S[je])(S[je + 1]), S[je] = void 0, S[je + 1] = void 0;
              t = 0;
            }
            var q, F, te, P, Q = void 0;
            function se(je, it) {
              var ve = this, Se = new this.constructor(ge);
              Se[ie] === void 0 && Be(Se);
              var Ye = ve._state;
              if (Ye) {
                var d = arguments[Ye - 1];
                p(function() {
                  return st(Ye, Se, d, ve._result);
                });
              } else Ue(ve, Se, je, it);
              return Se;
            }
            function K(je) {
              if (je && typeof je == "object" && je.constructor === this) return je;
              var it = new this(ge);
              return Oe(it, je), it;
            }
            Q = n ? function() {
              return process.nextTick(k);
            } : m ? (F = 0, te = new m(k), P = document.createTextNode(""), te.observe(P, { characterData: !0 }), function() {
              P.data = F = ++F % 2;
            }) : c ? ((q = new MessageChannel()).port1.onmessage = k, function() {
              return q.port2.postMessage(0);
            }) : o === void 0 ? function() {
              try {
                var je = Function("return this")().require("vertx");
                return (e = je.runOnLoop || je.runOnContext) !== void 0 ? function() {
                  e(k);
                } : f();
              } catch {
                return f();
              }
            }() : f();
            var ie = Math.random().toString(36).substring(2);
            function ge() {
            }
            var Ne = void 0;
            function ee(je, it, ve) {
              it.constructor === je.constructor && ve === se && it.constructor.resolve === K ? function(Se, Ye) {
                Ye._state === 1 ? Xe(Se, Ye._result) : Ye._state === 2 ? Ce(Se, Ye._result) : Ue(Ye, void 0, function(d) {
                  return Oe(Se, d);
                }, function(d) {
                  return Ce(Se, d);
                });
              }(je, it) : ve === void 0 ? Xe(je, it) : J(ve) ? function(Se, Ye, d) {
                p(function(l) {
                  var T = !1, b = function($, W, Ie, $e) {
                    try {
                      $.call(W, Ie, $e);
                    } catch (Ze) {
                      return Ze;
                    }
                  }(d, Ye, function($) {
                    T || (T = !0, Ye !== $ ? Oe(l, $) : Xe(l, $));
                  }, function($) {
                    T || (T = !0, Ce(l, $));
                  }, l._label);
                  !T && b && (T = !0, Ce(l, b));
                }, Se);
              }(je, it, ve) : Xe(je, it);
            }
            function Oe(je, it) {
              if (je === it) Ce(je, new TypeError("You cannot resolve a promise with itself"));
              else if (Ye = typeof (Se = it), Se === null || Ye !== "object" && Ye !== "function") Xe(je, it);
              else {
                var ve = void 0;
                try {
                  ve = it.then;
                } catch (d) {
                  return void Ce(je, d);
                }
                ee(je, it, ve);
              }
              var Se, Ye;
            }
            function Ge(je) {
              je._onerror && je._onerror(je._result), Je(je);
            }
            function Xe(je, it) {
              je._state === Ne && (je._result = it, je._state = 1, je._subscribers.length !== 0 && p(Je, je));
            }
            function Ce(je, it) {
              je._state === Ne && (je._state = 2, je._result = it, p(Ge, je));
            }
            function Ue(je, it, ve, Se) {
              var Ye = je._subscribers, d = Ye.length;
              je._onerror = null, Ye[d] = it, Ye[d + 1] = ve, Ye[d + 2] = Se, d === 0 && je._state && p(Je, je);
            }
            function Je(je) {
              var it = je._subscribers, ve = je._state;
              if (it.length !== 0) {
                for (var Se = void 0, Ye = void 0, d = je._result, l = 0; l < it.length; l += 3) Se = it[l], Ye = it[l + ve], Se ? st(ve, Se, Ye, d) : Ye(d);
                je._subscribers.length = 0;
              }
            }
            function st(je, it, ve, Se) {
              var Ye = J(ve), d = void 0, l = void 0, T = !0;
              if (Ye) {
                try {
                  d = ve(Se);
                } catch (b) {
                  T = !1, l = b;
                }
                if (it === d) return void Ce(it, new TypeError("A promises callback cannot return that same promise."));
              } else d = Se;
              it._state !== Ne || (Ye && T ? Oe(it, d) : T === !1 ? Ce(it, l) : je === 1 ? Xe(it, d) : je === 2 && Ce(it, d));
            }
            var we = 0;
            function Be(je) {
              je[ie] = we++, je._state = void 0, je._result = void 0, je._subscribers = [];
            }
            var At = function() {
              function je(it, ve) {
                this._instanceConstructor = it, this.promise = new it(ge), this.promise[ie] || Be(this.promise), E(ve) ? (this.length = ve.length, this._remaining = ve.length, this._result = new Array(this.length), this.length === 0 ? Xe(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(ve), this._remaining === 0 && Xe(this.promise, this._result))) : Ce(this.promise, new Error("Array Methods must be provided an Array"));
              }
              return je.prototype._enumerate = function(it) {
                for (var ve = 0; this._state === Ne && ve < it.length; ve++) this._eachEntry(it[ve], ve);
              }, je.prototype._eachEntry = function(it, ve) {
                var Se = this._instanceConstructor, Ye = Se.resolve;
                if (Ye === K) {
                  var d = void 0, l = void 0, T = !1;
                  try {
                    d = it.then;
                  } catch ($) {
                    T = !0, l = $;
                  }
                  if (d === se && it._state !== Ne) this._settledAt(it._state, ve, it._result);
                  else if (typeof d != "function") this._remaining--, this._result[ve] = it;
                  else if (Se === ht) {
                    var b = new Se(ge);
                    T ? Ce(b, l) : ee(b, it, d), this._willSettleAt(b, ve);
                  } else this._willSettleAt(new Se(function($) {
                    return $(it);
                  }), ve);
                } else this._willSettleAt(Ye(it), ve);
              }, je.prototype._settledAt = function(it, ve, Se) {
                var Ye = this.promise;
                Ye._state === Ne && (this._remaining--, it === 2 ? Ce(Ye, Se) : this._result[ve] = Se), this._remaining === 0 && Xe(Ye, this._result);
              }, je.prototype._willSettleAt = function(it, ve) {
                var Se = this;
                Ue(it, void 0, function(Ye) {
                  return Se._settledAt(1, ve, Ye);
                }, function(Ye) {
                  return Se._settledAt(2, ve, Ye);
                });
              }, je;
            }(), ht = function() {
              function je(it) {
                this[ie] = we++, this._result = this._state = void 0, this._subscribers = [], ge !== it && (typeof it != "function" && function() {
                  throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }(), this instanceof je ? function(ve, Se) {
                  try {
                    Se(function(Ye) {
                      Oe(ve, Ye);
                    }, function(Ye) {
                      Ce(ve, Ye);
                    });
                  } catch (Ye) {
                    Ce(ve, Ye);
                  }
                }(this, it) : function() {
                  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }());
              }
              return je.prototype.catch = function(it) {
                return this.then(null, it);
              }, je.prototype.finally = function(it) {
                var ve = this, Se = ve.constructor;
                return J(it) ? ve.then(function(Ye) {
                  return Se.resolve(it()).then(function() {
                    return Ye;
                  });
                }, function(Ye) {
                  return Se.resolve(it()).then(function() {
                    throw Ye;
                  });
                }) : ve.then(it, it);
              }, je;
            }();
            return ht.prototype.then = se, ht.all = function(je) {
              return new At(this, je).promise;
            }, ht.race = function(je) {
              var it = this;
              return E(je) ? new it(function(ve, Se) {
                for (var Ye = je.length, d = 0; d < Ye; d++) it.resolve(je[d]).then(ve, Se);
              }) : new it(function(ve, Se) {
                return Se(new TypeError("You must pass an array to race."));
              });
            }, ht.resolve = K, ht.reject = function(je) {
              var it = new this(ge);
              return Ce(it, je), it;
            }, ht._setScheduler = function(je) {
              h = je;
            }, ht._setAsap = function(je) {
              p = je;
            }, ht._asap = p, ht.polyfill = function() {
              var je = void 0;
              if (R.g !== void 0) je = R.g;
              else if (typeof self < "u") je = self;
              else try {
                je = Function("return this")();
              } catch {
                throw new Error("polyfill failed because global object is unavailable in this environment");
              }
              var it = je.Promise;
              if (it) {
                var ve = null;
                try {
                  ve = Object.prototype.toString.call(it.resolve());
                } catch {
                }
                if (ve === "[object Promise]" && !it.cast) return;
              }
              je.Promise = ht;
            }, ht.Promise = ht, ht;
          }();
        }, 1159: function(_e) {
          var fe, R = typeof Reflect == "object" ? Reflect : null, J = R && typeof R.apply == "function" ? R.apply : function(k, q, F) {
            return Function.prototype.apply.call(k, q, F);
          };
          fe = R && typeof R.ownKeys == "function" ? R.ownKeys : Object.getOwnPropertySymbols ? function(k) {
            return Object.getOwnPropertyNames(k).concat(Object.getOwnPropertySymbols(k));
          } : function(k) {
            return Object.getOwnPropertyNames(k);
          };
          var E = Number.isNaN || function(k) {
            return k != k;
          };
          function t() {
            t.init.call(this);
          }
          _e.exports = t, _e.exports.once = function(k, q) {
            return new Promise(function(F, te) {
              function P(se) {
                k.removeListener(q, Q), te(se);
              }
              function Q() {
                typeof k.removeListener == "function" && k.removeListener("error", P), F([].slice.call(arguments));
              }
              S(k, q, Q, { once: !0 }), q !== "error" && function(se, K, ie) {
                typeof se.on == "function" && S(se, "error", K, { once: !0 });
              }(k, P);
            });
          }, t.EventEmitter = t, t.prototype._events = void 0, t.prototype._eventsCount = 0, t.prototype._maxListeners = void 0;
          var e = 10;
          function h(k) {
            if (typeof k != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof k);
          }
          function p(k) {
            return k._maxListeners === void 0 ? t.defaultMaxListeners : k._maxListeners;
          }
          function o(k, q, F, te) {
            var P, Q, se, K;
            if (h(F), (Q = k._events) === void 0 ? (Q = k._events = /* @__PURE__ */ Object.create(null), k._eventsCount = 0) : (Q.newListener !== void 0 && (k.emit("newListener", q, F.listener ? F.listener : F), Q = k._events), se = Q[q]), se === void 0) se = Q[q] = F, ++k._eventsCount;
            else if (typeof se == "function" ? se = Q[q] = te ? [F, se] : [se, F] : te ? se.unshift(F) : se.push(F), (P = p(k)) > 0 && se.length > P && !se.warned) {
              se.warned = !0;
              var ie = new Error("Possible EventEmitter memory leak detected. " + se.length + " " + String(q) + " listeners added. Use emitter.setMaxListeners() to increase limit");
              ie.name = "MaxListenersExceededWarning", ie.emitter = k, ie.type = q, ie.count = se.length, K = ie, console && console.warn && console.warn(K);
            }
            return k;
          }
          function v() {
            if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
          }
          function m(k, q, F) {
            var te = { fired: !1, wrapFn: void 0, target: k, type: q, listener: F }, P = v.bind(te);
            return P.listener = F, te.wrapFn = P, P;
          }
          function n(k, q, F) {
            var te = k._events;
            if (te === void 0) return [];
            var P = te[q];
            return P === void 0 ? [] : typeof P == "function" ? F ? [P.listener || P] : [P] : F ? function(Q) {
              for (var se = new Array(Q.length), K = 0; K < se.length; ++K) se[K] = Q[K].listener || Q[K];
              return se;
            }(P) : f(P, P.length);
          }
          function c(k) {
            var q = this._events;
            if (q !== void 0) {
              var F = q[k];
              if (typeof F == "function") return 1;
              if (F !== void 0) return F.length;
            }
            return 0;
          }
          function f(k, q) {
            for (var F = new Array(q), te = 0; te < q; ++te) F[te] = k[te];
            return F;
          }
          function S(k, q, F, te) {
            if (typeof k.on == "function") te.once ? k.once(q, F) : k.on(q, F);
            else {
              if (typeof k.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof k);
              k.addEventListener(q, function P(Q) {
                te.once && k.removeEventListener(q, P), F(Q);
              });
            }
          }
          Object.defineProperty(t, "defaultMaxListeners", { enumerable: !0, get: function() {
            return e;
          }, set: function(k) {
            if (typeof k != "number" || k < 0 || E(k)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + k + ".");
            e = k;
          } }), t.init = function() {
            this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
          }, t.prototype.setMaxListeners = function(k) {
            if (typeof k != "number" || k < 0 || E(k)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + k + ".");
            return this._maxListeners = k, this;
          }, t.prototype.getMaxListeners = function() {
            return p(this);
          }, t.prototype.emit = function(k) {
            for (var q = [], F = 1; F < arguments.length; F++) q.push(arguments[F]);
            var te = k === "error", P = this._events;
            if (P !== void 0) te = te && P.error === void 0;
            else if (!te) return !1;
            if (te) {
              var Q;
              if (q.length > 0 && (Q = q[0]), Q instanceof Error) throw Q;
              var se = new Error("Unhandled error." + (Q ? " (" + Q.message + ")" : ""));
              throw se.context = Q, se;
            }
            var K = P[k];
            if (K === void 0) return !1;
            if (typeof K == "function") J(K, this, q);
            else {
              var ie = K.length, ge = f(K, ie);
              for (F = 0; F < ie; ++F) J(ge[F], this, q);
            }
            return !0;
          }, t.prototype.addListener = function(k, q) {
            return o(this, k, q, !1);
          }, t.prototype.on = t.prototype.addListener, t.prototype.prependListener = function(k, q) {
            return o(this, k, q, !0);
          }, t.prototype.once = function(k, q) {
            return h(q), this.on(k, m(this, k, q)), this;
          }, t.prototype.prependOnceListener = function(k, q) {
            return h(q), this.prependListener(k, m(this, k, q)), this;
          }, t.prototype.removeListener = function(k, q) {
            var F, te, P, Q, se;
            if (h(q), (te = this._events) === void 0) return this;
            if ((F = te[k]) === void 0) return this;
            if (F === q || F.listener === q) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete te[k], te.removeListener && this.emit("removeListener", k, F.listener || q));
            else if (typeof F != "function") {
              for (P = -1, Q = F.length - 1; Q >= 0; Q--) if (F[Q] === q || F[Q].listener === q) {
                se = F[Q].listener, P = Q;
                break;
              }
              if (P < 0) return this;
              P === 0 ? F.shift() : function(K, ie) {
                for (; ie + 1 < K.length; ie++) K[ie] = K[ie + 1];
                K.pop();
              }(F, P), F.length === 1 && (te[k] = F[0]), te.removeListener !== void 0 && this.emit("removeListener", k, se || q);
            }
            return this;
          }, t.prototype.off = t.prototype.removeListener, t.prototype.removeAllListeners = function(k) {
            var q, F, te;
            if ((F = this._events) === void 0) return this;
            if (F.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : F[k] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete F[k]), this;
            if (arguments.length === 0) {
              var P, Q = Object.keys(F);
              for (te = 0; te < Q.length; ++te) (P = Q[te]) !== "removeListener" && this.removeAllListeners(P);
              return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
            }
            if (typeof (q = F[k]) == "function") this.removeListener(k, q);
            else if (q !== void 0) for (te = q.length - 1; te >= 0; te--) this.removeListener(k, q[te]);
            return this;
          }, t.prototype.listeners = function(k) {
            return n(this, k, !0);
          }, t.prototype.rawListeners = function(k) {
            return n(this, k, !1);
          }, t.listenerCount = function(k, q) {
            return typeof k.listenerCount == "function" ? k.listenerCount(q) : c.call(k, q);
          }, t.prototype.listenerCount = c, t.prototype.eventNames = function() {
            return this._eventsCount > 0 ? fe(this._events) : [];
          };
        }, 3101: function(_e) {
          var fe = Array.isArray, R = Object.keys, J = Object.prototype.hasOwnProperty;
          _e.exports = function E(t, e) {
            if (t === e) return !0;
            if (t && e && typeof t == "object" && typeof e == "object") {
              var h, p, o, v = fe(t), m = fe(e);
              if (v && m) {
                if ((p = t.length) != e.length) return !1;
                for (h = p; h-- != 0; ) if (!E(t[h], e[h])) return !1;
                return !0;
              }
              if (v != m) return !1;
              var n = t instanceof Date, c = e instanceof Date;
              if (n != c) return !1;
              if (n && c) return t.getTime() == e.getTime();
              var f = t instanceof RegExp, S = e instanceof RegExp;
              if (f != S) return !1;
              if (f && S) return t.toString() == e.toString();
              var k = R(t);
              if ((p = k.length) !== R(e).length) return !1;
              for (h = p; h-- != 0; ) if (!J.call(e, k[h])) return !1;
              for (h = p; h-- != 0; ) if (!E(t[o = k[h]], e[o])) return !1;
              return !0;
            }
            return t != t && e != e;
          };
        }, 3362: function(_e, fe, R) {
          (function(J, E, t, e, h) {
            function p(l) {
              if ("contents" in l) for (var T = ("styleAttrs" in l) ? l.styleAttrs[e.byName.ruby.qname] : null, b = l.kind === "span" && (T === "container" || T === "textContainer" || T === "baseContainer"), $ = l.contents.length - 1; $ >= 0; $--) !b || "styleAttrs" in l.contents[$] && e.byName.ruby.qname in l.contents[$].styleAttrs ? p(l.contents[$]) : delete l.contents[$];
            }
            function o(l, T, b, $) {
              var W = $ && $.timeContainer === "seq", Ie = 0;
              $ && (Ie = W && b ? b.end : $.begin), T.begin = T.explicit_begin ? T.explicit_begin + Ie : Ie;
              var $e = T.begin, Ze = null;
              if ("sets" in T) for (var xe = 0; xe < T.sets.length; xe++) o(l, T.sets[xe], Ze, T), $e = T.timeContainer === "seq" ? T.sets[xe].end : Math.max($e, T.sets[xe].end), Ze = T.sets[xe];
              if ("contents" in T) {
                if ("contents" in T) for (var Me = 0; Me < T.contents.length; Me++) o(l, T.contents[Me], Ze, T), $e = T.timeContainer === "seq" ? T.contents[Me].end : Math.max($e, T.contents[Me].end), Ze = T.contents[Me];
              } else $e = W ? T.begin : Number.POSITIVE_INFINITY;
              T.explicit_end !== null && T.explicit_dur !== null ? T.end = Math.min(T.begin + T.explicit_dur, Ie + T.explicit_end) : T.explicit_end === null && T.explicit_dur !== null ? T.end = T.begin + T.explicit_dur : T.explicit_end !== null && T.explicit_dur === null ? T.end = Ie + T.explicit_end : T.end = $e, delete T.explicit_begin, delete T.explicit_dur, delete T.explicit_end, l._registerEvent(T);
            }
            function v(l) {
              this.node = l;
            }
            function m() {
              this.events = [], this.head = new n(), this.body = null;
            }
            function n() {
              this.styling = new c(), this.layout = new k();
            }
            function c() {
              this.styles = {}, this.initials = {};
            }
            function f() {
              this.id = null, this.styleAttrs = null, this.styleRefs = null;
            }
            function S() {
              this.styleAttrs = null;
            }
            function k() {
              this.regions = {};
            }
            function q(l, T) {
              F.call(this, "image"), this.src = l, this.type = T;
            }
            function F(l) {
              this.kind = l;
            }
            function te(l) {
              this.id = l;
            }
            function P(l) {
              this.regionID = l;
            }
            function Q(l) {
              this.styleAttrs = l;
            }
            function se(l) {
              this.sets = l;
            }
            function K(l) {
              this.contents = l;
            }
            function ie(l, T, b) {
              this.explicit_begin = l, this.explicit_end = T, this.explicit_dur = b;
            }
            function ge() {
              F.call(this, "body");
            }
            function Ne() {
              F.call(this, "div");
            }
            function ee() {
              F.call(this, "p");
            }
            function Oe() {
              F.call(this, "span");
            }
            function Ge() {
              F.call(this, "span");
            }
            function Xe() {
              F.call(this, "br");
            }
            function Ce() {
            }
            function Ue() {
            }
            function Je(l) {
              return l && "xml:id" in l.attributes && l.attributes["xml:id"].value || null;
            }
            function st(l) {
              return l && "style" in l.attributes ? l.attributes.style.value.split(" ") : [];
            }
            function we(l, T) {
              var b = {};
              if (l !== null) for (var $ in l.attributes) {
                var W = l.attributes[$].uri + " " + l.attributes[$].local, Ie = e.byQName[W];
                if (Ie !== void 0) {
                  var $e = Ie.parse(l.attributes[$].value);
                  $e !== null ? (b[W] = $e, Ie === e.byName.zIndex && ve(T, "zIndex attribute present but not used by IMSC1 since regions do not overlap")) : Se(T, "Cannot parse styling attribute " + W + " --> " + l.attributes[$].value);
                }
              }
              return b;
            }
            function Be(l, T, b) {
              for (var $ in l.attributes) if (l.attributes[$].uri === T && l.attributes[$].local === b) return l.attributes[$].value;
              return null;
            }
            function At(l, T, b) {
              var $, W = null;
              return ($ = /^(\d+(?:\.\d+)?)f$/.exec(b)) !== null ? T !== null && (W = parseFloat($[1]) / T) : ($ = /^(\d+(?:\.\d+)?)t$/.exec(b)) !== null ? l !== null && (W = parseFloat($[1]) / l) : ($ = /^(\d+(?:\.\d+)?)ms$/.exec(b)) !== null ? W = parseFloat($[1]) / 1e3 : ($ = /^(\d+(?:\.\d+)?)s$/.exec(b)) !== null ? W = parseFloat($[1]) : ($ = /^(\d+(?:\.\d+)?)h$/.exec(b)) !== null ? W = 3600 * parseFloat($[1]) : ($ = /^(\d+(?:\.\d+)?)m$/.exec(b)) !== null ? W = 60 * parseFloat($[1]) : ($ = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/.exec(b)) !== null ? W = 3600 * parseInt($[1]) + 60 * parseInt($[2]) + parseFloat($[3]) : ($ = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/.exec(b)) !== null && T !== null && (W = 3600 * parseInt($[1]) + 60 * parseInt($[2]) + parseInt($[3]) + ($[4] === null ? 0 : parseInt($[4]) / T)), W;
            }
            function ht(l, T, b) {
              for (; T.styleRefs.length > 0; ) {
                var $ = T.styleRefs.pop();
                $ in l.styles ? (ht(l, l.styles[$], b), it(l.styles[$].styleAttrs, T.styleAttrs)) : Se(b, "Non-existant style id referenced");
              }
            }
            function je(l, T, b, $) {
              for (var W = T.length - 1; W >= 0; W--) {
                var Ie = T[W];
                Ie in l.styles ? it(l.styles[Ie].styleAttrs, b) : Se($, "Non-existant style id referenced");
              }
            }
            function it(l, T) {
              for (var b in l) l.hasOwnProperty(b) && (b in T || (T[b] = l[b]));
            }
            function ve(l, T) {
              if (l && l.warn && l.warn(T)) throw T;
            }
            function Se(l, T) {
              if (l && l.error && l.error(T)) throw T;
            }
            function Ye(l, T) {
              throw l && l.fatal && l.fatal(T), T;
            }
            function d(l, T) {
              for (var b, $ = 0, W = l.length - 1; $ <= W; ) {
                var Ie = l[b = Math.floor(($ + W) / 2)];
                if (Ie < T) $ = b + 1;
                else {
                  if (!(Ie > T)) return { found: !0, index: b };
                  W = b - 1;
                }
              }
              return { found: !1, index: $ };
            }
            J.fromXML = function(l, T, b) {
              var $ = E.parser(!0, { xmlns: !0 }), W = [], Ie = [], $e = [], Ze = 0, xe = null;
              $.onclosetag = function(dt) {
                if (W[0] instanceof Ce) xe.head !== null && xe.head.styling !== null && je(xe.head.styling, W[0].styleRefs, W[0].styleAttrs, T), delete W[0].styleRefs;
                else if (W[0] instanceof c) for (var Yt in W[0].styles) W[0].styles.hasOwnProperty(Yt) && ht(W[0], W[0].styles[Yt], T);
                else if (W[0] instanceof ee || W[0] instanceof Oe) {
                  if (W[0].contents.length > 1) {
                    var Ot, Ht = [W[0].contents[0]];
                    for (Ot = 1; Ot < W[0].contents.length; Ot++) W[0].contents[Ot] instanceof Ge && Ht[Ht.length - 1] instanceof Ge ? Ht[Ht.length - 1].text += W[0].contents[Ot].text : Ht.push(W[0].contents[Ot]);
                    W[0].contents = Ht;
                  }
                  W[0] instanceof Oe && W[0].contents.length === 1 && W[0].contents[0] instanceof Ge && (W[0].text = W[0].contents[0].text, delete W[0].contents);
                } else W[0] instanceof v && (W[0].node.uri === t.ns_tt && W[0].node.local === "metadata" ? Ze-- : Ze > 0 && b && "onCloseTag" in b && b.onCloseTag());
                $e.shift(), Ie.shift(), W.shift();
              }, $.ontext = function(dt) {
                if (W[0] !== void 0) if (W[0] instanceof Oe || W[0] instanceof ee) {
                  if (W[0] instanceof Oe) {
                    var Yt = W[0].styleAttrs[e.byName.ruby.qname];
                    if (Yt === "container" || Yt === "textContainer" || Yt === "baseContainer") return;
                  }
                  var Ot = new Ge();
                  Ot.initFromText(xe, W[0], dt, Ie[0], $e[0], T), W[0].contents.push(Ot);
                } else W[0] instanceof v && Ze > 0 && b && "onText" in b && b.onText(dt);
              }, $.onopentag = function(dt) {
                var Yt = dt.attributes["xml:space"];
                Yt ? $e.unshift(Yt.value) : $e.length === 0 ? $e.unshift("default") : $e.unshift($e[0]);
                var Ot = dt.attributes["xml:lang"];
                if (Ot ? Ie.unshift(Ot.value) : Ie.length === 0 ? Ie.unshift("") : Ie.unshift(Ie[0]), dt.uri === t.ns_tt) if (dt.local === "tt") xe !== null && Ye(T, "Two <tt> elements at (" + this.line + "," + this.column + ")"), (xe = new m()).initFromNode(dt, Ie[0], T), W.unshift(xe);
                else if (dt.local === "head") W[0] instanceof m || Ye(T, "Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")"), W.unshift(xe.head);
                else if (dt.local === "styling") W[0] instanceof n || Ye(T, "Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")"), W.unshift(xe.head.styling);
                else if (dt.local === "style") {
                  var Ht;
                  W[0] instanceof c ? ((Ht = new f()).initFromNode(dt, T), Ht.id ? xe.head.styling.styles[Ht.id] = Ht : Se(T, "<style> element missing @id attribute"), W.unshift(Ht)) : W[0] instanceof Ce ? ((Ht = new f()).initFromNode(dt, T), it(Ht.styleAttrs, W[0].styleAttrs), W.unshift(Ht)) : Ye(T, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");
                } else if (dt.local === "initial") {
                  var Ut;
                  if (W[0] instanceof c) {
                    for (var fn in (Ut = new S()).initFromNode(dt, T), Ut.styleAttrs) Ut.styleAttrs.hasOwnProperty(fn) && (xe.head.styling.initials[fn] = Ut.styleAttrs[fn]);
                    W.unshift(Ut);
                  } else Ye(T, "Parent of <initial> element is not <styling> at (" + this.line + "," + this.column + ")");
                } else if (dt.local === "layout") W[0] instanceof n || Ye(T, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")"), W.unshift(xe.head.layout);
                else if (dt.local === "region") {
                  W[0] instanceof k || Ye(T, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
                  var Tn = new Ce();
                  Tn.initFromNode(xe, dt, Ie[0], T), !Tn.id || Tn.id in xe.head.layout.regions ? Se(T, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")") : xe.head.layout.regions[Tn.id] = Tn, W.unshift(Tn);
                } else if (dt.local === "body") {
                  W[0] instanceof m || Ye(T, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")"), xe.body !== null && Ye(T, "Second <body> element at " + this.line + "," + this.column + ")");
                  var Fn = new ge();
                  Fn.initFromNode(xe, dt, Ie[0], T), xe.body = Fn, W.unshift(Fn);
                } else if (dt.local === "div") {
                  W[0] instanceof Ne || W[0] instanceof ge || Ye(T, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");
                  var On = new Ne();
                  On.initFromNode(xe, W[0], dt, Ie[0], T);
                  var Zn = On.styleAttrs[e.byName.backgroundImage.qname];
                  Zn && (On.contents.push(new q(Zn)), delete On.styleAttrs[e.byName.backgroundImage.qname]), W[0].contents.push(On), W.unshift(On);
                } else if (dt.local === "image") {
                  W[0] instanceof Ne || Ye(T, "Parent of <image> element is not <div> at " + this.line + "," + this.column + ")");
                  var rr = new q();
                  rr.initFromNode(xe, W[0], dt, Ie[0], T), W[0].contents.push(rr), W.unshift(rr);
                } else if (dt.local === "p") {
                  W[0] instanceof Ne || Ye(T, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");
                  var wn = new ee();
                  wn.initFromNode(xe, W[0], dt, Ie[0], T), W[0].contents.push(wn), W.unshift(wn);
                } else if (dt.local === "span") {
                  W[0] instanceof Oe || W[0] instanceof ee || Ye(T, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                  var pr = new Oe();
                  pr.initFromNode(xe, W[0], dt, Ie[0], $e[0], T), W[0].contents.push(pr), W.unshift(pr);
                } else if (dt.local === "br") {
                  W[0] instanceof Oe || W[0] instanceof ee || Ye(T, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");
                  var Qn = new Xe();
                  Qn.initFromNode(xe, W[0], dt, Ie[0], T), W[0].contents.push(Qn), W.unshift(Qn);
                } else if (dt.local === "set") {
                  W[0] instanceof Oe || W[0] instanceof ee || W[0] instanceof Ne || W[0] instanceof ge || W[0] instanceof Ce || W[0] instanceof Xe || Ye(T, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");
                  var cr = new Ue();
                  cr.initFromNode(xe, W[0], dt, T), W[0].sets.push(cr), W.unshift(cr);
                } else W.unshift(new v(dt));
                else W.unshift(new v(dt));
                if (W[0] instanceof v) {
                  if (dt.uri === t.ns_tt && dt.local === "metadata") Ze++;
                  else if (Ze > 0 && b && "onOpenTag" in b) {
                    var Tr = [];
                    for (var fr in dt.attributes) Tr[dt.attributes[fr].uri + " " + dt.attributes[fr].local] = { uri: dt.attributes[fr].uri, local: dt.attributes[fr].local, value: dt.attributes[fr].value };
                    b.onOpenTag(dt.uri, dt.local, Tr);
                  }
                }
              }, $.write(l).close(), delete xe.head.styling.styles;
              var Me = !1;
              for (var Ve in xe.head.layout.regions) if (xe.head.layout.regions.hasOwnProperty(Ve)) {
                Me = !0;
                break;
              }
              if (!Me) {
                var ot = Ce.prototype.createDefaultRegion(xe.lang);
                xe.head.layout.regions[ot.id] = ot;
              }
              for (var bt in xe.head.layout.regions) xe.head.layout.regions.hasOwnProperty(bt) && o(xe, xe.head.layout.regions[bt], null, null);
              return xe.body && o(xe, xe.body, null, null), xe.body && p(xe.body), xe;
            }, m.prototype.initFromNode = function(l, T, b) {
              var $ = function(Ze, xe) {
                var Me = Be(Ze, t.ns_ttp, "cellResolution"), Ve = 15, ot = 32;
                if (Me !== null) {
                  var bt = /(\d+) (\d+)/.exec(Me);
                  bt !== null ? (ot = parseInt(bt[1]), Ve = parseInt(bt[2])) : ve(xe, "Malformed cellResolution value (using initial value instead)");
                }
                return { w: ot, h: Ve };
              }(l, b);
              this.cellLength = { h: new h.ComputedLength(0, 1 / $.h), w: new h.ComputedLength(1 / $.w, 0) };
              var W = function(Ze, xe) {
                var Me, Ve = Be(Ze, t.ns_ttp, "frameRate"), ot = 30;
                Ve !== null && ((Me = /(\d+)/.exec(Ve)) !== null ? ot = parseInt(Me[1]) : ve(xe, "Malformed frame rate attribute (using initial value instead)"));
                var bt = Be(Ze, t.ns_ttp, "frameRateMultiplier"), dt = 1;
                bt !== null && ((Me = /(\d+) (\d+)/.exec(bt)) !== null ? dt = parseInt(Me[1]) / parseInt(Me[2]) : ve(xe, "Malformed frame rate multiplier attribute (using initial value instead)"));
                var Yt = dt * ot, Ot = 1, Ht = Be(Ze, t.ns_ttp, "tickRate");
                return Ht === null ? Ve !== null && (Ot = Yt) : (Me = /(\d+)/.exec(Ht)) !== null ? Ot = parseInt(Me[1]) : ve(xe, "Malformed tick rate attribute (using initial value instead)"), { effectiveFrameRate: Yt, tickRate: Ot };
              }(l, b);
              this.effectiveFrameRate = W.effectiveFrameRate, this.tickRate = W.tickRate, this.aspectRatio = function(Ze, xe) {
                var Me = Be(Ze, t.ns_ittp, "aspectRatio");
                Me === null && (Me = Be(Ze, t.ns_ttp, "displayAspectRatio"));
                var Ve = null;
                if (Me !== null) {
                  var ot = /(\d+)\s+(\d+)/.exec(Me);
                  if (ot !== null) {
                    var bt = parseInt(ot[1]), dt = parseInt(ot[2]);
                    bt !== 0 && dt !== 0 ? Ve = bt / dt : Se(xe, "Illegal aspectRatio values (ignoring)");
                  } else Se(xe, "Malformed aspectRatio attribute (ignoring)");
                }
                return Ve;
              }(l, b);
              var Ie = Be(l, t.ns_ttp, "timeBase");
              Ie !== null && Ie !== "media" && Ye(b, "Unsupported time base");
              var $e = function(Ze, xe) {
                var Me = Be(Ze, t.ns_tts, "extent");
                if (Me === null) return null;
                var Ve = Me.split(" ");
                if (Ve.length !== 2) return ve(xe, "Malformed extent (ignoring)"), null;
                var ot = h.parseLength(Ve[0]), bt = h.parseLength(Ve[1]);
                return bt && ot ? { h: bt, w: ot } : (ve(xe, "Malformed extent values (ignoring)"), null);
              }(l, b);
              $e === null ? this.pxLength = { h: null, w: null } : ($e.h.unit === "px" && $e.w.unit === "px" || Ye(b, "Extent on TT must be in px or absent"), this.pxLength = { h: new h.ComputedLength(0, 1 / $e.h.value), w: new h.ComputedLength(1 / $e.w.value, 0) }), this.dimensions = { h: new h.ComputedLength(0, 1), w: new h.ComputedLength(1, 0) }, this.lang = T;
            }, m.prototype._registerEvent = function(l) {
              if (!(l.end <= l.begin)) {
                var T = d(this.events, l.begin);
                if (T.found || this.events.splice(T.index, 0, l.begin), l.end !== Number.POSITIVE_INFINITY) {
                  var b = d(this.events, l.end);
                  b.found || this.events.splice(b.index, 0, l.end);
                }
              }
            }, m.prototype.getMediaTimeRange = function() {
              return [this.events[0], this.events[this.events.length - 1]];
            }, m.prototype.getMediaTimeEvents = function() {
              return this.events;
            }, f.prototype.initFromNode = function(l, T) {
              this.id = Je(l), this.styleAttrs = we(l, T), this.styleRefs = st(l);
            }, S.prototype.initFromNode = function(l, T) {
              for (var b in this.styleAttrs = {}, l.attributes) if (l.attributes[b].uri === t.ns_itts || l.attributes[b].uri === t.ns_ebutts || l.attributes[b].uri === t.ns_tts) {
                var $ = l.attributes[b].uri + " " + l.attributes[b].local;
                this.styleAttrs[$] = l.attributes[b].value;
              }
            }, q.prototype.initFromNode = function(l, T, b, $, W) {
              this.src = "src" in b.attributes ? b.attributes.src.value : null, this.src || Se(W, "Invalid image@src attribute"), this.type = "type" in b.attributes ? b.attributes.type.value : null, this.type || Se(W, "Invalid image@type attribute"), Q.prototype.initFromNode.call(this, l, T, b, W), ie.prototype.initFromNode.call(this, l, T, b, W), se.prototype.initFromNode.call(this, l, T, b, W), P.prototype.initFromNode.call(this, l, T, b, W), this.lang = $;
            }, te.prototype.initFromNode = function(l, T, b, $) {
              this.id = Je(b);
            }, P.prototype.initFromNode = function(l, T, b, $) {
              this.regionID = function(W) {
                return W && "region" in W.attributes ? W.attributes.region.value : "";
              }(b);
            }, Q.prototype.initFromNode = function(l, T, b, $) {
              this.styleAttrs = we(b, $), l.head !== null && l.head.styling !== null && je(l.head.styling, st(b), this.styleAttrs, $);
            }, se.prototype.initFromNode = function(l, T, b, $) {
              this.sets = [];
            }, K.prototype.initFromNode = function(l, T, b, $) {
              this.contents = [];
            }, ie.prototype.initFromNode = function(l, T, b, $) {
              var W = function(Ie, $e, Ze, xe) {
                var Me = null;
                Ze && "begin" in Ze.attributes && (Me = At(Ie.tickRate, Ie.effectiveFrameRate, Ze.attributes.begin.value)) === null && ve(xe, "Malformed begin value " + Ze.attributes.begin.value + " (using 0)");
                var Ve = null;
                Ze && "dur" in Ze.attributes && (Ve = At(Ie.tickRate, Ie.effectiveFrameRate, Ze.attributes.dur.value)) === null && ve(xe, "Malformed dur value " + Ze.attributes.dur.value + " (ignoring)");
                var ot = null;
                return Ze && "end" in Ze.attributes && (ot = At(Ie.tickRate, Ie.effectiveFrameRate, Ze.attributes.end.value)) === null && ve(xe, "Malformed end value (ignoring)"), { explicit_begin: Me, explicit_end: ot, explicit_dur: Ve };
              }(l, 0, b, $);
              this.explicit_begin = W.explicit_begin, this.explicit_end = W.explicit_end, this.explicit_dur = W.explicit_dur, this.timeContainer = function(Ie, $e) {
                var Ze = Ie && "timeContainer" in Ie.attributes ? Ie.attributes.timeContainer.value : null;
                return Ze && Ze !== "par" ? Ze === "seq" ? "seq" : (Se($e, "Illegal value of timeContainer (assuming 'par')"), "par") : "par";
              }(b, $);
            }, ge.prototype.initFromNode = function(l, T, b, $) {
              Q.prototype.initFromNode.call(this, l, null, T, $), ie.prototype.initFromNode.call(this, l, null, T, $), se.prototype.initFromNode.call(this, l, null, T, $), P.prototype.initFromNode.call(this, l, null, T, $), K.prototype.initFromNode.call(this, l, null, T, $), this.lang = b;
            }, Ne.prototype.initFromNode = function(l, T, b, $, W) {
              Q.prototype.initFromNode.call(this, l, T, b, W), ie.prototype.initFromNode.call(this, l, T, b, W), se.prototype.initFromNode.call(this, l, T, b, W), P.prototype.initFromNode.call(this, l, T, b, W), K.prototype.initFromNode.call(this, l, T, b, W), this.lang = $;
            }, ee.prototype.initFromNode = function(l, T, b, $, W) {
              Q.prototype.initFromNode.call(this, l, T, b, W), ie.prototype.initFromNode.call(this, l, T, b, W), se.prototype.initFromNode.call(this, l, T, b, W), P.prototype.initFromNode.call(this, l, T, b, W), K.prototype.initFromNode.call(this, l, T, b, W), this.lang = $;
            }, Oe.prototype.initFromNode = function(l, T, b, $, W, Ie) {
              Q.prototype.initFromNode.call(this, l, T, b, Ie), ie.prototype.initFromNode.call(this, l, T, b, Ie), se.prototype.initFromNode.call(this, l, T, b, Ie), P.prototype.initFromNode.call(this, l, T, b, Ie), K.prototype.initFromNode.call(this, l, T, b, Ie), this.space = W, this.lang = $;
            }, Ge.prototype.initFromText = function(l, T, b, $, W, Ie) {
              ie.prototype.initFromNode.call(this, l, T, null, Ie), this.text = b, this.space = W, this.lang = $;
            }, Xe.prototype.initFromNode = function(l, T, b, $, W) {
              P.prototype.initFromNode.call(this, l, T, b, W), ie.prototype.initFromNode.call(this, l, T, b, W), this.lang = $;
            }, Ce.prototype.createDefaultRegion = function(l) {
              var T = new Ce();
              return te.call(T, ""), Q.call(T, {}), se.call(T, []), ie.call(T, 0, Number.POSITIVE_INFINITY, null), this.lang = l, T;
            }, Ce.prototype.initFromNode = function(l, T, b, $) {
              te.prototype.initFromNode.call(this, l, null, T, $), ie.prototype.initFromNode.call(this, l, null, T, $), se.prototype.initFromNode.call(this, l, null, T, $), this.styleAttrs = we(T, $), this.styleRefs = st(T), this.lang = b;
            }, Ue.prototype.initFromNode = function(l, T, b, $) {
              ie.prototype.initFromNode.call(this, l, T, b, $);
              var W = we(b, $);
              for (var Ie in this.qname = null, this.value = null, W) if (W.hasOwnProperty(Ie)) {
                if (this.qname) {
                  Se($, "More than one style specified on set");
                  break;
                }
                this.qname = Ie, this.value = W[Ie];
              }
            };
          })(fe, typeof sax > "u" ? R(5378) : sax, typeof imscNames > "u" ? R(210) : imscNames, typeof imscStyles > "u" ? R(6811) : imscStyles, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 506: function(_e, fe, R) {
          var J = /firefox/i.test(navigator.userAgent);
          (function(E, t, e) {
            function h(K, ie, ge, Ne) {
              var ee;
              if (ge.kind === "region") (ee = document.createElement("div")).style.position = "absolute";
              else if (ge.kind === "body") ee = document.createElement("div");
              else if (ge.kind === "div") ee = document.createElement("div");
              else if (ge.kind === "image") {
                if (ee = document.createElement("img"), K.imgResolver !== null && ge.src !== null) {
                  var Oe = K.imgResolver(ge.src, ee);
                  Oe && (ee.src = Oe), ee.height = K.regionH, ee.width = K.regionW;
                }
              } else if (ge.kind === "p") ee = document.createElement("p");
              else if (ge.kind === "span") if (ge.styleAttrs[e.byName.ruby.qname] === "container") ee = document.createElement("ruby"), K.ruby = !0;
              else if (ge.styleAttrs[e.byName.ruby.qname] === "base") ee = document.createElement("span");
              else if (ge.styleAttrs[e.byName.ruby.qname] === "text") ee = document.createElement("rt");
              else if (ge.styleAttrs[e.byName.ruby.qname] === "baseContainer") ee = document.createElement("rbc");
              else if (ge.styleAttrs[e.byName.ruby.qname] === "textContainer") ee = document.createElement("rtc");
              else {
                if (ge.styleAttrs[e.byName.ruby.qname] === "delimiter") return;
                ee = document.createElement("span");
              }
              else ge.kind === "br" && (ee = document.createElement("br"));
              if (ee) {
                if (ge.lang && (ge.kind !== "region" && ge.lang === Ne.lang || (ee.lang = ge.lang)), ie.appendChild(ee), ee.style.margin = "0", ge.kind === "region") {
                  var Ge = ge.styleAttrs[e.byName.writingMode.qname];
                  Ge === "lrtb" || Ge === "lr" ? (K.ipd = "lr", K.bpd = "tb") : Ge === "rltb" || Ge === "rl" ? (K.ipd = "rl", K.bpd = "tb") : Ge === "tblr" ? (K.ipd = "tb", K.bpd = "lr") : Ge !== "tbrl" && Ge !== "tb" || (K.ipd = "tb", K.bpd = "rl");
                } else if (ge.kind === "p" && K.bpd === "tb") {
                  var Xe = ge.styleAttrs[e.byName.direction.qname];
                  K.ipd = Xe === "ltr" ? "lr" : "rl";
                }
                for (var Ce = 0; Ce < S.length; Ce++) {
                  var Ue = S[Ce], Je = ge.styleAttrs[Ue.qname];
                  Je !== void 0 && Ue.map !== null && Ue.map(K, ee, ge, Je);
                }
                var st = ee, we = ge.styleAttrs[e.byName.linePadding.qname];
                if (we && !we.isZero()) {
                  var Be = we.toUsedLength(K.w, K.h);
                  if (Be > 0) {
                    var At = Math.ceil(Be) + "px";
                    K.bpd === "tb" ? (st.style.paddingLeft = At, st.style.paddingRight = At) : (st.style.paddingTop = At, st.style.paddingBottom = At), K.lp = we;
                  }
                }
                var ht = ge.styleAttrs[e.byName.multiRowAlign.qname];
                if (ht && ht !== "auto") {
                  var je = document.createElement("span");
                  je.style.display = "inline-block", je.style.textAlign = ht, ee.appendChild(je), st = je, K.mra = ht;
                }
                var it = ge.styleAttrs[e.byName.rubyReserve.qname];
                if (it && it[0] !== "none" && (K.rubyReserve = it), ge.styleAttrs[e.byName.fillLineGap.qname] && (K.flg = !0), ge.kind === "span" && ge.text) {
                  var ve = ge.styleAttrs[e.byName.textEmphasis.qname];
                  if (ve && ve.style !== "none" && (K.textEmphasis = !0), e.byName.textCombine.qname in ge.styleAttrs && ge.styleAttrs[e.byName.textCombine.qname] === "all") ee.textContent = ge.text, ee._isd_element = ge, ve && c(K, ee, 0, ve);
                  else for (var Se = "", Ye = 0; Ye < ge.text.length; Ye++) {
                    Se += ge.text.charAt(Ye);
                    var d = ge.text.charCodeAt(Ye);
                    if (d < 55296 || d > 56319 || Ye === ge.text.length - 1) {
                      var l = document.createElement("span");
                      l.textContent = Se, ve && c(K, l, 0, ve), ee.appendChild(l), Se = "", l._isd_element = ge;
                    }
                  }
                }
                if ("contents" in ge) for (var T = 0; T < ge.contents.length; T++) h(K, st, ge.contents[T], ge);
                var b = [];
                if (ge.kind === "p" && (n(K, st, b, null), K.rubyReserve && (function(Ze, xe) {
                  for (var Me = 0; Me < Ze.length; Me++) {
                    var Ve, ot, bt = document.createElement("ruby"), dt = document.createElement("span");
                    dt.textContent = "​", bt.appendChild(dt);
                    var Yt, Ot = xe.rubyReserve[1].toUsedLength(xe.w, xe.h) + "px";
                    xe.rubyReserve[0] === "both" || xe.rubyReserve[0] === "outside" && Ze.length == 1 ? ((Ve = document.createElement("rtc")).style[te] = F ? "after" : "under", Ve.textContent = "​", Ve.style.fontSize = Ot, (ot = document.createElement("rtc")).style[te] = F ? "before" : "over", ot.textContent = "​", ot.style.fontSize = Ot, bt.appendChild(Ve), bt.appendChild(ot)) : ((Ve = document.createElement("rtc")).textContent = "​", Ve.style.fontSize = Ot, Yt = xe.rubyReserve[0] === "after" || xe.rubyReserve[0] === "outside" && Me > 0 ? F ? "after" : xe.bpd === "tb" || xe.bpd === "rl" ? "under" : "over" : F ? "before" : xe.bpd === "tb" || xe.bpd === "rl" ? "over" : "under", Ve.style[te] = Yt, bt.appendChild(Ve));
                    for (var Ht = null, Ut = 0; Ut < Ze[Me].rbc.length; Ut++) if (Ze[Me].rbc[Ut].localName === "ruby") {
                      Ht = Ze[Me].rbc[Ut];
                      for (var fn = 0; fn < Ht.style.length; fn++) bt.style.setProperty(Ht.style.item(fn), Ht.style.getPropertyValue(Ht.style.item(fn)));
                      break;
                    }
                    (Ht = Ht || Ze[Me].elements[0].node).parentElement.insertBefore(bt, Ht);
                  }
                }(b, K), K.rubyReserve = null), (K.ruby || K.rubyReserve) && (function(Ze, xe) {
                  for (var Me = 0; Me < Ze.length; Me++) for (var Ve = 0; Ve < Ze[Me].rbc.length; Ve++) {
                    var ot;
                    Ze[Me].rbc[Ve].style[te] || (ot = F ? Me === 0 ? "before" : "after" : xe.bpd === "tb" || xe.bpd === "rl" ? Me === 0 ? "over" : "under" : Me === 0 ? "under" : "over", Ze[Me].rbc[Ve].style[te] = ot);
                  }
                }(b, K), K.ruby = null), K.textEmphasis && (function(Ze, xe) {
                  for (var Me = 0; Me < Ze.length; Me++) for (var Ve = 0; Ve < Ze[Me].te.length; Ve++) {
                    var ot;
                    Ze[Me].te[Ve].style[Q] && Ze[Me].te[Ve].style[Q] !== "none" || (ot = xe.bpd === "tb" ? Me === 0 ? "left over" : "left under" : xe.bpd === "rl" ? Me === 0 ? "right under" : "left under" : Me === 0 ? "left under" : "right under", Ze[Me].te[Ve].style[Q] = ot);
                  }
                }(b, K), K.textEmphasis = null), K.mra && (function(Ze) {
                  for (var xe = 0; xe < Ze.length - 1; xe++) {
                    var Me = Ze[xe].elements.length;
                    if (Me !== 0 && Ze[xe].br === !1) {
                      var Ve = document.createElement("br"), ot = Ze[xe].elements[Me - 1].node;
                      ot.parentElement.insertBefore(Ve, ot.nextSibling);
                    }
                  }
                }(b), K.mra = null), K.lp && (function(Ze, xe, Me) {
                  if (Ze !== null) for (var Ve = 0; Ve < Ze.length; Ve++) {
                    var ot = Ze[Ve].elements.length, bt = Math.ceil(xe) + "px", dt = "-" + Math.ceil(xe) + "px";
                    if (ot !== 0) {
                      var Yt = Ze[Ve].elements[Ze[Ve].start_elem], Ot = Ze[Ve].elements[Ze[Ve].end_elem];
                      if (Yt === Ot) {
                        var Ht = Yt.node.getBoundingClientRect();
                        if (Ht.width == 0 || Ht.height == 0) continue;
                      }
                      Me.ipd === "lr" ? (Yt.node.style.marginLeft = dt, Yt.node.style.paddingLeft = bt) : Me.ipd === "rl" ? (Yt.node.style.paddingRight = bt, Yt.node.style.marginRight = dt) : Me.ipd === "tb" && (Yt.node.style.paddingTop = bt, Yt.node.style.marginTop = dt), Me.ipd === "lr" ? (J || (Ot.node.style.marginRight = dt), Ot.node.style.paddingRight = bt) : Me.ipd === "rl" ? (Ot.node.style.paddingLeft = bt, J || (Ot.node.style.marginLeft = dt)) : Me.ipd === "tb" && (Ot.node.style.paddingBottom = bt, Ot.node.style.marginBottom = dt);
                    }
                  }
                }(b, K.lp.toUsedLength(K.w, K.h), K), K.lp = null), function(Ze, xe) {
                  for (var Me = 0; Me < Ze.length; Me++) for (var Ve = Ze[Me], ot = 1; ot < Ve.elements.length; ) {
                    var bt = Ve.elements[ot - 1], dt = Ve.elements[ot];
                    o(bt.node, dt.node, xe) ? Ve.elements.splice(ot, 1) : ot++;
                  }
                  for (var Yt, Ot, Ht = [], Ut = 0; Ut < Ze.length; Ut++) for (var fn = 0; fn < Ze[Ut].elements.length; fn++) (Ot = p(Yt = Ze[Ut].elements[fn].node, Ht, !1)) && (Yt.style.backgroundColor = Ot);
                  for (var Tn = 0; Tn < Ht.length; Tn++) Ht[Tn].style.backgroundColor = "";
                }(b, K), K.flg)) {
                  var $ = m(st.getBoundingClientRect(), K);
                  (function(Ze, xe, Me, Ve, ot) {
                    for (var bt = Math.sign(Me - xe), dt = 0; dt <= Ze.length; dt++) {
                      var Yt, Ot, Ht, Ut;
                      if (Yt = dt === 0 ? Math.round(xe) : dt === Ze.length ? Math.round(Me) : Math.round((Ze[dt - 1].after + Ze[dt].before) / 2), dt > 0 && Ze[dt - 1]) for (Ht = 0; Ht < Ze[dt - 1].elements.length; Ht++) Ot = bt * (Yt - (Ut = Ze[dt - 1].elements[Ht]).after) + "px", Ve.bpd === "lr" ? Ut.node.style.paddingRight = Ot : Ve.bpd === "rl" ? Ut.node.style.paddingLeft = Ot : Ve.bpd === "tb" && (Ut.node.style.paddingBottom = Ot);
                      if (dt < Ze.length) for (Ht = 0; Ht < Ze[dt].elements.length; Ht++) Ot = bt * ((Ut = Ze[dt].elements[Ht]).before - Yt) + "px", Ve.bpd === "lr" ? Ut.node.style.paddingLeft = Ot : Ve.bpd === "rl" ? Ut.node.style.paddingRight = Ot : Ve.bpd === "tb" && (Ut.node.style.paddingTop = Ot);
                    }
                  })(b, $.before, $.after, K), K.flg = null;
                }
                if (ge.kind === "region" && K.bpd === "tb" && K.enableRollUp && ge.contents.length > 0 && ge.styleAttrs[e.byName.displayAlign.qname] === "after") {
                  n(K, st, b, null);
                  var W = new v(ge.id === "" ? "_" : ge.id, b);
                  if (K.currentISDState[W.id] = W, K.previousISDState && W.id in K.previousISDState && K.previousISDState[W.id].plist.length > 0 && W.plist.length > 1 && W.plist[W.plist.length - 2].text === K.previousISDState[W.id].plist[K.previousISDState[W.id].plist.length - 1].text) {
                    var Ie = ee.firstElementChild, $e = W.plist[W.plist.length - 1].after - W.plist[W.plist.length - 1].before;
                    Ie.style.bottom = "-" + $e + "px", Ie.style.transition = "transform 0.4s", Ie.style.position = "relative", Ie.style.transform = "translateY(-" + $e + "px)";
                  }
                }
              } else se(K.errorHandler, "Error processing ISD element kind: " + ge.kind);
            }
            function p(K, ie, ge) {
              return K.style.backgroundColor ? (ge && !ie.includes(K) && ie.push(K), K.style.backgroundColor) : K.parentElement.nodeName === "SPAN" || K.parentElement.nodeName === "RUBY" || K.parentElement.nodeName === "RBC" || K.parentElement.nodeName === "RTC" || K.parentElement.nodeName === "RT" ? p(K.parentElement, ie, !0) : void 0;
            }
            function o(K, ie, ge) {
              if (K.tagName === "SPAN" && ie.tagName === "SPAN" && K._isd_element === ie._isd_element) {
                if (!K._isd_element) return se(ge.errorHandler, "Internal error: HTML span is not linked to a source element; cannot merge spans."), !1;
                K.textContent += ie.textContent;
                for (var Ne = 0; Ne < ie.style.length; Ne++) {
                  var ee = ie.style[Ne];
                  (ee.indexOf("border") >= 0 || ee.indexOf("padding") >= 0 || ee.indexOf("margin") >= 0) && (K.style[ee] = ie.style[ee]);
                }
                return ie.parentElement.removeChild(ie), !0;
              }
              return !1;
            }
            function v(K, ie) {
              this.id = K, this.plist = ie;
            }
            function m(K, ie) {
              var ge = { before: null, after: null, start: null, end: null };
              return ie.bpd === "tb" ? (ge.before = K.top, ge.after = K.bottom, ie.ipd === "lr" ? (ge.start = K.left, ge.end = K.right) : (ge.start = K.right, ge.end = K.left)) : ie.bpd === "lr" ? (ge.before = K.left, ge.after = K.right, ge.start = K.top, ge.end = K.bottom) : ie.bpd === "rl" && (ge.before = K.right, ge.after = K.left, ge.start = K.top, ge.end = K.bottom), ge;
            }
            function n(K, ie, ge, Ne) {
              if (ie.localName !== "rt" && ie.localName !== "rtc") {
                var ee, Oe, Ge, Xe, Ce = ie.style.backgroundColor || Ne;
                if (ie.childElementCount === 0) if (ie.localName === "span" || ie.localName === "rb") {
                  var Ue = m(ie.getBoundingClientRect(), K);
                  if (ge.length !== 0 && (ee = Ue.before, Oe = Ue.after, Ge = ge[ge.length - 1].before, Oe < (Xe = ge[ge.length - 1].after) && ee > Ge || Xe <= Oe && Ge >= ee)) {
                    var Je = Math.sign(Ue.after - Ue.before), st = Math.sign(Ue.end - Ue.start);
                    Je * (Ue.before - ge[ge.length - 1].before) < 0 && (ge[ge.length - 1].before = Ue.before), Je * (Ue.after - ge[ge.length - 1].after) > 0 && (ge[ge.length - 1].after = Ue.after), st * (Ue.start - ge[ge.length - 1].start) < 0 && (ge[ge.length - 1].start = Ue.start, ge[ge.length - 1].start_elem = ge[ge.length - 1].elements.length), st * (Ue.end - ge[ge.length - 1].end) > 0 && (ge[ge.length - 1].end = Ue.end, ge[ge.length - 1].end_elem = ge[ge.length - 1].elements.length);
                  } else ge.push({ before: Ue.before, after: Ue.after, start: Ue.start, end: Ue.end, start_elem: 0, end_elem: 0, elements: [], rbc: [], te: [], text: "", br: !1 });
                  ge[ge.length - 1].text += ie.textContent, ge[ge.length - 1].elements.push({ node: ie, bgcolor: Ce, before: Ue.before, after: Ue.after });
                } else ie.localName === "br" && ge.length !== 0 && (ge[ge.length - 1].br = !0);
                else for (var we = ie.firstChild; we; ) we.nodeType === Node.ELEMENT_NODE && (n(K, we, ge, Ce), we.localName === "ruby" || we.localName === "rtc" ? ge.length > 0 && ge[ge.length - 1].rbc.push(we) : we.localName === "span" && we.style[P] && we.style[P] !== "none" && ge.length > 0 && ge[ge.length - 1].te.push(we)), we = we.nextSibling;
              }
            }
            function c(K, ie, ge, Ne) {
              var ee;
              Ne.style !== "none" && (Ne.style === "auto" ? ie.style[P] = "filled" : ie.style[P] = Ne.style + " " + Ne.symbol, (Ne.position === "before" || Ne.position === "after") && (ee = K.bpd === "tb" ? Ne.position === "before" ? "left over" : "left under" : K.bpd === "rl" ? Ne.position === "before" ? "right under" : "left under" : Ne.position === "before" ? "left under" : "right under", ie.style[Q] = ee));
            }
            function f(K, ie) {
              this.qname = K, this.map = ie;
            }
            E.render = function(K, ie, ge, Ne, ee, Oe, Ge, Xe, Ce) {
              var Ue = Ne || ie.clientHeight, Je = ee || ie.clientWidth;
              if (K.aspectRatio !== null) {
                var st = Ue * K.aspectRatio;
                st > Je ? Ue = Math.round(Je / K.aspectRatio) : Je = st;
              }
              var we = document.createElement("div");
              we.style.position = "relative", we.style.width = Je + "px", we.style.height = Ue + "px", we.style.margin = "auto", we.style.top = 0, we.style.bottom = 0, we.style.left = 0, we.style.right = 0, we.style.zIndex = 0;
              var Be = { h: Ue, w: Je, regionH: null, regionW: null, imgResolver: ge, displayForcedOnlyMode: Oe || !1, isd: K, errorHandler: Ge, previousISDState: Xe, enableRollUp: Ce || !1, currentISDState: {}, flg: null, lp: null, mra: null, ipd: null, bpd: null, ruby: null, textEmphasis: null, rubyReserve: null };
              if (ie.appendChild(we), "contents" in K) for (var At = 0; At < K.contents.length; At++) h(Be, we, K.contents[At], K);
              return Be.currentISDState;
            };
            for (var S = [new f("http://www.w3.org/ns/ttml#styling backgroundColor", function(K, ie, ge, Ne) {
              Ne[3] !== 0 && (ie.style.backgroundColor = "rgba(" + Ne[0].toString() + "," + Ne[1].toString() + "," + Ne[2].toString() + "," + (Ne[3] / 255).toString() + ")");
            }), new f("http://www.w3.org/ns/ttml#styling color", function(K, ie, ge, Ne) {
              ie.style.color = "rgba(" + Ne[0].toString() + "," + Ne[1].toString() + "," + Ne[2].toString() + "," + (Ne[3] / 255).toString() + ")";
            }), new f("http://www.w3.org/ns/ttml#styling direction", function(K, ie, ge, Ne) {
              ie.style.direction = Ne;
            }), new f("http://www.w3.org/ns/ttml#styling display", function(K, ie, ge, Ne) {
            }), new f("http://www.w3.org/ns/ttml#styling displayAlign", function(K, ie, ge, Ne) {
              ie.style.display = "flex", ie.style.flexDirection = "column", Ne === "before" ? ie.style.justifyContent = "flex-start" : Ne === "center" ? ie.style.justifyContent = "center" : Ne === "after" && (ie.style.justifyContent = "flex-end");
            }), new f("http://www.w3.org/ns/ttml#styling extent", function(K, ie, ge, Ne) {
              K.regionH = Ne.h.toUsedLength(K.w, K.h), K.regionW = Ne.w.toUsedLength(K.w, K.h);
              var ee = 0, Oe = 0, Ge = ge.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];
              Ge && (ee = Ge[0].toUsedLength(K.w, K.h) + Ge[2].toUsedLength(K.w, K.h), Oe = Ge[1].toUsedLength(K.w, K.h) + Ge[3].toUsedLength(K.w, K.h)), ie.style.height = K.regionH - ee + "px", ie.style.width = K.regionW - Oe + "px";
            }), new f("http://www.w3.org/ns/ttml#styling fontFamily", function(K, ie, ge, Ne) {
              for (var ee = [], Oe = 0; Oe < Ne.length; Oe++) Ne[Oe] = Ne[Oe].trim(), Ne[Oe] === "monospaceSerif" ? (ee.push("Courier New"), ee.push('"Liberation Mono"'), ee.push("Courier"), ee.push("monospace")) : Ne[Oe] === "proportionalSansSerif" ? (ee.push("Arial"), ee.push("Helvetica"), ee.push('"Liberation Sans"'), ee.push("sans-serif")) : Ne[Oe] === "monospace" ? ee.push("monospace") : Ne[Oe] === "sansSerif" ? ee.push("sans-serif") : Ne[Oe] === "serif" ? ee.push("serif") : Ne[Oe] === "monospaceSansSerif" ? (ee.push("Consolas"), ee.push("monospace")) : Ne[Oe] === "proportionalSerif" ? ee.push("serif") : ee.push(Ne[Oe]);
              if (ee.length > 0) {
                for (var Ge = [ee[0]], Xe = 1; Xe < ee.length; Xe++) Ge.indexOf(ee[Xe]) == -1 && Ge.push(ee[Xe]);
                ee = Ge;
              }
              ie.style.fontFamily = ee.join(",");
            }), new f("http://www.w3.org/ns/ttml#styling shear", function(K, ie, ge, Ne) {
              if (Ne !== 0) {
                var ee = -0.9 * Ne;
                K.bpd === "tb" ? ie.style.transform = "skewX(" + ee + "deg)" : ie.style.transform = "skewY(" + ee + "deg)";
              }
            }), new f("http://www.w3.org/ns/ttml#styling fontSize", function(K, ie, ge, Ne) {
              ie.style.fontSize = Ne.toUsedLength(K.w, K.h) + "px";
            }), new f("http://www.w3.org/ns/ttml#styling fontStyle", function(K, ie, ge, Ne) {
              ie.style.fontStyle = Ne;
            }), new f("http://www.w3.org/ns/ttml#styling fontWeight", function(K, ie, ge, Ne) {
              ie.style.fontWeight = Ne;
            }), new f("http://www.w3.org/ns/ttml#styling lineHeight", function(K, ie, ge, Ne) {
              ie.style.lineHeight = Ne === "normal" ? "normal" : Ne.toUsedLength(K.w, K.h) + "px";
            }), new f("http://www.w3.org/ns/ttml#styling opacity", function(K, ie, ge, Ne) {
              ie.style.opacity = Ne;
            }), new f("http://www.w3.org/ns/ttml#styling origin", function(K, ie, ge, Ne) {
              ie.style.top = Ne.h.toUsedLength(K.w, K.h) + "px", ie.style.left = Ne.w.toUsedLength(K.w, K.h) + "px";
            }), new f("http://www.w3.org/ns/ttml#styling overflow", function(K, ie, ge, Ne) {
              ie.style.overflow = Ne;
            }), new f("http://www.w3.org/ns/ttml#styling padding", function(K, ie, ge, Ne) {
              var ee = [];
              ee[0] = Ne[0].toUsedLength(K.w, K.h) + "px", ee[1] = Ne[3].toUsedLength(K.w, K.h) + "px", ee[2] = Ne[2].toUsedLength(K.w, K.h) + "px", ee[3] = Ne[1].toUsedLength(K.w, K.h) + "px", ie.style.padding = ee.join(" ");
            }), new f("http://www.w3.org/ns/ttml#styling position", function(K, ie, ge, Ne) {
              ie.style.top = Ne.h.toUsedLength(K.w, K.h) + "px", ie.style.left = Ne.w.toUsedLength(K.w, K.h) + "px";
            }), new f("http://www.w3.org/ns/ttml#styling rubyAlign", function(K, ie, ge, Ne) {
              ie.style.rubyAlign = Ne === "spaceAround" ? "space-around" : "center";
            }), new f("http://www.w3.org/ns/ttml#styling rubyPosition", function(K, ie, ge, Ne) {
              var ee;
              Ne !== "before" && Ne !== "after" || (ee = F ? Ne : K.bpd === "tb" || K.bpd === "rl" ? Ne === "before" ? "over" : "under" : Ne === "before" ? "under" : "over", ie.parentElement.style[te] = ee);
            }), new f("http://www.w3.org/ns/ttml#styling showBackground", null), new f("http://www.w3.org/ns/ttml#styling textAlign", function(K, ie, ge, Ne) {
              var ee;
              ee = Ne === "start" ? K.ipd === "rl" ? "right" : "left" : Ne === "end" ? K.ipd === "rl" ? "left" : "right" : Ne, ie.style.textAlign = ee;
            }), new f("http://www.w3.org/ns/ttml#styling textDecoration", function(K, ie, ge, Ne) {
              ie.style.textDecoration = Ne.join(" ").replace("lineThrough", "line-through");
            }), new f("http://www.w3.org/ns/ttml#styling textOutline", function(K, ie, ge, Ne) {
            }), new f("http://www.w3.org/ns/ttml#styling textShadow", function(K, ie, ge, Ne) {
              var ee = ge.styleAttrs[e.byName.textOutline.qname];
              if (Ne === "none" && ee === "none") ie.style.textShadow = "";
              else {
                var Oe = [];
                if (ee !== "none") {
                  var Ge = "rgba(" + ee.color[0].toString() + "," + ee.color[1].toString() + "," + ee.color[2].toString() + "," + (ee.color[3] / 255).toString() + ")";
                  Oe.push("1px 1px 1px " + Ge), Oe.push("-1px 1px 1px " + Ge), Oe.push("1px -1px 1px " + Ge), Oe.push("-1px -1px 1px " + Ge);
                }
                if (Ne !== "none") for (var Xe = 0; Xe < Ne.length; Xe++) Oe.push(Ne[Xe].x_off.toUsedLength(K.w, K.h) + "px " + Ne[Xe].y_off.toUsedLength(K.w, K.h) + "px " + Ne[Xe].b_radius.toUsedLength(K.w, K.h) + "px rgba(" + Ne[Xe].color[0].toString() + "," + Ne[Xe].color[1].toString() + "," + Ne[Xe].color[2].toString() + "," + (Ne[Xe].color[3] / 255).toString() + ")");
                ie.style.textShadow = Oe.join(",");
              }
            }), new f("http://www.w3.org/ns/ttml#styling textCombine", function(K, ie, ge, Ne) {
              ie.style.textCombineUpright = Ne;
            }), new f("http://www.w3.org/ns/ttml#styling textEmphasis", function(K, ie, ge, Ne) {
            }), new f("http://www.w3.org/ns/ttml#styling unicodeBidi", function(K, ie, ge, Ne) {
              var ee;
              ee = Ne === "bidiOverride" ? "bidi-override" : Ne, ie.style.unicodeBidi = ee;
            }), new f("http://www.w3.org/ns/ttml#styling visibility", function(K, ie, ge, Ne) {
              ie.style.visibility = Ne;
            }), new f("http://www.w3.org/ns/ttml#styling wrapOption", function(K, ie, ge, Ne) {
              Ne === "wrap" ? ge.space === "preserve" ? ie.style.whiteSpace = "pre-wrap" : ie.style.whiteSpace = "normal" : ge.space === "preserve" ? ie.style.whiteSpace = "pre" : ie.style.whiteSpace = "noWrap";
            }), new f("http://www.w3.org/ns/ttml#styling writingMode", function(K, ie, ge, Ne) {
              Ne === "lrtb" || Ne === "lr" || Ne === "rltb" || Ne === "rl" ? ie.style.writingMode = "horizontal-tb" : Ne === "tblr" ? ie.style.writingMode = "vertical-lr" : Ne !== "tbrl" && Ne !== "tb" || (ie.style.writingMode = "vertical-rl");
            }), new f("http://www.w3.org/ns/ttml#styling zIndex", function(K, ie, ge, Ne) {
              ie.style.zIndex = Ne;
            }), new f("http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay", function(K, ie, ge, Ne) {
              K.displayForcedOnlyMode && Ne === !1 && (ie.style.visibility = "hidden");
            })], k = {}, q = 0; q < S.length; q++) k[S[q].qname] = S[q];
            var F = "webkitRubyPosition" in window.getComputedStyle(document.documentElement), te = F ? "webkitRubyPosition" : "rubyPosition", P = "webkitTextEmphasisStyle" in window.getComputedStyle(document.documentElement) ? "webkitTextEmphasisStyle" : "textEmphasisStyle", Q = "webkitTextEmphasisPosition" in window.getComputedStyle(document.documentElement) ? "webkitTextEmphasisPosition" : "textEmphasisPosition";
            function se(K, ie) {
              if (K && K.error && K.error(ie)) throw ie;
            }
          })(fe, typeof imscNames > "u" ? R(210) : imscNames, typeof imscStyles > "u" ? R(6811) : imscStyles, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 4080: function(_e, fe, R) {
          (function(J, E, t, e) {
            J.generateISD = function(f, S, k) {
              var q, F = new m(f), te = {}, P = {}, Q = f.head.styling.initials[t.byName.showBackground.qname], se = f.head.styling.initials[t.byName.backgroundColor.qname];
              for (var K in f.head.layout.regions) if (f.head.layout.regions.hasOwnProperty(K)) {
                var ie = f.head.layout.regions[K], ge = ie.styleAttrs[t.byName.showBackground.qname] || Q, Ne = ie.styleAttrs[t.byName.backgroundColor.qname] || se;
                P[ie.id] = (ge === "always" || ge === void 0) && Ne !== void 0 && !(S < ie.begin || S >= ie.end);
              }
              for (var ee in f.body && f.body.regionID && (P[f.body.regionID] = !0), q = f.body !== null ? function Ge(Xe, Ce) {
                if (Ce.contents) {
                  var Ue = {};
                  for (var Je in Ce) Ce.hasOwnProperty(Je) && (Ue[Je] = Ce[Je]);
                  return Ue.contents = [], Ce.contents.filter(function(st) {
                    return !(Xe < st.begin || Xe >= st.end);
                  }).forEach(function(st) {
                    var we = Ge(Xe, st);
                    we.regionID && (P[we.regionID] = !0), we !== null && Ue.contents.push(we);
                  }), Ue;
                }
                return Ce;
              }(S, f.body) : null, P[""] !== void 0 && (P[""] = !0), P) if (P[ee]) {
                var Oe = p(f, S, f.head.layout.regions[ee], q, null, "", f.head.layout.regions[ee], k, te);
                Oe !== null && F.contents.push(Oe.element);
              }
              return F;
            };
            var h = [t.byName.color.qname, t.byName.textCombine.qname, t.byName.textDecoration.qname, t.byName.textEmphasis.qname, t.byName.textOutline.qname, t.byName.textShadow.qname];
            function p(f, S, k, q, F, te, P, Q, se) {
              if (S < P.begin || S >= P.end) return null;
              var K = "regionID" in P && P.regionID !== "" ? P.regionID : te;
              if (F !== null && K !== k.id && (!("contents" in P) || "contents" in P && P.contents.length === 0 || K !== "")) return null;
              var ie = new n(P);
              if ("sets" in P) for (var ge = 0; ge < P.sets.length; ge++) S < P.sets[ge].begin || S >= P.sets[ge].end || (ie.styleAttrs[P.sets[ge].qname] = P.sets[ge].value);
              var Ne = {};
              for (var ee in ie.styleAttrs) if (ie.styleAttrs.hasOwnProperty(ee) && (Ne[ee] = !0, ie.kind === "region" && ee === t.byName.writingMode.qname && !(t.byName.direction.qname in ie.styleAttrs))) {
                var Oe = ie.styleAttrs[ee];
                Oe === "lrtb" || Oe === "lr" ? ie.styleAttrs[t.byName.direction.qname] = "ltr" : Oe !== "rltb" && Oe !== "rl" || (ie.styleAttrs[t.byName.direction.qname] = "rtl");
              }
              if (F !== null) for (var Ge = 0; Ge < t.all.length; Ge++) {
                var Xe = t.all[Ge];
                if (Xe.qname === t.byName.textDecoration.qname) {
                  var Ce = F.styleAttrs[Xe.qname], Ue = ie.styleAttrs[Xe.qname], Je = [];
                  Ue === void 0 ? Je = Ce : Ue.indexOf("none") === -1 ? ((Ue.indexOf("noUnderline") === -1 && Ce.indexOf("underline") !== -1 || Ue.indexOf("underline") !== -1) && Je.push("underline"), (Ue.indexOf("noLineThrough") === -1 && Ce.indexOf("lineThrough") !== -1 || Ue.indexOf("lineThrough") !== -1) && Je.push("lineThrough"), (Ue.indexOf("noOverline") === -1 && Ce.indexOf("overline") !== -1 || Ue.indexOf("overline") !== -1) && Je.push("overline")) : Je.push("none"), ie.styleAttrs[Xe.qname] = Je;
                } else if (Xe.qname !== t.byName.fontSize.qname || Xe.qname in ie.styleAttrs || ie.kind !== "span" || ie.styleAttrs[t.byName.ruby.qname] !== "textContainer") if (Xe.qname !== t.byName.fontSize.qname || Xe.qname in ie.styleAttrs || ie.kind !== "span" || ie.styleAttrs[t.byName.ruby.qname] !== "text") Xe.inherit && Xe.qname in F.styleAttrs && !(Xe.qname in ie.styleAttrs) && (ie.styleAttrs[Xe.qname] = F.styleAttrs[Xe.qname]);
                else {
                  var st = F.styleAttrs[t.byName.fontSize.qname];
                  F.styleAttrs[t.byName.ruby.qname] === "textContainer" ? ie.styleAttrs[Xe.qname] = st : ie.styleAttrs[Xe.qname] = new e.ComputedLength(0.5 * st.rw, 0.5 * st.rh);
                }
                else {
                  var we = F.styleAttrs[t.byName.fontSize.qname];
                  ie.styleAttrs[Xe.qname] = new e.ComputedLength(0.5 * we.rw, 0.5 * we.rh);
                }
              }
              for (var Be = 0; Be < t.all.length; Be++) {
                var At = t.all[Be];
                if (!(At.qname in ie.styleAttrs) && !(At.qname === t.byName.position.qname && t.byName.origin.qname in ie.styleAttrs || At.qname === t.byName.origin.qname && t.byName.position.qname in ie.styleAttrs)) {
                  var ht = f.head.styling.initials[At.qname] || At.initial;
                  if (ht !== null && (ie.kind === "region" || At.inherit === !1 && ht !== null)) {
                    var je = At.parse(ht);
                    je !== null ? (ie.styleAttrs[At.qname] = je, Ne[At.qname] = !0) : c(Q, "Invalid initial value for '" + At.qname + "' on element '" + ie.kind);
                  }
                }
              }
              for (var it = 0; it < t.all.length; it++) {
                var ve = t.all[it];
                if (ve.qname in Ne && ve.compute !== null) {
                  var Se = ve.compute(f, F, ie, ie.styleAttrs[ve.qname], se);
                  Se !== null ? ie.styleAttrs[ve.qname] = Se : (ie.styleAttrs[ve.qname] = ve.compute(f, F, ie, ve.parse(ve.initial), se), c(Q, "Style '" + ve.qname + "' on element '" + ie.kind + "' cannot be computed"));
                }
              }
              if (ie.styleAttrs[t.byName.display.qname] === "none") return null;
              var Ye = null;
              F === null ? Ye = q === null ? [] : [q] : "contents" in P && (Ye = P.contents);
              for (var d = 0; Ye !== null && d < Ye.length; d++) {
                var l = p(f, S, k, q, ie, K, Ye[d], Q, se);
                l !== null && ie.contents.push(l.element);
              }
              for (var T in ie.styleAttrs) if (ie.styleAttrs.hasOwnProperty(T)) {
                var b = !1;
                if (ie.kind === "span") {
                  var $ = ie.styleAttrs[t.byName.ruby.qname];
                  (b = ($ === "container" || $ === "textContainer" || $ === "baseContainer") && h.indexOf(T) !== -1) || (b = $ !== "container" && T === t.byName.rubyAlign.qname), b || (b = !($ === "textContainer" || $ === "text") && T === t.byName.rubyPosition.qname);
                }
                if (!b) {
                  var W = t.byQName[T];
                  "applies" in W && (b = W.applies.indexOf(ie.kind) === -1);
                }
                b && delete ie.styleAttrs[T];
              }
              var Ie = ie.styleAttrs[t.byName.ruby.qname];
              if (ie.kind === "p" || ie.kind === "span" && (Ie === "textContainer" || Ie === "text")) {
                var $e = [];
                o(ie, $e), function(Ze) {
                  for (var xe, Me = 0; Me < Ze.length; ) if ((xe = Ze[Me]).kind !== "br" && xe.space !== "preserve") {
                    var Ve = xe.text.replace(/[\t\r\n ]+/g, " ");
                    /^[ ]/.test(Ve) && (Me === 0 || (ot = Ze[Me - 1]).kind === "br" || /[\r\n\t ]$/.test(ot.text)) && (Ve = Ve.substring(1)), xe.text = Ve, Ve.length === 0 ? Ze.splice(Me, 1) : Me++;
                  } else Me++;
                  var ot, bt;
                  for (Me = 0; Me < Ze.length; Me++) (xe = Ze[Me]).kind !== "br" && xe.space !== "preserve" ? /[ ]$/.test(xe.text) && (Me === Ze.length - 1 || (bt = Ze[Me + 1]).kind === "br" || bt.space === "preserve" && /^[\r\n]/.test(bt.text)) && (xe.text = xe.text.slice(0, -1)) : Me++;
                }($e), v(ie);
              }
              return ie.kind === "div" && t.byName.backgroundImage.qname in ie.styleAttrs || ie.kind === "br" || ie.kind === "image" || "contents" in ie && ie.contents.length > 0 || ie.kind === "span" && ie.text !== null || ie.kind === "region" && ie.styleAttrs[t.byName.showBackground.qname] === "always" ? { region_id: K, element: ie } : null;
            }
            function o(f, S) {
              if ("contents" in f) for (var k = 0; k < f.contents.length; k++) {
                var q = f.contents[k], F = q.styleAttrs[t.byName.ruby.qname];
                (q.kind !== "span" || F !== "textContainer" && F !== "text") && ("contents" in q ? o(q, S) : (q.kind === "span" && q.text.length !== 0 || q.kind === "br") && S.push(q));
              }
            }
            function v(f) {
              if (f.kind === "br") return !1;
              if ("text" in f) return f.text.length === 0;
              if ("contents" in f) {
                for (var S = f.contents.length; S--; ) v(f.contents[S]) && f.contents.splice(S, 1);
                return f.contents.length === 0;
              }
            }
            function m(f) {
              this.contents = [], this.aspectRatio = f.aspectRatio, this.lang = f.lang;
            }
            function n(f) {
              for (var S in this.kind = f.kind || "region", this.lang = f.lang, f.id && (this.id = f.id), this.styleAttrs = {}, f.styleAttrs) f.styleAttrs.hasOwnProperty(S) && (this.styleAttrs[S] = f.styleAttrs[S]);
              "src" in f && (this.src = f.src), "type" in f && (this.type = f.type), "text" in f ? this.text = f.text : (this.kind === "region" || "contents" in f) && (this.contents = []), "space" in f && (this.space = f.space);
            }
            function c(f, S) {
              if (f && f.error && f.error(S)) throw S;
            }
          })(fe, typeof imscNames > "u" ? R(210) : imscNames, typeof imscStyles > "u" ? R(6811) : imscStyles, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 4403: function(_e, fe, R) {
          fe.generateISD = R(4080).generateISD, fe.fromXML = R(3362).fromXML, fe.renderHTML = R(506).render;
        }, 210: function(_e, fe) {
          (function(R) {
            R.ns_tt = "http://www.w3.org/ns/ttml", R.ns_tts = "http://www.w3.org/ns/ttml#styling", R.ns_ttp = "http://www.w3.org/ns/ttml#parameter", R.ns_xml = "http://www.w3.org/XML/1998/namespace", R.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling", R.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter", R.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt", R.ns_ebutts = "urn:ebu:tt:style";
          })(fe);
        }, 6811: function(_e, fe, R) {
          (function(J, E, t) {
            function e(o, v, m, n, c, f, S, k) {
              this.name = v, this.ns = o, this.qname = o + " " + v, this.inherit = c, this.animatable = f, this.initial = m, this.applies = n, this.parse = S, this.compute = k;
            }
            for (var h in J.all = [new e(E.ns_tts, "backgroundColor", "transparent", ["body", "div", "p", "region", "span"], !1, !0, t.parseColor, null), new e(E.ns_tts, "color", "white", ["span"], !0, !0, t.parseColor, null), new e(E.ns_tts, "direction", "ltr", ["p", "span"], !0, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "display", "auto", ["body", "div", "p", "region", "span"], !1, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "displayAlign", "before", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "extent", "auto", ["tt", "region"], !1, !0, function(o) {
              if (o === "auto") return o;
              var v = o.split(" ");
              if (v.length !== 2) return null;
              var m = t.parseLength(v[0]), n = t.parseLength(v[1]);
              return n && m ? { h: n, w: m } : null;
            }, function(o, v, m, n, c) {
              var f, S;
              if (n === "auto") f = new t.ComputedLength(0, 1);
              else if ((f = t.toComputedLength(n.h.value, n.h.unit, null, o.dimensions.h, null, o.pxLength.h)) === null) return null;
              if (n === "auto") S = new t.ComputedLength(1, 0);
              else if ((S = t.toComputedLength(n.w.value, n.w.unit, null, o.dimensions.w, null, o.pxLength.w)) === null) return null;
              return { h: f, w: S };
            }), new e(E.ns_tts, "fontFamily", "default", ["span", "p"], !0, !0, function(o) {
              for (var v = o.split(","), m = [], n = 0; n < v.length; n++) v[n] = v[n].trim(), v[n].charAt(0) !== "'" && v[n].charAt(0) !== '"' && v[n] === "default" ? m.push("monospaceSerif") : m.push(v[n]);
              return m;
            }, null), new e(E.ns_tts, "shear", "0%", ["p"], !0, !0, t.parseLength, function(o, v, m, n) {
              return n.unit !== "%" ? null : Math.abs(n.value) > 100 ? 100 * Math.sign(n.value) : n.value;
            }), new e(E.ns_tts, "fontSize", "1c", ["span", "p"], !0, !0, t.parseLength, function(o, v, m, n, c) {
              return t.toComputedLength(n.value, n.unit, v !== null ? v.styleAttrs[J.byName.fontSize.qname] : o.cellLength.h, v !== null ? v.styleAttrs[J.byName.fontSize.qname] : o.cellLength.h, o.cellLength.h, o.pxLength.h);
            }), new e(E.ns_tts, "fontStyle", "normal", ["span", "p"], !0, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "fontWeight", "normal", ["span", "p"], !0, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "lineHeight", "normal", ["p"], !0, !0, function(o) {
              return o === "normal" ? o : t.parseLength(o);
            }, function(o, v, m, n, c) {
              var f;
              if (n === "normal") f = n;
              else if ((f = t.toComputedLength(n.value, n.unit, m.styleAttrs[J.byName.fontSize.qname], m.styleAttrs[J.byName.fontSize.qname], o.cellLength.h, o.pxLength.h)) === null) return null;
              return f;
            }), new e(E.ns_tts, "opacity", 1, ["region"], !1, !0, parseFloat, null), new e(E.ns_tts, "origin", "auto", ["region"], !1, !0, function(o) {
              if (o === "auto") return o;
              var v = o.split(" ");
              if (v.length !== 2) return null;
              var m = t.parseLength(v[0]), n = t.parseLength(v[1]);
              return n && m ? { h: n, w: m } : null;
            }, function(o, v, m, n, c) {
              var f, S;
              if (n === "auto") f = new t.ComputedLength(0, 0);
              else if ((f = t.toComputedLength(n.h.value, n.h.unit, null, o.dimensions.h, null, o.pxLength.h)) === null) return null;
              if (n === "auto") S = new t.ComputedLength(0, 0);
              else if ((S = t.toComputedLength(n.w.value, n.w.unit, null, o.dimensions.w, null, o.pxLength.w)) === null) return null;
              return { h: f, w: S };
            }), new e(E.ns_tts, "overflow", "hidden", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "padding", "0px", ["region"], !1, !0, function(o) {
              var v = o.split(" ");
              if (v.length > 4) return null;
              for (var m = [], n = 0; n < v.length; n++) {
                var c = t.parseLength(v[n]);
                if (!c) return null;
                m.push(c);
              }
              return m;
            }, function(o, v, m, n, c) {
              var f;
              if (n.length === 1) f = [n[0], n[0], n[0], n[0]];
              else if (n.length === 2) f = [n[0], n[1], n[0], n[1]];
              else if (n.length === 3) f = [n[0], n[1], n[2], n[1]];
              else {
                if (n.length !== 4) return null;
                f = [n[0], n[1], n[2], n[3]];
              }
              var S = m.styleAttrs[J.byName.writingMode.qname];
              if (S === "lrtb" || S === "lr") f = [f[0], f[3], f[2], f[1]];
              else if (S === "rltb" || S === "rl") f = [f[0], f[1], f[2], f[3]];
              else if (S === "tblr") f = [f[3], f[0], f[1], f[2]];
              else {
                if (S !== "tbrl" && S !== "tb") return null;
                f = [f[3], f[2], f[1], f[0]];
              }
              for (var k = [], q = 0; q < f.length; q++) if (f[q].value === 0) k[q] = new t.ComputedLength(0, 0);
              else if (k[q] = t.toComputedLength(f[q].value, f[q].unit, m.styleAttrs[J.byName.fontSize.qname], q === 0 || q === 2 ? m.styleAttrs[J.byName.extent.qname].h : m.styleAttrs[J.byName.extent.qname].w, q === 0 || q === 2 ? o.cellLength.h : o.cellLength.w, q === 0 || q === 2 ? o.pxLength.h : o.pxLength.w), k[q] === null) return null;
              return k;
            }), new e(E.ns_tts, "position", "top left", ["region"], !1, !0, function(o) {
              return t.parsePosition(o);
            }, function(o, v, m, n) {
              var c, f;
              return (c = t.toComputedLength(n.v.offset.value, n.v.offset.unit, null, new t.ComputedLength(-m.styleAttrs[J.byName.extent.qname].h.rw, o.dimensions.h.rh - m.styleAttrs[J.byName.extent.qname].h.rh), null, o.pxLength.h)) === null ? null : (n.v.edge === "bottom" && (c = new t.ComputedLength(-c.rw - m.styleAttrs[J.byName.extent.qname].h.rw, o.dimensions.h.rh - c.rh - m.styleAttrs[J.byName.extent.qname].h.rh)), f = t.toComputedLength(n.h.offset.value, n.h.offset.unit, null, new t.ComputedLength(o.dimensions.w.rw - m.styleAttrs[J.byName.extent.qname].w.rw, -m.styleAttrs[J.byName.extent.qname].w.rh), null, o.pxLength.w), c === null ? null : (n.h.edge === "right" && (f = new t.ComputedLength(o.dimensions.w.rw - f.rw - m.styleAttrs[J.byName.extent.qname].w.rw, -f.rh - m.styleAttrs[J.byName.extent.qname].w.rh)), { h: c, w: f }));
            }), new e(E.ns_tts, "ruby", "none", ["span"], !1, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "rubyAlign", "center", ["span"], !0, !0, function(o) {
              return o !== "center" && o !== "spaceAround" ? null : o;
            }, null), new e(E.ns_tts, "rubyPosition", "outside", ["span"], !0, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "rubyReserve", "none", ["p"], !0, !0, function(o) {
              var v = o.split(" "), m = [null, null];
              if (v.length === 0 || v.length > 2 || v[0] !== "none" && v[0] !== "both" && v[0] !== "after" && v[0] !== "before" && v[0] !== "outside") return null;
              if (m[0] = v[0], v.length === 2 && v[0] !== "none") {
                var n = t.parseLength(v[1]);
                if (!n) return null;
                m[1] = n;
              }
              return m;
            }, function(o, v, m, n, c) {
              if (n[0] === "none") return n;
              var f;
              return (f = n[1] === null ? new t.ComputedLength(0.5 * m.styleAttrs[J.byName.fontSize.qname].rw, 0.5 * m.styleAttrs[J.byName.fontSize.qname].rh) : t.toComputedLength(n[1].value, n[1].unit, m.styleAttrs[J.byName.fontSize.qname], m.styleAttrs[J.byName.fontSize.qname], o.cellLength.h, o.pxLength.h)) === null ? null : [n[0], f];
            }), new e(E.ns_tts, "showBackground", "always", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "textAlign", "start", ["p"], !0, !0, function(o) {
              return o;
            }, function(o, v, m, n, c) {
              return n === "left" ? "start" : n === "right" ? "end" : n;
            }), new e(E.ns_tts, "textCombine", "none", ["span"], !0, !0, function(o) {
              return o === "none" || o === "all" ? o : null;
            }, null), new e(E.ns_tts, "textDecoration", "none", ["span"], !0, !0, function(o) {
              return o.split(" ");
            }, null), new e(E.ns_tts, "textEmphasis", "none", ["span"], !0, !0, function(o) {
              for (var v = o.split(" "), m = { style: null, symbol: null, color: null, position: null }, n = 0; n < v.length; n++) if (v[n] === "none" || v[n] === "auto") m.style = v[n];
              else if (v[n] === "filled" || v[n] === "open") m.style = v[n];
              else if (v[n] === "circle" || v[n] === "dot" || v[n] === "sesame") m.symbol = v[n];
              else if (v[n] === "current") m.color = v[n];
              else if (v[n] === "outside" || v[n] === "before" || v[n] === "after") m.position = v[n];
              else if (m.color = t.parseColor(v[n]), m.color === null) return null;
              return m.style == null && m.symbol == null ? m.style = "auto" : (m.symbol = m.symbol || "circle", m.style = m.style || "filled"), m.position = m.position || "outside", m.color = m.color || "current", m;
            }, null), new e(E.ns_tts, "textOutline", "none", ["span"], !0, !0, function(o) {
              if (o === "none") return o;
              var v = {}, m = o.split(" ");
              if (m.length === 0 || m.length > 2) return null;
              var n = t.parseColor(m[0]);
              if (v.color = n, n !== null && m.shift(), m.length !== 1) return null;
              var c = t.parseLength(m[0]);
              return c ? (v.thickness = c, v) : null;
            }, function(o, v, m, n, c) {
              if (n === "none") return n;
              var f = {};
              return n.color === null ? f.color = m.styleAttrs[J.byName.color.qname] : f.color = n.color, f.thickness = t.toComputedLength(n.thickness.value, n.thickness.unit, m.styleAttrs[J.byName.fontSize.qname], m.styleAttrs[J.byName.fontSize.qname], o.cellLength.h, o.pxLength.h), f.thickness === null ? null : f;
            }), new e(E.ns_tts, "textShadow", "none", ["span"], !0, !0, t.parseTextShadow, function(o, v, m, n) {
              if (n === "none") return n;
              for (var c = [], f = 0; f < n.length; f++) {
                var S = {};
                if (S.x_off = t.toComputedLength(n[f][0].value, n[f][0].unit, null, m.styleAttrs[J.byName.fontSize.qname], null, o.pxLength.w), S.x_off === null || (S.y_off = t.toComputedLength(n[f][1].value, n[f][1].unit, null, m.styleAttrs[J.byName.fontSize.qname], null, o.pxLength.h), S.y_off === null)) return null;
                if (n[f][2] === null) S.b_radius = 0;
                else if (S.b_radius = t.toComputedLength(n[f][2].value, n[f][2].unit, null, m.styleAttrs[J.byName.fontSize.qname], null, o.pxLength.h), S.b_radius === null) return null;
                n[f][3] === null ? S.color = m.styleAttrs[J.byName.color.qname] : S.color = n[f][3], c.push(S);
              }
              return c;
            }), new e(E.ns_tts, "unicodeBidi", "normal", ["span", "p"], !1, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "visibility", "visible", ["body", "div", "p", "region", "span"], !0, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "wrapOption", "wrap", ["span"], !0, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "writingMode", "lrtb", ["region"], !1, !0, function(o) {
              return o;
            }, null), new e(E.ns_tts, "zIndex", "auto", ["region"], !1, !0, function(o) {
              var v;
              return o === "auto" ? v = o : (v = parseInt(o), isNaN(v) && (v = null)), v;
            }, null), new e(E.ns_ebutts, "linePadding", "0c", ["p"], !0, !1, t.parseLength, function(o, v, m, n, c) {
              return t.toComputedLength(n.value, n.unit, null, null, o.cellLength.w, null);
            }), new e(E.ns_ebutts, "multiRowAlign", "auto", ["p"], !0, !1, function(o) {
              return o;
            }, null), new e(E.ns_smpte, "backgroundImage", null, ["div"], !1, !1, function(o) {
              return o;
            }, null), new e(E.ns_itts, "forcedDisplay", "false", ["body", "div", "p", "region", "span"], !0, !0, function(o) {
              return o === "true";
            }, null), new e(E.ns_itts, "fillLineGap", "false", ["p"], !0, !0, function(o) {
              return o === "true";
            }, null)], J.byQName = {}, J.all) J.byQName[J.all[h].qname] = J.all[h];
            for (var p in J.byName = {}, J.all) J.byName[J.all[p].name] = J.all[p];
          })(fe, typeof imscNames > "u" ? R(210) : imscNames, typeof imscUtils > "u" ? R(5926) : imscUtils);
        }, 5926: function(_e, fe) {
          (function(R) {
            var J = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/, E = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, t = /rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, e = { transparent: [0, 0, 0, 0], black: [0, 0, 0, 255], silver: [192, 192, 192, 255], gray: [128, 128, 128, 255], white: [255, 255, 255, 255], maroon: [128, 0, 0, 255], red: [255, 0, 0, 255], purple: [128, 0, 128, 255], fuchsia: [255, 0, 255, 255], magenta: [255, 0, 255, 255], green: [0, 128, 0, 255], lime: [0, 255, 0, 255], olive: [128, 128, 0, 255], yellow: [255, 255, 0, 255], navy: [0, 0, 128, 255], blue: [0, 0, 255, 255], teal: [0, 128, 128, 255], aqua: [0, 255, 255, 255], cyan: [0, 255, 255, 255] };
            R.parseColor = function(p) {
              var o, v = null, m = e[p.toLowerCase()];
              return m !== void 0 ? v = m : (o = J.exec(p)) !== null ? v = [parseInt(o[1], 16), parseInt(o[2], 16), parseInt(o[3], 16), o[4] !== void 0 ? parseInt(o[4], 16) : 255] : (o = E.exec(p)) !== null ? v = [parseInt(o[1]), parseInt(o[2]), parseInt(o[3]), 255] : (o = t.exec(p)) !== null && (v = [parseInt(o[1]), parseInt(o[2]), parseInt(o[3]), parseInt(o[4])]), v;
            };
            var h = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%|rh|rw)$/;
            R.parseLength = function(p) {
              var o, v = null;
              return (o = h.exec(p)) !== null && (v = { value: parseFloat(o[1]), unit: o[2] }), v;
            }, R.parseTextShadow = function(p) {
              for (var o = p.match(/([^\(,\)]|\([^\)]+\))+/g), v = [], m = 0; m < o.length; m++) {
                var n = o[m].split(" ");
                if (n.length === 1 && n[0] === "none") return "none";
                if (n.length > 1 && n.length < 5) {
                  var c = [null, null, null, null], f = R.parseLength(n.shift());
                  if (f === null || (c[0] = f, (f = R.parseLength(n.shift())) === null)) return null;
                  if (c[1] = f, n.length === 0) {
                    v.push(c);
                    continue;
                  }
                  if ((f = R.parseLength(n[0])) !== null && (c[2] = f, n.shift()), n.length === 0) {
                    v.push(c);
                    continue;
                  }
                  var S = R.parseColor(n[0]);
                  if (S === null) return null;
                  c[3] = S, v.push(c);
                }
              }
              return v;
            }, R.parsePosition = function(p) {
              var o = p.split(" "), v = function(q) {
                return q === "center" || q === "left" || q === "top" || q === "bottom" || q === "right";
              };
              if (o.length > 4) return null;
              for (var m = 0; m < o.length; m++) if (!v(o[m])) {
                var n = R.parseLength(o[m]);
                if (n === null) return null;
                o[m] = n;
              }
              for (var c = { h: { edge: "left", offset: { value: 50, unit: "%" } }, v: { edge: "top", offset: { value: 50, unit: "%" } } }, f = 0; f < o.length; ) {
                var S = o[f++];
                if (v(S)) {
                  var k = { value: 0, unit: "%" };
                  o.length !== 2 && f < o.length && !v(o[f]) && (k = o[f++]), S === "right" ? (c.h.edge = S, c.h.offset = k) : S === "bottom" ? (c.v.edge = S, c.v.offset = k) : S === "left" ? c.h.offset = k : S === "top" && (c.v.offset = k);
                } else {
                  if (o.length !== 1 && o.length !== 2) return null;
                  f === 1 ? c.h.offset = S : c.v.offset = S;
                }
              }
              return c;
            }, R.ComputedLength = function(p, o) {
              this.rw = p, this.rh = o;
            }, R.ComputedLength.prototype.toUsedLength = function(p, o) {
              return p * this.rw + o * this.rh;
            }, R.ComputedLength.prototype.isZero = function() {
              return this.rw === 0 && this.rh === 0;
            }, R.toComputedLength = function(p, o, v, m, n, c) {
              return o === "%" && m ? new R.ComputedLength(m.rw * p / 100, m.rh * p / 100) : o === "em" && v ? new R.ComputedLength(v.rw * p, v.rh * p) : o === "c" && n ? new R.ComputedLength(p * n.rw, p * n.rh) : o === "px" && c ? new R.ComputedLength(p * c.rw, p * c.rh) : o === "rh" ? new R.ComputedLength(0, p / 100) : o === "rw" ? new R.ComputedLength(p / 100, 0) : null;
            };
          })(fe);
        }, 3516: function(_e) {
          _e.exports = function(fe) {
            var R = typeof fe == "string" ? fe.charCodeAt(0) : fe;
            return R >= 97 && R <= 122 || R >= 65 && R <= 90;
          };
        }, 2219: function(_e, fe, R) {
          var J = R(3516), E = R(395);
          _e.exports = function(t) {
            return J(t) || E(t);
          };
        }, 395: function(_e) {
          _e.exports = function(fe) {
            var R = typeof fe == "string" ? fe.charCodeAt(0) : fe;
            return R >= 48 && R <= 57;
          };
        }, 3875: function(_e) {
          function fe(E) {
            if (typeof E != "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(E));
          }
          function R(E, t) {
            for (var e, h = "", p = 0, o = -1, v = 0, m = 0; m <= E.length; ++m) {
              if (m < E.length) e = E.charCodeAt(m);
              else {
                if (e === 47) break;
                e = 47;
              }
              if (e === 47) {
                if (!(o === m - 1 || v === 1)) if (o !== m - 1 && v === 2) {
                  if (h.length < 2 || p !== 2 || h.charCodeAt(h.length - 1) !== 46 || h.charCodeAt(h.length - 2) !== 46) {
                    if (h.length > 2) {
                      var n = h.lastIndexOf("/");
                      if (n !== h.length - 1) {
                        n === -1 ? (h = "", p = 0) : p = (h = h.slice(0, n)).length - 1 - h.lastIndexOf("/"), o = m, v = 0;
                        continue;
                      }
                    } else if (h.length === 2 || h.length === 1) {
                      h = "", p = 0, o = m, v = 0;
                      continue;
                    }
                  }
                  t && (h.length > 0 ? h += "/.." : h = "..", p = 2);
                } else h.length > 0 ? h += "/" + E.slice(o + 1, m) : h = E.slice(o + 1, m), p = m - o - 1;
                o = m, v = 0;
              } else e === 46 && v !== -1 ? ++v : v = -1;
            }
            return h;
          }
          var J = { resolve: function() {
            for (var E, t = "", e = !1, h = arguments.length - 1; h >= -1 && !e; h--) {
              var p;
              h >= 0 ? p = arguments[h] : (E === void 0 && (E = process.cwd()), p = E), fe(p), p.length !== 0 && (t = p + "/" + t, e = p.charCodeAt(0) === 47);
            }
            return t = R(t, !e), e ? t.length > 0 ? "/" + t : "/" : t.length > 0 ? t : ".";
          }, normalize: function(E) {
            if (fe(E), E.length === 0) return ".";
            var t = E.charCodeAt(0) === 47, e = E.charCodeAt(E.length - 1) === 47;
            return (E = R(E, !t)).length !== 0 || t || (E = "."), E.length > 0 && e && (E += "/"), t ? "/" + E : E;
          }, isAbsolute: function(E) {
            return fe(E), E.length > 0 && E.charCodeAt(0) === 47;
          }, join: function() {
            if (arguments.length === 0) return ".";
            for (var E, t = 0; t < arguments.length; ++t) {
              var e = arguments[t];
              fe(e), e.length > 0 && (E === void 0 ? E = e : E += "/" + e);
            }
            return E === void 0 ? "." : J.normalize(E);
          }, relative: function(E, t) {
            if (fe(E), fe(t), E === t || (E = J.resolve(E)) === (t = J.resolve(t))) return "";
            for (var e = 1; e < E.length && E.charCodeAt(e) === 47; ++e) ;
            for (var h = E.length, p = h - e, o = 1; o < t.length && t.charCodeAt(o) === 47; ++o) ;
            for (var v = t.length - o, m = p < v ? p : v, n = -1, c = 0; c <= m; ++c) {
              if (c === m) {
                if (v > m) {
                  if (t.charCodeAt(o + c) === 47) return t.slice(o + c + 1);
                  if (c === 0) return t.slice(o + c);
                } else p > m && (E.charCodeAt(e + c) === 47 ? n = c : c === 0 && (n = 0));
                break;
              }
              var f = E.charCodeAt(e + c);
              if (f !== t.charCodeAt(o + c)) break;
              f === 47 && (n = c);
            }
            var S = "";
            for (c = e + n + 1; c <= h; ++c) c !== h && E.charCodeAt(c) !== 47 || (S.length === 0 ? S += ".." : S += "/..");
            return S.length > 0 ? S + t.slice(o + n) : (o += n, t.charCodeAt(o) === 47 && ++o, t.slice(o));
          }, _makeLong: function(E) {
            return E;
          }, dirname: function(E) {
            if (fe(E), E.length === 0) return ".";
            for (var t = E.charCodeAt(0), e = t === 47, h = -1, p = !0, o = E.length - 1; o >= 1; --o) if ((t = E.charCodeAt(o)) === 47) {
              if (!p) {
                h = o;
                break;
              }
            } else p = !1;
            return h === -1 ? e ? "/" : "." : e && h === 1 ? "//" : E.slice(0, h);
          }, basename: function(E, t) {
            if (t !== void 0 && typeof t != "string") throw new TypeError('"ext" argument must be a string');
            fe(E);
            var e, h = 0, p = -1, o = !0;
            if (t !== void 0 && t.length > 0 && t.length <= E.length) {
              if (t.length === E.length && t === E) return "";
              var v = t.length - 1, m = -1;
              for (e = E.length - 1; e >= 0; --e) {
                var n = E.charCodeAt(e);
                if (n === 47) {
                  if (!o) {
                    h = e + 1;
                    break;
                  }
                } else m === -1 && (o = !1, m = e + 1), v >= 0 && (n === t.charCodeAt(v) ? --v == -1 && (p = e) : (v = -1, p = m));
              }
              return h === p ? p = m : p === -1 && (p = E.length), E.slice(h, p);
            }
            for (e = E.length - 1; e >= 0; --e) if (E.charCodeAt(e) === 47) {
              if (!o) {
                h = e + 1;
                break;
              }
            } else p === -1 && (o = !1, p = e + 1);
            return p === -1 ? "" : E.slice(h, p);
          }, extname: function(E) {
            fe(E);
            for (var t = -1, e = 0, h = -1, p = !0, o = 0, v = E.length - 1; v >= 0; --v) {
              var m = E.charCodeAt(v);
              if (m !== 47) h === -1 && (p = !1, h = v + 1), m === 46 ? t === -1 ? t = v : o !== 1 && (o = 1) : t !== -1 && (o = -1);
              else if (!p) {
                e = v + 1;
                break;
              }
            }
            return t === -1 || h === -1 || o === 0 || o === 1 && t === h - 1 && t === e + 1 ? "" : E.slice(t, h);
          }, format: function(E) {
            if (E === null || typeof E != "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof E);
            return function(t, e) {
              var h = e.dir || e.root, p = e.base || (e.name || "") + (e.ext || "");
              return h ? h === e.root ? h + p : h + "/" + p : p;
            }(0, E);
          }, parse: function(E) {
            fe(E);
            var t = { root: "", dir: "", base: "", ext: "", name: "" };
            if (E.length === 0) return t;
            var e, h = E.charCodeAt(0), p = h === 47;
            p ? (t.root = "/", e = 1) : e = 0;
            for (var o = -1, v = 0, m = -1, n = !0, c = E.length - 1, f = 0; c >= e; --c) if ((h = E.charCodeAt(c)) !== 47) m === -1 && (n = !1, m = c + 1), h === 46 ? o === -1 ? o = c : f !== 1 && (f = 1) : o !== -1 && (f = -1);
            else if (!n) {
              v = c + 1;
              break;
            }
            return o === -1 || m === -1 || f === 0 || f === 1 && o === m - 1 && o === v + 1 ? m !== -1 && (t.base = t.name = v === 0 && p ? E.slice(1, m) : E.slice(v, m)) : (v === 0 && p ? (t.name = E.slice(1, o), t.base = E.slice(1, m)) : (t.name = E.slice(v, o), t.base = E.slice(v, m)), t.ext = E.slice(o, m)), v > 0 ? t.dir = E.slice(0, v - 1) : p && (t.dir = "/"), t;
          }, sep: "/", delimiter: ":", win32: null, posix: null };
          J.posix = J, _e.exports = J;
        }, 8387: function(_e, fe, R) {
          var J = R(1549), E = J.Buffer;
          function t(h, p) {
            for (var o in h) p[o] = h[o];
          }
          function e(h, p, o) {
            return E(h, p, o);
          }
          E.from && E.alloc && E.allocUnsafe && E.allocUnsafeSlow ? _e.exports = J : (t(J, fe), fe.Buffer = e), t(E, e), e.from = function(h, p, o) {
            if (typeof h == "number") throw new TypeError("Argument must not be a number");
            return E(h, p, o);
          }, e.alloc = function(h, p, o) {
            if (typeof h != "number") throw new TypeError("Argument must be a number");
            var v = E(h);
            return p !== void 0 ? typeof o == "string" ? v.fill(p, o) : v.fill(p) : v.fill(0), v;
          }, e.allocUnsafe = function(h) {
            if (typeof h != "number") throw new TypeError("Argument must be a number");
            return E(h);
          }, e.allocUnsafeSlow = function(h) {
            if (typeof h != "number") throw new TypeError("Argument must be a number");
            return J.SlowBuffer(h);
          };
        }, 5378: function(_e, fe, R) {
          (function(J) {
            J.parser = function(d, l) {
              return new e(d, l);
            }, J.SAXParser = e, J.SAXStream = p, J.createStream = function(d, l) {
              return new p(d, l);
            }, J.MAX_BUFFER_LENGTH = 65536;
            var E, t = ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"];
            function e(d, l) {
              if (!(this instanceof e)) return new e(d, l);
              var T = this;
              (function(b) {
                for (var $ = 0, W = t.length; $ < W; $++) b[t[$]] = "";
              })(T), T.q = T.c = "", T.bufferCheckPosition = J.MAX_BUFFER_LENGTH, T.opt = l || {}, T.opt.lowercase = T.opt.lowercase || T.opt.lowercasetags, T.looseCase = T.opt.lowercase ? "toLowerCase" : "toUpperCase", T.tags = [], T.closed = T.closedRoot = T.sawRoot = !1, T.tag = T.error = null, T.strict = !!d, T.noscript = !(!d && !T.opt.noscript), T.state = ee.BEGIN, T.strictEntities = T.opt.strictEntities, T.ENTITIES = T.strictEntities ? Object.create(J.XML_ENTITIES) : Object.create(J.ENTITIES), T.attribList = [], T.opt.xmlns && (T.ns = Object.create(k)), T.trackPosition = T.opt.position !== !1, T.trackPosition && (T.position = T.line = T.column = 0), Ge(T, "onready");
            }
            J.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function(d) {
              function l() {
              }
              return l.prototype = d, new l();
            }), Object.keys || (Object.keys = function(d) {
              var l = [];
              for (var T in d) d.hasOwnProperty(T) && l.push(T);
              return l;
            }), e.prototype = { end: function() {
              st(this);
            }, write: function(d) {
              var l = this;
              if (this.error) throw this.error;
              if (l.closed) return Je(l, "Cannot write after close. Assign an onready handler.");
              if (d === null) return st(l);
              typeof d == "object" && (d = d.toString());
              for (var T = 0, b = ""; b = Ye(d, T++), l.c = b, b; ) switch (l.trackPosition && (l.position++, b === `
` ? (l.line++, l.column = 0) : l.column++), l.state) {
                case ee.BEGIN:
                  if (l.state = ee.BEGIN_WHITESPACE, b === "\uFEFF") continue;
                  Se(l, b);
                  continue;
                case ee.BEGIN_WHITESPACE:
                  Se(l, b);
                  continue;
                case ee.TEXT:
                  if (l.sawRoot && !l.closedRoot) {
                    for (var $ = T - 1; b && b !== "<" && b !== "&"; ) (b = Ye(d, T++)) && l.trackPosition && (l.position++, b === `
` ? (l.line++, l.column = 0) : l.column++);
                    l.textNode += d.substring($, T - 1);
                  }
                  b !== "<" || l.sawRoot && l.closedRoot && !l.strict ? (!K(o, b) || l.sawRoot && !l.closedRoot || we(l, "Text data outside of root node."), b === "&" ? l.state = ee.TEXT_ENTITY : l.textNode += b) : (l.state = ee.OPEN_WAKA, l.startTagPosition = l.position);
                  continue;
                case ee.SCRIPT:
                  b === "<" ? l.state = ee.SCRIPT_ENDING : l.script += b;
                  continue;
                case ee.SCRIPT_ENDING:
                  b === "/" ? l.state = ee.CLOSE_TAG : (l.script += "<" + b, l.state = ee.SCRIPT);
                  continue;
                case ee.OPEN_WAKA:
                  if (b === "!") l.state = ee.SGML_DECL, l.sgmlDecl = "";
                  else if (!se(o, b)) if (se(q, b)) l.state = ee.OPEN_TAG, l.tagName = b;
                  else if (b === "/") l.state = ee.CLOSE_TAG, l.tagName = "";
                  else if (b === "?") l.state = ee.PROC_INST, l.procInstName = l.procInstBody = "";
                  else {
                    if (we(l, "Unencoded <"), l.startTagPosition + 1 < l.position) {
                      var W = l.position - l.startTagPosition;
                      b = new Array(W).join(" ") + b;
                    }
                    l.textNode += "<" + b, l.state = ee.TEXT;
                  }
                  continue;
                case ee.SGML_DECL:
                  (l.sgmlDecl + b).toUpperCase() === "[CDATA[" ? (Xe(l, "onopencdata"), l.state = ee.CDATA, l.sgmlDecl = "", l.cdata = "") : l.sgmlDecl + b === "--" ? (l.state = ee.COMMENT, l.comment = "", l.sgmlDecl = "") : (l.sgmlDecl + b).toUpperCase() === "DOCTYPE" ? (l.state = ee.DOCTYPE, (l.doctype || l.sawRoot) && we(l, "Inappropriately located doctype declaration"), l.doctype = "", l.sgmlDecl = "") : b === ">" ? (Xe(l, "onsgmldeclaration", l.sgmlDecl), l.sgmlDecl = "", l.state = ee.TEXT) : (se(n, b) && (l.state = ee.SGML_DECL_QUOTED), l.sgmlDecl += b);
                  continue;
                case ee.SGML_DECL_QUOTED:
                  b === l.q && (l.state = ee.SGML_DECL, l.q = ""), l.sgmlDecl += b;
                  continue;
                case ee.DOCTYPE:
                  b === ">" ? (l.state = ee.TEXT, Xe(l, "ondoctype", l.doctype), l.doctype = !0) : (l.doctype += b, b === "[" ? l.state = ee.DOCTYPE_DTD : se(n, b) && (l.state = ee.DOCTYPE_QUOTED, l.q = b));
                  continue;
                case ee.DOCTYPE_QUOTED:
                  l.doctype += b, b === l.q && (l.q = "", l.state = ee.DOCTYPE);
                  continue;
                case ee.DOCTYPE_DTD:
                  l.doctype += b, b === "]" ? l.state = ee.DOCTYPE : se(n, b) && (l.state = ee.DOCTYPE_DTD_QUOTED, l.q = b);
                  continue;
                case ee.DOCTYPE_DTD_QUOTED:
                  l.doctype += b, b === l.q && (l.state = ee.DOCTYPE_DTD, l.q = "");
                  continue;
                case ee.COMMENT:
                  b === "-" ? l.state = ee.COMMENT_ENDING : l.comment += b;
                  continue;
                case ee.COMMENT_ENDING:
                  b === "-" ? (l.state = ee.COMMENT_ENDED, l.comment = Ue(l.opt, l.comment), l.comment && Xe(l, "oncomment", l.comment), l.comment = "") : (l.comment += "-" + b, l.state = ee.COMMENT);
                  continue;
                case ee.COMMENT_ENDED:
                  b !== ">" ? (we(l, "Malformed comment"), l.comment += "--" + b, l.state = ee.COMMENT) : l.state = ee.TEXT;
                  continue;
                case ee.CDATA:
                  b === "]" ? l.state = ee.CDATA_ENDING : l.cdata += b;
                  continue;
                case ee.CDATA_ENDING:
                  b === "]" ? l.state = ee.CDATA_ENDING_2 : (l.cdata += "]" + b, l.state = ee.CDATA);
                  continue;
                case ee.CDATA_ENDING_2:
                  b === ">" ? (l.cdata && Xe(l, "oncdata", l.cdata), Xe(l, "onclosecdata"), l.cdata = "", l.state = ee.TEXT) : b === "]" ? l.cdata += "]" : (l.cdata += "]]" + b, l.state = ee.CDATA);
                  continue;
                case ee.PROC_INST:
                  b === "?" ? l.state = ee.PROC_INST_ENDING : se(o, b) ? l.state = ee.PROC_INST_BODY : l.procInstName += b;
                  continue;
                case ee.PROC_INST_BODY:
                  if (!l.procInstBody && se(o, b)) continue;
                  b === "?" ? l.state = ee.PROC_INST_ENDING : l.procInstBody += b;
                  continue;
                case ee.PROC_INST_ENDING:
                  b === ">" ? (Xe(l, "onprocessinginstruction", { name: l.procInstName, body: l.procInstBody }), l.procInstName = l.procInstBody = "", l.state = ee.TEXT) : (l.procInstBody += "?" + b, l.state = ee.PROC_INST_BODY);
                  continue;
                case ee.OPEN_TAG:
                  se(F, b) ? l.tagName += b : (Be(l), b === ">" ? je(l) : b === "/" ? l.state = ee.OPEN_TAG_SLASH : (K(o, b) && we(l, "Invalid character in tag name"), l.state = ee.ATTRIB));
                  continue;
                case ee.OPEN_TAG_SLASH:
                  b === ">" ? (je(l, !0), it(l)) : (we(l, "Forward-slash in opening tag not followed by >"), l.state = ee.ATTRIB);
                  continue;
                case ee.ATTRIB:
                  if (se(o, b)) continue;
                  b === ">" ? je(l) : b === "/" ? l.state = ee.OPEN_TAG_SLASH : se(q, b) ? (l.attribName = b, l.attribValue = "", l.state = ee.ATTRIB_NAME) : we(l, "Invalid attribute name");
                  continue;
                case ee.ATTRIB_NAME:
                  b === "=" ? l.state = ee.ATTRIB_VALUE : b === ">" ? (we(l, "Attribute without value"), l.attribValue = l.attribName, ht(l), je(l)) : se(o, b) ? l.state = ee.ATTRIB_NAME_SAW_WHITE : se(F, b) ? l.attribName += b : we(l, "Invalid attribute name");
                  continue;
                case ee.ATTRIB_NAME_SAW_WHITE:
                  if (b === "=") l.state = ee.ATTRIB_VALUE;
                  else {
                    if (se(o, b)) continue;
                    we(l, "Attribute without value"), l.tag.attributes[l.attribName] = "", l.attribValue = "", Xe(l, "onattribute", { name: l.attribName, value: "" }), l.attribName = "", b === ">" ? je(l) : se(q, b) ? (l.attribName = b, l.state = ee.ATTRIB_NAME) : (we(l, "Invalid attribute name"), l.state = ee.ATTRIB);
                  }
                  continue;
                case ee.ATTRIB_VALUE:
                  if (se(o, b)) continue;
                  se(n, b) ? (l.q = b, l.state = ee.ATTRIB_VALUE_QUOTED) : (we(l, "Unquoted attribute value"), l.state = ee.ATTRIB_VALUE_UNQUOTED, l.attribValue = b);
                  continue;
                case ee.ATTRIB_VALUE_QUOTED:
                  if (b !== l.q) {
                    b === "&" ? l.state = ee.ATTRIB_VALUE_ENTITY_Q : l.attribValue += b;
                    continue;
                  }
                  ht(l), l.q = "", l.state = ee.ATTRIB_VALUE_CLOSED;
                  continue;
                case ee.ATTRIB_VALUE_CLOSED:
                  se(o, b) ? l.state = ee.ATTRIB : b === ">" ? je(l) : b === "/" ? l.state = ee.OPEN_TAG_SLASH : se(q, b) ? (we(l, "No whitespace between attributes"), l.attribName = b, l.attribValue = "", l.state = ee.ATTRIB_NAME) : we(l, "Invalid attribute name");
                  continue;
                case ee.ATTRIB_VALUE_UNQUOTED:
                  if (K(c, b)) {
                    b === "&" ? l.state = ee.ATTRIB_VALUE_ENTITY_U : l.attribValue += b;
                    continue;
                  }
                  ht(l), b === ">" ? je(l) : l.state = ee.ATTRIB;
                  continue;
                case ee.CLOSE_TAG:
                  if (l.tagName) b === ">" ? it(l) : se(F, b) ? l.tagName += b : l.script ? (l.script += "</" + l.tagName, l.tagName = "", l.state = ee.SCRIPT) : (K(o, b) && we(l, "Invalid tagname in closing tag"), l.state = ee.CLOSE_TAG_SAW_WHITE);
                  else {
                    if (se(o, b)) continue;
                    K(q, b) ? l.script ? (l.script += "</" + b, l.state = ee.SCRIPT) : we(l, "Invalid tagname in closing tag.") : l.tagName = b;
                  }
                  continue;
                case ee.CLOSE_TAG_SAW_WHITE:
                  if (se(o, b)) continue;
                  b === ">" ? it(l) : we(l, "Invalid characters in closing tag");
                  continue;
                case ee.TEXT_ENTITY:
                case ee.ATTRIB_VALUE_ENTITY_Q:
                case ee.ATTRIB_VALUE_ENTITY_U:
                  var Ie, $e;
                  switch (l.state) {
                    case ee.TEXT_ENTITY:
                      Ie = ee.TEXT, $e = "textNode";
                      break;
                    case ee.ATTRIB_VALUE_ENTITY_Q:
                      Ie = ee.ATTRIB_VALUE_QUOTED, $e = "attribValue";
                      break;
                    case ee.ATTRIB_VALUE_ENTITY_U:
                      Ie = ee.ATTRIB_VALUE_UNQUOTED, $e = "attribValue";
                  }
                  b === ";" ? (l[$e] += ve(l), l.entity = "", l.state = Ie) : se(l.entity.length ? P : te, b) ? l.entity += b : (we(l, "Invalid character in entity name"), l[$e] += "&" + l.entity + b, l.entity = "", l.state = Ie);
                  continue;
                default:
                  throw new Error(l, "Unknown state: " + l.state);
              }
              return l.position >= l.bufferCheckPosition && function(Ze) {
                for (var xe = Math.max(J.MAX_BUFFER_LENGTH, 10), Me = 0, Ve = 0, ot = t.length; Ve < ot; Ve++) {
                  var bt = Ze[t[Ve]].length;
                  if (bt > xe) switch (t[Ve]) {
                    case "textNode":
                      Ce(Ze);
                      break;
                    case "cdata":
                      Xe(Ze, "oncdata", Ze.cdata), Ze.cdata = "";
                      break;
                    case "script":
                      Xe(Ze, "onscript", Ze.script), Ze.script = "";
                      break;
                    default:
                      Je(Ze, "Max buffer length exceeded: " + t[Ve]);
                  }
                  Me = Math.max(Me, bt);
                }
                var dt = J.MAX_BUFFER_LENGTH - Me;
                Ze.bufferCheckPosition = dt + Ze.position;
              }(l), l;
            }, resume: function() {
              return this.error = null, this;
            }, close: function() {
              return this.write(null);
            }, flush: function() {
              var d;
              Ce(d = this), d.cdata !== "" && (Xe(d, "oncdata", d.cdata), d.cdata = ""), d.script !== "" && (Xe(d, "onscript", d.script), d.script = "");
            } };
            try {
              E = R(182).Stream;
            } catch {
              E = function() {
              };
            }
            var h = J.EVENTS.filter(function(d) {
              return d !== "error" && d !== "end";
            });
            function p(d, l) {
              if (!(this instanceof p)) return new p(d, l);
              E.apply(this), this._parser = new e(d, l), this.writable = !0, this.readable = !0;
              var T = this;
              this._parser.onend = function() {
                T.emit("end");
              }, this._parser.onerror = function(b) {
                T.emit("error", b), T._parser.error = null;
              }, this._decoder = null, h.forEach(function(b) {
                Object.defineProperty(T, "on" + b, { get: function() {
                  return T._parser["on" + b];
                }, set: function($) {
                  if (!$) return T.removeAllListeners(b), T._parser["on" + b] = $, $;
                  T.on(b, $);
                }, enumerable: !0, configurable: !1 });
              });
            }
            p.prototype = Object.create(E.prototype, { constructor: { value: p } }), p.prototype.write = function(d) {
              if (typeof Buffer == "function" && typeof Buffer.isBuffer == "function" && Buffer.isBuffer(d)) {
                if (!this._decoder) {
                  var l = R(7503).s;
                  this._decoder = new l("utf8");
                }
                d = this._decoder.write(d);
              }
              return this._parser.write(d.toString()), this.emit("data", d), !0;
            }, p.prototype.end = function(d) {
              return d && d.length && this.write(d), this._parser.end(), !0;
            }, p.prototype.on = function(d, l) {
              var T = this;
              return T._parser["on" + d] || h.indexOf(d) === -1 || (T._parser["on" + d] = function() {
                var b = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
                b.splice(0, 0, d), T.emit.apply(T, b);
              }), E.prototype.on.call(T, d, l);
            };
            var o = `\r
	 `, v = "0124356789", m = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", n = `'"`, c = o + ">", f = "http://www.w3.org/XML/1998/namespace", S = "http://www.w3.org/2000/xmlns/", k = { xml: f, xmlns: S };
            o = Q(o), v = Q(v), m = Q(m);
            var q = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, F = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/, te = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, P = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
            function Q(d) {
              return d.split("").reduce(function(l, T) {
                return l[T] = !0, l;
              }, {});
            }
            function se(d, l) {
              return function(T) {
                return Object.prototype.toString.call(T) === "[object RegExp]";
              }(d) ? !!l.match(d) : d[l];
            }
            function K(d, l) {
              return !se(d, l);
            }
            n = Q(n), c = Q(c);
            var ie, ge, Ne, ee = 0;
            for (var Oe in J.STATE = { BEGIN: ee++, BEGIN_WHITESPACE: ee++, TEXT: ee++, TEXT_ENTITY: ee++, OPEN_WAKA: ee++, SGML_DECL: ee++, SGML_DECL_QUOTED: ee++, DOCTYPE: ee++, DOCTYPE_QUOTED: ee++, DOCTYPE_DTD: ee++, DOCTYPE_DTD_QUOTED: ee++, COMMENT_STARTING: ee++, COMMENT: ee++, COMMENT_ENDING: ee++, COMMENT_ENDED: ee++, CDATA: ee++, CDATA_ENDING: ee++, CDATA_ENDING_2: ee++, PROC_INST: ee++, PROC_INST_BODY: ee++, PROC_INST_ENDING: ee++, OPEN_TAG: ee++, OPEN_TAG_SLASH: ee++, ATTRIB: ee++, ATTRIB_NAME: ee++, ATTRIB_NAME_SAW_WHITE: ee++, ATTRIB_VALUE: ee++, ATTRIB_VALUE_QUOTED: ee++, ATTRIB_VALUE_CLOSED: ee++, ATTRIB_VALUE_UNQUOTED: ee++, ATTRIB_VALUE_ENTITY_Q: ee++, ATTRIB_VALUE_ENTITY_U: ee++, CLOSE_TAG: ee++, CLOSE_TAG_SAW_WHITE: ee++, SCRIPT: ee++, SCRIPT_ENDING: ee++ }, J.XML_ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'" }, J.ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'", AElig: 198, Aacute: 193, Acirc: 194, Agrave: 192, Aring: 197, Atilde: 195, Auml: 196, Ccedil: 199, ETH: 208, Eacute: 201, Ecirc: 202, Egrave: 200, Euml: 203, Iacute: 205, Icirc: 206, Igrave: 204, Iuml: 207, Ntilde: 209, Oacute: 211, Ocirc: 212, Ograve: 210, Oslash: 216, Otilde: 213, Ouml: 214, THORN: 222, Uacute: 218, Ucirc: 219, Ugrave: 217, Uuml: 220, Yacute: 221, aacute: 225, acirc: 226, aelig: 230, agrave: 224, aring: 229, atilde: 227, auml: 228, ccedil: 231, eacute: 233, ecirc: 234, egrave: 232, eth: 240, euml: 235, iacute: 237, icirc: 238, igrave: 236, iuml: 239, ntilde: 241, oacute: 243, ocirc: 244, ograve: 242, oslash: 248, otilde: 245, ouml: 246, szlig: 223, thorn: 254, uacute: 250, ucirc: 251, ugrave: 249, uuml: 252, yacute: 253, yuml: 255, copy: 169, reg: 174, nbsp: 160, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, sect: 167, uml: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, deg: 176, plusmn: 177, sup1: 185, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, times: 215, divide: 247, OElig: 338, oelig: 339, Scaron: 352, scaron: 353, Yuml: 376, fnof: 402, circ: 710, tilde: 732, Alpha: 913, Beta: 914, Gamma: 915, Delta: 916, Epsilon: 917, Zeta: 918, Eta: 919, Theta: 920, Iota: 921, Kappa: 922, Lambda: 923, Mu: 924, Nu: 925, Xi: 926, Omicron: 927, Pi: 928, Rho: 929, Sigma: 931, Tau: 932, Upsilon: 933, Phi: 934, Chi: 935, Psi: 936, Omega: 937, alpha: 945, beta: 946, gamma: 947, delta: 948, epsilon: 949, zeta: 950, eta: 951, theta: 952, iota: 953, kappa: 954, lambda: 955, mu: 956, nu: 957, xi: 958, omicron: 959, pi: 960, rho: 961, sigmaf: 962, sigma: 963, tau: 964, upsilon: 965, phi: 966, chi: 967, psi: 968, omega: 969, thetasym: 977, upsih: 978, piv: 982, ensp: 8194, emsp: 8195, thinsp: 8201, zwnj: 8204, zwj: 8205, lrm: 8206, rlm: 8207, ndash: 8211, mdash: 8212, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, bull: 8226, hellip: 8230, permil: 8240, prime: 8242, Prime: 8243, lsaquo: 8249, rsaquo: 8250, oline: 8254, frasl: 8260, euro: 8364, image: 8465, weierp: 8472, real: 8476, trade: 8482, alefsym: 8501, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, harr: 8596, crarr: 8629, lArr: 8656, uArr: 8657, rArr: 8658, dArr: 8659, hArr: 8660, forall: 8704, part: 8706, exist: 8707, empty: 8709, nabla: 8711, isin: 8712, notin: 8713, ni: 8715, prod: 8719, sum: 8721, minus: 8722, lowast: 8727, radic: 8730, prop: 8733, infin: 8734, ang: 8736, and: 8743, or: 8744, cap: 8745, cup: 8746, int: 8747, there4: 8756, sim: 8764, cong: 8773, asymp: 8776, ne: 8800, equiv: 8801, le: 8804, ge: 8805, sub: 8834, sup: 8835, nsub: 8836, sube: 8838, supe: 8839, oplus: 8853, otimes: 8855, perp: 8869, sdot: 8901, lceil: 8968, rceil: 8969, lfloor: 8970, rfloor: 8971, lang: 9001, rang: 9002, loz: 9674, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830 }, Object.keys(J.ENTITIES).forEach(function(d) {
              var l = J.ENTITIES[d], T = typeof l == "number" ? String.fromCharCode(l) : l;
              J.ENTITIES[d] = T;
            }), J.STATE) J.STATE[J.STATE[Oe]] = Oe;
            function Ge(d, l, T) {
              d[l] && d[l](T);
            }
            function Xe(d, l, T) {
              d.textNode && Ce(d), Ge(d, l, T);
            }
            function Ce(d) {
              d.textNode = Ue(d.opt, d.textNode), d.textNode && Ge(d, "ontext", d.textNode), d.textNode = "";
            }
            function Ue(d, l) {
              return d.trim && (l = l.trim()), d.normalize && (l = l.replace(/\s+/g, " ")), l;
            }
            function Je(d, l) {
              return Ce(d), d.trackPosition && (l += `
Line: ` + d.line + `
Column: ` + d.column + `
Char: ` + d.c), l = new Error(l), d.error = l, Ge(d, "onerror", l), d;
            }
            function st(d) {
              return d.sawRoot && !d.closedRoot && we(d, "Unclosed root tag"), d.state !== ee.BEGIN && d.state !== ee.BEGIN_WHITESPACE && d.state !== ee.TEXT && Je(d, "Unexpected end"), Ce(d), d.c = "", d.closed = !0, Ge(d, "onend"), e.call(d, d.strict, d.opt), d;
            }
            function we(d, l) {
              if (typeof d != "object" || !(d instanceof e)) throw new Error("bad call to strictFail");
              d.strict && Je(d, l);
            }
            function Be(d) {
              d.strict || (d.tagName = d.tagName[d.looseCase]());
              var l = d.tags[d.tags.length - 1] || d, T = d.tag = { name: d.tagName, attributes: {} };
              d.opt.xmlns && (T.ns = l.ns), d.attribList.length = 0, Xe(d, "onopentagstart", T);
            }
            function At(d, l) {
              var T = d.indexOf(":") < 0 ? ["", d] : d.split(":"), b = T[0], $ = T[1];
              return l && d === "xmlns" && (b = "xmlns", $ = ""), { prefix: b, local: $ };
            }
            function ht(d) {
              if (d.strict || (d.attribName = d.attribName[d.looseCase]()), d.attribList.indexOf(d.attribName) !== -1 || d.tag.attributes.hasOwnProperty(d.attribName)) d.attribName = d.attribValue = "";
              else {
                if (d.opt.xmlns) {
                  var l = At(d.attribName, !0), T = l.prefix, b = l.local;
                  if (T === "xmlns") if (b === "xml" && d.attribValue !== f) we(d, "xml: prefix must be bound to " + f + `
Actual: ` + d.attribValue);
                  else if (b === "xmlns" && d.attribValue !== S) we(d, "xmlns: prefix must be bound to " + S + `
Actual: ` + d.attribValue);
                  else {
                    var $ = d.tag, W = d.tags[d.tags.length - 1] || d;
                    $.ns === W.ns && ($.ns = Object.create(W.ns)), $.ns[b] = d.attribValue;
                  }
                  d.attribList.push([d.attribName, d.attribValue]);
                } else d.tag.attributes[d.attribName] = d.attribValue, Xe(d, "onattribute", { name: d.attribName, value: d.attribValue });
                d.attribName = d.attribValue = "";
              }
            }
            function je(d, l) {
              if (d.opt.xmlns) {
                var T = d.tag, b = At(d.tagName);
                T.prefix = b.prefix, T.local = b.local, T.uri = T.ns[b.prefix] || "", T.prefix && !T.uri && (we(d, "Unbound namespace prefix: " + JSON.stringify(d.tagName)), T.uri = b.prefix);
                var $ = d.tags[d.tags.length - 1] || d;
                T.ns && $.ns !== T.ns && Object.keys(T.ns).forEach(function(Yt) {
                  Xe(d, "onopennamespace", { prefix: Yt, uri: T.ns[Yt] });
                });
                for (var W = 0, Ie = d.attribList.length; W < Ie; W++) {
                  var $e = d.attribList[W], Ze = $e[0], xe = $e[1], Me = At(Ze, !0), Ve = Me.prefix, ot = Me.local, bt = Ve === "" ? "" : T.ns[Ve] || "", dt = { name: Ze, value: xe, prefix: Ve, local: ot, uri: bt };
                  Ve && Ve !== "xmlns" && !bt && (we(d, "Unbound namespace prefix: " + JSON.stringify(Ve)), dt.uri = Ve), d.tag.attributes[Ze] = dt, Xe(d, "onattribute", dt);
                }
                d.attribList.length = 0;
              }
              d.tag.isSelfClosing = !!l, d.sawRoot = !0, d.tags.push(d.tag), Xe(d, "onopentag", d.tag), l || (d.noscript || d.tagName.toLowerCase() !== "script" ? d.state = ee.TEXT : d.state = ee.SCRIPT, d.tag = null, d.tagName = ""), d.attribName = d.attribValue = "", d.attribList.length = 0;
            }
            function it(d) {
              if (!d.tagName) return we(d, "Weird empty close tag."), d.textNode += "</>", void (d.state = ee.TEXT);
              if (d.script) {
                if (d.tagName !== "script") return d.script += "</" + d.tagName + ">", d.tagName = "", void (d.state = ee.SCRIPT);
                Xe(d, "onscript", d.script), d.script = "";
              }
              var l = d.tags.length, T = d.tagName;
              d.strict || (T = T[d.looseCase]());
              for (var b = T; l-- && d.tags[l].name !== b; ) we(d, "Unexpected close tag");
              if (l < 0) return we(d, "Unmatched closing tag: " + d.tagName), d.textNode += "</" + d.tagName + ">", void (d.state = ee.TEXT);
              d.tagName = T;
              for (var $ = d.tags.length; $-- > l; ) {
                var W = d.tag = d.tags.pop();
                d.tagName = d.tag.name, Xe(d, "onclosetag", d.tagName);
                var Ie = {};
                for (var $e in W.ns) Ie[$e] = W.ns[$e];
                var Ze = d.tags[d.tags.length - 1] || d;
                d.opt.xmlns && W.ns !== Ze.ns && Object.keys(W.ns).forEach(function(xe) {
                  var Me = W.ns[xe];
                  Xe(d, "onclosenamespace", { prefix: xe, uri: Me });
                });
              }
              l === 0 && (d.closedRoot = !0), d.tagName = d.attribValue = d.attribName = "", d.attribList.length = 0, d.state = ee.TEXT;
            }
            function ve(d) {
              var l, T = d.entity, b = T.toLowerCase(), $ = "";
              return d.ENTITIES[T] ? d.ENTITIES[T] : d.ENTITIES[b] ? d.ENTITIES[b] : ((T = b).charAt(0) === "#" && (T.charAt(1) === "x" ? (T = T.slice(2), $ = (l = parseInt(T, 16)).toString(16)) : (T = T.slice(1), $ = (l = parseInt(T, 10)).toString(10))), T = T.replace(/^0+/, ""), $.toLowerCase() !== T ? (we(d, "Invalid character entity"), "&" + d.entity + ";") : String.fromCodePoint(l));
            }
            function Se(d, l) {
              l === "<" ? (d.state = ee.OPEN_WAKA, d.startTagPosition = d.position) : K(o, l) && (we(d, "Non-whitespace before first tag."), d.textNode = l, d.state = ee.TEXT);
            }
            function Ye(d, l) {
              var T = "";
              return l < d.length && (T = d.charAt(l)), T;
            }
            ee = J.STATE, String.fromCodePoint || (ie = String.fromCharCode, ge = Math.floor, Ne = function() {
              var d, l, T = 16384, b = [], $ = -1, W = arguments.length;
              if (!W) return "";
              for (var Ie = ""; ++$ < W; ) {
                var $e = Number(arguments[$]);
                if (!isFinite($e) || $e < 0 || $e > 1114111 || ge($e) !== $e) throw RangeError("Invalid code point: " + $e);
                $e <= 65535 ? b.push($e) : (d = 55296 + (($e -= 65536) >> 10), l = $e % 1024 + 56320, b.push(d, l)), ($ + 1 === W || b.length > T) && (Ie += ie.apply(null, b), b.length = 0);
              }
              return Ie;
            }, Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", { value: Ne, configurable: !0, writable: !0 }) : String.fromCodePoint = Ne);
          })(fe);
        }, 182: function(_e, fe, R) {
          _e.exports = E;
          var J = R(1159).EventEmitter;
          function E() {
            J.call(this);
          }
          R(1765)(E, J), E.Readable = R(2846), E.Writable = R(8318), E.Duplex = R(6138), E.Transform = R(9798), E.PassThrough = R(5472), E.finished = R(8800), E.pipeline = R(7295), E.Stream = E, E.prototype.pipe = function(t, e) {
            var h = this;
            function p(S) {
              t.writable && t.write(S) === !1 && h.pause && h.pause();
            }
            function o() {
              h.readable && h.resume && h.resume();
            }
            h.on("data", p), t.on("drain", o), t._isStdio || e && e.end === !1 || (h.on("end", m), h.on("close", n));
            var v = !1;
            function m() {
              v || (v = !0, t.end());
            }
            function n() {
              v || (v = !0, typeof t.destroy == "function" && t.destroy());
            }
            function c(S) {
              if (f(), J.listenerCount(this, "error") === 0) throw S;
            }
            function f() {
              h.removeListener("data", p), t.removeListener("drain", o), h.removeListener("end", m), h.removeListener("close", n), h.removeListener("error", c), t.removeListener("error", c), h.removeListener("end", f), h.removeListener("close", f), t.removeListener("close", f);
            }
            return h.on("error", c), t.on("error", c), h.on("end", f), h.on("close", f), t.on("close", f), t.emit("pipe", h), t;
          };
        }, 1765: function(_e) {
          typeof Object.create == "function" ? _e.exports = function(fe, R) {
            R && (fe.super_ = R, fe.prototype = Object.create(R.prototype, { constructor: { value: fe, enumerable: !1, writable: !0, configurable: !0 } }));
          } : _e.exports = function(fe, R) {
            if (R) {
              fe.super_ = R;
              var J = function() {
              };
              J.prototype = R.prototype, fe.prototype = new J(), fe.prototype.constructor = fe;
            }
          };
        }, 3690: function(_e) {
          var fe = {};
          function R(E, t, e) {
            e || (e = Error);
            var h = function(p) {
              var o, v;
              function m(n, c, f) {
                return p.call(this, function(S, k, q) {
                  return typeof t == "string" ? t : t(S, k, q);
                }(n, c, f)) || this;
              }
              return v = p, (o = m).prototype = Object.create(v.prototype), o.prototype.constructor = o, o.__proto__ = v, m;
            }(e);
            h.prototype.name = e.name, h.prototype.code = E, fe[E] = h;
          }
          function J(E, t) {
            if (Array.isArray(E)) {
              var e = E.length;
              return E = E.map(function(h) {
                return String(h);
              }), e > 2 ? "one of ".concat(t, " ").concat(E.slice(0, e - 1).join(", "), ", or ") + E[e - 1] : e === 2 ? "one of ".concat(t, " ").concat(E[0], " or ").concat(E[1]) : "of ".concat(t, " ").concat(E[0]);
            }
            return "of ".concat(t, " ").concat(String(E));
          }
          R("ERR_INVALID_OPT_VALUE", function(E, t) {
            return 'The value "' + t + '" is invalid for option "' + E + '"';
          }, TypeError), R("ERR_INVALID_ARG_TYPE", function(E, t, e) {
            var h, p, o, v, m;
            if (typeof t == "string" && (p = "not ", t.substr(0, p.length) === p) ? (h = "must not be", t = t.replace(/^not /, "")) : h = "must be", function(c, f, S) {
              return (S === void 0 || S > c.length) && (S = c.length), c.substring(S - f.length, S) === f;
            }(E, " argument")) o = "The ".concat(E, " ").concat(h, " ").concat(J(t, "type"));
            else {
              var n = (typeof m != "number" && (m = 0), m + 1 > (v = E).length || v.indexOf(".", m) === -1 ? "argument" : "property");
              o = 'The "'.concat(E, '" ').concat(n, " ").concat(h, " ").concat(J(t, "type"));
            }
            return o + ". Received type ".concat(typeof e);
          }, TypeError), R("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), R("ERR_METHOD_NOT_IMPLEMENTED", function(E) {
            return "The " + E + " method is not implemented";
          }), R("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), R("ERR_STREAM_DESTROYED", function(E) {
            return "Cannot call " + E + " after a stream was destroyed";
          }), R("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), R("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), R("ERR_STREAM_WRITE_AFTER_END", "write after end"), R("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), R("ERR_UNKNOWN_ENCODING", function(E) {
            return "Unknown encoding: " + E;
          }, TypeError), R("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), _e.exports.q = fe;
        }, 6138: function(_e, fe, R) {
          var J = Object.keys || function(n) {
            var c = [];
            for (var f in n) c.push(f);
            return c;
          };
          _e.exports = o;
          var E = R(2846), t = R(8318);
          R(1765)(o, E);
          for (var e = J(t.prototype), h = 0; h < e.length; h++) {
            var p = e[h];
            o.prototype[p] || (o.prototype[p] = t.prototype[p]);
          }
          function o(n) {
            if (!(this instanceof o)) return new o(n);
            E.call(this, n), t.call(this, n), this.allowHalfOpen = !0, n && (n.readable === !1 && (this.readable = !1), n.writable === !1 && (this.writable = !1), n.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", v)));
          }
          function v() {
            this._writableState.ended || process.nextTick(m, this);
          }
          function m(n) {
            n.end();
          }
          Object.defineProperty(o.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), Object.defineProperty(o.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(o.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(o.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._writableState !== void 0 && this._readableState.destroyed && this._writableState.destroyed;
          }, set: function(n) {
            this._readableState !== void 0 && this._writableState !== void 0 && (this._readableState.destroyed = n, this._writableState.destroyed = n);
          } });
        }, 5472: function(_e, fe, R) {
          _e.exports = E;
          var J = R(9798);
          function E(t) {
            if (!(this instanceof E)) return new E(t);
            J.call(this, t);
          }
          R(1765)(E, J), E.prototype._transform = function(t, e, h) {
            h(null, t);
          };
        }, 2846: function(_e, fe, R) {
          var J;
          _e.exports = ie, ie.ReadableState = K, R(1159).EventEmitter;
          var E, t = function(ve, Se) {
            return ve.listeners(Se).length;
          }, e = R(9299), h = R(1549).Buffer, p = R.g.Uint8Array || function() {
          }, o = R(964);
          E = o && o.debuglog ? o.debuglog("stream") : function() {
          };
          var v, m, n, c = R(8393), f = R(6163), S = R(7269).getHighWaterMark, k = R(3690).q, q = k.ERR_INVALID_ARG_TYPE, F = k.ERR_STREAM_PUSH_AFTER_EOF, te = k.ERR_METHOD_NOT_IMPLEMENTED, P = k.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
          R(1765)(ie, e);
          var Q = f.errorOrDestroy, se = ["error", "close", "destroy", "pause", "resume"];
          function K(ve, Se, Ye) {
            J = J || R(6138), ve = ve || {}, typeof Ye != "boolean" && (Ye = Se instanceof J), this.objectMode = !!ve.objectMode, Ye && (this.objectMode = this.objectMode || !!ve.readableObjectMode), this.highWaterMark = S(this, ve, "readableHighWaterMark", Ye), this.buffer = new c(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = ve.emitClose !== !1, this.autoDestroy = !!ve.autoDestroy, this.destroyed = !1, this.defaultEncoding = ve.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, ve.encoding && (v || (v = R(7503).s), this.decoder = new v(ve.encoding), this.encoding = ve.encoding);
          }
          function ie(ve) {
            if (J = J || R(6138), !(this instanceof ie)) return new ie(ve);
            var Se = this instanceof J;
            this._readableState = new K(ve, this, Se), this.readable = !0, ve && (typeof ve.read == "function" && (this._read = ve.read), typeof ve.destroy == "function" && (this._destroy = ve.destroy)), e.call(this);
          }
          function ge(ve, Se, Ye, d, l) {
            E("readableAddChunk", Se);
            var T, b = ve._readableState;
            if (Se === null) b.reading = !1, function($, W) {
              if (E("onEofChunk"), !W.ended) {
                if (W.decoder) {
                  var Ie = W.decoder.end();
                  Ie && Ie.length && (W.buffer.push(Ie), W.length += W.objectMode ? 1 : Ie.length);
                }
                W.ended = !0, W.sync ? Ge($) : (W.needReadable = !1, W.emittedReadable || (W.emittedReadable = !0, Xe($)));
              }
            }(ve, b);
            else if (l || (T = function($, W) {
              var Ie, $e;
              return $e = W, h.isBuffer($e) || $e instanceof p || typeof W == "string" || W === void 0 || $.objectMode || (Ie = new q("chunk", ["string", "Buffer", "Uint8Array"], W)), Ie;
            }(b, Se)), T) Q(ve, T);
            else if (b.objectMode || Se && Se.length > 0) if (typeof Se == "string" || b.objectMode || Object.getPrototypeOf(Se) === h.prototype || (Se = function($) {
              return h.from($);
            }(Se)), d) b.endEmitted ? Q(ve, new P()) : Ne(ve, b, Se, !0);
            else if (b.ended) Q(ve, new F());
            else {
              if (b.destroyed) return !1;
              b.reading = !1, b.decoder && !Ye ? (Se = b.decoder.write(Se), b.objectMode || Se.length !== 0 ? Ne(ve, b, Se, !1) : Ce(ve, b)) : Ne(ve, b, Se, !1);
            }
            else d || (b.reading = !1, Ce(ve, b));
            return !b.ended && (b.length < b.highWaterMark || b.length === 0);
          }
          function Ne(ve, Se, Ye, d) {
            Se.flowing && Se.length === 0 && !Se.sync ? (Se.awaitDrain = 0, ve.emit("data", Ye)) : (Se.length += Se.objectMode ? 1 : Ye.length, d ? Se.buffer.unshift(Ye) : Se.buffer.push(Ye), Se.needReadable && Ge(ve)), Ce(ve, Se);
          }
          Object.defineProperty(ie.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._readableState !== void 0 && this._readableState.destroyed;
          }, set: function(ve) {
            this._readableState && (this._readableState.destroyed = ve);
          } }), ie.prototype.destroy = f.destroy, ie.prototype._undestroy = f.undestroy, ie.prototype._destroy = function(ve, Se) {
            Se(ve);
          }, ie.prototype.push = function(ve, Se) {
            var Ye, d = this._readableState;
            return d.objectMode ? Ye = !0 : typeof ve == "string" && ((Se = Se || d.defaultEncoding) !== d.encoding && (ve = h.from(ve, Se), Se = ""), Ye = !0), ge(this, ve, Se, !1, Ye);
          }, ie.prototype.unshift = function(ve) {
            return ge(this, ve, null, !0, !1);
          }, ie.prototype.isPaused = function() {
            return this._readableState.flowing === !1;
          }, ie.prototype.setEncoding = function(ve) {
            v || (v = R(7503).s);
            var Se = new v(ve);
            this._readableState.decoder = Se, this._readableState.encoding = this._readableState.decoder.encoding;
            for (var Ye = this._readableState.buffer.head, d = ""; Ye !== null; ) d += Se.write(Ye.data), Ye = Ye.next;
            return this._readableState.buffer.clear(), d !== "" && this._readableState.buffer.push(d), this._readableState.length = d.length, this;
          };
          var ee = 1073741824;
          function Oe(ve, Se) {
            return ve <= 0 || Se.length === 0 && Se.ended ? 0 : Se.objectMode ? 1 : ve != ve ? Se.flowing && Se.length ? Se.buffer.head.data.length : Se.length : (ve > Se.highWaterMark && (Se.highWaterMark = function(Ye) {
              return Ye >= ee ? Ye = ee : (Ye--, Ye |= Ye >>> 1, Ye |= Ye >>> 2, Ye |= Ye >>> 4, Ye |= Ye >>> 8, Ye |= Ye >>> 16, Ye++), Ye;
            }(ve)), ve <= Se.length ? ve : Se.ended ? Se.length : (Se.needReadable = !0, 0));
          }
          function Ge(ve) {
            var Se = ve._readableState;
            E("emitReadable", Se.needReadable, Se.emittedReadable), Se.needReadable = !1, Se.emittedReadable || (E("emitReadable", Se.flowing), Se.emittedReadable = !0, process.nextTick(Xe, ve));
          }
          function Xe(ve) {
            var Se = ve._readableState;
            E("emitReadable_", Se.destroyed, Se.length, Se.ended), Se.destroyed || !Se.length && !Se.ended || (ve.emit("readable"), Se.emittedReadable = !1), Se.needReadable = !Se.flowing && !Se.ended && Se.length <= Se.highWaterMark, Be(ve);
          }
          function Ce(ve, Se) {
            Se.readingMore || (Se.readingMore = !0, process.nextTick(Ue, ve, Se));
          }
          function Ue(ve, Se) {
            for (; !Se.reading && !Se.ended && (Se.length < Se.highWaterMark || Se.flowing && Se.length === 0); ) {
              var Ye = Se.length;
              if (E("maybeReadMore read 0"), ve.read(0), Ye === Se.length) break;
            }
            Se.readingMore = !1;
          }
          function Je(ve) {
            var Se = ve._readableState;
            Se.readableListening = ve.listenerCount("readable") > 0, Se.resumeScheduled && !Se.paused ? Se.flowing = !0 : ve.listenerCount("data") > 0 && ve.resume();
          }
          function st(ve) {
            E("readable nexttick read 0"), ve.read(0);
          }
          function we(ve, Se) {
            E("resume", Se.reading), Se.reading || ve.read(0), Se.resumeScheduled = !1, ve.emit("resume"), Be(ve), Se.flowing && !Se.reading && ve.read(0);
          }
          function Be(ve) {
            var Se = ve._readableState;
            for (E("flow", Se.flowing); Se.flowing && ve.read() !== null; ) ;
          }
          function At(ve, Se) {
            return Se.length === 0 ? null : (Se.objectMode ? Ye = Se.buffer.shift() : !ve || ve >= Se.length ? (Ye = Se.decoder ? Se.buffer.join("") : Se.buffer.length === 1 ? Se.buffer.first() : Se.buffer.concat(Se.length), Se.buffer.clear()) : Ye = Se.buffer.consume(ve, Se.decoder), Ye);
            var Ye;
          }
          function ht(ve) {
            var Se = ve._readableState;
            E("endReadable", Se.endEmitted), Se.endEmitted || (Se.ended = !0, process.nextTick(je, Se, ve));
          }
          function je(ve, Se) {
            if (E("endReadableNT", ve.endEmitted, ve.length), !ve.endEmitted && ve.length === 0 && (ve.endEmitted = !0, Se.readable = !1, Se.emit("end"), ve.autoDestroy)) {
              var Ye = Se._writableState;
              (!Ye || Ye.autoDestroy && Ye.finished) && Se.destroy();
            }
          }
          function it(ve, Se) {
            for (var Ye = 0, d = ve.length; Ye < d; Ye++) if (ve[Ye] === Se) return Ye;
            return -1;
          }
          ie.prototype.read = function(ve) {
            E("read", ve), ve = parseInt(ve, 10);
            var Se = this._readableState, Ye = ve;
            if (ve !== 0 && (Se.emittedReadable = !1), ve === 0 && Se.needReadable && ((Se.highWaterMark !== 0 ? Se.length >= Se.highWaterMark : Se.length > 0) || Se.ended)) return E("read: emitReadable", Se.length, Se.ended), Se.length === 0 && Se.ended ? ht(this) : Ge(this), null;
            if ((ve = Oe(ve, Se)) === 0 && Se.ended) return Se.length === 0 && ht(this), null;
            var d, l = Se.needReadable;
            return E("need readable", l), (Se.length === 0 || Se.length - ve < Se.highWaterMark) && E("length less than watermark", l = !0), Se.ended || Se.reading ? E("reading or ended", l = !1) : l && (E("do read"), Se.reading = !0, Se.sync = !0, Se.length === 0 && (Se.needReadable = !0), this._read(Se.highWaterMark), Se.sync = !1, Se.reading || (ve = Oe(Ye, Se))), (d = ve > 0 ? At(ve, Se) : null) === null ? (Se.needReadable = Se.length <= Se.highWaterMark, ve = 0) : (Se.length -= ve, Se.awaitDrain = 0), Se.length === 0 && (Se.ended || (Se.needReadable = !0), Ye !== ve && Se.ended && ht(this)), d !== null && this.emit("data", d), d;
          }, ie.prototype._read = function(ve) {
            Q(this, new te("_read()"));
          }, ie.prototype.pipe = function(ve, Se) {
            var Ye = this, d = this._readableState;
            switch (d.pipesCount) {
              case 0:
                d.pipes = ve;
                break;
              case 1:
                d.pipes = [d.pipes, ve];
                break;
              default:
                d.pipes.push(ve);
            }
            d.pipesCount += 1, E("pipe count=%d opts=%j", d.pipesCount, Se);
            var l = Se && Se.end === !1 || ve === process.stdout || ve === process.stderr ? xe : T;
            function T() {
              E("onend"), ve.end();
            }
            d.endEmitted ? process.nextTick(l) : Ye.once("end", l), ve.on("unpipe", function Me(Ve, ot) {
              E("onunpipe"), Ve === Ye && ot && ot.hasUnpiped === !1 && (ot.hasUnpiped = !0, E("cleanup"), ve.removeListener("close", $e), ve.removeListener("finish", Ze), ve.removeListener("drain", b), ve.removeListener("error", Ie), ve.removeListener("unpipe", Me), Ye.removeListener("end", T), Ye.removeListener("end", xe), Ye.removeListener("data", W), $ = !0, !d.awaitDrain || ve._writableState && !ve._writableState.needDrain || b());
            });
            var b = /* @__PURE__ */ function(Me) {
              return function() {
                var Ve = Me._readableState;
                E("pipeOnDrain", Ve.awaitDrain), Ve.awaitDrain && Ve.awaitDrain--, Ve.awaitDrain === 0 && t(Me, "data") && (Ve.flowing = !0, Be(Me));
              };
            }(Ye);
            ve.on("drain", b);
            var $ = !1;
            function W(Me) {
              E("ondata");
              var Ve = ve.write(Me);
              E("dest.write", Ve), Ve === !1 && ((d.pipesCount === 1 && d.pipes === ve || d.pipesCount > 1 && it(d.pipes, ve) !== -1) && !$ && (E("false write response, pause", d.awaitDrain), d.awaitDrain++), Ye.pause());
            }
            function Ie(Me) {
              E("onerror", Me), xe(), ve.removeListener("error", Ie), t(ve, "error") === 0 && Q(ve, Me);
            }
            function $e() {
              ve.removeListener("finish", Ze), xe();
            }
            function Ze() {
              E("onfinish"), ve.removeListener("close", $e), xe();
            }
            function xe() {
              E("unpipe"), Ye.unpipe(ve);
            }
            return Ye.on("data", W), function(Me, Ve, ot) {
              if (typeof Me.prependListener == "function") return Me.prependListener(Ve, ot);
              Me._events && Me._events[Ve] ? Array.isArray(Me._events[Ve]) ? Me._events[Ve].unshift(ot) : Me._events[Ve] = [ot, Me._events[Ve]] : Me.on(Ve, ot);
            }(ve, "error", Ie), ve.once("close", $e), ve.once("finish", Ze), ve.emit("pipe", Ye), d.flowing || (E("pipe resume"), Ye.resume()), ve;
          }, ie.prototype.unpipe = function(ve) {
            var Se = this._readableState, Ye = { hasUnpiped: !1 };
            if (Se.pipesCount === 0) return this;
            if (Se.pipesCount === 1) return ve && ve !== Se.pipes || (ve || (ve = Se.pipes), Se.pipes = null, Se.pipesCount = 0, Se.flowing = !1, ve && ve.emit("unpipe", this, Ye)), this;
            if (!ve) {
              var d = Se.pipes, l = Se.pipesCount;
              Se.pipes = null, Se.pipesCount = 0, Se.flowing = !1;
              for (var T = 0; T < l; T++) d[T].emit("unpipe", this, { hasUnpiped: !1 });
              return this;
            }
            var b = it(Se.pipes, ve);
            return b === -1 || (Se.pipes.splice(b, 1), Se.pipesCount -= 1, Se.pipesCount === 1 && (Se.pipes = Se.pipes[0]), ve.emit("unpipe", this, Ye)), this;
          }, ie.prototype.on = function(ve, Se) {
            var Ye = e.prototype.on.call(this, ve, Se), d = this._readableState;
            return ve === "data" ? (d.readableListening = this.listenerCount("readable") > 0, d.flowing !== !1 && this.resume()) : ve === "readable" && (d.endEmitted || d.readableListening || (d.readableListening = d.needReadable = !0, d.flowing = !1, d.emittedReadable = !1, E("on readable", d.length, d.reading), d.length ? Ge(this) : d.reading || process.nextTick(st, this))), Ye;
          }, ie.prototype.addListener = ie.prototype.on, ie.prototype.removeListener = function(ve, Se) {
            var Ye = e.prototype.removeListener.call(this, ve, Se);
            return ve === "readable" && process.nextTick(Je, this), Ye;
          }, ie.prototype.removeAllListeners = function(ve) {
            var Se = e.prototype.removeAllListeners.apply(this, arguments);
            return ve !== "readable" && ve !== void 0 || process.nextTick(Je, this), Se;
          }, ie.prototype.resume = function() {
            var ve = this._readableState;
            return ve.flowing || (E("resume"), ve.flowing = !ve.readableListening, function(Se, Ye) {
              Ye.resumeScheduled || (Ye.resumeScheduled = !0, process.nextTick(we, Se, Ye));
            }(this, ve)), ve.paused = !1, this;
          }, ie.prototype.pause = function() {
            return E("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (E("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
          }, ie.prototype.wrap = function(ve) {
            var Se = this, Ye = this._readableState, d = !1;
            for (var l in ve.on("end", function() {
              if (E("wrapped end"), Ye.decoder && !Ye.ended) {
                var b = Ye.decoder.end();
                b && b.length && Se.push(b);
              }
              Se.push(null);
            }), ve.on("data", function(b) {
              E("wrapped data"), Ye.decoder && (b = Ye.decoder.write(b)), Ye.objectMode && b == null || (Ye.objectMode || b && b.length) && (Se.push(b) || (d = !0, ve.pause()));
            }), ve) this[l] === void 0 && typeof ve[l] == "function" && (this[l] = /* @__PURE__ */ function(b) {
              return function() {
                return ve[b].apply(ve, arguments);
              };
            }(l));
            for (var T = 0; T < se.length; T++) ve.on(se[T], this.emit.bind(this, se[T]));
            return this._read = function(b) {
              E("wrapped _read", b), d && (d = !1, ve.resume());
            }, this;
          }, typeof Symbol == "function" && (ie.prototype[Symbol.asyncIterator] = function() {
            return m === void 0 && (m = R(7299)), m(this);
          }), Object.defineProperty(ie.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
            return this._readableState.highWaterMark;
          } }), Object.defineProperty(ie.prototype, "readableBuffer", { enumerable: !1, get: function() {
            return this._readableState && this._readableState.buffer;
          } }), Object.defineProperty(ie.prototype, "readableFlowing", { enumerable: !1, get: function() {
            return this._readableState.flowing;
          }, set: function(ve) {
            this._readableState && (this._readableState.flowing = ve);
          } }), ie._fromList = At, Object.defineProperty(ie.prototype, "readableLength", { enumerable: !1, get: function() {
            return this._readableState.length;
          } }), typeof Symbol == "function" && (ie.from = function(ve, Se) {
            return n === void 0 && (n = R(6233)), n(ie, ve, Se);
          });
        }, 9798: function(_e, fe, R) {
          _e.exports = v;
          var J = R(3690).q, E = J.ERR_METHOD_NOT_IMPLEMENTED, t = J.ERR_MULTIPLE_CALLBACK, e = J.ERR_TRANSFORM_ALREADY_TRANSFORMING, h = J.ERR_TRANSFORM_WITH_LENGTH_0, p = R(6138);
          function o(c, f) {
            var S = this._transformState;
            S.transforming = !1;
            var k = S.writecb;
            if (k === null) return this.emit("error", new t());
            S.writechunk = null, S.writecb = null, f != null && this.push(f), k(c);
            var q = this._readableState;
            q.reading = !1, (q.needReadable || q.length < q.highWaterMark) && this._read(q.highWaterMark);
          }
          function v(c) {
            if (!(this instanceof v)) return new v(c);
            p.call(this, c), this._transformState = { afterTransform: o.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, c && (typeof c.transform == "function" && (this._transform = c.transform), typeof c.flush == "function" && (this._flush = c.flush)), this.on("prefinish", m);
          }
          function m() {
            var c = this;
            typeof this._flush != "function" || this._readableState.destroyed ? n(this, null, null) : this._flush(function(f, S) {
              n(c, f, S);
            });
          }
          function n(c, f, S) {
            if (f) return c.emit("error", f);
            if (S != null && c.push(S), c._writableState.length) throw new h();
            if (c._transformState.transforming) throw new e();
            return c.push(null);
          }
          R(1765)(v, p), v.prototype.push = function(c, f) {
            return this._transformState.needTransform = !1, p.prototype.push.call(this, c, f);
          }, v.prototype._transform = function(c, f, S) {
            S(new E("_transform()"));
          }, v.prototype._write = function(c, f, S) {
            var k = this._transformState;
            if (k.writecb = S, k.writechunk = c, k.writeencoding = f, !k.transforming) {
              var q = this._readableState;
              (k.needTransform || q.needReadable || q.length < q.highWaterMark) && this._read(q.highWaterMark);
            }
          }, v.prototype._read = function(c) {
            var f = this._transformState;
            f.writechunk === null || f.transforming ? f.needTransform = !0 : (f.transforming = !0, this._transform(f.writechunk, f.writeencoding, f.afterTransform));
          }, v.prototype._destroy = function(c, f) {
            p.prototype._destroy.call(this, c, function(S) {
              f(S);
            });
          };
        }, 8318: function(_e, fe, R) {
          function J(Ce) {
            var Ue = this;
            this.next = null, this.entry = null, this.finish = function() {
              (function(Je, st, we) {
                var Be = Je.entry;
                for (Je.entry = null; Be; ) {
                  var At = Be.callback;
                  st.pendingcb--, At(void 0), Be = Be.next;
                }
                st.corkedRequestsFree.next = Je;
              })(Ue, Ce);
            };
          }
          var E;
          _e.exports = ie, ie.WritableState = K;
          var t, e = { deprecate: R(7839) }, h = R(9299), p = R(1549).Buffer, o = R.g.Uint8Array || function() {
          }, v = R(6163), m = R(7269).getHighWaterMark, n = R(3690).q, c = n.ERR_INVALID_ARG_TYPE, f = n.ERR_METHOD_NOT_IMPLEMENTED, S = n.ERR_MULTIPLE_CALLBACK, k = n.ERR_STREAM_CANNOT_PIPE, q = n.ERR_STREAM_DESTROYED, F = n.ERR_STREAM_NULL_VALUES, te = n.ERR_STREAM_WRITE_AFTER_END, P = n.ERR_UNKNOWN_ENCODING, Q = v.errorOrDestroy;
          function se() {
          }
          function K(Ce, Ue, Je) {
            E = E || R(6138), Ce = Ce || {}, typeof Je != "boolean" && (Je = Ue instanceof E), this.objectMode = !!Ce.objectMode, Je && (this.objectMode = this.objectMode || !!Ce.writableObjectMode), this.highWaterMark = m(this, Ce, "writableHighWaterMark", Je), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
            var st = Ce.decodeStrings === !1;
            this.decodeStrings = !st, this.defaultEncoding = Ce.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(we) {
              (function(Be, At) {
                var ht = Be._writableState, je = ht.sync, it = ht.writecb;
                if (typeof it != "function") throw new S();
                if (function(Se) {
                  Se.writing = !1, Se.writecb = null, Se.length -= Se.writelen, Se.writelen = 0;
                }(ht), At) (function(Se, Ye, d, l, T) {
                  --Ye.pendingcb, d ? (process.nextTick(T, l), process.nextTick(Xe, Se, Ye), Se._writableState.errorEmitted = !0, Q(Se, l)) : (T(l), Se._writableState.errorEmitted = !0, Q(Se, l), Xe(Se, Ye));
                })(Be, ht, je, At, it);
                else {
                  var ve = Oe(ht) || Be.destroyed;
                  ve || ht.corked || ht.bufferProcessing || !ht.bufferedRequest || ee(Be, ht), je ? process.nextTick(Ne, Be, ht, ve, it) : Ne(Be, ht, ve, it);
                }
              })(Ue, we);
            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Ce.emitClose !== !1, this.autoDestroy = !!Ce.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new J(this);
          }
          function ie(Ce) {
            var Ue = this instanceof (E = E || R(6138));
            if (!Ue && !t.call(ie, this)) return new ie(Ce);
            this._writableState = new K(Ce, this, Ue), this.writable = !0, Ce && (typeof Ce.write == "function" && (this._write = Ce.write), typeof Ce.writev == "function" && (this._writev = Ce.writev), typeof Ce.destroy == "function" && (this._destroy = Ce.destroy), typeof Ce.final == "function" && (this._final = Ce.final)), h.call(this);
          }
          function ge(Ce, Ue, Je, st, we, Be, At) {
            Ue.writelen = st, Ue.writecb = At, Ue.writing = !0, Ue.sync = !0, Ue.destroyed ? Ue.onwrite(new q("write")) : Je ? Ce._writev(we, Ue.onwrite) : Ce._write(we, Be, Ue.onwrite), Ue.sync = !1;
          }
          function Ne(Ce, Ue, Je, st) {
            Je || function(we, Be) {
              Be.length === 0 && Be.needDrain && (Be.needDrain = !1, we.emit("drain"));
            }(Ce, Ue), Ue.pendingcb--, st(), Xe(Ce, Ue);
          }
          function ee(Ce, Ue) {
            Ue.bufferProcessing = !0;
            var Je = Ue.bufferedRequest;
            if (Ce._writev && Je && Je.next) {
              var st = Ue.bufferedRequestCount, we = new Array(st), Be = Ue.corkedRequestsFree;
              Be.entry = Je;
              for (var At = 0, ht = !0; Je; ) we[At] = Je, Je.isBuf || (ht = !1), Je = Je.next, At += 1;
              we.allBuffers = ht, ge(Ce, Ue, !0, Ue.length, we, "", Be.finish), Ue.pendingcb++, Ue.lastBufferedRequest = null, Be.next ? (Ue.corkedRequestsFree = Be.next, Be.next = null) : Ue.corkedRequestsFree = new J(Ue), Ue.bufferedRequestCount = 0;
            } else {
              for (; Je; ) {
                var je = Je.chunk, it = Je.encoding, ve = Je.callback;
                if (ge(Ce, Ue, !1, Ue.objectMode ? 1 : je.length, je, it, ve), Je = Je.next, Ue.bufferedRequestCount--, Ue.writing) break;
              }
              Je === null && (Ue.lastBufferedRequest = null);
            }
            Ue.bufferedRequest = Je, Ue.bufferProcessing = !1;
          }
          function Oe(Ce) {
            return Ce.ending && Ce.length === 0 && Ce.bufferedRequest === null && !Ce.finished && !Ce.writing;
          }
          function Ge(Ce, Ue) {
            Ce._final(function(Je) {
              Ue.pendingcb--, Je && Q(Ce, Je), Ue.prefinished = !0, Ce.emit("prefinish"), Xe(Ce, Ue);
            });
          }
          function Xe(Ce, Ue) {
            var Je = Oe(Ue);
            if (Je && (function(we, Be) {
              Be.prefinished || Be.finalCalled || (typeof we._final != "function" || Be.destroyed ? (Be.prefinished = !0, we.emit("prefinish")) : (Be.pendingcb++, Be.finalCalled = !0, process.nextTick(Ge, we, Be)));
            }(Ce, Ue), Ue.pendingcb === 0 && (Ue.finished = !0, Ce.emit("finish"), Ue.autoDestroy))) {
              var st = Ce._readableState;
              (!st || st.autoDestroy && st.endEmitted) && Ce.destroy();
            }
            return Je;
          }
          R(1765)(ie, h), K.prototype.getBuffer = function() {
            for (var Ce = this.bufferedRequest, Ue = []; Ce; ) Ue.push(Ce), Ce = Ce.next;
            return Ue;
          }, function() {
            try {
              Object.defineProperty(K.prototype, "buffer", { get: e.deprecate(function() {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
            } catch {
            }
          }(), typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (t = Function.prototype[Symbol.hasInstance], Object.defineProperty(ie, Symbol.hasInstance, { value: function(Ce) {
            return !!t.call(this, Ce) || this === ie && Ce && Ce._writableState instanceof K;
          } })) : t = function(Ce) {
            return Ce instanceof this;
          }, ie.prototype.pipe = function() {
            Q(this, new k());
          }, ie.prototype.write = function(Ce, Ue, Je) {
            var st, we = this._writableState, Be = !1, At = !we.objectMode && (st = Ce, p.isBuffer(st) || st instanceof o);
            return At && !p.isBuffer(Ce) && (Ce = function(ht) {
              return p.from(ht);
            }(Ce)), typeof Ue == "function" && (Je = Ue, Ue = null), At ? Ue = "buffer" : Ue || (Ue = we.defaultEncoding), typeof Je != "function" && (Je = se), we.ending ? function(ht, je) {
              var it = new te();
              Q(ht, it), process.nextTick(je, it);
            }(this, Je) : (At || function(ht, je, it, ve) {
              var Se;
              return it === null ? Se = new F() : typeof it == "string" || je.objectMode || (Se = new c("chunk", ["string", "Buffer"], it)), !Se || (Q(ht, Se), process.nextTick(ve, Se), !1);
            }(this, we, Ce, Je)) && (we.pendingcb++, Be = function(ht, je, it, ve, Se, Ye) {
              if (!it) {
                var d = function($, W, Ie) {
                  return $.objectMode || $.decodeStrings === !1 || typeof W != "string" || (W = p.from(W, Ie)), W;
                }(je, ve, Se);
                ve !== d && (it = !0, Se = "buffer", ve = d);
              }
              var l = je.objectMode ? 1 : ve.length;
              je.length += l;
              var T = je.length < je.highWaterMark;
              if (T || (je.needDrain = !0), je.writing || je.corked) {
                var b = je.lastBufferedRequest;
                je.lastBufferedRequest = { chunk: ve, encoding: Se, isBuf: it, callback: Ye, next: null }, b ? b.next = je.lastBufferedRequest : je.bufferedRequest = je.lastBufferedRequest, je.bufferedRequestCount += 1;
              } else ge(ht, je, !1, l, ve, Se, Ye);
              return T;
            }(this, we, At, Ce, Ue, Je)), Be;
          }, ie.prototype.cork = function() {
            this._writableState.corked++;
          }, ie.prototype.uncork = function() {
            var Ce = this._writableState;
            Ce.corked && (Ce.corked--, Ce.writing || Ce.corked || Ce.bufferProcessing || !Ce.bufferedRequest || ee(this, Ce));
          }, ie.prototype.setDefaultEncoding = function(Ce) {
            if (typeof Ce == "string" && (Ce = Ce.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Ce + "").toLowerCase()) > -1)) throw new P(Ce);
            return this._writableState.defaultEncoding = Ce, this;
          }, Object.defineProperty(ie.prototype, "writableBuffer", { enumerable: !1, get: function() {
            return this._writableState && this._writableState.getBuffer();
          } }), Object.defineProperty(ie.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
            return this._writableState.highWaterMark;
          } }), ie.prototype._write = function(Ce, Ue, Je) {
            Je(new f("_write()"));
          }, ie.prototype._writev = null, ie.prototype.end = function(Ce, Ue, Je) {
            var st = this._writableState;
            return typeof Ce == "function" ? (Je = Ce, Ce = null, Ue = null) : typeof Ue == "function" && (Je = Ue, Ue = null), Ce != null && this.write(Ce, Ue), st.corked && (st.corked = 1, this.uncork()), st.ending || function(we, Be, At) {
              Be.ending = !0, Xe(we, Be), At && (Be.finished ? process.nextTick(At) : we.once("finish", At)), Be.ended = !0, we.writable = !1;
            }(this, st, Je), this;
          }, Object.defineProperty(ie.prototype, "writableLength", { enumerable: !1, get: function() {
            return this._writableState.length;
          } }), Object.defineProperty(ie.prototype, "destroyed", { enumerable: !1, get: function() {
            return this._writableState !== void 0 && this._writableState.destroyed;
          }, set: function(Ce) {
            this._writableState && (this._writableState.destroyed = Ce);
          } }), ie.prototype.destroy = v.destroy, ie.prototype._undestroy = v.undestroy, ie.prototype._destroy = function(Ce, Ue) {
            Ue(Ce);
          };
        }, 7299: function(_e, fe, R) {
          var J;
          function E(F, te, P) {
            return te in F ? Object.defineProperty(F, te, { value: P, enumerable: !0, configurable: !0, writable: !0 }) : F[te] = P, F;
          }
          var t = R(8800), e = Symbol("lastResolve"), h = Symbol("lastReject"), p = Symbol("error"), o = Symbol("ended"), v = Symbol("lastPromise"), m = Symbol("handlePromise"), n = Symbol("stream");
          function c(F, te) {
            return { value: F, done: te };
          }
          function f(F) {
            var te = F[e];
            if (te !== null) {
              var P = F[n].read();
              P !== null && (F[v] = null, F[e] = null, F[h] = null, te(c(P, !1)));
            }
          }
          function S(F) {
            process.nextTick(f, F);
          }
          var k = Object.getPrototypeOf(function() {
          }), q = Object.setPrototypeOf((E(J = { get stream() {
            return this[n];
          }, next: function() {
            var F = this, te = this[p];
            if (te !== null) return Promise.reject(te);
            if (this[o]) return Promise.resolve(c(void 0, !0));
            if (this[n].destroyed) return new Promise(function(K, ie) {
              process.nextTick(function() {
                F[p] ? ie(F[p]) : K(c(void 0, !0));
              });
            });
            var P, Q = this[v];
            if (Q) P = new Promise(/* @__PURE__ */ function(K, ie) {
              return function(ge, Ne) {
                K.then(function() {
                  ie[o] ? ge(c(void 0, !0)) : ie[m](ge, Ne);
                }, Ne);
              };
            }(Q, this));
            else {
              var se = this[n].read();
              if (se !== null) return Promise.resolve(c(se, !1));
              P = new Promise(this[m]);
            }
            return this[v] = P, P;
          } }, Symbol.asyncIterator, function() {
            return this;
          }), E(J, "return", function() {
            var F = this;
            return new Promise(function(te, P) {
              F[n].destroy(null, function(Q) {
                Q ? P(Q) : te(c(void 0, !0));
              });
            });
          }), J), k);
          _e.exports = function(F) {
            var te, P = Object.create(q, (E(te = {}, n, { value: F, writable: !0 }), E(te, e, { value: null, writable: !0 }), E(te, h, { value: null, writable: !0 }), E(te, p, { value: null, writable: !0 }), E(te, o, { value: F._readableState.endEmitted, writable: !0 }), E(te, m, { value: function(Q, se) {
              var K = P[n].read();
              K ? (P[v] = null, P[e] = null, P[h] = null, Q(c(K, !1))) : (P[e] = Q, P[h] = se);
            }, writable: !0 }), te));
            return P[v] = null, t(F, function(Q) {
              if (Q && Q.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var se = P[h];
                return se !== null && (P[v] = null, P[e] = null, P[h] = null, se(Q)), void (P[p] = Q);
              }
              var K = P[e];
              K !== null && (P[v] = null, P[e] = null, P[h] = null, K(c(void 0, !0))), P[o] = !0;
            }), F.on("readable", S.bind(null, P)), P;
          };
        }, 8393: function(_e, fe, R) {
          function J(o, v) {
            var m = Object.keys(o);
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(o);
              v && (n = n.filter(function(c) {
                return Object.getOwnPropertyDescriptor(o, c).enumerable;
              })), m.push.apply(m, n);
            }
            return m;
          }
          function E(o, v, m) {
            return v in o ? Object.defineProperty(o, v, { value: m, enumerable: !0, configurable: !0, writable: !0 }) : o[v] = m, o;
          }
          function t(o, v) {
            for (var m = 0; m < v.length; m++) {
              var n = v[m];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(o, n.key, n);
            }
          }
          var e = R(1549).Buffer, h = R(9862).inspect, p = h && h.custom || "inspect";
          _e.exports = function() {
            function o() {
              (function(n, c) {
                if (!(n instanceof c)) throw new TypeError("Cannot call a class as a function");
              })(this, o), this.head = null, this.tail = null, this.length = 0;
            }
            var v, m;
            return v = o, m = [{ key: "push", value: function(n) {
              var c = { data: n, next: null };
              this.length > 0 ? this.tail.next = c : this.head = c, this.tail = c, ++this.length;
            } }, { key: "unshift", value: function(n) {
              var c = { data: n, next: this.head };
              this.length === 0 && (this.tail = c), this.head = c, ++this.length;
            } }, { key: "shift", value: function() {
              if (this.length !== 0) {
                var n = this.head.data;
                return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, n;
              }
            } }, { key: "clear", value: function() {
              this.head = this.tail = null, this.length = 0;
            } }, { key: "join", value: function(n) {
              if (this.length === 0) return "";
              for (var c = this.head, f = "" + c.data; c = c.next; ) f += n + c.data;
              return f;
            } }, { key: "concat", value: function(n) {
              if (this.length === 0) return e.alloc(0);
              for (var c, f, S, k = e.allocUnsafe(n >>> 0), q = this.head, F = 0; q; ) c = q.data, f = k, S = F, e.prototype.copy.call(c, f, S), F += q.data.length, q = q.next;
              return k;
            } }, { key: "consume", value: function(n, c) {
              var f;
              return n < this.head.data.length ? (f = this.head.data.slice(0, n), this.head.data = this.head.data.slice(n)) : f = n === this.head.data.length ? this.shift() : c ? this._getString(n) : this._getBuffer(n), f;
            } }, { key: "first", value: function() {
              return this.head.data;
            } }, { key: "_getString", value: function(n) {
              var c = this.head, f = 1, S = c.data;
              for (n -= S.length; c = c.next; ) {
                var k = c.data, q = n > k.length ? k.length : n;
                if (q === k.length ? S += k : S += k.slice(0, n), (n -= q) == 0) {
                  q === k.length ? (++f, c.next ? this.head = c.next : this.head = this.tail = null) : (this.head = c, c.data = k.slice(q));
                  break;
                }
                ++f;
              }
              return this.length -= f, S;
            } }, { key: "_getBuffer", value: function(n) {
              var c = e.allocUnsafe(n), f = this.head, S = 1;
              for (f.data.copy(c), n -= f.data.length; f = f.next; ) {
                var k = f.data, q = n > k.length ? k.length : n;
                if (k.copy(c, c.length - n, 0, q), (n -= q) == 0) {
                  q === k.length ? (++S, f.next ? this.head = f.next : this.head = this.tail = null) : (this.head = f, f.data = k.slice(q));
                  break;
                }
                ++S;
              }
              return this.length -= S, c;
            } }, { key: p, value: function(n, c) {
              return h(this, function(f) {
                for (var S = 1; S < arguments.length; S++) {
                  var k = arguments[S] != null ? arguments[S] : {};
                  S % 2 ? J(Object(k), !0).forEach(function(q) {
                    E(f, q, k[q]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(k)) : J(Object(k)).forEach(function(q) {
                    Object.defineProperty(f, q, Object.getOwnPropertyDescriptor(k, q));
                  });
                }
                return f;
              }({}, c, { depth: 0, customInspect: !1 }));
            } }], m && t(v.prototype, m), o;
          }();
        }, 6163: function(_e) {
          function fe(E, t) {
            J(E, t), R(E);
          }
          function R(E) {
            E._writableState && !E._writableState.emitClose || E._readableState && !E._readableState.emitClose || E.emit("close");
          }
          function J(E, t) {
            E.emit("error", t);
          }
          _e.exports = { destroy: function(E, t) {
            var e = this, h = this._readableState && this._readableState.destroyed, p = this._writableState && this._writableState.destroyed;
            return h || p ? (t ? t(E) : E && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(J, this, E)) : process.nextTick(J, this, E)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(E || null, function(o) {
              !t && o ? e._writableState ? e._writableState.errorEmitted ? process.nextTick(R, e) : (e._writableState.errorEmitted = !0, process.nextTick(fe, e, o)) : process.nextTick(fe, e, o) : t ? (process.nextTick(R, e), t(o)) : process.nextTick(R, e);
            }), this);
          }, undestroy: function() {
            this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
          }, errorOrDestroy: function(E, t) {
            var e = E._readableState, h = E._writableState;
            e && e.autoDestroy || h && h.autoDestroy ? E.destroy(t) : E.emit("error", t);
          } };
        }, 8800: function(_e, fe, R) {
          var J = R(3690).q.ERR_STREAM_PREMATURE_CLOSE;
          function E() {
          }
          _e.exports = function t(e, h, p) {
            if (typeof h == "function") return t(e, null, h);
            h || (h = {}), p = /* @__PURE__ */ function(te) {
              var P = !1;
              return function() {
                if (!P) {
                  P = !0;
                  for (var Q = arguments.length, se = new Array(Q), K = 0; K < Q; K++) se[K] = arguments[K];
                  te.apply(this, se);
                }
              };
            }(p || E);
            var o = h.readable || h.readable !== !1 && e.readable, v = h.writable || h.writable !== !1 && e.writable, m = function() {
              e.writable || c();
            }, n = e._writableState && e._writableState.finished, c = function() {
              v = !1, n = !0, o || p.call(e);
            }, f = e._readableState && e._readableState.endEmitted, S = function() {
              o = !1, f = !0, v || p.call(e);
            }, k = function(te) {
              p.call(e, te);
            }, q = function() {
              var te;
              return o && !f ? (e._readableState && e._readableState.ended || (te = new J()), p.call(e, te)) : v && !n ? (e._writableState && e._writableState.ended || (te = new J()), p.call(e, te)) : void 0;
            }, F = function() {
              e.req.on("finish", c);
            };
            return function(te) {
              return te.setHeader && typeof te.abort == "function";
            }(e) ? (e.on("complete", c), e.on("abort", q), e.req ? F() : e.on("request", F)) : v && !e._writableState && (e.on("end", m), e.on("close", m)), e.on("end", S), e.on("finish", c), h.error !== !1 && e.on("error", k), e.on("close", q), function() {
              e.removeListener("complete", c), e.removeListener("abort", q), e.removeListener("request", F), e.req && e.req.removeListener("finish", c), e.removeListener("end", m), e.removeListener("close", m), e.removeListener("finish", c), e.removeListener("end", S), e.removeListener("error", k), e.removeListener("close", q);
            };
          };
        }, 6233: function(_e) {
          _e.exports = function() {
            throw new Error("Readable.from is not available in the browser");
          };
        }, 7295: function(_e, fe, R) {
          var J, E = R(3690).q, t = E.ERR_MISSING_ARGS, e = E.ERR_STREAM_DESTROYED;
          function h(n) {
            if (n) throw n;
          }
          function p(n, c, f, S) {
            S = /* @__PURE__ */ function(F) {
              var te = !1;
              return function() {
                te || (te = !0, F.apply(void 0, arguments));
              };
            }(S);
            var k = !1;
            n.on("close", function() {
              k = !0;
            }), J === void 0 && (J = R(8800)), J(n, { readable: c, writable: f }, function(F) {
              if (F) return S(F);
              k = !0, S();
            });
            var q = !1;
            return function(F) {
              if (!k && !q) return q = !0, function(te) {
                return te.setHeader && typeof te.abort == "function";
              }(n) ? n.abort() : typeof n.destroy == "function" ? n.destroy() : void S(F || new e("pipe"));
            };
          }
          function o(n) {
            n();
          }
          function v(n, c) {
            return n.pipe(c);
          }
          function m(n) {
            return n.length ? typeof n[n.length - 1] != "function" ? h : n.pop() : h;
          }
          _e.exports = function() {
            for (var n = arguments.length, c = new Array(n), f = 0; f < n; f++) c[f] = arguments[f];
            var S, k = m(c);
            if (Array.isArray(c[0]) && (c = c[0]), c.length < 2) throw new t("streams");
            var q = c.map(function(F, te) {
              var P = te < c.length - 1;
              return p(F, P, te > 0, function(Q) {
                S || (S = Q), Q && q.forEach(o), P || (q.forEach(o), k(S));
              });
            });
            return c.reduce(v);
          };
        }, 7269: function(_e, fe, R) {
          var J = R(3690).q.ERR_INVALID_OPT_VALUE;
          _e.exports = { getHighWaterMark: function(E, t, e, h) {
            var p = function(o, v, m) {
              return o.highWaterMark != null ? o.highWaterMark : v ? o[m] : null;
            }(t, h, e);
            if (p != null) {
              if (!isFinite(p) || Math.floor(p) !== p || p < 0) throw new J(h ? e : "highWaterMark", p);
              return Math.floor(p);
            }
            return E.objectMode ? 16 : 16384;
          } };
        }, 9299: function(_e, fe, R) {
          _e.exports = R(1159).EventEmitter;
        }, 7503: function(_e, fe, R) {
          var J = R(8387).Buffer, E = J.isEncoding || function(f) {
            switch ((f = "" + f) && f.toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
              case "raw":
                return !0;
              default:
                return !1;
            }
          };
          function t(f) {
            var S;
            switch (this.encoding = function(k) {
              var q = function(F) {
                if (!F) return "utf8";
                for (var te; ; ) switch (F) {
                  case "utf8":
                  case "utf-8":
                    return "utf8";
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return "utf16le";
                  case "latin1":
                  case "binary":
                    return "latin1";
                  case "base64":
                  case "ascii":
                  case "hex":
                    return F;
                  default:
                    if (te) return;
                    F = ("" + F).toLowerCase(), te = !0;
                }
              }(k);
              if (typeof q != "string" && (J.isEncoding === E || !E(k))) throw new Error("Unknown encoding: " + k);
              return q || k;
            }(f), this.encoding) {
              case "utf16le":
                this.text = p, this.end = o, S = 4;
                break;
              case "utf8":
                this.fillLast = h, S = 4;
                break;
              case "base64":
                this.text = v, this.end = m, S = 3;
                break;
              default:
                return this.write = n, void (this.end = c);
            }
            this.lastNeed = 0, this.lastTotal = 0, this.lastChar = J.allocUnsafe(S);
          }
          function e(f) {
            return f <= 127 ? 0 : f >> 5 == 6 ? 2 : f >> 4 == 14 ? 3 : f >> 3 == 30 ? 4 : f >> 6 == 2 ? -1 : -2;
          }
          function h(f) {
            var S = this.lastTotal - this.lastNeed, k = function(q, F, te) {
              if ((192 & F[0]) != 128) return q.lastNeed = 0, "�";
              if (q.lastNeed > 1 && F.length > 1) {
                if ((192 & F[1]) != 128) return q.lastNeed = 1, "�";
                if (q.lastNeed > 2 && F.length > 2 && (192 & F[2]) != 128) return q.lastNeed = 2, "�";
              }
            }(this, f);
            return k !== void 0 ? k : this.lastNeed <= f.length ? (f.copy(this.lastChar, S, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (f.copy(this.lastChar, S, 0, f.length), void (this.lastNeed -= f.length));
          }
          function p(f, S) {
            if ((f.length - S) % 2 == 0) {
              var k = f.toString("utf16le", S);
              if (k) {
                var q = k.charCodeAt(k.length - 1);
                if (q >= 55296 && q <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = f[f.length - 2], this.lastChar[1] = f[f.length - 1], k.slice(0, -1);
              }
              return k;
            }
            return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = f[f.length - 1], f.toString("utf16le", S, f.length - 1);
          }
          function o(f) {
            var S = f && f.length ? this.write(f) : "";
            if (this.lastNeed) {
              var k = this.lastTotal - this.lastNeed;
              return S + this.lastChar.toString("utf16le", 0, k);
            }
            return S;
          }
          function v(f, S) {
            var k = (f.length - S) % 3;
            return k === 0 ? f.toString("base64", S) : (this.lastNeed = 3 - k, this.lastTotal = 3, k === 1 ? this.lastChar[0] = f[f.length - 1] : (this.lastChar[0] = f[f.length - 2], this.lastChar[1] = f[f.length - 1]), f.toString("base64", S, f.length - k));
          }
          function m(f) {
            var S = f && f.length ? this.write(f) : "";
            return this.lastNeed ? S + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : S;
          }
          function n(f) {
            return f.toString(this.encoding);
          }
          function c(f) {
            return f && f.length ? this.write(f) : "";
          }
          fe.s = t, t.prototype.write = function(f) {
            if (f.length === 0) return "";
            var S, k;
            if (this.lastNeed) {
              if ((S = this.fillLast(f)) === void 0) return "";
              k = this.lastNeed, this.lastNeed = 0;
            } else k = 0;
            return k < f.length ? S ? S + this.text(f, k) : this.text(f, k) : S || "";
          }, t.prototype.end = function(f) {
            var S = f && f.length ? this.write(f) : "";
            return this.lastNeed ? S + "�" : S;
          }, t.prototype.text = function(f, S) {
            var k = function(F, te, P) {
              var Q = te.length - 1;
              if (Q < P) return 0;
              var se = e(te[Q]);
              return se >= 0 ? (se > 0 && (F.lastNeed = se - 1), se) : --Q < P || se === -2 ? 0 : (se = e(te[Q])) >= 0 ? (se > 0 && (F.lastNeed = se - 2), se) : --Q < P || se === -2 ? 0 : (se = e(te[Q])) >= 0 ? (se > 0 && (se === 2 ? se = 0 : F.lastNeed = se - 3), se) : 0;
            }(this, f, S);
            if (!this.lastNeed) return f.toString("utf8", S);
            this.lastTotal = k;
            var q = f.length - (k - this.lastNeed);
            return f.copy(this.lastChar, 0, q), f.toString("utf8", S, q);
          }, t.prototype.fillLast = function(f) {
            if (this.lastNeed <= f.length) return f.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
            f.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, f.length), this.lastNeed -= f.length;
          };
        }, 1067: function(_e, fe, R) {
          var J;
          (function(E, t) {
            var e = "function", h = "undefined", p = "object", o = "string", v = "major", m = "model", n = "name", c = "type", f = "vendor", S = "version", k = "architecture", q = "console", F = "mobile", te = "tablet", P = "smarttv", Q = "wearable", se = "embedded", K = "Amazon", ie = "Apple", ge = "ASUS", Ne = "BlackBerry", ee = "Browser", Oe = "Chrome", Ge = "Firefox", Xe = "Google", Ce = "Huawei", Ue = "LG", Je = "Microsoft", st = "Motorola", we = "Opera", Be = "Samsung", At = "Sharp", ht = "Sony", je = "Xiaomi", it = "Zebra", ve = "Facebook", Se = "Chromium OS", Ye = "Mac OS", d = function(Ve) {
              for (var ot = {}, bt = 0; bt < Ve.length; bt++) ot[Ve[bt].toUpperCase()] = Ve[bt];
              return ot;
            }, l = function(Ve, ot) {
              return typeof Ve === o && T(ot).indexOf(T(Ve)) !== -1;
            }, T = function(Ve) {
              return Ve.toLowerCase();
            }, b = function(Ve, ot) {
              if (typeof Ve === o) return Ve = Ve.replace(/^\s\s*/, ""), typeof ot === h ? Ve : Ve.substring(0, 500);
            }, $ = function(Ve, ot) {
              for (var bt, dt, Yt, Ot, Ht, Ut, fn = 0; fn < ot.length && !Ht; ) {
                var Tn = ot[fn], Fn = ot[fn + 1];
                for (bt = dt = 0; bt < Tn.length && !Ht && Tn[bt]; ) if (Ht = Tn[bt++].exec(Ve)) for (Yt = 0; Yt < Fn.length; Yt++) Ut = Ht[++dt], typeof (Ot = Fn[Yt]) === p && Ot.length > 0 ? Ot.length === 2 ? typeof Ot[1] == e ? this[Ot[0]] = Ot[1].call(this, Ut) : this[Ot[0]] = Ot[1] : Ot.length === 3 ? typeof Ot[1] !== e || Ot[1].exec && Ot[1].test ? this[Ot[0]] = Ut ? Ut.replace(Ot[1], Ot[2]) : t : this[Ot[0]] = Ut ? Ot[1].call(this, Ut, Ot[2]) : t : Ot.length === 4 && (this[Ot[0]] = Ut ? Ot[3].call(this, Ut.replace(Ot[1], Ot[2])) : t) : this[Ot] = Ut || t;
                fn += 2;
              }
            }, W = function(Ve, ot) {
              for (var bt in ot) if (typeof ot[bt] === p && ot[bt].length > 0) {
                for (var dt = 0; dt < ot[bt].length; dt++) if (l(ot[bt][dt], Ve)) return bt === "?" ? t : bt;
              } else if (l(ot[bt], Ve)) return bt === "?" ? t : bt;
              return Ve;
            }, Ie = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, $e = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [S, [n, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [S, [n, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [n, S], [/opios[\/ ]+([\w\.]+)/i], [S, [n, we + " Mini"]], [/\bopr\/([\w\.]+)/i], [S, [n, we]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [S, [n, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [n, S], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [S, [n, "UC" + ee]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [S, [n, "WeChat"]], [/konqueror\/([\w\.]+)/i], [S, [n, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [S, [n, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [S, [n, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [S, [n, "Smart Lenovo " + ee]], [/(avast|avg)\/([\w\.]+)/i], [[n, /(.+)/, "$1 Secure " + ee], S], [/\bfocus\/([\w\.]+)/i], [S, [n, Ge + " Focus"]], [/\bopt\/([\w\.]+)/i], [S, [n, we + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [S, [n, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [S, [n, "Dolphin"]], [/coast\/([\w\.]+)/i], [S, [n, we + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [S, [n, "MIUI " + ee]], [/fxios\/([-\w\.]+)/i], [S, [n, Ge]], [/\bqihu|(qi?ho?o?|360)browser/i], [[n, "360 " + ee]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[n, /(.+)/, "$1 " + ee], S], [/samsungbrowser\/([\w\.]+)/i], [S, [n, Be + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[n, /_/g, " "], S], [/metasr[\/ ]?([\d\.]+)/i], [S, [n, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[n, "Sogou Mobile"], S], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [n, S], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [n], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[n, ve], S], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [n, S], [/\bgsa\/([\w\.]+) .*safari\//i], [S, [n, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [S, [n, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [S, [n, Oe + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[n, Oe + " WebView"], S], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [S, [n, "Android " + ee]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [n, S], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [S, [n, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [S, n], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [n, [S, W, { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }]], [/(webkit|khtml)\/([\w\.]+)/i], [n, S], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[n, "Netscape"], S], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [S, [n, Ge + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [n, S], [/(cobalt)\/([\w\.]+)/i], [n, [S, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[k, "amd64"]], [/(ia32(?=;))/i], [[k, T]], [/((?:i[346]|x)86)[;\)]/i], [[k, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[k, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[k, "armhf"]], [/windows (ce|mobile); ppc;/i], [[k, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[k, /ower/, "", T]], [/(sun4\w)[;\)]/i], [[k, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[k, T]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [m, [f, Be], [c, te]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [m, [f, Be], [c, F]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [m, [f, ie], [c, F]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [m, [f, ie], [c, te]], [/(macintosh);/i], [m, [f, ie]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [m, [f, At], [c, F]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [m, [f, Ce], [c, te]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [m, [f, Ce], [c, F]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[m, /_/g, " "], [f, je], [c, F]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[m, /_/g, " "], [f, je], [c, te]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [m, [f, "OPPO"], [c, F]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [m, [f, "Vivo"], [c, F]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [m, [f, "Realme"], [c, F]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [m, [f, st], [c, F]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [m, [f, st], [c, te]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [m, [f, Ue], [c, te]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [m, [f, Ue], [c, F]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [m, [f, "Lenovo"], [c, te]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[m, /_/g, " "], [f, "Nokia"], [c, F]], [/(pixel c)\b/i], [m, [f, Xe], [c, te]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [m, [f, Xe], [c, F]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [m, [f, ht], [c, F]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[m, "Xperia Tablet"], [f, ht], [c, te]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [m, [f, "OnePlus"], [c, F]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [m, [f, K], [c, te]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[m, /(.+)/g, "Fire Phone $1"], [f, K], [c, F]], [/(playbook);[-\w\),; ]+(rim)/i], [m, f, [c, te]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [m, [f, Ne], [c, F]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [m, [f, ge], [c, te]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [m, [f, ge], [c, F]], [/(nexus 9)/i], [m, [f, "HTC"], [c, te]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [f, [m, /_/g, " "], [c, F]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [m, [f, "Acer"], [c, te]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [m, [f, "Meizu"], [c, F]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [m, [f, "Ulefone"], [c, F]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [f, m, [c, F]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [f, m, [c, te]], [/(surface duo)/i], [m, [f, Je], [c, te]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [m, [f, "Fairphone"], [c, F]], [/(u304aa)/i], [m, [f, "AT&T"], [c, F]], [/\bsie-(\w*)/i], [m, [f, "Siemens"], [c, F]], [/\b(rct\w+) b/i], [m, [f, "RCA"], [c, te]], [/\b(venue[\d ]{2,7}) b/i], [m, [f, "Dell"], [c, te]], [/\b(q(?:mv|ta)\w+) b/i], [m, [f, "Verizon"], [c, te]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [m, [f, "Barnes & Noble"], [c, te]], [/\b(tm\d{3}\w+) b/i], [m, [f, "NuVision"], [c, te]], [/\b(k88) b/i], [m, [f, "ZTE"], [c, te]], [/\b(nx\d{3}j) b/i], [m, [f, "ZTE"], [c, F]], [/\b(gen\d{3}) b.+49h/i], [m, [f, "Swiss"], [c, F]], [/\b(zur\d{3}) b/i], [m, [f, "Swiss"], [c, te]], [/\b((zeki)?tb.*\b) b/i], [m, [f, "Zeki"], [c, te]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[f, "Dragon Touch"], m, [c, te]], [/\b(ns-?\w{0,9}) b/i], [m, [f, "Insignia"], [c, te]], [/\b((nxa|next)-?\w{0,9}) b/i], [m, [f, "NextBook"], [c, te]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[f, "Voice"], m, [c, F]], [/\b(lvtel\-)?(v1[12]) b/i], [[f, "LvTel"], m, [c, F]], [/\b(ph-1) /i], [m, [f, "Essential"], [c, F]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [m, [f, "Envizen"], [c, te]], [/\b(trio[-\w\. ]+) b/i], [m, [f, "MachSpeed"], [c, te]], [/\btu_(1491) b/i], [m, [f, "Rotor"], [c, te]], [/(shield[\w ]+) b/i], [m, [f, "Nvidia"], [c, te]], [/(sprint) (\w+)/i], [f, m, [c, F]], [/(kin\.[onetw]{3})/i], [[m, /\./g, " "], [f, Je], [c, F]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [m, [f, it], [c, te]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [m, [f, it], [c, F]], [/smart-tv.+(samsung)/i], [f, [c, P]], [/hbbtv.+maple;(\d+)/i], [[m, /^/, "SmartTV"], [f, Be], [c, P]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[f, Ue], [c, P]], [/(apple) ?tv/i], [f, [m, ie + " TV"], [c, P]], [/crkey/i], [[m, Oe + "cast"], [f, Xe], [c, P]], [/droid.+aft(\w+)( bui|\))/i], [m, [f, K], [c, P]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [m, [f, At], [c, P]], [/(bravia[\w ]+)( bui|\))/i], [m, [f, ht], [c, P]], [/(mitv-\w{5}) bui/i], [m, [f, je], [c, P]], [/Hbbtv.*(technisat) (.*);/i], [f, m, [c, P]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[f, b], [m, b], [c, P]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[c, P]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [f, m, [c, q]], [/droid.+; (shield) bui/i], [m, [f, "Nvidia"], [c, q]], [/(playstation [345portablevi]+)/i], [m, [f, ht], [c, q]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [m, [f, Je], [c, q]], [/((pebble))app/i], [f, m, [c, Q]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [m, [f, ie], [c, Q]], [/droid.+; (glass) \d/i], [m, [f, Xe], [c, Q]], [/droid.+; (wt63?0{2,3})\)/i], [m, [f, it], [c, Q]], [/(quest( 2| pro)?)/i], [m, [f, ve], [c, Q]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [f, [c, se]], [/(aeobc)\b/i], [m, [f, K], [c, se]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [m, [c, F]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [m, [c, te]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[c, te]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[c, F]], [/(android[-\w\. ]{0,9});.+buil/i], [m, [f, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [S, [n, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [S, [n, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [n, S], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [S, n]], os: [[/microsoft (windows) (vista|xp)/i], [n, S], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [n, [S, W, Ie]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[S, W, Ie], [n, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[S, /_/g, "."], [n, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[n, Ye], [S, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [S, n], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [n, S], [/\(bb(10);/i], [S, [n, Ne]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [S, [n, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [S, [n, Ge + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [S, [n, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [S, [n, "watchOS"]], [/crkey\/([\d\.]+)/i], [S, [n, Oe + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[n, Se], S], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [n, S], [/(sunos) ?([\w\.\d]*)/i], [[n, "Solaris"], S], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [n, S]] }, Ze = function(Ve, ot) {
              if (typeof Ve === p && (ot = Ve, Ve = t), !(this instanceof Ze)) return new Ze(Ve, ot).getResult();
              var bt = typeof E !== h && E.navigator ? E.navigator : t, dt = Ve || (bt && bt.userAgent ? bt.userAgent : ""), Yt = bt && bt.userAgentData ? bt.userAgentData : t, Ot = ot ? function(Ut, fn) {
                var Tn = {};
                for (var Fn in Ut) fn[Fn] && fn[Fn].length % 2 == 0 ? Tn[Fn] = fn[Fn].concat(Ut[Fn]) : Tn[Fn] = Ut[Fn];
                return Tn;
              }($e, ot) : $e, Ht = bt && bt.userAgent == dt;
              return this.getBrowser = function() {
                var Ut, fn = {};
                return fn[n] = t, fn[S] = t, $.call(fn, dt, Ot.browser), fn[v] = typeof (Ut = fn[S]) === o ? Ut.replace(/[^\d\.]/g, "").split(".")[0] : t, Ht && bt && bt.brave && typeof bt.brave.isBrave == e && (fn[n] = "Brave"), fn;
              }, this.getCPU = function() {
                var Ut = {};
                return Ut[k] = t, $.call(Ut, dt, Ot.cpu), Ut;
              }, this.getDevice = function() {
                var Ut = {};
                return Ut[f] = t, Ut[m] = t, Ut[c] = t, $.call(Ut, dt, Ot.device), Ht && !Ut[c] && Yt && Yt.mobile && (Ut[c] = F), Ht && Ut[m] == "Macintosh" && bt && typeof bt.standalone !== h && bt.maxTouchPoints && bt.maxTouchPoints > 2 && (Ut[m] = "iPad", Ut[c] = te), Ut;
              }, this.getEngine = function() {
                var Ut = {};
                return Ut[n] = t, Ut[S] = t, $.call(Ut, dt, Ot.engine), Ut;
              }, this.getOS = function() {
                var Ut = {};
                return Ut[n] = t, Ut[S] = t, $.call(Ut, dt, Ot.os), Ht && !Ut[n] && Yt && Yt.platform != "Unknown" && (Ut[n] = Yt.platform.replace(/chrome os/i, Se).replace(/macos/i, Ye)), Ut;
              }, this.getResult = function() {
                return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
              }, this.getUA = function() {
                return dt;
              }, this.setUA = function(Ut) {
                return dt = typeof Ut === o && Ut.length > 500 ? b(Ut, 500) : Ut, this;
              }, this.setUA(dt), this;
            };
            Ze.VERSION = "1.0.37", Ze.BROWSER = d([n, S, v]), Ze.CPU = d([k]), Ze.DEVICE = d([m, f, c, q, F, P, te, Q, se]), Ze.ENGINE = Ze.OS = d([n, S]), typeof fe !== h ? (_e.exports && (fe = _e.exports = Ze), fe.UAParser = Ze) : R.amdO ? (J = (function() {
              return Ze;
            }).call(fe, R, fe, _e)) === t || (_e.exports = J) : typeof E !== h && (E.UAParser = Ze);
            var xe = typeof E !== h && (E.jQuery || E.Zepto);
            if (xe && !xe.ua) {
              var Me = new Ze();
              xe.ua = Me.getResult(), xe.ua.get = function() {
                return Me.getUA();
              }, xe.ua.set = function(Ve) {
                Me.setUA(Ve);
                var ot = Me.getResult();
                for (var bt in ot) xe.ua[bt] = ot[bt];
              };
            }
          })(typeof window == "object" ? window : this);
        }, 7839: function(_e, fe, R) {
          function J(E) {
            try {
              if (!R.g.localStorage) return !1;
            } catch {
              return !1;
            }
            var t = R.g.localStorage[E];
            return t != null && String(t).toLowerCase() === "true";
          }
          _e.exports = function(E, t) {
            if (J("noDeprecation")) return E;
            var e = !1;
            return function() {
              if (!e) {
                if (J("throwDeprecation")) throw new Error(t);
                J("traceDeprecation") ? console.trace(t) : console.warn(t), e = !0;
              }
              return E.apply(this, arguments);
            };
          };
        }, 9862: function() {
        }, 964: function() {
        }, 3165: function(_e) {
          _e.exports = JSON.parse('["mni-beng-in","mni-mtei-in","sat-deva-in","sat-olck-in","shi-latn-ma","shi-tfng-ma","vai-latn-lr","vai-vaii-lr","yue-hans-cn","yue-hant-hk","az-arab-ir","az-cyrl-az","az-latn-az","bm-nkoo-ml","bs-cyrl-ba","bs-latn-ba","en-dsrt-us","ff-adlm-gn","ff-latn-sn","ha-arab-ng","hi-latn-in","iu-latn-ca","ks-arab-in","ks-deva-in","mn-mong-cn","ms-arab-my","pa-arab-pk","pa-guru-in","sd-arab-pk","sd-deva-in","sr-cyrl-rs","sr-latn-rs","su-latn-id","uz-arab-af","uz-cyrl-uz","uz-latn-uz","zh-hans-cn","zh-hant-tw","mni-beng","sat-olck","shi-tfng","vai-vaii","yue-hant","az-latn","bs-latn","ff-latn","jbo-001","ks-arab","pa-guru","prg-001","sd-arab","sr-cyrl","su-latn","uz-latn","zh-hans","agq-cm","ar-001","arn-cl","asa-tz","ast-es","bas-cm","bem-zm","bez-tz","bgn-pk","blt-vn","brx-in","bss-cm","byn-er","cad-us","cch-ng","ccp-bd","ceb-ph","cgg-ug","chr-us","cic-us","ckb-iq","dav-ke","dje-ne","doi-in","dsb-de","dua-cm","dyo-sn","ebu-ke","eo-001","ewo-cm","fil-ph","fur-it","gaa-gh","gez-et","gsw-ch","guz-ke","haw-us","hsb-de","ia-001","ife-tg","io-001","jgo-cm","jmc-tz","kab-dz","kaj-ng","kam-ke","kcg-ng","kde-tz","kea-cv","ken-cm","khq-ml","kkj-cm","kln-ke","kok-in","kpe-lr","ksb-tz","ksf-cm","ksh-de","lag-tz","lkt-us","lrc-ir","luo-ke","luy-ke","mai-in","mas-ke","mer-ke","mfe-mu","mgh-mz","mgo-cm","moh-ca","mua-cm","mus-us","myv-ru","mzn-ir","naq-na","nds-de","nmg-cm","nnh-cm","nqo-gn","nso-za","nus-ss","nyn-ug","osa-us","pcm-ng","quc-gt","rof-tz","rwk-tz","sah-ru","saq-ke","sbp-tz","scn-it","sdh-ir","seh-mz","ses-ml","sid-et","sma-se","smj-se","smn-fi","sms-fi","ssy-er","syr-iq","szl-pl","teo-ug","tig-er","trv-tw","trw-pk","twq-ne","tzm-ma","vo-001","vun-tz","wae-ch","wal-et","wbp-au","xog-ug","yav-cm","yi-001","zgh-ma","aa-et","af-za","ak-gh","am-et","an-es","as-in","ba-ru","be-by","bg-bg","bm-ml","bn-bd","bo-cn","br-fr","ca-es","ce-ru","co-fr","cs-cz","cu-ru","cv-ru","cy-gb","da-dk","de-de","dv-mv","dz-bt","ee-gh","el-gr","en-us","es-es","et-ee","eu-es","fa-ir","fi-fi","fo-fo","fr-fr","fy-nl","ga-ie","gd-gb","gl-es","gn-py","gu-in","gv-im","ha-ng","he-il","hi-in","hr-hr","hu-hu","hy-am","id-id","ig-ng","ii-cn","is-is","it-it","iu-ca","ja-jp","jv-id","ka-ge","ki-ke","kk-kz","kl-gl","km-kh","kn-in","ko-kr","ku-tr","kw-gb","ky-kg","lb-lu","lg-ug","ln-cd","lo-la","lt-lt","lu-cd","lv-lv","mg-mg","mi-nz","mk-mk","ml-in","mn-mn","mr-in","ms-my","mt-mt","my-mm","nb-no","nd-zw","ne-np","nl-nl","nn-no","nr-za","nv-us","ny-mw","oc-fr","om-et","or-in","os-ge","pl-pl","ps-af","pt-br","qu-pe","rm-ch","rn-bi","ro-ro","ru-ru","rw-rw","sa-in","sc-it","se-no","sg-cf","si-lk","sk-sk","sl-si","sn-zw","so-so","sq-al","ss-za","st-za","sv-se","sw-tz","ta-in","te-in","tg-tj","th-th","ti-et","tk-tm","tn-za","to-to","tr-tr","ts-za","tt-ru","ug-cn","uk-ua","ur-pk","ve-za","vi-vn","wa-be","wo-sn","xh-za","yo-ng","zu-za"]');
        }, 5813: function(_e) {
          _e.exports = JSON.parse('[{"from":{"field":"script","value":"qaai"},"to":{"field":"script","value":"zinh"}},{"from":{"field":"region","value":"bu"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"ct"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"dd"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"dy"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"fx"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"hv"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"jt"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"mi"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"nh"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"nq"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"pu"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"pz"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"qu"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"rh"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"tp"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"uk"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"vd"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"wk"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"yd"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"zr"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"230"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"280"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"736"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"886"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"958"},"to":{"field":"region","value":"aa"}},{"from":{"field":"region","value":"020"},"to":{"field":"region","value":"ad"}},{"from":{"field":"region","value":"784"},"to":{"field":"region","value":"ae"}},{"from":{"field":"region","value":"004"},"to":{"field":"region","value":"af"}},{"from":{"field":"region","value":"028"},"to":{"field":"region","value":"ag"}},{"from":{"field":"region","value":"660"},"to":{"field":"region","value":"ai"}},{"from":{"field":"region","value":"008"},"to":{"field":"region","value":"al"}},{"from":{"field":"region","value":"051"},"to":{"field":"region","value":"am"}},{"from":{"field":"region","value":"024"},"to":{"field":"region","value":"ao"}},{"from":{"field":"region","value":"010"},"to":{"field":"region","value":"aq"}},{"from":{"field":"region","value":"032"},"to":{"field":"region","value":"ar"}},{"from":{"field":"region","value":"016"},"to":{"field":"region","value":"as"}},{"from":{"field":"region","value":"040"},"to":{"field":"region","value":"at"}},{"from":{"field":"region","value":"036"},"to":{"field":"region","value":"au"}},{"from":{"field":"region","value":"533"},"to":{"field":"region","value":"aw"}},{"from":{"field":"region","value":"248"},"to":{"field":"region","value":"ax"}},{"from":{"field":"region","value":"031"},"to":{"field":"region","value":"az"}},{"from":{"field":"region","value":"070"},"to":{"field":"region","value":"ba"}},{"from":{"field":"region","value":"052"},"to":{"field":"region","value":"bb"}},{"from":{"field":"region","value":"050"},"to":{"field":"region","value":"bd"}},{"from":{"field":"region","value":"056"},"to":{"field":"region","value":"be"}},{"from":{"field":"region","value":"854"},"to":{"field":"region","value":"bf"}},{"from":{"field":"region","value":"100"},"to":{"field":"region","value":"bg"}},{"from":{"field":"region","value":"048"},"to":{"field":"region","value":"bh"}},{"from":{"field":"region","value":"108"},"to":{"field":"region","value":"bi"}},{"from":{"field":"region","value":"204"},"to":{"field":"region","value":"bj"}},{"from":{"field":"region","value":"652"},"to":{"field":"region","value":"bl"}},{"from":{"field":"region","value":"060"},"to":{"field":"region","value":"bm"}},{"from":{"field":"region","value":"096"},"to":{"field":"region","value":"bn"}},{"from":{"field":"region","value":"068"},"to":{"field":"region","value":"bo"}},{"from":{"field":"region","value":"535"},"to":{"field":"region","value":"bq"}},{"from":{"field":"region","value":"076"},"to":{"field":"region","value":"br"}},{"from":{"field":"region","value":"044"},"to":{"field":"region","value":"bs"}},{"from":{"field":"region","value":"064"},"to":{"field":"region","value":"bt"}},{"from":{"field":"region","value":"104"},"to":{"field":"region","value":"mm"}},{"from":{"field":"region","value":"074"},"to":{"field":"region","value":"bv"}},{"from":{"field":"region","value":"072"},"to":{"field":"region","value":"bw"}},{"from":{"field":"region","value":"112"},"to":{"field":"region","value":"by"}},{"from":{"field":"region","value":"084"},"to":{"field":"region","value":"bz"}},{"from":{"field":"region","value":"124"},"to":{"field":"region","value":"ca"}},{"from":{"field":"region","value":"166"},"to":{"field":"region","value":"cc"}},{"from":{"field":"region","value":"180"},"to":{"field":"region","value":"cd"}},{"from":{"field":"region","value":"140"},"to":{"field":"region","value":"cf"}},{"from":{"field":"region","value":"178"},"to":{"field":"region","value":"cg"}},{"from":{"field":"region","value":"756"},"to":{"field":"region","value":"ch"}},{"from":{"field":"region","value":"384"},"to":{"field":"region","value":"ci"}},{"from":{"field":"region","value":"184"},"to":{"field":"region","value":"ck"}},{"from":{"field":"region","value":"152"},"to":{"field":"region","value":"cl"}},{"from":{"field":"region","value":"120"},"to":{"field":"region","value":"cm"}},{"from":{"field":"region","value":"156"},"to":{"field":"region","value":"cn"}},{"from":{"field":"region","value":"170"},"to":{"field":"region","value":"co"}},{"from":{"field":"region","value":"188"},"to":{"field":"region","value":"cr"}},{"from":{"field":"region","value":"192"},"to":{"field":"region","value":"cu"}},{"from":{"field":"region","value":"132"},"to":{"field":"region","value":"cv"}},{"from":{"field":"region","value":"531"},"to":{"field":"region","value":"cw"}},{"from":{"field":"region","value":"162"},"to":{"field":"region","value":"cx"}},{"from":{"field":"region","value":"196"},"to":{"field":"region","value":"cy"}},{"from":{"field":"region","value":"203"},"to":{"field":"region","value":"cz"}},{"from":{"field":"region","value":"278"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"276"},"to":{"field":"region","value":"de"}},{"from":{"field":"region","value":"262"},"to":{"field":"region","value":"dj"}},{"from":{"field":"region","value":"208"},"to":{"field":"region","value":"dk"}},{"from":{"field":"region","value":"212"},"to":{"field":"region","value":"dm"}},{"from":{"field":"region","value":"214"},"to":{"field":"region","value":"do"}},{"from":{"field":"region","value":"012"},"to":{"field":"region","value":"dz"}},{"from":{"field":"region","value":"218"},"to":{"field":"region","value":"ec"}},{"from":{"field":"region","value":"233"},"to":{"field":"region","value":"ee"}},{"from":{"field":"region","value":"818"},"to":{"field":"region","value":"eg"}},{"from":{"field":"region","value":"732"},"to":{"field":"region","value":"eh"}},{"from":{"field":"region","value":"232"},"to":{"field":"region","value":"er"}},{"from":{"field":"region","value":"724"},"to":{"field":"region","value":"es"}},{"from":{"field":"region","value":"231"},"to":{"field":"region","value":"et"}},{"from":{"field":"region","value":"246"},"to":{"field":"region","value":"fi"}},{"from":{"field":"region","value":"242"},"to":{"field":"region","value":"fj"}},{"from":{"field":"region","value":"238"},"to":{"field":"region","value":"fk"}},{"from":{"field":"region","value":"583"},"to":{"field":"region","value":"fm"}},{"from":{"field":"region","value":"234"},"to":{"field":"region","value":"fo"}},{"from":{"field":"region","value":"250"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"249"},"to":{"field":"region","value":"fr"}},{"from":{"field":"region","value":"266"},"to":{"field":"region","value":"ga"}},{"from":{"field":"region","value":"826"},"to":{"field":"region","value":"gb"}},{"from":{"field":"region","value":"308"},"to":{"field":"region","value":"gd"}},{"from":{"field":"region","value":"268"},"to":{"field":"region","value":"ge"}},{"from":{"field":"region","value":"254"},"to":{"field":"region","value":"gf"}},{"from":{"field":"region","value":"831"},"to":{"field":"region","value":"gg"}},{"from":{"field":"region","value":"288"},"to":{"field":"region","value":"gh"}},{"from":{"field":"region","value":"292"},"to":{"field":"region","value":"gi"}},{"from":{"field":"region","value":"304"},"to":{"field":"region","value":"gl"}},{"from":{"field":"region","value":"270"},"to":{"field":"region","value":"gm"}},{"from":{"field":"region","value":"324"},"to":{"field":"region","value":"gn"}},{"from":{"field":"region","value":"312"},"to":{"field":"region","value":"gp"}},{"from":{"field":"region","value":"226"},"to":{"field":"region","value":"gq"}},{"from":{"field":"region","value":"300"},"to":{"field":"region","value":"gr"}},{"from":{"field":"region","value":"239"},"to":{"field":"region","value":"gs"}},{"from":{"field":"region","value":"320"},"to":{"field":"region","value":"gt"}},{"from":{"field":"region","value":"316"},"to":{"field":"region","value":"gu"}},{"from":{"field":"region","value":"624"},"to":{"field":"region","value":"gw"}},{"from":{"field":"region","value":"328"},"to":{"field":"region","value":"gy"}},{"from":{"field":"region","value":"344"},"to":{"field":"region","value":"hk"}},{"from":{"field":"region","value":"334"},"to":{"field":"region","value":"hm"}},{"from":{"field":"region","value":"340"},"to":{"field":"region","value":"hn"}},{"from":{"field":"region","value":"191"},"to":{"field":"region","value":"hr"}},{"from":{"field":"region","value":"332"},"to":{"field":"region","value":"ht"}},{"from":{"field":"region","value":"348"},"to":{"field":"region","value":"hu"}},{"from":{"field":"region","value":"360"},"to":{"field":"region","value":"id"}},{"from":{"field":"region","value":"372"},"to":{"field":"region","value":"ie"}},{"from":{"field":"region","value":"376"},"to":{"field":"region","value":"il"}},{"from":{"field":"region","value":"833"},"to":{"field":"region","value":"im"}},{"from":{"field":"region","value":"356"},"to":{"field":"region","value":"in"}},{"from":{"field":"region","value":"086"},"to":{"field":"region","value":"io"}},{"from":{"field":"region","value":"368"},"to":{"field":"region","value":"iq"}},{"from":{"field":"region","value":"364"},"to":{"field":"region","value":"ir"}},{"from":{"field":"region","value":"352"},"to":{"field":"region","value":"is"}},{"from":{"field":"region","value":"380"},"to":{"field":"region","value":"it"}},{"from":{"field":"region","value":"832"},"to":{"field":"region","value":"je"}},{"from":{"field":"region","value":"388"},"to":{"field":"region","value":"jm"}},{"from":{"field":"region","value":"400"},"to":{"field":"region","value":"jo"}},{"from":{"field":"region","value":"392"},"to":{"field":"region","value":"jp"}},{"from":{"field":"region","value":"404"},"to":{"field":"region","value":"ke"}},{"from":{"field":"region","value":"417"},"to":{"field":"region","value":"kg"}},{"from":{"field":"region","value":"116"},"to":{"field":"region","value":"kh"}},{"from":{"field":"region","value":"296"},"to":{"field":"region","value":"ki"}},{"from":{"field":"region","value":"174"},"to":{"field":"region","value":"km"}},{"from":{"field":"region","value":"659"},"to":{"field":"region","value":"kn"}},{"from":{"field":"region","value":"408"},"to":{"field":"region","value":"kp"}},{"from":{"field":"region","value":"410"},"to":{"field":"region","value":"kr"}},{"from":{"field":"region","value":"414"},"to":{"field":"region","value":"kw"}},{"from":{"field":"region","value":"136"},"to":{"field":"region","value":"ky"}},{"from":{"field":"region","value":"398"},"to":{"field":"region","value":"kz"}},{"from":{"field":"region","value":"418"},"to":{"field":"region","value":"la"}},{"from":{"field":"region","value":"422"},"to":{"field":"region","value":"lb"}},{"from":{"field":"region","value":"662"},"to":{"field":"region","value":"lc"}},{"from":{"field":"region","value":"438"},"to":{"field":"region","value":"li"}},{"from":{"field":"region","value":"144"},"to":{"field":"region","value":"lk"}},{"from":{"field":"region","value":"430"},"to":{"field":"region","value":"lr"}},{"from":{"field":"region","value":"426"},"to":{"field":"region","value":"ls"}},{"from":{"field":"region","value":"440"},"to":{"field":"region","value":"lt"}},{"from":{"field":"region","value":"442"},"to":{"field":"region","value":"lu"}},{"from":{"field":"region","value":"428"},"to":{"field":"region","value":"lv"}},{"from":{"field":"region","value":"434"},"to":{"field":"region","value":"ly"}},{"from":{"field":"region","value":"504"},"to":{"field":"region","value":"ma"}},{"from":{"field":"region","value":"492"},"to":{"field":"region","value":"mc"}},{"from":{"field":"region","value":"498"},"to":{"field":"region","value":"md"}},{"from":{"field":"region","value":"499"},"to":{"field":"region","value":"me"}},{"from":{"field":"region","value":"663"},"to":{"field":"region","value":"mf"}},{"from":{"field":"region","value":"450"},"to":{"field":"region","value":"mg"}},{"from":{"field":"region","value":"584"},"to":{"field":"region","value":"mh"}},{"from":{"field":"region","value":"807"},"to":{"field":"region","value":"mk"}},{"from":{"field":"region","value":"466"},"to":{"field":"region","value":"ml"}},{"from":{"field":"region","value":"496"},"to":{"field":"region","value":"mn"}},{"from":{"field":"region","value":"446"},"to":{"field":"region","value":"mo"}},{"from":{"field":"region","value":"580"},"to":{"field":"region","value":"mp"}},{"from":{"field":"region","value":"474"},"to":{"field":"region","value":"mq"}},{"from":{"field":"region","value":"478"},"to":{"field":"region","value":"mr"}},{"from":{"field":"region","value":"500"},"to":{"field":"region","value":"ms"}},{"from":{"field":"region","value":"470"},"to":{"field":"region","value":"mt"}},{"from":{"field":"region","value":"480"},"to":{"field":"region","value":"mu"}},{"from":{"field":"region","value":"462"},"to":{"field":"region","value":"mv"}},{"from":{"field":"region","value":"454"},"to":{"field":"region","value":"mw"}},{"from":{"field":"region","value":"484"},"to":{"field":"region","value":"mx"}},{"from":{"field":"region","value":"458"},"to":{"field":"region","value":"my"}},{"from":{"field":"region","value":"508"},"to":{"field":"region","value":"mz"}},{"from":{"field":"region","value":"516"},"to":{"field":"region","value":"na"}},{"from":{"field":"region","value":"540"},"to":{"field":"region","value":"nc"}},{"from":{"field":"region","value":"562"},"to":{"field":"region","value":"ne"}},{"from":{"field":"region","value":"574"},"to":{"field":"region","value":"nf"}},{"from":{"field":"region","value":"566"},"to":{"field":"region","value":"ng"}},{"from":{"field":"region","value":"558"},"to":{"field":"region","value":"ni"}},{"from":{"field":"region","value":"528"},"to":{"field":"region","value":"nl"}},{"from":{"field":"region","value":"578"},"to":{"field":"region","value":"no"}},{"from":{"field":"region","value":"524"},"to":{"field":"region","value":"np"}},{"from":{"field":"region","value":"520"},"to":{"field":"region","value":"nr"}},{"from":{"field":"region","value":"570"},"to":{"field":"region","value":"nu"}},{"from":{"field":"region","value":"554"},"to":{"field":"region","value":"nz"}},{"from":{"field":"region","value":"512"},"to":{"field":"region","value":"om"}},{"from":{"field":"region","value":"591"},"to":{"field":"region","value":"pa"}},{"from":{"field":"region","value":"604"},"to":{"field":"region","value":"pe"}},{"from":{"field":"region","value":"258"},"to":{"field":"region","value":"pf"}},{"from":{"field":"region","value":"598"},"to":{"field":"region","value":"pg"}},{"from":{"field":"region","value":"608"},"to":{"field":"region","value":"ph"}},{"from":{"field":"region","value":"586"},"to":{"field":"region","value":"pk"}},{"from":{"field":"region","value":"616"},"to":{"field":"region","value":"pl"}},{"from":{"field":"region","value":"666"},"to":{"field":"region","value":"pm"}},{"from":{"field":"region","value":"612"},"to":{"field":"region","value":"pn"}},{"from":{"field":"region","value":"630"},"to":{"field":"region","value":"pr"}},{"from":{"field":"region","value":"275"},"to":{"field":"region","value":"ps"}},{"from":{"field":"region","value":"620"},"to":{"field":"region","value":"pt"}},{"from":{"field":"region","value":"585"},"to":{"field":"region","value":"pw"}},{"from":{"field":"region","value":"600"},"to":{"field":"region","value":"py"}},{"from":{"field":"region","value":"634"},"to":{"field":"region","value":"qa"}},{"from":{"field":"region","value":"959"},"to":{"field":"region","value":"qm"}},{"from":{"field":"region","value":"960"},"to":{"field":"region","value":"qn"}},{"from":{"field":"region","value":"962"},"to":{"field":"region","value":"qp"}},{"from":{"field":"region","value":"963"},"to":{"field":"region","value":"qq"}},{"from":{"field":"region","value":"964"},"to":{"field":"region","value":"qr"}},{"from":{"field":"region","value":"965"},"to":{"field":"region","value":"qs"}},{"from":{"field":"region","value":"966"},"to":{"field":"region","value":"qt"}},{"from":{"field":"region","value":"967"},"to":{"field":"region","value":"eu"}},{"from":{"field":"region","value":"968"},"to":{"field":"region","value":"qv"}},{"from":{"field":"region","value":"969"},"to":{"field":"region","value":"qw"}},{"from":{"field":"region","value":"970"},"to":{"field":"region","value":"qx"}},{"from":{"field":"region","value":"971"},"to":{"field":"region","value":"qy"}},{"from":{"field":"region","value":"972"},"to":{"field":"region","value":"qz"}},{"from":{"field":"region","value":"638"},"to":{"field":"region","value":"re"}},{"from":{"field":"region","value":"642"},"to":{"field":"region","value":"ro"}},{"from":{"field":"region","value":"688"},"to":{"field":"region","value":"rs"}},{"from":{"field":"region","value":"643"},"to":{"field":"region","value":"ru"}},{"from":{"field":"region","value":"646"},"to":{"field":"region","value":"rw"}},{"from":{"field":"region","value":"682"},"to":{"field":"region","value":"sa"}},{"from":{"field":"region","value":"090"},"to":{"field":"region","value":"sb"}},{"from":{"field":"region","value":"690"},"to":{"field":"region","value":"sc"}},{"from":{"field":"region","value":"729"},"to":{"field":"region","value":"sd"}},{"from":{"field":"region","value":"752"},"to":{"field":"region","value":"se"}},{"from":{"field":"region","value":"702"},"to":{"field":"region","value":"sg"}},{"from":{"field":"region","value":"654"},"to":{"field":"region","value":"sh"}},{"from":{"field":"region","value":"705"},"to":{"field":"region","value":"si"}},{"from":{"field":"region","value":"744"},"to":{"field":"region","value":"sj"}},{"from":{"field":"region","value":"703"},"to":{"field":"region","value":"sk"}},{"from":{"field":"region","value":"694"},"to":{"field":"region","value":"sl"}},{"from":{"field":"region","value":"674"},"to":{"field":"region","value":"sm"}},{"from":{"field":"region","value":"686"},"to":{"field":"region","value":"sn"}},{"from":{"field":"region","value":"706"},"to":{"field":"region","value":"so"}},{"from":{"field":"region","value":"740"},"to":{"field":"region","value":"sr"}},{"from":{"field":"region","value":"728"},"to":{"field":"region","value":"ss"}},{"from":{"field":"region","value":"678"},"to":{"field":"region","value":"st"}},{"from":{"field":"region","value":"222"},"to":{"field":"region","value":"sv"}},{"from":{"field":"region","value":"534"},"to":{"field":"region","value":"sx"}},{"from":{"field":"region","value":"760"},"to":{"field":"region","value":"sy"}},{"from":{"field":"region","value":"748"},"to":{"field":"region","value":"sz"}},{"from":{"field":"region","value":"796"},"to":{"field":"region","value":"tc"}},{"from":{"field":"region","value":"148"},"to":{"field":"region","value":"td"}},{"from":{"field":"region","value":"260"},"to":{"field":"region","value":"tf"}},{"from":{"field":"region","value":"768"},"to":{"field":"region","value":"tg"}},{"from":{"field":"region","value":"764"},"to":{"field":"region","value":"th"}},{"from":{"field":"region","value":"762"},"to":{"field":"region","value":"tj"}},{"from":{"field":"region","value":"772"},"to":{"field":"region","value":"tk"}},{"from":{"field":"region","value":"626"},"to":{"field":"region","value":"tl"}},{"from":{"field":"region","value":"795"},"to":{"field":"region","value":"tm"}},{"from":{"field":"region","value":"788"},"to":{"field":"region","value":"tn"}},{"from":{"field":"region","value":"776"},"to":{"field":"region","value":"to"}},{"from":{"field":"region","value":"792"},"to":{"field":"region","value":"tr"}},{"from":{"field":"region","value":"780"},"to":{"field":"region","value":"tt"}},{"from":{"field":"region","value":"798"},"to":{"field":"region","value":"tv"}},{"from":{"field":"region","value":"158"},"to":{"field":"region","value":"tw"}},{"from":{"field":"region","value":"834"},"to":{"field":"region","value":"tz"}},{"from":{"field":"region","value":"804"},"to":{"field":"region","value":"ua"}},{"from":{"field":"region","value":"800"},"to":{"field":"region","value":"ug"}},{"from":{"field":"region","value":"581"},"to":{"field":"region","value":"um"}},{"from":{"field":"region","value":"840"},"to":{"field":"region","value":"us"}},{"from":{"field":"region","value":"858"},"to":{"field":"region","value":"uy"}},{"from":{"field":"region","value":"860"},"to":{"field":"region","value":"uz"}},{"from":{"field":"region","value":"336"},"to":{"field":"region","value":"va"}},{"from":{"field":"region","value":"670"},"to":{"field":"region","value":"vc"}},{"from":{"field":"region","value":"862"},"to":{"field":"region","value":"ve"}},{"from":{"field":"region","value":"092"},"to":{"field":"region","value":"vg"}},{"from":{"field":"region","value":"850"},"to":{"field":"region","value":"vi"}},{"from":{"field":"region","value":"704"},"to":{"field":"region","value":"vn"}},{"from":{"field":"region","value":"548"},"to":{"field":"region","value":"vu"}},{"from":{"field":"region","value":"876"},"to":{"field":"region","value":"wf"}},{"from":{"field":"region","value":"882"},"to":{"field":"region","value":"ws"}},{"from":{"field":"region","value":"973"},"to":{"field":"region","value":"xa"}},{"from":{"field":"region","value":"974"},"to":{"field":"region","value":"xb"}},{"from":{"field":"region","value":"975"},"to":{"field":"region","value":"xc"}},{"from":{"field":"region","value":"976"},"to":{"field":"region","value":"xd"}},{"from":{"field":"region","value":"977"},"to":{"field":"region","value":"xe"}},{"from":{"field":"region","value":"978"},"to":{"field":"region","value":"xf"}},{"from":{"field":"region","value":"979"},"to":{"field":"region","value":"xg"}},{"from":{"field":"region","value":"980"},"to":{"field":"region","value":"xh"}},{"from":{"field":"region","value":"981"},"to":{"field":"region","value":"xi"}},{"from":{"field":"region","value":"982"},"to":{"field":"region","value":"xj"}},{"from":{"field":"region","value":"983"},"to":{"field":"region","value":"xk"}},{"from":{"field":"region","value":"984"},"to":{"field":"region","value":"xl"}},{"from":{"field":"region","value":"985"},"to":{"field":"region","value":"xm"}},{"from":{"field":"region","value":"986"},"to":{"field":"region","value":"xn"}},{"from":{"field":"region","value":"987"},"to":{"field":"region","value":"xo"}},{"from":{"field":"region","value":"988"},"to":{"field":"region","value":"xp"}},{"from":{"field":"region","value":"989"},"to":{"field":"region","value":"xq"}},{"from":{"field":"region","value":"990"},"to":{"field":"region","value":"xr"}},{"from":{"field":"region","value":"991"},"to":{"field":"region","value":"xs"}},{"from":{"field":"region","value":"992"},"to":{"field":"region","value":"xt"}},{"from":{"field":"region","value":"993"},"to":{"field":"region","value":"xu"}},{"from":{"field":"region","value":"994"},"to":{"field":"region","value":"xv"}},{"from":{"field":"region","value":"995"},"to":{"field":"region","value":"xw"}},{"from":{"field":"region","value":"996"},"to":{"field":"region","value":"xx"}},{"from":{"field":"region","value":"997"},"to":{"field":"region","value":"xy"}},{"from":{"field":"region","value":"998"},"to":{"field":"region","value":"xz"}},{"from":{"field":"region","value":"720"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"887"},"to":{"field":"region","value":"ye"}},{"from":{"field":"region","value":"175"},"to":{"field":"region","value":"yt"}},{"from":{"field":"region","value":"710"},"to":{"field":"region","value":"za"}},{"from":{"field":"region","value":"894"},"to":{"field":"region","value":"zm"}},{"from":{"field":"region","value":"716"},"to":{"field":"region","value":"zw"}},{"from":{"field":"region","value":"999"},"to":{"field":"region","value":"zz"}},{"from":{"field":"variants","value":"aaland"},"to":{"field":"region","value":"ax"}},{"from":{"field":"variants","value":"polytoni"},"to":{"field":"variants","value":"polyton"}},{"from":{"field":"variants","value":"heploc"},"to":{"field":"variants","value":"alalc97"}},{"from":{"field":"variants","value":"arevela"},"to":{"field":"language","value":"hy"}},{"from":{"field":"variants","value":"arevmda"},"to":{"field":"language","value":"hyw"}}]');
        }, 9460: function(_e) {
          _e.exports = JSON.parse('{"region":{"172":["ru","am","az","by","ge","kg","kz","md","tj","tm","ua","uz"],"200":["cz","sk"],"530":["cw","sx","bq"],"532":["cw","sx","bq"],"536":["sa","iq"],"582":["fm","mh","mp","pw"],"810":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"830":["je","gg"],"890":["rs","me","si","hr","mk","ba"],"891":["rs","me"],"an":["cw","sx","bq"],"cs":["rs","me"],"fq":["aq","tf"],"nt":["sa","iq"],"pc":["fm","mh","mp","pw"],"su":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yu":["rs","me"],"062":["034","143"],"ant":["cw","sx","bq"],"scg":["rs","me"],"ntz":["sa","iq"],"sun":["ru","am","az","by","ee","ge","kz","kg","lv","lt","md","tj","tm","ua","uz"],"yug":["rs","me"]}}');
        }, 7778: function(_e) {
          _e.exports = JSON.parse('[{"from":"in","to":"id"},{"from":"iw","to":"he"},{"from":"ji","to":"yi"},{"from":"jw","to":"jv"},{"from":"mo","to":"ro"},{"from":"scc","to":"sr"},{"from":"scr","to":"hr"},{"from":"aam","to":"aas"},{"from":"adp","to":"dz"},{"from":"aue","to":"ktz"},{"from":"ayx","to":"nun"},{"from":"bgm","to":"bcg"},{"from":"bjd","to":"drl"},{"from":"ccq","to":"rki"},{"from":"cjr","to":"mom"},{"from":"cka","to":"cmr"},{"from":"cmk","to":"xch"},{"from":"coy","to":"pij"},{"from":"cqu","to":"quh"},{"from":"drh","to":"mn"},{"from":"drw","to":"fa-af"},{"from":"gav","to":"dev"},{"from":"gfx","to":"vaj"},{"from":"ggn","to":"gvr"},{"from":"gti","to":"nyc"},{"from":"guv","to":"duz"},{"from":"hrr","to":"jal"},{"from":"ibi","to":"opa"},{"from":"ilw","to":"gal"},{"from":"jeg","to":"oyb"},{"from":"kgc","to":"tdf"},{"from":"kgh","to":"kml"},{"from":"koj","to":"kwv"},{"from":"krm","to":"bmf"},{"from":"ktr","to":"dtp"},{"from":"kvs","to":"gdj"},{"from":"kwq","to":"yam"},{"from":"kxe","to":"tvd"},{"from":"kzj","to":"dtp"},{"from":"kzt","to":"dtp"},{"from":"lii","to":"raq"},{"from":"lmm","to":"rmx"},{"from":"meg","to":"cir"},{"from":"mst","to":"mry"},{"from":"mwj","to":"vaj"},{"from":"myt","to":"mry"},{"from":"nad","to":"xny"},{"from":"ncp","to":"kdz"},{"from":"nnx","to":"ngv"},{"from":"nts","to":"pij"},{"from":"oun","to":"vaj"},{"from":"pcr","to":"adx"},{"from":"pmc","to":"huw"},{"from":"pmu","to":"phr"},{"from":"ppa","to":"bfy"},{"from":"ppr","to":"lcq"},{"from":"pry","to":"prt"},{"from":"puz","to":"pub"},{"from":"sca","to":"hle"},{"from":"skk","to":"oyb"},{"from":"tdu","to":"dtp"},{"from":"thc","to":"tpo"},{"from":"thx","to":"oyb"},{"from":"tie","to":"ras"},{"from":"tkk","to":"twm"},{"from":"tlw","to":"weo"},{"from":"tmp","to":"tyj"},{"from":"tne","to":"kak"},{"from":"tnf","to":"fa-af"},{"from":"tsf","to":"taj"},{"from":"uok","to":"ema"},{"from":"xba","to":"cax"},{"from":"xia","to":"acn"},{"from":"xkh","to":"waw"},{"from":"xsj","to":"suj"},{"from":"ybd","to":"rki"},{"from":"yma","to":"lrr"},{"from":"ymt","to":"mtm"},{"from":"yos","to":"zom"},{"from":"yuu","to":"yug"},{"from":"asd","to":"snz"},{"from":"dit","to":"dif"},{"from":"llo","to":"ngt"},{"from":"myd","to":"aog"},{"from":"nns","to":"nbr"},{"from":"sgn-br","to":"bzs"},{"from":"sgn-co","to":"csn"},{"from":"sgn-de","to":"gsg"},{"from":"sgn-dk","to":"dsl"},{"from":"sgn-fr","to":"fsl"},{"from":"sgn-gb","to":"bfi"},{"from":"sgn-gr","to":"gss"},{"from":"sgn-ie","to":"isg"},{"from":"sgn-it","to":"ise"},{"from":"sgn-jp","to":"jsl"},{"from":"sgn-mx","to":"mfs"},{"from":"sgn-ni","to":"ncs"},{"from":"sgn-nl","to":"dse"},{"from":"sgn-no","to":"nsi"},{"from":"sgn-pt","to":"psr"},{"from":"sgn-se","to":"swl"},{"from":"sgn-us","to":"ase"},{"from":"sgn-za","to":"sfs"},{"from":"no-bokmal","to":"nb"},{"from":"no-nynorsk","to":"nn"},{"from":"aa-saaho","to":"ssy"},{"from":"sh","to":"sr-latn"},{"from":"cnr","to":"sr-me"},{"from":"no","to":"nb"},{"from":"tl","to":"fil"},{"from":"az-az","to":"az-latn-az"},{"from":"bs-ba","to":"bs-latn-ba"},{"from":"ha-latn-gh","to":"ha-gh"},{"from":"ha-latn-ne","to":"ha-ne"},{"from":"ha-latn-ng","to":"ha-ng"},{"from":"kk-cyrl-kz","to":"kk-kz"},{"from":"ky-cyrl-kg","to":"ky-kg"},{"from":"ks-arab-in","to":"ks-in"},{"from":"mn-cyrl-mn","to":"mn-mn"},{"from":"ms-latn-bn","to":"ms-bn"},{"from":"ms-latn-my","to":"ms-my"},{"from":"ms-latn-sg","to":"ms-sg"},{"from":"pa-in","to":"pa-guru-in"},{"from":"pa-pk","to":"pa-arab-pk"},{"from":"shi-ma","to":"shi-tfng-ma"},{"from":"sr-ba","to":"sr-cyrl-ba"},{"from":"sr-me","to":"sr-latn-me"},{"from":"sr-rs","to":"sr-cyrl-rs"},{"from":"sr-xk","to":"sr-cyrl-xk"},{"from":"tzm-latn-ma","to":"tzm-ma"},{"from":"ug-arab-cn","to":"ug-cn"},{"from":"uz-af","to":"uz-arab-af"},{"from":"uz-uz","to":"uz-latn-uz"},{"from":"vai-lr","to":"vai-vaii-lr"},{"from":"yue-cn","to":"yue-hans-cn"},{"from":"yue-hk","to":"yue-hant-hk"},{"from":"zh-cn","to":"zh-hans-cn"},{"from":"zh-hk","to":"zh-hant-hk"},{"from":"zh-mo","to":"zh-hant-mo"},{"from":"zh-sg","to":"zh-hans-sg"},{"from":"zh-tw","to":"zh-hant-tw"},{"from":"aju","to":"jrb"},{"from":"als","to":"sq"},{"from":"arb","to":"ar"},{"from":"ayr","to":"ay"},{"from":"azj","to":"az"},{"from":"bcc","to":"bal"},{"from":"bcl","to":"bik"},{"from":"bxk","to":"luy"},{"from":"bxr","to":"bua"},{"from":"cld","to":"syr"},{"from":"cmn","to":"zh"},{"from":"cwd","to":"cr"},{"from":"dgo","to":"doi"},{"from":"dhd","to":"mwr"},{"from":"dik","to":"din"},{"from":"diq","to":"zza"},{"from":"lbk","to":"bnc"},{"from":"ekk","to":"et"},{"from":"emk","to":"man"},{"from":"esk","to":"ik"},{"from":"fat","to":"ak"},{"from":"fuc","to":"ff"},{"from":"gaz","to":"om"},{"from":"gbo","to":"grb"},{"from":"gno","to":"gon"},{"from":"gug","to":"gn"},{"from":"gya","to":"gba"},{"from":"hdn","to":"hai"},{"from":"hea","to":"hmn"},{"from":"ike","to":"iu"},{"from":"kmr","to":"ku"},{"from":"knc","to":"kr"},{"from":"kng","to":"kg"},{"from":"knn","to":"kok"},{"from":"kpv","to":"kv"},{"from":"lvs","to":"lv"},{"from":"mhr","to":"chm"},{"from":"mup","to":"raj"},{"from":"khk","to":"mn"},{"from":"npi","to":"ne"},{"from":"ojg","to":"oj"},{"from":"ory","to":"or"},{"from":"pbu","to":"ps"},{"from":"pes","to":"fa"},{"from":"plt","to":"mg"},{"from":"pnb","to":"lah"},{"from":"quz","to":"qu"},{"from":"rmy","to":"rom"},{"from":"spy","to":"kln"},{"from":"src","to":"sc"},{"from":"swh","to":"sw"},{"from":"ttq","to":"tmh"},{"from":"tw","to":"ak"},{"from":"umu","to":"del"},{"from":"uzn","to":"uz"},{"from":"xpe","to":"kpe"},{"from":"xsl","to":"den"},{"from":"ydd","to":"yi"},{"from":"zai","to":"zap"},{"from":"zsm","to":"ms"},{"from":"zyb","to":"za"},{"from":"him","to":"srx"},{"from":"mnk","to":"man"},{"from":"bh","to":"bho"},{"from":"prs","to":"fa-af"},{"from":"swc","to":"sw-cd"},{"from":"aar","to":"aa"},{"from":"abk","to":"ab"},{"from":"ave","to":"ae"},{"from":"afr","to":"af"},{"from":"aka","to":"ak"},{"from":"amh","to":"am"},{"from":"arg","to":"an"},{"from":"ara","to":"ar"},{"from":"asm","to":"as"},{"from":"ava","to":"av"},{"from":"aym","to":"ay"},{"from":"aze","to":"az"},{"from":"bak","to":"ba"},{"from":"bel","to":"be"},{"from":"bul","to":"bg"},{"from":"bih","to":"bho"},{"from":"bis","to":"bi"},{"from":"bam","to":"bm"},{"from":"ben","to":"bn"},{"from":"bod","to":"bo"},{"from":"bre","to":"br"},{"from":"bos","to":"bs"},{"from":"cat","to":"ca"},{"from":"che","to":"ce"},{"from":"cha","to":"ch"},{"from":"cos","to":"co"},{"from":"cre","to":"cr"},{"from":"ces","to":"cs"},{"from":"chu","to":"cu"},{"from":"chv","to":"cv"},{"from":"cym","to":"cy"},{"from":"dan","to":"da"},{"from":"deu","to":"de"},{"from":"div","to":"dv"},{"from":"dzo","to":"dz"},{"from":"ewe","to":"ee"},{"from":"ell","to":"el"},{"from":"eng","to":"en"},{"from":"epo","to":"eo"},{"from":"spa","to":"es"},{"from":"est","to":"et"},{"from":"eus","to":"eu"},{"from":"fas","to":"fa"},{"from":"ful","to":"ff"},{"from":"fin","to":"fi"},{"from":"fij","to":"fj"},{"from":"fao","to":"fo"},{"from":"fra","to":"fr"},{"from":"fry","to":"fy"},{"from":"gle","to":"ga"},{"from":"gla","to":"gd"},{"from":"glg","to":"gl"},{"from":"grn","to":"gn"},{"from":"guj","to":"gu"},{"from":"glv","to":"gv"},{"from":"hau","to":"ha"},{"from":"heb","to":"he"},{"from":"hin","to":"hi"},{"from":"hmo","to":"ho"},{"from":"hrv","to":"hr"},{"from":"hat","to":"ht"},{"from":"hun","to":"hu"},{"from":"hye","to":"hy"},{"from":"her","to":"hz"},{"from":"ina","to":"ia"},{"from":"ind","to":"id"},{"from":"ile","to":"ie"},{"from":"ibo","to":"ig"},{"from":"iii","to":"ii"},{"from":"ipk","to":"ik"},{"from":"ido","to":"io"},{"from":"isl","to":"is"},{"from":"ita","to":"it"},{"from":"iku","to":"iu"},{"from":"jpn","to":"ja"},{"from":"jav","to":"jv"},{"from":"kat","to":"ka"},{"from":"kon","to":"kg"},{"from":"kik","to":"ki"},{"from":"kua","to":"kj"},{"from":"kaz","to":"kk"},{"from":"kal","to":"kl"},{"from":"khm","to":"km"},{"from":"kan","to":"kn"},{"from":"kor","to":"ko"},{"from":"kau","to":"kr"},{"from":"kas","to":"ks"},{"from":"kur","to":"ku"},{"from":"kom","to":"kv"},{"from":"cor","to":"kw"},{"from":"kir","to":"ky"},{"from":"lat","to":"la"},{"from":"ltz","to":"lb"},{"from":"lug","to":"lg"},{"from":"lim","to":"li"},{"from":"lin","to":"ln"},{"from":"lao","to":"lo"},{"from":"lit","to":"lt"},{"from":"lub","to":"lu"},{"from":"lav","to":"lv"},{"from":"mlg","to":"mg"},{"from":"mah","to":"mh"},{"from":"mri","to":"mi"},{"from":"mkd","to":"mk"},{"from":"mal","to":"ml"},{"from":"mon","to":"mn"},{"from":"mol","to":"ro"},{"from":"mar","to":"mr"},{"from":"msa","to":"ms"},{"from":"mlt","to":"mt"},{"from":"mya","to":"my"},{"from":"nau","to":"na"},{"from":"nob","to":"nb"},{"from":"nde","to":"nd"},{"from":"nep","to":"ne"},{"from":"ndo","to":"ng"},{"from":"nld","to":"nl"},{"from":"nno","to":"nn"},{"from":"nor","to":"nb"},{"from":"nbl","to":"nr"},{"from":"nav","to":"nv"},{"from":"nya","to":"ny"},{"from":"oci","to":"oc"},{"from":"oji","to":"oj"},{"from":"orm","to":"om"},{"from":"ori","to":"or"},{"from":"oss","to":"os"},{"from":"pan","to":"pa"},{"from":"pli","to":"pi"},{"from":"pol","to":"pl"},{"from":"pus","to":"ps"},{"from":"por","to":"pt"},{"from":"que","to":"qu"},{"from":"roh","to":"rm"},{"from":"run","to":"rn"},{"from":"ron","to":"ro"},{"from":"rus","to":"ru"},{"from":"kin","to":"rw"},{"from":"san","to":"sa"},{"from":"srd","to":"sc"},{"from":"snd","to":"sd"},{"from":"sme","to":"se"},{"from":"sag","to":"sg"},{"from":"hbs","to":"sr-latn"},{"from":"sin","to":"si"},{"from":"slk","to":"sk"},{"from":"slv","to":"sl"},{"from":"smo","to":"sm"},{"from":"sna","to":"sn"},{"from":"som","to":"so"},{"from":"sqi","to":"sq"},{"from":"srp","to":"sr"},{"from":"ssw","to":"ss"},{"from":"sot","to":"st"},{"from":"sun","to":"su"},{"from":"swe","to":"sv"},{"from":"swa","to":"sw"},{"from":"tam","to":"ta"},{"from":"tel","to":"te"},{"from":"tgk","to":"tg"},{"from":"tha","to":"th"},{"from":"tir","to":"ti"},{"from":"tuk","to":"tk"},{"from":"tgl","to":"fil"},{"from":"tsn","to":"tn"},{"from":"ton","to":"to"},{"from":"tur","to":"tr"},{"from":"tso","to":"ts"},{"from":"tat","to":"tt"},{"from":"twi","to":"ak"},{"from":"tah","to":"ty"},{"from":"uig","to":"ug"},{"from":"ukr","to":"uk"},{"from":"urd","to":"ur"},{"from":"uzb","to":"uz"},{"from":"ven","to":"ve"},{"from":"vie","to":"vi"},{"from":"vol","to":"vo"},{"from":"wln","to":"wa"},{"from":"wol","to":"wo"},{"from":"xho","to":"xh"},{"from":"yid","to":"yi"},{"from":"yor","to":"yo"},{"from":"zha","to":"za"},{"from":"zho","to":"zh"},{"from":"zul","to":"zu"},{"from":"alb","to":"sq"},{"from":"arm","to":"hy"},{"from":"baq","to":"eu"},{"from":"bur","to":"my"},{"from":"chi","to":"zh"},{"from":"cze","to":"cs"},{"from":"dut","to":"nl"},{"from":"fre","to":"fr"},{"from":"geo","to":"ka"},{"from":"ger","to":"de"},{"from":"gre","to":"el"},{"from":"ice","to":"is"},{"from":"mac","to":"mk"},{"from":"mao","to":"mi"},{"from":"may","to":"ms"},{"from":"per","to":"fa"},{"from":"rum","to":"ro"},{"from":"slo","to":"sk"},{"from":"tib","to":"bo"},{"from":"wel","to":"cy"}]');
        }, 8589: function(_e) {
          _e.exports = JSON.parse('{"en-gb-oed":"en-GB-oxendict","i-ami":"ami","i-bnn":"bnn","i-default":null,"i-enochian":null,"i-hak":"hak","i-klingon":"tlh","i-lux":"lb","i-mingo":null,"i-navajo":"nv","i-pwn":"pwn","i-tao":"tao","i-tay":"tay","i-tsu":"tsu","sgn-be-fr":"sfb","sgn-be-nl":"vgt","sgn-ch-de":"sgg","art-lojban":"jbo","cel-gaulish":null,"no-bok":"nb","no-nyn":"nn","zh-guoyu":"cmn","zh-hakka":"hak","zh-min":null,"zh-min-nan":"nan","zh-xiang":"hsn"}');
        }, 858: function(_e) {
          _e.exports = JSON.parse('["art-lojban","cel-gaulish","no-bok","no-nyn","zh-guoyu","zh-hakka","zh-min","zh-min-nan","zh-xiang"]');
        } }, le = {};
        function be(_e) {
          var fe = le[_e];
          if (fe !== void 0) return fe.exports;
          var R = le[_e] = { exports: {} };
          return B[_e].call(R.exports, R, R.exports, be), R.exports;
        }
        be.amdO = {}, be.n = function(_e) {
          var fe = _e && _e.__esModule ? function() {
            return _e.default;
          } : function() {
            return _e;
          };
          return be.d(fe, { a: fe }), fe;
        }, be.d = function(_e, fe) {
          for (var R in fe) be.o(fe, R) && !be.o(_e, R) && Object.defineProperty(_e, R, { enumerable: !0, get: fe[R] });
        }, be.g = function() {
          if (typeof globalThis == "object") return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object") return window;
          }
        }(), be.o = function(_e, fe) {
          return Object.prototype.hasOwnProperty.call(_e, fe);
        };
        var qe = {};
        return function() {
          be.d(qe, { default: function() {
            return p;
          } }), be(8416);
          var _e, fe = be(1715), R = be(8080), J = be(1737), E = be(1139), t = /* @__PURE__ */ function() {
            var o, v = "application/dash+xml";
            function m(c, f, S) {
              if (!c || !/^VIDEO$/i.test(c.nodeName)) return null;
              if (c._dashjs_player) return c._dashjs_player;
              var k, q = c.id || c.name || "video element";
              if (!(f = f || [].slice.call(c.querySelectorAll("source")).filter(function(F) {
                return F.type == v;
              })[0]) && c.src) (f = document.createElement("source")).src = c.src;
              else if (!f && !c.src) return null;
              return S = S || {}, (k = (0, E.Z)(S).create()).initialize(c, f.src, c.autoplay), o || (o = k.getDebug().getLogger()), o.debug("Converted " + q + " to dash.js player and added content: " + f.src), c._dashjs_player = k, k;
            }
            function n(c) {
              return /^VIDEO$/i.test(c.nodeName) ? c : n(c.parentNode);
            }
            return { create: m, createAll: function(c, f) {
              var S = [];
              c = c || "[data-dashjs-player]";
              for (var k = (f = f || document).querySelectorAll(c), q = 0; q < k.length; q++) {
                var F = m(k[q], null);
                S.push(F);
              }
              for (var te = f.querySelectorAll('source[type="' + v + '"]'), P = 0; P < te.length; P++) {
                var Q = m(n(te[P]), null);
                S.push(Q);
              }
              return S;
            } };
          }();
          !(typeof window < "u" && window && window.dashjs && window.dashjs.skipAutoCreate) && typeof window < "u" && window && window.addEventListener && (window.document.readyState === "complete" ? window.dashjs ? t.createAll() : _e = window.setInterval(function() {
            window.dashjs && (window.clearInterval(_e), t.createAll());
          }, 500) : window.addEventListener("load", function o() {
            window.removeEventListener("load", o), t.createAll();
          }));
          var e = t, h = be(6398);
          dashjs.Protection = J.default, dashjs.MetricsReporting = R.default, dashjs.MediaPlayerFactory = e, dashjs.Debug = h.Z, dashjs.supportsMediaSource = fe.B;
          var p = dashjs;
        }(), qe.default;
      }();
    });
  }(_o)), _o.exports;
}
var _f = yf();
const Ef = (D, C, B) => {
  const le = D[C];
  return le ? typeof le == "function" ? le() : Promise.resolve(le) : new Promise((be, qe) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      qe.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + C + (C.split("/").length !== B ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
Hc.use(Gc).use(
  qc(
    (D) => Ef(/* @__PURE__ */ Object.assign({ "./locales/ar.json": () => import("./ar-Dq2lfU9v.js"), "./locales/ca.json": () => import("./ca-CEIjcFEk.js"), "./locales/cy.json": () => import("./cy-RkQvUS05.js"), "./locales/da-x-k12.json": () => import("./da-x-k12-Cx-fRJQD.js"), "./locales/da.json": () => import("./da-DaoSD51O.js"), "./locales/de.json": () => import("./de-DOnP2vsp.js"), "./locales/en-AU-x-unimelb.json": () => import("./en-AU-x-unimelb-MTHy5EWR.js"), "./locales/en-GB-x-ukhe.json": () => import("./en-GB-x-ukhe-CdtZID84.js"), "./locales/en.json": () => import("./en-CaQr0kDB.js"), "./locales/en_AU.json": () => import("./en_AU-D0-xBzdc.js"), "./locales/en_CY.json": () => import("./en_CY-CA866dY6.js"), "./locales/en_GB.json": () => import("./en_GB-C8WlbIYV.js"), "./locales/es.json": () => import("./es-BMsOqQnw.js"), "./locales/es_ES.json": () => import("./es_ES-BaO4fwsj.js"), "./locales/fi.json": () => import("./fi-DG5cb01V.js"), "./locales/fr.json": () => import("./fr-Bj0RDuna.js"), "./locales/fr_CA.json": () => import("./fr_CA-vtCvpmg6.js"), "./locales/ga.json": () => import("./ga-As-yPyIL.js"), "./locales/hi.json": () => import("./hi-BFiP7k4-.js"), "./locales/ht.json": () => import("./ht-DaPU0j7l.js"), "./locales/id.json": () => import("./id-L-uU6WlH.js"), "./locales/is.json": () => import("./is-DSoEMoP3.js"), "./locales/it.json": () => import("./it-CbFOjERF.js"), "./locales/ja.json": () => import("./ja-BFpwGimK.js"), "./locales/kl.json": () => import("./kl-CBFEKDWH.js"), "./locales/ko.json": () => import("./ko-h8qXdEut.js"), "./locales/mi.json": () => import("./mi-CkNirgTn.js"), "./locales/ms.json": () => import("./ms-BIg5nUUv.js"), "./locales/nb-x-k12.json": () => import("./nb-x-k12-BNK1BXzJ.js"), "./locales/nb.json": () => import("./nb-DOW9WETe.js"), "./locales/nl.json": () => import("./nl-BesPgk_y.js"), "./locales/pl.json": () => import("./pl-Bt8176p4.js"), "./locales/pt.json": () => import("./pt-C-VaiXtK.js"), "./locales/pt_BR.json": () => import("./pt_BR-3Mr2dTBm.js"), "./locales/ru.json": () => import("./ru-CxVmn8IA.js"), "./locales/sl.json": () => import("./sl-o_d_CMMe.js"), "./locales/sv-x-k12.json": () => import("./sv-x-k12-COhbRt9Y.js"), "./locales/sv.json": () => import("./sv-DGafNw30.js"), "./locales/th.json": () => import("./th-C9mXwbOG.js"), "./locales/vi.json": () => import("./vi-BvXJQ23P.js"), "./locales/zh-Hans.json": () => import("./zh-Hans-B1Y37PsL.js"), "./locales/zh-Hant.json": () => import("./zh-Hant-DlwFiBTg.js"), "./locales/zh.json": () => import("./zh-5kql5j8x.js"), "./locales/zh_HK.json": () => import("./zh_HK-Bc_wk_Ar.js") }), `./locales/${D}.json`, 3)
  )
).init({
  fallbackLng: "en",
  partialBundledLanguages: !0,
  ns: [],
  resources: {},
  interpolation: {
    escapeValue: !1
  }
});
const ml = Ta(null);
function vf({
  children: D,
  contextValue: C
}) {
  return /* @__PURE__ */ ce(ml.Provider, { value: C, children: D });
}
function wr() {
  const D = ba(ml);
  if (!D)
    throw new Error(
      "useStudioPlayerContext must be used within a StudioPlayerContextProvider"
    );
  return D;
}
const dr = (D) => {
  const C = wr();
  return va(C[D]);
}, pl = Ta(null);
function Tf(D, C) {
  return D != null ? !1 : C;
}
function bf({
  title: D,
  hideFullScreen: C,
  comments: B,
  captions: le,
  thumbnail: be,
  annotations: qe,
  quizMarkers: _e,
  interactive: fe,
  onAnnotationClick: R,
  onQuizMarkerClick: J,
  onInteractivePinClick: E,
  onPlayerSizeChange: t,
  onTranscriptEdit: e,
  onConfirmEditChanges: h,
  interactiveMenuElements: p,
  kebabMenuElements: o,
  darkMode: v,
  children: m,
  forceComments: n,
  disableCaptionSettings: c,
  disableStorage: f,
  captionOffsetOverride: S,
  disableInteractivePinRanges: k,
  onQuizMarkerShow: q,
  onCaptionsDelete: F,
  controlsLayout: te,
  startAt: P,
  hideQuizMarkers: Q,
  enableSidebar: se,
  lockSpeed: K,
  tabs: ie,
  openSidebar: ge,
  emptyTranscriptsComponent: Ne,
  rollingTranscriptElement: ee,
  transcriptMenuElements: Oe,
  onTrackEvent: Ge
}) {
  const Xe = {
    title: D,
    hideFullScreen: C,
    comments: B,
    captions: le,
    thumbnail: be,
    annotations: qe,
    quizMarkers: _e,
    interactive: fe,
    onAnnotationClick: R,
    onQuizMarkerClick: J,
    onInteractivePinClick: E,
    onPlayerSizeChange: t,
    onTranscriptEdit: e,
    onConfirmEditChanges: h,
    interactiveMenuElements: p,
    kebabMenuElements: o,
    darkMode: v,
    hasComments: B.length > 0,
    hasAnnotations: qe.length > 0,
    hasQuizmarkers: _e.length > 0,
    forceComments: n,
    disableCaptionSettings: c,
    disableStorage: f,
    captionOffsetOverride: S,
    disableInteractivePinRanges: k,
    onQuizMarkerShow: q,
    onCaptionsDelete: F,
    controlsLayout: te,
    startAt: P,
    hideQuizMarkers: Q,
    enableSidebar: Tf(
      ee,
      se
    ),
    lockSpeed: K,
    tabs: ie,
    openSidebar: ge,
    emptyTranscriptsComponent: Ne,
    rollingTranscriptElement: ee,
    transcriptMenuElements: Oe,
    onTrackEvent: Ge
  };
  return /* @__PURE__ */ ce(pl.Provider, { value: Xe, children: m });
}
function zn() {
  const D = ba(pl);
  if (!D)
    throw new Error(
      "useStudioPlayerPropsContext must be used within a StudioPlayerPropsContextProvider"
    );
  return D;
}
const Sf = "_annotation-overlay_mg9r8_1", Af = {
  "annotation-overlay": "_annotation-overlay_mg9r8_1",
  annotationOverlay: Sf
}, Js = 0.25, If = (D, C) => {
  let B = !1;
  return (le) => {
    const be = le.detail.currentTime;
    be >= D.time && be < D.time + Js && !B && (B = !0, C(D)), (be < D.time || be >= D.time + Js) && B && (B = !1);
  };
};
function Cf({ annotations: D }) {
  const C = Cr(), B = wr(), le = zn(), [be, qe] = ur(
    null
  ), _e = xn(
    (R) => {
      C == null || C.pause(), qe(R), B.interactionsDisabled.set(!0);
    },
    [C, B]
  ), fe = () => {
    qe(null), B.interactionsDisabled.set(!1);
    let R;
    le.interactive ? R = () => {
      const J = document.querySelector(
        "[data-interactive-pin]"
      );
      J == null || J.focus();
    } : (C == null || C.play(), R = () => {
      const J = document.querySelector(
        "[data-play-pause-button]"
      );
      J == null || J.focus();
    }), requestAnimationFrame(R);
  };
  return Ir(() => {
    if (!C)
      return;
    const R = new AbortController();
    return requestAnimationFrame(() => {
      for (const J of D) {
        const E = If(J, _e);
        C.addEventListener("time-update", E, {
          signal: R.signal
        });
      }
      if (be) {
        const J = D.find(
          (E) => E.id === be.id
        );
        J ? qe(J) : (qe(null), B.interactionsDisabled.set(!1));
      }
    }), () => R.abort();
  }, [C, D]), be ? /* @__PURE__ */ ce("div", { className: Af.annotationOverlay, children: be.render(fe) }) : null;
}
const wf = "_media-buffering-indicator_1fwjr_1", Rf = "_media-buffering-spinner_1fwjr_17", Nf = "_media-buffering-spin_1fwjr_17", Df = "_media-buffering-track_1fwjr_22", Mf = "_media-buffering-track-fill_1fwjr_27", ga = {
  "media-buffering-indicator": "_media-buffering-indicator_1fwjr_1",
  mediaBufferingIndicator: wf,
  "media-buffering-spinner": "_media-buffering-spinner_1fwjr_17",
  mediaBufferingSpinner: Rf,
  "media-buffering-spin": "_media-buffering-spin_1fwjr_17",
  mediaBufferingSpin: Nf,
  "media-buffering-track": "_media-buffering-track_1fwjr_22",
  mediaBufferingTrack: Df,
  "media-buffering-track-fill": "_media-buffering-track-fill_1fwjr_27",
  mediaBufferingTrackFill: Mf
};
function yl() {
  return /* @__PURE__ */ ce("div", { className: ga.mediaBufferingIndicator, children: /* @__PURE__ */ tn(Vc, { className: ga.mediaBufferingSpinner, size: 96, children: [
    /* @__PURE__ */ ce(jc, { className: ga.mediaBufferingTrack, width: 8 }),
    /* @__PURE__ */ ce(
      Yc,
      {
        className: ga.mediaBufferingTrackFill,
        width: 8
      }
    )
  ] }) });
}
const Of = "_controls-overlay_12udo_1", Lf = "_keyboard-shortcuts-overlay_12udo_12", Pf = "_screen-reader-content_12udo_77", xf = "_keyboard-shortcuts-button_12udo_91", Ff = "_kebab-menu-button_12udo_101", kf = "_kebab-menu_12udo_101", Zf = "_kebab-menu-item_12udo_151", Bf = "_close-button_12udo_209", Uf = "_arrow_12udo_223", Qr = {
  "controls-overlay": "_controls-overlay_12udo_1",
  controlsOverlay: Of,
  "keyboard-shortcuts-overlay": "_keyboard-shortcuts-overlay_12udo_12",
  keyboardShortcutsOverlay: Lf,
  "screen-reader-content": "_screen-reader-content_12udo_77",
  screenReaderContent: Pf,
  "keyboard-shortcuts-button": "_keyboard-shortcuts-button_12udo_91",
  keyboardShortcutsButton: xf,
  "kebab-menu-button": "_kebab-menu-button_12udo_101",
  kebabMenuButton: Ff,
  "kebab-menu": "_kebab-menu_12udo_101",
  kebabMenu: kf,
  "kebab-menu-item": "_kebab-menu-item_12udo_151",
  kebabMenuItem: Zf,
  "close-button": "_close-button_12udo_209",
  closeButton: Bf,
  arrow: Uf
}, Gf = window.matchMedia("(hover: none)"), Hf = () => Gf.matches, Oa = () => jn("width") < 720, _l = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8234 16.4118C14.8234 16.7029 14.5852 16.9412 14.294 16.9412H3.70577C3.41459 16.9412 3.17636 16.7029 3.17636 16.4118V5.29412H2.11753V16.4118C2.11753 17.2874 2.83012 18 3.70577 18H14.294C15.1697 18 15.8822 17.2874 15.8822 16.4118V5.29412H14.8234V16.4118ZM6.35284 14.8235H7.41166V6.35294H6.35284V14.8235ZM10.5881 14.8235H11.6469V6.35294H10.5881V14.8235ZM12.5682 3.17647L11.4099 0H6.51176L5.35553 3.17647H0V4.23529H18V3.17647H12.5682ZM6.48105 3.17647L7.25293 1.05882H10.6698L11.4416 3.17647H6.48105Z", fill: "currentColor" }) }), qf = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.30365 10.9535V0H9.3637V10.9535L12.6986 7.61855L13.4491 8.368L8.83261 12.9824L4.21823 8.368L4.96875 7.61855L8.30365 10.9535ZM3.77376 16.94H13.9354L16.9607 13.9146L17.7091 14.6651L14.3742 18H3.3349L0 14.6651L0.749452 13.9146L3.77376 16.94Z", fill: "currentColor" }) }), Vf = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M2.60586 0.460092C3.21774 -0.152839 4.21634 -0.153889 4.83242 0.460092L7.00918 2.63685L16.9057 12.5353L17.9994 18.0001L12.5346 16.9064L3.62734 8.00013L4.36953 7.25794L11.8861 14.7736L14.7738 11.8868L6.26699 3.37904L2.63613 7.00892L0.459374 4.83216C-0.153077 4.21718 -0.153172 3.2194 0.459374 2.60658L2.60586 0.460092ZM12.6283 15.5158L13.0512 15.9386L16.6605 16.6613L15.9389 13.0519L15.515 12.6281L12.6283 15.5158ZM12.8217 12.0802L12.0795 12.8224L5.58926 6.33216L6.33144 5.58997L12.8217 12.0802ZM3.71816 1.04896C3.58397 1.04907 3.45079 1.09954 3.34805 1.20228L1.20156 3.34876C0.998208 3.5524 0.998036 3.88638 1.20156 4.09095L2.63613 5.52552L5.5248 2.63685L4.09023 1.20228C3.98738 1.09942 3.8525 1.04896 3.71816 1.04896Z", fill: "currentColor" }) }), jf = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M1 17V12.5656H2.41098V15.5882H5.43188V17H1ZM12.5681 17V15.5882H15.589V12.5656H17V17H12.5681ZM1 5.43435V1H5.43188V2.41176H2.41098V5.43435H1ZM15.589 5.43435V2.41176H12.5681V1H17V5.43435H15.589Z", fill: "currentColor" }) }), Yf = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9412 15.2941C16.9412 15.5853 16.704 15.8235 16.4118 15.8235H1.58823C1.296 15.8235 1.05882 15.5853 1.05882 15.2941V6.82353C1.05882 6.53235 1.296 6.29412 1.58823 6.29412H16.4118C16.704 6.29412 16.9412 6.53235 16.9412 6.82353V15.2941ZM16.4118 5.23529H9.57494C9.71471 4.42 10.1933 4.17118 10.8254 3.85565C11.6629 3.43741 12.7059 2.91541 12.7059 1H11.6471C11.6471 2.26106 11.1039 2.53212 10.3511 2.90906C9.59824 3.28494 8.68659 3.75506 8.50871 5.23529H1.58824C0.712588 5.23529 0 5.94788 0 6.82353V15.2941C0 16.1698 0.712588 16.8824 1.58824 16.8824H16.4118C17.2874 16.8824 18 16.1698 18 15.2941V6.82353C18 5.94788 17.2874 5.23529 16.4118 5.23529ZM11.1177 11.5882H6.88236C6.59013 11.5882 6.35295 11.8254 6.35295 12.1176V13.1765C6.35295 13.4687 6.59013 13.7059 6.88236 13.7059H11.1177C11.4099 13.7059 11.6471 13.4687 11.6471 13.1765V12.1176C11.6471 11.8254 11.4099 11.5882 11.1177 11.5882ZM14.2941 11.5882H13.2353C12.943 11.5882 12.7059 11.8254 12.7059 12.1176V13.1765C12.7059 13.4687 12.943 13.7059 13.2353 13.7059H14.2941C14.5863 13.7059 14.8235 13.4687 14.8235 13.1765V12.1176C14.8235 11.8254 14.5863 11.5882 14.2941 11.5882ZM4.76472 11.5882H3.7059C3.41366 11.5882 3.17649 11.8254 3.17649 12.1176V13.1765C3.17649 13.4687 3.41366 13.7059 3.7059 13.7059H4.76472C5.05696 13.7059 5.29413 13.4687 5.29413 13.1765V12.1176C5.29413 11.8254 5.05696 11.5882 4.76472 11.5882ZM4.76472 8.41176H3.7059C3.41366 8.41176 3.17649 8.64894 3.17649 8.94118V10C3.17649 10.2922 3.41366 10.5294 3.7059 10.5294H4.76472C5.05696 10.5294 5.29413 10.2922 5.29413 10V8.94118C5.29413 8.64894 5.05696 8.41176 4.76472 8.41176ZM6.88236 10.5294H7.94118C8.23342 10.5294 8.4706 10.2922 8.4706 10V8.94118C8.4706 8.64894 8.23342 8.41176 7.94118 8.41176H6.88236C6.59013 8.41176 6.35295 8.64894 6.35295 8.94118V10C6.35295 10.2922 6.59013 10.5294 6.88236 10.5294ZM11.1176 8.41176H10.0588C9.76658 8.41176 9.52941 8.64894 9.52941 8.94118V10C9.52941 10.2922 9.76658 10.5294 10.0588 10.5294H11.1176C11.4099 10.5294 11.6471 10.2922 11.6471 10V8.94118C11.6471 8.64894 11.4099 8.41176 11.1176 8.41176ZM14.2941 8.41176H13.2353C12.943 8.41176 12.7059 8.64894 12.7059 8.94118V10C12.7059 10.2922 12.943 10.5294 13.2353 10.5294H14.2941C14.5863 10.5294 14.8235 10.2922 14.8235 10V8.94118C14.8235 8.64894 14.5863 8.41176 14.2941 8.41176Z", fill: "currentColor" }) }), Kf = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1074 16.8677C12.8638 16.8677 11.8524 15.8563 11.8524 14.6127C11.8524 14.4154 11.8862 14.2271 11.9336 14.0444C12.0317 13.6701 12.22 13.3318 12.4804 13.059C12.8908 12.6294 13.467 12.3576 14.1074 12.3576C15.3511 12.3576 16.3625 13.369 16.3625 14.6127C16.3625 15.8563 15.3511 16.8677 14.1074 16.8677ZM4.38257 11.2301C3.13891 11.2301 2.12752 10.2187 2.12752 8.97507C2.12752 7.73141 3.13891 6.72002 4.38257 6.72002C5.01623 6.72002 5.58676 6.98386 5.99718 7.40556C6.25989 7.67616 6.44819 8.01329 6.54966 8.38763C6.60153 8.57592 6.63761 8.76986 6.63761 8.97507C6.63761 9.2017 6.59364 9.41818 6.53049 9.62452C6.41887 9.99435 6.22155 10.327 5.94982 10.5908C5.54391 10.9843 4.99256 11.2301 4.38257 11.2301ZM11.8524 3.38257C11.8524 2.13891 12.8638 1.12753 14.1074 1.12753C15.3511 1.12753 16.3625 2.13891 16.3625 3.38257C16.3625 4.62622 15.3511 5.63761 14.1074 5.63761C13.4749 5.63761 12.9055 5.3749 12.4962 4.95546C12.2324 4.68485 12.0429 4.34773 11.9415 3.97339C11.8896 3.78397 11.8524 3.5889 11.8524 3.38257ZM14.1074 11.2301C13.0498 11.2301 12.1151 11.7273 11.495 12.4907L7.52722 10.1996C7.67605 9.81846 7.76513 9.40804 7.76513 8.97507C7.76513 8.56465 7.68056 8.17678 7.54639 7.8126L11.5108 5.5226C12.132 6.27466 13.0588 6.76513 14.1074 6.76513C15.9724 6.76513 17.49 5.24748 17.49 3.38256C17.49 1.51764 15.9724 0 14.1074 0C12.2425 0 10.7249 1.51764 10.7249 3.38256C10.7249 3.79411 10.8094 4.18423 10.9447 4.54842L6.9815 6.83729C6.36136 6.08411 5.43341 5.59251 4.38256 5.59251C2.51764 5.59251 1 7.11015 1 8.97507C1 10.84 2.51764 12.3576 4.38256 12.3576C5.40974 12.3576 6.32077 11.8875 6.94091 11.1625L10.9368 13.4694C10.8072 13.829 10.7249 14.2102 10.7249 14.6127C10.7249 16.4776 12.2425 17.9952 14.1074 17.9952C15.9724 17.9952 17.49 16.4776 17.49 14.6127C17.49 12.7478 15.9724 11.2301 14.1074 11.2301Z", fill: "currentColor" }) }), zf = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.7647 16.9412H2.05882V1.05883H10.5294V5.29412H14.7647V16.9412ZM11.5882 1.278L14.5455 4.2353H11.5882V1.278ZM15.3587 3.55129L12.2722 0.464824C11.9715 0.165176 11.5724 0 11.1488 0H1V18H15.8235V4.67471C15.8235 4.25118 15.6584 3.852 15.3587 3.55129ZM1 0H15.8235V18H1V0ZM1 18H15.8235V0H1V18ZM4.17649 5.29412H8.41178V4.23529H4.17649V5.29412ZM4.17649 9.52941H10.5294V8.47059H4.17649V9.52941ZM4.17649 13.7647H8.41178V12.7059H4.17649V13.7647ZM4.17649 7.41177H12.6471V6.35294H4.17649V7.41177ZM4.17649 11.6471H11.5883V10.5882H4.17649V11.6471Z", fill: "currentColor" }) });
function Io(D) {
  return typeof D != "string";
}
const Co = {
  share: /* @__PURE__ */ ce(Kf, {}),
  transcript: /* @__PURE__ */ ce(zf, {}),
  media: /* @__PURE__ */ ce(qf, {}),
  delete: /* @__PURE__ */ ce(_l, {}),
  shortcuts: /* @__PURE__ */ ce(Yf, {}),
  edit: /* @__PURE__ */ ce(Vf, {}),
  expand: /* @__PURE__ */ ce(jf, {})
}, El = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.8 3.6C9.79288 3.6 10.6 2.79288 10.6 1.8C10.6 0.80712 9.79288 0 8.8 0C7.80712 0 7 0.80712 7 1.8C7 2.79288 7.80712 3.6 8.8 3.6ZM10.6 8.99999C10.6 9.99287 9.79288 10.8 8.8 10.8C7.80712 10.8 7 9.99287 7 8.99999C7 8.00711 7.80712 7.19999 8.8 7.19999C9.79288 7.19999 10.6 8.00711 10.6 8.99999ZM10.6 16.2C10.6 17.1929 9.79288 18 8.8 18C7.80712 18 7 17.1929 7 16.2C7 15.2071 7.80712 14.4 8.8 14.4C9.79288 14.4 10.6 15.2071 10.6 16.2Z", fill: "currentColor" }) });
function Wf(D) {
  return D.filter((C) => C.showInOverlay).sort((C, B) => (C.order ?? 1) - (B.order ?? 1));
}
function Qf(D, C, B) {
  const le = [];
  return Hf() || le.push({
    id: "keyboard-shortcuts",
    text: B.label,
    icon: "shortcuts",
    onClick: B.onClick,
    order: 1
  }), le.concat(D).filter((be) => !C || !be.showInOverlay).sort((be, qe) => (be.order ?? 1) - (qe.order ?? 1));
}
function Xf({ openShortcuts: D, shouldFocus: C }) {
  const [B, le] = ur(!1), [be, qe] = ur(null), _e = wr(), fe = zn(), R = () => {
    le(!B), _e.globalKeysDisabled.set(!B);
  }, J = lr(null), E = lr([]), { refs: t, floatingStyles: e, context: h } = xi({
    open: B,
    onOpenChange: R,
    whileElementsMounted: Fi,
    placement: "bottom-end",
    middleware: [
      Aa(),
      Ia(10),
      Ca({
        element: J
      })
    ]
  }), p = (te) => {
    te !== null && C && te.focus();
  }, o = wa([t.setReference, p]), v = So(h, {
    listRef: E,
    activeIndex: be,
    onNavigate: qe,
    loop: !0
  }), m = hl(h, {
    toggle: !0
  }), n = Ra(h, {
    outsidePress: !0,
    outsidePressEvent: "mousedown"
  }), { getReferenceProps: c, getFloatingProps: f, getItemProps: S } = Na(
    [m, n, v]
  ), { t: k } = An(), q = Oa(), F = ir(
    () => Qf(fe.kebabMenuElements, q, {
      label: k("KEYBOARD_SHORTCUTS"),
      onClick: D
    }),
    [fe.kebabMenuElements, k, D, q]
  );
  return F.length > 0 ? /* @__PURE__ */ tn(Hr, { children: [
    /* @__PURE__ */ ce(
      "button",
      {
        id: "kebab-menu-button",
        type: "button",
        "aria-label": k("KEBAB_MENU", { title: fe.title }),
        "aria-haspopup": "true",
        "aria-expanded": B,
        className: Qr.kebabMenuButton,
        ref: o,
        ...c({
          onClick: () => R()
        }),
        children: /* @__PURE__ */ ce(El, {})
      }
    ),
    B && /* @__PURE__ */ ce(Da, { context: h, guards: !1, children: /* @__PURE__ */ tn(
      "div",
      {
        id: "kebab-menu",
        ref: t.setFloating,
        style: e,
        className: Qr.kebabMenu,
        role: "menu",
        "aria-labelledby": "kebab-menu-button",
        ...f(),
        children: [
          F.map(({ id: te, text: P, icon: Q, onClick: se, ariaLabel: K }, ie) => /* @__PURE__ */ tn(
            "button",
            {
              tabIndex: be === ie ? 0 : -1,
              type: "button",
              role: "menuitem",
              "aria-label": K,
              className: Qr.kebabMenuItem,
              ref: (ge) => {
                E.current[ie] = ge;
              },
              ...S({
                onClick: () => {
                  se(te), le(!1);
                }
              }),
              children: [
                Io(Q) ? Q : Co[Q],
                P
              ]
            },
            te
          )),
          /* @__PURE__ */ ce(
            Ma,
            {
              ref: J,
              context: h,
              className: Qr.arrow
            }
          )
        ]
      }
    ) })
  ] }) : null;
}
const $f = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Escape"
];
function wo(D, C = !1, B = !0) {
  Ir(() => {
    if (!B)
      return;
    const le = new AbortController();
    return document.addEventListener(
      "keydown",
      (be) => {
        var qe;
        return (qe = D[be.key]) == null ? void 0 : qe.call(D, be);
      },
      {
        passive: !0,
        signal: le.signal
      }
    ), C && window.addEventListener(
      "keydown",
      (be) => {
        $f.includes(be.code) && be.preventDefault();
      },
      { signal: le.signal }
    ), () => {
      le.abort();
    };
  }, [D, C, B]);
}
function Jf(D) {
  const C = ir(() => ({ Escape: D }), [D]);
  return wo(C);
}
const Ro = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.94968 7.74766L3.99993 2.79791L2.79785 3.99999L7.7476 8.94974L2.79785 13.8995L3.99993 15.1016L8.94968 10.1518L13.8994 15.1016L15.1015 13.8995L10.1518 8.94974L15.1015 3.99999L13.8994 2.79791L8.94968 7.74766Z", fill: "currentColor" }) });
function ed({ onClose: D }) {
  const { t: C } = An();
  return Jf(D), /* @__PURE__ */ tn(
    "div",
    {
      className: Qr.keyboardShortcutsOverlay,
      tabIndex: 0,
      role: "dialog",
      "aria-label": C("KEYBOARD_SHORTCUTS"),
      children: [
        /* @__PURE__ */ tn("header", { children: [
          /* @__PURE__ */ ce("h2", { children: C("KEYBOARD_SHORTCUTS") }),
          /* @__PURE__ */ ce(
            "button",
            {
              type: "button",
              className: Qr.closeButton,
              onClick: D,
              "aria-label": C("CLOSE"),
              autoFocus: !0,
              children: /* @__PURE__ */ ce(Ro, {})
            }
          )
        ] }),
        /* @__PURE__ */ tn("table", { children: [
          /* @__PURE__ */ ce("caption", { className: Qr.screenReaderContent, children: C("KEYBOARD_SHORTCUTS") }),
          /* @__PURE__ */ ce("thead", { children: /* @__PURE__ */ tn("tr", { children: [
            /* @__PURE__ */ ce("th", { children: C("ACTION") }),
            /* @__PURE__ */ ce("th", { children: C("SHORTCUT") })
          ] }) }),
          /* @__PURE__ */ tn("tbody", { children: [
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("SEEK_BACKWARD", { seconds: 5 }) }),
              /* @__PURE__ */ ce("td", { children: C("LEFT_ARROW") })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("SEEK_FORWARD", { seconds: 5 }) }),
              /* @__PURE__ */ ce("td", { children: C("RIGHT_ARROW") })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("SEEK_BACKWARD", { seconds: 10 }) }),
              /* @__PURE__ */ ce("td", { children: "J" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("SEEK_FORWARD", { seconds: 10 }) }),
              /* @__PURE__ */ ce("td", { children: "L" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("INCREASE_VOLUME", { percent: 5 }) }),
              /* @__PURE__ */ ce("td", { children: C("UP_ARROW") })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("DECREASE_VOLUME", { percent: 5 }) }),
              /* @__PURE__ */ ce("td", { children: C("DOWN_ARROW") })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("TOGGLE_MUTED") }),
              /* @__PURE__ */ ce("td", { children: "M" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("TOGGLE_PLAY_PAUSE") }),
              /* @__PURE__ */ tn("td", { children: [
                C("SPACE"),
                ", K"
              ] })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("FULLSCREEN") }),
              /* @__PURE__ */ ce("td", { children: "F" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("TOGGLE_CAPTIONS") }),
              /* @__PURE__ */ ce("td", { children: "C" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("NEXT_CAPTION_LANGUAGE") }),
              /* @__PURE__ */ ce("td", { children: "V" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("PREVIOUS_CAPTION_LANGUAGE") }),
              /* @__PURE__ */ ce("td", { children: "X" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("DECREASE_PLAYBACK_SPEED") }),
              /* @__PURE__ */ ce("td", { children: "A" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("RESET_PLAYBACK_SPEED") }),
              /* @__PURE__ */ ce("td", { children: "S" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("INCREASE_PLAYBACK_SPEED") }),
              /* @__PURE__ */ ce("td", { children: "D" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("JUMP_TO_START") }),
              /* @__PURE__ */ ce("td", { children: "0" })
            ] }),
            /* @__PURE__ */ tn("tr", { children: [
              /* @__PURE__ */ ce("td", { children: C("JUMP_TO_PERCENTAGE") }),
              /* @__PURE__ */ ce("td", { children: "1-9" })
            ] })
          ] })
        ] })
      ]
    }
  );
}
const td = "_container_15ptq_1", nd = "_button_15ptq_8", el = {
  container: td,
  button: nd
};
function rd() {
  const D = jn("paused"), C = zn(), B = Oa(), le = ir(
    () => Wf(C.kebabMenuElements),
    [C.kebabMenuElements]
  );
  return B && D ? /* @__PURE__ */ ce("div", { className: el.container, children: le.map(({ id: be, text: qe, overlayText: _e, icon: fe, onClick: R, ariaLabel: J }) => /* @__PURE__ */ tn(
    "button",
    {
      type: "button",
      className: el.button,
      onClick: () => R(be),
      title: qe,
      "aria-label": J,
      children: [
        Io(fe) ? fe : Co[fe],
        _e ?? qe
      ]
    },
    be
  )) }) : null;
}
function id() {
  const D = wr(), [C, B] = ur(!1), le = Sa(), be = lr(!1), qe = lr(!1), _e = xn(() => {
    B(!0), requestAnimationFrame(() => {
      D.interactionsDisabled.set(!0);
    });
    const R = le.getPlayer();
    R != null && R.state.playing && (be.current = !0, le.pause()), qe.current = !0;
  }, [le, D]), fe = xn(() => {
    B(!1), D.interactionsDisabled.set(!1), be.current && (be.current = !1, le.play());
  }, [le, D]);
  return C ? /* @__PURE__ */ ce(ed, { onClose: fe }) : /* @__PURE__ */ tn("div", { className: Qr.controlsOverlay, children: [
    /* @__PURE__ */ ce(rd, {}),
    /* @__PURE__ */ ce(
      Xf,
      {
        openShortcuts: _e,
        shouldFocus: qe.current
      }
    )
  ] });
}
const vl = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M21.6133 0C21.7618 0.00076969 21.9069 0.0163677 22.0479 0.0429688C22.08 0.049029 22.1118 0.0561449 22.1436 0.0634766C22.2504 0.0882055 22.3543 0.119742 22.4551 0.158203C22.5054 0.177395 22.5548 0.198283 22.6035 0.220703C22.6693 0.251023 22.7328 0.285114 22.7949 0.321289C23.5109 0.698258 24.001 1.44878 24.001 2.3125V2.37598C24.0011 2.38411 24.002 2.39224 24.002 2.40039V21.5996C24.002 21.6084 24.0011 21.6172 24.001 21.626V21.8125C24.001 23.053 22.9915 24.0625 21.751 24.0625H2.25098C1.01048 24.0625 0.000976562 23.053 0.000976562 21.8125V2.3125C0.000976562 1.45189 0.487409 0.703493 1.19922 0.325195C1.2534 0.29368 1.30843 0.263587 1.36523 0.236328C1.42453 0.207895 1.485 0.181784 1.54688 0.158203C1.63627 0.1241 1.72811 0.0956196 1.82227 0.0722656C1.87757 0.0585704 1.93349 0.0468931 1.99023 0.0371094C2.1196 0.0147491 2.25212 0.00075657 2.3877 0H21.6133ZM2.66797 21.334H21.335V2.66699H2.66797V21.334ZM9.41211 8.00391C10.1452 8.00415 10.7451 8.60471 10.7451 9.33789V10.6709H8.74512V10.0039H6.07812V14.0039H8.74512V13.3379H10.7451V14.6709C10.7451 15.4041 10.1452 16.0037 9.41211 16.0039H5.41211C4.6788 16.0039 4.07814 15.4042 4.07812 14.6709V9.33789C4.07812 8.60457 4.67878 8.00391 5.41211 8.00391H9.41211ZM18.4746 8.00391C19.2077 8.00415 19.8076 8.60471 19.8076 9.33789V10.6709H17.8076V10.0039H15.1406V14.0039H17.8076V13.3379H19.8076V14.6709C19.8076 15.4041 19.2077 16.0037 18.4746 16.0039H14.4746C13.7413 16.0039 13.1406 15.4042 13.1406 14.6709V9.33789C13.1406 8.60457 13.7413 8.00391 14.4746 8.00391H18.4746Z", fill: "currentColor" }) }), Tl = (D) => /* @__PURE__ */ tn("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...D, children: [
  /* @__PURE__ */ ce("defs", { children: /* @__PURE__ */ ce("clipPath", { id: "clip0_149_104406", children: /* @__PURE__ */ ce("rect", { width: 24, height: 24, fill: "white" }) }) }),
  /* @__PURE__ */ ce("g", { clipPath: "url(#clip0_149_104406)", children: /* @__PURE__ */ ce("path", { d: "M21.3333 0H2.66666C1.18666 0 0 1.35 0 3V21C0 22.65 1.18666 24 2.66666 24H21.3333C22.8 24 24 22.65 24 21V3C24 1.35 22.8 0 21.3333 0ZM10.6667 10.6667H8.66666V10H6V14H8.66666V13.3333H10.6667V14.6667C10.6667 15.4 10.0667 16 9.33334 16H5.33334C4.6 16 4 15.4 4 14.6667V9.33334C4 8.6 4.6 8 5.33334 8H9.33334C10.0667 8 10.6667 8.6 10.6667 9.33334V10.6667ZM20.0042 10.6667H18.0042V10H15.3375V14H18.0042V13.3333H20.0042V14.6667C20.0042 15.4 19.4042 16 18.6708 16H14.6708C13.9375 16 13.3375 15.4 13.3375 14.6667V9.33334C13.3375 8.6 13.9375 8 14.6708 8H18.6708C19.4042 8 20.0042 8.6 20.0042 9.33334V10.6667Z", fill: "currentColor" }) })
] });
function ad() {
  const D = Sa(), C = jn("textTrack"), B = jn("hasCaptions"), le = C && Kc(C), { t: be } = An(), qe = xn(
    (_e) => {
      D.toggleCaptions(_e.nativeEvent);
    },
    [D]
  );
  return B ? /* @__PURE__ */ ce(
    "button",
    {
      type: "button",
      className: "controls-button",
      onClick: qe,
      "aria-label": be("CAPTIONS"),
      "aria-pressed": le ? "true" : "false",
      children: le ? /* @__PURE__ */ ce(Tl, { className: "controls-button-icon" }) : /* @__PURE__ */ ce(vl, { className: "controls-button-icon" })
    }
  ) : null;
}
const od = "_captions_1mt3b_1", sd = {
  captions: od
}, ld = (D, C) => D ? C.top : C.bottom;
function bl({ captions: D }) {
  const { captionOffsetOverride: C, controlsLayout: B } = zn(), le = dr("captionPositionOnTop"), be = dr("captionsInvertColors"), qe = dr("captionsFontSizeMultiplier"), _e = ld(
    le,
    C ?? {}
  );
  return /* @__PURE__ */ tn(Hr, { children: [
    D.map((fe) => /* @__PURE__ */ ce(
      zc,
      {
        kind: "subtitles",
        type: fe.type,
        language: fe.language,
        label: fe.label,
        src: fe.src,
        sourceType: fe.sourceType
      },
      fe.src ? fe.src : `${fe.language}-${fe.sourceType || "standard"}`
    )),
    D.length > 0 ? /* @__PURE__ */ ce(
      "div",
      {
        style: {
          display: "contents",
          ..._e ? { "--caption-offset": _e } : {},
          "--captions-font-size-multiplier": qe ?? 1,
          "--captions-justify-content": le ? "start" : "end",
          "--captions-color": be ? "rgba(22, 22, 22)" : "white",
          "--captions-background-color": be ? "rgba(255, 255, 255, 0.75)" : "rgba(22, 22, 22, 0.75)",
          "--captions-fullscreen-offset": B === "normal" ? "5.5rem" : "4rem"
        },
        children: /* @__PURE__ */ ce(Wc, { className: sd.captions })
      }
    ) : null
  ] });
}
const ud = "_comments-overlay_1t0mq_1", cd = "_comments-container_1t0mq_20", fd = "_comment_1t0mq_1", dd = "_comment-text_1t0mq_64", gd = "_comment-author-avatar_1t0mq_84", hd = "_comment-author-name_1t0mq_108", oi = {
  "comments-overlay": "_comments-overlay_1t0mq_1",
  commentsOverlay: ud,
  "comments-container": "_comments-container_1t0mq_20",
  commentsContainer: cd,
  comment: fd,
  "comment-text": "_comment-text_1t0mq_64",
  commentText: dd,
  "comment-author-avatar": "_comment-author-avatar_1t0mq_84",
  commentAuthorAvatar: gd,
  "comment-author-name": "_comment-author-name_1t0mq_108",
  commentAuthorName: hd
};
function md({ comment: D }) {
  return D.render ? D.render(D, oi) : /* @__PURE__ */ tn("div", { className: oi.comment, onClick: () => {
    var C;
    return (C = D.onClick) == null ? void 0 : C.call(D, D);
  }, children: [
    /* @__PURE__ */ ce(
      "img",
      {
        className: oi.commentAuthorAvatar,
        src: D.user.avatar,
        alt: D.user.name
      }
    ),
    /* @__PURE__ */ ce("span", { className: oi.commentText, children: D.text }),
    /* @__PURE__ */ ce("span", { className: oi.commentAuthorName, children: D.user.name })
  ] });
}
const pd = (D) => {
  const [, C] = ur({});
  return ir(() => {
    let B = [];
    return {
      add(le) {
        B.length >= D && B.shift(), B.push(le), C({});
      },
      remove(le) {
        B = B.filter((be) => be !== le), C({});
      },
      clear() {
        B = [], C({});
      },
      map(le) {
        return B.map(le);
      }
    };
  }, []);
}, yd = (D, C, B) => {
  let le = !1;
  return (be) => {
    const qe = be.detail.currentTime;
    qe >= D.timestamp && qe < D.timestamp + C && !le && (B.add(D), le = !0), (qe < D.timestamp || qe >= D.timestamp + C) && le && (B.remove(D), le = !1);
  };
}, _d = (D, C = 5) => {
  const B = Cr(), le = pd(C);
  return Ir(() => {
    if (!B)
      return;
    const be = new AbortController();
    return requestAnimationFrame(() => {
      for (const qe of D) {
        const _e = yd(qe, gf, le);
        B.addEventListener("time-update", _e, {
          signal: be.signal
        });
      }
      B.dispatchEvent(
        new CustomEvent("time-update", {
          detail: { currentTime: B.currentTime }
        })
      );
    }), () => {
      be.abort(), le.clear();
    };
  }, [B, le, D]), le;
}, Ed = 4;
function vd({ comments: D }) {
  const { controlsLayout: C } = zn(), B = dr("commentsEnabled"), le = dr("captionPositionOnTop"), be = _d(D, Ed), qe = !!jn("textTrack"), _e = be.map((fe) => /* @__PURE__ */ ce(md, { comment: fe }, fe.id));
  return D.length > 0 && B ? /* @__PURE__ */ ce(
    "div",
    {
      className: oi.commentsOverlay,
      "data-testid": "comments-overlay",
      style: {
        flexDirection: le && qe ? "column-reverse" : "column",
        "--comments-fullscreen-offset": C === "normal" ? "5.5rem" : "4rem"
      },
      children: /* @__PURE__ */ ce("div", { className: oi.commentsContainer, children: qe ? _e.slice(-3) : _e })
    }
  ) : null;
}
function Td({ renderOverlay: D }) {
  const C = wr();
  return D(C);
}
const bd = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0692 12C21.0692 11.4776 21.0212 10.944 20.9238 10.4104L23.5511 8.13318L21.0579 3.87247L17.7431 4.97788C16.9059 4.28329 15.9515 3.73553 14.9449 3.37271L14.2616 0H9.28941L8.60612 3.37129C7.58823 3.73553 6.65082 4.27482 5.80659 4.97647L2.49318 3.87247L0 8.13318L2.62729 10.4104C2.52988 10.944 2.48188 11.4776 2.48188 12C2.48188 12.5224 2.52988 13.056 2.62729 13.5896L0 15.8668L2.49318 20.1275L5.808 19.0221C6.64518 19.7167 7.59953 20.2645 8.60612 20.6273L9.28941 24H14.2616L14.9449 20.6287C15.9614 20.2645 16.9002 19.7252 17.7445 19.0235L21.0579 20.1289L23.5511 15.8682L20.9238 13.5911C21.0212 13.056 21.0692 12.5224 21.0692 12ZM11.7755 16.9412C9.05082 16.9412 6.83435 14.7247 6.83435 12C6.83435 9.2753 9.05082 7.05883 11.7755 7.05883C14.5002 7.05883 16.7167 9.2753 16.7167 12C16.7167 14.7247 14.5002 16.9412 11.7755 16.9412Z", fill: "currentColor" }) }), Sd = "_settings-menu_1eq3c_1", Ad = "_menu-heading_1eq3c_38", Id = "_check-icon_1eq3c_49", Cd = "_trash-icon_1eq3c_50", wd = "_menu-item-multiline-label-wrapper_1eq3c_63", Rd = "_menu-item-secondary-label_1eq3c_69", Nd = "_menu-item-label_1eq3c_75", Dd = "_menu-item_1eq3c_63", Md = "_menu-back-button_1eq3c_116", Od = "_arrow_1eq3c_142", Br = {
  "settings-menu": "_settings-menu_1eq3c_1",
  settingsMenu: Sd,
  "menu-heading": "_menu-heading_1eq3c_38",
  menuHeading: Ad,
  "check-icon": "_check-icon_1eq3c_49",
  checkIcon: Id,
  "trash-icon": "_trash-icon_1eq3c_50",
  trashIcon: Cd,
  "menu-item-multiline-label-wrapper": "_menu-item-multiline-label-wrapper_1eq3c_63",
  menuItemMultilineLabelWrapper: wd,
  "menu-item-secondary-label": "_menu-item-secondary-label_1eq3c_69",
  menuItemSecondaryLabel: Rd,
  "menu-item-label": "_menu-item-label_1eq3c_75",
  menuItemLabel: Nd,
  "menu-item": "_menu-item_1eq3c_63",
  menuItem: Dd,
  "menu-back-button": "_menu-back-button_1eq3c_116",
  menuBackButton: Md,
  arrow: Od
}, Ld = (D) => D.map((C) => {
  const { language: B, sourceType: le } = C;
  return le === "youtube" ? { ...C, language: `${B}${Ao}` } : C;
}), Pd = (D) => D ? D.replace(Ao, "") : null, xd = (D, C) => D.reduce((B, le) => {
  const be = B.findIndex(
    (qe) => qe.languageCode === le.languageCode
  );
  return be === -1 ? B.push(le) : B[be].kind === "asr" && le.kind !== "asr" && (B[be] = le), B;
}, []).map((B) => ({
  label: new Intl.DisplayNames([C], { type: "language" }).of(
    B.languageCode
  ) || B.displayName,
  language: B.languageCode,
  sourceType: "youtube",
  type: "srt"
}));
function ha(D, C) {
  if (!(D != null && D.contentWindow)) return;
  const B = C ? Pd(C) : null, le = {
    event: "command",
    func: "setOption",
    args: [
      "captions",
      "track",
      C ? { languageCode: B } : {}
    ]
  };
  D.contentWindow.postMessage(JSON.stringify(le), "*");
}
const tl = {
  0.5: -1,
  1: 0,
  2: 1,
  3: 2,
  4: 3
};
function Sl(D, C) {
  var le;
  if (!(D != null && D.contentWindow)) return;
  const B = {
    event: "command",
    func: "setOption",
    args: [
      "captions",
      "fontSize",
      tl[C] !== void 0 ? tl[C] : 0
    ]
  };
  (le = D.contentWindow) == null || le.postMessage(JSON.stringify(B), "*");
}
const Fd = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.037 3.03704L6.07407 9L12.037 14.963L11 16L4 9L11 2L12.037 3.03704Z", fill: "currentColor" }) });
function li({
  noBackButton: D,
  heading: C,
  children: B
}) {
  const le = Xr(), { t: be } = An();
  return /* @__PURE__ */ tn(Hr, { children: [
    !D && /* @__PURE__ */ tn(
      "button",
      {
        type: "button",
        role: "menuitem",
        tabIndex: -1,
        className: Br.menuBackButton,
        onClick: le.back,
        children: [
          /* @__PURE__ */ ce(Fd, {}),
          /* @__PURE__ */ ce("span", { children: be("BACK") })
        ]
      }
    ),
    C && /* @__PURE__ */ ce(
      "strong",
      {
        role: "presentation",
        id: "menu-heading",
        className: Br.menuHeading,
        children: C
      }
    ),
    B
  ] });
}
const kd = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.1347 3.00061L6.55157 13.5825L0.865302 7.89624L0 8.76154L6.55157 15.3131L17.9988 3.86469L17.1347 3.00061Z", fill: "currentColor" }) });
function La({
  selected: D,
  label: C,
  secondaryLabel: B,
  onClick: le
}) {
  return /* @__PURE__ */ tn(
    "button",
    {
      type: "button",
      role: "menuitemradio",
      "aria-checked": D,
      onClick: le,
      tabIndex: -1,
      className: Br.menuItem,
      children: [
        /* @__PURE__ */ ce(kd, { className: Br.checkIcon }),
        /* @__PURE__ */ tn("div", { className: Br.menuItemMultilineLabelWrapper, children: [
          /* @__PURE__ */ ce("span", { className: Br.menuItemLabel, children: C }),
          B && /* @__PURE__ */ ce("span", { className: Br.menuItemSecondaryLabel, children: B })
        ] })
      ]
    }
  );
}
function Zd() {
  const D = wr(), C = dr("captionsFontSizeMultiplier"), B = dr(
    "youtubeEducationProvider"
  ), { t: le } = An();
  return /* @__PURE__ */ ce(li, { heading: le("CAPTION_FONT_SIZE"), children: df.map((be) => /* @__PURE__ */ ce(
    La,
    {
      selected: be === C,
      onClick: () => {
        D.captionsFontSizeMultiplier.set(be), B && Sl(B.iframe, be);
      },
      label: `${be * 100}%`
    },
    be
  )) });
}
function Bd() {
  const D = Qc(), { t: C } = An();
  return /* @__PURE__ */ ce(li, { heading: C("CAPTIONS_LANGUAGE"), children: D.map(({ value: B, label: le, select: be, selected: qe, track: _e }, fe) => /* @__PURE__ */ ce(
    La,
    {
      selected: qe,
      onClick: () => !qe && be(),
      label: le,
      secondaryLabel: (_e == null ? void 0 : _e.sourceType) === "youtube" ? "YouTube" : void 0
    },
    `${B}-${fe}-${(_e == null ? void 0 : _e.language) || "und"}-${(_e == null ? void 0 : _e.sourceType) || "standard"}`
  )) });
}
const Xr = () => {
  const D = ba(Nl);
  if (!D)
    throw new Error(
      "useCustomSettingsMenuContext must be used within a CustomSettingsMenuContext.Provider"
    );
  return D;
};
function Ud() {
  const D = Xr(), C = zn(), { t: B } = An();
  return Ir(() => {
    C.captions.length === 0 && D.backToMain();
  }, [C.captions]), /* @__PURE__ */ ce(li, { heading: B("CAPTIONS_MANAGE"), children: C.captions.map((le) => /* @__PURE__ */ tn(
    "button",
    {
      type: "button",
      role: "menuitem",
      onClick: () => {
        var be;
        (be = C.onCaptionsDelete) == null || be.call(C, le);
      },
      tabIndex: -1,
      className: Br.menuItem,
      children: [
        /* @__PURE__ */ ce(_l, { className: Br.trashIcon }),
        /* @__PURE__ */ ce("span", { className: Br.menuItemLabel, children: B("CAPTION_DELETE", { language: le.label }) })
      ]
    },
    le.language
  )) });
}
const Gd = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3.03704L7.03704 2L14.037 9L7.03704 16L6 14.963L11.963 9L6 3.03704Z", fill: "currentColor" }) }), Hd = "_menu-hint_16n6u_1", qd = "_menu-button_16n6u_5", Vd = "_menu-label_16n6u_42", jd = "_menu-icon_16n6u_47", ma = {
  "menu-hint": "_menu-hint_16n6u_1",
  menuHint: Hd,
  "menu-button": "_menu-button_16n6u_5",
  menuButton: qd,
  "menu-label": "_menu-label_16n6u_42",
  menuLabel: Vd,
  "menu-icon": "_menu-icon_16n6u_47",
  menuIcon: jd
};
function Ai({
  label: D,
  hint: C,
  onClick: B,
  Icon: le,
  disabled: be = !1
}) {
  return /* @__PURE__ */ tn(
    "button",
    {
      type: "button",
      role: "menuitem",
      "aria-haspopup": be ? void 0 : "true",
      disabled: be,
      tabIndex: -1,
      onClick: B,
      className: ma.menuButton,
      children: [
        le && /* @__PURE__ */ ce(le, { className: ma.menuIcon }),
        /* @__PURE__ */ ce("span", { className: ma.menuLabel, children: D }),
        C && /* @__PURE__ */ ce("span", { className: ma.menuHint, children: C }),
        !be && /* @__PURE__ */ ce(Gd, {})
      ]
    }
  );
}
function Yd() {
  const { t: D } = An(), C = Xr(), B = dr("captionsFontSizeMultiplier"), le = xn(() => {
    C.setPage("captionFontSize");
  }, [C]);
  return /* @__PURE__ */ ce(
    Ai,
    {
      label: D("CAPTION_FONT_SIZE"),
      hint: `${B * 100}%`,
      onClick: le
    }
  );
}
const Kd = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M 21.798373,3.342155 8.8843977,16.256145 2.2000774,9.571825 0,11.771895 8.8843977,20.657845 24,5.543795 Z", fill: "currentColor" }) }), zd = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M 9.64706,12 4,17.64706 6.35293,20 12,14.35293 17.64706,20 20,17.64706 14.35293,12 20,6.35293 17.64706,4 12,9.64706 6.35293,4 4,6.35293 Z", fill: "currentColor" }) }), Wd = "_switch-track_olfik_1", Qd = "_switch-thumb_olfik_22", Xd = "_switch-icon_olfik_36", $d = "_switch-body_olfik_42", Jd = "_switch-label_olfik_83", eg = "_menu-icon_olfik_87", ii = {
  "switch-track": "_switch-track_olfik_1",
  switchTrack: Wd,
  "switch-thumb": "_switch-thumb_olfik_22",
  switchThumb: Qd,
  "switch-icon": "_switch-icon_olfik_36",
  switchIcon: Xd,
  "switch-body": "_switch-body_olfik_42",
  switchBody: $d,
  "switch-label": "_switch-label_olfik_83",
  switchLabel: Jd,
  "menu-icon": "_menu-icon_olfik_87",
  menuIcon: eg
};
function No({
  label: D,
  checked: C = !1,
  onClick: B,
  Icon: le
}) {
  return /* @__PURE__ */ tn(
    "button",
    {
      type: "button",
      className: ii.switchBody,
      role: "menuitemcheckbox",
      "aria-label": D,
      "aria-checked": C,
      onClick: B,
      tabIndex: -1,
      children: [
        le && /* @__PURE__ */ ce(le, { className: ii.menuIcon }),
        /* @__PURE__ */ ce("span", { className: ii.switchLabel, children: D }),
        /* @__PURE__ */ ce("div", { className: ii.switchTrack, children: /* @__PURE__ */ ce("div", { className: ii.switchThumb, children: C ? /* @__PURE__ */ ce(Kd, { className: ii.switchIcon }) : /* @__PURE__ */ ce(zd, { className: ii.switchIcon }) }) })
      ]
    }
  );
}
function tg() {
  const { t: D } = An(), C = wr(), B = dr("captionsInvertColors");
  return /* @__PURE__ */ ce(
    No,
    {
      label: D("INVERT_COLORS"),
      onClick: () => C.captionsInvertColors.set(!B),
      checked: B
    }
  );
}
function ng() {
  const D = Xr(), C = jn("textTrack"), { t: B } = An(), { disableCaptionSettings: le } = zn(), be = xn(() => {
    D.setPage("captionLanguage");
  }, [D]);
  return le ? null : /* @__PURE__ */ ce(
    Ai,
    {
      label: B("LANGUAGE"),
      hint: (C == null ? void 0 : C.label) ?? B("OFF"),
      onClick: be
    }
  );
}
function rg() {
  const D = Xr(), { t: C } = An(), B = xn(() => {
    D.setPage("captionManage");
  }, [D]);
  return /* @__PURE__ */ ce(Ai, { label: C("CAPTIONS_MANAGE"), onClick: B });
}
function ig() {
  const { t: D } = An(), C = wr(), B = dr("captionPositionOnTop");
  return /* @__PURE__ */ ce(
    No,
    {
      label: D("ON_TOP"),
      onClick: () => C.captionPositionOnTop.set(!B),
      checked: B
    }
  );
}
function ag() {
  const D = zn(), { t: C } = An(), B = jn("textTrack");
  return /* @__PURE__ */ tn(li, { heading: C("CAPTIONS"), children: [
    /* @__PURE__ */ ce(ng, {}),
    /* @__PURE__ */ ce(Yd, {}),
    (B == null ? void 0 : B.sourceType) !== "youtube" && /* @__PURE__ */ tn(Hr, { children: [
      /* @__PURE__ */ ce(ig, {}),
      /* @__PURE__ */ ce(tg, {})
    ] }),
    D.onCaptionsDelete && /* @__PURE__ */ ce(rg, {})
  ] });
}
function og() {
  const D = Xr(), C = jn("hasCaptions"), B = jn("textTrack"), { t: le } = An(), be = xn(() => {
    D.setPage("captions");
  }, [D]);
  return C ? /* @__PURE__ */ ce(
    Ai,
    {
      label: le("CAPTIONS"),
      hint: (B == null ? void 0 : B.label) ?? le("OFF"),
      onClick: be,
      Icon: vl
    }
  ) : null;
}
const sg = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 0V12.7489H5.44V18L10.5007 12.7489H16.582V0H1ZM2 1H15.58V11.7339H9.98655L6.52667 15.25V11.7339H2V1ZM5.24963 5.35011H12.3323V4.24835H5.24963V5.35011ZM5.24963 8.18462H9.50067V7.08285H5.24963V8.18462Z", fill: "currentColor" }) });
function lg() {
  const { t: D } = An(), C = zn(), B = wr(), le = dr("commentsEnabled");
  return !C.forceComments && C.hasComments ? /* @__PURE__ */ ce(
    No,
    {
      Icon: sg,
      label: D("COMMENTS"),
      onClick: () => B.commentsEnabled.set(!le),
      checked: le
    }
  ) : null;
}
function Al(D) {
  const { width: C, height: B } = D;
  if (C >= 3800 || B >= 2100)
    return "2160p";
  const le = B > C, be = le ? C : B, qe = le ? B : C;
  return be >= 1400 || qe >= 2500 ? "1440p" : be >= 1e3 || qe >= 1800 ? "1080p" : be >= 700 || qe >= 1200 ? "720p" : be >= 460 || qe >= 800 ? "480p" : be >= 300 || qe >= 540 ? "360p" : be >= 200 || qe >= 360 ? "240p" : "144p";
}
const ug = (D) => /* @__PURE__ */ tn("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: [
  /* @__PURE__ */ ce("defs", { children: /* @__PURE__ */ ce("clipPath", { id: "clip0_412_23039", children: /* @__PURE__ */ ce("rect", { width: 18, height: 18, fill: "white" }) }) }),
  /* @__PURE__ */ tn("g", { clipPath: "url(#clip0_412_23039)", children: [
    /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.46326 3.85039H0V2.65039H2.46326C2.7388 1.36449 3.88181 0.400391 5.24999 0.400391C6.61818 0.400391 7.76119 1.36449 8.03673 2.65039H18V3.85039H8.03673C7.76119 5.13629 6.61818 6.10039 5.24999 6.10039C3.88181 6.10039 2.7388 5.13629 2.46326 3.85039ZM3.59999 3.25039C3.59999 2.33912 4.33872 1.60039 5.24999 1.60039C6.16126 1.60039 6.89999 2.33912 6.89999 3.25039C6.89999 4.16166 6.16126 4.90039 5.24999 4.90039C4.33872 4.90039 3.59999 4.16166 3.59999 3.25039Z", fill: "currentColor" }),
    /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.40039H9.46326C9.7388 7.11449 10.8818 6.15039 12.25 6.15039C13.6182 6.15039 14.7612 7.11449 15.0367 8.40039H18V9.60039H15.0367C14.7612 10.8863 13.6182 11.8504 12.25 11.8504C10.8818 11.8504 9.7388 10.8863 9.46326 9.60039H0V8.40039ZM12.25 7.35039C11.3387 7.35039 10.6 8.08912 10.6 9.00039C10.6 9.91166 11.3387 10.6504 12.25 10.6504C13.1613 10.6504 13.9 9.91166 13.9 9.00039C13.9 8.08912 13.1613 7.35039 12.25 7.35039Z", fill: "currentColor" }),
    /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.24999 17.6004C6.61818 17.6004 7.76119 16.6363 8.03673 15.3504H18V14.1504H8.03673C7.76119 12.8645 6.61818 11.9004 5.24999 11.9004C3.88181 11.9004 2.7388 12.8645 2.46326 14.1504H0V15.3504H2.46326C2.7388 16.6363 3.88181 17.6004 5.24999 17.6004ZM5.24999 13.1004C4.33872 13.1004 3.59999 13.8391 3.59999 14.7504C3.59999 15.6617 4.33872 16.4004 5.24999 16.4004C6.16126 16.4004 6.89999 15.6617 6.89999 14.7504C6.89999 13.8391 6.16126 13.1004 5.24999 13.1004Z", fill: "currentColor" })
  ] })
] });
function cg(D, C, B, le) {
  return D ? C ? le("AUTO_QUALITY", { quality: B }) : le("AUTO") : B;
}
function fg() {
  const D = Xr(), C = jn("autoQuality"), B = jn("started"), le = jn("quality"), { t: be } = An(), qe = xn(() => {
    D.setPage("quality");
  }, [D]);
  if (!le)
    return null;
  const _e = Al(le), fe = cg(C, B, _e, be);
  return /* @__PURE__ */ ce(
    Ai,
    {
      label: be("QUALITY"),
      hint: fe,
      onClick: qe,
      Icon: ug
    }
  );
}
const dg = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.42229 2.82911C4.71149 1.83006 6.23876 1.19768 7.8383 1L7.96797 2.05432C6.55867 2.22862 5.21101 2.7866 4.07273 3.66874L3.42229 2.82911ZM5.44493 6.71393L9.49745 10.7665L17.0924 3.1705L17.8438 3.92297L9.49745 12.2693L4.69352 7.46534L5.44493 6.71393ZM17.932 8.83829C17.8618 8.27074 17.7364 7.70745 17.5589 7.16222L16.5482 7.49276C16.7055 7.97209 16.816 8.46843 16.8766 8.96689C16.917 9.29742 16.9372 9.6269 16.9372 9.96594C16.9372 10.305 16.917 10.6344 16.8777 10.9639C16.7033 12.3732 16.1454 13.7209 15.2632 14.8592L16.1029 15.5096C17.1019 14.2204 17.7343 12.6931 17.932 11.0925C17.9766 10.7205 18 10.3486 18 9.96594C18 9.58332 17.9766 9.21134 17.932 8.83829ZM1.05432 8.96795L0 8.83829C0.197684 7.23874 0.830061 5.71147 1.82911 4.42228L2.66874 5.07272C1.7866 6.211 1.22862 7.55865 1.05432 8.96795ZM0 11.0936C0.197684 12.6931 0.830061 14.2204 1.82911 15.5096L2.66874 14.8591C1.7866 13.7209 1.22862 12.3732 1.05432 10.9639L0 11.0936ZM10.0939 1.00011C11.6935 1.19673 13.2207 1.83017 14.5099 2.82922L13.8595 3.66884C12.7202 2.7867 11.3736 2.22872 9.96426 2.05442L10.0939 1.00011Z", fill: "currentColor" }) });
function gg() {
  const D = Xr(), C = zn(), B = jn("playbackRate"), { t: le } = An(), be = xn(() => {
    D.setPage("speed");
  }, [D]);
  return /* @__PURE__ */ ce(
    Ai,
    {
      label: le("PLAYBACK_SPEED"),
      hint: `${B}x`,
      onClick: be,
      disabled: C.lockSpeed,
      Icon: dg
    }
  );
}
function hg() {
  return /* @__PURE__ */ tn(li, { noBackButton: !0, children: [
    /* @__PURE__ */ ce(gg, {}),
    /* @__PURE__ */ ce(og, {}),
    /* @__PURE__ */ ce(lg, {}),
    /* @__PURE__ */ ce(fg, {})
  ] });
}
function mg() {
  const D = jn("autoQuality"), C = Xc({ sort: "descending" }), { t: B } = An();
  return /* @__PURE__ */ ce(li, { heading: B("QUALITY"), children: C.map(({ value: le, select: be, selected: qe, label: _e, quality: fe }) => /* @__PURE__ */ ce(
    La,
    {
      selected: le === "auto" && D || qe && !D,
      onClick: () => be(),
      label: fe ? Al(fe) : _e
    },
    le
  )) });
}
function pg() {
  const D = $c({
    rates: Si,
    normalLabel: "1x"
  }), { t: C } = An();
  return /* @__PURE__ */ ce(li, { heading: C("PLAYBACK_SPEED"), children: D.map(({ value: B, label: le, select: be, selected: qe }) => /* @__PURE__ */ ce(
    La,
    {
      selected: qe,
      onClick: () => be(),
      label: le
    },
    B
  )) });
}
function Il(D, C) {
  const B = Array.from(D.querySelectorAll("button")).filter(
    (be) => !be.disabled
  ), le = B.indexOf(C);
  return B[le - 1] ?? null;
}
function Cl(D, C) {
  const B = Array.from(D.querySelectorAll("button")).filter(
    (be) => !be.disabled
  ), le = B.indexOf(C);
  return B[le + 1] ?? null;
}
function nl(D) {
  return D.querySelector("button");
}
function rl(D) {
  const C = Array.from(D.querySelectorAll("button"));
  return C[C.length - 1] ?? null;
}
function wl(D, C) {
  var le, be;
  if (!D)
    return;
  const B = document.activeElement;
  if (B && B !== D && D.contains(B)) {
    const qe = Il(D, B);
    qe ? qe.focus() : (le = rl(D)) == null || le.focus();
  } else C && D.contains(C) ? C.focus() : (be = rl(D)) == null || be.focus();
}
function Rl(D, C) {
  var le, be;
  if (!D)
    return;
  const B = document.activeElement;
  if (B && B !== D && D.contains(B)) {
    const qe = Cl(D, B);
    qe ? qe.focus() : (le = nl(D)) == null || le.focus();
  } else C && D.contains(C) ? C.focus() : (be = nl(D)) == null || be.focus();
}
function yg(D, C) {
  const B = lr(null), le = ir(
    () => ({
      Escape: D.toggle,
      ArrowUp: () => wl(B.current),
      ArrowDown: () => Rl(B.current),
      ArrowRight: () => {
        const be = document.activeElement;
        be && be.getAttribute("aria-haspopup") === "true" && B.current && B.current.contains(be) && be.click();
      },
      ArrowLeft: D.back
    }),
    [D]
  );
  return wo(le, !0, C), B;
}
const Nl = Ta(null), _g = {
  main: hg,
  speed: pg,
  captions: ag,
  captionLanguage: Bd,
  captionFontSize: Zd,
  captionManage: Ud,
  quality: mg
};
function Eg(D) {
  return {
    name: "resizingMiddleware",
    options: D,
    async fn(C) {
      const B = await ff(C, {
        boundary: D ?? void 0
      });
      return {
        x: C.x - B.right - 4,
        y: C.y - 4
      };
    }
  };
}
function vg() {
  const D = wr(), [C, B] = ur(["main"]), [le, be] = ur(!1), qe = xn(() => {
    be(!le), B(["main"]), D.globalKeysDisabled.set(!le);
  }, [le]), _e = xn((f) => {
    B((S) => S.concat(f));
  }, []), fe = xn(() => {
    B((f) => f.length > 1 ? f.slice(0, -1) : f);
  }, []), R = xn(() => {
    B(["main"]);
  }, []), J = ir(() => _g[C[C.length - 1]], [C]), { refs: E, floatingStyles: t, context: e } = xi({
    open: le,
    onOpenChange: qe,
    placement: "top-end",
    whileElementsMounted: Fi,
    middleware: [Eg(D.playerElement.current)]
  }), h = hl(e, {
    toggle: !0
  }), p = Ra(e, {
    escapeKey: !1,
    outsidePress: !0,
    outsidePressEvent: "mousedown"
  }), { getReferenceProps: o, getFloatingProps: v } = Na([
    h,
    p
  ]), m = ir(
    () => ({ setPage: _e, back: fe, backToMain: R, toggle: qe }),
    [_e, fe, R, qe]
  ), n = yg(m, le), c = wa([E.setFloating, n]);
  return {
    Page: J,
    open: le,
    floatingRef: c,
    referenceRef: E.setReference,
    floatingStyles: t,
    context: e,
    getReferenceProps: o,
    getFloatingProps: v,
    contextValue: m
  };
}
function Tg() {
  const {
    Page: D,
    context: C,
    floatingStyles: B,
    getFloatingProps: le,
    getReferenceProps: be,
    open: qe,
    floatingRef: _e,
    referenceRef: fe,
    contextValue: R
  } = vg(), { t: J } = An();
  return /* @__PURE__ */ tn(Hr, { children: [
    /* @__PURE__ */ ce(
      "button",
      {
        ref: fe,
        type: "button",
        className: "controls-button",
        "aria-label": J("SETTINGS"),
        "aria-expanded": qe,
        "aria-haspopup": "true",
        ...be(),
        children: /* @__PURE__ */ ce(bd, { className: "controls-button-icon icon-rotate" })
      }
    ),
    qe && /* @__PURE__ */ ce(
      Da,
      {
        context: C,
        restoreFocus: !0,
        guards: !1,
        initialFocus: -1,
        children: /* @__PURE__ */ ce(
          "div",
          {
            role: "menu",
            "aria-label": J("VIDEO_SETTINGS"),
            "aria-labelledby": "menu-heading",
            className: Br.settingsMenu,
            ref: _e,
            style: B,
            ...le(),
            children: /* @__PURE__ */ ce(Nl.Provider, { value: R, children: /* @__PURE__ */ ce(D, {}) })
          }
        )
      }
    )
  ] });
}
function Dl(D, C = 1e3) {
  return function() {
    const le = Cr(), [be, qe] = ur(null), _e = xn(() => qe(null), []);
    return Ir(() => {
      if (!le)
        return () => {
        };
      const fe = new AbortController();
      let R;
      return requestAnimationFrame(() => {
        le.addEventListener(
          "keyboardAction",
          (J) => {
            clearTimeout(R);
            const E = J.detail;
            qe(/* @__PURE__ */ ce(D, { action: E })), R = setTimeout(_e, C);
          },
          { signal: fe.signal }
        );
      }), () => {
        clearTimeout(R), fe.abort();
      };
    }, [C]), be;
  };
}
const bg = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.309 3.99987L0 12.1331L13.309 20.2663V13.7367L23.9987 20.2596V4.00655L13.309 10.5281V3.99987Z", fill: "currentColor" }) }), Sg = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.691 3.99987V10.5281L0 4.00655V20.2596L10.691 13.7367V20.2663L23.9987 12.1331L10.691 3.99987Z", fill: "currentColor" }) }), Ml = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1179 1.41211V22.589H11.2943L5.64717 16.9418V7.05928L11.2943 1.41211H14.1179ZM4.23537 7.05928V16.9418H2.11769C0.957618 16.9418 0.0189406 16.0147 0.00028305 14.8592L0 14.8241V9.17696C0 8.01689 0.927077 7.07822 2.0826 7.05956L2.11769 7.05928H4.23537ZM22.3744 7.93711L24 9.56119L21.5623 11.9988L24 14.4365L22.3744 16.0621L19.9383 13.6245L17.5006 16.0621L15.875 14.4365L18.3127 11.9988L15.875 9.56119L17.5006 7.93711L19.9383 10.3748L22.3744 7.93711Z", fill: "currentColor" }) }), Do = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M 11,21 H 5 V 3 h 6 z m 8,0 H 13 V 3 h 6 z", fill: "currentColor" }) }), Mo = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M 5,2 V 22 L 21,12.000665 Z", fill: "currentColor" }) }), Ol = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.64714 16.8627V6.98017L11.2943 1.33301H14.1179V22.5099H11.2943L5.64714 16.8627ZM0 14.745V9.09785C0 7.92607 0.945899 6.98017 2.11768 6.98017H4.23537V16.8627H2.11768C0.945899 16.8627 0 15.9168 0 14.745ZM16.9056 8.4209C17.8388 9.36962 18.3527 10.6134 18.3527 11.9207C18.3527 13.2295 17.8388 14.4732 16.9056 15.422L17.9094 16.4116C19.1066 15.1989 19.7645 13.6036 19.7645 11.9207C19.7645 10.2393 19.1066 8.64396 17.9094 7.43123L16.9056 8.4209ZM19.9016 5.43185L20.8997 4.43372C22.9002 6.43422 24 9.09403 24 11.9219C24 14.7497 22.9002 17.4081 20.8997 19.4086L19.9016 18.4104C21.6353 16.6782 22.5882 14.3727 22.5882 11.9219C22.5882 9.46957 21.6353 7.16553 19.9016 5.43185Z", fill: "currentColor" }) }), Ll = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.64714 6.98017V16.8627L11.2943 22.5099H14.1179V1.33301H11.2943L5.64714 6.98017ZM0 9.09785V14.745C0 15.9168 0.945899 16.8627 2.11768 16.8627H4.23537V6.98017H2.11768C0.945899 6.98017 0 7.92607 0 9.09785ZM18.3527 11.9207C18.3527 10.6134 17.8388 9.36962 16.9056 8.4209L17.9094 7.43123C19.1066 8.64396 19.7645 10.2393 19.7645 11.9207C19.7645 13.6036 19.1066 15.1989 17.9094 16.4116L16.9056 15.422C17.8388 14.4732 18.3527 13.2295 18.3527 11.9207Z", fill: "currentColor" }) }), Ag = "_feedback-overlay_14jdq_1", Ig = "_feedback-message_14jdq_14", Cg = "_feedback-icon_14jdq_30", wg = "_feedback-icon-animation_14jdq_1", Sr = {
  "feedback-overlay": "_feedback-overlay_14jdq_1",
  feedbackOverlay: Ag,
  "feedback-message": "_feedback-message_14jdq_14",
  feedbackMessage: Ig,
  "feedback-icon": "_feedback-icon_14jdq_30",
  feedbackIcon: Cg,
  "feedback-icon-animation": "_feedback-icon-animation_14jdq_1",
  feedbackIconAnimation: wg
};
function Rg({ action: D }) {
  const C = Cr();
  if (!C)
    return null;
  switch (D) {
    case "togglePaused":
      return /* @__PURE__ */ ce("i", { className: Sr.feedbackIcon, children: C.paused ? /* @__PURE__ */ ce(Do, {}) : /* @__PURE__ */ ce(Mo, {}) });
    case "seekForward":
    case "seekForward10":
      return /* @__PURE__ */ ce("i", { className: Sr.feedbackIcon, children: /* @__PURE__ */ ce(Sg, { className: "right" }) });
    case "seekBackward":
    case "seekBackward10":
      return /* @__PURE__ */ ce("i", { className: Sr.feedbackIcon, children: /* @__PURE__ */ ce(bg, { className: "left" }) });
    case "captionsChange":
      return /* @__PURE__ */ ce("i", { className: Sr.feedbackIcon, children: /* @__PURE__ */ ce(Tl, {}) });
    case "volumeChange":
      return /* @__PURE__ */ ce("i", { className: Sr.feedbackIcon, children: C.muted || C.volume === 0 ? /* @__PURE__ */ ce(Ml, {}) : C.volume >= 0.5 ? /* @__PURE__ */ ce(Ol, {}) : /* @__PURE__ */ ce(Ll, {}) });
    default:
      return null;
  }
}
function Ng({ action: D }) {
  const { t: C } = An(), B = Cr();
  if (!B)
    return null;
  switch (D) {
    case "captionsChange":
      return /* @__PURE__ */ ce("div", { className: Sr.feedbackMessage, children: B.textTracks.selected ? C("CAPTION_LANGUAGE", {
        language: B.textTracks.selected.label
      }) : `${C("CAPTIONS")}: ${C("OFF")}` });
    case "volumeChange":
      return /* @__PURE__ */ ce("div", { className: Sr.feedbackMessage, children: B.muted || B.volume === 0 ? C("MUTED") : C("VOLUME_VALUE", { volume: (B.volume * 100).toFixed(0) }) });
    case "playbackRateChange":
      return /* @__PURE__ */ ce("div", { className: Sr.feedbackMessage, children: C("PLAYBACK_SPEED_MESSAGE", { speed: B.playbackRate }) });
    case "seekForward":
      return /* @__PURE__ */ ce("div", { className: Sr.feedbackMessage, children: C("SEEK_FORWARD", { seconds: 5 }) });
    case "seekForward10":
      return /* @__PURE__ */ ce("div", { className: Sr.feedbackMessage, children: C("SEEK_FORWARD", { seconds: 10 }) });
    case "seekBackward":
      return /* @__PURE__ */ ce("div", { className: Sr.feedbackMessage, children: C("SEEK_BACKWARD", { seconds: 5 }) });
    case "seekBackward10":
      return /* @__PURE__ */ ce("div", { className: Sr.feedbackMessage, children: C("SEEK_BACKWARD", { seconds: 10 }) });
    default:
      return null;
  }
}
const Dg = Dl(Rg, 300), Mg = Dl(Ng, 1e3);
function Pl() {
  return /* @__PURE__ */ tn("div", { className: Sr.feedbackOverlay, children: [
    /* @__PURE__ */ ce(Dg, {}),
    /* @__PURE__ */ ce(Mg, {})
  ] });
}
const Og = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.1383 0.999867V3.66268H18.4561L3.66281 18.4546V14.1382H1V23H9.86449V20.3372H5.54542L20.3387 5.54528V9.86303H23.0001V0.999867H14.1383Z", fill: "currentColor" }) }), Lg = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.562 6.58944L22.1514 0L24.0005 1.84907L17.4111 8.43851H21.6506V11.0552H12.9453V2.34861H15.562V6.58944ZM2.34861 15.5615V12.9461H11.0539V21.6501H8.43982V17.4106L1.84907 24L0 22.1509L6.59075 15.5615H2.34861Z", fill: "currentColor" }) }), Pg = "_full-screen-button_1xm32_2", xg = {
  "full-screen-button": "_full-screen-button_1xm32_2",
  fullScreenButton: Pg
};
function Fg() {
  const D = jn("fullscreen"), C = Cr(), B = zn(), { t: le } = An();
  return B.hideFullScreen ? null : /* @__PURE__ */ ce(
    "button",
    {
      type: "button",
      "aria-label": le("FULLSCREEN"),
      "aria-pressed": D ? "true" : "false",
      className: `controls-button ${xg.fullScreenButton}`,
      onClick: async () => {
        try {
          D ? await (C == null ? void 0 : C.exitFullscreen()) : await (C == null ? void 0 : C.enterFullscreen());
        } catch {
        }
      },
      children: D ? /* @__PURE__ */ ce(Lg, { className: "controls-button-icon" }) : /* @__PURE__ */ ce(Og, { className: "controls-button-icon" })
    }
  );
}
const kg = "_gestures-container_1fn3b_1", Zg = "_gesture_1fn3b_1", il = {
  "gestures-container": "_gestures-container_1fn3b_1",
  gesturesContainer: kg,
  gesture: Zg
};
function xl() {
  const D = Sa(), C = () => {
    D.togglePaused();
  };
  return /* @__PURE__ */ ce("div", { className: il.gesturesContainer, children: /* @__PURE__ */ ce("div", { "aria-hidden": !0, className: il.gesture, onClick: C }) });
}
const Bg = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0V2.66667C17.1453 2.66667 21.3333 6.85333 21.3333 12C21.3333 17.1467 17.1453 21.3333 12 21.3333C6.85467 21.3333 2.66667 17.1467 2.66667 12C2.66667 9.53733 3.64667 7.21867 5.33333 5.49067V8.66667H8V1.33333H0.666667V4H3.05467C1.108 6.176 0 9.012 0 12C0 18.616 5.38267 24 12 24C18.6173 24 24 18.616 24 12C24 5.384 18.6173 0 12 0Z", fill: "currentColor" }) }), Ug = "_play-pause-button_vj8da_1", Gg = {
  "play-pause-button": "_play-pause-button_vj8da_1",
  playPauseButton: Ug
};
function Hg(D, C) {
  return C ? Bg : D ? Mo : Do;
}
function qg(D, C) {
  return C ? "REPLAY" : D ? "PLAY" : "PAUSE";
}
function Vg() {
  const D = Cr(), C = jn("paused"), B = jn("ended"), { t: le } = An(), be = lr(null), qe = Hg(C, B);
  return D ? /* @__PURE__ */ ce(
    "button",
    {
      ref: be,
      type: "button",
      "data-play-pause-button": "",
      className: `controls-button ${Gg.playPauseButton}`,
      "aria-label": le(qg(C, B)),
      onClick: () => {
        D.paused ? D.remoteControl.play() : D.remoteControl.pause();
      },
      children: /* @__PURE__ */ ce(qe, { className: "controls-button-icon" })
    }
  ) : null;
}
function Fl({ src: D }) {
  const C = Cr(), B = jn("started"), le = !!D && !B;
  return Ir(() => {
    const be = C == null ? void 0 : C.provider;
    if (be && (be.type === "video" || be.type === "dash")) {
      const qe = be.media;
      qe.style.visibility && qe.style.removeProperty("visibility"), qe.style.length === 0 && qe.removeAttribute("style");
    }
  }, [C]), le ? /* @__PURE__ */ ce("img", { "data-poster": "", alt: "", src: D, loading: "eager", decoding: "async" }) : null;
}
function jg(D, C) {
  return D.reduce((B, le) => (Object.keys(C).includes(le.id) || (B[le.id] = !0), B), C);
}
function Yg(D, C, B, le, be) {
  return (qe) => {
    const _e = qe.detail.currentTime, fe = !B.paused, R = Math.min(B.duration * 0.05, 2);
    _e >= D.time && _e < D.time + R && !le[D.id] && (be({ ...le, [D.id]: !0 }), C(D, fe));
  };
}
function Kg() {
  const D = Cr(), { quizMarkers: C, onQuizMarkerShow: B } = zn(), [le, be] = ur(
    C.reduce((qe, _e) => (qe[_e.id] = !1, qe), {})
  );
  Ir(() => {
    if (!D)
      return;
    C.length > Object.keys(le).length && be(jg(C, le));
    const qe = new AbortController(), _e = (fe) => {
      var E;
      const R = (E = fe == null ? void 0 : fe.request) == null ? void 0 : E.detail, J = C.reduce((t, e) => (t[e.id] = e.time <= R, t), {});
      be({ ...le, ...J });
    };
    return requestAnimationFrame(() => {
      D.addEventListener("seeked", _e, {
        signal: qe.signal
      });
      for (const fe of C) {
        const R = Yg(
          fe,
          B,
          D,
          le,
          be
        );
        D.addEventListener("time-update", R, {
          signal: qe.signal
        });
      }
    }), () => {
      qe.abort();
    };
  }, [C, D, le]);
}
function zg() {
  return Kg(), null;
}
function kl(D) {
  const C = Ta(null), B = () => {
    const le = ba(C);
    if (le === null)
      throw new Error(D);
    return le;
  };
  return [C.Provider, B];
}
function Wg(D) {
  return Array.isArray(D) && typeof D[0] == "object";
}
function Zl(D) {
  return Wg(D) && D.length === 1 ? D[0].src : D;
}
function vo(D) {
  return typeof D == "number" && !Number.isNaN(D);
}
function Bl(D, C = 1e3) {
  let B = !1;
  return () => {
    B || (D(), B = !0, setTimeout(() => {
      B = !1;
    }, C));
  };
}
function Ul(D, C) {
  let B = null;
  const le = (...be) => {
    B && clearTimeout(B), B = setTimeout(() => D(...be), C);
  };
  return le.cancel = () => {
    B && (clearTimeout(B), B = null);
  }, le;
}
class Qg {
  constructor(C) {
    nn(this, "onSearchResults", (C) => {
      C === 0 ? this.message.set(["A11Y_SEARCH_NO_RESULTS", {}]) : this.message.set(["A11Y_SEARCH_RESULTS_FOUND", { count: C }]);
    });
    nn(this, "onHasEditChanges", (C, B) => {
      C && B === "idle" && this.message.set(["A11Y_UPDATE_CAPTIONS_AVAILABLE", {}]);
    });
    nn(this, "onSavingStateChange", (C) => {
      C === "saving" ? this.message.set(["A11Y_TRANSCRIPT_SAVING", {}]) : C === "success" ? this.message.set(["A11Y_TRANSCRIPT_SUCCESS", {}]) : C === "error" && this.message.set(["A11Y_TRANSCRIPT_ERROR", {}]);
    });
    this.message = C;
  }
  onCueClick(C) {
    const B = Math.floor(C / 3600), le = Math.floor(C % 3600 / 60), be = Math.round(C % 60);
    C >= 3600 ? this.message.set([
      "A11Y_TIMESTAMP_JUMP_HOURS",
      { hours: B, minutes: le, seconds: be }
    ]) : C >= 60 ? this.message.set(["A11Y_TIMESTAMP_JUMP_MINUTES", { minutes: le, seconds: be }]) : this.message.set(["A11Y_TIMESTAMP_JUMP_SECONDS", { seconds: be }]);
  }
}
function Xg({
  allowEditing: D,
  editLabel: C,
  onEdit: B,
  elements: le
}) {
  const be = [];
  return D && be.push({
    id: "edit-transcript",
    icon: "edit",
    text: C,
    onClick: B,
    order: 1
  }), be.concat(le).sort((qe, _e) => (qe.order ?? 1) - (_e.order ?? 1));
}
function Oo(D, C) {
  let B = -1, le = 0, be = C.length - 1;
  for (; le <= be; ) {
    const qe = Math.floor((le + be) / 2), _e = C[qe];
    if (_e.startTime < D)
      B = qe, le = qe + 1;
    else if (_e.startTime > D)
      be = qe - 1;
    else {
      B = qe;
      break;
    }
  }
  return B;
}
function To(D, C, B = !1) {
  const le = D.getBoundingClientRect(), be = C.getBoundingClientRect(), qe = be.top - le.top, fe = { top: D.scrollTop + qe - le.height / 2 + be.height / 2 };
  B && (fe.behavior = "instant"), D.scrollTo(fe);
}
function $g(D) {
  return !D || D.length === 0 ? "" : D.map((C, B) => {
    const le = al(C.startTime), be = al(C.endTime), qe = C.text;
    return `${B + 1}
${le} --> ${be}
${qe}`;
  }).join(`

`);
}
function pa(D, C) {
  return D.toString().padStart(C, "0");
}
function al(D) {
  const C = Math.floor(D / 3600), B = Math.floor(D % 3600 / 60), le = Math.floor(D % 60), be = Math.floor(D % 1 * 1e3);
  return `${pa(C, 2)}:${pa(B, 2)}:${pa(le, 2)},${pa(be, 3)}`;
}
class Jg {
  constructor(C, B) {
    nn(this, "saveCallback");
    nn(this, "confirmCallback");
    nn(this, "onTrackEvent");
    nn(this, "currentSaveAbortController", null);
    nn(this, "lastSuccessfulCues", null);
    nn(this, "debouncedSave");
    nn(this, "savingStateTimeout", null);
    nn(this, "validationErrorTimeout", null);
    nn(this, "exitRequested", !1);
    nn(this, "DEBOUNCE_DELAY", 1e3);
    nn(this, "STATUS_MESSAGE_DELAY", 3e3);
    nn(this, "startEditing", (C) => {
      this.saveCallback && (this.state.autoScroll.set(!1), this.state.editingCueIndex.set(C), this.exitRequested = !1, this.debouncedSave.cancel());
    });
    nn(this, "cancelEditing", (C) => {
      !C || this.state.editingCueIndex.get() === -1 || (C.innerText = this.state.cues.get()[this.state.editingCueIndex.get()].text);
    });
    nn(this, "stopEditing", (C, B) => {
      var fe;
      if (!this.saveCallback) return;
      this.state.editingCueIndex.set(-1);
      const le = this.state.cues.get(), be = le[C];
      if (!be || be.text === B)
        return;
      if (B.trim() === "") {
        this.setValidationError(C);
        return;
      }
      this.state.validationError.get() === C && this.state.validationError.set(null), this.lastSuccessfulCues === null && (this.lastSuccessfulCues = [...this.state.cues.get()]);
      const qe = B.replace(/\n+/g, `
`), _e = new VTTCue(be.startTime, be.endTime, qe);
      this.state.cues.set([
        ...le.slice(0, C),
        _e,
        ...le.slice(C + 1)
      ]), (fe = this.onTrackEvent) == null || fe.call(this, {
        type: "studio_transcript_editing",
        action: "segment_edited"
      }), this.debouncedSave();
    });
    nn(this, "exitEditMode", () => {
      var B;
      this.exitRequested = !0, this.clearSavingStateTimeout(), this.state.editingCueIndex.set(-1), this.state.editMode.set(!1), this.state.hasEditChanges.get() && ((B = this.confirmCallback) == null || B.call(this)), this.state.hasEditChanges.set(!1), this.state.savingState.set("idle");
    });
    nn(this, "cleanup", () => {
      this.exitEditMode(), this.debouncedSave.cancel(), this.abortOngoingSave(), this.clearValidationErrorTimeout(), this.clearSavingStateTimeout();
    });
    nn(this, "executeSave", async () => {
      var le, be, qe;
      if (!this.saveCallback) return;
      this.abortOngoingSave();
      const C = new AbortController();
      this.currentSaveAbortController = C, this.clearSavingStateTimeout();
      const B = this.state.cues.get();
      this.state.savingState.set("saving");
      try {
        const _e = new FormData(), fe = $g(B);
        if (_e.append("locale", this.state.language.get()), _e.append("src", this.state.src.get()), _e.append("content", fe), await this.saveCallback(_e), C.signal.aborted)
          return;
        this.lastSuccessfulCues = [...B], this.state.hasEditChanges.set(!0), this.state.savingState.set("success"), (le = this.onTrackEvent) == null || le.call(this, {
          type: "studio_transcript_editing",
          action: "autosave_succeeded"
        }), this.exitRequested && ((be = this.confirmCallback) == null || be.call(this), this.state.savingState.set("idle"));
      } catch {
        if (C.signal.aborted)
          return;
        this.lastSuccessfulCues && this.state.cues.set([...this.lastSuccessfulCues]), this.state.savingState.set("error"), (qe = this.onTrackEvent) == null || qe.call(this, {
          type: "studio_transcript_editing",
          action: "autosave_failed"
        });
      } finally {
        this.currentSaveAbortController === C && (this.currentSaveAbortController === C && this.abortOngoingSave(), this.clearSavingStateTimeout(), this.state.editMode.get() && (this.savingStateTimeout = setTimeout(() => {
          this.state.savingState.set("idle");
        }, this.STATUS_MESSAGE_DELAY)));
      }
    });
    nn(this, "abortOngoingSave", () => {
      this.currentSaveAbortController && (this.currentSaveAbortController.abort(), this.currentSaveAbortController = null);
    });
    nn(this, "clearSavingStateTimeout", () => {
      this.savingStateTimeout && (clearTimeout(this.savingStateTimeout), this.savingStateTimeout = null);
    });
    nn(this, "clearValidationErrorTimeout", () => {
      this.validationErrorTimeout && (clearTimeout(this.validationErrorTimeout), this.validationErrorTimeout = null);
    });
    nn(this, "setValidationError", (C) => {
      this.state.validationError.set(C), this.clearValidationErrorTimeout(), this.validationErrorTimeout = setTimeout(() => {
        this.state.validationError.get() === C && this.state.validationError.set(null);
      }, this.STATUS_MESSAGE_DELAY);
    });
    this.state = C, this.saveCallback = B.onTranscriptEdit, this.confirmCallback = B.onConfirmEditChanges, this.onTrackEvent = B.onTrackEvent, this.debouncedSave = Ul(this.executeSave, this.DEBOUNCE_DELAY);
  }
}
class eh {
  constructor(C, B, le) {
    nn(this, "listElement", null);
    nn(this, "initialize", (C) => {
      this.listElement = C;
      const B = new AbortController();
      return B.signal.addEventListener(
        "abort",
        this.state.editMode.subscribe(this.onEditModeChange)
      ), () => B.abort();
    });
    nn(this, "handleKeyboard", (C) => {
      var B, le, be, qe;
      if (this.listElement) {
        if (C.key === "ArrowUp") {
          C.preventDefault(), this.state.autoScroll.get() && this.state.autoScroll.set(!1);
          const _e = this.state.editingCueIndex.get();
          _e > -1 ? (le = Il(
            this.listElement,
            (B = this.listElement.children[_e]) == null ? void 0 : B.firstElementChild
          )) == null || le.focus() : wl(this.listElement, this.getStartElement());
        }
        if (C.key === "ArrowDown") {
          C.preventDefault(), this.state.autoScroll.get() && this.state.autoScroll.set(!1);
          const _e = this.state.editingCueIndex.get();
          _e > -1 ? (qe = Cl(
            this.listElement,
            (be = this.listElement.children[_e]) == null ? void 0 : be.firstElementChild
          )) == null || qe.focus() : Rl(this.listElement, this.getStartElement());
        }
      }
    });
    nn(this, "onFocus", () => {
      this.playerContext.globalKeysDisabled.set(!0);
    });
    nn(this, "onBlur", () => {
      this.playerContext.globalKeysDisabled.set(!1);
    });
    nn(this, "getStartElement", () => {
      var le;
      if (!this.listElement) return null;
      const C = CSS.highlights.get("search-results-current");
      return (C ? (le = Array.from(C)[0].startContainer.parentElement) == null ? void 0 : le.parentElement : this.findButtonToClosestTimeStamp()) ?? this.listElement.querySelector('[aria-current="true"]');
    });
    nn(this, "findButtonToClosestTimeStamp", () => {
      if (!this.listElement) return null;
      const C = Oo(
        this.player.currentTime,
        this.state.cues.get()
      );
      return C === -1 ? null : this.listElement.children[C].firstElementChild;
    });
    nn(this, "onEditModeChange", (C) => {
      if (!this.listElement || !C) return;
      const B = this.listElement.closest('[role="tabpanel"]');
      B == null || B.focus();
    });
    this.state = C, this.player = B, this.playerContext = le;
  }
}
class th {
  constructor(C, B, le, be) {
    nn(this, "currentTrack", null);
    nn(this, "cueChangeAbortController", null);
    nn(this, "retry", () => {
      this.state.status.set("loading"), this.currentTrack = null;
      const C = [...this.player.$state.textTracks()];
      for (const B of C)
        this.player.textTracks.remove(B);
      for (const B of this.props.captions)
        this.player.textTracks.add({
          src: B.src,
          label: B.label,
          language: B.language,
          kind: "subtitles",
          type: B.type
        });
    });
    nn(this, "cleanup", () => {
      var C;
      (C = this.cueChangeAbortController) == null || C.abort();
    });
    nn(this, "onTrackChange", (C) => {
      var B;
      if (C) {
        if (this.currentTrack === C) {
          C.cues.length > 0 && this.state.cues.get().length === 0 && this.finalizeTrack(C);
          return;
        }
        if (this.state.language.set(C.language), this.state.src.set(C.src ?? ""), this.currentTrack = C, (B = this.cueChangeAbortController) == null || B.abort(), this.cueChangeAbortController = new AbortController(), C.cues.length === 0) {
          C.addEventListener(
            "load",
            () => {
              this.finalizeTrack(C);
            },
            { once: !0, signal: this.cueChangeAbortController.signal }
          );
          return;
        }
        this.finalizeTrack(C);
      }
    });
    nn(this, "finalizeTrack", (C) => {
      this.state.status.set("ready"), this.state.cues.set(C.cues), this.setClosestCueToCurrentTimestamp(), C.addEventListener(
        "cue-change",
        ({ target: B }) => {
          this.state.activeCueIndex.set(
            B.cues.indexOf(B.activeCues[0])
          );
        },
        {
          signal: this.cueChangeAbortController.signal
        }
      );
    });
    nn(this, "setClosestCueToCurrentTimestamp", () => {
      const C = this.state.cues.get(), B = this.player.currentTime, le = Oo(B, C);
      le > -1 && C[le].endTime > B && this.state.activeCueIndex.set(le);
    });
    this.state = C, this.player = B, this.playerContext = le, this.props = be, Jc(() => {
      const qe = this.player.$state.textTrack(), _e = this.player.$state.textTracks();
      if (qe)
        return this.onTrackChange(qe);
      if (this.currentTrack) {
        if (_e.some(
          (R) => {
            var J;
            return R.src === ((J = this.currentTrack) == null ? void 0 : J.src);
          }
        ))
          return this.onTrackChange(this.currentTrack);
        this.currentTrack = null;
      }
      if (_e.length > 0 && _e[0]) {
        const fe = this.props.disableStorage ? _e[0] : _e.find(
          (R) => R.language === this.playerContext.storage.data.lang
        ) || _e[0];
        if (fe.cues.length === 0) {
          if (fe.readyState === 3) {
            this.state.status.set("error");
            return;
          }
          if (fe.readyState === 2) {
            this.state.status.set("empty");
            return;
          }
          fe.addEventListener(
            "load",
            (R) => {
              this.onTrackChange(R.target);
            },
            { once: !0 }
          ), fe.addEventListener(
            "error",
            () => {
              this.state.status.set("error");
            },
            { once: !0 }
          );
          return;
        }
        return this.onTrackChange(fe);
      } else this.props.captions.length === 0 && this.state.status.set("empty");
    });
  }
}
class nh {
  constructor(C, B) {
    nn(this, "listElement", null);
    nn(this, "initialize", (C) => {
      this.listElement = C;
      const B = new AbortController(), le = Bl(() => {
        this.state.autoScroll.get() && this.state.autoScroll.set(!1);
      });
      for (const be of ["touchmove", "wheel"])
        this.listElement.addEventListener(be, le, {
          signal: B.signal,
          passive: !0
        });
      return B.signal.addEventListener(
        "abort",
        this.state.activeCueIndex.subscribe(this.onCueChange)
      ), B.signal.addEventListener(
        "abort",
        this.state.autoScroll.subscribe(this.onAutoScrollChange)
      ), () => B.abort();
    });
    nn(this, "enableAutoScroll", () => {
      this.state.autoScroll.set(!0);
    });
    // scroll to last active cue if auto-scroll is re-enabled
    nn(this, "onAutoScrollChange", (C) => {
      if (!C || !this.listElement || !this.listElement.children.length)
        return;
      let B = Oo(
        this.player.currentTime,
        this.state.cues.get()
      );
      B === -1 && (B = 0);
      const le = this.listElement.children[B];
      le && (this.listElement.addEventListener(
        "scrollend",
        () => {
          var be;
          return (be = this.listElement) == null ? void 0 : be.focus({ preventScroll: !0 });
        },
        { once: !0 }
      ), To(this.listElement, le));
    });
    // scroll active cue into view if auto-scroll is enabled
    nn(this, "onCueChange", (C) => {
      this.state.autoScroll.get() && C > -1 && (this.listElement && this.listElement.children.length > 0 ? this.scrollToActiveCue(C) : setTimeout(() => {
        this.scrollToActiveCue(C, !0);
      }, 0));
    });
    nn(this, "scrollToActiveCue", (C, B) => {
      if (!this.listElement) return;
      const le = this.listElement.children[C];
      le && To(this.listElement, le, B);
    });
    this.state = C, this.player = B;
  }
}
class rh {
  constructor(C, B, le) {
    nn(this, "listElement", null);
    nn(this, "initialize", (C) => {
      this.listElement = C;
      const B = new AbortController();
      return this.player.addEventListener("text-track-change", this.clearSearch, {
        signal: B.signal
      }), B.signal.addEventListener(
        "abort",
        this.state.searchTerm.subscribe(this.onSearchTermChange)
      ), () => B.abort();
    });
    nn(this, "onSearch", (C) => {
      this.state.searchTerm.set(C.target.value);
    });
    nn(this, "clearSearch", () => {
      this.state.searchTerm.set(""), this.state.currentHit.set(-1), this.state.numHits.set(0), this.state.autoScroll.set(!0);
    });
    nn(this, "nextHit", () => {
      const C = this.state.numHits.get();
      if (C === 0) return;
      this.state.autoScroll.set(!1);
      let B = this.state.currentHit.get() + 1;
      B >= C && (B = 0), this.state.currentHit.set(B), this.highlightAndScrollToActiveHit();
    });
    nn(this, "previousHit", () => {
      const C = this.state.numHits.get();
      if (C === 0) return;
      this.state.autoScroll.set(!1);
      let B = this.state.currentHit.get() - 1;
      B < 0 && (B = C - 1), this.state.currentHit.set(B), this.highlightAndScrollToActiveHit();
    });
    nn(this, "highlightAndScrollToActiveHit", () => {
      const C = CSS.highlights.get("search-results");
      if (!C || !this.listElement) return;
      const B = Array.from(C), le = this.state.currentHit.get();
      if (B.forEach((be) => {
        const qe = be.startContainer.parentElement;
        qe && qe.removeAttribute("data-current-search-hit");
      }), le > -1 && le < C.size) {
        const be = B[le], qe = new Highlight(be);
        if (CSS.highlights.set("search-results-current", qe), !be.startContainer.parentElement) return;
        be.startContainer.parentElement.setAttribute(
          "data-current-search-hit",
          ""
        ), To(
          this.listElement,
          be.startContainer.parentElement,
          !0
        );
      }
    });
    nn(this, "onSearchTermChange", (C) => {
      if (CSS.highlights.clear(), this.playerContext.lastSearchTerm = C, C)
        this.listElement && this.listElement.children.length > 0 ? this.highlight(C) : setTimeout(() => {
          this.highlight(C);
        }, 10);
      else return;
    });
    nn(this, "highlight", (C) => {
      if (!this.listElement)
        return;
      const B = this.listElement.querySelectorAll("p"), le = C.toLowerCase(), be = [];
      B.forEach((_e) => {
        var e;
        const fe = (e = _e.textContent) == null ? void 0 : e.toLowerCase();
        if (!fe || !fe.includes(le)) return;
        let R = 0;
        const J = [];
        for (; R < fe.length; ) {
          const h = fe.indexOf(le, R);
          if (h === -1) break;
          J.push(h), R = h + le.length;
        }
        const E = [];
        let t = 0;
        _e.childNodes.forEach((h) => {
          h.nodeType === Node.TEXT_NODE && (E.push({ node: h, start: t }), t += h.length);
        });
        for (const h of J) {
          const p = E.find(
            ({ node: v, start: m }) => h >= m && h + le.length <= m + v.length
          );
          if (!p) continue;
          const o = new Range();
          o.setStart(p.node, h - p.start), o.setEnd(
            p.node,
            h - p.start + le.length
          ), be.push(o);
        }
      });
      const qe = new Highlight(...be);
      CSS.highlights.set("search-results", qe), this.state.numHits.set(qe.size), this.state.currentHit.set(-1), this.nextHit();
    });
    this.state = C, this.player = B, this.playerContext = le;
  }
}
class ih {
  constructor(C, B, le) {
    nn(this, "state");
    nn(this, "player");
    nn(this, "abortController", null);
    nn(this, "props");
    nn(this, "debouncedTrackSearch");
    nn(this, "loadingManager");
    nn(this, "keyboardManager");
    nn(this, "searchManager");
    nn(this, "scrollManager");
    nn(this, "announcer");
    nn(this, "editingManager");
    nn(this, "initialize", (C) => {
      var le;
      if (!C)
        return;
      this.abortController = new AbortController();
      const B = [];
      B.push(this.keyboardManager.initialize(C)), B.push(this.searchManager.initialize(C)), B.push(this.scrollManager.initialize(C)), B.push(this.state.numHits.subscribe(this.announcer.onSearchResults)), B.push(
        this.state.savingState.subscribe(this.announcer.onSavingStateChange)
      ), B.push(
        mf(
          [this.state.hasEditChanges, this.state.savingState],
          this.announcer.onHasEditChanges
        )
      );
      for (const be of B)
        (le = this.abortController) == null || le.signal.addEventListener("abort", be);
    });
    nn(this, "cleanup", () => {
      var C;
      (C = this.abortController) == null || C.abort(), this.debouncedTrackSearch.cancel(), this.loadingManager.cleanup(), this.editingManager.cleanup();
    });
    nn(this, "onCueClick", (C, B) => {
      var le, be;
      this.state.editMode.get() && this.state.editingCueIndex.get() === -1 ? this.editingManager.startEditing(B) : this.state.editMode.get() || (this.player.remoteControl.seek(C + 0.01), this.announcer.onCueClick(C), (be = (le = this.props).onTrackEvent) == null || be.call(le, {
        type: "transcript_timestamp_click",
        timestamp: C
      }));
    });
    nn(this, "onCueBlur", (C, B) => {
      this.editingManager.stopEditing(C, B);
    });
    nn(this, "enableAutoScroll", () => {
      var C, B;
      this.scrollManager.enableAutoScroll(), (B = (C = this.props).onTrackEvent) == null || B.call(C, {
        type: "transcript_auto_follow_toggle",
        enabled: !0
      });
    });
    nn(this, "onSearch", (C) => {
      this.searchManager.onSearch(C), this.debouncedTrackSearch();
    });
    nn(this, "clearSearch", () => {
      this.debouncedTrackSearch.cancel(), this.searchManager.clearSearch();
    });
    nn(this, "nextHit", () => {
      this.searchManager.nextHit();
    });
    nn(this, "previousHit", () => {
      this.searchManager.previousHit();
    });
    nn(this, "handleKeyboard", (C) => {
      this.keyboardManager.handleKeyboard(C);
    });
    nn(this, "onFocus", () => {
      this.keyboardManager.onFocus();
    });
    nn(this, "onBlur", () => {
      this.keyboardManager.onBlur();
    });
    nn(this, "enterEditMode", () => {
      var C, B;
      this.state.editMode.set(!0), (B = (C = this.props).onTrackEvent) == null || B.call(C, {
        type: "studio_transcript_editing",
        action: "enter_edit_mode"
      });
    });
    nn(this, "exitEditMode", () => {
      this.editingManager.exitEditMode();
    });
    nn(this, "cancelEditing", (C) => {
      this.editingManager.cancelEditing(C);
    });
    nn(this, "retryTranscriptLoad", () => {
      this.loadingManager.retry();
    });
    this.player = C, this.props = le, this.debouncedTrackSearch = Ul(() => {
      var qe, _e;
      const be = this.state.searchTerm.get();
      be && ((_e = (qe = this.props).onTrackEvent) == null || _e.call(qe, { type: "transcript_search", searchTerm: be }));
    }, 500), this.state = {
      language: Wn(""),
      src: Wn(""),
      cues: Wn([]),
      activeCueIndex: Wn(-1),
      editingCueIndex: Wn(-1),
      autoScroll: Wn(!0),
      searchTerm: Wn(B.lastSearchTerm),
      numHits: Wn(0),
      currentHit: Wn(-1),
      status: Wn("loading"),
      editMode: Wn(!1),
      hasEditChanges: Wn(!1),
      outputMessage: Wn(["", {}]),
      savingState: Wn("idle"),
      validationError: Wn(null)
    }, this.loadingManager = new th(
      this.state,
      this.player,
      B,
      le
    ), this.keyboardManager = new eh(
      this.state,
      this.player,
      B
    ), this.searchManager = new rh(
      this.state,
      this.player,
      B
    ), this.scrollManager = new nh(
      this.state,
      this.player
    ), this.editingManager = new Jg(
      this.state,
      le
    ), this.announcer = new Qg(this.state.outputMessage);
  }
}
function ah() {
  const D = Cr(), C = wr(), B = zn(), le = ir(
    // biome-ignore lint/style/noNonNullAssertion: player cannot be null here
    () => new ih(D, C, B),
    [D, C]
  );
  return Ir(() => () => le.cleanup(), [le]), le;
}
const [oh, Ii] = kl(
  "useRollingTranscriptContext must be used within a RollingTranscriptContextProvider"
), Ar = (D) => {
  const C = Ii();
  return va(C.state[D]);
}, sh = "_rolling-transcript_xt89c_1", lh = "_header_xt89c_8", uh = "_edit-mode-bar_xt89c_16", ch = "_edit-mode-bar-buttons_xt89c_35", fh = "_close-button_xt89c_41", dh = "_confirm-button_xt89c_65", gh = "_saving-indicator_xt89c_66", hh = "_success-indicator_xt89c_67", mh = "_error-indicator_xt89c_68", ph = "_transcript-search_xt89c_107", yh = "_search-wrapper_xt89c_150", _h = "_transcript-search-clear-button_xt89c_155", Eh = "_transcript-search-widget_xt89c_182", vh = "_transcript-search-widget-button_xt89c_195", Th = "_transcript-list_xt89c_230", bh = "_transcript-line-wrapper_xt89c_263", Sh = "_transcript-line_xt89c_263", Ah = "_text_xt89c_287", Ih = "_editable-text_xt89c_288", Ch = "_validation-error_xt89c_322", wh = "_auto-scroll-button_xt89c_355", Rh = "_output_xt89c_397", Jn = {
  "rolling-transcript": "_rolling-transcript_xt89c_1",
  rollingTranscript: sh,
  header: lh,
  "edit-mode-bar": "_edit-mode-bar_xt89c_16",
  editModeBar: uh,
  "edit-mode-bar-buttons": "_edit-mode-bar-buttons_xt89c_35",
  editModeBarButtons: ch,
  "close-button": "_close-button_xt89c_41",
  closeButton: fh,
  "confirm-button": "_confirm-button_xt89c_65",
  confirmButton: dh,
  "saving-indicator": "_saving-indicator_xt89c_66",
  savingIndicator: gh,
  "success-indicator": "_success-indicator_xt89c_67",
  successIndicator: hh,
  "error-indicator": "_error-indicator_xt89c_68",
  errorIndicator: mh,
  "transcript-search": "_transcript-search_xt89c_107",
  transcriptSearch: ph,
  "search-wrapper": "_search-wrapper_xt89c_150",
  searchWrapper: yh,
  "transcript-search-clear-button": "_transcript-search-clear-button_xt89c_155",
  transcriptSearchClearButton: _h,
  "transcript-search-widget": "_transcript-search-widget_xt89c_182",
  transcriptSearchWidget: Eh,
  "transcript-search-widget-button": "_transcript-search-widget-button_xt89c_195",
  transcriptSearchWidgetButton: vh,
  "transcript-list": "_transcript-list_xt89c_230",
  transcriptList: Th,
  "transcript-line-wrapper": "_transcript-line-wrapper_xt89c_263",
  transcriptLineWrapper: bh,
  "transcript-line": "_transcript-line_xt89c_263",
  transcriptLine: Sh,
  text: Ah,
  "editable-text": "_editable-text_xt89c_288",
  editableText: Ih,
  "validation-error": "_validation-error_xt89c_322",
  validationError: Ch,
  "auto-scroll-button": "_auto-scroll-button_xt89c_355",
  autoScrollButton: wh,
  output: Rh
};
function Nh() {
  const D = Ar("outputMessage"), { t: C } = An();
  return /* @__PURE__ */ ce("output", { className: Jn.output, "aria-live": "polite", "aria-atomic": "true", children: C.apply(null, D) });
}
const Dh = (D) => /* @__PURE__ */ tn("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: [
  /* @__PURE__ */ ce("path", { d: "M12.3665 7.40676L9.56307 3.33553C9.25214 2.88398 8.74226 2.89235 8.43708 3.33553L5.63362 7.40676C5.32269 7.8583 5.51567 8.22435 6.06596 8.22435H11.9342C12.4839 8.22435 12.6717 7.84994 12.3665 7.40676Z", fill: "currentColor" }),
  /* @__PURE__ */ ce("path", { d: "M5.63094 10.5932L8.4344 14.6645C8.74533 15.116 9.25522 15.1076 9.56039 14.6645L12.3638 10.5932C12.6748 10.1417 12.4818 9.77564 11.9315 9.77564L6.06328 9.77563C5.51357 9.77563 5.32577 10.15 5.63094 10.5932Z", fill: "currentColor" })
] });
function Mh() {
  const D = Ii(), { t: C } = An();
  return /* @__PURE__ */ ce(
    "button",
    {
      tabIndex: 0,
      type: "button",
      onClick: D.enableAutoScroll,
      className: Jn.autoScrollButton,
      "aria-label": C("START_AUTOSCROLL"),
      children: /* @__PURE__ */ ce(Dh, {})
    }
  );
}
const Oh = (D) => /* @__PURE__ */ ce("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M14 8C14 9.18669 13.6481 10.3467 12.9888 11.3334C12.3295 12.3201 11.3925 13.0892 10.2961 13.5433C9.19975 13.9974 7.99335 14.1162 6.82946 13.8847C5.66558 13.6532 4.59648 13.0818 3.75736 12.2426C2.91825 11.4035 2.3468 10.3344 2.11529 9.17054C1.88378 8.00666 2.0026 6.80026 2.45673 5.7039C2.91085 4.60754 3.67989 3.67047 4.66658 3.01118C5.65328 2.35189 6.81331 2 8 2C9.68 2 11.2867 2.66667 12.4933 3.82667L14 5.33333M14 5.33333L14 2M14 5.33333H10.6667", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }) }), Lh = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M11.9999 9V13M11.9999 17H12.0099M21.7299 18.0002L13.7299 4.00022C13.5555 3.69243 13.3025 3.43641 12.9969 3.25829C12.6912 3.08017 12.3437 2.98633 11.9899 2.98633C11.6361 2.98633 11.2887 3.08017 10.983 3.25829C10.6773 3.43641 10.4244 3.69243 10.2499 4.00022L2.24993 18.0002C2.07361 18.3056 1.98116 18.6521 1.98194 19.0047C1.98272 19.3573 2.07671 19.7035 2.25438 20.008C2.43204 20.3126 2.68708 20.5648 2.99362 20.7391C3.30017 20.9133 3.64734 21.0034 3.99993 21.0002H19.9999C20.3508 20.9999 20.6955 20.9072 20.9992 20.7315C21.303 20.5558 21.5551 20.3033 21.7304 19.9993C21.9057 19.6954 21.998 19.3506 21.9979 18.9997C21.9978 18.6488 21.9054 18.3041 21.7299 18.0002Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), Ph = "_error-container_1mp96_1", xh = "_error-texts_1mp96_10", Fh = "_error-icon_1mp96_16", kh = "_error-title_1mp96_22", Zh = "_error-description_1mp96_30", Bh = "_error-retry-button_1mp96_38", Ti = {
  "error-container": "_error-container_1mp96_1",
  errorContainer: Ph,
  "error-texts": "_error-texts_1mp96_10",
  errorTexts: xh,
  "error-icon": "_error-icon_1mp96_16",
  errorIcon: Fh,
  "error-title": "_error-title_1mp96_22",
  errorTitle: kh,
  "error-description": "_error-description_1mp96_30",
  errorDescription: Zh,
  "error-retry-button": "_error-retry-button_1mp96_38",
  errorRetryButton: Bh
};
function Uh({ onRetry: D }) {
  const { t: C } = An();
  return /* @__PURE__ */ tn("div", { className: Ti.errorContainer, children: [
    /* @__PURE__ */ ce(Lh, { className: Ti.errorIcon, "aria-hidden": "true" }),
    /* @__PURE__ */ tn("div", { className: Ti.errorTexts, children: [
      /* @__PURE__ */ ce("span", { className: Ti.errorTitle, children: C("TRANSCRIPT_UNAVAILABLE") }),
      /* @__PURE__ */ ce("span", { className: Ti.errorDescription, children: C("TRANSCRIPT_LOAD_ERROR") })
    ] }),
    /* @__PURE__ */ tn(
      "button",
      {
        type: "button",
        className: Ti.errorRetryButton,
        onClick: D,
        children: [
          /* @__PURE__ */ ce(Oh, { "aria-hidden": "true" }),
          C("TRANSCRIPT_RETRY")
        ]
      }
    )
  ] });
}
const Gh = (D) => /* @__PURE__ */ tn("svg", { width: 80, height: 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: [
  /* @__PURE__ */ ce("path", { d: "M64 40C64 43.1517 63.3792 46.2726 62.1731 49.1844C60.967 52.0962 59.1992 54.742 56.9706 56.9706C54.742 59.1992 52.0962 60.967 49.1844 62.1731C46.2726 63.3792 43.1517 64 40 64C36.8483 64 33.7274 63.3792 30.8156 62.1731C27.9038 60.967 25.258 59.1992 23.0294 56.9706C20.8008 54.742 19.033 52.0962 17.8269 49.1844C16.6208 46.2726 16 43.1517 16 40C16 36.8483 16.6208 33.7274 17.8269 30.8156C19.033 27.9038 20.8008 25.258 23.0294 23.0294C25.258 20.8008 27.9038 19.033 30.8156 17.8269C33.7274 16.6208 36.8483 16 40 16C43.1517 16 46.2726 16.6208 49.1844 17.8269C52.0962 19.033 54.742 20.8008 56.9706 23.0294C59.1992 25.258 60.967 27.9038 62.1731 30.8156C63.3792 33.7274 64 36.8483 64 40L64 40Z", stroke: "currentColor", strokeOpacity: 0.1, strokeWidth: 8, strokeLinecap: "round" }),
  /* @__PURE__ */ ce("path", { d: "M63.6354 35.8324C64.2931 39.5624 64.0587 43.395 62.9513 47.0169C61.844 50.6389 59.8951 53.9473 57.2642 56.6718", stroke: "currentColor", strokeWidth: 8, strokeLinecap: "round" })
] }), Hh = "_loading-container_1mz7b_1", qh = "_loading-spinner_1mz7b_10", Vh = "_spinner-rotate_1mz7b_1", jh = "_loading-text_1mz7b_17", Eo = {
  "loading-container": "_loading-container_1mz7b_1",
  loadingContainer: Hh,
  "loading-spinner": "_loading-spinner_1mz7b_10",
  loadingSpinner: qh,
  "spinner-rotate": "_spinner-rotate_1mz7b_1",
  spinnerRotate: Vh,
  "loading-text": "_loading-text_1mz7b_17",
  loadingText: jh
};
function Yh() {
  const { t: D } = An();
  return /* @__PURE__ */ tn("output", { className: Eo.loadingContainer, children: [
    /* @__PURE__ */ ce(Gh, { className: Eo.loadingSpinner, "aria-hidden": "true" }),
    /* @__PURE__ */ ce("span", { className: Eo.loadingText, children: D("TRANSCRIPT_LOADING") })
  ] });
}
const Kh = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18ZM8.99998 17.0526C13.4473 17.0526 17.0526 13.4473 17.0526 9C17.0526 4.55266 13.4473 0.947372 8.99998 0.947372C4.55263 0.947372 0.947347 4.55266 0.947347 9C0.947347 13.4473 4.55263 17.0526 8.99998 17.0526ZM8.91262 12.3989C8.1624 12.3989 7.55205 13.0092 7.55205 13.7594C7.55205 14.5097 8.1624 15.12 8.91262 15.12C9.66285 15.12 10.2732 14.5097 10.2732 13.7594C10.2732 13.0092 9.66285 12.3989 8.91262 12.3989ZM10.72 3.31579H7.10526L7.98558 11.297H9.83965L10.72 3.31579Z", fill: "currentColor" }) }), zh = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M7.29395 4.23535H3.58789C3.29697 4.23553 3.05877 4.47268 3.05859 4.76465V11.7451C3.22473 11.6859 3.40166 11.6475 3.58789 11.6475H14.1768C14.363 11.6475 14.5399 11.6859 14.7061 11.7451V4.76465C14.7059 4.47271 14.4676 4.23559 14.1768 4.23535H10.4707V3.17676H14.1768C15.0521 3.17699 15.7645 3.8893 15.7646 4.76465V16.4121C15.7645 17.2875 15.0521 17.9998 14.1768 18H3.58789C2.71251 17.9998 2.00018 17.2875 2 16.4121V4.76465C2.00018 3.88927 2.71251 3.17693 3.58789 3.17676H7.29395V4.23535ZM3.58789 12.7061C3.2969 12.7062 3.05865 12.9433 3.05859 13.2354V16.4121C3.05878 16.7041 3.29698 16.9412 3.58789 16.9414H14.1768C14.4676 16.9412 14.7059 16.704 14.7061 16.4121V13.2354C14.706 12.9433 14.4677 12.7063 14.1768 12.7061H3.58789ZM5.17676 13.7646C5.76096 13.7648 6.23518 14.2401 6.23535 14.8232C6.23535 15.4065 5.76107 15.8826 5.17676 15.8828C4.59229 15.8828 4.11719 15.4066 4.11719 14.8232C4.11736 14.24 4.5924 13.7646 5.17676 13.7646ZM9.41211 8.25098L11.7207 5.94238L12.4688 6.69043L8.88281 10.2783L5.29492 6.69043L6.04395 5.94238L8.35352 8.25098V0H9.41211V8.25098Z", fill: "currentColor" }) });
function Wh({ children: D }) {
  return /* @__PURE__ */ ce("div", { className: Jn.savingIndicator, children: /* @__PURE__ */ ce("span", { children: D }) });
}
function Qh({ children: D }) {
  return /* @__PURE__ */ tn("div", { className: Jn.successIndicator, children: [
    /* @__PURE__ */ ce(zh, {}),
    /* @__PURE__ */ ce("span", { children: D })
  ] });
}
function Xh({ children: D }) {
  return /* @__PURE__ */ tn("div", { className: Jn.errorIndicator, children: [
    /* @__PURE__ */ ce(Kh, {}),
    /* @__PURE__ */ ce("span", { children: D })
  ] });
}
function $h() {
  const D = Ii(), C = Ar("savingState"), { t: B } = An();
  return /* @__PURE__ */ tn("div", { className: Jn.editModeBar, children: [
    /* @__PURE__ */ ce("h3", { children: B("EDIT_TRANSCRIPT") }),
    /* @__PURE__ */ tn("div", { className: Jn.editModeBarButtons, children: [
      C === "saving" && /* @__PURE__ */ ce(Wh, { children: B("EDIT_SAVING") }),
      C === "success" && /* @__PURE__ */ ce(Qh, { children: B("EDIT_SUCCESS") }),
      C === "error" && /* @__PURE__ */ ce(Xh, { children: B("EDIT_ERROR") }),
      /* @__PURE__ */ ce(
        "button",
        {
          type: "button",
          "data-testid": "close-edit-mode",
          className: Jn.closeButton,
          onClick: D.exitEditMode,
          "aria-label": B("EDIT_CLOSE"),
          disabled: C === "saving",
          children: /* @__PURE__ */ ce(Ro, {})
        }
      )
    ] })
  ] });
}
const Jh = "_rolling-transcript-kebab-menu_1t2gp_1", em = "_rolling-transcript-kebab-menu-container_1t2gp_28", tm = "_rolling-transcript-kebab-menu-item_1t2gp_40", nm = "_rolling-transcript-kebab-arrow_1t2gp_72", ya = {
  "rolling-transcript-kebab-menu": "_rolling-transcript-kebab-menu_1t2gp_1",
  rollingTranscriptKebabMenu: Jh,
  "rolling-transcript-kebab-menu-container": "_rolling-transcript-kebab-menu-container_1t2gp_28",
  rollingTranscriptKebabMenuContainer: em,
  "rolling-transcript-kebab-menu-item": "_rolling-transcript-kebab-menu-item_1t2gp_40",
  rollingTranscriptKebabMenuItem: tm,
  "rolling-transcript-kebab-arrow": "_rolling-transcript-kebab-arrow_1t2gp_72",
  rollingTranscriptKebabArrow: nm
};
function rm({
  elements: D
}) {
  const [C, B] = ur(!1), [le, be] = ur(null), { t: qe } = An(), _e = () => {
    B(!C);
  }, fe = lr(null), R = lr([]), { refs: J, floatingStyles: E, context: t } = xi({
    open: C,
    onOpenChange: _e,
    whileElementsMounted: Fi,
    placement: "bottom-end",
    middleware: [
      Aa(),
      Ia(10),
      Ca({
        element: fe
      })
    ]
  }), e = So(t, {
    listRef: R,
    activeIndex: le,
    onNavigate: be,
    loop: !0
  }), h = Ra(t), { getReferenceProps: p, getFloatingProps: o, getItemProps: v } = Na(
    [h, e]
  ), m = ir(
    () => [...D].sort((n, c) => (n.order ?? 1) - (c.order ?? 1)),
    [D]
  );
  return /* @__PURE__ */ tn(Hr, { children: [
    /* @__PURE__ */ ce(
      "button",
      {
        id: "transcript-kebab-menu-button",
        tabIndex: 0,
        type: "button",
        "aria-label": qe("TRANSCRIPT_OPTIONS"),
        "aria-haspopup": "true",
        "aria-expanded": C,
        className: ya.rollingTranscriptKebabMenu,
        ref: J.setReference,
        ...p({
          onClick: _e
        }),
        children: /* @__PURE__ */ ce(El, {})
      }
    ),
    C && /* @__PURE__ */ ce(Da, { context: t, guards: !1, children: /* @__PURE__ */ tn(
      "div",
      {
        id: "transcript-kebab-menu",
        ref: J.setFloating,
        style: E,
        className: ya.rollingTranscriptKebabMenuContainer,
        role: "menu",
        "aria-labelledby": "transcript-kebab-menu-button",
        ...o(),
        children: [
          m.map(({ id: n, text: c, icon: f, onClick: S }, k) => /* @__PURE__ */ tn(
            "button",
            {
              tabIndex: le === k ? 0 : -1,
              type: "button",
              role: "menuitem",
              className: ya.rollingTranscriptKebabMenuItem,
              ref: (q) => {
                R.current[k] = q;
              },
              ...v({
                onClick: () => {
                  S(n), B(!1);
                }
              }),
              children: [
                Io(f) ? f : Co[f],
                c
              ]
            },
            n
          )),
          /* @__PURE__ */ ce(
            Ma,
            {
              ref: fe,
              context: t,
              className: ya.rollingTranscriptKebabArrow
            }
          )
        ]
      }
    ) })
  ] });
}
const im = (D) => /* @__PURE__ */ ce("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 0C3.58871 0 0 3.58871 0 8C0 12.4113 3.58871 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58871 12.4113 0 8 0ZM8 15.0588C4.10729 15.0588 0.941174 11.8927 0.941174 8C0.941174 4.1073 4.10729 0.941177 8 0.941177C11.8927 0.941177 15.0588 4.1073 15.0588 8C15.0588 11.8927 11.8927 15.0588 8 15.0588ZM10.6622 4.67238L7.99961 7.33496L5.33796 4.67238L4.67255 5.33779L7.3342 8.00038L4.67255 10.662L5.33796 11.3274L7.99961 8.66579L10.6622 11.3274L11.3276 10.662L8.66502 8.00038L11.3276 5.33779L10.6622 4.67238Z", fill: "currentColor" }) }), am = (D) => /* @__PURE__ */ ce("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.64531 12.3413C3.50398 12.3413 0.949332 9.78664 0.949332 6.64531C0.949332 3.50398 3.50398 0.949331 6.64531 0.949331C9.78664 0.949331 12.3413 3.50398 12.3413 6.64531C12.3413 9.78664 9.78664 12.3413 6.64531 12.3413ZM11.6616 10.9904C12.6735 9.82461 13.2906 8.30663 13.2906 6.64531C13.2906 2.98184 10.3088 0 6.64531 0C2.98184 0 0 2.98184 0 6.64531C0 10.3088 2.98184 13.2906 6.64531 13.2906C8.30663 13.2906 9.82461 12.6735 10.9904 11.6616L15.3279 16L16 15.3279L11.6616 10.9904Z", fill: "currentColor" }) });
function om() {
  const D = Ii(), C = Ar("searchTerm"), { t: B } = An(), le = xn((qe) => qe.preventDefault(), []), be = xn(
    (qe) => {
      qe.key === "Escape" ? D.clearSearch() : qe.key === "Enter" && !qe.shiftKey && (qe.preventDefault(), D.nextHit());
    },
    [D]
  );
  return /* @__PURE__ */ tn("form", { className: Jn.transcriptSearch, onSubmit: le, children: [
    /* @__PURE__ */ ce(am, { "aria-hidden": "true" }),
    /* @__PURE__ */ ce(
      "input",
      {
        id: "transcript-search",
        type: "text",
        placeholder: B("SEARCH_TRANSCRIPT_PLACEHOLDER"),
        onChange: D.onSearch,
        value: C,
        onKeyDown: be
      }
    ),
    C.length > 0 ? /* @__PURE__ */ ce(
      "button",
      {
        type: "button",
        "aria-label": B("CLEAR_SEARCH"),
        onClick: D.clearSearch,
        className: Jn.transcriptSearchClearButton,
        children: /* @__PURE__ */ ce(im, {})
      }
    ) : null
  ] });
}
const sm = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.03704 5L9 10.963L14.963 5L16 6.03704L9 13.037L2 6.03704L3.03704 5Z", fill: "currentColor" }) }), lm = (D) => /* @__PURE__ */ ce("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.03704 13.037L2 12L9 5L16 12L14.963 13.037L9 7.07407L3.03704 13.037Z", fill: "currentColor" }) });
function um() {
  const D = Ii(), C = Ar("searchTerm"), B = Ar("numHits"), le = Ar("currentHit"), { t: be } = An();
  return C.length > 0 ? /* @__PURE__ */ tn("div", { className: Jn.transcriptSearchWidget, children: [
    /* @__PURE__ */ ce(
      "output",
      {
        "aria-label": be("A11Y_SEARCH_HITS", {
          current: le + 1,
          total: B
        }),
        children: /* @__PURE__ */ tn("span", { "data-testid": "search-results-indicator", "aria-hidden": "true", children: [
          le + 1,
          "/",
          B
        ] })
      }
    ),
    /* @__PURE__ */ ce(
      "button",
      {
        type: "button",
        className: Jn.transcriptSearchWidgetButton,
        "aria-label": be("PREVIOUS_HIT"),
        onClick: D.previousHit,
        disabled: B === 0,
        children: /* @__PURE__ */ ce(lm, {})
      }
    ),
    /* @__PURE__ */ ce(
      "button",
      {
        type: "button",
        className: Jn.transcriptSearchWidgetButton,
        "aria-label": be("NEXT_HIT"),
        onClick: D.nextHit,
        disabled: B === 0,
        children: /* @__PURE__ */ ce(sm, {})
      }
    )
  ] }) : null;
}
function cm(D) {
  if (!D) return;
  D.focus();
  const C = document.createRange(), B = window.getSelection();
  C.selectNodeContents(D), C.collapse(!1), B == null || B.removeAllRanges(), B == null || B.addRange(C);
}
function fm(D) {
  return D.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");
}
const dm = Fc(function({
  index: C,
  timestamp: B,
  text: le,
  active: be,
  onClick: qe,
  onBlur: _e,
  onCancel: fe,
  isEditing: R,
  hasValidationError: J,
  validationErrorMessage: E
}) {
  const { t } = An(), e = lr(null), h = lr(null), p = wa([h, cm]), o = xn(() => {
    R || qe(B, C);
  }, [qe, B, C, R]), v = xn(
    (f) => {
      var S;
      !R || f.target.tagName !== "DIV" || _e(C, ((S = h.current) == null ? void 0 : S.innerText) ?? le);
    },
    [_e, C, R, le]
  ), m = xn(
    (f) => {
      var S, k;
      f.key === "Enter" && !f.shiftKey ? (f.preventDefault(), (S = e.current) == null || S.focus()) : f.key === "Escape" && (f.preventDefault(), fe(h.current), (k = e.current) == null || k.focus());
    },
    [fe]
  ), n = _a(B), c = fm(le);
  return /* @__PURE__ */ tn(
    "button",
    {
      ref: e,
      tabIndex: -1,
      className: Jn.transcriptLine,
      type: "button",
      onClick: o,
      onBlur: v,
      "aria-current": be ? "true" : void 0,
      "aria-label": t("A11Y_TRANSCRIPT_LINE", { time: n, text: le }),
      children: [
        /* @__PURE__ */ ce("span", { children: n }),
        R ? (
          /* biome-ignore lint/a11y/useSemanticElements: Using div with contentEditable:
             better control over focus, cursor placement and sizing.
             We ensure to set appropriate ARIA attributes for accessibility. */
          /* @__PURE__ */ ce(
            "div",
            {
              "data-testid": "edited-line",
              ref: p,
              tabIndex: 0,
              role: "textbox",
              "aria-multiline": "true",
              className: Jn.editableText,
              contentEditable: !0,
              suppressContentEditableWarning: !0,
              onKeyDown: m,
              dangerouslySetInnerHTML: {
                __html: c
              }
            }
          )
        ) : /* @__PURE__ */ tn("div", { children: [
          /* @__PURE__ */ ce(
            "p",
            {
              className: Jn.text,
              "data-validation-error": J ? "" : null,
              dangerouslySetInnerHTML: {
                __html: c
              }
            }
          ),
          J && /* @__PURE__ */ ce("small", { className: Jn.validationError, children: E })
        ] })
      ]
    }
  );
});
function gm() {
  const D = Ii(), C = zn(), B = Ar("cues"), le = Ar("autoScroll"), be = Ar("activeCueIndex"), qe = Ar("editingCueIndex"), _e = Ar("status"), fe = Ar("editMode"), R = Ar("validationError"), { t: J } = An(), E = ir(
    () => Xg({
      allowEditing: C.onTranscriptEdit !== void 0,
      editLabel: J("EDIT_TRANSCRIPT"),
      onEdit: D.enterEditMode,
      elements: C.transcriptMenuElements
    }),
    [
      C.onTranscriptEdit,
      J,
      D,
      C.transcriptMenuElements
    ]
  ), t = E.length > 0, e = C.captions.length > 0 && C.captions.every((o) => o.sourceType === "youtube"), h = C.captions.length === 0 || e;
  return !h && _e === "loading" && B.length === 0 ? /* @__PURE__ */ ce(Yh, {}) : _e === "error" ? /* @__PURE__ */ ce(Uh, { onRetry: D.retryTranscriptLoad }) : _e === "empty" || h ? C.emptyTranscriptsComponent : /* @__PURE__ */ tn(Hr, { children: [
    /* @__PURE__ */ tn("header", { className: Jn.header, "data-fullsize": fe, children: [
      fe && /* @__PURE__ */ ce($h, {}),
      /* @__PURE__ */ tn("div", { className: Jn.searchWrapper, children: [
        /* @__PURE__ */ ce(om, {}),
        t && !fe && /* @__PURE__ */ ce(rm, { elements: E })
      ] }),
      /* @__PURE__ */ ce(um, {})
    ] }),
    /* @__PURE__ */ ce(
      "ul",
      {
        className: Jn.transcriptList,
        ref: D.initialize,
        onKeyDown: D.handleKeyboard,
        onFocus: D.onFocus,
        onBlur: D.onBlur,
        "aria-label": J("A11Y_TRANSCRIPT_LINES", { count: B.length }),
        tabIndex: 0,
        children: B.map((o, v) => /* @__PURE__ */ ce(
          "li",
          {
            className: Jn.transcriptLineWrapper,
            children: /* @__PURE__ */ ce(
              dm,
              {
                index: v,
                onClick: D.onCueClick,
                onBlur: D.onCueBlur,
                onCancel: D.cancelEditing,
                timestamp: o.startTime,
                text: o.text,
                active: be === v,
                isEditing: qe === v,
                hasValidationError: R === v,
                validationErrorMessage: J("EDIT_VALIDATION_ERROR")
              }
            )
          },
          `${o.startTime}-${o.endTime}-${v}`
        ))
      }
    ),
    le ? null : /* @__PURE__ */ ce(Mh, {})
  ] });
}
function Gl() {
  const D = ah();
  return /* @__PURE__ */ ce(oh, { value: D, children: /* @__PURE__ */ tn("section", { className: Jn.rollingTranscript, children: [
    /* @__PURE__ */ ce(gm, {}),
    /* @__PURE__ */ ce(Nh, {})
  ] }) });
}
function hm({
  element: D
}) {
  const [C, B] = ur();
  return kc(() => {
    const le = typeof D == "string" ? document.getElementById(D) : D;
    B(le);
  }, [D]), C ? ef.createPortal(/* @__PURE__ */ ce(Gl, {}), C) : null;
}
const mm = "_studio-player-sidebar_1fcpy_1", pm = {
  "studio-player-sidebar": "_studio-player-sidebar_1fcpy_1",
  studioPlayerSidebar: mm
};
function ym(D) {
  return [
    {
      id: "transcript",
      label: "Transcript",
      Component: /* @__PURE__ */ ce(Gl, {})
    }
  ].concat(D).sort((B, le) => (B.order ?? 1) - (le.order ?? 1));
}
function _m() {
  var J;
  const { enableSidebar: D, tabs: C } = zn(), B = dr("sidebarOpen"), le = Oa(), { t: be } = An(), qe = D && !le, _e = lr(((J = C.find((E) => E.default)) == null ? void 0 : J.id) ?? "transcript"), fe = xn((E) => {
    _e.current = E;
  }, []), R = ir(() => ym(C), [C]);
  return qe && B ? /* @__PURE__ */ ce("aside", { className: pm.studioPlayerSidebar, "data-testid": "sidebar", children: /* @__PURE__ */ tn(si, { defaultValue: _e.current, onTabChange: fe, children: [
    /* @__PURE__ */ ce(si.List, { ariaLabel: be("SIDEBAR"), children: R.map((E) => /* @__PURE__ */ ce(si.Tab, { value: E.id, children: E.label }, E.id)) }),
    R.map(({ id: E, Component: t }) => /* @__PURE__ */ ce(si.Panel, { value: E, children: t }, E))
  ] }) }) : null;
}
const Em = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM17.3333 21.3333H21.3333V2.66667H17.3333V21.3333ZM14.6667 21.3333V2.66667H2.66667V21.3333H14.6667Z", fill: "currentColor" }) }), vm = (D) => /* @__PURE__ */ ce("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("path", { d: "M2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM14.6667 21.3333V2.66667H2.66667V21.3333H14.6667Z", fill: "currentColor" }) });
function Tm() {
  const D = dr("sidebarOpen"), C = wr(), { onTrackEvent: B } = zn(), { t: le } = An();
  return /* @__PURE__ */ ce(
    "button",
    {
      type: "button",
      className: "controls-button",
      onClick: () => {
        C.sidebarOpen.set(!D), B == null || B({
          type: "sidebar_visibility_changed",
          isVisible: !D
        });
      },
      "aria-label": le("SIDEBAR"),
      "aria-pressed": D ? "true" : "false",
      children: D ? /* @__PURE__ */ ce(vm, { className: "controls-button-icon" }) : /* @__PURE__ */ ce(Em, { className: "controls-button-icon" })
    }
  );
}
function ol(D, C) {
  if (D == null || !C)
    return "";
  const B = Math.floor(D / 3600), le = Math.floor(D % 3600 / 60), be = Math.floor(D % 60), qe = [];
  return B > 0 && qe.push(C("HOURS", { count: B })), le > 0 && qe.push(C("MINUTES", { count: le })), (be > 0 || qe.length === 0) && qe.push(C("SECONDS", { count: be })), qe.join(" ");
}
const bm = "_small-layout-overlay_1giz1_1", Sm = "_small-layout-button_1giz1_14", Am = "_small-layout-icon-play_1giz1_24", Im = "_small-layout-icon-pause_1giz1_30", Cm = "_small-layout-timestamp_1giz1_36", wm = "_time-display-group_1giz1_49", Rm = "_full-screen-close-icon_1giz1_53", Nm = "_fade-out_1giz1_1", ai = {
  "small-layout-overlay": "_small-layout-overlay_1giz1_1",
  smallLayoutOverlay: bm,
  "small-layout-button": "_small-layout-button_1giz1_14",
  smallLayoutButton: Sm,
  "small-layout-icon-play": "_small-layout-icon-play_1giz1_24",
  smallLayoutIconPlay: Am,
  "small-layout-icon-pause": "_small-layout-icon-pause_1giz1_30",
  smallLayoutIconPause: Im,
  "small-layout-timestamp": "_small-layout-timestamp_1giz1_36",
  smallLayoutTimestamp: Cm,
  "time-display-group": "_time-display-group_1giz1_49",
  timeDisplayGroup: wm,
  "full-screen-close-icon": "_full-screen-close-icon_1giz1_53",
  fullScreenCloseIcon: Rm,
  "fade-out": "_fade-out_1giz1_1",
  fadeOut: Nm
};
function Hl() {
  const D = jn("paused"), C = jn("currentTime"), B = jn("duration"), { t: le } = An(), be = ol(C, le), qe = ol(B, le);
  return /* @__PURE__ */ tn(
    "div",
    {
      className: ai.smallLayoutOverlay,
      "data-testid": "small-layout-overlay",
      children: [
        /* @__PURE__ */ ce(tf, { className: ai.fullScreenCloseIcon, children: /* @__PURE__ */ ce(Ro, {}) }),
        /* @__PURE__ */ ce("i", { className: ai.smallLayoutButton, "aria-hidden": !0, children: D ? /* @__PURE__ */ ce(Mo, { className: ai.smallLayoutIconPlay }) : /* @__PURE__ */ ce(Do, { className: ai.smallLayoutIconPause }) }),
        /* @__PURE__ */ ce(
          "div",
          {
            className: ai.smallLayoutTimestamp,
            role: "timer",
            "aria-label": le("A11Y_DURATION", {
              currentTime: be,
              duration: qe
            }),
            children: /* @__PURE__ */ tn("span", { className: ai.timeDisplayGroup, "aria-hidden": !0, children: [
              /* @__PURE__ */ ce(Ea, { type: "current" }),
              /* @__PURE__ */ ce("span", { children: "/" }),
              /* @__PURE__ */ ce(Ea, { type: "duration" })
            ] })
          }
        )
      ]
    }
  );
}
const [Dm, Lo] = kl(
  "useTabsContext must be used within a TabsProvider"
), Mm = "_tabs_1szs9_17", Om = "_tabs-list_1szs9_24", Lm = "_tabs-tab_1szs9_36", Pm = "_appear_1szs9_1", xm = "_tabs-panel_1szs9_85", Fm = "_fade-in_1szs9_1", Pa = {
  tabs: Mm,
  "tabs-list": "_tabs-list_1szs9_24",
  tabsList: Om,
  "tabs-tab": "_tabs-tab_1szs9_36",
  tabsTab: Lm,
  appear: Pm,
  "tabs-panel": "_tabs-panel_1szs9_85",
  tabsPanel: xm,
  "fade-in": "_fade-in_1szs9_1",
  fadeIn: Fm
};
function km() {
  const { setActiveTab: D } = Lo(), C = lr(null);
  return Ir(() => {
    if (!C.current)
      return () => {
      };
    const B = C.current, le = new AbortController();
    return B.addEventListener(
      "keydown",
      (be) => {
        if (be.key === "ArrowRight") {
          be.preventDefault(), be.stopPropagation();
          const qe = Array.from(B.children).findIndex(
            (fe) => fe.getAttribute("aria-selected") === "true"
          ), _e = qe + 1 < B.children.length ? B.children[qe + 1] : B.children[0];
          _e != null && _e.dataset.value && (D(_e.dataset.value), _e.focus());
        } else if (be.key === "ArrowLeft") {
          be.preventDefault(), be.stopPropagation();
          const qe = Array.from(B.children).findIndex(
            (fe) => fe.getAttribute("aria-selected") === "true"
          ), _e = qe - 1 >= 0 ? B.children[qe - 1] : B.children[B.children.length - 1];
          _e != null && _e.dataset.value && (D(_e.dataset.value), _e.focus());
        }
      },
      {
        signal: le.signal
      }
    ), () => {
      le.abort();
    };
  }, [D]), C;
}
function Zm({
  children: D,
  ariaLabel: C = ""
}) {
  const B = km();
  return /* @__PURE__ */ ce(
    "div",
    {
      ref: B,
      role: "tablist",
      "aria-orientation": "horizontal",
      className: Pa.tabsList,
      "aria-label": C,
      children: D
    }
  );
}
function Bm({
  value: D,
  keepMounted: C = !1,
  children: B
}) {
  const { activeTab: le, getPanelId: be, getTabId: qe } = Lo();
  return /* @__PURE__ */ ce(
    "div",
    {
      role: "tabpanel",
      id: be(D),
      "aria-labelledby": qe(D),
      hidden: le !== D,
      className: Pa.tabsPanel,
      tabIndex: 0,
      children: C || le === D ? B : null
    }
  );
}
function Um({ value: D, children: C }) {
  const { activeTab: B, setActiveTab: le, getTabId: be, getPanelId: qe } = Lo(), _e = B === D;
  return /* @__PURE__ */ ce(
    "button",
    {
      type: "button",
      role: "tab",
      tabIndex: _e ? 0 : -1,
      "aria-selected": _e,
      "aria-controls": qe(D),
      id: be(D),
      "data-value": D,
      className: Pa.tabsTab,
      onClick: () => le(D),
      children: C
    }
  );
}
function si({
  defaultValue: D,
  onTabChange: C,
  children: B
}) {
  const le = Zc(), [be, qe] = ur(D ?? null), _e = xn(
    (J) => {
      qe(J), C == null || C(J);
    },
    [C]
  ), fe = xn(
    (J) => `${J}-panel-${le}`,
    [le]
  ), R = xn(
    (J) => `${J}-tab-${le}`,
    [le]
  );
  return /* @__PURE__ */ ce(
    Dm,
    {
      value: {
        activeTab: be,
        setActiveTab: _e,
        getTabId: R,
        getPanelId: fe
      },
      children: /* @__PURE__ */ ce("div", { className: Pa.tabs, children: B })
    }
  );
}
si.List = Zm;
si.Tab = Um;
si.Panel = Bm;
const Gm = "_time-indicator_1eqqx_1", Hm = {
  "time-indicator": "_time-indicator_1eqqx_1",
  timeIndicator: Gm
};
function qm() {
  return /* @__PURE__ */ tn("div", { className: Hm.timeIndicator, children: [
    /* @__PURE__ */ ce(Ea, { type: "current" }),
    "/",
    /* @__PURE__ */ ce(Ea, { type: "duration" })
  ] });
}
const Vm = "_comment-markers_p3cgm_1", jm = "_comment-marker_p3cgm_1", Ym = "_timeline-wrapper_p3cgm_24", Km = "_timeline-wrapper-compact_p3cgm_25", zm = "_track_p3cgm_55", Wm = "_thumb_p3cgm_68", Qm = "_root_p3cgm_82", Xm = "_track-inner_p3cgm_112", $m = "_progress_p3cgm_118", Jm = "_track-fill_p3cgm_124", ep = "_pins_p3cgm_130", tp = "_pin-button_p3cgm_139", np = "_annotation-pin_p3cgm_165", rp = "_quiz-pin_p3cgm_174", ip = "_annotation-pin-child_p3cgm_183", ap = "_quiz-pin-child_p3cgm_187", op = "_interactive-pin-container_p3cgm_192", sp = "_interactive-pin-wrapper_p3cgm_199", lp = "_interactive-pin-icon_p3cgm_205", up = "_interactive-pin_p3cgm_192", cp = "_bg_p3cgm_219", fp = "_symbol_p3cgm_223", dp = "_interactive-pin-button_p3cgm_228", gp = "_interactive-pin-menu_p3cgm_257", hp = "_interactive-pin-menu-item_p3cgm_278", mp = "_arrow_p3cgm_303", pp = "_tooltip_p3cgm_307", yp = "_tooltip-arrow_p3cgm_316", Pn = {
  "comment-markers": "_comment-markers_p3cgm_1",
  commentMarkers: Vm,
  "comment-marker": "_comment-marker_p3cgm_1",
  commentMarker: jm,
  "timeline-wrapper": "_timeline-wrapper_p3cgm_24",
  timelineWrapper: Ym,
  "timeline-wrapper-compact": "_timeline-wrapper-compact_p3cgm_25",
  timelineWrapperCompact: Km,
  track: zm,
  thumb: Wm,
  root: Qm,
  "track-inner": "_track-inner_p3cgm_112",
  trackInner: Xm,
  progress: $m,
  "track-fill": "_track-fill_p3cgm_124",
  trackFill: Jm,
  pins: ep,
  "pin-button": "_pin-button_p3cgm_139",
  pinButton: tp,
  "annotation-pin": "_annotation-pin_p3cgm_165",
  annotationPin: np,
  "quiz-pin": "_quiz-pin_p3cgm_174",
  quizPin: rp,
  "annotation-pin-child": "_annotation-pin-child_p3cgm_183",
  annotationPinChild: ip,
  "quiz-pin-child": "_quiz-pin-child_p3cgm_187",
  quizPinChild: ap,
  "interactive-pin-container": "_interactive-pin-container_p3cgm_192",
  interactivePinContainer: op,
  "interactive-pin-wrapper": "_interactive-pin-wrapper_p3cgm_199",
  interactivePinWrapper: sp,
  "interactive-pin-icon": "_interactive-pin-icon_p3cgm_205",
  interactivePinIcon: lp,
  "interactive-pin": "_interactive-pin_p3cgm_192",
  interactivePin: up,
  bg: cp,
  symbol: fp,
  "interactive-pin-button": "_interactive-pin-button_p3cgm_228",
  interactivePinButton: dp,
  "interactive-pin-menu": "_interactive-pin-menu_p3cgm_257",
  interactivePinMenu: gp,
  "interactive-pin-menu-item": "_interactive-pin-menu-item_p3cgm_278",
  interactivePinMenuItem: hp,
  arrow: mp,
  tooltip: pp,
  "tooltip-arrow": "_tooltip-arrow_p3cgm_316",
  tooltipArrow: yp
};
function sl() {
  const D = jn("duration"), C = zn(), B = dr("commentsEnabled");
  return D > 0 && C.hasComments && B ? /* @__PURE__ */ ce("div", { className: Pn.commentMarkers, "data-testid": "comment-markers", children: C.comments.map((le) => /* @__PURE__ */ ce(
    "span",
    {
      className: Pn.commentMarker,
      style: {
        left: `${le.timestamp / D * 100}%`
      }
    },
    le.id
  )) }) : null;
}
const _p = Bc(function({ currentTime: C, position: B }, le) {
  const [be, qe] = ur(!1), [_e, fe] = ur(null), R = zn(), J = wr(), E = xn(() => {
    R.interactiveMenuElements.length > 0 ? qe((F) => (J.globalKeysDisabled.set(!F), !F)) : R.onInteractivePinClick(C);
  }, [
    R.interactiveMenuElements,
    R.onInteractivePinClick,
    C
  ]), t = lr(null), { refs: e, floatingStyles: h, context: p } = xi({
    open: be,
    onOpenChange: E,
    whileElementsMounted: Fi,
    placement: "top",
    middleware: [
      Aa(),
      Ia(6),
      Ca({
        element: t
      })
    ]
  }), o = lr([]), v = Ra(p), m = So(p, {
    listRef: o,
    activeIndex: _e,
    onNavigate: fe,
    loop: !0,
    openOnArrowKeyDown: !1
  }), { getReferenceProps: n, getFloatingProps: c, getItemProps: f } = Na(
    [v, m]
  ), S = wa([e.setReference, le]), { t: k } = An(), q = _a(C);
  return /* @__PURE__ */ tn(Hr, { children: [
    /* @__PURE__ */ ce(
      "button",
      {
        id: "interactive-pin",
        "data-interactive-pin": "",
        type: "button",
        "aria-label": R.interactiveMenuElements.length > 0 ? k("ADD_QUESTION_AT", { time: q }) : k("ADD_ANNOTATION_AT", { time: q }),
        "aria-haspopup": R.interactiveMenuElements.length > 0 ? "true" : void 0,
        className: Pn.interactivePinButton,
        ref: S,
        style: { left: `${B}%` },
        ...n({
          onClick: E
        }),
        children: /* @__PURE__ */ tn(
          "svg",
          {
            className: Pn.interactivePin,
            width: "36",
            height: "44",
            fill: "none",
            viewBox: "0 0 36 44",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ ce(
                "path",
                {
                  className: Pn.bg,
                  d: "M 33.1703,27.499961 C 34.9615,24.721661 36,21.418761 36,17.874961 36,8.0028612 27.9411,-3.8819277e-5 18,-3.8819277e-5 8.0588999,-3.8819277e-5 -1.5e-7,8.0028612 -1.5e-7,17.874961 c 0,3.5438 1.03844995,6.8467 2.82964995,9.625 4.5447501,6.8094 10.1600502,10.1014 15.2487502,16.5 5.0364,-6.3985 10.5573,-9.7259 15.0919,-16.5 z"
                }
              ),
              /* @__PURE__ */ ce(
                "path",
                {
                  className: Pn.symbol,
                  d: "m 35.499961,17.877772 c 0,3.443549 -1.008198,6.652061 -2.747494,9.351891 -2.235095,3.338633 -4.71529,5.832631 -7.286584,8.306425 -0.277599,0.267143 -0.556499,0.534085 -0.836198,0.801928 -2.174595,2.082232 -4.40389,4.216673 -6.553385,6.870196 -2.158995,-2.636621 -4.40379,-4.754859 -6.591985,-6.819788 -0.2979,-0.281145 -0.594699,-0.561289 -0.890198,-0.841534 C 7.9918219,33.077896 5.4869279,30.584698 3.2477829,27.230063 1.5082968,24.530133 0.50003905,21.321521 0.50003905,17.877772 0.50003905,8.2835422 8.3317219,0.50000048 18,0.50000048 c 9.668278,0 17.499961,7.78354172 17.499961,17.37777152 z"
                }
              ),
              /* @__PURE__ */ ce(
                "path",
                {
                  className: Pn.interactivePinIcon,
                  "data-open": be,
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "m 18.75,17.388467 v -6.25 h -1.5 v 6.25 H 11 v 1.5 h 6.25 v 6.25 h 1.5 v -6.25 H 25 v -1.5 z",
                  fill: "white"
                }
              )
            ]
          }
        )
      }
    ),
    be && /* @__PURE__ */ ce(Da, { context: p, initialFocus: -1, modal: !0, children: /* @__PURE__ */ tn(
      "div",
      {
        ref: e.setFloating,
        style: h,
        className: Pn.interactivePinMenu,
        ...c(),
        children: [
          R.interactiveMenuElements.map(
            ({ id: F, text: te, onClick: P }, Q) => /* @__PURE__ */ tn(
              "button",
              {
                type: "button",
                className: Pn.interactivePinMenuItem,
                ref: (se) => {
                  o.current[Q] = se;
                },
                tabIndex: _e === Q ? 0 : -1,
                ...f({
                  onClick: () => {
                    P(F, C), qe(!1), J.globalKeysDisabled.set(!1);
                  }
                }),
                children: [
                  /* @__PURE__ */ ce(
                    "svg",
                    {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: /* @__PURE__ */ ce(
                        "path",
                        {
                          fillRule: "evenodd",
                          clipRule: "evenodd",
                          d: "M7.33339 7.33339H1.77783V8.66672H7.33339V14.2223H8.66672V8.66672H14.2223V7.33339H8.66672V1.77783H7.33339V7.33339Z",
                          fill: "currentColor"
                        }
                      )
                    }
                  ),
                  te
                ]
              },
              F
            )
          ),
          /* @__PURE__ */ ce(
            Ma,
            {
              ref: t,
              context: p,
              className: Pn.arrow
            }
          )
        ]
      }
    ) })
  ] });
}), Ep = () => {
  const D = lr(!1), C = lr(!1), B = ir(
    () => ({
      ArrowLeft: () => {
        C.current = !0;
      },
      ArrowRight: () => {
        C.current = !0;
      },
      Tab: () => {
        C.current = !1;
      }
    }),
    []
  );
  return wo(B), { focusCallback: xn((be) => {
    be && (be.addEventListener("focus", () => {
      D.current = !0;
    }), be.addEventListener("blur", () => {
      C.current || (D.current = !1);
    }), D.current && be.focus());
  }, []), wasPinFocused: D.current };
};
function vp() {
  var fe;
  const D = jn("duration"), C = jn("currentTime"), B = C / D * 100, { disableInteractivePinRanges: le } = zn(), be = !le.some(
    ([R, J]) => C >= R && C <= J
  ), { wasPinFocused: qe, focusCallback: _e } = Ep();
  return be ? /* @__PURE__ */ ce("div", { className: Pn.interactivePinContainer, children: /* @__PURE__ */ ce("div", { className: Pn.interactivePinWrapper, children: /* @__PURE__ */ ce(
    _p,
    {
      ref: _e,
      currentTime: C,
      position: B
    }
  ) }) }) : (qe && ((fe = document.querySelector("[data-media-time-slider]")) == null || fe.focus()), null);
}
function Tp() {
  const D = jn("paused"), C = dr("interactionsDisabled");
  return D && !C ? /* @__PURE__ */ ce(vp, {}) : null;
}
const bp = {
  annotation: Pn.annotationPin,
  quiz: Pn.quizPin
}, Sp = (D, C, B, le = !1) => C === "annotation" ? D("OPEN_ANNOTATION_AT", { time: _a(B) }) : C === "quiz" ? D(le ? "OPEN_COMPLETED_QUIZ_AT" : "OPEN_QUIZ_AT", {
  time: _a(B)
}) : "";
function ql({
  type: D,
  position: C,
  children: B,
  onClick: le,
  id: be,
  time: qe,
  completed: _e
}) {
  const { t: fe } = An();
  return /* @__PURE__ */ ce(
    "button",
    {
      type: "button",
      className: Pn.pinButton,
      style: { left: `${C}%` },
      onClick: le,
      "data-marker-id": be,
      "aria-label": Sp(fe, D, qe, _e),
      children: /* @__PURE__ */ tn(
        "svg",
        {
          className: bp[D],
          width: "26",
          height: "32",
          viewBox: "0 0 26 32",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ ce("path", { d: "M25.5 13C25.5 15.4774 24.7798 17.785 23.5376 19.7268C21.932 22.1411 20.1501 23.9459 18.2945 25.7433C18.0942 25.9373 17.8929 26.1314 17.6908 26.3262C16.157 27.8047 14.5793 29.3256 13.0545 31.2007C11.5227 29.3377 9.93394 27.8282 8.39067 26.362C8.17552 26.1576 7.96126 25.954 7.74816 25.7505C5.87029 23.9566 4.07076 22.1526 2.46259 19.7271C1.22024 17.7852 0.5 15.4775 0.5 13C0.5 6.09644 6.09644 0.5 13 0.5C19.9036 0.5 25.5 6.09644 25.5 13Z" }),
            B
          ]
        }
      )
    }
  );
}
function Ap(D) {
  return /* @__PURE__ */ ce(ql, { type: "annotation", ...D, children: /* @__PURE__ */ ce(
    "path",
    {
      className: Pn.annotationPinChild,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 8V19.25H8.875V18.875C8.875 17.8415 9.7165 17 10.75 17H19V8H7ZM10 11.75H16V11H10V11.75ZM14.5 14H10V13.25H14.5V14Z",
      fill: "currentColor",
      stroke: "none"
    }
  ) });
}
function Ip(D) {
  const C = D.completed ? /* @__PURE__ */ ce(
    "path",
    {
      className: Pn.quizPinChild,
      transform: "translate(6, 6)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7156 2.33212L5.18253 9.86522L1.28337 5.96607L0 7.24944L5.18253 12.4329L13.9999 3.6164L12.7156 2.33212Z",
      fill: "currentColor",
      stroke: "none",
      "data-completed": "true"
    }
  ) : /* @__PURE__ */ ce(
    "text",
    {
      className: Pn.quizPinChild,
      x: "50%",
      y: "56%",
      textAnchor: "middle",
      fill: "currentColor",
      stroke: "none",
      children: D.ordinal
    }
  );
  return /* @__PURE__ */ ce(ql, { type: "quiz", ...D, children: D.multiple ? /* @__PURE__ */ ce("circle", { className: Pn.quizPinChild, cx: "13", cy: "13", r: "6" }) : C });
}
function Cp(D, C) {
  return D.map((B, le) => ({
    id: B.id,
    time: B.time,
    type: "annotation",
    ordinal: le + 1,
    onClick: () => C(B)
  }));
}
function wp(D, C) {
  const B = /* @__PURE__ */ new Map();
  D.forEach((qe) => {
    var fe;
    const _e = qe.time;
    B.has(_e) || B.set(_e, []), (fe = B.get(_e)) == null || fe.push(qe);
  });
  const le = [];
  let be = 0;
  return B.forEach((qe, _e) => {
    le.push({
      id: qe.map((fe) => fe.id).join("-"),
      time: _e,
      type: "quiz",
      ordinal: be + 1,
      onClick: () => C(qe),
      multiple: qe.length > 1,
      completed: qe.every((fe) => fe.completed)
    }), be++;
  }), le;
}
function Rp(D, C, B, le) {
  switch (D.type) {
    case "annotation": {
      const be = () => le ? D.onClick() : B.seek(D.time);
      return /* @__PURE__ */ ce(
        Ap,
        {
          id: D.id,
          position: D.time / C * 100,
          onClick: be,
          time: D.time
        },
        D.id
      );
    }
    case "quiz":
      return /* @__PURE__ */ ce(
        Ip,
        {
          id: D.id,
          position: D.time / C * 100,
          ordinal: D.ordinal,
          multiple: D.multiple,
          onClick: D.onClick,
          completed: D.completed,
          time: D.time
        },
        D.id
      );
    default:
      return null;
  }
}
function Np() {
  const D = Sa(), C = jn("duration"), B = zn(), le = ir(() => [
    ...Cp(
      B.annotations,
      B.onAnnotationClick
    ),
    ...B.hideQuizMarkers ? [] : wp(
      B.quizMarkers,
      B.onQuizMarkerClick
    )
  ].sort((qe, _e) => qe.time - _e.time).map((qe) => Rp(qe, C, D, B.interactive)), [B.annotations, B.quizMarkers, C, D]);
  return B.interactive || le.length > 0 ? /* @__PURE__ */ ce("div", { className: Pn.pins, "data-pins": "", children: le }) : null;
}
function Vl(D) {
  var C, B, le = "";
  if (typeof D == "string" || typeof D == "number") le += D;
  else if (typeof D == "object") if (Array.isArray(D)) {
    var be = D.length;
    for (C = 0; C < be; C++) D[C] && (B = Vl(D[C])) && (le && (le += " "), le += B);
  } else for (B in D) D[B] && (le && (le += " "), le += B);
  return le;
}
function bo() {
  for (var D, C, B = 0, le = "", be = arguments.length; B < be; B++) (D = arguments[B]) && (C = Vl(D)) && (le && (le += " "), le += C);
  return le;
}
const Dp = {
  normal: Pn.timelineWrapper,
  compact: Pn.timelineWrapperCompact
};
function ll({
  layout: D,
  children: C
}) {
  const [B, le] = ur(!1), be = xn(() => le(!0), []), qe = xn(() => le(!1), []), _e = lr(null), { refs: fe, floatingStyles: R, context: J } = xi({
    open: B,
    onOpenChange: le,
    whileElementsMounted: (E, t, e) => Fi(E, t, e, {
      animationFrame: !0
    }),
    placement: "top",
    middleware: [
      Aa(),
      Ia(18),
      Ca({
        element: _e
      })
    ]
  });
  return /* @__PURE__ */ tn("div", { className: Dp[D], children: [
    C,
    /* @__PURE__ */ tn(
      nf,
      {
        className: Pn.root,
        onDragStart: be,
        onDragEnd: qe,
        "data-timeline": !0,
        children: [
          /* @__PURE__ */ tn(fl, { className: Pn.track, children: [
            /* @__PURE__ */ ce(
              rf,
              {
                className: bo(Pn.progress, Pn.trackInner)
              }
            ),
            /* @__PURE__ */ ce(
              dl,
              {
                className: bo(Pn.trackFill, Pn.trackInner)
              }
            )
          ] }),
          /* @__PURE__ */ ce(gl, { className: Pn.thumb, ref: fe.setReference }),
          B ? /* @__PURE__ */ tn(
            "div",
            {
              role: "tooltip",
              ref: fe.setFloating,
              style: R,
              className: Pn.tooltip,
              children: [
                /* @__PURE__ */ ce(af, {}),
                /* @__PURE__ */ ce(
                  Ma,
                  {
                    ref: _e,
                    context: J,
                    className: Pn.tooltipArrow,
                    width: 20,
                    height: 10
                  }
                )
              ]
            }
          ) : null
        ]
      }
    )
  ] });
}
const Mp = "_wrapper_1ld4n_1", Op = "_track_1ld4n_6", Lp = "_thumb_1ld4n_18", Pp = "_track-fill_1ld4n_32", xp = "_root_1ld4n_39", Oi = {
  wrapper: Mp,
  track: Op,
  thumb: Lp,
  "track-fill": "_track-fill_1ld4n_32",
  trackFill: Pp,
  root: xp
};
function Fp() {
  const D = Cr(), C = jn("volume"), le = jn("muted") || C === 0, { t: be } = An();
  return /* @__PURE__ */ tn("div", { className: Oi.wrapper, children: [
    /* @__PURE__ */ ce(
      "button",
      {
        type: "button",
        className: "controls-button",
        "aria-label": be(le ? "VOLUME" : "MUTE"),
        onClick: () => {
          le ? D == null || D.remoteControl.unmute() : D == null || D.remoteControl.mute();
        },
        children: le ? /* @__PURE__ */ ce(Ml, { className: "controls-button-icon" }) : C < 0.5 ? /* @__PURE__ */ ce(Ll, { className: "controls-button-icon" }) : /* @__PURE__ */ ce(Ol, { className: "controls-button-icon" })
      }
    ),
    /* @__PURE__ */ tn(of, { className: Oi.root, children: [
      /* @__PURE__ */ ce(fl, { className: Oi.track, children: /* @__PURE__ */ ce(dl, { className: Oi.trackFill }) }),
      /* @__PURE__ */ ce(gl, { className: Oi.thumb })
    ] })
  ] });
}
class Pi extends Error {
}
Pi.prototype.name = "InvalidTokenError";
function kp(D) {
  return decodeURIComponent(atob(D).replace(/(.)/g, (C, B) => {
    let le = B.charCodeAt(0).toString(16).toUpperCase();
    return le.length < 2 && (le = "0" + le), "%" + le;
  }));
}
function Zp(D) {
  let C = D.replace(/-/g, "+").replace(/_/g, "/");
  switch (C.length % 4) {
    case 0:
      break;
    case 2:
      C += "==";
      break;
    case 3:
      C += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return kp(C);
  } catch {
    return atob(C);
  }
}
function Bp(D, C) {
  if (typeof D != "string")
    throw new Pi("Invalid token specified: must be a string");
  C || (C = {});
  const B = C.header === !0 ? 0 : 1, le = D.split(".")[B];
  if (typeof le != "string")
    throw new Pi(`Invalid token specified: missing part #${B + 1}`);
  let be;
  try {
    be = Zp(le);
  } catch (qe) {
    throw new Pi(`Invalid token specified: invalid base64 for part #${B + 1} (${qe.message})`);
  }
  try {
    return JSON.parse(be);
  } catch (qe) {
    throw new Pi(`Invalid token specified: invalid json for part #${B + 1} (${qe.message})`);
  }
}
const Up = (D, C, B) => {
  var fe;
  const le = Zl(D);
  if (!le || typeof le != "string") return [];
  const be = Gp(le);
  if (!be) return [];
  const qe = Hp(be.token);
  if (!qe) return [];
  const _e = ((fe = qe.metadata) == null ? void 0 : fe.captions) || [];
  return qp(_e, be, C, B);
}, Gp = (D) => {
  const C = D.match(/^(https?:\/\/.+\/drm\/)([^/]+)(\/.+)$/);
  return C ? {
    baseUrl: C[1],
    token: C[2],
    remainingPath: C[3]
  } : null;
}, Hp = (D) => {
  try {
    return Bp(D);
  } catch {
    return null;
  }
}, qp = (D, C, B, le) => D.map((be) => {
  const qe = new Intl.DisplayNames([B], { type: "language" }).of(
    be.language
  ) || be.language, _e = be.asr ? le("CAPTION_LANGUAGE_AUTOMATIC", { language: qe }) : qe;
  return {
    src: `${C.baseUrl}${C.token}/captions/${be.language}.srt`,
    label: _e,
    language: `${be.language}-ntrs`,
    type: "srt",
    sourceType: "standard"
  };
});
function Vp({
  src: D,
  captions: C,
  locale: B,
  displayAsrCaptions: le
}) {
  const { t: be } = An(), [qe, _e] = ur([]), fe = ir(
    () => le ? Up(D, B, be) : [],
    [D, B, le, be]
  );
  return {
    allCaptions: ir(
      () => [...C, ...fe, ...qe],
      [C, fe, qe]
    ),
    setDynamicYoutubeCaptions: _e
  };
}
function jp() {
  const D = Cr(), C = zn();
  Ir(() => {
    const B = () => {
      const le = C.startAt;
      D && C.disableStorage && vo(le) && (D.remoteControl.seek(le), D.$state.started.set(!0));
    };
    return D == null || D.addEventListener("loaded-metadata", B), () => {
      D == null || D.removeEventListener("loaded-metadata", B);
    };
  }, [D]);
}
const Yp = "_root_cuap3_1", Kp = "_normal_cuap3_24", zp = "_compact_cuap3_35", Wp = "_left-controls_cuap3_67", Qp = "_right-controls_cuap3_76", Xp = "_indicators_cuap3_85", bi = {
  root: Yp,
  normal: Kp,
  compact: zp,
  "left-controls": "_left-controls_cuap3_67",
  leftControls: Wp,
  "right-controls": "_right-controls_cuap3_76",
  rightControls: Qp,
  indicators: Xp
};
function $p({ playerRef: D }) {
  const C = Cr(), {
    hasAnnotations: B,
    hasQuizmarkers: le,
    interactive: be,
    enableSidebar: qe,
    controlsLayout: _e,
    disableCaptionSettings: fe,
    darkMode: R,
    onPlayerSizeChange: J
  } = zn(), E = dr("interactionsDisabled"), t = Oa();
  jp();
  const e = qe && !t;
  return Ir(() => {
    J(t);
  }, [t, J]), Ir(() => {
    const h = new AbortController();
    return C && (C.remoteControl.pauseControls(), C.addEventListener(
      "fullscreenchange",
      () => {
        requestAnimationFrame(() => {
          C.$state.fullscreen() ? C.remoteControl.resumeControls() : C.remoteControl.pauseControls();
        });
      },
      { signal: h.signal }
    ), D && (typeof D == "function" ? D(C) : D.current = C)), () => {
      h.abort();
    };
  }, [C, D]), /* @__PURE__ */ tn(
    "div",
    {
      "data-darkmode": R,
      "data-testid": "controls-layout",
      "data-controls-layout": _e,
      className: bo(bi.root, {
        [bi.normal]: _e === "normal",
        [bi.compact]: _e === "compact"
      }),
      inert: E ? "true" : void 0,
      children: [
        _e === "normal" ? /* @__PURE__ */ tn(ll, { layout: "normal", children: [
          be || B || le ? /* @__PURE__ */ ce(Np, {}) : null,
          be ? /* @__PURE__ */ ce(Tp, {}) : null,
          /* @__PURE__ */ ce(sl, {})
        ] }) : null,
        /* @__PURE__ */ tn("div", { className: bi.leftControls, children: [
          /* @__PURE__ */ ce(Vg, {}),
          /* @__PURE__ */ ce(Fp, {})
        ] }),
        /* @__PURE__ */ ce("div", { className: bi.indicators, children: /* @__PURE__ */ ce(qm, {}) }),
        _e === "compact" ? /* @__PURE__ */ ce(ll, { layout: "compact", children: /* @__PURE__ */ ce(sl, {}) }) : null,
        /* @__PURE__ */ tn("div", { className: bi.rightControls, children: [
          !fe && /* @__PURE__ */ ce(ad, {}),
          e && /* @__PURE__ */ ce(Tm, {}),
          /* @__PURE__ */ ce(Tg, {}),
          /* @__PURE__ */ ce(Fg, {})
        ] })
      ]
    }
  );
}
const Jp = (D) => /* @__PURE__ */ ce("svg", { width: 56, height: 72, viewBox: "0 0 28 36", xmlns: "http://www.w3.org/2000/svg", ...D, children: /* @__PURE__ */ ce("g", { id: "Icons", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ tn("g", { id: "audio", children: [
  /* @__PURE__ */ tn("g", { id: "icon-file-base-2", children: [
    /* @__PURE__ */ ce("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z", fill: "#FFFFFF" }),
    /* @__PURE__ */ ce("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z M1.993,35 C1.445,35 1,34.552 1,34 L1,2 C1,1.448 1.445,1 1.993,1 L16.5,1 L16.5,9 C16.5,10.379 17.621,11.5 18.999,11.5 L27,11.5 L27,34 C27,34.552 26.554,35 26.006,35 L1.993,35 Z M27,10.5 L18.999,10.5 C18.173,10.5 17.5,9.827 17.5,9 L17.5,1 L17.585,1 L27,10.414 L27,10.5 L27,10.5 Z", id: "icon-file-base", fill: "#FFFFFF" }),
    /* @__PURE__ */ ce("path", { d: "M0,2 L0,34 C0,35.105 0.899,36 1.993,36 L26.006,36 C27.107,36 28,35.11 28,34 L28,10 L18,0 L1.993,0 C0.892,0 0,0.89 0,2 Z M1.993,35 C1.445,35 1,34.552 1,34 L1,2 C1,1.448 1.445,1 1.993,1 L16.5,1 L16.5,9 C16.5,10.379 17.621,11.5 18.999,11.5 L27,11.5 L27,34 C27,34.552 26.554,35 26.006,35 L1.993,35 Z M27,10.5 L18.999,10.5 C18.173,10.5 17.5,9.827 17.5,9 L17.5,1 L17.585,1 L27,10.414 L27,10.5 L27,10.5 Z", fill: "#384A58" })
  ] }),
  /* @__PURE__ */ ce("path", { d: "M14.7142857,14.2824 L14.7142857,13 L13.2857143,13.2548 L13.2857143,23.0912 C12.8642857,22.9106 12.3785714,22.8 11.8571429,22.8 C10.2771429,22.8 9,23.7408 9,24.9 C9,26.0592 10.2771429,27 11.8571429,27 C12.3785714,27 12.8642857,26.8894 13.2857143,26.7088 C14.1371429,26.3448 14.7142857,25.6756 14.7142857,24.9 L14.7142857,17.0824 C17.5714286,17.0824 19,20 19,21.4 C19,15.8 16.1428571,14.2824 14.7142857,14.2824", id: "Fill-776", fill: "#384A58" })
] }) }) }), ey = "_audio-layout-wrapper_1tj9s_1", ty = {
  "audio-layout-wrapper": "_audio-layout-wrapper_1tj9s_1",
  audioLayoutWrapper: ey
};
function ny() {
  const D = zn();
  return /* @__PURE__ */ tn(
    "div",
    {
      "data-testid": "audio-layout-wrapper",
      className: ty.audioLayoutWrapper,
      children: [
        /* @__PURE__ */ ce(Jp, {}),
        /* @__PURE__ */ ce(Fl, { src: D.thumbnail }),
        /* @__PURE__ */ ce(Pl, {}),
        /* @__PURE__ */ ce(yl, {}),
        /* @__PURE__ */ ce(bl, { captions: D.captions }),
        /* @__PURE__ */ ce(Hl, {}),
        /* @__PURE__ */ ce(xl, {})
      ]
    }
  );
}
function ry() {
  const D = zn(), C = dr(
    "youtubeEducationProvider"
  ), B = ir(() => C ? Ld(D.captions) : D.captions, [D.captions, C]);
  return /* @__PURE__ */ tn(Hr, { children: [
    /* @__PURE__ */ ce(Fl, { src: D.thumbnail }),
    /* @__PURE__ */ ce(Pl, {}),
    /* @__PURE__ */ ce(yl, {}),
    /* @__PURE__ */ ce(bl, { captions: B }),
    /* @__PURE__ */ ce(Hl, {}),
    /* @__PURE__ */ ce(xl, {}),
    /* @__PURE__ */ ce(vd, { comments: D.comments })
  ] });
}
const iy = "_main-layout_xxzj0_187", ul = {
  "main-layout": "_main-layout_xxzj0_187",
  mainLayout: iy
};
function Er(D, C) {
  D.dispatchEvent(
    new CustomEvent("keyboardAction", {
      detail: C
    })
  );
}
function vr(D, C) {
  D.preventDefault(), C();
}
const ay = (D, C) => ({
  togglePaused: {
    keys: ["Space", "Enter", "k"],
    onKeyDown({ player: B, remote: le, event: be }) {
      var qe, _e, fe;
      ((qe = document.activeElement) != null && qe.hasAttribute("data-media-player") || (_e = document.activeElement) != null && _e.hasAttribute("data-play-pause-button") || (fe = document.activeElement) != null && fe.hasAttribute("data-timeline")) && vr(be, () => {
        le.togglePaused(be), Er(B, "togglePaused");
      });
    }
  },
  seekForward: {
    keys: ["ArrowRight"],
    onKeyDown({ player: B, remote: le, event: be }) {
      be.preventDefault(), vr(be, () => {
        le.seek(B.currentTime + 5, be), Er(B, "seekForward");
      });
    }
  },
  seekBackward: {
    keys: ["ArrowLeft"],
    onKeyDown({ player: B, remote: le, event: be }) {
      vr(be, () => {
        le.seek(B.currentTime - 5, be), Er(B, "seekBackward");
      });
    }
  },
  volumeUp: {
    keys: ["ArrowUp"],
    onKeyDown({ player: B, remote: le, event: be }) {
      vr(be, () => {
        le.changeVolume(B.volume + 0.05, be), Er(B, "volumeChange");
      });
    }
  },
  volumeDown: {
    keys: ["ArrowDown"],
    onKeyDown({ player: B, remote: le, event: be }) {
      vr(be, () => {
        le.changeVolume(B.volume - 0.05, be), Er(B, "volumeChange");
      });
    }
  },
  toggleFullscreen: D ? [] : ["f"],
  toggleMuted: {
    keys: ["m"],
    onKeyDown({ player: B, remote: le, event: be }) {
      vr(be, () => {
        le.toggleMuted(be), Er(B, "volumeChange");
      });
    }
  },
  toggleCaptions: {
    keys: ["c"],
    onKeyDown({ player: B, remote: le, event: be }) {
      vr(be, () => {
        le.toggleCaptions(be), Er(B, "captionsChange");
      });
    }
  },
  nextCaptionLanguage: {
    keys: ["v"],
    onKeyDown({ event: B, player: le, remote: be }) {
      vr(B, () => {
        const qe = le.textTracks.selectedIndex, _e = qe + 1;
        be.changeTextTrackMode(qe, "hidden", B), be.changeTextTrackMode(
          _e >= le.textTracks.length ? 0 : _e,
          "showing",
          B
        ), Er(le, "captionsChange");
      });
    }
  },
  previousCaptionLanguage: {
    keys: ["x"],
    onKeyDown({ event: B, player: le, remote: be }) {
      vr(B, () => {
        const qe = le.textTracks.selectedIndex, _e = qe - 1;
        be.changeTextTrackMode(qe, "hidden", B), be.changeTextTrackMode(
          _e < 0 ? le.textTracks.length - 1 : _e,
          "showing",
          B
        ), Er(le, "captionsChange");
      });
    }
  },
  decreasePlaybackRate: {
    keys: C ? [] : ["a"],
    onKeyDown({ event: B, player: le, remote: be }) {
      vr(B, () => {
        const _e = Si.indexOf(le.playbackRate) - 1;
        _e >= 0 && (be.changePlaybackRate(Si[_e], B), Er(le, "playbackRateChange"));
      });
    }
  },
  increasePlaybackRate: {
    keys: C ? [] : ["d"],
    onKeyDown({ event: B, player: le, remote: be }) {
      vr(B, () => {
        const _e = Si.indexOf(le.playbackRate) + 1;
        _e < Si.length && (be.changePlaybackRate(Si[_e], B), Er(le, "playbackRateChange"));
      });
    }
  },
  resetPlaybackRate: {
    keys: C ? [] : ["s"],
    onKeyDown({ event: B, player: le, remote: be }) {
      vr(B, () => {
        be.changePlaybackRate(1, B), Er(le, "playbackRateChange");
      });
    }
  },
  seekForward10Seconds: {
    keys: ["l"],
    onKeyDown({ event: B, player: le, remote: be }) {
      vr(B, () => {
        be.seek(le.currentTime + 10, B), Er(le, "seekForward10");
      });
    }
  },
  seekBackward10Seconds: {
    keys: ["j"],
    onKeyDown({ event: B, player: le, remote: be }) {
      vr(B, () => {
        be.seek(le.currentTime - 10, B), Er(le, "seekBackward10");
      });
    }
  }
}), cl = {
  volume: 1,
  muted: !1,
  lang: null,
  captions: !1,
  rate: 1,
  multiplier: 1,
  ontop: !1,
  invert: !1,
  comments: !1
};
class oy {
  constructor(C) {
    nn(this, "playerId", "studio-player");
    nn(this, "mediaId", null);
    nn(this, "data", cl);
    nn(this, "time", null);
    nn(this, "overrideTime", null);
    nn(this, "lockSpeed");
    nn(this, "saveTime", () => {
      if (!this.mediaId) return;
      const C = (this.time ?? 0).toString();
      localStorage.setItem(this.mediaId, C);
    });
    nn(this, "saveTimeThrottled", Bl(this.saveTime, 1e3));
    // only used for useStudioPlayer hook's state initialization
    nn(this, "initializeState", (C) => {
      const B = localStorage.getItem(this.playerId);
      if (vo(C) && C >= 0 && (this.overrideTime = C), B)
        try {
          this.data = JSON.parse(B);
        } catch {
        }
      return {
        captionsFontSizeMultiplier: this.data.multiplier || 1,
        captionPositionOnTop: this.data.ontop || !1,
        captionsInvertColors: this.data.invert || !1,
        commentsEnabled: this.data.comments || !1
      };
    });
    nn(this, "saveData", (C, B) => {
      this.data = {
        ...this.data,
        [C]: B
      }, this.save();
    });
    this.lockSpeed = C;
  }
  async getVideoQuality() {
    return null;
  }
  async getAudioGain() {
    return null;
  }
  async getLang() {
    return this.data.lang;
  }
  async setLang(C) {
    this.data.lang = C, this.save();
  }
  async getVolume() {
    return this.data.volume;
  }
  async setVolume(C) {
    this.data.volume = C, this.save();
  }
  async getMuted() {
    return this.data.muted;
  }
  async setMuted(C) {
    this.data.muted = C, this.save();
  }
  async getTime() {
    return this.time;
  }
  // TODO: temporarily disabled
  // async setTime(time: number, ended: boolean) {
  //   const shouldClear = time < 0;
  //
  //   this.time = !shouldClear ? time : null;
  //
  //   if (shouldClear || ended) this.saveTime();
  //   else this.saveTimeThrottled();
  // }
  async getCaptions() {
    return this.data.captions;
  }
  async setCaptions(C) {
    this.data.captions = C, this.save();
  }
  async getPlaybackRate() {
    return this.lockSpeed ? 1 : this.data.rate;
  }
  async setPlaybackRate(C) {
    this.data.rate = C, this.save();
  }
  onChange(C, B, le = "studio-player") {
    const be = le ? localStorage.getItem(le) : null, qe = B ? localStorage.getItem(B) : null;
    this.playerId = le, this.mediaId = B;
    let _e = {};
    if (be)
      try {
        _e = JSON.parse(be);
      } catch {
      }
    this.data = {
      ...cl,
      ..._e
    }, vo(this.overrideTime) && this.overrideTime >= 0 ? this.time = this.overrideTime : this.time = qe ? +qe : null;
  }
  save() {
    if (!this.playerId) return;
    const C = JSON.stringify(this.data);
    localStorage.setItem(this.playerId, C);
  }
}
function sy(D, C, B, le, be, qe) {
  const _e = ir(
    () => new oy(le),
    [le]
  ), fe = ir(
    () => ay(D, le),
    [D, le]
  );
  return {
    contextValue: ir(() => {
      const J = _e.initializeState(qe), E = {
        storage: _e,
        captionsFontSizeMultiplier: Wn(J.captionsFontSizeMultiplier),
        captionPositionOnTop: Wn(J.captionPositionOnTop),
        captionsInvertColors: Wn(J.captionsInvertColors),
        commentsEnabled: Wn(C || J.commentsEnabled),
        interactionsDisabled: Wn(!1),
        globalKeysDisabled: Wn(!1),
        youtubeEducationProvider: Wn(null),
        sidebarOpen: Wn(be),
        playerElement: Uc(),
        lastSearchTerm: ""
      };
      return B || (E.captionsFontSizeMultiplier.listen((t) => {
        _e.saveData("multiplier", t);
      }), E.captionPositionOnTop.listen((t) => {
        _e.saveData("ontop", t);
      }), E.captionsInvertColors.listen((t) => {
        _e.saveData("invert", t);
      }), E.commentsEnabled.listen((t) => {
        _e.saveData("comments", t);
      })), E;
    }, [B]),
    shortcuts: fe,
    storage: _e
  };
}
const Li = () => {
};
function py({
  title: D,
  playerRef: C,
  src: B,
  captions: le = [],
  thumbnail: be,
  hideFullScreen: qe = !1,
  comments: _e = [],
  locale: fe = "en",
  annotations: R = [],
  quizMarkers: J = [],
  interactive: E = !1,
  onAnnotationClick: t = Li,
  onQuizMarkerClick: e = Li,
  onQuizMarkerShow: h = Li,
  onInteractivePinClick: p = Li,
  onPlayerSizeChange: o = Li,
  onCaptionsDelete: v,
  onTranscriptEdit: m,
  onConfirmEditChanges: n,
  interactiveMenuElements: c = [],
  kebabMenuElements: f = [],
  darkMode: S = !1,
  autoLoadCaptionSrc: k = "",
  forceComments: q = !1,
  disableCaptionSettings: F = !1,
  disableStorage: te = !1,
  startAt: P,
  crossOrigin: Q,
  captionOffsetOverride: se,
  disableInteractivePinRanges: K = [],
  customOverlay: ie,
  controlsLayout: ge = "compact",
  hideQuizMarkers: Ne = !1,
  useYtPfEdu: ee = !1,
  ytEncryptedPayload: Oe,
  enableSidebar: Ge = !1,
  lockSpeed: Xe = !1,
  tabs: Ce = [],
  openSidebar: Ue = !1,
  emptyTranscriptsComponent: Je = null,
  rollingTranscriptElement: st = null,
  transcriptMenuElements: we = [],
  displayAsrCaptions: Be = !1,
  onTrackEvent: At
}) {
  const { contextValue: ht, shortcuts: je, storage: it } = sy(
    qe,
    q,
    te,
    Xe,
    Ue,
    P
  ), { i18n: ve } = An();
  Ir(() => {
    ve.changeLanguage(fe);
  }, [ve, fe]);
  const { allCaptions: Se, setDynamicYoutubeCaptions: Ye } = Vp({
    src: B,
    captions: le,
    locale: fe,
    displayAsrCaptions: Be
  }), [d, l] = ur("none"), T = xn(
    (Ie) => {
      sf(Ie) ? l("audio") : (Qs(Ie) || Xs(Ie) || lf(Ie)) && l("video"), (Qs(Ie) || po(Ie)) && be && (Ie.video.style.visibility = "hidden");
    },
    [be]
  ), b = xn(
    (Ie) => {
      po(Ie) ? Ie.library = _f.MediaPlayer : Xs(Ie) && (ee ? (Ie.education = !0, Ie.autoLoadCaptions = !0, ht.youtubeEducationProvider.set(Ie)) : Ie.cookies = !0, typeof Oe == "string" && Oe.length > 0 && (Ie.encryptedPayload = Oe));
    },
    []
  ), $ = va(ht.interactionsDisabled), W = va(ht.globalKeysDisabled);
  return /* @__PURE__ */ ce(
    bf,
    {
      title: D,
      hideFullScreen: qe,
      comments: _e,
      captions: Se,
      thumbnail: be,
      annotations: R,
      quizMarkers: J,
      interactive: E,
      onAnnotationClick: t,
      onQuizMarkerClick: e,
      onInteractivePinClick: p,
      onPlayerSizeChange: o,
      onTranscriptEdit: m,
      onConfirmEditChanges: n,
      interactiveMenuElements: c,
      kebabMenuElements: f,
      darkMode: S,
      forceComments: q,
      disableCaptionSettings: F,
      disableStorage: te,
      captionOffsetOverride: se,
      disableInteractivePinRanges: K,
      onQuizMarkerShow: h,
      onCaptionsDelete: v,
      controlsLayout: ge,
      startAt: P,
      hideQuizMarkers: Ne,
      enableSidebar: Ge,
      lockSpeed: Xe,
      tabs: Ce,
      openSidebar: Ue,
      emptyTranscriptsComponent: Je,
      rollingTranscriptElement: st,
      transcriptMenuElements: we,
      onTrackEvent: At,
      children: /* @__PURE__ */ ce(vf, { contextValue: ht, children: /* @__PURE__ */ tn(
        uf,
        {
          "data-version": "1.10.0",
          "data-darkmode": S,
          crossOrigin: Q,
          storage: te ? null : it,
          title: D,
          src: Zl(B),
          keyShortcuts: je,
          playsInline: !0,
          keyDisabled: $ || W,
          onTextTracksChange: (Ie) => {
            const $e = Ie == null ? void 0 : Ie.findIndex(
              (Ze) => Ze.src === k
            );
            $e > -1 && (Ie[$e].mode = "showing");
          },
          onLoadedMetadata: (Ie) => {
            var Ze;
            const $e = ht.youtubeEducationProvider.get();
            if ($e) {
              if (Ie != null && Ie.youtubeCaptions && Ie.youtubeCaptions.length > 0 && !le.some((xe) => xe.sourceType === "youtube")) {
                const xe = xd(
                  Ie.youtubeCaptions ?? [],
                  fe
                );
                Ye(xe);
              }
              if (te)
                ha($e.iframe, null);
              else {
                const xe = it.data.captions && ((Ze = it.data.lang) == null ? void 0 : Ze.endsWith(Ao)) && it.data.lang || null;
                ha(
                  $e.iframe,
                  xe
                ), Sl(
                  $e.iframe,
                  it.data.multiplier
                );
              }
            }
          },
          onProviderChange: b,
          onProviderSetup: T,
          onTextTrackChange: (Ie) => {
            const $e = ht.youtubeEducationProvider.get();
            $e && ((Ie == null ? void 0 : Ie.sourceType) === "youtube" ? ha(
              $e.iframe,
              Ie == null ? void 0 : Ie.language
            ) : ha($e.iframe, null));
          },
          onFullscreenChange: (Ie) => {
            At == null || At({ type: "fullscreen_toggled", isFullScreen: Ie });
          },
          onCanPlay: ({ provider: Ie }) => {
            po(Ie) && (Ie.ctx.qualities.items.length === 0 ? l("audio") : l("video"));
          },
          children: [
            /* @__PURE__ */ tn("div", { className: ul.mainLayout, ref: ht.playerElement, children: [
              /* @__PURE__ */ tn(cf, { className: ul.mediaProvider, children: [
                d === "audio" && /* @__PURE__ */ ce(ny, {}),
                d === "video" && /* @__PURE__ */ ce(ry, {})
              ] }),
              /* @__PURE__ */ ce(id, {}),
              ie && /* @__PURE__ */ ce(Td, { renderOverlay: ie }),
              /* @__PURE__ */ ce($p, { playerRef: C }),
              /* @__PURE__ */ ce(Cf, { annotations: R }),
              !!J.length && /* @__PURE__ */ ce(zg, {})
            ] }),
            /* @__PURE__ */ ce(_m, {}),
            st && /* @__PURE__ */ ce(hm, { element: st })
          ]
        }
      ) })
    }
  );
}
export {
  df as CAPTION_FONT_SIZE_MULTIPLIERS,
  gf as COMMENT_DURATION,
  Si as PLAYBACK_RATES,
  py as StudioPlayer,
  Ao as YOUTUBE_CAPTION_SUFFIX,
  jn as useMediaState,
  Ey as useMediaStore
};
